var QL = Object.defineProperty, tD = Object.defineProperties;
var eD = Object.getOwnPropertyDescriptors;
var jf = Object.getOwnPropertySymbols;
var C4 = Object.prototype.hasOwnProperty, $4 = Object.prototype.propertyIsEnumerable;
var ig = (t, e, n) => e in t ? QL(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, qr = (t, e) => {
  for (var n in e || (e = {}))
    C4.call(e, n) && ig(t, n, e[n]);
  if (jf)
    for (var n of jf(e))
      $4.call(e, n) && ig(t, n, e[n]);
  return t;
}, el = (t, e) => tD(t, eD(e));
var T4 = (t, e) => {
  var n = {};
  for (var r in t)
    C4.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && jf)
    for (var r of jf(t))
      e.indexOf(r) < 0 && $4.call(t, r) && (n[r] = t[r]);
  return n;
};
var Vf = (t, e, n) => (ig(t, typeof e != "symbol" ? e + "" : e, n), n);
var _e = (t, e, n) => new Promise((r, i) => {
  var a = (l) => {
    try {
      s(n.next(l));
    } catch (c) {
      i(c);
    }
  }, o = (l) => {
    try {
      s(n.throw(l));
    } catch (c) {
      i(c);
    }
  }, s = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(a, o);
  s((n = n.apply(t, e)).next());
});
import Ot, { defineComponent as te } from "vue";
/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
var W7 = [
  "compactDisplay",
  "currency",
  "currencyDisplay",
  "currencySign",
  "localeMatcher",
  "notation",
  "numberingSystem",
  "signDisplay",
  "style",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits"
], nD = [
  "dateStyle",
  "timeStyle",
  "calendar",
  "localeMatcher",
  "hour12",
  "hourCycle",
  "timeZone",
  "formatMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName"
];
function Wt(t, e) {
  typeof console != "undefined" && (console.warn("[vue-i18n] " + t), e && console.warn(e.stack));
}
function U7(t, e) {
  typeof console != "undefined" && (console.error("[vue-i18n] " + t), e && console.error(e.stack));
}
var oi = Array.isArray;
function $r(t) {
  return t !== null && typeof t == "object";
}
function rD(t) {
  return typeof t == "boolean";
}
function Ve(t) {
  return typeof t == "string";
}
var iD = Object.prototype.toString, aD = "[object Object]";
function ii(t) {
  return iD.call(t) === aD;
}
function zn(t) {
  return t == null;
}
function c0(t) {
  return typeof t == "function";
}
function _p() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  var n = null, r = null;
  return t.length === 1 ? $r(t[0]) || oi(t[0]) ? r = t[0] : typeof t[0] == "string" && (n = t[0]) : t.length === 2 && (typeof t[0] == "string" && (n = t[0]), ($r(t[1]) || oi(t[1])) && (r = t[1])), { locale: n, params: r };
}
function gu(t) {
  return JSON.parse(JSON.stringify(t));
}
function oD(t, e) {
  if (t.delete(e))
    return t;
}
function sD(t) {
  var e = [];
  return t.forEach(function(n) {
    return e.push(n);
  }), e;
}
function Cc(t, e) {
  return !!~t.indexOf(e);
}
var uD = Object.prototype.hasOwnProperty;
function lD(t, e) {
  return uD.call(t, e);
}
function go(t) {
  for (var e = arguments, n = Object(t), r = 1; r < arguments.length; r++) {
    var i = e[r];
    if (i != null) {
      var a = void 0;
      for (a in i)
        lD(i, a) && ($r(i[a]) ? n[a] = go(n[a], i[a]) : n[a] = i[a]);
    }
  }
  return n;
}
function Zh(t, e) {
  if (t === e)
    return !0;
  var n = $r(t), r = $r(e);
  if (n && r)
    try {
      var i = oi(t), a = oi(e);
      if (i && a)
        return t.length === e.length && t.every(function(l, c) {
          return Zh(l, e[c]);
        });
      if (!i && !a) {
        var o = Object.keys(t), s = Object.keys(e);
        return o.length === s.length && o.every(function(l) {
          return Zh(t[l], e[l]);
        });
      } else
        return !1;
    } catch (l) {
      return !1;
    }
  else
    return !n && !r ? String(t) === String(e) : !1;
}
function cD(t) {
  return t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function fD(t) {
  return t != null && Object.keys(t).forEach(function(e) {
    typeof t[e] == "string" && (t[e] = cD(t[e]));
  }), t;
}
function hD(t) {
  t.prototype.hasOwnProperty("$i18n") || Object.defineProperty(t.prototype, "$i18n", {
    get: function() {
      return this._i18n;
    }
  }), t.prototype.$t = function(e) {
    for (var n = [], r = arguments.length - 1; r-- > 0; )
      n[r] = arguments[r + 1];
    var i = this.$i18n;
    return i._t.apply(i, [e, i.locale, i._getMessages(), this].concat(n));
  }, t.prototype.$tc = function(e, n) {
    for (var r = [], i = arguments.length - 2; i-- > 0; )
      r[i] = arguments[i + 2];
    var a = this.$i18n;
    return a._tc.apply(a, [e, a.locale, a._getMessages(), this, n].concat(r));
  }, t.prototype.$te = function(e, n) {
    var r = this.$i18n;
    return r._te(e, r.locale, r._getMessages(), n);
  }, t.prototype.$d = function(e) {
    for (var n, r = [], i = arguments.length - 1; i-- > 0; )
      r[i] = arguments[i + 1];
    return (n = this.$i18n).d.apply(n, [e].concat(r));
  }, t.prototype.$n = function(e) {
    for (var n, r = [], i = arguments.length - 1; i-- > 0; )
      r[i] = arguments[i + 1];
    return (n = this.$i18n).n.apply(n, [e].concat(r));
  };
}
function dD(t) {
  t === void 0 && (t = !1);
  function e() {
    this !== this.$root && this.$options.__INTLIFY_META__ && this.$el && this.$el.setAttribute("data-intlify", this.$options.__INTLIFY_META__);
  }
  return t ? { mounted: e } : {
    // regulary 
    beforeCreate: function() {
      var r = this.$options;
      if (r.i18n = r.i18n || (r.__i18nBridge || r.__i18n ? {} : null), r.i18n)
        if (r.i18n instanceof dt) {
          if (r.__i18nBridge || r.__i18n)
            try {
              var i = r.i18n && r.i18n.messages ? r.i18n.messages : {}, a = r.__i18nBridge || r.__i18n;
              a.forEach(function(d) {
                i = go(i, JSON.parse(d));
              }), Object.keys(i).forEach(function(d) {
                r.i18n.mergeLocaleMessage(d, i[d]);
              });
            } catch (d) {
              process.env.NODE_ENV !== "production" && U7("Cannot parse locale messages via custom blocks.", d);
            }
          this._i18n = r.i18n, this._i18nWatcher = this._i18n.watchI18nData();
        } else if (ii(r.i18n)) {
          var o = this.$root && this.$root.$i18n && this.$root.$i18n instanceof dt ? this.$root.$i18n : null;
          if (o && (r.i18n.root = this.$root, r.i18n.formatter = o.formatter, r.i18n.fallbackLocale = o.fallbackLocale, r.i18n.formatFallbackMessages = o.formatFallbackMessages, r.i18n.silentTranslationWarn = o.silentTranslationWarn, r.i18n.silentFallbackWarn = o.silentFallbackWarn, r.i18n.pluralizationRules = o.pluralizationRules, r.i18n.preserveDirectiveContent = o.preserveDirectiveContent), r.__i18nBridge || r.__i18n)
            try {
              var s = r.i18n && r.i18n.messages ? r.i18n.messages : {}, l = r.__i18nBridge || r.__i18n;
              l.forEach(function(d) {
                s = go(s, JSON.parse(d));
              }), r.i18n.messages = s;
            } catch (d) {
              process.env.NODE_ENV !== "production" && Wt("Cannot parse locale messages via custom blocks.", d);
            }
          var c = r.i18n, h = c.sharedMessages;
          h && ii(h) && (r.i18n.messages = go(r.i18n.messages, h)), this._i18n = new dt(r.i18n), this._i18nWatcher = this._i18n.watchI18nData(), (r.i18n.sync === void 0 || r.i18n.sync) && (this._localeWatcher = this.$i18n.watchLocale()), o && o.onComponentInstanceCreated(this._i18n);
        } else
          process.env.NODE_ENV !== "production" && Wt("Cannot be interpreted 'i18n' option.");
      else
        this.$root && this.$root.$i18n && this.$root.$i18n instanceof dt ? this._i18n = this.$root.$i18n : r.parent && r.parent.$i18n && r.parent.$i18n instanceof dt && (this._i18n = r.parent.$i18n);
    },
    beforeMount: function() {
      var r = this.$options;
      r.i18n = r.i18n || (r.__i18nBridge || r.__i18n ? {} : null), r.i18n ? r.i18n instanceof dt ? (this._i18n.subscribeDataChanging(this), this._subscribing = !0) : ii(r.i18n) ? (this._i18n.subscribeDataChanging(this), this._subscribing = !0) : process.env.NODE_ENV !== "production" && Wt("Cannot be interpreted 'i18n' option.") : this.$root && this.$root.$i18n && this.$root.$i18n instanceof dt ? (this._i18n.subscribeDataChanging(this), this._subscribing = !0) : r.parent && r.parent.$i18n && r.parent.$i18n instanceof dt && (this._i18n.subscribeDataChanging(this), this._subscribing = !0);
    },
    mounted: e,
    beforeDestroy: function() {
      if (this._i18n) {
        var r = this;
        this.$nextTick(function() {
          r._subscribing && (r._i18n.unsubscribeDataChanging(r), delete r._subscribing), r._i18nWatcher && (r._i18nWatcher(), r._i18n.destroyVM(), delete r._i18nWatcher), r._localeWatcher && (r._localeWatcher(), delete r._localeWatcher);
        });
      }
    }
  };
}
var O4 = {
  name: "i18n",
  functional: !0,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    path: {
      type: String,
      required: !0
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function(e, n) {
    var r = n.data, i = n.parent, a = n.props, o = n.slots, s = i.$i18n;
    if (!s) {
      process.env.NODE_ENV !== "production" && Wt("Cannot find VueI18n instance!");
      return;
    }
    var l = a.path, c = a.locale, h = a.places, d = o(), p = s.i(
      l,
      c,
      pD(d) || h ? mD(d.default, h) : d
    ), g = a.tag && a.tag !== !0 || a.tag === !1 ? a.tag : "span";
    return g ? e(g, r, p) : p;
  }
};
function pD(t) {
  var e;
  for (e in t)
    if (e !== "default")
      return !1;
  return !!e;
}
function mD(t, e) {
  var n = e ? gD(e) : {};
  if (!t)
    return n;
  t = t.filter(function(i) {
    return i.tag || i.text.trim() !== "";
  });
  var r = t.every(_D);
  return process.env.NODE_ENV !== "production" && r && Wt("`place` attribute is deprecated in next major version. Please switch to Vue slots."), t.reduce(
    r ? vD : Y7,
    n
  );
}
function gD(t) {
  return process.env.NODE_ENV !== "production" && Wt("`places` prop is deprecated in next major version. Please switch to Vue slots."), Array.isArray(t) ? t.reduce(Y7, {}) : Object.assign({}, t);
}
function vD(t, e) {
  return e.data && e.data.attrs && e.data.attrs.place && (t[e.data.attrs.place] = e), t;
}
function Y7(t, e, n) {
  return t[n] = e, t;
}
function _D(t) {
  return !!(t.data && t.data.attrs && t.data.attrs.place);
}
var S4 = {
  name: "i18n-n",
  functional: !0,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function(e, n) {
    var r = n.props, i = n.parent, a = n.data, o = i.$i18n;
    if (!o)
      return process.env.NODE_ENV !== "production" && Wt("Cannot find VueI18n instance!"), null;
    var s = null, l = null;
    Ve(r.format) ? s = r.format : $r(r.format) && (r.format.key && (s = r.format.key), l = Object.keys(r.format).reduce(function(g, v) {
      var b;
      return Cc(W7, v) ? Object.assign({}, g, (b = {}, b[v] = r.format[v], b)) : g;
    }, null));
    var c = r.locale || o.locale, h = o._ntp(r.value, c, s, l), d = h.map(function(g, v) {
      var b, _ = a.scopedSlots && a.scopedSlots[g.type];
      return _ ? _((b = {}, b[g.type] = g.value, b.index = v, b.parts = h, b)) : g.value;
    }), p = r.tag && r.tag !== !0 || r.tag === !1 ? r.tag : "span";
    return p ? e(p, {
      attrs: a.attrs,
      class: a.class,
      staticClass: a.staticClass
    }, d) : d;
  }
};
function bD(t, e, n) {
  q7(t, n) && G7(t, e, n);
}
function yD(t, e, n, r) {
  if (q7(t, n)) {
    var i = n.context.$i18n;
    xD(t, n) && Zh(e.value, e.oldValue) && Zh(t._localeMessage, i.getLocaleMessage(i.locale)) || G7(t, e, n);
  }
}
function wD(t, e, n, r) {
  var i = n.context;
  if (!i) {
    Wt("Vue instance does not exists in VNode context");
    return;
  }
  var a = n.context.$i18n || {};
  !e.modifiers.preserve && !a.preserveDirectiveContent && (t.textContent = ""), t._vt = void 0, delete t._vt, t._locale = void 0, delete t._locale, t._localeMessage = void 0, delete t._localeMessage;
}
function q7(t, e) {
  var n = e.context;
  return n ? n.$i18n ? !0 : (Wt("VueI18n instance does not exists in Vue instance"), !1) : (Wt("Vue instance does not exists in VNode context"), !1);
}
function xD(t, e) {
  var n = e.context;
  return t._locale === n.$i18n.locale;
}
function G7(t, e, n) {
  var r, i, a = e.value, o = CD(a), s = o.path, l = o.locale, c = o.args, h = o.choice;
  if (!s && !l && !c) {
    Wt("value type not supported");
    return;
  }
  if (!s) {
    Wt("`path` is required in v-t directive");
    return;
  }
  var d = n.context;
  h != null ? t._vt = t.textContent = (r = d.$i18n).tc.apply(r, [s, h].concat(E4(l, c))) : t._vt = t.textContent = (i = d.$i18n).t.apply(i, [s].concat(E4(l, c))), t._locale = d.$i18n.locale, t._localeMessage = d.$i18n.getLocaleMessage(d.$i18n.locale);
}
function CD(t) {
  var e, n, r, i;
  return Ve(t) ? e = t : ii(t) && (e = t.path, n = t.locale, r = t.args, i = t.choice), { path: e, locale: n, args: r, choice: i };
}
function E4(t, e) {
  var n = [];
  return t && n.push(t), e && (Array.isArray(e) || ii(e)) && n.push(e), n;
}
var Xe;
function Nl(t, e) {
  if (e === void 0 && (e = { bridge: !1 }), process.env.NODE_ENV !== "production" && Nl.installed && t === Xe) {
    Wt("already installed.");
    return;
  }
  Nl.installed = !0, Xe = t;
  var n = Xe.version && Number(Xe.version.split(".")[0]) || -1;
  if (process.env.NODE_ENV !== "production" && n < 2) {
    Wt("vue-i18n (" + Nl.version + ") need to use Vue 2.0 or later (Vue: " + Xe.version + ").");
    return;
  }
  hD(Xe), Xe.mixin(dD(e.bridge)), Xe.directive("t", { bind: bD, update: yD, unbind: wD }), Xe.component(O4.name, O4), Xe.component(S4.name, S4);
  var r = Xe.config.optionMergeStrategies;
  r.i18n = function(i, a) {
    return a === void 0 ? i : a;
  };
}
var K7 = function() {
  this._caches = /* @__PURE__ */ Object.create(null);
};
K7.prototype.interpolate = function(e, n) {
  if (!n)
    return [e];
  var r = this._caches[e];
  return r || (r = OD(e), this._caches[e] = r), SD(r, n);
};
var $D = /^(?:\d)+/, TD = /^(?:\w)+/;
function OD(t) {
  for (var e = [], n = 0, r = ""; n < t.length; ) {
    var i = t[n++];
    if (i === "{") {
      r && e.push({ type: "text", value: r }), r = "";
      var a = "";
      for (i = t[n++]; i !== void 0 && i !== "}"; )
        a += i, i = t[n++];
      var o = i === "}", s = $D.test(a) ? "list" : o && TD.test(a) ? "named" : "unknown";
      e.push({ value: a, type: s });
    } else
      i === "%" ? t[n] !== "{" && (r += i) : r += i;
  }
  return r && e.push({ type: "text", value: r }), e;
}
function SD(t, e) {
  var n = [], r = 0, i = Array.isArray(e) ? "list" : $r(e) ? "named" : "unknown";
  if (i === "unknown")
    return n;
  for (; r < t.length; ) {
    var a = t[r];
    switch (a.type) {
      case "text":
        n.push(a.value);
        break;
      case "list":
        n.push(e[parseInt(a.value, 10)]);
        break;
      case "named":
        i === "named" ? n.push(e[a.value]) : process.env.NODE_ENV !== "production" && Wt("Type of token '" + a.type + "' and format of value '" + i + "' don't match!");
        break;
      case "unknown":
        process.env.NODE_ENV !== "production" && Wt("Detect 'unknown' type of token!");
        break;
    }
    r++;
  }
  return n;
}
var Be = 0, Es = 1, X7 = 2, Z7 = 3, f0 = 0, Jh = 1, Qh = 2, ca = 3, Ai = 4, td = 5, ed = 6, bp = 7, Ul = 8, Ra = [];
Ra[f0] = {
  ws: [f0],
  ident: [ca, Be],
  "[": [Ai],
  eof: [bp]
};
Ra[Jh] = {
  ws: [Jh],
  ".": [Qh],
  "[": [Ai],
  eof: [bp]
};
Ra[Qh] = {
  ws: [Qh],
  ident: [ca, Be],
  0: [ca, Be],
  number: [ca, Be]
};
Ra[ca] = {
  ident: [ca, Be],
  0: [ca, Be],
  number: [ca, Be],
  ws: [Jh, Es],
  ".": [Qh, Es],
  "[": [Ai, Es],
  eof: [bp, Es]
};
Ra[Ai] = {
  "'": [td, Be],
  '"': [ed, Be],
  "[": [Ai, X7],
  "]": [Jh, Z7],
  eof: Ul,
  else: [Ai, Be]
};
Ra[td] = {
  "'": [Ai, Be],
  eof: Ul,
  else: [td, Be]
};
Ra[ed] = {
  '"': [Ai, Be],
  eof: Ul,
  else: [ed, Be]
};
var ED = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function AD(t) {
  return ED.test(t);
}
function PD(t) {
  var e = t.charCodeAt(0), n = t.charCodeAt(t.length - 1);
  return e === n && (e === 34 || e === 39) ? t.slice(1, -1) : t;
}
function MD(t) {
  if (t == null)
    return "eof";
  var e = t.charCodeAt(0);
  switch (e) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return t;
    case 95:
    case 36:
    case 45:
      return "ident";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "ws";
  }
  return "ident";
}
function kD(t) {
  var e = t.trim();
  return t.charAt(0) === "0" && isNaN(t) ? !1 : AD(e) ? PD(e) : "*" + e;
}
function ND(t) {
  var e = [], n = -1, r = f0, i = 0, a, o, s, l, c, h, d, p = [];
  p[Es] = function() {
    o !== void 0 && (e.push(o), o = void 0);
  }, p[Be] = function() {
    o === void 0 ? o = s : o += s;
  }, p[X7] = function() {
    p[Be](), i++;
  }, p[Z7] = function() {
    if (i > 0)
      i--, r = Ai, p[Be]();
    else {
      if (i = 0, o === void 0 || (o = kD(o), o === !1))
        return !1;
      p[Es]();
    }
  };
  function g() {
    var v = t[n + 1];
    if (r === td && v === "'" || r === ed && v === '"')
      return n++, s = "\\" + v, p[Be](), !0;
  }
  for (; r !== null; )
    if (n++, a = t[n], !(a === "\\" && g())) {
      if (l = MD(a), d = Ra[r], c = d[l] || d.else || Ul, c === Ul || (r = c[0], h = p[c[1]], h && (s = c[2], s = s === void 0 ? a : s, h() === !1)))
        return;
      if (r === bp)
        return e;
    }
}
var u_ = function() {
  this._cache = /* @__PURE__ */ Object.create(null);
};
u_.prototype.parsePath = function(e) {
  var n = this._cache[e];
  return n || (n = ND(e), n && (this._cache[e] = n)), n || [];
};
u_.prototype.getPathValue = function(e, n) {
  if (!$r(e))
    return null;
  var r = this.parsePath(n);
  if (r.length === 0)
    return null;
  for (var i = r.length, a = e, o = 0; o < i; ) {
    var s = a[r[o]];
    if (s == null)
      return null;
    a = s, o++;
  }
  return a;
};
var ID = /<\/?[\w\s="/.':;#-\/]+>/, RD = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g, LD = /^@(?:\.([a-zA-Z]+))?:/, DD = /[()]/g, A4 = {
  upper: function(t) {
    return t.toLocaleUpperCase();
  },
  lower: function(t) {
    return t.toLocaleLowerCase();
  },
  capitalize: function(t) {
    return "" + t.charAt(0).toLocaleUpperCase() + t.substr(1);
  }
}, h0 = new K7(), dt = function(e) {
  var n = this;
  e === void 0 && (e = {}), !Xe && typeof window != "undefined" && window.Vue && Nl(window.Vue);
  var r = e.locale || "en-US", i = e.fallbackLocale === !1 ? !1 : e.fallbackLocale || "en-US", a = e.messages || {}, o = e.dateTimeFormats || e.datetimeFormats || {}, s = e.numberFormats || {};
  this._vm = null, this._formatter = e.formatter || h0, this._modifiers = e.modifiers || {}, this._missing = e.missing || null, this._root = e.root || null, this._sync = e.sync === void 0 ? !0 : !!e.sync, this._fallbackRoot = e.fallbackRoot === void 0 ? !0 : !!e.fallbackRoot, this._fallbackRootWithEmptyString = e.fallbackRootWithEmptyString === void 0 ? !0 : !!e.fallbackRootWithEmptyString, this._formatFallbackMessages = e.formatFallbackMessages === void 0 ? !1 : !!e.formatFallbackMessages, this._silentTranslationWarn = e.silentTranslationWarn === void 0 ? !1 : e.silentTranslationWarn, this._silentFallbackWarn = e.silentFallbackWarn === void 0 ? !1 : !!e.silentFallbackWarn, this._dateTimeFormatters = {}, this._numberFormatters = {}, this._path = new u_(), this._dataListeners = /* @__PURE__ */ new Set(), this._componentInstanceCreatedListener = e.componentInstanceCreatedListener || null, this._preserveDirectiveContent = e.preserveDirectiveContent === void 0 ? !1 : !!e.preserveDirectiveContent, this.pluralizationRules = e.pluralizationRules || {}, this._warnHtmlInMessage = e.warnHtmlInMessage || "off", this._postTranslation = e.postTranslation || null, this._escapeParameterHtml = e.escapeParameterHtml || !1, "__VUE_I18N_BRIDGE__" in e && (this.__VUE_I18N_BRIDGE__ = e.__VUE_I18N_BRIDGE__), this.getChoiceIndex = function(l, c) {
    var h = Object.getPrototypeOf(n);
    if (h && h.getChoiceIndex) {
      var d = h.getChoiceIndex;
      return d.call(n, l, c);
    }
    var p = function(g, v) {
      return g = Math.abs(g), v === 2 ? g ? g > 1 ? 1 : 0 : 1 : g ? Math.min(g, 2) : 0;
    };
    return n.locale in n.pluralizationRules ? n.pluralizationRules[n.locale].apply(n, [l, c]) : p(l, c);
  }, this._exist = function(l, c) {
    return !l || !c ? !1 : !!(!zn(n._path.getPathValue(l, c)) || l[c]);
  }, (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") && Object.keys(a).forEach(function(l) {
    n._checkLocaleMessage(l, n._warnHtmlInMessage, a[l]);
  }), this._initVM({
    locale: r,
    fallbackLocale: i,
    messages: a,
    dateTimeFormats: o,
    numberFormats: s
  });
}, Xt = { vm: { configurable: !0 }, messages: { configurable: !0 }, dateTimeFormats: { configurable: !0 }, numberFormats: { configurable: !0 }, availableLocales: { configurable: !0 }, locale: { configurable: !0 }, fallbackLocale: { configurable: !0 }, formatFallbackMessages: { configurable: !0 }, missing: { configurable: !0 }, formatter: { configurable: !0 }, silentTranslationWarn: { configurable: !0 }, silentFallbackWarn: { configurable: !0 }, preserveDirectiveContent: { configurable: !0 }, warnHtmlInMessage: { configurable: !0 }, postTranslation: { configurable: !0 }, sync: { configurable: !0 } };
dt.prototype._checkLocaleMessage = function(e, n, r) {
  var i = [], a = function(o, s, l, c) {
    if (ii(l))
      Object.keys(l).forEach(function(p) {
        var g = l[p];
        ii(g) ? (c.push(p), c.push("."), a(o, s, g, c), c.pop(), c.pop()) : (c.push(p), a(o, s, g, c), c.pop());
      });
    else if (oi(l))
      l.forEach(function(p, g) {
        ii(p) ? (c.push("[" + g + "]"), c.push("."), a(o, s, p, c), c.pop(), c.pop()) : (c.push("[" + g + "]"), a(o, s, p, c), c.pop());
      });
    else if (Ve(l)) {
      var h = ID.test(l);
      if (h) {
        var d = "Detected HTML in message '" + l + "' of keypath '" + c.join("") + "' at '" + s + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        o === "warn" ? Wt(d) : o === "error" && U7(d);
      }
    }
  };
  a(n, e, r, i);
};
dt.prototype._initVM = function(e) {
  var n = Xe.config.silent;
  Xe.config.silent = !0, this._vm = new Xe({ data: e, __VUE18N__INSTANCE__: !0 }), Xe.config.silent = n;
};
dt.prototype.destroyVM = function() {
  this._vm.$destroy();
};
dt.prototype.subscribeDataChanging = function(e) {
  this._dataListeners.add(e);
};
dt.prototype.unsubscribeDataChanging = function(e) {
  oD(this._dataListeners, e);
};
dt.prototype.watchI18nData = function() {
  var e = this;
  return this._vm.$watch("$data", function() {
    for (var n = sD(e._dataListeners), r = n.length; r--; )
      Xe.nextTick(function() {
        n[r] && n[r].$forceUpdate();
      });
  }, { deep: !0 });
};
dt.prototype.watchLocale = function(e) {
  if (e) {
    if (!this.__VUE_I18N_BRIDGE__)
      return null;
    var r = this, i = this._vm;
    return this.vm.$watch("locale", function(a) {
      i.$set(i, "locale", a), r.__VUE_I18N_BRIDGE__ && e && (e.locale.value = a), i.$forceUpdate();
    }, { immediate: !0 });
  } else {
    if (!this._sync || !this._root)
      return null;
    var n = this._vm;
    return this._root.$i18n.vm.$watch("locale", function(a) {
      n.$set(n, "locale", a), n.$forceUpdate();
    }, { immediate: !0 });
  }
};
dt.prototype.onComponentInstanceCreated = function(e) {
  this._componentInstanceCreatedListener && this._componentInstanceCreatedListener(e, this);
};
Xt.vm.get = function() {
  return this._vm;
};
Xt.messages.get = function() {
  return gu(this._getMessages());
};
Xt.dateTimeFormats.get = function() {
  return gu(this._getDateTimeFormats());
};
Xt.numberFormats.get = function() {
  return gu(this._getNumberFormats());
};
Xt.availableLocales.get = function() {
  return Object.keys(this.messages).sort();
};
Xt.locale.get = function() {
  return this._vm.locale;
};
Xt.locale.set = function(t) {
  this._vm.$set(this._vm, "locale", t);
};
Xt.fallbackLocale.get = function() {
  return this._vm.fallbackLocale;
};
Xt.fallbackLocale.set = function(t) {
  this._localeChainCache = {}, this._vm.$set(this._vm, "fallbackLocale", t);
};
Xt.formatFallbackMessages.get = function() {
  return this._formatFallbackMessages;
};
Xt.formatFallbackMessages.set = function(t) {
  this._formatFallbackMessages = t;
};
Xt.missing.get = function() {
  return this._missing;
};
Xt.missing.set = function(t) {
  this._missing = t;
};
Xt.formatter.get = function() {
  return this._formatter;
};
Xt.formatter.set = function(t) {
  this._formatter = t;
};
Xt.silentTranslationWarn.get = function() {
  return this._silentTranslationWarn;
};
Xt.silentTranslationWarn.set = function(t) {
  this._silentTranslationWarn = t;
};
Xt.silentFallbackWarn.get = function() {
  return this._silentFallbackWarn;
};
Xt.silentFallbackWarn.set = function(t) {
  this._silentFallbackWarn = t;
};
Xt.preserveDirectiveContent.get = function() {
  return this._preserveDirectiveContent;
};
Xt.preserveDirectiveContent.set = function(t) {
  this._preserveDirectiveContent = t;
};
Xt.warnHtmlInMessage.get = function() {
  return this._warnHtmlInMessage;
};
Xt.warnHtmlInMessage.set = function(t) {
  var e = this, n = this._warnHtmlInMessage;
  if (this._warnHtmlInMessage = t, n !== t && (t === "warn" || t === "error")) {
    var r = this._getMessages();
    Object.keys(r).forEach(function(i) {
      e._checkLocaleMessage(i, e._warnHtmlInMessage, r[i]);
    });
  }
};
Xt.postTranslation.get = function() {
  return this._postTranslation;
};
Xt.postTranslation.set = function(t) {
  this._postTranslation = t;
};
Xt.sync.get = function() {
  return this._sync;
};
Xt.sync.set = function(t) {
  this._sync = t;
};
dt.prototype._getMessages = function() {
  return this._vm.messages;
};
dt.prototype._getDateTimeFormats = function() {
  return this._vm.dateTimeFormats;
};
dt.prototype._getNumberFormats = function() {
  return this._vm.numberFormats;
};
dt.prototype._warnDefault = function(e, n, r, i, a, o) {
  if (!zn(r))
    return r;
  if (this._missing) {
    var s = this._missing.apply(null, [e, n, i, a]);
    if (Ve(s))
      return s;
  } else
    process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(n) && Wt(
      "Cannot translate the value of keypath '" + n + "'. Use the value of keypath as default."
    );
  if (this._formatFallbackMessages) {
    var l = _p.apply(void 0, a);
    return this._render(n, o, l.params, n);
  } else
    return n;
};
dt.prototype._isFallbackRoot = function(e) {
  return (this._fallbackRootWithEmptyString ? !e : zn(e)) && !zn(this._root) && this._fallbackRoot;
};
dt.prototype._isSilentFallbackWarn = function(e) {
  return this._silentFallbackWarn instanceof RegExp ? this._silentFallbackWarn.test(e) : this._silentFallbackWarn;
};
dt.prototype._isSilentFallback = function(e, n) {
  return this._isSilentFallbackWarn(n) && (this._isFallbackRoot() || e !== this.fallbackLocale);
};
dt.prototype._isSilentTranslationWarn = function(e) {
  return this._silentTranslationWarn instanceof RegExp ? this._silentTranslationWarn.test(e) : this._silentTranslationWarn;
};
dt.prototype._interpolate = function(e, n, r, i, a, o, s) {
  if (!n)
    return null;
  var l = this._path.getPathValue(n, r);
  if (oi(l) || ii(l))
    return l;
  var c;
  if (zn(l))
    if (ii(n)) {
      if (c = n[r], !(Ve(c) || c0(c)))
        return process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(r) && !this._isSilentFallback(e, r) && Wt("Value of key '" + r + "' is not a string or function !"), null;
    } else
      return null;
  else if (Ve(l) || c0(l))
    c = l;
  else
    return process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(r) && !this._isSilentFallback(e, r) && Wt("Value of key '" + r + "' is not a string or function!"), null;
  return Ve(c) && (c.indexOf("@:") >= 0 || c.indexOf("@.") >= 0) && (c = this._link(e, n, c, i, "raw", o, s)), this._render(c, a, o, r);
};
dt.prototype._link = function(e, n, r, i, a, o, s) {
  var l = r, c = l.match(RD);
  for (var h in c)
    if (c.hasOwnProperty(h)) {
      var d = c[h], p = d.match(LD), g = p[0], v = p[1], b = d.replace(g, "").replace(DD, "");
      if (Cc(s, b))
        return process.env.NODE_ENV !== "production" && Wt('Circular reference found. "' + d + '" is already visited in the chain of ' + s.reverse().join(" <- ")), l;
      s.push(b);
      var _ = this._interpolate(
        e,
        n,
        b,
        i,
        a === "raw" ? "string" : a,
        a === "raw" ? void 0 : o,
        s
      );
      if (this._isFallbackRoot(_)) {
        if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(b) && Wt("Fall back to translate the link placeholder '" + b + "' with root locale."), !this._root)
          throw Error("unexpected error");
        var w = this._root.$i18n;
        _ = w._translate(
          w._getMessages(),
          w.locale,
          w.fallbackLocale,
          b,
          i,
          a,
          o
        );
      }
      _ = this._warnDefault(
        e,
        b,
        _,
        i,
        oi(o) ? o : [o],
        a
      ), this._modifiers.hasOwnProperty(v) ? _ = this._modifiers[v](_) : A4.hasOwnProperty(v) && (_ = A4[v](_)), s.pop(), l = _ ? l.replace(d, _) : l;
    }
  return l;
};
dt.prototype._createMessageContext = function(e, n, r, i) {
  var a = this, o = oi(e) ? e : [], s = $r(e) ? e : {}, l = function(p) {
    return o[p];
  }, c = function(p) {
    return s[p];
  }, h = this._getMessages(), d = this.locale;
  return {
    list: l,
    named: c,
    values: e,
    formatter: n,
    path: r,
    messages: h,
    locale: d,
    linked: function(p) {
      return a._interpolate(d, h[d] || {}, p, null, i, void 0, [p]);
    }
  };
};
dt.prototype._render = function(e, n, r, i) {
  if (c0(e))
    return e(
      this._createMessageContext(r, this._formatter || h0, i, n)
    );
  var a = this._formatter.interpolate(e, r, i);
  return a || (a = h0.interpolate(e, r, i)), n === "string" && !Ve(a) ? a.join("") : a;
};
dt.prototype._appendItemToChain = function(e, n, r) {
  var i = !1;
  return Cc(e, n) || (i = !0, n && (i = n[n.length - 1] !== "!", n = n.replace(/!/g, ""), e.push(n), r && r[n] && (i = r[n]))), i;
};
dt.prototype._appendLocaleToChain = function(e, n, r) {
  var i, a = n.split("-");
  do {
    var o = a.join("-");
    i = this._appendItemToChain(e, o, r), a.splice(-1, 1);
  } while (a.length && i === !0);
  return i;
};
dt.prototype._appendBlockToChain = function(e, n, r) {
  for (var i = !0, a = 0; a < n.length && rD(i); a++) {
    var o = n[a];
    Ve(o) && (i = this._appendLocaleToChain(e, o, r));
  }
  return i;
};
dt.prototype._getLocaleChain = function(e, n) {
  if (e === "")
    return [];
  this._localeChainCache || (this._localeChainCache = {});
  var r = this._localeChainCache[e];
  if (!r) {
    n || (n = this.fallbackLocale), r = [];
    for (var i = [e]; oi(i); )
      i = this._appendBlockToChain(
        r,
        i,
        n
      );
    var a;
    oi(n) ? a = n : $r(n) ? n.default ? a = n.default : a = null : a = n, Ve(a) ? i = [a] : i = a, i && this._appendBlockToChain(
      r,
      i,
      null
    ), this._localeChainCache[e] = r;
  }
  return r;
};
dt.prototype._translate = function(e, n, r, i, a, o, s) {
  for (var l = this._getLocaleChain(n, r), c, h = 0; h < l.length; h++) {
    var d = l[h];
    if (c = this._interpolate(d, e[d], i, a, o, s, [i]), !zn(c))
      return d !== n && process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(i) && !this._isSilentFallbackWarn(i) && Wt("Fall back to translate the keypath '" + i + "' with '" + d + "' locale."), c;
  }
  return null;
};
dt.prototype._t = function(e, n, r, i) {
  for (var a, o = [], s = arguments.length - 4; s-- > 0; )
    o[s] = arguments[s + 4];
  if (!e)
    return "";
  var l = _p.apply(void 0, o);
  this._escapeParameterHtml && (l.params = fD(l.params));
  var c = l.locale || n, h = this._translate(
    r,
    c,
    this.fallbackLocale,
    e,
    i,
    "string",
    l.params
  );
  if (this._isFallbackRoot(h)) {
    if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(e) && !this._isSilentFallbackWarn(e) && Wt("Fall back to translate the keypath '" + e + "' with root locale."), !this._root)
      throw Error("unexpected error");
    return (a = this._root).$t.apply(a, [e].concat(o));
  } else
    return h = this._warnDefault(c, e, h, i, o, "string"), this._postTranslation && h !== null && h !== void 0 && (h = this._postTranslation(h, e)), h;
};
dt.prototype.t = function(e) {
  for (var n, r = [], i = arguments.length - 1; i-- > 0; )
    r[i] = arguments[i + 1];
  return (n = this)._t.apply(n, [e, this.locale, this._getMessages(), null].concat(r));
};
dt.prototype._i = function(e, n, r, i, a) {
  var o = this._translate(r, n, this.fallbackLocale, e, i, "raw", a);
  if (this._isFallbackRoot(o)) {
    if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(e) && Wt("Fall back to interpolate the keypath '" + e + "' with root locale."), !this._root)
      throw Error("unexpected error");
    return this._root.$i18n.i(e, n, a);
  } else
    return this._warnDefault(n, e, o, i, [a], "raw");
};
dt.prototype.i = function(e, n, r) {
  return e ? (Ve(n) || (n = this.locale), this._i(e, n, this._getMessages(), null, r)) : "";
};
dt.prototype._tc = function(e, n, r, i, a) {
  for (var o, s = [], l = arguments.length - 5; l-- > 0; )
    s[l] = arguments[l + 5];
  if (!e)
    return "";
  a === void 0 && (a = 1);
  var c = { count: a, n: a }, h = _p.apply(void 0, s);
  return h.params = Object.assign(c, h.params), s = h.locale === null ? [h.params] : [h.locale, h.params], this.fetchChoice((o = this)._t.apply(o, [e, n, r, i].concat(s)), a);
};
dt.prototype.fetchChoice = function(e, n) {
  if (!e || !Ve(e))
    return null;
  var r = e.split("|");
  return n = this.getChoiceIndex(n, r.length), r[n] ? r[n].trim() : e;
};
dt.prototype.tc = function(e, n) {
  for (var r, i = [], a = arguments.length - 2; a-- > 0; )
    i[a] = arguments[a + 2];
  return (r = this)._tc.apply(r, [e, this.locale, this._getMessages(), null, n].concat(i));
};
dt.prototype._te = function(e, n, r) {
  for (var i = [], a = arguments.length - 3; a-- > 0; )
    i[a] = arguments[a + 3];
  var o = _p.apply(void 0, i).locale || n;
  return this._exist(r[o], e);
};
dt.prototype.te = function(e, n) {
  return this._te(e, this.locale, this._getMessages(), n);
};
dt.prototype.getLocaleMessage = function(e) {
  return gu(this._vm.messages[e] || {});
};
dt.prototype.setLocaleMessage = function(e, n) {
  (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") && this._checkLocaleMessage(e, this._warnHtmlInMessage, n), this._vm.$set(this._vm.messages, e, n);
};
dt.prototype.mergeLocaleMessage = function(e, n) {
  (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") && this._checkLocaleMessage(e, this._warnHtmlInMessage, n), this._vm.$set(this._vm.messages, e, go(
    typeof this._vm.messages[e] != "undefined" && Object.keys(this._vm.messages[e]).length ? Object.assign({}, this._vm.messages[e]) : {},
    n
  ));
};
dt.prototype.getDateTimeFormat = function(e) {
  return gu(this._vm.dateTimeFormats[e] || {});
};
dt.prototype.setDateTimeFormat = function(e, n) {
  this._vm.$set(this._vm.dateTimeFormats, e, n), this._clearDateTimeFormat(e, n);
};
dt.prototype.mergeDateTimeFormat = function(e, n) {
  this._vm.$set(this._vm.dateTimeFormats, e, go(this._vm.dateTimeFormats[e] || {}, n)), this._clearDateTimeFormat(e, n);
};
dt.prototype._clearDateTimeFormat = function(e, n) {
  for (var r in n) {
    var i = e + "__" + r;
    this._dateTimeFormatters.hasOwnProperty(i) && delete this._dateTimeFormatters[i];
  }
};
dt.prototype._localizeDateTime = function(e, n, r, i, a, o) {
  for (var s = n, l = i[s], c = this._getLocaleChain(n, r), h = 0; h < c.length; h++) {
    var d = s, p = c[h];
    if (l = i[p], s = p, zn(l) || zn(l[a]))
      p !== n && process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(a) && !this._isSilentFallbackWarn(a) && Wt("Fall back to '" + p + "' datetime formats from '" + d + "' datetime formats.");
    else
      break;
  }
  if (zn(l) || zn(l[a]))
    return null;
  var g = l[a], v;
  if (o)
    v = new Intl.DateTimeFormat(s, Object.assign({}, g, o));
  else {
    var b = s + "__" + a;
    v = this._dateTimeFormatters[b], v || (v = this._dateTimeFormatters[b] = new Intl.DateTimeFormat(s, g));
  }
  return v.format(e);
};
dt.prototype._d = function(e, n, r, i) {
  if (process.env.NODE_ENV !== "production" && !dt.availabilities.dateTimeFormat)
    return Wt("Cannot format a Date value due to not supported Intl.DateTimeFormat."), "";
  if (!r) {
    var a = i ? new Intl.DateTimeFormat(n, i) : new Intl.DateTimeFormat(n);
    return a.format(e);
  }
  var o = this._localizeDateTime(e, n, this.fallbackLocale, this._getDateTimeFormats(), r, i);
  if (this._isFallbackRoot(o)) {
    if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(r) && !this._isSilentFallbackWarn(r) && Wt("Fall back to datetime localization of root: key '" + r + "'."), !this._root)
      throw Error("unexpected error");
    return this._root.$i18n.d(e, r, n);
  } else
    return o || "";
};
dt.prototype.d = function(e) {
  for (var n = [], r = arguments.length - 1; r-- > 0; )
    n[r] = arguments[r + 1];
  var i = this.locale, a = null, o = null;
  return n.length === 1 ? (Ve(n[0]) ? a = n[0] : $r(n[0]) && (n[0].locale && (i = n[0].locale), n[0].key && (a = n[0].key)), o = Object.keys(n[0]).reduce(function(s, l) {
    var c;
    return Cc(nD, l) ? Object.assign({}, s, (c = {}, c[l] = n[0][l], c)) : s;
  }, null)) : n.length === 2 && (Ve(n[0]) && (a = n[0]), Ve(n[1]) && (i = n[1])), this._d(e, i, a, o);
};
dt.prototype.getNumberFormat = function(e) {
  return gu(this._vm.numberFormats[e] || {});
};
dt.prototype.setNumberFormat = function(e, n) {
  this._vm.$set(this._vm.numberFormats, e, n), this._clearNumberFormat(e, n);
};
dt.prototype.mergeNumberFormat = function(e, n) {
  this._vm.$set(this._vm.numberFormats, e, go(this._vm.numberFormats[e] || {}, n)), this._clearNumberFormat(e, n);
};
dt.prototype._clearNumberFormat = function(e, n) {
  for (var r in n) {
    var i = e + "__" + r;
    this._numberFormatters.hasOwnProperty(i) && delete this._numberFormatters[i];
  }
};
dt.prototype._getNumberFormatter = function(e, n, r, i, a, o) {
  for (var s = n, l = i[s], c = this._getLocaleChain(n, r), h = 0; h < c.length; h++) {
    var d = s, p = c[h];
    if (l = i[p], s = p, zn(l) || zn(l[a]))
      p !== n && process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(a) && !this._isSilentFallbackWarn(a) && Wt("Fall back to '" + p + "' number formats from '" + d + "' number formats.");
    else
      break;
  }
  if (zn(l) || zn(l[a]))
    return null;
  var g = l[a], v;
  if (o)
    v = new Intl.NumberFormat(s, Object.assign({}, g, o));
  else {
    var b = s + "__" + a;
    v = this._numberFormatters[b], v || (v = this._numberFormatters[b] = new Intl.NumberFormat(s, g));
  }
  return v;
};
dt.prototype._n = function(e, n, r, i) {
  if (!dt.availabilities.numberFormat)
    return process.env.NODE_ENV !== "production" && Wt("Cannot format a Number value due to not supported Intl.NumberFormat."), "";
  if (!r) {
    var a = i ? new Intl.NumberFormat(n, i) : new Intl.NumberFormat(n);
    return a.format(e);
  }
  var o = this._getNumberFormatter(e, n, this.fallbackLocale, this._getNumberFormats(), r, i), s = o && o.format(e);
  if (this._isFallbackRoot(s)) {
    if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(r) && !this._isSilentFallbackWarn(r) && Wt("Fall back to number localization of root: key '" + r + "'."), !this._root)
      throw Error("unexpected error");
    return this._root.$i18n.n(e, Object.assign({}, { key: r, locale: n }, i));
  } else
    return s || "";
};
dt.prototype.n = function(e) {
  for (var n = [], r = arguments.length - 1; r-- > 0; )
    n[r] = arguments[r + 1];
  var i = this.locale, a = null, o = null;
  return n.length === 1 ? Ve(n[0]) ? a = n[0] : $r(n[0]) && (n[0].locale && (i = n[0].locale), n[0].key && (a = n[0].key), o = Object.keys(n[0]).reduce(function(s, l) {
    var c;
    return Cc(W7, l) ? Object.assign({}, s, (c = {}, c[l] = n[0][l], c)) : s;
  }, null)) : n.length === 2 && (Ve(n[0]) && (a = n[0]), Ve(n[1]) && (i = n[1])), this._n(e, i, a, o);
};
dt.prototype._ntp = function(e, n, r, i) {
  if (!dt.availabilities.numberFormat)
    return process.env.NODE_ENV !== "production" && Wt("Cannot format to parts a Number value due to not supported Intl.NumberFormat."), [];
  if (!r) {
    var a = i ? new Intl.NumberFormat(n, i) : new Intl.NumberFormat(n);
    return a.formatToParts(e);
  }
  var o = this._getNumberFormatter(e, n, this.fallbackLocale, this._getNumberFormats(), r, i), s = o && o.formatToParts(e);
  if (this._isFallbackRoot(s)) {
    if (process.env.NODE_ENV !== "production" && !this._isSilentTranslationWarn(r) && Wt("Fall back to format number to parts of root: key '" + r + "' ."), !this._root)
      throw Error("unexpected error");
    return this._root.$i18n._ntp(e, n, r, i);
  } else
    return s || [];
};
Object.defineProperties(dt.prototype, Xt);
var ag;
Object.defineProperty(dt, "availabilities", {
  get: function() {
    if (!ag) {
      var e = typeof Intl != "undefined";
      ag = {
        dateTimeFormat: e && typeof Intl.DateTimeFormat != "undefined",
        numberFormat: e && typeof Intl.NumberFormat != "undefined"
      };
    }
    return ag;
  }
});
dt.install = Nl;
dt.version = "8.28.2";
const J7 = dt, FD = {
  "imddb-header": {
    navbar: {
      leak: "Leak to us",
      support: "Soutenez nous",
      follow: "Suivez l'ICIJ"
    }
  },
  "generic-header": {
    navbar: {
      investigations: "Enquêtes",
      leak: "Contact securisé",
      support: "Soutenez nous",
      follow: "Suivez l'ICIJ"
    }
  },
  "embeddable-footer": {
    share: "Partager"
  },
  "embed-form": {
    heading: "Intégrer sur votre site",
    introduction: "Copiez le code ci-dessous pour l'intégrer à votre site.",
    "responsive-optin": "Hauteur dynamique",
    copy: "Copier"
  },
  "follow-us-popover": {
    heading: "Suivez nous"
  },
  "generic-footer": {
    investigations: "Enquêtes",
    "follow-us": "Suivez nous",
    "all-rights": "Tous droits réservés",
    version: "Version %{version}"
  },
  "donate-form": {
    support: "Soutenez nous",
    introduction: 'ICIJ’s investigations are supported by readers like you. Help keep our databases free and open to the public by joining our <strong><a target="_blank" href="https://icij.org/donate">ICIJ Insiders</a></strong> community.',
    "join-heading": "Won't you join us today?",
    label: "I would like to donate",
    frequency: {
      monthly: "Monthly",
      yearly: "Yearly",
      onetime: "One time"
    },
    result: {
      sentence: "With this donation, you are <strong>changing the %{target}</strong>.",
      conversation: "conversation",
      rules: "rules",
      world: "world"
    },
    suggesteddonation: {
      conversation: {
        monthly: 10,
        yearly: 25,
        onetime: 50
      },
      rules: {
        monthly: 25,
        yearly: 180,
        onetime: 180
      },
      world: {
        monthly: 100,
        yearly: 600,
        onetime: 600
      }
    },
    submit: "Donate now",
    benefits: {
      heading: "ICIJ Insiders benefits",
      introduction: "Your monthly or annual donation will give you the following benefits.",
      more: "More about donations",
      list: [
        "Invitation to exclusive chat with ICIJ staff about our latest major project after publication",
        "Opportunity to submit your questions to ICIJ staff. Several questions will be answered in our quarterly ICIJ Insider newsletter",
        "Sneak previews behind the scenes of ICIJ’s work (monthly)",
        "ICIJ Insider Newsletter (quarterly)",
        "ICIJ’s Weekly Update"
      ],
      impacts: {
        conversation: {
          level: "conversation",
          heading: "Change the conversation",
          highlight: "$1-$179/Year <span class='monthly'>or $1-$14/Month</span>"
        },
        rules: {
          level: "rules",
          heading: "Change the rules",
          highlight: "$180-$599/Year <span class='monthly'>or $15-$49/Month</span>"
        },
        world: {
          level: "world",
          heading: "Change the world",
          highlight: "$600+/Year <span class='monthly'>or $50+/Month</span>"
        }
      }
    }
  },
  "sign-up-form": {
    label: "Recevez nos articles par email",
    placeholder: "Adresse email",
    submit: "S'abonner"
  },
  "haptic-copy": {
    label: "Copier",
    tooltip: {
      succeed: "Copié!"
    }
  },
  "tiny-pagination": {
    page: "Page",
    aria: "Allez à la page",
    total: "sur {numberOfPages}",
    previous: "Page suivante",
    next: "Page précédente"
  }
}, zD = {
  "advanced-link-form": {
    raw: {
      tab: "Text"
    },
    rich: {
      tab: "Formatted Text",
      description: "Copy this link in Libre Office, Word, Google Document, etc."
    },
    markdown: {
      tab: "Markdown",
      description: "Copy this link for online platforms supporting Markdown."
    },
    html: {
      tab: "HTML"
    }
  },
  "generic-header": {
    navbar: {
      investigations: "Investigations",
      leak: "Leak to us",
      support: "Support us",
      follow: "Follow ICIJ"
    }
  },
  "imddb-header": {
    navbar: {
      leak: "Leak to us",
      support: "Support us",
      follow: "Follow ICIJ"
    }
  },
  "embeddable-footer": {
    share: "Share"
  },
  "embed-form": {
    heading: "Embed on your website",
    introduction: "Copy the code below to embed this on your website.",
    "responsive-optin": "Responsive iFrame",
    copy: "Copy"
  },
  "follow-us-popover": {
    heading: "Follow us"
  },
  "generic-footer": {
    investigations: "Investigations",
    "follow-us": "Follow us",
    "all-rights": "All rights reserved",
    version: "Version %{version}"
  },
  "donate-form": {
    support: "Support us",
    introduction: 'ICIJ’s investigations are supported by readers like you. Help keep our databases free and open to the public by joining our <strong><a target="_blank" href="https://icij.org/donate">ICIJ Insiders</a></strong> community.',
    "join-heading": "Won't you join us today?",
    label: "I would like to donate",
    frequency: {
      monthly: "Monthly",
      yearly: "Yearly",
      onetime: "One time"
    },
    result: {
      sentence: "With this donation, you are <strong>changing the %{target}</strong>.",
      conversation: "conversation",
      rules: "rules",
      world: "world"
    },
    suggesteddonation: {
      conversation: {
        monthly: 10,
        yearly: 25,
        onetime: 50
      },
      rules: {
        monthly: 25,
        yearly: 180,
        onetime: 200
      },
      world: {
        monthly: 100,
        yearly: 600,
        onetime: 600
      }
    },
    submit: "Donate now",
    benefits: {
      heading: "ICIJ Insiders benefits",
      introduction: "Your monthly or annual donation will give you the following benefits.",
      more: "More about donations",
      list: [
        "Invitation to exclusive chat with ICIJ staff about our latest major project after publication",
        "Opportunity to submit your questions to ICIJ staff. Several questions will be answered in our quarterly ICIJ Insider newsletter",
        "Sneak previews behind the scenes of ICIJ’s work (monthly)",
        "ICIJ Insider Newsletter (quarterly)",
        "ICIJ’s Weekly Update"
      ],
      impacts: {
        conversation: {
          level: "conversation",
          heading: "Change the conversation",
          highlight: "$1-$179/Year <span class='monthly'>or $1-$14/Month</span>"
        },
        rules: {
          level: "rules",
          heading: "Change the rules",
          highlight: "$180-$599/Year <span class='monthly'>or $15-$49/Month</span>"
        },
        world: {
          level: "world",
          heading: "Change the world",
          highlight: "$600+/Year <span class='monthly'>or $50+/Month</span>"
        }
      }
    }
  },
  "sign-up-form": {
    label: "Stories in your inbox",
    placeholder: "Enter your email",
    submit: "Sign up"
  },
  "haptic-copy": {
    label: "Copy",
    tooltip: {
      succeed: "Copied!",
      failed: "Unable to copy the text"
    }
  },
  "custom-pagination": {
    placeholder: "Jump to page",
    "compact-placeholder": "Jump to...",
    "total-pages": "No pages | 1 page | {count} pages total",
    "invalid-number-error": "Invalid page number"
  },
  "tiny-pagination": {
    page: "Page",
    aria: "Jump to page",
    total: "of {numberOfPages}",
    previous: "Previous page",
    next: "Next page"
  }
};
Ot.prototype.hasOwnProperty("$i18n") || Ot.use(J7);
const BD = "en", HD = "en", Hn = new J7({
  locale: BD,
  fallbackLocale: HD,
  messages: { fr: FD, en: zD }
}), Q7 = Symbol("Accordion"), og = "step-change", jD = te({
  name: "AccordionWrapper",
  provide() {
    return {
      [Q7]: {
        emitAccordionNextStepEvent: this.emitAccordionNextStepEvent,
        emitAccordionPreviousStepEvent: this.emitAccordionPreviousStepEvent,
        isActiveStep: this.isActiveStep,
        isPreviousStep: this.isPreviousStep,
        isFirstStep: this.isFirstStep,
        isLastStep: this.isLastStep,
        step: this.step,
        steps: this.steps
      }
    };
  },
  model: {
    prop: "step",
    event: og
  },
  props: {
    /**
     * Current active step value. Modified on "step-change" event.
     */
    step: {
      type: [String, Symbol, Object],
      required: !0
    },
    /**
     * List of the steps. Numbering respects the array positions
     */
    steps: {
      type: Array,
      required: !0
    }
  },
  computed: {
    activeStepIndex() {
      return this.steps.indexOf(this.step);
    }
  },
  methods: {
    isFirstStep(t) {
      return this.steps.indexOf(t) === 0;
    },
    isLastStep(t) {
      return this.steps.indexOf(t) === this.steps.length - 1;
    },
    isActiveStep(t) {
      return this.step === t;
    },
    isPreviousStep(t) {
      return this.steps.indexOf(t) < this.activeStepIndex;
    },
    emitAccordionNextStepEvent() {
      this.$emit(og, this.steps[this.activeStepIndex + 1] || this.step);
    },
    emitAccordionPreviousStepEvent() {
      this.$emit(og, this.steps[this.activeStepIndex - 1] || this.step);
    }
  }
});
function Bt(t, e, n, r, i, a, o, s) {
  var l = typeof t == "function" ? t.options : t;
  e && (l.render = e, l.staticRenderFns = n, l._compiled = !0), r && (l.functional = !0), a && (l._scopeId = "data-v-" + a);
  var c;
  if (o ? (c = function(p) {
    p = p || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !p && typeof __VUE_SSR_CONTEXT__ != "undefined" && (p = __VUE_SSR_CONTEXT__), i && i.call(this, p), p && p._registeredComponents && p._registeredComponents.add(o);
  }, l._ssrRegister = c) : i && (c = s ? function() {
    i.call(
      this,
      (l.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), c)
    if (l.functional) {
      l._injectStyles = c;
      var h = l.render;
      l.render = function(g, v) {
        return c.call(v), h(g, v);
      };
    } else {
      var d = l.beforeCreate;
      l.beforeCreate = d ? [].concat(d, c) : [c];
    }
  return {
    exports: t,
    options: l
  };
}
var VD = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "accordion-wrapper" }, [n("div", { staticClass: "accordion-wrapper__content ml-5" }, [e._t("default")], 2)]);
}, WD = [], UD = /* @__PURE__ */ Bt(
  jD,
  VD,
  WD,
  !1,
  null,
  "90a2396f",
  null,
  null
);
const YD = UD.exports, qD = Ot.extend({
  name: "AccordionStep",
  inject: {
    accordion: { from: Q7 }
  },
  props: {
    /**
     * Step name
     */
    step: {
      type: [String, Object, Symbol],
      required: !0
    },
    /**
     * Title of the step card
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Content of the step card
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * Force card expansion/collapse
     */
    active: {
      type: Boolean,
      required: !1
    }
  },
  computed: {
    isActive() {
      var n;
      const t = !!((n = this.accordion) != null && n.isActiveStep(this.step));
      return (this.active !== void 0 ? this.active : !1) || t;
    },
    isPrevious() {
      var t;
      return !!((t = this.accordion) != null && t.isPreviousStep(this.step));
    },
    isFirst() {
      var t;
      return !!((t = this.accordion) != null && t.isFirstStep(this.step));
    },
    isLast() {
      var t;
      return !!((t = this.accordion) != null && t.isLastStep(this.step));
    }
  },
  methods: {
    nextStep() {
      var t;
      (t = this.accordion) == null || t.emitAccordionNextStepEvent(), this.$emit("next-step");
    },
    previousStep() {
      var t;
      (t = this.accordion) == null || t.emitAccordionPreviousStepEvent(), this.$emit("previous-step");
    }
  }
});
var GD = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("b-card", { staticClass: "accordion-wrapper__content__step", class: {
    "accordion-wrapper__content__step--active": e.isActive,
    "accordion-wrapper__content__step--previous": e.isPrevious
  }, attrs: { "no-body": "" } }, [n("h4", { staticClass: "card-body accordion-wrapper__content__step__heading m-0" }, [e._t("title", function() {
    return [e._v(" " + e._s(e.title) + " ")];
  })], 2), n("b-collapse", { attrs: { visible: e.isActive } }, [n("div", { staticClass: "accordion-wrapper__content__step__main card-body row no-gutters" }, [e._t("content", function() {
    return [e._v(" " + e._s(e.content) + " ")];
  }, null, { isFirst: e.isFirst, isLast: e.isLast, step: e.step, previousStep: e.previousStep, nextStep: e.nextStep })], 2), n("div", { staticClass: "card-footer" }, [e._t("previousStepButton", function() {
    return [e.isFirst ? e._e() : n("b-button", { staticClass: "accordion-wrapper__content__step__back-button", attrs: { type: "button", variant: "link" }, on: { click: e.previousStep } }, [e._v(" Back ")])];
  }, null, { isFirst: e.isFirst, isLast: e.isLast, step: e.step, previousStep: e.previousStep }), e._t("nextStepButton", function() {
    return [e.isLast ? e._e() : n("b-button", { staticClass: "accordion-wrapper__content__step__continue-button", attrs: { type: "button", variant: "primary" }, on: { click: e.nextStep } }, [e._v(" Continue ")])];
  }, null, { isFirst: e.isFirst, isLast: e.isLast, step: e.step, nextStep: e.nextStep })], 2)])], 1);
}, KD = [], XD = /* @__PURE__ */ Bt(
  qD,
  GD,
  KD,
  !1,
  null,
  null,
  null,
  null
);
const ZD = XD.exports;
var Fn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function t9(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var JD = Array.isArray, Ue = JD, QD = typeof Fn == "object" && Fn && Fn.Object === Object && Fn, e9 = QD, tF = e9, eF = typeof self == "object" && self && self.Object === Object && self, nF = tF || eF || Function("return this")(), Hi = nF, rF = Hi, iF = rF.Symbol, $c = iF, P4 = $c, n9 = Object.prototype, aF = n9.hasOwnProperty, oF = n9.toString, nl = P4 ? P4.toStringTag : void 0;
function sF(t) {
  var e = aF.call(t, nl), n = t[nl];
  try {
    t[nl] = void 0;
    var r = !0;
  } catch (a) {
  }
  var i = oF.call(t);
  return r && (e ? t[nl] = n : delete t[nl]), i;
}
var uF = sF, lF = Object.prototype, cF = lF.toString;
function fF(t) {
  return cF.call(t);
}
var hF = fF, M4 = $c, dF = uF, pF = hF, mF = "[object Null]", gF = "[object Undefined]", k4 = M4 ? M4.toStringTag : void 0;
function vF(t) {
  return t == null ? t === void 0 ? gF : mF : k4 && k4 in Object(t) ? dF(t) : pF(t);
}
var vu = vF;
function _F(t) {
  return t != null && typeof t == "object";
}
var Do = _F, bF = vu, yF = Do, wF = "[object Symbol]";
function xF(t) {
  return typeof t == "symbol" || yF(t) && bF(t) == wF;
}
var _u = xF, CF = Ue, $F = _u, TF = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, OF = /^\w*$/;
function SF(t, e) {
  if (CF(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || $F(t) ? !0 : OF.test(t) || !TF.test(t) || e != null && t in Object(e);
}
var l_ = SF;
function EF(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var bu = EF, AF = vu, PF = bu, MF = "[object AsyncFunction]", kF = "[object Function]", NF = "[object GeneratorFunction]", IF = "[object Proxy]";
function RF(t) {
  if (!PF(t))
    return !1;
  var e = AF(t);
  return e == kF || e == NF || e == MF || e == IF;
}
var yp = RF, LF = Hi, DF = LF["__core-js_shared__"], FF = DF, sg = FF, N4 = function() {
  var t = /[^.]+$/.exec(sg && sg.keys && sg.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function zF(t) {
  return !!N4 && N4 in t;
}
var BF = zF, HF = Function.prototype, jF = HF.toString;
function VF(t) {
  if (t != null) {
    try {
      return jF.call(t);
    } catch (e) {
    }
    try {
      return t + "";
    } catch (e) {
    }
  }
  return "";
}
var r9 = VF, WF = yp, UF = BF, YF = bu, qF = r9, GF = /[\\^$.*+?()[\]{}|]/g, KF = /^\[object .+?Constructor\]$/, XF = Function.prototype, ZF = Object.prototype, JF = XF.toString, QF = ZF.hasOwnProperty, tz = RegExp(
  "^" + JF.call(QF).replace(GF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ez(t) {
  if (!YF(t) || UF(t))
    return !1;
  var e = WF(t) ? tz : KF;
  return e.test(qF(t));
}
var nz = ez;
function rz(t, e) {
  return t == null ? void 0 : t[e];
}
var iz = rz, az = nz, oz = iz;
function sz(t, e) {
  var n = oz(t, e);
  return az(n) ? n : void 0;
}
var Fo = sz, uz = Fo, lz = uz(Object, "create"), wp = lz, I4 = wp;
function cz() {
  this.__data__ = I4 ? I4(null) : {}, this.size = 0;
}
var fz = cz;
function hz(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var dz = hz, pz = wp, mz = "__lodash_hash_undefined__", gz = Object.prototype, vz = gz.hasOwnProperty;
function _z(t) {
  var e = this.__data__;
  if (pz) {
    var n = e[t];
    return n === mz ? void 0 : n;
  }
  return vz.call(e, t) ? e[t] : void 0;
}
var bz = _z, yz = wp, wz = Object.prototype, xz = wz.hasOwnProperty;
function Cz(t) {
  var e = this.__data__;
  return yz ? e[t] !== void 0 : xz.call(e, t);
}
var $z = Cz, Tz = wp, Oz = "__lodash_hash_undefined__";
function Sz(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Tz && e === void 0 ? Oz : e, this;
}
var Ez = Sz, Az = fz, Pz = dz, Mz = bz, kz = $z, Nz = Ez;
function yu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
yu.prototype.clear = Az;
yu.prototype.delete = Pz;
yu.prototype.get = Mz;
yu.prototype.has = kz;
yu.prototype.set = Nz;
var Iz = yu;
function Rz() {
  this.__data__ = [], this.size = 0;
}
var Lz = Rz;
function Dz(t, e) {
  return t === e || t !== t && e !== e;
}
var xp = Dz, Fz = xp;
function zz(t, e) {
  for (var n = t.length; n--; )
    if (Fz(t[n][0], e))
      return n;
  return -1;
}
var Cp = zz, Bz = Cp, Hz = Array.prototype, jz = Hz.splice;
function Vz(t) {
  var e = this.__data__, n = Bz(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : jz.call(e, n, 1), --this.size, !0;
}
var Wz = Vz, Uz = Cp;
function Yz(t) {
  var e = this.__data__, n = Uz(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var qz = Yz, Gz = Cp;
function Kz(t) {
  return Gz(this.__data__, t) > -1;
}
var Xz = Kz, Zz = Cp;
function Jz(t, e) {
  var n = this.__data__, r = Zz(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var Qz = Jz, tB = Lz, eB = Wz, nB = qz, rB = Xz, iB = Qz;
function wu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
wu.prototype.clear = tB;
wu.prototype.delete = eB;
wu.prototype.get = nB;
wu.prototype.has = rB;
wu.prototype.set = iB;
var $p = wu, aB = Fo, oB = Hi, sB = aB(oB, "Map"), c_ = sB, R4 = Iz, uB = $p, lB = c_;
function cB() {
  this.size = 0, this.__data__ = {
    hash: new R4(),
    map: new (lB || uB)(),
    string: new R4()
  };
}
var fB = cB;
function hB(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var dB = hB, pB = dB;
function mB(t, e) {
  var n = t.__data__;
  return pB(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Tp = mB, gB = Tp;
function vB(t) {
  var e = gB(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var _B = vB, bB = Tp;
function yB(t) {
  return bB(this, t).get(t);
}
var wB = yB, xB = Tp;
function CB(t) {
  return xB(this, t).has(t);
}
var $B = CB, TB = Tp;
function OB(t, e) {
  var n = TB(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var SB = OB, EB = fB, AB = _B, PB = wB, MB = $B, kB = SB;
function xu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
xu.prototype.clear = EB;
xu.prototype.delete = AB;
xu.prototype.get = PB;
xu.prototype.has = MB;
xu.prototype.set = kB;
var f_ = xu, i9 = f_, NB = "Expected a function";
function h_(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(NB);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = t.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (h_.Cache || i9)(), n;
}
h_.Cache = i9;
var IB = h_, RB = IB, LB = 500;
function DB(t) {
  var e = RB(t, function(r) {
    return n.size === LB && n.clear(), r;
  }), n = e.cache;
  return e;
}
var FB = DB, zB = FB, BB = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, HB = /\\(\\)?/g, jB = zB(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(BB, function(n, r, i, a) {
    e.push(i ? a.replace(HB, "$1") : r || n);
  }), e;
}), VB = jB;
function WB(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var Op = WB, L4 = $c, UB = Op, YB = Ue, qB = _u, GB = 1 / 0, D4 = L4 ? L4.prototype : void 0, F4 = D4 ? D4.toString : void 0;
function a9(t) {
  if (typeof t == "string")
    return t;
  if (YB(t))
    return UB(t, a9) + "";
  if (qB(t))
    return F4 ? F4.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -GB ? "-0" : e;
}
var KB = a9, XB = KB;
function ZB(t) {
  return t == null ? "" : XB(t);
}
var Sp = ZB, JB = Ue, QB = l_, tH = VB, eH = Sp;
function nH(t, e) {
  return JB(t) ? t : QB(t, e) ? [t] : tH(eH(t));
}
var o9 = nH, rH = _u, iH = 1 / 0;
function aH(t) {
  if (typeof t == "string" || rH(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -iH ? "-0" : e;
}
var Ep = aH, oH = o9, sH = Ep;
function uH(t, e) {
  e = oH(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[sH(e[n++])];
  return n && n == r ? t : void 0;
}
var d_ = uH, lH = d_;
function cH(t, e, n) {
  var r = t == null ? void 0 : lH(t, e);
  return r === void 0 ? n : r;
}
var He = cH, fH = Sp, hH = 0;
function dH(t) {
  var e = ++hH;
  return fH(t) + e;
}
var p_ = dH, s9 = function() {
  if (typeof Map != "undefined")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(i, a) {
      return i[0] === n ? (r = a, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, e.prototype.set = function(n, r) {
        var i = t(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, i = t(r, n);
        ~i && r.splice(i, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, a = this.__entries__; i < a.length; i++) {
          var o = a[i];
          n.call(r, o[1], o[0]);
        }
      }, e;
    }()
  );
}(), d0 = typeof window != "undefined" && typeof document != "undefined" && window.document === document, nd = function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
}(), pH = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(nd) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), mH = 2;
function gH(t, e) {
  var n = !1, r = !1, i = 0;
  function a() {
    n && (n = !1, t()), r && s();
  }
  function o() {
    pH(a);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - i < mH)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(o, e);
    i = l;
  }
  return s;
}
var vH = 20, _H = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], bH = typeof MutationObserver != "undefined", yH = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = gH(this.refresh.bind(this), vH);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !d0 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), bH ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !d0 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, i = _H.some(function(a) {
        return !!~r.indexOf(a);
      });
      i && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), u9 = function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(t, i, {
      value: e[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, Ws = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || nd;
}, l9 = Ap(0, 0, 0, 0);
function rd(t) {
  return parseFloat(t) || 0;
}
function z4(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, i) {
    var a = t["border-" + i + "-width"];
    return r + rd(a);
  }, 0);
}
function wH(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, i = e; r < i.length; r++) {
    var a = i[r], o = t["padding-" + a];
    n[a] = rd(o);
  }
  return n;
}
function xH(t) {
  var e = t.getBBox();
  return Ap(0, 0, e.width, e.height);
}
function CH(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return l9;
  var r = Ws(t).getComputedStyle(t), i = wH(r), a = i.left + i.right, o = i.top + i.bottom, s = rd(r.width), l = rd(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + a) !== e && (s -= z4(r, "left", "right") + a), Math.round(l + o) !== n && (l -= z4(r, "top", "bottom") + o)), !TH(t)) {
    var c = Math.round(s + a) - e, h = Math.round(l + o) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(h) !== 1 && (l -= h);
  }
  return Ap(i.left, i.top, s, l);
}
var $H = function() {
  return typeof SVGGraphicsElement != "undefined" ? function(t) {
    return t instanceof Ws(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Ws(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function TH(t) {
  return t === Ws(t).document.documentElement;
}
function OH(t) {
  return d0 ? $H(t) ? xH(t) : CH(t) : l9;
}
function SH(t) {
  var e = t.x, n = t.y, r = t.width, i = t.height, a = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, o = Object.create(a.prototype);
  return u9(o, {
    x: e,
    y: n,
    width: r,
    height: i,
    top: n,
    right: e + r,
    bottom: i + n,
    left: e
  }), o;
}
function Ap(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var EH = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ap(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = OH(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), AH = (
  /** @class */
  function() {
    function t(e, n) {
      var r = SH(n);
      u9(this, { target: e, contentRect: r });
    }
    return t;
  }()
), PH = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new s9(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(e instanceof Ws(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new EH(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(e instanceof Ws(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new AH(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), c9 = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new s9(), f9 = (
  /** @class */
  function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = yH.getInstance(), r = new PH(e, n, this);
      c9.set(this, r);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  f9.prototype[t] = function() {
    var e;
    return (e = c9.get(this))[t].apply(e, arguments);
  };
});
var m_ = function() {
  return typeof nd.ResizeObserver != "undefined" ? nd.ResizeObserver : f9;
}();
class MH {
  constructor() {
    Vf(this, "live");
    Vf(this, "callback");
    this.live = !1, this.callback = () => null;
  }
  start(e) {
    this.live = !0, this.callback = e, this.schedule();
  }
  stop() {
    this.live = !1, this.callback = () => null;
  }
  schedule() {
    this.callback(), this.live && window.requestAnimationFrame(this.schedule.bind(this));
  }
}
const kH = te({
  name: "ActiveTextTruncate",
  props: {
    /**
     * Number of Pixel Per Millisecond for the text transition.
     */
    ppms: {
      type: Number,
      default: 0.025
    },
    /**
     * Maximum width of the fading mask.
     */
    fadingMaxWidth: {
      type: Number,
      default: 50,
      validator: (t) => t > 0
    },
    /**
     * Minimum width of the fading mask.
     */
    fadingMinWidth: {
      type: Number,
      default: 1e-3,
      validator: (t) => t > 0
    },
    /**
     * Delay to start moving the text (in milliseconds).
     */
    delay: {
      type: Number,
      default: 1e3
    },
    /**
     * Direction of the truncate
     */
    direction: {
      type: String,
      default: "ltr",
      validator: (t) => ["ltr", "rtl"].indexOf(t) > -1
    }
  },
  data() {
    return {
      textLivePosition: 0,
      // This will hold a key generated every time the component is resized.
      resizeObserverKey: null
    };
  },
  resizeObserver: null,
  computed: {
    wrapperElement() {
      const t = ".active-text-truncate__wrapper";
      return this.resizeObserverKey ? this.$el.querySelector(t) : null;
    },
    wrapperElementWidth() {
      return He(this, "wrapperElement.offsetWidth", 0);
    },
    textElement() {
      const t = ".active-text-truncate__wrapper__text";
      return this.resizeObserverKey ? this.$el.querySelector(t) : null;
    },
    textElementWidth() {
      return He(this, "textElement.offsetWidth", 0);
    },
    textOffsetTransitionDelay() {
      return `${this.delay}ms`;
    },
    textOffsetTransitionDuration() {
      return `${Math.abs(this.wrapperElementWidth - this.textElementWidth) / this.ppms}ms`;
    },
    textInitialOffset() {
      return "0";
    },
    textFinalOffset() {
      return `${this.wrapperElementWidth - this.textElementWidth}px`;
    },
    textOffsetValues() {
      return this.direction === "ltr" ? [this.textInitialOffset, this.textFinalOffset] : [this.textFinalOffset, this.textInitialOffset];
    },
    isFadingLeft() {
      return this.direction === "rtl" && this.isFading;
    },
    isFadingRight() {
      return this.direction === "ltr" && this.isFading;
    },
    isFading() {
      return this.wrapperElementWidth < this.textElementWidth;
    },
    fadingLeftWidth() {
      const t = this.textLivePosition;
      return `${Math.min(Math.max(this.fadingMinWidth, Math.abs(t)), this.fadingMaxWidth)}px`;
    },
    fadingRightWidth() {
      const t = parseInt(this.textFinalOffset) - this.textLivePosition;
      return `${Math.min(Math.max(this.fadingMinWidth, Math.abs(t)), this.fadingMaxWidth)}px`;
    },
    textLivePositionRequestAnimationFrame() {
      return new MH();
    }
  },
  mounted() {
    return _e(this, null, function* () {
      var t;
      this.$options.resizeObserver = new m_(this.setup), yield this.$nextTick(), (t = this.$options.resizeObserver) == null || t.observe(this.$el);
    });
  },
  beforeDestroy() {
    var t;
    (t = this.$options.resizeObserver) == null || t.unobserve(this.$el), this.$options.resizeObserver = null;
  },
  methods: {
    setup() {
      this.resizeObserverKey = p_(), this.textLivePosition = parseInt(this.textOffsetValues[0]), this.listenOnTextElement("transitionstart", this.startTrackingTextLivePosition), this.listenOnTextElement("transitionend", this.endTrackingTextLivePosition), this.listenOnTextElement("transitioncancel", this.resetTextLivePosition);
    },
    listenOnTextElement(t, e) {
      var n, r;
      (n = this.textElement) == null || n.removeEventListener(t, e), (r = this.textElement) == null || r.addEventListener(t, e);
    },
    trackTextLivePosition() {
      if (!this.textElement)
        return;
      const t = window.getComputedStyle(this.textElement, null).getPropertyValue("left");
      this.textLivePosition = parseInt(t);
    },
    startTrackingTextLivePosition() {
      this.textLivePositionRequestAnimationFrame.start(this.trackTextLivePosition), this.$emit("start");
    },
    endTrackingTextLivePosition() {
      this.textLivePositionRequestAnimationFrame.stop(), this.$emit("end");
    },
    resetTextLivePosition() {
      this.textLivePositionRequestAnimationFrame.stop(), this.textLivePosition = parseInt(this.textOffsetValues[0]), this.$emit("cancel");
    }
  }
});
var NH = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("span", { staticClass: "active-text-truncate", class: {
    "active-text-truncate--fading": e.isFading,
    [`active-text-truncate--${e.direction}`]: !0
  }, style: {
    "--fading-left-width": e.fadingLeftWidth,
    "--fading-right-width": e.fadingRightWidth,
    "--text-offset-transition-duration": e.textOffsetTransitionDuration,
    "--text-offset-transition-delay": e.textOffsetTransitionDelay,
    "--text-final-offset": e.textFinalOffset
  }, on: { mouseleave: e.resetTextLivePosition } }, [n("span", { staticClass: "active-text-truncate__wrapper" }, [n("span", { staticClass: "active-text-truncate__wrapper__text" }, [e._t("default")], 2)])]);
}, IH = [], RH = /* @__PURE__ */ Bt(
  kH,
  NH,
  IH,
  !1,
  null,
  "a48c9449",
  null,
  null
);
const LH = RH.exports;
var h9 = function() {
  return (h9 = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++)
      for (var i in e = arguments[n])
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    return t;
  }).apply(this, arguments);
}, ug = { kebab: /-(\w)/g, styleProp: /:(.*)/, styleList: /;(?![^(]*\))/g };
function DH(t, e) {
  return e ? e.toUpperCase() : "";
}
function FH(t) {
  for (var e, n = {}, r = 0, i = t.split(ug.styleList); r < i.length; r++) {
    var a = i[r].split(ug.styleProp), o = a[0], s = a[1];
    (o = o.trim()) && (typeof s == "string" && (s = s.trim()), n[e = o, e.replace(ug.kebab, DH)] = s);
  }
  return n;
}
function ji() {
  for (var t, e, n = {}, r = arguments.length; r--; )
    for (var i = 0, a = Object.keys(arguments[r]); i < a.length; i++)
      switch (t = a[i]) {
        case "class":
        case "style":
        case "directives":
          if (Array.isArray(n[t]) || (n[t] = []), t === "style") {
            var o = void 0;
            o = Array.isArray(arguments[r].style) ? arguments[r].style : [arguments[r].style];
            for (var s = 0; s < o.length; s++) {
              var l = o[s];
              typeof l == "string" && (o[s] = FH(l));
            }
            arguments[r].style = o;
          }
          n[t] = n[t].concat(arguments[r][t]);
          break;
        case "staticClass":
          if (!arguments[r][t])
            break;
          n[t] === void 0 && (n[t] = ""), n[t] && (n[t] += " "), n[t] += arguments[r][t].trim();
          break;
        case "on":
        case "nativeOn":
          n[t] || (n[t] = {});
          for (var c = 0, h = Object.keys(arguments[r][t] || {}); c < h.length; c++)
            e = h[c], n[t][e] ? n[t][e] = [].concat(n[t][e], arguments[r][t][e]) : n[t][e] = arguments[r][t][e];
          break;
        case "attrs":
        case "props":
        case "domProps":
        case "scopedSlots":
        case "staticStyle":
        case "hook":
        case "transition":
          n[t] || (n[t] = {}), n[t] = h9({}, arguments[r][t], n[t]);
          break;
        case "slot":
        case "key":
        case "ref":
        case "tag":
        case "show":
        case "keepAlive":
        default:
          n[t] || (n[t] = arguments[r][t]);
      }
  return n;
}
var Ls = "_uid", Cu = typeof window != "undefined", d9 = typeof document != "undefined", p9 = typeof navigator != "undefined", zH = typeof MutationObserver != "undefined" || typeof WebKitMutationObserver != "undefined" || typeof MozMutationObserver != "undefined", Je = Cu && d9 && p9, Te = Cu ? window : {}, $u = d9 ? document : {}, m9 = p9 ? navigator : {}, BH = (m9.userAgent || "").toLowerCase();
BH.indexOf("jsdom") > 0;
var HH = function() {
  var t = !1;
  if (Je)
    try {
      var e = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          t = !0;
        }
      };
      Te.addEventListener("test", e, e), Te.removeEventListener("test", e, e);
    } catch (n) {
      t = !1;
    }
  return t;
}(), jH = Je && ("ontouchstart" in $u.documentElement || m9.maxTouchPoints > 0);
Je && (Te.PointerEvent || Te.MSPointerEvent);
Je && "IntersectionObserver" in Te && "IntersectionObserverEntry" in Te && // Edge 15 and UC Browser lack support for `isIntersecting`
// but we an use `intersectionRatio > 0` instead
// 'isIntersecting' in window.IntersectionObserverEntry.prototype &&
"intersectionRatio" in Te.IntersectionObserverEntry.prototype;
var VH = "$bvConfig", WH = /^(BV?)/, UH = /\B([A-Z])/g, YH = /%2C/g, qH = /[!'()*]/g;
function p0(t) {
  return p0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, p0(t);
}
function Pp(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Mp(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  Object.defineProperty(t, "prototype", { value: Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), writable: !1 }), e && Yl(t, e);
}
function kp(t) {
  var e = g9();
  return function() {
    var r = ql(t), i;
    if (e) {
      var a = ql(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return GH(this, i);
  };
}
function GH(t, e) {
  if (e && (p0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return KH(t);
}
function KH(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function id(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return id = function(r) {
    if (r === null || !XH(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e != "undefined") {
      if (e.has(r))
        return e.get(r);
      e.set(r, i);
    }
    function i() {
      return Oh(r, arguments, ql(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Yl(i, r);
  }, id(t);
}
function Oh(t, e, n) {
  return g9() ? Oh = Reflect.construct : Oh = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(i, s), c = new l();
    return o && Yl(c, o.prototype), c;
  }, Oh.apply(null, arguments);
}
function g9() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (t) {
    return !1;
  }
}
function XH(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function Yl(t, e) {
  return Yl = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Yl(t, e);
}
function ql(t) {
  return ql = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ql(t);
}
var g_ = Cu ? Te.Element : /* @__PURE__ */ function(t) {
  Mp(n, t);
  var e = kp(n);
  function n() {
    return Pp(this, n), e.apply(this, arguments);
  }
  return n;
}(/* @__PURE__ */ id(Object)), ga = Cu ? Te.HTMLElement : /* @__PURE__ */ function(t) {
  Mp(n, t);
  var e = kp(n);
  function n() {
    return Pp(this, n), e.apply(this, arguments);
  }
  return n;
}(g_), v9 = Cu ? Te.SVGElement : /* @__PURE__ */ function(t) {
  Mp(n, t);
  var e = kp(n);
  function n() {
    return Pp(this, n), e.apply(this, arguments);
  }
  return n;
}(g_);
Cu && Te.File;
function ad(t) {
  return ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ad(t);
}
var Np = function(e) {
  return ad(e);
}, ba = function(e) {
  return e === void 0;
}, Ri = function(e) {
  return e === null;
}, si = function(e) {
  return ba(e) || Ri(e);
}, Me = function(e) {
  return Np(e) === "function";
}, v_ = function(e) {
  return Np(e) === "boolean";
}, fa = function(e) {
  return Np(e) === "string";
}, _9 = function(e) {
  return Np(e) === "number";
}, Us = function(e) {
  return Array.isArray(e);
}, Oi = function(e) {
  return e !== null && ad(e) === "object";
}, ya = function(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}, B4 = function(e) {
  return e instanceof Date;
}, Ip = function(e) {
  return e instanceof Event;
};
function H4(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ys(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? H4(Object(n), !0).forEach(function(r) {
      Tc(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : H4(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Tc(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var b9 = function() {
  return Object.assign.apply(Object, arguments);
}, y9 = function(e, n) {
  return Object.defineProperties(e, n);
}, ZH = function(e, n, r) {
  return Object.defineProperty(e, n, r);
}, Se = function(e) {
  return Object.keys(e);
}, m0 = function(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}, w9 = function(e, n) {
  return Se(e).filter(function(r) {
    return n.indexOf(r) !== -1;
  }).reduce(function(r, i) {
    return Ys(Ys({}, r), {}, Tc({}, i, e[i]));
  }, {});
}, Tu = function(e, n) {
  return Se(e).filter(function(r) {
    return n.indexOf(r) === -1;
  }).reduce(function(r, i) {
    return Ys(Ys({}, r), {}, Tc({}, i, e[i]));
  }, {});
}, JH = function t(e, n) {
  return Oi(e) && Oi(n) && Se(n).forEach(function(r) {
    Oi(n[r]) ? ((!e[r] || !Oi(e[r])) && (e[r] = n[r]), t(e[r], n[r])) : b9(e, Tc({}, r, n[r]));
  }), e;
}, jn = function(e) {
  return Se(e).sort().reduce(function(n, r) {
    return Ys(Ys({}, n), {}, Tc({}, r, e[r]));
  }, {});
}, ia = function() {
  return {
    enumerable: !0,
    configurable: !1,
    writable: !1
  };
};
function j4(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V4(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? j4(Object(n), !0).forEach(function(r) {
      x9(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j4(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function x9(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function QH(t) {
  return rj(t) || nj(t) || ej(t) || tj();
}
function tj() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ej(t, e) {
  if (t) {
    if (typeof t == "string")
      return g0(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return g0(t, e);
  }
}
function nj(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function rj(t) {
  if (Array.isArray(t))
    return g0(t);
}
function g0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
var Rp = function t(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
  return Us(e) ? e.reduce(function(r, i) {
    return [].concat(QH(r), [t(i, i)]);
  }, []) : ya(e) ? Se(e).reduce(function(r, i) {
    return V4(V4({}, r), {}, x9({}, i, t(e[i], e[i])));
  }, {}) : n;
}, Vi = function(e) {
  return e;
}, W4 = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = typeof process != "undefined" && process ? process.env || {} : {};
  return e ? r[e] || n : r;
}, ij = function() {
  return W4("BOOTSTRAP_VUE_NO_WARN") || W4("NODE_ENV") === "production";
}, Oc = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  ij() || console.warn("[BootstrapVue warn]: ".concat(n ? "".concat(n, " - ") : "").concat(e));
}, aj = function(e) {
  return zH ? !1 : (Oc("".concat(e, ": Requires MutationObserver support.")), !0);
}, C9 = "BButton", $9 = "BButtonClose", qs = "BDropdown", T9 = "BDropdownItem", O9 = "BFormInput", S9 = "BInputGroup", E9 = "BInputGroupAddon", A9 = "BInputGroupAppend", P9 = "BInputGroupPrepend", M9 = "BInputGroupText", __ = "BLink", Ci = "BModal", k9 = "BNav", N9 = "BNavItemDropdown", Lp = "BPagination", I9 = "BPopover", R9 = "BTab", L9 = "BTabs", so = "BTooltip", oj = "BVPopover", sj = "BVPopoverTemplate", uj = "BVPopper", lj = "BVTabButton", cj = "BVTooltip", fj = "BVTooltipTemplate", hj = "BVTransition", dj = "BVTransporter", pj = "BVTransporterTarget", mj = "activate-tab", gj = "blur", vj = "cancel", b_ = "change", _j = "changed", wa = "click", v0 = "close", _0 = "disable", Sh = "disabled", b0 = "enable", Eh = "enabled", D9 = "first", F9 = "focusin", z9 = "focusout", wn = "hidden", Pi = "hide", B9 = "input", H9 = "last", j9 = "mouseenter", V9 = "mouseleave", W9 = "next", bj = "ok", U4 = "open", yj = "page-click", U9 = "prev", Cr = "show", Mi = "shown", Y9 = "toggle", wj = "update", xj = "hook:beforeDestroy", q9 = "hook:destroyed", y_ = "update:", G9 = "bv", K9 = "::", $e = {
  passive: !0,
  capture: !1
}, X9 = void 0, w_ = Array, st = Boolean, Dp = Function, vo = Number, Lr = Object, Q = String, Cj = [w_, Dp], fe = [w_, Lr, Q], Gs = [w_, Q], $j = [st, vo, Q], Tj = [st, Q], Oj = [Dp, Q], Bn = [vo, Q], Sj = [vo, Lr, Q], Z9 = [Lr, Q], Y4 = "append", Ej = "button-content", xo = "default", Aj = "ellipsis-text", Pj = "empty", Mj = "first-text", kj = "last-text", Nj = "modal-backdrop", q4 = "modal-cancel", Ij = "modal-footer", Rj = "modal-header", Lj = "modal-header-close", G4 = "modal-ok", lg = "modal-title", Dj = "next-text", Fj = "page", K4 = "prepend", zj = "prev-text", Bj = "tabs-end", Hj = "tabs-start", jj = "text", x_ = "title", J9 = function() {
  return Array.from.apply(Array, arguments);
}, ln = function(e, n) {
  return e.indexOf(n) !== -1;
}, Fr = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return Array.prototype.concat.apply([], n);
}, Vj = function(e, n) {
  var r = Me(n) ? n : function() {
    return n;
  };
  return Array.apply(null, {
    length: e
  }).map(r);
}, Qt = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, r = parseInt(e, 10);
  return isNaN(r) ? n : r;
}, co = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, r = parseFloat(e);
  return isNaN(r) ? n : r;
}, Wj = function(e) {
  return e.replace(UH, "-$1").toLowerCase();
}, nr = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  return si(e) ? "" : Us(e) || ya(e) && e.toString === Object.prototype.toString ? JSON.stringify(e, null, n) : String(e);
}, Ah = g_.prototype, Uj = ["button", "[href]:not(.disabled)", "input", "select", "textarea", "[tabindex]", "[contenteditable]"].map(function(t) {
  return "".concat(t, ":not(:disabled):not([disabled])");
}).join(", "), Yj = Ah.matches || Ah.msMatchesSelector || Ah.webkitMatchesSelector, qj = Ah.closest || function(t) {
  var e = this;
  do {
    if (tx(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (!Ri(e) && e.nodeType === Node.ELEMENT_NODE);
  return null;
}, Nr = (Te.requestAnimationFrame || Te.webkitRequestAnimationFrame || Te.mozRequestAnimationFrame || Te.msRequestAnimationFrame || Te.oRequestAnimationFrame || // Fallback, but not a true polyfill
// Only needed for Opera Mini
/* istanbul ignore next */
function(t) {
  return setTimeout(t, 16);
}).bind(Te), Gj = Te.MutationObserver || Te.WebKitMutationObserver || Te.MozMutationObserver || null, Kj = function(e) {
  return e && e.parentNode && e.parentNode.removeChild(e);
}, Ee = function(e) {
  return !!(e && e.nodeType === Node.ELEMENT_NODE);
}, od = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = $u.activeElement;
  return n && !e.some(function(r) {
    return r === n;
  }) ? n : null;
}, Fp = function(e, n) {
  return nr(e).toLowerCase() === nr(n).toLowerCase();
}, Q9 = function(e) {
  return Ee(e) && e === od();
}, Co = function(e) {
  if (!Ee(e) || !e.parentNode || !ze($u.body, e) || _l(e, "display") === "none")
    return !1;
  var n = y0(e);
  return !!(n && n.height > 0 && n.width > 0);
}, gl = function(e) {
  return !Ee(e) || e.disabled || Ds(e, "disabled") || nx(e, "disabled");
}, _o = function(e, n) {
  return J9((Ee(n) ? n : $u).querySelectorAll(e));
}, Sc = function(e, n) {
  return (Ee(n) ? n : $u).querySelector(e) || null;
}, tx = function(e, n) {
  return Ee(e) ? Yj.call(e, n) : !1;
}, sd = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (!Ee(n))
    return null;
  var i = qj.call(n, e);
  return r ? i : i === n ? null : i;
}, ze = function(e, n) {
  return e && Me(e.contains) ? e.contains(n) : !1;
}, X4 = function(e) {
  return $u.getElementById(/^#/.test(e) ? e.slice(1) : e) || null;
}, vl = function(e, n) {
  n && Ee(e) && e.classList && e.classList.add(n);
}, ex = function(e, n) {
  n && Ee(e) && e.classList && e.classList.remove(n);
}, nx = function(e, n) {
  return n && Ee(e) && e.classList ? e.classList.contains(n) : !1;
}, Xr = function(e, n, r) {
  n && Ee(e) && e.setAttribute(n, r);
}, Il = function(e, n) {
  n && Ee(e) && e.removeAttribute(n);
}, ha = function(e, n) {
  return n && Ee(e) ? e.getAttribute(n) : null;
}, Ds = function(e, n) {
  return n && Ee(e) ? e.hasAttribute(n) : null;
}, na = function(e, n, r) {
  n && Ee(e) && (e.style[n] = r);
}, _l = function(e, n) {
  return n && Ee(e) && e.style[n] || null;
}, y0 = function(e) {
  return Ee(e) ? e.getBoundingClientRect() : null;
}, $s = function(e) {
  var n = Te.getComputedStyle;
  return n && Ee(e) ? n(e) : {};
}, Xj = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  return _o(Uj, e).filter(Co).filter(function(n) {
    return n.tabIndex > -1 && !n.disabled;
  });
}, Oe = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  try {
    e.focus(n);
  } catch (r) {
  }
  return Q9(e);
}, C_ = function(e) {
  try {
    e.blur();
  } catch (n) {
  }
  return !Q9(e);
}, Zj = Ot.prototype, Z4 = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, r = Zj[VH];
  return r ? r.getConfigValue(e, n) : Rp(n);
}, Ts = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  return n ? Z4("".concat(e, ".").concat(n), r) : Z4(e, {});
};
function J4(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bo(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? J4(Object(n), !0).forEach(function(r) {
      rx(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J4(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function rx(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var M = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : X9, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : void 0, a = r === !0;
  return i = a ? i : r, bo(bo(bo({}, e ? {
    type: e
  } : {}), a ? {
    required: a
  } : ba(n) ? {} : {
    default: Oi(n) ? function() {
      return n;
    } : n
  }), ba(i) ? {} : {
    validator: i
  });
}, $_ = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Vi;
  return (Us(e) ? e.slice() : Se(e)).reduce(function(i, a) {
    return i[r(a)] = n[a], i;
  }, {});
}, ix = function(e, n, r) {
  return bo(bo({}, Rp(e)), {}, {
    default: function() {
      var a = Ts(r, n, e.default);
      return Me(a) ? a() : a;
    }
  });
}, ue = function(e, n) {
  return Se(e).reduce(function(r, i) {
    return bo(bo({}, r), {}, rx({}, i, ix(e[i], i, n)));
  }, {});
}, Jj = ix({}, "", "").default.name, ax = function(e) {
  return Me(e) && e.name && e.name !== Jj;
};
function Qj(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var zp = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.type, i = r === void 0 ? X9 : r, a = n.defaultValue, o = a === void 0 ? void 0 : a, s = n.validator, l = s === void 0 ? void 0 : s, c = n.event, h = c === void 0 ? B9 : c, d = Qj({}, e, M(i, o, l)), p = Ot.extend({
    model: {
      prop: e,
      event: h
    },
    props: d
  });
  return {
    mixin: p,
    props: d,
    prop: e,
    event: h
  };
}, ud = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return e = Fr(e).filter(Vi), e.some(function(i) {
    return n[i] || r[i];
  });
}, Rl = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  e = Fr(e).filter(Vi);
  for (var a, o = 0; o < e.length && !a; o++) {
    var s = e[o];
    a = r[s] || i[s];
  }
  return Me(a) ? a(n) : a;
}, Wi = Ot.extend({
  methods: {
    // Returns `true` if the either a `$scopedSlot` or `$slot` exists with the specified name
    // `name` can be a string name or an array of names
    hasNormalizedSlot: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xo, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.$scopedSlots, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.$slots;
      return ud(e, n, r);
    },
    // Returns an array of rendered VNodes if slot found, otherwise `undefined`
    // `name` can be a string name or an array of names
    normalizeSlot: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xo, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.$scopedSlots, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.$slots, a = Rl(e, n, r, i);
      return a && Fr(a);
    }
  }
}), ox = function(e) {
  return HH ? Oi(e) ? e : {
    capture: !!e || !1
  } : !!(Oi(e) ? e.capture : e);
}, gn = function(e, n, r, i) {
  e && e.addEventListener && e.addEventListener(n, r, ox(i));
}, zr = function(e, n, r, i) {
  e && e.removeEventListener && e.removeEventListener(n, r, ox(i));
}, w0 = function(e) {
  for (var n = e ? gn : zr, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
    i[a - 1] = arguments[a];
  n.apply(void 0, i);
}, ke = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.preventDefault, i = r === void 0 ? !0 : r, a = n.propagation, o = a === void 0 ? !0 : a, s = n.immediatePropagation, l = s === void 0 ? !1 : s;
  i && e.preventDefault(), o && e.stopPropagation(), l && e.stopImmediatePropagation();
}, sx = function(e) {
  return Wj(e.replace(WH, ""));
}, ki = function(e, n) {
  return [G9, sx(e), n].join(K9);
}, fo = function(e, n) {
  return [G9, n, sx(e)].join(K9);
};
function tV(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var eV = ue({
  ariaLabel: M(Q, "Close"),
  content: M(Q, "&times;"),
  disabled: M(st, !1),
  textVariant: M(Q)
}, $9), nV = /* @__PURE__ */ Ot.extend({
  name: $9,
  functional: !0,
  props: eV,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.slots, o = n.scopedSlots, s = a(), l = o || {}, c = {
      staticClass: "close",
      class: tV({}, "text-".concat(r.textVariant), r.textVariant),
      attrs: {
        type: "button",
        disabled: r.disabled,
        "aria-label": r.ariaLabel ? String(r.ariaLabel) : null
      },
      on: {
        click: function(d) {
          r.disabled && Ip(d) && ke(d);
        }
      }
    };
    return ud(xo, l, s) || (c.domProps = {
      innerHTML: r.content
    }), e("button", ji(i, c), Rl(xo, {}, l, s));
  }
});
function Q4(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function As(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Q4(Object(n), !0).forEach(function(r) {
      rV(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Q4(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function rV(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ux = {
  name: "",
  enterClass: "",
  enterActiveClass: "",
  enterToClass: "show",
  leaveClass: "show",
  leaveActiveClass: "",
  leaveToClass: ""
}, iV = As(As({}, ux), {}, {
  enterActiveClass: "fade",
  leaveActiveClass: "fade"
}), aV = {
  // Has no effect if `trans-props` provided
  appear: M(st, !1),
  // Can be overridden by user supplied `trans-props`
  mode: M(Q),
  // Only applicable to the built in transition
  // Has no effect if `trans-props` provided
  noFade: M(st, !1),
  // For user supplied transitions (if needed)
  transProps: M(Lr)
}, T_ = /* @__PURE__ */ Ot.extend({
  name: hj,
  functional: !0,
  props: aV,
  render: function(e, n) {
    var r = n.children, i = n.data, a = n.props, o = a.transProps;
    return ya(o) || (o = a.noFade ? ux : iV, a.appear && (o = As(As({}, o), {}, {
      appear: !0,
      appearClass: o.enterClass,
      appearActiveClass: o.enterActiveClass,
      appearToClass: o.enterToClass
    }))), o = As(As({
      mode: a.mode
    }, o), {}, {
      // We always need `css` true
      css: !0
    }), e(
      "transition",
      // Any transition event listeners will get merged here
      ji(i, {
        props: o
      }),
      r
    );
  }
}), Wf = Math.min, Ni = Math.max, oV = Math.ceil, sV = Math.floor, lx = "a", uV = function(e) {
  return "%" + e.charCodeAt(0).toString(16);
}, cs = function(e) {
  return encodeURIComponent(nr(e)).replace(qH, uV).replace(YH, ",");
}, lV = function(e) {
  if (!ya(e))
    return "";
  var n = Se(e).map(function(r) {
    var i = e[r];
    return ba(i) ? "" : Ri(i) ? cs(r) : Us(i) ? i.reduce(function(a, o) {
      return Ri(o) ? a.push(cs(r)) : ba(o) || a.push(cs(r) + "=" + cs(o)), a;
    }, []).join("&") : cs(r) + "=" + cs(i);
  }).filter(function(r) {
    return r.length > 0;
  }).join("&");
  return n ? "?".concat(n) : "";
}, cV = function(e) {
  return !!(e.href || e.to);
}, cx = function(e) {
  return !!(e && !Fp(e, "a"));
}, fV = function(e, n) {
  var r = e.to, i = e.disabled, a = e.routerComponentName, o = !!n.$router;
  return !o || o && (i || !r) ? lx : a || (n.$nuxt ? "nuxt-link" : "router-link");
}, hV = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.target, r = e.rel;
  return n === "_blank" && Ri(r) ? "noopener" : r || null;
}, dV = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.href, r = e.to, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : lx, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "#", o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "/";
  if (n)
    return n;
  if (cx(i))
    return null;
  if (fa(r))
    return r || o;
  if (ya(r) && (r.path || r.query || r.hash)) {
    var s = nr(r.path), l = lV(r.query), c = nr(r.hash);
    return c = !c || c.charAt(0) === "#" ? c : "#".concat(c), "".concat(s).concat(l).concat(c) || o;
  }
  return a;
}, ld = 40, t5 = 35, fx = 13, hx = 27, e5 = 36, dx = 37, px = 39, Bp = 32, O_ = 38, pV = function(e, n) {
  if (e.length !== n.length)
    return !1;
  for (var r = !0, i = 0; r && i < e.length; i++)
    r = Ec(e[i], n[i]);
  return r;
}, Ec = function t(e, n) {
  if (e === n)
    return !0;
  var r = B4(e), i = B4(n);
  if (r || i)
    return r && i ? e.getTime() === n.getTime() : !1;
  if (r = Us(e), i = Us(n), r || i)
    return r && i ? pV(e, n) : !1;
  if (r = Oi(e), i = Oi(n), r || i) {
    if (!r || !i)
      return !1;
    var a = Se(e).length, o = Se(n).length;
    if (a !== o)
      return !1;
    for (var s in e) {
      var l = m0(e, s), c = m0(n, s);
      if (l && !c || !l && c || !t(e[s], n[s]))
        return !1;
    }
  }
  return String(e) === String(n);
};
function n5(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var r5 = function(e) {
  return !e || Se(e).length === 0;
}, mV = function(e) {
  return {
    handler: function(r, i) {
      if (!Ec(r, i)) {
        if (r5(r) || r5(i)) {
          this[e] = Rp(r);
          return;
        }
        for (var a in i)
          m0(r, a) || this.$delete(this.$data[e], a);
        for (var o in r)
          this.$set(this.$data[e], o, r[o]);
      }
    }
  };
}, mx = function(e, n) {
  return Ot.extend({
    data: function() {
      return n5({}, n, Rp(this[e]));
    },
    watch: n5({}, e, mV(n))
  });
}, S_ = mx("$attrs", "bvAttrs"), Kn = "$_rootListeners", Hp = Ot.extend({
  created: function() {
    this[Kn] = {};
  },
  beforeDestroy: function() {
    var e = this;
    Se(this[Kn] || {}).forEach(function(n) {
      e[Kn][n].forEach(function(r) {
        e.listenOffRoot(n, r);
      });
    }), this[Kn] = null;
  },
  methods: {
    registerRootListener: function(e, n) {
      this[Kn] && (this[Kn][e] = this[Kn][e] || [], ln(this[Kn][e], n) || this[Kn][e].push(n));
    },
    unregisterRootListener: function(e, n) {
      this[Kn] && this[Kn][e] && (this[Kn][e] = this[Kn][e].filter(function(r) {
        return r !== n;
      }));
    },
    /**
     * Safely register event listeners on the root Vue node
     * While Vue automatically removes listeners for individual components,
     * when a component registers a listener on `$root` and is destroyed,
     * this orphans a callback because the node is gone, but the `$root`
     * does not clear the callback
     *
     * When registering a `$root` listener, it also registers the listener
     * to be removed in the component's `beforeDestroy()` hook
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOnRoot: function(e, n) {
      this.$root && (this.$root.$on(e, n), this.registerRootListener(e, n));
    },
    /**
     * Safely register a `$once()` event listener on the root Vue node
     * While Vue automatically removes listeners for individual components,
     * when a component registers a listener on `$root` and is destroyed,
     * this orphans a callback because the node is gone, but the `$root`
     * does not clear the callback
     *
     * When registering a `$root` listener, it also registers the listener
     * to be removed in the component's `beforeDestroy()` hook
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOnRootOnce: function(e, n) {
      var r = this;
      if (this.$root) {
        var i = function a() {
          r.unregisterRootListener(a), n.apply(void 0, arguments);
        };
        this.$root.$once(e, i), this.registerRootListener(e, i);
      }
    },
    /**
     * Safely unregister event listeners from the root Vue node
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOffRoot: function(e, n) {
      this.unregisterRootListener(e, n), this.$root && this.$root.$off(e, n);
    },
    /**
     * Convenience method for calling `vm.$emit()` on `$root`
     *
     * @param {string} event
     * @param {*} args
     */
    emitOnRoot: function(e) {
      if (this.$root) {
        for (var n, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          i[a - 1] = arguments[a];
        (n = this.$root).$emit.apply(n, [e].concat(i));
      }
    }
  }
}), gx = mx("$listeners", "bvListeners");
function gV(t) {
  return yV(t) || bV(t) || _V(t) || vV();
}
function vV() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _V(t, e) {
  if (t) {
    if (typeof t == "string")
      return x0(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return x0(t, e);
  }
}
function bV(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function yV(t) {
  if (Array.isArray(t))
    return x0(t);
}
function x0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function i5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? i5(Object(n), !0).forEach(function(r) {
      vx(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : i5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function vx(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var wV = ki(__, "clicked"), _x = {
  activeClass: M(Q),
  append: M(st, !1),
  event: M(Gs),
  exact: M(st, !1),
  exactActiveClass: M(Q),
  exactPath: M(st, !1),
  exactPathActiveClass: M(Q),
  replace: M(st, !1),
  routerTag: M(Q),
  to: M(Z9)
}, bx = {
  noPrefetch: M(st, !1),
  // Must be `null` to fall back to the value defined in the
  // `nuxt.config.js` configuration file for `router.prefetchLinks`
  // We convert `null` to `undefined`, so that Nuxt.js will use the
  // compiled default
  // Vue treats `undefined` as default of `false` for Boolean props,
  // so we must set it as `null` here to be a true tri-state prop
  prefetch: M(st, null)
}, E_ = ue(jn(pn(pn(pn({}, bx), _x), {}, {
  active: M(st, !1),
  disabled: M(st, !1),
  href: M(Q),
  // Must be `null` if no value provided
  rel: M(Q, null),
  // To support 3rd party router links based on `<router-link>` (i.e. `g-link` for Gridsome)
  // Default is to auto choose between `<router-link>` and `<nuxt-link>`
  // Gridsome doesn't provide a mechanism to auto detect and has caveats
  // such as not supporting FQDN URLs or hash only URLs
  routerComponentName: M(Q),
  target: M(Q, "_self")
})), __), Ks = /* @__PURE__ */ Ot.extend({
  name: __,
  // Mixin order is important!
  mixins: [S_, gx, Hp, Wi],
  inheritAttrs: !1,
  props: E_,
  computed: {
    computedTag: function() {
      var e = this.to, n = this.disabled, r = this.routerComponentName;
      return fV({
        to: e,
        disabled: n,
        routerComponentName: r
      }, this);
    },
    isRouterLink: function() {
      return cx(this.computedTag);
    },
    computedRel: function() {
      var e = this.target, n = this.rel;
      return hV({
        target: e,
        rel: n
      });
    },
    computedHref: function() {
      var e = this.to, n = this.href;
      return dV({
        to: e,
        href: n
      }, this.computedTag);
    },
    computedProps: function() {
      var e = this.event, n = this.prefetch, r = this.routerTag;
      return this.isRouterLink ? pn(pn(pn(pn({}, $_(Tu(pn(pn({}, _x), bx), ["event", "prefetch", "routerTag"]), this)), e ? {
        event: e
      } : {}), v_(n) ? {
        prefetch: n
      } : {}), r ? {
        tag: r
      } : {}) : {};
    },
    computedAttrs: function() {
      var e = this.bvAttrs, n = this.computedHref, r = this.computedRel, i = this.disabled, a = this.target, o = this.routerTag, s = this.isRouterLink;
      return pn(pn(pn(pn({}, e), n ? {
        href: n
      } : {}), s && o && !Fp(o, "a") ? {} : {
        rel: r,
        target: a
      }), {}, {
        tabindex: i ? "-1" : ba(e.tabindex) ? null : e.tabindex,
        "aria-disabled": i ? "true" : null
      });
    },
    computedListeners: function() {
      return pn(pn({}, this.bvListeners), {}, {
        // We want to overwrite any click handler since our callback
        // will invoke the user supplied handler(s) if `!this.disabled`
        click: this.onClick
      });
    }
  },
  methods: {
    onClick: function(e) {
      var n = arguments, r = Ip(e), i = this.isRouterLink, a = this.bvListeners.click;
      r && this.disabled ? ke(e, {
        immediatePropagation: !0
      }) : (i && e.currentTarget.__vue__ && e.currentTarget.__vue__.$emit(wa, e), Fr(a).filter(function(o) {
        return Me(o);
      }).forEach(function(o) {
        o.apply(void 0, gV(n));
      }), this.emitOnRoot(wV, e), this.emitOnRoot("clicked::link", e)), r && !i && this.computedHref === "#" && ke(e, {
        propagation: !1
      });
    },
    focus: function() {
      Oe(this.$el);
    },
    blur: function() {
      C_(this.$el);
    }
  },
  render: function(e) {
    var n = this.active, r = this.disabled;
    return e(this.computedTag, vx({
      class: {
        active: n,
        disabled: r
      },
      attrs: this.computedAttrs,
      props: this.computedProps
    }, this.isRouterLink ? "nativeOn" : "on", this.computedListeners), this.normalizeSlot());
  }
});
function a5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? a5(Object(n), !0).forEach(function(r) {
      ro(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function ro(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var jp = Tu(E_, ["event", "routerTag"]);
delete jp.href.default;
delete jp.to.default;
var xV = ue(jn(o5(o5({}, jp), {}, {
  block: M(st, !1),
  disabled: M(st, !1),
  pill: M(st, !1),
  // Tri-state: `true`, `false` or `null`
  // => On, off, not a toggle
  pressed: M(st, null),
  size: M(Q),
  squared: M(st, !1),
  tag: M(Q, "button"),
  type: M(Q, "button"),
  variant: M(Q, "secondary")
})), C9), s5 = function(e) {
  e.type === "focusin" ? vl(e.target, "focus") : e.type === "focusout" && ex(e.target, "focus");
}, Ac = function(e) {
  return cV(e) || Fp(e.tag, "a");
}, yx = function(e) {
  return v_(e.pressed);
}, wx = function(e) {
  return !(Ac(e) || e.tag && !Fp(e.tag, "button"));
}, xx = function(e) {
  return !Ac(e) && !wx(e);
}, CV = function(e) {
  var n;
  return ["btn-".concat(e.variant || "secondary"), (n = {}, ro(n, "btn-".concat(e.size), e.size), ro(n, "btn-block", e.block), ro(n, "rounded-pill", e.pill), ro(n, "rounded-0", e.squared && !e.pill), ro(n, "disabled", e.disabled), ro(n, "active", e.pressed), n)];
}, $V = function(e) {
  return Ac(e) ? $_(jp, e) : {};
}, TV = function(e, n) {
  var r = wx(e), i = Ac(e), a = yx(e), o = xx(e), s = i && e.href === "#", l = n.attrs && n.attrs.role ? n.attrs.role : null, c = n.attrs ? n.attrs.tabindex : null;
  return (o || s) && (c = "0"), {
    // Type only used for "real" buttons
    type: r && !i ? e.type : null,
    // Disabled only set on "real" buttons
    disabled: r ? e.disabled : null,
    // We add a role of button when the tag is not a link or button for ARIA
    // Don't bork any role provided in `data.attrs` when `isLink` or `isButton`
    // Except when link has `href` of `#`
    role: o || s ? "button" : l,
    // We set the `aria-disabled` state for non-standard tags
    "aria-disabled": o ? String(e.disabled) : null,
    // For toggles, we need to set the pressed state for ARIA
    "aria-pressed": a ? String(e.pressed) : null,
    // `autocomplete="off"` is needed in toggle mode to prevent some browsers
    // from remembering the previous setting when using the back button
    autocomplete: a ? "off" : null,
    // `tabindex` is used when the component is not a button
    // Links are tabbable, but don't allow disabled, while non buttons or links
    // are not tabbable, so we mimic that functionality by disabling tabbing
    // when disabled, and adding a `tabindex="0"` to non buttons or non links
    tabindex: e.disabled && !r ? "-1" : c
  };
}, C0 = /* @__PURE__ */ Ot.extend({
  name: C9,
  functional: !0,
  props: xV,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.listeners, o = n.children, s = yx(r), l = Ac(r), c = xx(r), h = l && r.href === "#", d = {
      keydown: function(v) {
        if (!(r.disabled || !(c || h))) {
          var b = v.keyCode;
          if (b === Bp || b === fx && c) {
            var _ = v.currentTarget || v.target;
            ke(v, {
              propagation: !1
            }), _.click();
          }
        }
      },
      click: function(v) {
        r.disabled && Ip(v) ? ke(v) : s && a && a["update:pressed"] && Fr(a["update:pressed"]).forEach(function(b) {
          Me(b) && b(!r.pressed);
        });
      }
    };
    s && (d.focusin = s5, d.focusout = s5);
    var p = {
      staticClass: "btn",
      class: CV(r),
      props: $V(r),
      attrs: TV(r, i),
      on: d
    };
    return e(l ? Ks : r.tag, ji(i, p), o);
  }
}), Fs = function(e, n) {
  return e ? {
    innerHTML: e
  } : n ? {
    textContent: n
  } : {};
}, La = {
  id: M(Q)
}, Ou = Ot.extend({
  props: La,
  data: function() {
    return {
      localId_: null
    };
  },
  computed: {
    safeId: function() {
      var e = this.id || this.localId_, n = function(i) {
        return e ? (i = String(i || "").replace(/\s+/g, "_"), i ? e + "_" + i : e) : null;
      };
      return n;
    }
  },
  mounted: function() {
    var e = this;
    this.$nextTick(function() {
      e.localId_ = "__BVID__".concat(e[Ls]);
    });
  }
}), OV = function() {
};
function u5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function SV(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? u5(Object(n), !0).forEach(function(r) {
      EV(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function EV(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Cx = function(e, n, r) {
  if (e = e ? e.$el || e : null, !Ee(e) || aj("observeDom"))
    return null;
  var i = new Gj(function(a) {
    for (var o = !1, s = 0; s < a.length && !o; s++) {
      var l = a[s], c = l.type, h = l.target;
      (c === "characterData" && h.nodeType === Node.TEXT_NODE || c === "attributes" || c === "childList" && (l.addedNodes.length > 0 || l.removedNodes.length > 0)) && (o = !0);
    }
    o && n();
  });
  return i.observe(e, SV({
    childList: !0,
    subtree: !0
  }, r)), i;
};
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var Pc = typeof window != "undefined" && typeof document != "undefined" && typeof navigator != "undefined", AV = function() {
  for (var t = ["Edge", "Trident", "Firefox"], e = 0; e < t.length; e += 1)
    if (Pc && navigator.userAgent.indexOf(t[e]) >= 0)
      return 1;
  return 0;
}();
function PV(t) {
  var e = !1;
  return function() {
    e || (e = !0, window.Promise.resolve().then(function() {
      e = !1, t();
    }));
  };
}
function MV(t) {
  var e = !1;
  return function() {
    e || (e = !0, setTimeout(function() {
      e = !1, t();
    }, AV));
  };
}
var kV = Pc && window.Promise, NV = kV ? PV : MV;
function $x(t) {
  var e = {};
  return t && e.toString.call(t) === "[object Function]";
}
function zo(t, e) {
  if (t.nodeType !== 1)
    return [];
  var n = t.ownerDocument.defaultView, r = n.getComputedStyle(t, null);
  return e ? r[e] : r;
}
function A_(t) {
  return t.nodeName === "HTML" ? t : t.parentNode || t.host;
}
function Mc(t) {
  if (!t)
    return document.body;
  switch (t.nodeName) {
    case "HTML":
    case "BODY":
      return t.ownerDocument.body;
    case "#document":
      return t.body;
  }
  var e = zo(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /(auto|scroll|overlay)/.test(n + i + r) ? t : Mc(A_(t));
}
function Tx(t) {
  return t && t.referenceNode ? t.referenceNode : t;
}
var l5 = Pc && !!(window.MSInputMethodContext && document.documentMode), c5 = Pc && /MSIE 10/.test(navigator.userAgent);
function Su(t) {
  return t === 11 ? l5 : t === 10 ? c5 : l5 || c5;
}
function Xs(t) {
  if (!t)
    return document.documentElement;
  for (var e = Su(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling; )
    n = (t = t.nextElementSibling).offsetParent;
  var r = n && n.nodeName;
  return !r || r === "BODY" || r === "HTML" ? t ? t.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(n.nodeName) !== -1 && zo(n, "position") === "static" ? Xs(n) : n;
}
function IV(t) {
  var e = t.nodeName;
  return e === "BODY" ? !1 : e === "HTML" || Xs(t.firstElementChild) === t;
}
function $0(t) {
  return t.parentNode !== null ? $0(t.parentNode) : t;
}
function cd(t, e) {
  if (!t || !t.nodeType || !e || !e.nodeType)
    return document.documentElement;
  var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? t : e, i = n ? e : t, a = document.createRange();
  a.setStart(r, 0), a.setEnd(i, 0);
  var o = a.commonAncestorContainer;
  if (t !== o && e !== o || r.contains(i))
    return IV(o) ? o : Xs(o);
  var s = $0(t);
  return s.host ? cd(s.host, e) : cd(t, $0(e).host);
}
function Zs(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", n = e === "top" ? "scrollTop" : "scrollLeft", r = t.nodeName;
  if (r === "BODY" || r === "HTML") {
    var i = t.ownerDocument.documentElement, a = t.ownerDocument.scrollingElement || i;
    return a[n];
  }
  return t[n];
}
function RV(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = Zs(e, "top"), i = Zs(e, "left"), a = n ? -1 : 1;
  return t.top += r * a, t.bottom += r * a, t.left += i * a, t.right += i * a, t;
}
function f5(t, e) {
  var n = e === "x" ? "Left" : "Top", r = n === "Left" ? "Right" : "Bottom";
  return parseFloat(t["border" + n + "Width"]) + parseFloat(t["border" + r + "Width"]);
}
function h5(t, e, n, r) {
  return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], Su(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + (t === "Height" ? "Top" : "Left")]) + parseInt(r["margin" + (t === "Height" ? "Bottom" : "Right")]) : 0);
}
function Ox(t) {
  var e = t.body, n = t.documentElement, r = Su(10) && getComputedStyle(n);
  return {
    height: h5("Height", e, n, r),
    width: h5("Width", e, n, r)
  };
}
var LV = function(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, DV = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}(), Js = function(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}, yr = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function xa(t) {
  return yr({}, t, {
    right: t.left + t.width,
    bottom: t.top + t.height
  });
}
function T0(t) {
  var e = {};
  try {
    if (Su(10)) {
      e = t.getBoundingClientRect();
      var n = Zs(t, "top"), r = Zs(t, "left");
      e.top += n, e.left += r, e.bottom += n, e.right += r;
    } else
      e = t.getBoundingClientRect();
  } catch (d) {
  }
  var i = {
    left: e.left,
    top: e.top,
    width: e.right - e.left,
    height: e.bottom - e.top
  }, a = t.nodeName === "HTML" ? Ox(t.ownerDocument) : {}, o = a.width || t.clientWidth || i.width, s = a.height || t.clientHeight || i.height, l = t.offsetWidth - o, c = t.offsetHeight - s;
  if (l || c) {
    var h = zo(t);
    l -= f5(h, "x"), c -= f5(h, "y"), i.width -= l, i.height -= c;
  }
  return xa(i);
}
function P_(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = Su(10), i = e.nodeName === "HTML", a = T0(t), o = T0(e), s = Mc(t), l = zo(e), c = parseFloat(l.borderTopWidth), h = parseFloat(l.borderLeftWidth);
  n && i && (o.top = Math.max(o.top, 0), o.left = Math.max(o.left, 0));
  var d = xa({
    top: a.top - o.top - c,
    left: a.left - o.left - h,
    width: a.width,
    height: a.height
  });
  if (d.marginTop = 0, d.marginLeft = 0, !r && i) {
    var p = parseFloat(l.marginTop), g = parseFloat(l.marginLeft);
    d.top -= c - p, d.bottom -= c - p, d.left -= h - g, d.right -= h - g, d.marginTop = p, d.marginLeft = g;
  }
  return (r && !n ? e.contains(s) : e === s && s.nodeName !== "BODY") && (d = RV(d, e)), d;
}
function FV(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = t.ownerDocument.documentElement, r = P_(t, n), i = Math.max(n.clientWidth, window.innerWidth || 0), a = Math.max(n.clientHeight, window.innerHeight || 0), o = e ? 0 : Zs(n), s = e ? 0 : Zs(n, "left"), l = {
    top: o - r.top + r.marginTop,
    left: s - r.left + r.marginLeft,
    width: i,
    height: a
  };
  return xa(l);
}
function Sx(t) {
  var e = t.nodeName;
  if (e === "BODY" || e === "HTML")
    return !1;
  if (zo(t, "position") === "fixed")
    return !0;
  var n = A_(t);
  return n ? Sx(n) : !1;
}
function Ex(t) {
  if (!t || !t.parentElement || Su())
    return document.documentElement;
  for (var e = t.parentElement; e && zo(e, "transform") === "none"; )
    e = e.parentElement;
  return e || document.documentElement;
}
function M_(t, e, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, a = { top: 0, left: 0 }, o = i ? Ex(t) : cd(t, Tx(e));
  if (r === "viewport")
    a = FV(o, i);
  else {
    var s = void 0;
    r === "scrollParent" ? (s = Mc(A_(e)), s.nodeName === "BODY" && (s = t.ownerDocument.documentElement)) : r === "window" ? s = t.ownerDocument.documentElement : s = r;
    var l = P_(s, o, i);
    if (s.nodeName === "HTML" && !Sx(o)) {
      var c = Ox(t.ownerDocument), h = c.height, d = c.width;
      a.top += l.top - l.marginTop, a.bottom = h + l.top, a.left += l.left - l.marginLeft, a.right = d + l.left;
    } else
      a = l;
  }
  n = n || 0;
  var p = typeof n == "number";
  return a.left += p ? n : n.left || 0, a.top += p ? n : n.top || 0, a.right -= p ? n : n.right || 0, a.bottom -= p ? n : n.bottom || 0, a;
}
function zV(t) {
  var e = t.width, n = t.height;
  return e * n;
}
function Ax(t, e, n, r, i) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (t.indexOf("auto") === -1)
    return t;
  var o = M_(n, r, a, i), s = {
    top: {
      width: o.width,
      height: e.top - o.top
    },
    right: {
      width: o.right - e.right,
      height: o.height
    },
    bottom: {
      width: o.width,
      height: o.bottom - e.bottom
    },
    left: {
      width: e.left - o.left,
      height: o.height
    }
  }, l = Object.keys(s).map(function(p) {
    return yr({
      key: p
    }, s[p], {
      area: zV(s[p])
    });
  }).sort(function(p, g) {
    return g.area - p.area;
  }), c = l.filter(function(p) {
    var g = p.width, v = p.height;
    return g >= n.clientWidth && v >= n.clientHeight;
  }), h = c.length > 0 ? c[0].key : l[0].key, d = t.split("-")[1];
  return h + (d ? "-" + d : "");
}
function Px(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = r ? Ex(e) : cd(e, Tx(n));
  return P_(n, i, r);
}
function Mx(t) {
  var e = t.ownerDocument.defaultView, n = e.getComputedStyle(t), r = parseFloat(n.marginTop || 0) + parseFloat(n.marginBottom || 0), i = parseFloat(n.marginLeft || 0) + parseFloat(n.marginRight || 0), a = {
    width: t.offsetWidth + i,
    height: t.offsetHeight + r
  };
  return a;
}
function fd(t) {
  var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return t.replace(/left|right|bottom|top/g, function(n) {
    return e[n];
  });
}
function kx(t, e, n) {
  n = n.split("-")[0];
  var r = Mx(t), i = {
    width: r.width,
    height: r.height
  }, a = ["right", "left"].indexOf(n) !== -1, o = a ? "top" : "left", s = a ? "left" : "top", l = a ? "height" : "width", c = a ? "width" : "height";
  return i[o] = e[o] + e[l] / 2 - r[l] / 2, n === s ? i[s] = e[s] - r[c] : i[s] = e[fd(s)], i;
}
function kc(t, e) {
  return Array.prototype.find ? t.find(e) : t.filter(e)[0];
}
function BV(t, e, n) {
  if (Array.prototype.findIndex)
    return t.findIndex(function(i) {
      return i[e] === n;
    });
  var r = kc(t, function(i) {
    return i[e] === n;
  });
  return t.indexOf(r);
}
function Nx(t, e, n) {
  var r = n === void 0 ? t : t.slice(0, BV(t, "name", n));
  return r.forEach(function(i) {
    i.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var a = i.function || i.fn;
    i.enabled && $x(a) && (e.offsets.popper = xa(e.offsets.popper), e.offsets.reference = xa(e.offsets.reference), e = a(e, i));
  }), e;
}
function HV() {
  if (!this.state.isDestroyed) {
    var t = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    t.offsets.reference = Px(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = Ax(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = kx(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = Nx(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
  }
}
function Ix(t, e) {
  return t.some(function(n) {
    var r = n.name, i = n.enabled;
    return i && r === e;
  });
}
function k_(t) {
  for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
    var i = e[r], a = i ? "" + i + n : t;
    if (typeof document.body.style[a] != "undefined")
      return a;
  }
  return null;
}
function jV() {
  return this.state.isDestroyed = !0, Ix(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[k_("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function Rx(t) {
  var e = t.ownerDocument;
  return e ? e.defaultView : window;
}
function Lx(t, e, n, r) {
  var i = t.nodeName === "BODY", a = i ? t.ownerDocument.defaultView : t;
  a.addEventListener(e, n, { passive: !0 }), i || Lx(Mc(a.parentNode), e, n, r), r.push(a);
}
function VV(t, e, n, r) {
  n.updateBound = r, Rx(t).addEventListener("resize", n.updateBound, { passive: !0 });
  var i = Mc(t);
  return Lx(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
}
function WV() {
  this.state.eventsEnabled || (this.state = VV(this.reference, this.options, this.state, this.scheduleUpdate));
}
function UV(t, e) {
  return Rx(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(n) {
    n.removeEventListener("scroll", e.updateBound);
  }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e;
}
function YV() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = UV(this.reference, this.state));
}
function N_(t) {
  return t !== "" && !isNaN(parseFloat(t)) && isFinite(t);
}
function O0(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(n) !== -1 && N_(e[n]) && (r = "px"), t.style[n] = e[n] + r;
  });
}
function qV(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = e[n];
    r !== !1 ? t.setAttribute(n, e[n]) : t.removeAttribute(n);
  });
}
function GV(t) {
  return O0(t.instance.popper, t.styles), qV(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && O0(t.arrowElement, t.arrowStyles), t;
}
function KV(t, e, n, r, i) {
  var a = Px(i, e, t, n.positionFixed), o = Ax(n.placement, a, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
  return e.setAttribute("x-placement", o), O0(e, { position: n.positionFixed ? "fixed" : "absolute" }), n;
}
function XV(t, e) {
  var n = t.offsets, r = n.popper, i = n.reference, a = Math.round, o = Math.floor, s = function(w) {
    return w;
  }, l = a(i.width), c = a(r.width), h = ["left", "right"].indexOf(t.placement) !== -1, d = t.placement.indexOf("-") !== -1, p = l % 2 === c % 2, g = l % 2 === 1 && c % 2 === 1, v = e ? h || d || p ? a : o : s, b = e ? a : s;
  return {
    left: v(g && !d && e ? r.left - 1 : r.left),
    top: b(r.top),
    bottom: b(r.bottom),
    right: v(r.right)
  };
}
var ZV = Pc && /Firefox/i.test(navigator.userAgent);
function JV(t, e) {
  var n = e.x, r = e.y, i = t.offsets.popper, a = kc(t.instance.modifiers, function(C) {
    return C.name === "applyStyle";
  }).gpuAcceleration;
  a !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var o = a !== void 0 ? a : e.gpuAcceleration, s = Xs(t.instance.popper), l = T0(s), c = {
    position: i.position
  }, h = XV(t, window.devicePixelRatio < 2 || !ZV), d = n === "bottom" ? "top" : "bottom", p = r === "right" ? "left" : "right", g = k_("transform"), v = void 0, b = void 0;
  if (d === "bottom" ? s.nodeName === "HTML" ? b = -s.clientHeight + h.bottom : b = -l.height + h.bottom : b = h.top, p === "right" ? s.nodeName === "HTML" ? v = -s.clientWidth + h.right : v = -l.width + h.right : v = h.left, o && g)
    c[g] = "translate3d(" + v + "px, " + b + "px, 0)", c[d] = 0, c[p] = 0, c.willChange = "transform";
  else {
    var _ = d === "bottom" ? -1 : 1, w = p === "right" ? -1 : 1;
    c[d] = b * _, c[p] = v * w, c.willChange = d + ", " + p;
  }
  var x = {
    "x-placement": t.placement
  };
  return t.attributes = yr({}, x, t.attributes), t.styles = yr({}, c, t.styles), t.arrowStyles = yr({}, t.offsets.arrow, t.arrowStyles), t;
}
function Dx(t, e, n) {
  var r = kc(t, function(s) {
    var l = s.name;
    return l === e;
  }), i = !!r && t.some(function(s) {
    return s.name === n && s.enabled && s.order < r.order;
  });
  if (!i) {
    var a = "`" + e + "`", o = "`" + n + "`";
    console.warn(o + " modifier is required by " + a + " modifier in order to work, be sure to include it before " + a + "!");
  }
  return i;
}
function QV(t, e) {
  var n;
  if (!Dx(t.instance.modifiers, "arrow", "keepTogether"))
    return t;
  var r = e.element;
  if (typeof r == "string") {
    if (r = t.instance.popper.querySelector(r), !r)
      return t;
  } else if (!t.instance.popper.contains(r))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
  var i = t.placement.split("-")[0], a = t.offsets, o = a.popper, s = a.reference, l = ["left", "right"].indexOf(i) !== -1, c = l ? "height" : "width", h = l ? "Top" : "Left", d = h.toLowerCase(), p = l ? "left" : "top", g = l ? "bottom" : "right", v = Mx(r)[c];
  s[g] - v < o[d] && (t.offsets.popper[d] -= o[d] - (s[g] - v)), s[d] + v > o[g] && (t.offsets.popper[d] += s[d] + v - o[g]), t.offsets.popper = xa(t.offsets.popper);
  var b = s[d] + s[c] / 2 - v / 2, _ = zo(t.instance.popper), w = parseFloat(_["margin" + h]), x = parseFloat(_["border" + h + "Width"]), C = b - t.offsets.popper[d] - w - x;
  return C = Math.max(Math.min(o[c] - v, C), 0), t.arrowElement = r, t.offsets.arrow = (n = {}, Js(n, d, Math.round(C)), Js(n, p, ""), n), t;
}
function tW(t) {
  return t === "end" ? "start" : t === "start" ? "end" : t;
}
var Fx = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], cg = Fx.slice(3);
function d5(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = cg.indexOf(t), r = cg.slice(n + 1).concat(cg.slice(0, n));
  return e ? r.reverse() : r;
}
var fg = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function eW(t, e) {
  if (Ix(t.instance.modifiers, "inner") || t.flipped && t.placement === t.originalPlacement)
    return t;
  var n = M_(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), r = t.placement.split("-")[0], i = fd(r), a = t.placement.split("-")[1] || "", o = [];
  switch (e.behavior) {
    case fg.FLIP:
      o = [r, i];
      break;
    case fg.CLOCKWISE:
      o = d5(r);
      break;
    case fg.COUNTERCLOCKWISE:
      o = d5(r, !0);
      break;
    default:
      o = e.behavior;
  }
  return o.forEach(function(s, l) {
    if (r !== s || o.length === l + 1)
      return t;
    r = t.placement.split("-")[0], i = fd(r);
    var c = t.offsets.popper, h = t.offsets.reference, d = Math.floor, p = r === "left" && d(c.right) > d(h.left) || r === "right" && d(c.left) < d(h.right) || r === "top" && d(c.bottom) > d(h.top) || r === "bottom" && d(c.top) < d(h.bottom), g = d(c.left) < d(n.left), v = d(c.right) > d(n.right), b = d(c.top) < d(n.top), _ = d(c.bottom) > d(n.bottom), w = r === "left" && g || r === "right" && v || r === "top" && b || r === "bottom" && _, x = ["top", "bottom"].indexOf(r) !== -1, C = !!e.flipVariations && (x && a === "start" && g || x && a === "end" && v || !x && a === "start" && b || !x && a === "end" && _), $ = !!e.flipVariationsByContent && (x && a === "start" && v || x && a === "end" && g || !x && a === "start" && _ || !x && a === "end" && b), E = C || $;
    (p || w || E) && (t.flipped = !0, (p || w) && (r = o[l + 1]), E && (a = tW(a)), t.placement = r + (a ? "-" + a : ""), t.offsets.popper = yr({}, t.offsets.popper, kx(t.instance.popper, t.offsets.reference, t.placement)), t = Nx(t.instance.modifiers, t, "flip"));
  }), t;
}
function nW(t) {
  var e = t.offsets, n = e.popper, r = e.reference, i = t.placement.split("-")[0], a = Math.floor, o = ["top", "bottom"].indexOf(i) !== -1, s = o ? "right" : "bottom", l = o ? "left" : "top", c = o ? "width" : "height";
  return n[s] < a(r[l]) && (t.offsets.popper[l] = a(r[l]) - n[c]), n[l] > a(r[s]) && (t.offsets.popper[l] = a(r[s])), t;
}
function rW(t, e, n, r) {
  var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), a = +i[1], o = i[2];
  if (!a)
    return t;
  if (o.indexOf("%") === 0) {
    var s = void 0;
    switch (o) {
      case "%p":
        s = n;
        break;
      case "%":
      case "%r":
      default:
        s = r;
    }
    var l = xa(s);
    return l[e] / 100 * a;
  } else if (o === "vh" || o === "vw") {
    var c = void 0;
    return o === "vh" ? c = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : c = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), c / 100 * a;
  } else
    return a;
}
function iW(t, e, n, r) {
  var i = [0, 0], a = ["right", "left"].indexOf(r) !== -1, o = t.split(/(\+|\-)/).map(function(h) {
    return h.trim();
  }), s = o.indexOf(kc(o, function(h) {
    return h.search(/,|\s/) !== -1;
  }));
  o[s] && o[s].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var l = /\s*,\s*|\s+/, c = s !== -1 ? [o.slice(0, s).concat([o[s].split(l)[0]]), [o[s].split(l)[1]].concat(o.slice(s + 1))] : [o];
  return c = c.map(function(h, d) {
    var p = (d === 1 ? !a : a) ? "height" : "width", g = !1;
    return h.reduce(function(v, b) {
      return v[v.length - 1] === "" && ["+", "-"].indexOf(b) !== -1 ? (v[v.length - 1] = b, g = !0, v) : g ? (v[v.length - 1] += b, g = !1, v) : v.concat(b);
    }, []).map(function(v) {
      return rW(v, p, e, n);
    });
  }), c.forEach(function(h, d) {
    h.forEach(function(p, g) {
      N_(p) && (i[d] += p * (h[g - 1] === "-" ? -1 : 1));
    });
  }), i;
}
function aW(t, e) {
  var n = e.offset, r = t.placement, i = t.offsets, a = i.popper, o = i.reference, s = r.split("-")[0], l = void 0;
  return N_(+n) ? l = [+n, 0] : l = iW(n, a, o, s), s === "left" ? (a.top += l[0], a.left -= l[1]) : s === "right" ? (a.top += l[0], a.left += l[1]) : s === "top" ? (a.left += l[0], a.top -= l[1]) : s === "bottom" && (a.left += l[0], a.top += l[1]), t.popper = a, t;
}
function oW(t, e) {
  var n = e.boundariesElement || Xs(t.instance.popper);
  t.instance.reference === n && (n = Xs(n));
  var r = k_("transform"), i = t.instance.popper.style, a = i.top, o = i.left, s = i[r];
  i.top = "", i.left = "", i[r] = "";
  var l = M_(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
  i.top = a, i.left = o, i[r] = s, e.boundaries = l;
  var c = e.priority, h = t.offsets.popper, d = {
    primary: function(g) {
      var v = h[g];
      return h[g] < l[g] && !e.escapeWithReference && (v = Math.max(h[g], l[g])), Js({}, g, v);
    },
    secondary: function(g) {
      var v = g === "right" ? "left" : "top", b = h[v];
      return h[g] > l[g] && !e.escapeWithReference && (b = Math.min(h[v], l[g] - (g === "right" ? h.width : h.height))), Js({}, v, b);
    }
  };
  return c.forEach(function(p) {
    var g = ["left", "top"].indexOf(p) !== -1 ? "primary" : "secondary";
    h = yr({}, h, d[g](p));
  }), t.offsets.popper = h, t;
}
function sW(t) {
  var e = t.placement, n = e.split("-")[0], r = e.split("-")[1];
  if (r) {
    var i = t.offsets, a = i.reference, o = i.popper, s = ["bottom", "top"].indexOf(n) !== -1, l = s ? "left" : "top", c = s ? "width" : "height", h = {
      start: Js({}, l, a[l]),
      end: Js({}, l, a[l] + a[c] - o[c])
    };
    t.offsets.popper = yr({}, o, h[r]);
  }
  return t;
}
function uW(t) {
  if (!Dx(t.instance.modifiers, "hide", "preventOverflow"))
    return t;
  var e = t.offsets.reference, n = kc(t.instance.modifiers, function(r) {
    return r.name === "preventOverflow";
  }).boundaries;
  if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
    if (t.hide === !0)
      return t;
    t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
  } else {
    if (t.hide === !1)
      return t;
    t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
  }
  return t;
}
function lW(t) {
  var e = t.placement, n = e.split("-")[0], r = t.offsets, i = r.popper, a = r.reference, o = ["left", "right"].indexOf(n) !== -1, s = ["top", "left"].indexOf(n) === -1;
  return i[o ? "left" : "top"] = a[n] - (s ? i[o ? "width" : "height"] : 0), t.placement = fd(e), t.offsets.popper = xa(i), t;
}
var cW = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: sW
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: aW,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: oW,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: nW
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: QV,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: eW,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: lW
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: uW
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: JV,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: GV,
    /** @prop {Function} */
    onLoad: KV,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, fW = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: cW
}, Vp = function() {
  function t(e, n) {
    var r = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    LV(this, t), this.scheduleUpdate = function() {
      return requestAnimationFrame(r.update);
    }, this.update = NV(this.update.bind(this)), this.options = yr({}, t.Defaults, i), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(yr({}, t.Defaults.modifiers, i.modifiers)).forEach(function(o) {
      r.options.modifiers[o] = yr({}, t.Defaults.modifiers[o] || {}, i.modifiers ? i.modifiers[o] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(o) {
      return yr({
        name: o
      }, r.options.modifiers[o]);
    }).sort(function(o, s) {
      return o.order - s.order;
    }), this.modifiers.forEach(function(o) {
      o.enabled && $x(o.onLoad) && o.onLoad(r.reference, r.popper, r.options, o, r.state);
    }), this.update();
    var a = this.options.eventsEnabled;
    a && this.enableEventListeners(), this.state.eventsEnabled = a;
  }
  return DV(t, [{
    key: "update",
    value: function() {
      return HV.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return jV.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return WV.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return YV.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), t;
}();
Vp.Utils = (typeof window != "undefined" ? window : global).PopperUtils;
Vp.placements = Fx;
Vp.Defaults = fW;
const S0 = Vp;
var hW = "top-start", dW = "top-end", pW = "bottom-start", mW = "bottom-end", gW = "right-start", vW = "left-start";
function _W(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function p5(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function bW(t, e, n) {
  return e && p5(t.prototype, e), n && p5(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var Nc = /* @__PURE__ */ function() {
  function t(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (_W(this, t), !e)
      throw new TypeError("Failed to construct '".concat(this.constructor.name, "'. 1 argument required, ").concat(arguments.length, " given."));
    b9(this, t.Defaults, this.constructor.Defaults, n, {
      type: e
    }), y9(this, {
      type: ia(),
      cancelable: ia(),
      nativeEvent: ia(),
      target: ia(),
      relatedTarget: ia(),
      vueTarget: ia(),
      componentId: ia()
    });
    var r = !1;
    this.preventDefault = function() {
      this.cancelable && (r = !0);
    }, ZH(this, "defaultPrevented", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
  }
  return bW(t, null, [{
    key: "Defaults",
    get: function() {
      return {
        type: "",
        cancelable: !0,
        nativeEvent: null,
        target: null,
        relatedTarget: null,
        vueTarget: null,
        componentId: null
      };
    }
  }]), t;
}(), yW = Ot.extend({
  data: function() {
    return {
      listenForClickOut: !1
    };
  },
  watch: {
    listenForClickOut: function(e, n) {
      e !== n && (zr(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, $e), e && gn(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, $e));
    }
  },
  beforeCreate: function() {
    this.clickOutElement = null, this.clickOutEventName = null;
  },
  mounted: function() {
    this.clickOutElement || (this.clickOutElement = document), this.clickOutEventName || (this.clickOutEventName = "click"), this.listenForClickOut && gn(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, $e);
  },
  beforeDestroy: function() {
    zr(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, $e);
  },
  methods: {
    isClickOut: function(e) {
      return !ze(this.$el, e.target);
    },
    _clickOutHandler: function(e) {
      this.clickOutHandler && this.isClickOut(e) && this.clickOutHandler(e);
    }
  }
}), wW = Ot.extend({
  data: function() {
    return {
      listenForFocusIn: !1
    };
  },
  watch: {
    listenForFocusIn: function(e, n) {
      e !== n && (zr(this.focusInElement, "focusin", this._focusInHandler, $e), e && gn(this.focusInElement, "focusin", this._focusInHandler, $e));
    }
  },
  beforeCreate: function() {
    this.focusInElement = null;
  },
  mounted: function() {
    this.focusInElement || (this.focusInElement = document), this.listenForFocusIn && gn(this.focusInElement, "focusin", this._focusInHandler, $e);
  },
  beforeDestroy: function() {
    zr(this.focusInElement, "focusin", this._focusInHandler, $e);
  },
  methods: {
    _focusInHandler: function(e) {
      this.focusInHandler && this.focusInHandler(e);
    }
  }
});
function m5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? m5(Object(n), !0).forEach(function(r) {
      xW(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function xW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var v5 = ki(qs, Mi), CW = ki(qs, wn), $W = ".dropdown form", TW = [".dropdown-item", ".b-dropdown-form"].map(function(t) {
  return "".concat(t, ":not(.disabled):not([disabled])");
}).join(", "), OW = function(e) {
  return (e || []).filter(Co);
}, I_ = ue(jn(g5(g5({}, La), {}, {
  // String: `scrollParent`, `window` or `viewport`
  // HTMLElement: HTML Element reference
  boundary: M([ga, Q], "scrollParent"),
  disabled: M(st, !1),
  // Place left if possible
  dropleft: M(st, !1),
  // Place right if possible
  dropright: M(st, !1),
  // Place on top if possible
  dropup: M(st, !1),
  // Disable auto-flipping of menu from bottom <=> top
  noFlip: M(st, !1),
  // Number of pixels or a CSS unit value to offset menu
  // (i.e. `1px`, `1rem`, etc.)
  offset: M(Bn, 0),
  popperOpts: M(Lr, {}),
  // Right align menu (default is left align)
  right: M(st, !1)
})), qs), SW = Ot.extend({
  mixins: [Ou, Hp, yW, wW],
  provide: function() {
    return {
      bvDropdown: this
    };
  },
  inject: {
    bvNavbar: {
      default: null
    }
  },
  props: I_,
  data: function() {
    return {
      visible: !1,
      visibleChangePrevented: !1
    };
  },
  computed: {
    inNavbar: function() {
      return !Ri(this.bvNavbar);
    },
    toggler: function() {
      var e = this.$refs.toggle;
      return e ? e.$el || e : null;
    },
    directionClass: function() {
      return this.dropup ? "dropup" : this.dropright ? "dropright" : this.dropleft ? "dropleft" : "";
    },
    boundaryClass: function() {
      return this.boundary !== "scrollParent" && !this.inNavbar ? "position-static" : "";
    },
    hideDelay: function() {
      return this.inNavbar ? jH ? 300 : 50 : 0;
    }
  },
  watch: {
    visible: function(e, n) {
      if (this.visibleChangePrevented) {
        this.visibleChangePrevented = !1;
        return;
      }
      if (e !== n) {
        var r = e ? Cr : Pi, i = new Nc(r, {
          cancelable: !0,
          vueTarget: this,
          target: this.$refs.menu,
          relatedTarget: null,
          componentId: this.safeId ? this.safeId() : this.id || null
        });
        if (this.emitEvent(i), i.defaultPrevented) {
          this.visibleChangePrevented = !0, this.visible = n, this.$off(wn, this.focusToggler);
          return;
        }
        e ? this.showMenu() : this.hideMenu();
      }
    },
    disabled: function(e, n) {
      e !== n && e && this.visible && (this.visible = !1);
    }
  },
  created: function() {
    this.$_popper = null, this.$_hideTimeout = null;
  },
  /* istanbul ignore next */
  deactivated: function() {
    this.visible = !1, this.whileOpenListen(!1), this.destroyPopper();
  },
  beforeDestroy: function() {
    this.visible = !1, this.whileOpenListen(!1), this.destroyPopper(), this.clearHideTimeout();
  },
  methods: {
    // Event emitter
    emitEvent: function(e) {
      var n = e.type;
      this.emitOnRoot(ki(qs, n), e), this.$emit(n, e);
    },
    showMenu: function() {
      var e = this;
      if (!this.disabled) {
        if (!this.inNavbar)
          if (typeof S0 == "undefined")
            Oc("Popper.js not found. Falling back to CSS positioning", qs);
          else {
            var n = this.dropup && this.right || this.split ? this.$el : this.$refs.toggle;
            n = n.$el || n, this.createPopper(n);
          }
        this.emitOnRoot(v5, this), this.whileOpenListen(!0), this.$nextTick(function() {
          e.focusMenu(), e.$emit(Mi);
        });
      }
    },
    hideMenu: function() {
      this.whileOpenListen(!1), this.emitOnRoot(CW, this), this.$emit(wn), this.destroyPopper();
    },
    createPopper: function(e) {
      this.destroyPopper(), this.$_popper = new S0(e, this.$refs.menu, this.getPopperConfig());
    },
    // Ensure popper event listeners are removed cleanly
    destroyPopper: function() {
      this.$_popper && this.$_popper.destroy(), this.$_popper = null;
    },
    // Instructs popper to re-computes the dropdown position
    // useful if the content changes size
    updatePopper: function() {
      try {
        this.$_popper.scheduleUpdate();
      } catch (e) {
      }
    },
    clearHideTimeout: function() {
      clearTimeout(this.$_hideTimeout), this.$_hideTimeout = null;
    },
    getPopperConfig: function() {
      var e = pW;
      this.dropup ? e = this.right ? dW : hW : this.dropright ? e = gW : this.dropleft ? e = vW : this.right && (e = mW);
      var n = {
        placement: e,
        modifiers: {
          offset: {
            offset: this.offset || 0
          },
          flip: {
            enabled: !this.noFlip
          }
        }
      }, r = this.boundary;
      return r && (n.modifiers.preventOverflow = {
        boundariesElement: r
      }), JH(n, this.popperOpts || {});
    },
    // Turn listeners on/off while open
    whileOpenListen: function(e) {
      this.listenForClickOut = e, this.listenForFocusIn = e;
      var n = e ? "$on" : "$off";
      this.$root[n](v5, this.rootCloseListener);
    },
    rootCloseListener: function(e) {
      e !== this && (this.visible = !1);
    },
    // Public method to show dropdown
    show: function() {
      var e = this;
      this.disabled || Nr(function() {
        e.visible = !0;
      });
    },
    // Public method to hide dropdown
    hide: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      this.disabled || (this.visible = !1, e && this.$once(wn, this.focusToggler));
    },
    // Called only by a button that toggles the menu
    toggle: function(e) {
      e = e || {};
      var n = e, r = n.type, i = n.keyCode;
      if (!(r !== "click" && !(r === "keydown" && [fx, Bp, ld].indexOf(i) !== -1))) {
        if (this.disabled) {
          this.visible = !1;
          return;
        }
        this.$emit(Y9, e), ke(e), this.visible ? this.hide(!0) : this.show();
      }
    },
    // Mousedown handler for the toggle
    /* istanbul ignore next */
    onMousedown: function(e) {
      ke(e, {
        propagation: !1
      });
    },
    // Called from dropdown menu context
    onKeydown: function(e) {
      var n = e.keyCode;
      n === hx ? this.onEsc(e) : n === ld ? this.focusNext(e, !1) : n === O_ && this.focusNext(e, !0);
    },
    // If user presses ESC, close the menu
    onEsc: function(e) {
      this.visible && (this.visible = !1, ke(e), this.$once(wn, this.focusToggler));
    },
    // Called only in split button mode, for the split button
    onSplitClick: function(e) {
      if (this.disabled) {
        this.visible = !1;
        return;
      }
      this.$emit(wa, e);
    },
    // Shared hide handler between click-out and focus-in events
    hideHandler: function(e) {
      var n = this, r = e.target;
      this.visible && !ze(this.$refs.menu, r) && !ze(this.toggler, r) && (this.clearHideTimeout(), this.$_hideTimeout = setTimeout(function() {
        return n.hide();
      }, this.hideDelay));
    },
    // Document click-out listener
    clickOutHandler: function(e) {
      this.hideHandler(e);
    },
    // Document focus-in listener
    focusInHandler: function(e) {
      this.hideHandler(e);
    },
    // Keyboard nav
    focusNext: function(e, n) {
      var r = this, i = e.target;
      !this.visible || e && sd($W, i) || (ke(e), this.$nextTick(function() {
        var a = r.getItems();
        if (!(a.length < 1)) {
          var o = a.indexOf(i);
          n && o > 0 ? o-- : !n && o < a.length - 1 && o++, o < 0 && (o = 0), r.focusItem(o, a);
        }
      }));
    },
    focusItem: function(e, n) {
      var r = n.find(function(i, a) {
        return a === e;
      });
      Oe(r);
    },
    getItems: function() {
      return OW(_o(TW, this.$refs.menu));
    },
    focusMenu: function() {
      Oe(this.$refs.menu);
    },
    focusToggler: function() {
      var e = this;
      this.$nextTick(function() {
        Oe(e.toggler);
      });
    }
  }
});
function _5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hg(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _5(Object(n), !0).forEach(function(r) {
      EW(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : _5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function EW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var AW = ue(jn(hg(hg(hg({}, La), I_), {}, {
  block: M(st, !1),
  html: M(Q),
  // If `true`, only render menu contents when open
  lazy: M(st, !1),
  menuClass: M(fe),
  noCaret: M(st, !1),
  role: M(Q, "menu"),
  size: M(Q),
  split: M(st, !1),
  splitButtonType: M(Q, "button", function(t) {
    return ln(["button", "submit", "reset"], t);
  }),
  splitClass: M(fe),
  splitHref: M(Q),
  splitTo: M(Z9),
  splitVariant: M(Q),
  text: M(Q),
  toggleAttrs: M(Lr, {}),
  toggleClass: M(fe),
  toggleTag: M(Q, "button"),
  // TODO: This really should be `toggleLabel`
  toggleText: M(Q, "Toggle dropdown"),
  variant: M(Q, "secondary")
})), qs);
function b5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? b5(Object(n), !0).forEach(function(r) {
      zx(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function zx(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Bx = Tu(E_, ["event", "routerTag"]), PW = ue(jn(hd(hd({}, Bx), {}, {
  linkClass: M(fe),
  variant: M(Q)
})), T9), MW = /* @__PURE__ */ Ot.extend({
  name: T9,
  mixins: [S_, Wi],
  inject: {
    bvDropdown: {
      default: null
    }
  },
  inheritAttrs: !1,
  props: PW,
  computed: {
    computedAttrs: function() {
      return hd(hd({}, this.bvAttrs), {}, {
        role: "menuitem"
      });
    }
  },
  methods: {
    closeDropdown: function() {
      var e = this;
      Nr(function() {
        e.bvDropdown && e.bvDropdown.hide(!0);
      });
    },
    onClick: function(e) {
      this.$emit(wa, e), this.closeDropdown();
    }
  },
  render: function(e) {
    var n = this.linkClass, r = this.variant, i = this.active, a = this.disabled, o = this.onClick, s = this.bvAttrs;
    return e("li", {
      class: s.class,
      style: s.style,
      attrs: {
        role: "presentation"
      }
    }, [e(Ks, {
      staticClass: "dropdown-item",
      class: [n, zx({}, "text-".concat(r), r && !(i || a))],
      props: $_(Bx, this.$props),
      attrs: this.computedAttrs,
      on: {
        click: o
      },
      ref: "item"
    }, this.normalizeSlot())]);
  }
}), y5 = "input, textarea, select", Hx = ue({
  autofocus: M(st, !1),
  disabled: M(st, !1),
  form: M(Q),
  id: M(Q),
  name: M(Q),
  required: M(st, !1)
}, "formControls"), kW = Ot.extend({
  props: Hx,
  mounted: function() {
    this.handleAutofocus();
  },
  /* istanbul ignore next */
  activated: function() {
    this.handleAutofocus();
  },
  methods: {
    handleAutofocus: function() {
      var e = this;
      this.$nextTick(function() {
        Nr(function() {
          var n = e.$el;
          e.autofocus && Co(n) && (tx(n, y5) || (n = Sc(y5, n)), Oe(n));
        });
      });
    }
  }
}), jx = ue({
  size: M(Q)
}, "formControls"), NW = Ot.extend({
  props: jx,
  computed: {
    sizeFormClass: function() {
      return [this.size ? "form-control-".concat(this.size) : null];
    }
  }
}), Vx = ue({
  // Tri-state prop: true, false, null (or undefined)
  state: M(st, null)
}, "formState"), IW = Ot.extend({
  props: Vx,
  computed: {
    computedState: function() {
      return v_(this.state) ? this.state : null;
    },
    stateClass: function() {
      var e = this.computedState;
      return e === !0 ? "is-valid" : e === !1 ? "is-invalid" : null;
    },
    computedAriaInvalid: function() {
      var e = this.ariaInvalid;
      return e === !0 || e === "true" || e === "" || this.computedState === !1 ? "true" : e;
    }
  }
}), RW = Ot.extend({
  computed: {
    selectionStart: {
      // Expose selectionStart for formatters, etc
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.selectionStart;
      },
      /* istanbul ignore next */
      set: function(e) {
        this.$refs.input.selectionStart = e;
      }
    },
    selectionEnd: {
      // Expose selectionEnd for formatters, etc
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.selectionEnd;
      },
      /* istanbul ignore next */
      set: function(e) {
        this.$refs.input.selectionEnd = e;
      }
    },
    selectionDirection: {
      // Expose selectionDirection for formatters, etc
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.selectionDirection;
      },
      /* istanbul ignore next */
      set: function(e) {
        this.$refs.input.selectionDirection = e;
      }
    }
  },
  methods: {
    /* istanbul ignore next */
    select: function() {
      var e;
      (e = this.$refs.input).select.apply(e, arguments);
    },
    /* istanbul ignore next */
    setSelectionRange: function() {
      var e;
      (e = this.$refs.input).setSelectionRange.apply(e, arguments);
    },
    /* istanbul ignore next */
    setRangeText: function() {
      var e;
      (e = this.$refs.input).setRangeText.apply(e, arguments);
    }
  }
});
function w5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function x5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? w5(Object(n), !0).forEach(function(r) {
      Wx(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Wx(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Wp = zp("value", {
  type: Bn,
  defaultValue: "",
  event: wj
}), LW = Wp.mixin, DW = Wp.props, C5 = Wp.prop, FW = Wp.event, Ux = ue(jn(x5(x5({}, DW), {}, {
  ariaInvalid: M(Tj, !1),
  autocomplete: M(Q),
  // Debounce timeout (in ms). Not applicable with `lazy` prop
  debounce: M(Bn, 0),
  formatter: M(Dp),
  // Only update the `v-model` on blur/change events
  lazy: M(st, !1),
  lazyFormatter: M(st, !1),
  number: M(st, !1),
  placeholder: M(Q),
  plaintext: M(st, !1),
  readonly: M(st, !1),
  trim: M(st, !1)
})), "formTextControls"), zW = Ot.extend({
  mixins: [LW],
  props: Ux,
  data: function() {
    var e = this[C5];
    return {
      localValue: nr(e),
      vModelValue: this.modifyValue(e)
    };
  },
  computed: {
    computedClass: function() {
      var e = this.plaintext, n = this.type, r = n === "range", i = n === "color";
      return [{
        // Range input needs class `custom-range`
        "custom-range": r,
        // `plaintext` not supported by `type="range"` or `type="color"`
        "form-control-plaintext": e && !r && !i,
        // `form-control` not used by `type="range"` or `plaintext`
        // Always used by `type="color"`
        "form-control": i || !e && !r
      }, this.sizeFormClass, this.stateClass];
    },
    computedDebounce: function() {
      return Ni(Qt(this.debounce, 0), 0);
    },
    hasFormatter: function() {
      return ax(this.formatter);
    }
  },
  watch: Wx({}, C5, function(t) {
    var e = nr(t), n = this.modifyValue(t);
    (e !== this.localValue || n !== this.vModelValue) && (this.clearDebounce(), this.localValue = e, this.vModelValue = n);
  }),
  created: function() {
    this.$_inputDebounceTimer = null;
  },
  beforeDestroy: function() {
    this.clearDebounce();
  },
  methods: {
    clearDebounce: function() {
      clearTimeout(this.$_inputDebounceTimer), this.$_inputDebounceTimer = null;
    },
    formatValue: function(e, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return e = nr(e), this.hasFormatter && (!this.lazyFormatter || r) && (e = this.formatter(e, n)), e;
    },
    modifyValue: function(e) {
      return e = nr(e), this.trim && (e = e.trim()), this.number && (e = co(e, e)), e;
    },
    updateValue: function(e) {
      var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = this.lazy;
      if (!(i && !r)) {
        this.clearDebounce();
        var a = function() {
          if (e = n.modifyValue(e), e !== n.vModelValue)
            n.vModelValue = e, n.$emit(FW, e);
          else if (n.hasFormatter) {
            var l = n.$refs.input;
            l && e !== l.value && (l.value = e);
          }
        }, o = this.computedDebounce;
        o > 0 && !i && !r ? this.$_inputDebounceTimer = setTimeout(a, o) : a();
      }
    },
    onInput: function(e) {
      if (!e.target.composing) {
        var n = e.target.value, r = this.formatValue(n, e);
        if (r === !1 || e.defaultPrevented) {
          ke(e, {
            propagation: !1
          });
          return;
        }
        this.localValue = r, this.updateValue(r), this.$emit(B9, r);
      }
    },
    onChange: function(e) {
      var n = e.target.value, r = this.formatValue(n, e);
      if (r === !1 || e.defaultPrevented) {
        ke(e, {
          propagation: !1
        });
        return;
      }
      this.localValue = r, this.updateValue(r, !0), this.$emit(b_, r);
    },
    onBlur: function(e) {
      var n = e.target.value, r = this.formatValue(n, e, !0);
      r !== !1 && (this.localValue = nr(this.modifyValue(r)), this.updateValue(r, !0)), this.$emit(gj, e);
    },
    focus: function() {
      this.disabled || Oe(this.$el);
    },
    blur: function() {
      this.disabled || C_(this.$el);
    }
  }
}), BW = Ot.extend({
  computed: {
    validity: {
      // Expose validity property
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.validity;
      }
    },
    validationMessage: {
      // Expose validationMessage property
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.validationMessage;
      }
    },
    willValidate: {
      // Expose willValidate property
      cache: !1,
      /* istanbul ignore next */
      get: function() {
        return this.$refs.input.willValidate;
      }
    }
  },
  methods: {
    /* istanbul ignore next */
    setCustomValidity: function() {
      var e;
      return (e = this.$refs.input).setCustomValidity.apply(e, arguments);
    },
    /* istanbul ignore next */
    checkValidity: function() {
      var e;
      return (e = this.$refs.input).checkValidity.apply(e, arguments);
    },
    /* istanbul ignore next */
    reportValidity: function() {
      var e;
      return (e = this.$refs.input).reportValidity.apply(e, arguments);
    }
  }
});
function $5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $5(Object(n), !0).forEach(function(r) {
      HW(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : $5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function HW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Yx = ["text", "password", "email", "number", "url", "tel", "search", "range", "color", "date", "time", "datetime", "datetime-local", "month", "week"], jW = ue(jn(aa(aa(aa(aa(aa(aa({}, La), Hx), jx), Vx), Ux), {}, {
  list: M(Q),
  max: M(Bn),
  min: M(Bn),
  // Disable mousewheel to prevent wheel from changing values (i.e. number/date)
  noWheel: M(st, !1),
  step: M(Bn),
  type: M(Q, "text", function(t) {
    return ln(Yx, t);
  })
})), O9), qx = /* @__PURE__ */ Ot.extend({
  name: O9,
  // Mixin order is important!
  mixins: [gx, Ou, kW, NW, IW, zW, RW, BW],
  props: jW,
  computed: {
    localType: function() {
      var e = this.type;
      return ln(Yx, e) ? e : "text";
    },
    computedAttrs: function() {
      var e = this.localType, n = this.name, r = this.form, i = this.disabled, a = this.placeholder, o = this.required, s = this.min, l = this.max, c = this.step;
      return {
        id: this.safeId(),
        name: n,
        form: r,
        type: e,
        disabled: i,
        placeholder: a,
        required: o,
        autocomplete: this.autocomplete || null,
        readonly: this.readonly || this.plaintext,
        min: s,
        max: l,
        step: c,
        list: e !== "password" ? this.list : null,
        "aria-required": o ? "true" : null,
        "aria-invalid": this.computedAriaInvalid
      };
    },
    computedListeners: function() {
      return aa(aa({}, this.bvListeners), {}, {
        input: this.onInput,
        change: this.onChange,
        blur: this.onBlur
      });
    }
  },
  watch: {
    noWheel: function(e) {
      this.setWheelStopper(e);
    }
  },
  mounted: function() {
    this.setWheelStopper(this.noWheel);
  },
  /* istanbul ignore next */
  deactivated: function() {
    this.setWheelStopper(!1);
  },
  /* istanbul ignore next */
  activated: function() {
    this.setWheelStopper(this.noWheel);
  },
  beforeDestroy: function() {
    this.setWheelStopper(!1);
  },
  methods: {
    setWheelStopper: function(e) {
      var n = this.$el;
      w0(e, n, "focus", this.onWheelFocus), w0(e, n, "blur", this.onWheelBlur), e || zr(document, "wheel", this.stopWheel);
    },
    onWheelFocus: function() {
      gn(document, "wheel", this.stopWheel);
    },
    onWheelBlur: function() {
      zr(document, "wheel", this.stopWheel);
    },
    stopWheel: function(e) {
      ke(e, {
        propagation: !1
      }), C_(this.$el);
    }
  },
  render: function(e) {
    return e("input", {
      class: this.computedClass,
      attrs: this.computedAttrs,
      domProps: {
        value: this.localValue
      },
      on: this.computedListeners,
      ref: "input"
    });
  }
}), VW = ue({
  tag: M(Q, "div")
}, M9), E0 = /* @__PURE__ */ Ot.extend({
  name: M9,
  functional: !0,
  props: VW,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.children;
    return e(r.tag, ji(i, {
      staticClass: "input-group-text"
    }), a);
  }
}), R_ = ue({
  append: M(st, !1),
  id: M(Q),
  isText: M(st, !1),
  tag: M(Q, "div")
}, E9), Gx = /* @__PURE__ */ Ot.extend({
  name: E9,
  functional: !0,
  props: R_,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.children, o = r.append;
    return e(r.tag, ji(i, {
      class: {
        "input-group-append": o,
        "input-group-prepend": !o
      },
      attrs: {
        id: r.id
      }
    }), r.isText ? [e(E0, a)] : a);
  }
});
function T5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function O5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? T5(Object(n), !0).forEach(function(r) {
      WW(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : T5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function WW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var UW = ue(Tu(R_, ["append"]), A9), Kx = /* @__PURE__ */ Ot.extend({
  name: A9,
  functional: !0,
  props: UW,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.children;
    return e(Gx, ji(i, {
      props: O5(O5({}, r), {}, {
        append: !0
      })
    }), a);
  }
});
function S5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function E5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? S5(Object(n), !0).forEach(function(r) {
      YW(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : S5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function YW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var qW = ue(Tu(R_, ["append"]), P9), GW = /* @__PURE__ */ Ot.extend({
  name: P9,
  functional: !0,
  props: qW,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.children;
    return e(Gx, ji(i, {
      props: E5(E5({}, r), {}, {
        append: !1
      })
    }), a);
  }
});
function KW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var XW = ue({
  append: M(Q),
  appendHtml: M(Q),
  id: M(Q),
  prepend: M(Q),
  prependHtml: M(Q),
  size: M(Q),
  tag: M(Q, "div")
}, S9), Xx = /* @__PURE__ */ Ot.extend({
  name: S9,
  functional: !0,
  props: XW,
  render: function(e, n) {
    var r = n.props, i = n.data, a = n.slots, o = n.scopedSlots, s = r.prepend, l = r.prependHtml, c = r.append, h = r.appendHtml, d = r.size, p = o || {}, g = a(), v = {}, b = e(), _ = ud(K4, p, g);
    (_ || s || l) && (b = e(GW, [_ ? Rl(K4, v, p, g) : e(E0, {
      domProps: Fs(l, s)
    })]));
    var w = e(), x = ud(Y4, p, g);
    return (x || c || h) && (w = e(Kx, [x ? Rl(Y4, v, p, g) : e(E0, {
      domProps: Fs(h, c)
    })])), e(r.tag, ji(i, {
      staticClass: "input-group",
      class: KW({}, "input-group-".concat(d), d),
      attrs: {
        id: r.id || null,
        role: "group"
      }
    }), [b, Rl(xo, v, p, g), w]);
  }
}), Xn = "$_documentListeners", ZW = Ot.extend({
  created: function() {
    this[Xn] = {};
  },
  beforeDestroy: function() {
    var e = this;
    Se(this[Xn] || {}).forEach(function(n) {
      e[Xn][n].forEach(function(r) {
        e.listenOffDocument(n, r);
      });
    }), this[Xn] = null;
  },
  methods: {
    registerDocumentListener: function(e, n) {
      this[Xn] && (this[Xn][e] = this[Xn][e] || [], ln(this[Xn][e], n) || this[Xn][e].push(n));
    },
    unregisterDocumentListener: function(e, n) {
      this[Xn] && this[Xn][e] && (this[Xn][e] = this[Xn][e].filter(function(r) {
        return r !== n;
      }));
    },
    listenDocument: function(e, n, r) {
      e ? this.listenOnDocument(n, r) : this.listenOffDocument(n, r);
    },
    listenOnDocument: function(e, n) {
      Je && (gn(document, e, n, $e), this.registerDocumentListener(e, n));
    },
    listenOffDocument: function(e, n) {
      Je && zr(document, e, n, $e), this.unregisterDocumentListener(e, n);
    }
  }
}), Zn = "$_windowListeners", JW = Ot.extend({
  created: function() {
    this[Zn] = {};
  },
  beforeDestroy: function() {
    var e = this;
    Se(this[Zn] || {}).forEach(function(n) {
      e[Zn][n].forEach(function(r) {
        e.listenOffWindow(n, r);
      });
    }), this[Zn] = null;
  },
  methods: {
    registerWindowListener: function(e, n) {
      this[Zn] && (this[Zn][e] = this[Zn][e] || [], ln(this[Zn][e], n) || this[Zn][e].push(n));
    },
    unregisterWindowListener: function(e, n) {
      this[Zn] && this[Zn][e] && (this[Zn][e] = this[Zn][e].filter(function(r) {
        return r !== n;
      }));
    },
    listenWindow: function(e, n, r) {
      e ? this.listenOnWindow(n, r) : this.listenOffWindow(n, r);
    },
    listenOnWindow: function(e, n) {
      Je && (gn(window, e, n, $e), this.registerWindowListener(e, n));
    },
    listenOffWindow: function(e, n) {
      Je && zr(window, e, n, $e), this.unregisterWindowListener(e, n);
    }
  }
}), Gl = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  return e && e.$options._scopeId || n;
};
function QW(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Zx = Ot.extend({
  computed: {
    scopedStyleAttrs: function() {
      var e = Gl(this.$parent);
      return e ? QW({}, e, "") : {};
    }
  }
}), tU = /* @__PURE__ */ Ot.extend({
  // As an abstract component, it doesn't appear in the $parent chain of
  // components, which means the next parent of any component rendered inside
  // of this one will be the parent from which is was portal'd
  abstract: !0,
  name: pj,
  props: {
    // Even though we only support a single root element,
    // VNodes are always passed as an array
    nodes: M(Cj)
  },
  data: function(e) {
    return {
      updatedNodes: e.nodes
    };
  },
  destroyed: function() {
    Kj(this.$el);
  },
  render: function(e) {
    var n = this.updatedNodes, r = Me(n) ? n({}) : n;
    return r = Fr(r).filter(Vi), r && r.length > 0 && !r[0].text ? r[0] : e();
  }
}), eU = {
  // String: CSS selector,
  // HTMLElement: Element reference
  // Mainly needed for tooltips/popovers inside modals
  container: M([ga, Q], "body"),
  disabled: M(st, !1),
  // This should be set to match the root element type
  tag: M(Q, "div")
}, nU = /* @__PURE__ */ Ot.extend({
  name: dj,
  mixins: [Wi],
  props: eU,
  watch: {
    disabled: {
      immediate: !0,
      handler: function(e) {
        e ? this.unmountTarget() : this.$nextTick(this.mountTarget);
      }
    }
  },
  created: function() {
    this.$_defaultFn = null, this.$_target = null;
  },
  beforeMount: function() {
    this.mountTarget();
  },
  updated: function() {
    this.updateTarget();
  },
  beforeDestroy: function() {
    this.unmountTarget(), this.$_defaultFn = null;
  },
  methods: {
    // Get the element which the target should be appended to
    getContainer: function() {
      if (Je) {
        var e = this.container;
        return fa(e) ? Sc(e) : e;
      } else
        return null;
    },
    // Mount the target
    mountTarget: function() {
      if (!this.$_target) {
        var e = this.getContainer();
        if (e) {
          var n = document.createElement("div");
          e.appendChild(n), this.$_target = new tU({
            el: n,
            parent: this,
            propsData: {
              // Initial nodes to be rendered
              nodes: Fr(this.normalizeSlot())
            }
          });
        }
      }
    },
    // Update the content of the target
    updateTarget: function() {
      if (Je && this.$_target) {
        var e = this.$scopedSlots.default;
        this.disabled || (e && this.$_defaultFn !== e ? this.$_target.updatedNodes = e : e || (this.$_target.updatedNodes = this.$slots.default)), this.$_defaultFn = e;
      }
    },
    // Unmount the target
    unmountTarget: function() {
      this.$_target && this.$_target.$destroy(), this.$_target = null;
    }
  },
  render: function(e) {
    if (this.disabled) {
      var n = Fr(this.normalizeSlot()).filter(Vi);
      if (n.length > 0 && !n[0].text)
        return n[0];
    }
    return e();
  }
});
function A0(t) {
  return A0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, A0(t);
}
function A5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function P5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? A5(Object(n), !0).forEach(function(r) {
      rU(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : A5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function rU(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function iU(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function M5(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function aU(t, e, n) {
  return e && M5(t.prototype, e), n && M5(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Ph() {
  return typeof Reflect != "undefined" && Reflect.get ? Ph = Reflect.get : Ph = function(e, n, r) {
    var i = oU(e, n);
    if (i) {
      var a = Object.getOwnPropertyDescriptor(i, n);
      return a.get ? a.get.call(arguments.length < 3 ? e : r) : a.value;
    }
  }, Ph.apply(this, arguments);
}
function oU(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = Qs(t), t !== null); )
    ;
  return t;
}
function sU(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  Object.defineProperty(t, "prototype", { value: Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), writable: !1 }), e && P0(t, e);
}
function P0(t, e) {
  return P0 = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, P0(t, e);
}
function uU(t) {
  var e = cU();
  return function() {
    var r = Qs(t), i;
    if (e) {
      var a = Qs(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return lU(this, i);
  };
}
function lU(t, e) {
  if (e && (A0(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Jx(t);
}
function Jx(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function cU() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (t) {
    return !1;
  }
}
function Qs(t) {
  return Qs = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Qs(t);
}
var fU = /* @__PURE__ */ function(t) {
  sU(n, t);
  var e = uU(n);
  function n(r) {
    var i, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return iU(this, n), i = e.call(this, r, a), y9(Jx(i), {
      trigger: ia()
    }), i;
  }
  return aU(n, null, [{
    key: "Defaults",
    get: function() {
      return P5(P5({}, Ph(Qs(n), "Defaults", this)), {}, {
        trigger: null
      });
    }
  }]), n;
}(Nc), k5 = 1040, hU = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", dU = ".sticky-top", pU = ".navbar-toggler", mU = /* @__PURE__ */ Ot.extend({
  data: function() {
    return {
      modals: [],
      baseZIndex: null,
      scrollbarWidth: null,
      isBodyOverflowing: !1
    };
  },
  computed: {
    modalCount: function() {
      return this.modals.length;
    },
    modalsAreOpen: function() {
      return this.modalCount > 0;
    }
  },
  watch: {
    modalCount: function(e, n) {
      Je && (this.getScrollbarWidth(), e > 0 && n === 0 ? (this.checkScrollbar(), this.setScrollbar(), vl(document.body, "modal-open")) : e === 0 && n > 0 && (this.resetScrollbar(), ex(document.body, "modal-open")), Xr(document.body, "data-modal-open-count", String(e)));
    },
    modals: function(e) {
      var n = this;
      this.checkScrollbar(), Nr(function() {
        n.updateModals(e || []);
      });
    }
  },
  methods: {
    // Public methods
    registerModal: function(e) {
      e && this.modals.indexOf(e) === -1 && this.modals.push(e);
    },
    unregisterModal: function(e) {
      var n = this.modals.indexOf(e);
      n > -1 && (this.modals.splice(n, 1), !e._isBeingDestroyed && !e._isDestroyed && this.resetModal(e));
    },
    getBaseZIndex: function() {
      if (Je && Ri(this.baseZIndex)) {
        var e = document.createElement("div");
        vl(e, "modal-backdrop"), vl(e, "d-none"), na(e, "display", "none"), document.body.appendChild(e), this.baseZIndex = Qt($s(e).zIndex, k5), document.body.removeChild(e);
      }
      return this.baseZIndex || k5;
    },
    getScrollbarWidth: function() {
      if (Je && Ri(this.scrollbarWidth)) {
        var e = document.createElement("div");
        vl(e, "modal-scrollbar-measure"), document.body.appendChild(e), this.scrollbarWidth = y0(e).width - e.clientWidth, document.body.removeChild(e);
      }
      return this.scrollbarWidth || 0;
    },
    // Private methods
    updateModals: function(e) {
      var n = this, r = this.getBaseZIndex(), i = this.getScrollbarWidth();
      e.forEach(function(a, o) {
        a.zIndex = r + o, a.scrollbarWidth = i, a.isTop = o === n.modals.length - 1, a.isBodyOverflowing = n.isBodyOverflowing;
      });
    },
    resetModal: function(e) {
      e && (e.zIndex = this.getBaseZIndex(), e.isTop = !0, e.isBodyOverflowing = !1);
    },
    checkScrollbar: function() {
      var e = y0(document.body), n = e.left, r = e.right;
      this.isBodyOverflowing = n + r < window.innerWidth;
    },
    setScrollbar: function() {
      var e = document.body;
      if (e._paddingChangedForModal = e._paddingChangedForModal || [], e._marginChangedForModal = e._marginChangedForModal || [], this.isBodyOverflowing) {
        var n = this.scrollbarWidth;
        _o(hU).forEach(function(i) {
          var a = _l(i, "paddingRight") || "";
          Xr(i, "data-padding-right", a), na(i, "paddingRight", "".concat(co($s(i).paddingRight, 0) + n, "px")), e._paddingChangedForModal.push(i);
        }), _o(dU).forEach(function(i) {
          var a = _l(i, "marginRight") || "";
          Xr(i, "data-margin-right", a), na(i, "marginRight", "".concat(co($s(i).marginRight, 0) - n, "px")), e._marginChangedForModal.push(i);
        }), _o(pU).forEach(function(i) {
          var a = _l(i, "marginRight") || "";
          Xr(i, "data-margin-right", a), na(i, "marginRight", "".concat(co($s(i).marginRight, 0) + n, "px")), e._marginChangedForModal.push(i);
        });
        var r = _l(e, "paddingRight") || "";
        Xr(e, "data-padding-right", r), na(e, "paddingRight", "".concat(co($s(e).paddingRight, 0) + n, "px"));
      }
    },
    resetScrollbar: function() {
      var e = document.body;
      e._paddingChangedForModal && e._paddingChangedForModal.forEach(function(n) {
        Ds(n, "data-padding-right") && (na(n, "paddingRight", ha(n, "data-padding-right") || ""), Il(n, "data-padding-right"));
      }), e._marginChangedForModal && e._marginChangedForModal.forEach(function(n) {
        Ds(n, "data-margin-right") && (na(n, "marginRight", ha(n, "data-margin-right") || ""), Il(n, "data-margin-right"));
      }), e._paddingChangedForModal = null, e._marginChangedForModal = null, Ds(e, "data-padding-right") && (na(e, "paddingRight", ha(e, "data-padding-right") || ""), Il(e, "data-padding-right"));
    }
  }
}), fs = new mU();
function N5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ua(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? N5(Object(n), !0).forEach(function(r) {
      Jn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : N5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Jn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Up = zp("visible", {
  type: st,
  defaultValue: !1,
  event: b_
}), gU = Up.mixin, vU = Up.props, dg = Up.prop, _U = Up.event, bU = "backdrop", yU = "esc", wU = "FORCE", xU = "toggle", Mh = "cancel", kh = "headerclose", Nh = "ok", CU = [Mh, kh, Nh], $U = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  attributes: !0,
  attributeFilter: ["style", "class"]
}, TU = ue(jn(ua(ua(ua({}, La), vU), {}, {
  ariaLabel: M(Q),
  autoFocusButton: M(
    Q,
    null,
    /* istanbul ignore next */
    function(t) {
      return si(t) || ln(CU, t);
    }
  ),
  bodyBgVariant: M(Q),
  bodyClass: M(fe),
  bodyTextVariant: M(Q),
  busy: M(st, !1),
  buttonSize: M(Q),
  cancelDisabled: M(st, !1),
  cancelTitle: M(Q, "Cancel"),
  cancelTitleHtml: M(Q),
  cancelVariant: M(Q, "secondary"),
  centered: M(st, !1),
  contentClass: M(fe),
  dialogClass: M(fe),
  footerBgVariant: M(Q),
  footerBorderVariant: M(Q),
  footerClass: M(fe),
  footerTag: M(Q, "footer"),
  footerTextVariant: M(Q),
  headerBgVariant: M(Q),
  headerBorderVariant: M(Q),
  headerClass: M(fe),
  headerCloseContent: M(Q, "&times;"),
  headerCloseLabel: M(Q, "Close"),
  headerCloseVariant: M(Q),
  headerTag: M(Q, "header"),
  headerTextVariant: M(Q),
  // TODO: Rename to `noBackdrop` and deprecate `hideBackdrop`
  hideBackdrop: M(st, !1),
  // TODO: Rename to `noFooter` and deprecate `hideFooter`
  hideFooter: M(st, !1),
  // TODO: Rename to `noHeader` and deprecate `hideHeader`
  hideHeader: M(st, !1),
  // TODO: Rename to `noHeaderClose` and deprecate `hideHeaderClose`
  hideHeaderClose: M(st, !1),
  ignoreEnforceFocusSelector: M(Gs),
  lazy: M(st, !1),
  modalClass: M(fe),
  noCloseOnBackdrop: M(st, !1),
  noCloseOnEsc: M(st, !1),
  noEnforceFocus: M(st, !1),
  noFade: M(st, !1),
  noStacking: M(st, !1),
  okDisabled: M(st, !1),
  okOnly: M(st, !1),
  okTitle: M(Q, "OK"),
  okTitleHtml: M(Q),
  okVariant: M(Q, "primary"),
  // HTML Element, CSS selector string or Vue component instance
  returnFocus: M([ga, Lr, Q]),
  scrollable: M(st, !1),
  size: M(Q, "md"),
  static: M(st, !1),
  title: M(Q),
  titleClass: M(fe),
  titleHtml: M(Q),
  titleSrOnly: M(st, !1),
  titleTag: M(Q, "h5")
})), Ci), L_ = /* @__PURE__ */ Ot.extend({
  name: Ci,
  mixins: [S_, Ou, gU, ZW, Hp, JW, Wi, Zx],
  inheritAttrs: !1,
  props: TU,
  data: function() {
    return {
      isHidden: !0,
      // If modal should not be in document
      isVisible: !1,
      // Controls modal visible state
      isTransitioning: !1,
      // Used for style control
      isShow: !1,
      // Used for style control
      isBlock: !1,
      // Used for style control
      isOpening: !1,
      // To signal that the modal is in the process of opening
      isClosing: !1,
      // To signal that the modal is in the process of closing
      ignoreBackdropClick: !1,
      // Used to signify if click out listener should ignore the click
      isModalOverflowing: !1,
      // The following items are controlled by the modalManager instance
      scrollbarWidth: 0,
      zIndex: fs.getBaseZIndex(),
      isTop: !0,
      isBodyOverflowing: !1
    };
  },
  computed: {
    modalId: function() {
      return this.safeId();
    },
    modalOuterId: function() {
      return this.safeId("__BV_modal_outer_");
    },
    modalHeaderId: function() {
      return this.safeId("__BV_modal_header_");
    },
    modalBodyId: function() {
      return this.safeId("__BV_modal_body_");
    },
    modalTitleId: function() {
      return this.safeId("__BV_modal_title_");
    },
    modalContentId: function() {
      return this.safeId("__BV_modal_content_");
    },
    modalFooterId: function() {
      return this.safeId("__BV_modal_footer_");
    },
    modalBackdropId: function() {
      return this.safeId("__BV_modal_backdrop_");
    },
    modalClasses: function() {
      return [{
        fade: !this.noFade,
        show: this.isShow
      }, this.modalClass];
    },
    modalStyles: function() {
      var e = "".concat(this.scrollbarWidth, "px");
      return {
        paddingLeft: !this.isBodyOverflowing && this.isModalOverflowing ? e : "",
        paddingRight: this.isBodyOverflowing && !this.isModalOverflowing ? e : "",
        // Needed to fix issue https://github.com/bootstrap-vue/bootstrap-vue/issues/3457
        // Even though we are using v-show, we must ensure 'none' is restored in the styles
        display: this.isBlock ? "block" : "none"
      };
    },
    dialogClasses: function() {
      var e;
      return [(e = {}, Jn(e, "modal-".concat(this.size), this.size), Jn(e, "modal-dialog-centered", this.centered), Jn(e, "modal-dialog-scrollable", this.scrollable), e), this.dialogClass];
    },
    headerClasses: function() {
      var e;
      return [(e = {}, Jn(e, "bg-".concat(this.headerBgVariant), this.headerBgVariant), Jn(e, "text-".concat(this.headerTextVariant), this.headerTextVariant), Jn(e, "border-".concat(this.headerBorderVariant), this.headerBorderVariant), e), this.headerClass];
    },
    titleClasses: function() {
      return [{
        "sr-only": this.titleSrOnly
      }, this.titleClass];
    },
    bodyClasses: function() {
      var e;
      return [(e = {}, Jn(e, "bg-".concat(this.bodyBgVariant), this.bodyBgVariant), Jn(e, "text-".concat(this.bodyTextVariant), this.bodyTextVariant), e), this.bodyClass];
    },
    footerClasses: function() {
      var e;
      return [(e = {}, Jn(e, "bg-".concat(this.footerBgVariant), this.footerBgVariant), Jn(e, "text-".concat(this.footerTextVariant), this.footerTextVariant), Jn(e, "border-".concat(this.footerBorderVariant), this.footerBorderVariant), e), this.footerClass];
    },
    modalOuterStyle: function() {
      return {
        position: "absolute",
        zIndex: this.zIndex
      };
    },
    slotScope: function() {
      return {
        cancel: this.onCancel,
        close: this.onClose,
        hide: this.hide,
        ok: this.onOk,
        visible: this.isVisible
      };
    },
    computeIgnoreEnforceFocusSelector: function() {
      return Fr(this.ignoreEnforceFocusSelector).filter(Vi).join(",").trim();
    },
    computedAttrs: function() {
      var e = this.static ? {} : this.scopedStyleAttrs;
      return ua(ua(ua({}, e), this.bvAttrs), {}, {
        id: this.modalOuterId
      });
    },
    computedModalAttrs: function() {
      var e = this.isVisible, n = this.ariaLabel;
      return {
        id: this.modalId,
        role: "dialog",
        "aria-hidden": e ? null : "true",
        "aria-modal": e ? "true" : null,
        "aria-label": n,
        "aria-labelledby": this.hideHeader || n || // TODO: Rename slot to `title` and deprecate `modal-title`
        !(this.hasNormalizedSlot(lg) || this.titleHtml || this.title) ? null : this.modalTitleId,
        "aria-describedby": this.modalBodyId
      };
    }
  },
  watch: Jn({}, dg, function(t, e) {
    t !== e && this[t ? "show" : "hide"]();
  }),
  created: function() {
    this.$_observer = null, this.$_returnFocus = this.returnFocus || null;
  },
  mounted: function() {
    this.zIndex = fs.getBaseZIndex(), this.listenOnRoot(fo(Ci, Cr), this.showHandler), this.listenOnRoot(fo(Ci, Pi), this.hideHandler), this.listenOnRoot(fo(Ci, Y9), this.toggleHandler), this.listenOnRoot(ki(Ci, Cr), this.modalListener), this[dg] === !0 && this.$nextTick(this.show);
  },
  beforeDestroy: function() {
    fs.unregisterModal(this), this.setObserver(!1), this.isVisible && (this.isVisible = !1, this.isShow = !1, this.isTransitioning = !1);
  },
  methods: {
    setObserver: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      this.$_observer && this.$_observer.disconnect(), this.$_observer = null, e && (this.$_observer = Cx(this.$refs.content, this.checkModalOverflow.bind(this), $U));
    },
    // Private method to update the v-model
    updateModel: function(e) {
      e !== this[dg] && this.$emit(_U, e);
    },
    // Private method to create a BvModalEvent object
    buildEvent: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new fU(e, ua(ua({
        // Default options
        cancelable: !1,
        target: this.$refs.modal || this.$el || null,
        relatedTarget: null,
        trigger: null
      }, n), {}, {
        // Options that can't be overridden
        vueTarget: this,
        componentId: this.modalId
      }));
    },
    // Public method to show modal
    show: function() {
      if (!(this.isVisible || this.isOpening)) {
        if (this.isClosing) {
          this.$once(wn, this.show);
          return;
        }
        this.isOpening = !0, this.$_returnFocus = this.$_returnFocus || this.getActiveElement();
        var e = this.buildEvent(Cr, {
          cancelable: !0
        });
        if (this.emitEvent(e), e.defaultPrevented || this.isVisible) {
          this.isOpening = !1, this.updateModel(!1);
          return;
        }
        this.doShow();
      }
    },
    // Public method to hide modal
    hide: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      if (!(!this.isVisible || this.isClosing)) {
        this.isClosing = !0;
        var n = this.buildEvent(Pi, {
          cancelable: e !== wU,
          trigger: e || null
        });
        if (e === Nh ? this.$emit(bj, n) : e === Mh ? this.$emit(vj, n) : e === kh && this.$emit(v0, n), this.emitEvent(n), n.defaultPrevented || !this.isVisible) {
          this.isClosing = !1, this.updateModel(!0);
          return;
        }
        this.setObserver(!1), this.isVisible = !1, this.updateModel(!1);
      }
    },
    // Public method to toggle modal visibility
    toggle: function(e) {
      e && (this.$_returnFocus = e), this.isVisible ? this.hide(xU) : this.show();
    },
    // Private method to get the current document active element
    getActiveElement: function() {
      var e = od(Je ? [document.body] : []);
      return e && e.focus ? e : null;
    },
    // Private method to finish showing modal
    doShow: function() {
      var e = this;
      if (fs.modalsAreOpen && this.noStacking) {
        this.listenOnRootOnce(ki(Ci, wn), this.doShow);
        return;
      }
      fs.registerModal(this), this.isHidden = !1, this.$nextTick(function() {
        e.isVisible = !0, e.isOpening = !1, e.updateModel(!0), e.$nextTick(function() {
          e.setObserver(!0);
        });
      });
    },
    // Transition handlers
    onBeforeEnter: function() {
      this.isTransitioning = !0, this.setResizeEvent(!0);
    },
    onEnter: function() {
      var e = this;
      this.isBlock = !0, Nr(function() {
        Nr(function() {
          e.isShow = !0;
        });
      });
    },
    onAfterEnter: function() {
      var e = this;
      this.checkModalOverflow(), this.isTransitioning = !1, Nr(function() {
        e.emitEvent(e.buildEvent(Mi)), e.setEnforceFocus(!0), e.$nextTick(function() {
          e.focusFirst();
        });
      });
    },
    onBeforeLeave: function() {
      this.isTransitioning = !0, this.setResizeEvent(!1), this.setEnforceFocus(!1);
    },
    onLeave: function() {
      this.isShow = !1;
    },
    onAfterLeave: function() {
      var e = this;
      this.isBlock = !1, this.isTransitioning = !1, this.isModalOverflowing = !1, this.isHidden = !0, this.$nextTick(function() {
        e.isClosing = !1, fs.unregisterModal(e), e.returnFocusTo(), e.emitEvent(e.buildEvent(wn));
      });
    },
    emitEvent: function(e) {
      var n = e.type;
      this.emitOnRoot(ki(Ci, n), e, e.componentId), this.$emit(n, e);
    },
    // UI event handlers
    onDialogMousedown: function() {
      var e = this, n = this.$refs.modal, r = function i(a) {
        zr(n, "mouseup", i, $e), a.target === n && (e.ignoreBackdropClick = !0);
      };
      gn(n, "mouseup", r, $e);
    },
    onClickOut: function(e) {
      if (this.ignoreBackdropClick) {
        this.ignoreBackdropClick = !1;
        return;
      }
      !this.isVisible || this.noCloseOnBackdrop || !ze(document.body, e.target) || ze(this.$refs.content, e.target) || this.hide(bU);
    },
    onOk: function() {
      this.hide(Nh);
    },
    onCancel: function() {
      this.hide(Mh);
    },
    onClose: function() {
      this.hide(kh);
    },
    onEsc: function(e) {
      e.keyCode === hx && this.isVisible && !this.noCloseOnEsc && this.hide(yU);
    },
    // Document focusin listener
    focusHandler: function(e) {
      var n = this.$refs.content, r = e.target;
      if (!(this.noEnforceFocus || !this.isTop || !this.isVisible || !n || document === r || ze(n, r) || this.computeIgnoreEnforceFocusSelector && sd(this.computeIgnoreEnforceFocusSelector, r, !0))) {
        var i = Xj(this.$refs.content), a = this.$refs["bottom-trap"], o = this.$refs["top-trap"];
        if (a && r === a) {
          if (Oe(i[0]))
            return;
        } else if (o && r === o && Oe(i[i.length - 1]))
          return;
        Oe(n, {
          preventScroll: !0
        });
      }
    },
    // Turn on/off focusin listener
    setEnforceFocus: function(e) {
      this.listenDocument(e, "focusin", this.focusHandler);
    },
    // Resize listener
    setResizeEvent: function(e) {
      this.listenWindow(e, "resize", this.checkModalOverflow), this.listenWindow(e, "orientationchange", this.checkModalOverflow);
    },
    // Root listener handlers
    showHandler: function(e, n) {
      e === this.modalId && (this.$_returnFocus = n || this.getActiveElement(), this.show());
    },
    hideHandler: function(e) {
      e === this.modalId && this.hide("event");
    },
    toggleHandler: function(e, n) {
      e === this.modalId && this.toggle(n);
    },
    modalListener: function(e) {
      this.noStacking && e.vueTarget !== this && this.hide();
    },
    // Focus control handlers
    focusFirst: function() {
      var e = this;
      Je && Nr(function() {
        var n = e.$refs.modal, r = e.$refs.content, i = e.getActiveElement();
        if (n && r && !(i && ze(r, i))) {
          var a = e.$refs["ok-button"], o = e.$refs["cancel-button"], s = e.$refs["close-button"], l = e.autoFocusButton, c = l === Nh && a ? a.$el || a : l === Mh && o ? o.$el || o : l === kh && s ? s.$el || s : r;
          Oe(c), c === r && e.$nextTick(function() {
            n.scrollTop = 0;
          });
        }
      });
    },
    returnFocusTo: function() {
      var e = this.returnFocus || this.$_returnFocus || null;
      this.$_returnFocus = null, this.$nextTick(function() {
        e = fa(e) ? Sc(e) : e, e && (e = e.$el || e, Oe(e));
      });
    },
    checkModalOverflow: function() {
      if (this.isVisible) {
        var e = this.$refs.modal;
        this.isModalOverflowing = e.scrollHeight > document.documentElement.clientHeight;
      }
    },
    makeModal: function(e) {
      var n = e();
      if (!this.hideHeader) {
        var r = this.normalizeSlot(Rj, this.slotScope);
        if (!r) {
          var i = e();
          this.hideHeaderClose || (i = e(
            nV,
            {
              props: {
                content: this.headerCloseContent,
                disabled: this.isTransitioning,
                ariaLabel: this.headerCloseLabel,
                textVariant: this.headerCloseVariant || this.headerTextVariant
              },
              on: {
                click: this.onClose
              },
              ref: "close-button"
            },
            // TODO: Rename slot to `header-close` and deprecate `modal-header-close`
            [this.normalizeSlot(Lj)]
          )), r = [e(
            this.titleTag,
            {
              staticClass: "modal-title",
              class: this.titleClasses,
              attrs: {
                id: this.modalTitleId
              },
              // TODO: Rename slot to `title` and deprecate `modal-title`
              domProps: this.hasNormalizedSlot(lg) ? {} : Fs(this.titleHtml, this.title)
            },
            // TODO: Rename slot to `title` and deprecate `modal-title`
            this.normalizeSlot(lg, this.slotScope)
          ), i];
        }
        n = e(this.headerTag, {
          staticClass: "modal-header",
          class: this.headerClasses,
          attrs: {
            id: this.modalHeaderId
          },
          ref: "header"
        }, [r]);
      }
      var a = e("div", {
        staticClass: "modal-body",
        class: this.bodyClasses,
        attrs: {
          id: this.modalBodyId
        },
        ref: "body"
      }, this.normalizeSlot(xo, this.slotScope)), o = e();
      if (!this.hideFooter) {
        var s = this.normalizeSlot(Ij, this.slotScope);
        if (!s) {
          var l = e();
          this.okOnly || (l = e(
            C0,
            {
              props: {
                variant: this.cancelVariant,
                size: this.buttonSize,
                disabled: this.cancelDisabled || this.busy || this.isTransitioning
              },
              // TODO: Rename slot to `cancel-button` and deprecate `modal-cancel`
              domProps: this.hasNormalizedSlot(q4) ? {} : Fs(this.cancelTitleHtml, this.cancelTitle),
              on: {
                click: this.onCancel
              },
              ref: "cancel-button"
            },
            // TODO: Rename slot to `cancel-button` and deprecate `modal-cancel`
            this.normalizeSlot(q4)
          ));
          var c = e(
            C0,
            {
              props: {
                variant: this.okVariant,
                size: this.buttonSize,
                disabled: this.okDisabled || this.busy || this.isTransitioning
              },
              // TODO: Rename slot to `ok-button` and deprecate `modal-ok`
              domProps: this.hasNormalizedSlot(G4) ? {} : Fs(this.okTitleHtml, this.okTitle),
              on: {
                click: this.onOk
              },
              ref: "ok-button"
            },
            // TODO: Rename slot to `ok-button` and deprecate `modal-ok`
            this.normalizeSlot(G4)
          );
          s = [l, c];
        }
        o = e(this.footerTag, {
          staticClass: "modal-footer",
          class: this.footerClasses,
          attrs: {
            id: this.modalFooterId
          },
          ref: "footer"
        }, [s]);
      }
      var h = e("div", {
        staticClass: "modal-content",
        class: this.contentClass,
        attrs: {
          id: this.modalContentId,
          tabindex: "-1"
        },
        ref: "content"
      }, [n, a, o]), d = e(), p = e();
      this.isVisible && !this.noEnforceFocus && (d = e("span", {
        attrs: {
          tabindex: "0"
        },
        ref: "top-trap"
      }), p = e("span", {
        attrs: {
          tabindex: "0"
        },
        ref: "bottom-trap"
      }));
      var g = e("div", {
        staticClass: "modal-dialog",
        class: this.dialogClasses,
        on: {
          mousedown: this.onDialogMousedown
        },
        ref: "dialog"
      }, [d, h, p]), v = e("div", {
        staticClass: "modal",
        class: this.modalClasses,
        style: this.modalStyles,
        attrs: this.computedModalAttrs,
        on: {
          keydown: this.onEsc,
          click: this.onClickOut
        },
        directives: [{
          name: "show",
          value: this.isVisible
        }],
        ref: "modal"
      }, [g]);
      v = e("transition", {
        props: {
          enterClass: "",
          enterToClass: "",
          enterActiveClass: "",
          leaveClass: "",
          leaveActiveClass: "",
          leaveToClass: ""
        },
        on: {
          beforeEnter: this.onBeforeEnter,
          enter: this.onEnter,
          afterEnter: this.onAfterEnter,
          beforeLeave: this.onBeforeLeave,
          leave: this.onLeave,
          afterLeave: this.onAfterLeave
        }
      }, [v]);
      var b = e();
      return !this.hideBackdrop && this.isVisible && (b = e(
        "div",
        {
          staticClass: "modal-backdrop",
          attrs: {
            id: this.modalBackdropId
          }
        },
        // TODO: Rename slot to `backdrop` and deprecate `modal-backdrop`
        this.normalizeSlot(Nj)
      )), b = e(T_, {
        props: {
          noFade: this.noFade
        }
      }, [b]), e("div", {
        style: this.modalOuterStyle,
        attrs: this.computedAttrs,
        key: "modal-outer-".concat(this[Ls])
      }, [v, b]);
    }
  },
  render: function(e) {
    return this.static ? this.lazy && this.isHidden ? e() : this.makeModal(e) : this.isHidden ? e() : e(nU, [this.makeModal(e)]);
  }
});
function I5(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var OU = function(e) {
  return e = e === "left" ? "start" : e === "right" ? "end" : e, "justify-content-".concat(e);
}, Qx = ue({
  align: M(Q),
  // Set to `true` if placing in a card header
  cardHeader: M(st, !1),
  fill: M(st, !1),
  justified: M(st, !1),
  pills: M(st, !1),
  small: M(st, !1),
  tabs: M(st, !1),
  tag: M(Q, "ul"),
  vertical: M(st, !1)
}, k9), SU = /* @__PURE__ */ Ot.extend({
  name: k9,
  functional: !0,
  props: Qx,
  render: function(e, n) {
    var r, i = n.props, a = n.data, o = n.children, s = i.tabs, l = i.pills, c = i.vertical, h = i.align, d = i.cardHeader;
    return e(i.tag, ji(a, {
      staticClass: "nav",
      class: (r = {
        "nav-tabs": s,
        "nav-pills": l && !s,
        "card-header-tabs": !c && d && s,
        "card-header-pills": !c && d && l && !s,
        "flex-column": c,
        "nav-fill": !c && i.fill,
        "nav-justified": !c && i.justified
      }, I5(r, OU(h), !c && h), I5(r, "small", i.small), r)
    }), o);
  }
});
function EU(t) {
  return kU(t) || MU(t) || PU(t) || AU();
}
function AU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PU(t, e) {
  if (t) {
    if (typeof t == "string")
      return M0(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return M0(t, e);
  }
}
function MU(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function kU(t) {
  if (Array.isArray(t))
    return M0(t);
}
function M0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function R5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function L5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? R5(Object(n), !0).forEach(function(r) {
      NU(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : R5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function NU(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var IU = ue(jn(L5(L5({}, La), w9(AW, [].concat(EU(Se(I_)), ["html", "lazy", "menuClass", "noCaret", "role", "text", "toggleClass"])))), N9), RU = /* @__PURE__ */ Ot.extend({
  name: N9,
  mixins: [Ou, SW, Wi],
  props: IU,
  computed: {
    toggleId: function() {
      return this.safeId("_BV_toggle_");
    },
    menuId: function() {
      return this.safeId("_BV_toggle_menu_");
    },
    dropdownClasses: function() {
      return [this.directionClass, this.boundaryClass, {
        show: this.visible
      }];
    },
    menuClasses: function() {
      return [this.menuClass, {
        "dropdown-menu-right": this.right,
        show: this.visible
      }];
    },
    toggleClasses: function() {
      return [this.toggleClass, {
        "dropdown-toggle-no-caret": this.noCaret
      }];
    }
  },
  render: function(e) {
    var n = this.toggleId, r = this.menuId, i = this.visible, a = this.hide, o = e(Ks, {
      staticClass: "nav-link dropdown-toggle",
      class: this.toggleClasses,
      props: {
        href: "#".concat(this.id || ""),
        disabled: this.disabled
      },
      attrs: {
        id: n,
        role: "button",
        "aria-haspopup": "true",
        "aria-expanded": i ? "true" : "false",
        "aria-controls": r
      },
      on: {
        mousedown: this.onMousedown,
        click: this.toggle,
        keydown: this.toggle
        // Handle ENTER, SPACE and DOWN
      },
      ref: "toggle"
    }, [
      // TODO: The `text` slot is deprecated in favor of the `button-content` slot
      this.normalizeSlot([Ej, jj]) || e("span", {
        domProps: Fs(this.html, this.text)
      })
    ]), s = e("ul", {
      staticClass: "dropdown-menu",
      class: this.menuClasses,
      attrs: {
        tabindex: "-1",
        "aria-labelledby": n,
        id: r
      },
      on: {
        keydown: this.onKeydown
        // Handle UP, DOWN and ESC
      },
      ref: "menu"
    }, !this.lazy || i ? this.normalizeSlot(xo, {
      hide: a
    }) : [e()]);
    return e("li", {
      staticClass: "nav-item b-nav-dropdown dropdown",
      class: this.dropdownClasses,
      attrs: {
        id: this.safeId()
      }
    }, [o, s]);
  }
}), rl;
function D5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function F5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? D5(Object(n), !0).forEach(function(r) {
      Ih(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Ih(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Yp = zp("value", {
  type: $j,
  defaultValue: null,
  /* istanbul ignore next */
  validator: function(e) {
    return !Ri(e) && Qt(e, 0) < 1 ? (Oc('"v-model" value must be a number greater than "0"', Lp), !1) : !0;
  }
}), LU = Yp.mixin, DU = Yp.props, k0 = Yp.prop, FU = Yp.event, Uf = 3, D_ = 5, zU = function(e, n) {
  return Vj(n, function(r, i) {
    return {
      number: e + i,
      classes: null
    };
  });
}, z5 = function(e) {
  var n = Qt(e) || 1;
  return n < 1 ? D_ : n;
}, B5 = function(e, n) {
  var r = Qt(e) || 1;
  return r > n ? n : r < 1 ? 1 : r;
}, H5 = function(e) {
  if (e.keyCode === Bp)
    return ke(e, {
      immediatePropagation: !0
    }), e.currentTarget.click(), !1;
}, tC = ue(jn(F5(F5({}, DU), {}, {
  align: M(Q, "left"),
  ariaLabel: M(Q, "Pagination"),
  disabled: M(st, !1),
  ellipsisClass: M(fe),
  ellipsisText: M(Q, "…"),
  // '…'
  firstClass: M(fe),
  firstNumber: M(st, !1),
  firstText: M(Q, "«"),
  // '«'
  hideEllipsis: M(st, !1),
  hideGotoEndButtons: M(st, !1),
  labelFirstPage: M(Q, "Go to first page"),
  labelLastPage: M(Q, "Go to last page"),
  labelNextPage: M(Q, "Go to next page"),
  labelPage: M(Oj, "Go to page"),
  labelPrevPage: M(Q, "Go to previous page"),
  lastClass: M(fe),
  lastNumber: M(st, !1),
  lastText: M(Q, "»"),
  // '»'
  limit: M(
    Bn,
    D_,
    /* istanbul ignore next */
    function(t) {
      return Qt(t, 0) < 1 ? (Oc('Prop "limit" must be a number greater than "0"', Lp), !1) : !0;
    }
  ),
  nextClass: M(fe),
  nextText: M(Q, "›"),
  // '›'
  pageClass: M(fe),
  pills: M(st, !1),
  prevClass: M(fe),
  prevText: M(Q, "‹"),
  // '‹'
  size: M(Q)
})), "pagination"), BU = Ot.extend({
  mixins: [LU, Wi],
  props: tC,
  data: function() {
    var e = Qt(this[k0], 0);
    return e = e > 0 ? e : -1, {
      currentPage: e,
      localNumberOfPages: 1,
      localLimit: D_
    };
  },
  computed: {
    btnSize: function() {
      var e = this.size;
      return e ? "pagination-".concat(e) : "";
    },
    alignment: function() {
      var e = this.align;
      return e === "center" ? "justify-content-center" : e === "end" || e === "right" ? "justify-content-end" : e === "fill" ? "text-center" : "";
    },
    styleClass: function() {
      return this.pills ? "b-pagination-pills" : "";
    },
    computedCurrentPage: function() {
      return B5(this.currentPage, this.localNumberOfPages);
    },
    paginationParams: function() {
      var e = this.localLimit, n = this.localNumberOfPages, r = this.computedCurrentPage, i = this.hideEllipsis, a = this.firstNumber, o = this.lastNumber, s = !1, l = !1, c = e, h = 1;
      n <= e ? c = n : r < e - 1 && e > Uf ? ((!i || o) && (l = !0, c = e - (a ? 0 : 1)), c = Wf(c, e)) : n - r + 2 < e && e > Uf ? ((!i || a) && (s = !0, c = e - (o ? 0 : 1)), h = n - c + 1) : (e > Uf && (c = e - (i ? 0 : 2), s = !!(!i || a), l = !!(!i || o)), h = r - sV(c / 2)), h < 1 ? (h = 1, s = !1) : h > n - c && (h = n - c + 1, l = !1), s && a && h < 4 && (c = c + 2, h = 1, s = !1);
      var d = h + c - 1;
      return l && o && d > n - 3 && (c = c + (d === n - 2 ? 2 : 3), l = !1), e <= Uf && (a && h === 1 ? c = Wf(c + 1, n, e + 1) : o && n === h + c - 1 && (h = Ni(h - 1, 1), c = Wf(n - h + 1, n, e + 1))), c = Wf(c, n - h + 1), {
        showFirstDots: s,
        showLastDots: l,
        numberOfLinks: c,
        startNumber: h
      };
    },
    pageList: function() {
      var e = this.paginationParams, n = e.numberOfLinks, r = e.startNumber, i = this.computedCurrentPage, a = zU(r, n);
      if (a.length > 3) {
        var o = i - r, s = "bv-d-xs-down-none";
        if (o === 0)
          for (var l = 3; l < a.length; l++)
            a[l].classes = s;
        else if (o === a.length - 1)
          for (var c = 0; c < a.length - 3; c++)
            a[c].classes = s;
        else {
          for (var h = 0; h < o - 1; h++)
            a[h].classes = s;
          for (var d = a.length - 1; d > o + 1; d--)
            a[d].classes = s;
        }
      }
      return a;
    }
  },
  watch: (rl = {}, Ih(rl, k0, function(t, e) {
    t !== e && (this.currentPage = B5(t, this.localNumberOfPages));
  }), Ih(rl, "currentPage", function(e, n) {
    e !== n && this.$emit(FU, e > 0 ? e : null);
  }), Ih(rl, "limit", function(e, n) {
    e !== n && (this.localLimit = z5(e));
  }), rl),
  created: function() {
    var e = this;
    this.localLimit = z5(this.limit), this.$nextTick(function() {
      e.currentPage = e.currentPage > e.localNumberOfPages ? e.localNumberOfPages : e.currentPage;
    });
  },
  methods: {
    handleKeyNav: function(e) {
      var n = e.keyCode, r = e.shiftKey;
      this.isNav || (n === dx || n === O_ ? (ke(e, {
        propagation: !1
      }), r ? this.focusFirst() : this.focusPrev()) : (n === px || n === ld) && (ke(e, {
        propagation: !1
      }), r ? this.focusLast() : this.focusNext()));
    },
    getButtons: function() {
      return _o("button.page-link, a.page-link", this.$el).filter(function(e) {
        return Co(e);
      });
    },
    focusCurrent: function() {
      var e = this;
      this.$nextTick(function() {
        var n = e.getButtons().find(function(r) {
          return Qt(ha(r, "aria-posinset"), 0) === e.computedCurrentPage;
        });
        Oe(n) || e.focusFirst();
      });
    },
    focusFirst: function() {
      var e = this;
      this.$nextTick(function() {
        var n = e.getButtons().find(function(r) {
          return !gl(r);
        });
        Oe(n);
      });
    },
    focusLast: function() {
      var e = this;
      this.$nextTick(function() {
        var n = e.getButtons().reverse().find(function(r) {
          return !gl(r);
        });
        Oe(n);
      });
    },
    focusPrev: function() {
      var e = this;
      this.$nextTick(function() {
        var n = e.getButtons(), r = n.indexOf(od());
        r > 0 && !gl(n[r - 1]) && Oe(n[r - 1]);
      });
    },
    focusNext: function() {
      var e = this;
      this.$nextTick(function() {
        var n = e.getButtons(), r = n.indexOf(od());
        r < n.length - 1 && !gl(n[r + 1]) && Oe(n[r + 1]);
      });
    }
  },
  render: function(e) {
    var n = this, r = this.disabled, i = this.labelPage, a = this.ariaLabel, o = this.isNav, s = this.localNumberOfPages, l = this.computedCurrentPage, c = this.pageList.map(function(R) {
      return R.number;
    }), h = this.paginationParams, d = h.showFirstDots, p = h.showLastDots, g = this.align === "fill", v = [], b = function(L) {
      return L === l;
    }, _ = this.currentPage < 1, w = function(L, W, P, k, Y, V, I) {
      var D = r || b(V) || _ || L < 1 || L > s, z = L < 1 ? 1 : L > s ? s : L, q = {
        disabled: D,
        page: z,
        index: z - 1
      }, Z = n.normalizeSlot(P, q) || nr(k) || e(), B = e(D ? "span" : o ? Ks : "button", {
        staticClass: "page-link",
        class: {
          "flex-grow-1": !o && !D && g
        },
        props: D || !o ? {} : n.linkProps(L),
        attrs: {
          role: o ? null : "menuitem",
          type: o || D ? null : "button",
          tabindex: D || o ? null : "-1",
          "aria-label": W,
          "aria-controls": n.ariaControls || null,
          "aria-disabled": D ? "true" : null
        },
        on: D ? {} : {
          "!click": function(J) {
            n.onClick(J, L);
          },
          keydown: H5
        }
      }, [Z]);
      return e("li", {
        key: I,
        staticClass: "page-item",
        class: [{
          disabled: D,
          "flex-fill": g,
          "d-flex": g && !o && !D
        }, Y],
        attrs: {
          role: o ? null : "presentation",
          "aria-hidden": D ? "true" : null
        }
      }, [B]);
    }, x = function(L) {
      return e("li", {
        staticClass: "page-item",
        class: ["disabled", "bv-d-xs-down-none", g ? "flex-fill" : "", n.ellipsisClass],
        attrs: {
          role: "separator"
        },
        key: "ellipsis-".concat(L ? "last" : "first")
      }, [e("span", {
        staticClass: "page-link"
      }, [n.normalizeSlot(Aj) || nr(n.ellipsisText) || e()])]);
    }, C = function(L, W) {
      var P = L.number, k = b(P) && !_, Y = r ? null : k || _ && W === 0 ? "0" : "-1", V = {
        role: o ? null : "menuitemradio",
        type: o || r ? null : "button",
        "aria-disabled": r ? "true" : null,
        "aria-controls": n.ariaControls || null,
        "aria-label": ax(i) ? (
          /* istanbul ignore next */
          i(P)
        ) : "".concat(Me(i) ? i() : i, " ").concat(P),
        "aria-checked": o ? null : k ? "true" : "false",
        "aria-current": o && k ? "page" : null,
        "aria-posinset": o ? null : P,
        "aria-setsize": o ? null : s,
        // ARIA "roving tabindex" method (except in `isNav` mode)
        tabindex: o ? null : Y
      }, I = nr(n.makePage(P)), D = {
        page: P,
        index: P - 1,
        content: I,
        active: k,
        disabled: r
      }, z = e(r ? "span" : o ? Ks : "button", {
        props: r || !o ? {} : n.linkProps(P),
        staticClass: "page-link",
        class: {
          "flex-grow-1": !o && !r && g
        },
        attrs: V,
        on: r ? {} : {
          "!click": function(Z) {
            n.onClick(Z, P);
          },
          keydown: H5
        }
      }, [n.normalizeSlot(Fj, D) || I]);
      return e("li", {
        staticClass: "page-item",
        class: [{
          disabled: r,
          active: k,
          "flex-fill": g,
          "d-flex": g && !o && !r
        }, L.classes, n.pageClass],
        attrs: {
          role: o ? null : "presentation"
        },
        key: "page-".concat(P)
      }, [z]);
    }, $ = e();
    !this.firstNumber && !this.hideGotoEndButtons && ($ = w(1, this.labelFirstPage, Mj, this.firstText, this.firstClass, 1, "pagination-goto-first")), v.push($), v.push(w(l - 1, this.labelPrevPage, zj, this.prevText, this.prevClass, 1, "pagination-goto-prev")), v.push(this.firstNumber && c[0] !== 1 ? C({
      number: 1
    }, 0) : e()), v.push(d ? x(!1) : e()), this.pageList.forEach(function(R, L) {
      var W = d && n.firstNumber && c[0] !== 1 ? 1 : 0;
      v.push(C(R, L + W));
    }), v.push(p ? x(!0) : e()), v.push(this.lastNumber && c[c.length - 1] !== s ? C({
      number: s
    }, -1) : e()), v.push(w(l + 1, this.labelNextPage, Dj, this.nextText, this.nextClass, s, "pagination-goto-next"));
    var E = e();
    !this.lastNumber && !this.hideGotoEndButtons && (E = w(s, this.labelLastPage, kj, this.lastText, this.lastClass, s, "pagination-goto-last")), v.push(E);
    var A = e("ul", {
      staticClass: "pagination",
      class: ["b-pagination", this.btnSize, this.alignment, this.styleClass],
      attrs: {
        role: o ? null : "menubar",
        "aria-disabled": r ? "true" : "false",
        "aria-label": o ? null : a || null
      },
      // We disable keyboard left/right nav when `<b-pagination-nav>`
      on: o ? {} : {
        keydown: this.handleKeyNav
      },
      ref: "ul"
    }, v);
    return o ? e("nav", {
      attrs: {
        "aria-disabled": r ? "true" : null,
        "aria-hidden": r ? "true" : "false",
        "aria-label": o && a || null
      }
    }, [A]) : A;
  }
});
function j5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? j5(Object(n), !0).forEach(function(r) {
      HU(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function HU(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var eC = 20, nC = 0, W5 = function(e) {
  return Ni(Qt(e) || eC, 1);
}, U5 = function(e) {
  return Ni(Qt(e) || nC, 0);
}, jU = ue(jn(V5(V5({}, tC), {}, {
  ariaControls: M(Q),
  perPage: M(Bn, eC),
  totalRows: M(Bn, nC)
})), Lp), VU = /* @__PURE__ */ Ot.extend({
  name: Lp,
  // The render function is brought in via the `paginationMixin`
  mixins: [BU],
  props: jU,
  computed: {
    numberOfPages: function() {
      var e = oV(U5(this.totalRows) / W5(this.perPage));
      return e < 1 ? 1 : e;
    },
    // Used for watching changes to `perPage` and `numberOfPages`
    pageSizeNumberOfPages: function() {
      return {
        perPage: W5(this.perPage),
        totalRows: U5(this.totalRows),
        numberOfPages: this.numberOfPages
      };
    }
  },
  watch: {
    pageSizeNumberOfPages: function(e, n) {
      si(n) || (e.perPage !== n.perPage && e.totalRows === n.totalRows ? this.currentPage = 1 : e.numberOfPages !== n.numberOfPages && this.currentPage > e.numberOfPages && (this.currentPage = 1)), this.localNumberOfPages = e.numberOfPages;
    }
  },
  created: function() {
    var e = this;
    this.localNumberOfPages = this.numberOfPages;
    var n = Qt(this[k0], 0);
    n > 0 ? this.currentPage = n : this.$nextTick(function() {
      e.currentPage = 0;
    });
  },
  methods: {
    // These methods are used by the render function
    onClick: function(e, n) {
      var r = this;
      if (n !== this.currentPage) {
        var i = e.target, a = new Nc(yj, {
          cancelable: !0,
          vueTarget: this,
          target: i
        });
        this.$emit(a.type, a, n), !a.defaultPrevented && (this.currentPage = n, this.$emit(b_, this.currentPage), this.$nextTick(function() {
          Co(i) && r.$el.contains(i) ? Oe(i) : r.focusCurrent();
        }));
      }
    },
    makePage: function(e) {
      return e;
    },
    /* istanbul ignore next */
    linkProps: function() {
      return {};
    }
  }
}), WU = {
  AUTO: "auto",
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left",
  TOPLEFT: "top",
  TOPRIGHT: "top",
  RIGHTTOP: "right",
  RIGHTBOTTOM: "right",
  BOTTOMLEFT: "bottom",
  BOTTOMRIGHT: "bottom",
  LEFTTOP: "left",
  LEFTBOTTOM: "left"
}, UU = {
  AUTO: 0,
  TOPLEFT: -1,
  TOP: 0,
  TOPRIGHT: 1,
  RIGHTTOP: -1,
  RIGHT: 0,
  RIGHTBOTTOM: 1,
  BOTTOMLEFT: -1,
  BOTTOM: 0,
  BOTTOMRIGHT: 1,
  LEFTTOP: -1,
  LEFT: 0,
  LEFTBOTTOM: 1
}, YU = {
  // The minimum distance (in `px`) from the edge of the
  // tooltip/popover that the arrow can be positioned
  arrowPadding: M(Bn, 6),
  // 'scrollParent', 'viewport', 'window', or `Element`
  boundary: M([ga, Q], "scrollParent"),
  // Tooltip/popover will try and stay away from
  // boundary edge by this many pixels
  boundaryPadding: M(Bn, 5),
  fallbackPlacement: M(Gs, "flip"),
  offset: M(Bn, 0),
  placement: M(Q, "top"),
  // Element that the tooltip/popover is positioned relative to
  target: M([ga, v9])
}, qU = /* @__PURE__ */ Ot.extend({
  name: uj,
  props: YU,
  data: function() {
    return {
      // reactive props set by parent
      noFade: !1,
      // State related data
      localShow: !0,
      attachment: this.getAttachment(this.placement)
    };
  },
  computed: {
    /* istanbul ignore next */
    templateType: function() {
      return "unknown";
    },
    popperConfig: function() {
      var e = this, n = this.placement;
      return {
        placement: this.getAttachment(n),
        modifiers: {
          offset: {
            offset: this.getOffset(n)
          },
          flip: {
            behavior: this.fallbackPlacement
          },
          // `arrow.element` can also be a reference to an HTML Element
          // maybe we should make this a `$ref` in the templates?
          arrow: {
            element: ".arrow"
          },
          preventOverflow: {
            padding: this.boundaryPadding,
            boundariesElement: this.boundary
          }
        },
        onCreate: function(i) {
          i.originalPlacement !== i.placement && e.popperPlacementChange(i);
        },
        onUpdate: function(i) {
          e.popperPlacementChange(i);
        }
      };
    }
  },
  created: function() {
    var e = this;
    this.$_popper = null, this.localShow = !0, this.$on(Cr, function(r) {
      e.popperCreate(r);
    });
    var n = function() {
      e.$nextTick(function() {
        Nr(function() {
          e.$destroy();
        });
      });
    };
    this.$parent.$once(q9, n), this.$once(wn, n);
  },
  beforeMount: function() {
    this.attachment = this.getAttachment(this.placement);
  },
  updated: function() {
    this.updatePopper();
  },
  beforeDestroy: function() {
    this.destroyPopper();
  },
  destroyed: function() {
    var e = this.$el;
    e && e.parentNode && e.parentNode.removeChild(e);
  },
  methods: {
    // "Public" method to trigger hide template
    hide: function() {
      this.localShow = !1;
    },
    // Private
    getAttachment: function(e) {
      return WU[String(e).toUpperCase()] || "auto";
    },
    getOffset: function(e) {
      if (!this.offset) {
        var n = this.$refs.arrow || Sc(".arrow", this.$el), r = co($s(n).width, 0) + co(this.arrowPadding, 0);
        switch (UU[String(e).toUpperCase()] || 0) {
          case 1:
            return "+50%p - ".concat(r, "px");
          case -1:
            return "-50%p + ".concat(r, "px");
          default:
            return 0;
        }
      }
      return this.offset;
    },
    popperCreate: function(e) {
      this.destroyPopper(), this.$_popper = new S0(this.target, e, this.popperConfig);
    },
    destroyPopper: function() {
      this.$_popper && this.$_popper.destroy(), this.$_popper = null;
    },
    updatePopper: function() {
      this.$_popper && this.$_popper.scheduleUpdate();
    },
    popperPlacementChange: function(e) {
      this.attachment = this.getAttachment(e.placement);
    },
    /* istanbul ignore next */
    renderTemplate: function(e) {
      return e("div");
    }
  },
  render: function(e) {
    var n = this, r = this.noFade;
    return e(T_, {
      // Transitions as soon as mounted
      props: {
        appear: !0,
        noFade: r
      },
      on: {
        // Events used by parent component/instance
        beforeEnter: function(a) {
          return n.$emit(Cr, a);
        },
        afterEnter: function(a) {
          return n.$emit(Mi, a);
        },
        beforeLeave: function(a) {
          return n.$emit(Pi, a);
        },
        afterLeave: function(a) {
          return n.$emit(wn, a);
        }
      }
    }, [this.localShow ? this.renderTemplate(e) : e()]);
  }
});
function Y5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function q5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Y5(Object(n), !0).forEach(function(r) {
      N0(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Y5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function N0(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var GU = {
  // Used only by the directive versions
  html: M(st, !1),
  // Other non-reactive (while open) props are pulled in from BVPopper
  id: M(Q)
}, rC = /* @__PURE__ */ Ot.extend({
  name: fj,
  extends: qU,
  mixins: [Zx],
  props: GU,
  data: function() {
    return {
      title: "",
      content: "",
      variant: null,
      customClass: null,
      interactive: !0
    };
  },
  computed: {
    templateType: function() {
      return "tooltip";
    },
    templateClasses: function() {
      var e, n = this.variant, r = this.attachment, i = this.templateType;
      return [(e = {
        // Disables pointer events to hide the tooltip when the user
        // hovers over its content
        noninteractive: !this.interactive
      }, N0(e, "b-".concat(i, "-").concat(n), n), N0(e, "bs-".concat(i, "-").concat(r), r), e), this.customClass];
    },
    templateAttributes: function() {
      var e = this.id;
      return q5(q5({}, this.$parent.$parent.$attrs), {}, {
        id: e,
        role: "tooltip",
        tabindex: "-1"
      }, this.scopedStyleAttrs);
    },
    templateListeners: function() {
      var e = this;
      return {
        mouseenter: (
          /* istanbul ignore next */
          function(r) {
            e.$emit(j9, r);
          }
        ),
        mouseleave: (
          /* istanbul ignore next */
          function(r) {
            e.$emit(V9, r);
          }
        ),
        focusin: (
          /* istanbul ignore next */
          function(r) {
            e.$emit(F9, r);
          }
        ),
        focusout: (
          /* istanbul ignore next */
          function(r) {
            e.$emit(z9, r);
          }
        )
      };
    }
  },
  methods: {
    renderTemplate: function(e) {
      var n = this.title, r = Me(n) ? n({}) : n, i = this.html && !Me(n) ? {
        innerHTML: n
      } : {};
      return e("div", {
        staticClass: "tooltip b-tooltip",
        class: this.templateClasses,
        attrs: this.templateAttributes,
        on: this.templateListeners
      }, [e("div", {
        staticClass: "arrow",
        ref: "arrow"
      }), e("div", {
        staticClass: "tooltip-inner",
        domProps: i
      }, [r])]);
    }
  }
});
function G5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pg(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? G5(Object(n), !0).forEach(function(r) {
      KU(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : G5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function KU(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var iC = ".modal-content", XU = ki(Ci, wn), ZU = ".b-sidebar", JU = [iC, ZU].join(", "), QU = "dropdown", tY = ".dropdown-menu.show", Yf = "data-original-title", K5 = {
  // Text string or Scoped slot function
  title: "",
  // Text string or Scoped slot function
  content: "",
  // String
  variant: null,
  // String, Array, Object
  customClass: null,
  // String or array of Strings (overwritten by BVPopper)
  triggers: "",
  // String (overwritten by BVPopper)
  placement: "auto",
  // String or array of strings
  fallbackPlacement: "flip",
  // Element or Component reference (or function that returns element) of
  // the element that will have the trigger events bound, and is also
  // default element for positioning
  target: null,
  // HTML ID, Element or Component reference
  container: null,
  // 'body'
  // Boolean
  noFade: !1,
  // 'scrollParent', 'viewport', 'window', Element, or Component reference
  boundary: "scrollParent",
  // Tooltip/popover will try and stay away from
  // boundary edge by this many pixels (Number)
  boundaryPadding: 5,
  // Arrow offset (Number)
  offset: 0,
  // Hover/focus delay (Number or Object)
  delay: 0,
  // Arrow of Tooltip/popover will try and stay away from
  // the edge of tooltip/popover edge by this many pixels
  arrowPadding: 6,
  // Interactive state (Boolean)
  interactive: !0,
  // Disabled state (Boolean)
  disabled: !1,
  // ID to use for tooltip/popover
  id: null,
  // Flag used by directives only, for HTML content
  html: !1
}, F_ = /* @__PURE__ */ Ot.extend({
  name: cj,
  mixins: [Hp],
  data: function() {
    return pg(pg({}, K5), {}, {
      // State management data
      activeTrigger: {
        // manual: false,
        hover: !1,
        click: !1,
        focus: !1
      },
      localShow: !1
    });
  },
  computed: {
    templateType: function() {
      return "tooltip";
    },
    computedId: function() {
      return this.id || "__bv_".concat(this.templateType, "_").concat(this[Ls], "__");
    },
    computedDelay: function() {
      var e = {
        show: 0,
        hide: 0
      };
      return ya(this.delay) ? (e.show = Ni(Qt(this.delay.show, 0), 0), e.hide = Ni(Qt(this.delay.hide, 0), 0)) : (_9(this.delay) || fa(this.delay)) && (e.show = e.hide = Ni(Qt(this.delay, 0), 0)), e;
    },
    computedTriggers: function() {
      return Fr(this.triggers).filter(Vi).join(" ").trim().toLowerCase().split(/\s+/).sort();
    },
    isWithActiveTrigger: function() {
      for (var e in this.activeTrigger)
        if (this.activeTrigger[e])
          return !0;
      return !1;
    },
    computedTemplateData: function() {
      var e = this.title, n = this.content, r = this.variant, i = this.customClass, a = this.noFade, o = this.interactive;
      return {
        title: e,
        content: n,
        variant: r,
        customClass: i,
        noFade: a,
        interactive: o
      };
    }
  },
  watch: {
    computedTriggers: function(e, n) {
      var r = this;
      Ec(e, n) || this.$nextTick(function() {
        r.unListen(), n.forEach(function(i) {
          ln(e, i) || r.activeTrigger[i] && (r.activeTrigger[i] = !1);
        }), r.listen();
      });
    },
    computedTemplateData: function() {
      this.handleTemplateUpdate();
    },
    title: function(e, n) {
      e !== n && !e && this.hide();
    },
    disabled: function(e) {
      e ? this.disable() : this.enable();
    }
  },
  created: function() {
    var e = this;
    this.$_tip = null, this.$_hoverTimeout = null, this.$_hoverState = "", this.$_visibleInterval = null, this.$_enabled = !this.disabled, this.$_noop = OV.bind(this), this.$parent && this.$parent.$once(xj, function() {
      e.$nextTick(function() {
        Nr(function() {
          e.$destroy();
        });
      });
    }), this.$nextTick(function() {
      var n = e.getTarget();
      n && ze(document.body, n) ? (e.scopeId = Gl(e.$parent), e.listen()) : Oc(fa(e.target) ? 'Unable to find target element by ID "#'.concat(e.target, '" in document.') : "The provided target is no valid HTML element.", e.templateType);
    });
  },
  /* istanbul ignore next */
  updated: function() {
    this.$nextTick(this.handleTemplateUpdate);
  },
  /* istanbul ignore next */
  deactivated: function() {
    this.forceHide();
  },
  beforeDestroy: function() {
    this.unListen(), this.setWhileOpenListeners(!1), this.clearHoverTimeout(), this.clearVisibilityInterval(), this.destroyTemplate(), this.$_noop = null;
  },
  methods: {
    // --- Methods for creating and destroying the template ---
    getTemplate: function() {
      return rC;
    },
    updateData: function() {
      var e = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = !1;
      Se(K5).forEach(function(i) {
        !ba(n[i]) && e[i] !== n[i] && (e[i] = n[i], i === "title" && (r = !0));
      }), r && this.localShow && this.fixTitle();
    },
    createTemplateAndShow: function() {
      var e = this.getContainer(), n = this.getTemplate(), r = this.$_tip = new n({
        parent: this,
        // The following is not reactive to changes in the props data
        propsData: {
          // These values cannot be changed while template is showing
          id: this.computedId,
          html: this.html,
          placement: this.placement,
          fallbackPlacement: this.fallbackPlacement,
          target: this.getPlacementTarget(),
          boundary: this.getBoundary(),
          // Ensure the following are integers
          offset: Qt(this.offset, 0),
          arrowPadding: Qt(this.arrowPadding, 0),
          boundaryPadding: Qt(this.boundaryPadding, 0)
        }
      });
      this.handleTemplateUpdate(), r.$once(Cr, this.onTemplateShow), r.$once(Mi, this.onTemplateShown), r.$once(Pi, this.onTemplateHide), r.$once(wn, this.onTemplateHidden), r.$once(q9, this.destroyTemplate), r.$on(F9, this.handleEvent), r.$on(z9, this.handleEvent), r.$on(j9, this.handleEvent), r.$on(V9, this.handleEvent), r.$mount(e.appendChild(document.createElement("div")));
    },
    hideTemplate: function() {
      this.$_tip && this.$_tip.hide(), this.clearActiveTriggers(), this.$_hoverState = "";
    },
    // Destroy the template instance and reset state
    destroyTemplate: function() {
      this.setWhileOpenListeners(!1), this.clearHoverTimeout(), this.$_hoverState = "", this.clearActiveTriggers(), this.localPlacementTarget = null;
      try {
        this.$_tip.$destroy();
      } catch (e) {
      }
      this.$_tip = null, this.removeAriaDescribedby(), this.restoreTitle(), this.localShow = !1;
    },
    getTemplateElement: function() {
      return this.$_tip ? this.$_tip.$el : null;
    },
    handleTemplateUpdate: function() {
      var e = this, n = this.$_tip;
      if (n) {
        var r = ["title", "content", "variant", "customClass", "noFade", "interactive"];
        r.forEach(function(i) {
          n[i] !== e[i] && (n[i] = e[i]);
        });
      }
    },
    // --- Show/Hide handlers ---
    // Show the tooltip
    show: function() {
      var e = this.getTarget();
      if (!(!e || !ze(document.body, e) || !Co(e) || this.dropdownOpen() || (si(this.title) || this.title === "") && (si(this.content) || this.content === "")) && !(this.$_tip || this.localShow)) {
        this.localShow = !0;
        var n = this.buildEvent(Cr, {
          cancelable: !0
        });
        if (this.emitEvent(n), n.defaultPrevented) {
          this.destroyTemplate();
          return;
        }
        this.fixTitle(), this.addAriaDescribedby(), this.createTemplateAndShow();
      }
    },
    hide: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = this.getTemplateElement();
      if (!n || !this.localShow) {
        this.restoreTitle();
        return;
      }
      var r = this.buildEvent(Pi, {
        cancelable: !e
      });
      this.emitEvent(r), !r.defaultPrevented && this.hideTemplate();
    },
    forceHide: function() {
      var e = this.getTemplateElement();
      !e || !this.localShow || (this.setWhileOpenListeners(!1), this.clearHoverTimeout(), this.$_hoverState = "", this.clearActiveTriggers(), this.$_tip && (this.$_tip.noFade = !0), this.hide(!0));
    },
    enable: function() {
      this.$_enabled = !0, this.emitEvent(this.buildEvent(Eh));
    },
    disable: function() {
      this.$_enabled = !1, this.emitEvent(this.buildEvent(Sh));
    },
    // --- Handlers for template events ---
    // When template is inserted into DOM, but not yet shown
    onTemplateShow: function() {
      this.setWhileOpenListeners(!0);
    },
    // When template show transition completes
    onTemplateShown: function() {
      var e = this.$_hoverState;
      this.$_hoverState = "", e === "out" && this.leave(null), this.emitEvent(this.buildEvent(Mi));
    },
    // When template is starting to hide
    onTemplateHide: function() {
      this.setWhileOpenListeners(!1);
    },
    // When template has completed closing (just before it self destructs)
    onTemplateHidden: function() {
      this.destroyTemplate(), this.emitEvent(this.buildEvent(wn));
    },
    // --- Helper methods ---
    getTarget: function() {
      var e = this.target;
      return fa(e) ? e = X4(e.replace(/^#/, "")) : Me(e) ? e = e() : e && (e = e.$el || e), Ee(e) ? e : null;
    },
    getPlacementTarget: function() {
      return this.getTarget();
    },
    getTargetId: function() {
      var e = this.getTarget();
      return e && e.id ? e.id : null;
    },
    getContainer: function() {
      var e = this.container ? this.container.$el || this.container : !1, n = document.body, r = this.getTarget();
      return e === !1 ? sd(JU, r) || n : (
        /*istanbul ignore next */
        fa(e) && /*istanbul ignore next */
        X4(e.replace(/^#/, "")) || n
      );
    },
    getBoundary: function() {
      return this.boundary ? this.boundary.$el || this.boundary : "scrollParent";
    },
    isInModal: function() {
      var e = this.getTarget();
      return e && sd(iC, e);
    },
    isDropdown: function() {
      var e = this.getTarget();
      return e && nx(e, QU);
    },
    dropdownOpen: function() {
      var e = this.getTarget();
      return this.isDropdown() && e && Sc(tY, e);
    },
    clearHoverTimeout: function() {
      clearTimeout(this.$_hoverTimeout), this.$_hoverTimeout = null;
    },
    clearVisibilityInterval: function() {
      clearInterval(this.$_visibleInterval), this.$_visibleInterval = null;
    },
    clearActiveTriggers: function() {
      for (var e in this.activeTrigger)
        this.activeTrigger[e] = !1;
    },
    addAriaDescribedby: function() {
      var e = this.getTarget(), n = ha(e, "aria-describedby") || "";
      n = n.split(/\s+/).concat(this.computedId).join(" ").trim(), Xr(e, "aria-describedby", n);
    },
    removeAriaDescribedby: function() {
      var e = this, n = this.getTarget(), r = ha(n, "aria-describedby") || "";
      r = r.split(/\s+/).filter(function(i) {
        return i !== e.computedId;
      }).join(" ").trim(), r ? Xr(n, "aria-describedby", r) : Il(n, "aria-describedby");
    },
    fixTitle: function() {
      var e = this.getTarget();
      if (Ds(e, "title")) {
        var n = ha(e, "title");
        Xr(e, "title", ""), n && Xr(e, Yf, n);
      }
    },
    restoreTitle: function() {
      var e = this.getTarget();
      if (Ds(e, Yf)) {
        var n = ha(e, Yf);
        Il(e, Yf), n && Xr(e, "title", n);
      }
    },
    // --- BvEvent helpers ---
    buildEvent: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Nc(e, pg({
        cancelable: !1,
        target: this.getTarget(),
        relatedTarget: this.getTemplateElement() || null,
        componentId: this.computedId,
        vueTarget: this
      }, n));
    },
    emitEvent: function(e) {
      var n = e.type;
      this.emitOnRoot(ki(this.templateType, n), e), this.$emit(n, e);
    },
    // --- Event handler setup methods ---
    listen: function() {
      var e = this, n = this.getTarget();
      n && (this.setRootListener(!0), this.computedTriggers.forEach(function(r) {
        r === "click" ? gn(n, "click", e.handleEvent, $e) : r === "focus" ? (gn(n, "focusin", e.handleEvent, $e), gn(n, "focusout", e.handleEvent, $e)) : r === "blur" ? gn(n, "focusout", e.handleEvent, $e) : r === "hover" && (gn(n, "mouseenter", e.handleEvent, $e), gn(n, "mouseleave", e.handleEvent, $e));
      }, this));
    },
    /* istanbul ignore next */
    unListen: function() {
      var e = this, n = ["click", "focusin", "focusout", "mouseenter", "mouseleave"], r = this.getTarget();
      this.setRootListener(!1), n.forEach(function(i) {
        r && zr(r, i, e.handleEvent, $e);
      }, this);
    },
    setRootListener: function(e) {
      var n = this.$root;
      if (n) {
        var r = e ? "$on" : "$off", i = this.templateType;
        n[r](fo(i, Pi), this.doHide), n[r](fo(i, Cr), this.doShow), n[r](fo(i, _0), this.doDisable), n[r](fo(i, b0), this.doEnable);
      }
    },
    setWhileOpenListeners: function(e) {
      this.setModalListener(e), this.setDropdownListener(e), this.visibleCheck(e), this.setOnTouchStartListener(e);
    },
    // Handler for periodic visibility check
    visibleCheck: function(e) {
      var n = this;
      this.clearVisibilityInterval();
      var r = this.getTarget();
      e && (this.$_visibleInterval = setInterval(function() {
        var i = n.getTemplateElement();
        i && n.localShow && (!r.parentNode || !Co(r)) && n.forceHide();
      }, 100));
    },
    setModalListener: function(e) {
      this.isInModal() && this.$root[e ? "$on" : "$off"](XU, this.forceHide);
    },
    /* istanbul ignore next: JSDOM doesn't support `ontouchstart` */
    setOnTouchStartListener: function(e) {
      var n = this;
      "ontouchstart" in document.documentElement && J9(document.body.children).forEach(function(r) {
        w0(e, r, "mouseover", n.$_noop);
      });
    },
    setDropdownListener: function(e) {
      var n = this.getTarget();
      !n || !this.$root || !this.isDropdown || n.__vue__ && n.__vue__[e ? "$on" : "$off"](Mi, this.forceHide);
    },
    // --- Event handlers ---
    handleEvent: function(e) {
      var n = this.getTarget();
      if (!(!n || gl(n) || !this.$_enabled || this.dropdownOpen())) {
        var r = e.type, i = this.computedTriggers;
        if (r === "click" && ln(i, "click"))
          this.click(e);
        else if (r === "mouseenter" && ln(i, "hover"))
          this.enter(e);
        else if (r === "focusin" && ln(i, "focus"))
          this.enter(e);
        else if (r === "focusout" && (ln(i, "focus") || ln(i, "blur")) || r === "mouseleave" && ln(i, "hover")) {
          var a = this.getTemplateElement(), o = e.target, s = e.relatedTarget;
          if (
            // From tip to target
            a && ze(a, o) && ze(n, s) || // From target to tip
            a && ze(n, o) && ze(a, s) || // Within tip
            a && ze(a, o) && ze(a, s) || // Within target
            ze(n, o) && ze(n, s)
          )
            return;
          this.leave(e);
        }
      }
    },
    doHide: function(e) {
      (!e || this.getTargetId() === e || this.computedId === e) && this.forceHide();
    },
    doShow: function(e) {
      (!e || this.getTargetId() === e || this.computedId === e) && this.show();
    },
    /*istanbul ignore next: ignore for now */
    doDisable: function(e) {
      (!e || this.getTargetId() === e || this.computedId === e) && this.disable();
    },
    /*istanbul ignore next: ignore for now */
    doEnable: function(e) {
      (!e || this.getTargetId() === e || this.computedId === e) && this.enable();
    },
    click: function(e) {
      !this.$_enabled || this.dropdownOpen() || (Oe(e.currentTarget), this.activeTrigger.click = !this.activeTrigger.click, this.isWithActiveTrigger ? this.enter(null) : this.leave(null));
    },
    /* istanbul ignore next */
    toggle: function() {
      !this.$_enabled || this.dropdownOpen() || (this.localShow ? this.leave(null) : this.enter(null));
    },
    enter: function() {
      var e = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      if (n && (this.activeTrigger[n.type === "focusin" ? "focus" : "hover"] = !0), this.localShow || this.$_hoverState === "in") {
        this.$_hoverState = "in";
        return;
      }
      this.clearHoverTimeout(), this.$_hoverState = "in", this.computedDelay.show ? (this.fixTitle(), this.$_hoverTimeout = setTimeout(function() {
        e.$_hoverState === "in" ? e.show() : e.localShow || e.restoreTitle();
      }, this.computedDelay.show)) : this.show();
    },
    leave: function() {
      var e = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      n && (this.activeTrigger[n.type === "focusout" ? "focus" : "hover"] = !1, n.type === "focusout" && ln(this.computedTriggers, "blur") && (this.activeTrigger.click = !1, this.activeTrigger.hover = !1)), !this.isWithActiveTrigger && (this.clearHoverTimeout(), this.$_hoverState = "out", this.computedDelay.hide ? this.$_hoverTimeout = setTimeout(function() {
        e.$_hoverState === "out" && e.hide();
      }, this.computedDelay.hide) : this.hide());
    }
  }
}), Nn, Qa;
function X5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eY(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? X5(Object(n), !0).forEach(function(r) {
      Fe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : X5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Fe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Ll = "disabled", Z5 = y_ + Ll, dd = "show", nY = y_ + dd, aC = ue((Nn = {
  // String: scrollParent, window, or viewport
  // Element: element reference
  // Object: Vue component
  boundary: M([ga, Lr, Q], "scrollParent"),
  boundaryPadding: M(Bn, 50),
  // String: HTML ID of container, if null body is used (default)
  // HTMLElement: element reference reference
  // Object: Vue Component
  container: M([ga, Lr, Q]),
  customClass: M(Q),
  delay: M(Sj, 50)
}, Fe(Nn, Ll, M(st, !1)), Fe(Nn, "fallbackPlacement", M(Gs, "flip")), Fe(Nn, "id", M(Q)), Fe(Nn, "noFade", M(st, !1)), Fe(Nn, "noninteractive", M(st, !1)), Fe(Nn, "offset", M(Bn, 0)), Fe(Nn, "placement", M(Q, "top")), Fe(Nn, dd, M(st, !1)), Fe(Nn, "target", M([ga, v9, Dp, Lr, Q], void 0, !0)), Fe(Nn, "title", M(Q)), Fe(Nn, "triggers", M(Gs, "hover focus")), Fe(Nn, "variant", M(Q)), Nn), so), z_ = /* @__PURE__ */ Ot.extend({
  name: so,
  mixins: [Wi],
  inheritAttrs: !1,
  props: aC,
  data: function() {
    return {
      localShow: this[dd],
      localTitle: "",
      localContent: ""
    };
  },
  computed: {
    // Data that will be passed to the template and popper
    templateData: function() {
      return eY({
        title: this.localTitle,
        content: this.localContent,
        interactive: !this.noninteractive
      }, w9(this.$props, ["boundary", "boundaryPadding", "container", "customClass", "delay", "fallbackPlacement", "id", "noFade", "offset", "placement", "target", "target", "triggers", "variant", Ll]));
    },
    // Used to watch for changes to the title and content props
    templateTitleContent: function() {
      var e = this.title, n = this.content;
      return {
        title: e,
        content: n
      };
    }
  },
  watch: (Qa = {}, Fe(Qa, dd, function(t, e) {
    t !== e && t !== this.localShow && this.$_toolpop && (t ? this.$_toolpop.show() : this.$_toolpop.forceHide());
  }), Fe(Qa, Ll, function(t) {
    t ? this.doDisable() : this.doEnable();
  }), Fe(Qa, "localShow", function(e) {
    this.$emit(nY, e);
  }), Fe(Qa, "templateData", function() {
    var e = this;
    this.$nextTick(function() {
      e.$_toolpop && e.$_toolpop.updateData(e.templateData);
    });
  }), Fe(Qa, "templateTitleContent", function() {
    this.$nextTick(this.updateContent);
  }), Qa),
  created: function() {
    this.$_toolpop = null;
  },
  updated: function() {
    this.$nextTick(this.updateContent);
  },
  beforeDestroy: function() {
    this.$off(U4, this.doOpen), this.$off(v0, this.doClose), this.$off(_0, this.doDisable), this.$off(b0, this.doEnable), this.$_toolpop && (this.$_toolpop.$destroy(), this.$_toolpop = null);
  },
  mounted: function() {
    var e = this;
    this.$nextTick(function() {
      var n = e.getComponent();
      e.updateContent();
      var r = Gl(e) || Gl(e.$parent), i = e.$_toolpop = new n({
        parent: e,
        // Pass down the scoped style ID
        _scopeId: r || void 0
      });
      i.updateData(e.templateData), i.$on(Cr, e.onShow), i.$on(Mi, e.onShown), i.$on(Pi, e.onHide), i.$on(wn, e.onHidden), i.$on(Sh, e.onDisabled), i.$on(Eh, e.onEnabled), e[Ll] && e.doDisable(), e.$on(U4, e.doOpen), e.$on(v0, e.doClose), e.$on(_0, e.doDisable), e.$on(b0, e.doEnable), e.localShow && i.show();
    });
  },
  methods: {
    getComponent: function() {
      return F_;
    },
    updateContent: function() {
      this.setTitle(this.normalizeSlot() || this.title);
    },
    // Helper methods for `updateContent()`
    setTitle: function(e) {
      e = si(e) ? "" : e, this.localTitle !== e && (this.localTitle = e);
    },
    setContent: function(e) {
      e = si(e) ? "" : e, this.localContent !== e && (this.localContent = e);
    },
    // --- Template event handlers ---
    onShow: function(e) {
      this.$emit(Cr, e), e && (this.localShow = !e.defaultPrevented);
    },
    onShown: function(e) {
      this.localShow = !0, this.$emit(Mi, e);
    },
    onHide: function(e) {
      this.$emit(Pi, e);
    },
    onHidden: function(e) {
      this.$emit(wn, e), this.localShow = !1;
    },
    onDisabled: function(e) {
      e && e.type === Sh && (this.$emit(Z5, !0), this.$emit(Sh, e));
    },
    onEnabled: function(e) {
      e && e.type === Eh && (this.$emit(Z5, !1), this.$emit(Eh, e));
    },
    // --- Local event listeners ---
    doOpen: function() {
      !this.localShow && this.$_toolpop && this.$_toolpop.show();
    },
    doClose: function() {
      this.localShow && this.$_toolpop && this.$_toolpop.hide();
    },
    doDisable: function() {
      this.$_toolpop && this.$_toolpop.disable();
    },
    doEnable: function() {
      this.$_toolpop && this.$_toolpop.enable();
    }
  },
  render: function(e) {
    return e();
  }
}), rY = /* @__PURE__ */ Ot.extend({
  name: sj,
  extends: rC,
  computed: {
    templateType: function() {
      return "popover";
    }
  },
  methods: {
    renderTemplate: function(e) {
      var n = this.title, r = this.content, i = Me(n) ? n({}) : n, a = Me(r) ? r({}) : r, o = this.html && !Me(n) ? {
        innerHTML: n
      } : {}, s = this.html && !Me(r) ? {
        innerHTML: r
      } : {};
      return e("div", {
        staticClass: "popover b-popover",
        class: this.templateClasses,
        attrs: this.templateAttributes,
        on: this.templateListeners
      }, [e("div", {
        staticClass: "arrow",
        ref: "arrow"
      }), si(i) || i === "" ? (
        /* istanbul ignore next */
        e()
      ) : e("h3", {
        staticClass: "popover-header",
        domProps: o
      }, [i]), si(a) || a === "" ? (
        /* istanbul ignore next */
        e()
      ) : e("div", {
        staticClass: "popover-body",
        domProps: s
      }, [a])]);
    }
  }
}), iY = /* @__PURE__ */ Ot.extend({
  name: oj,
  extends: F_,
  computed: {
    // Overwrites BVTooltip
    templateType: function() {
      return "popover";
    }
  },
  methods: {
    getTemplate: function() {
      return rY;
    }
  }
});
function J5(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Q5(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? J5(Object(n), !0).forEach(function(r) {
      aY(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J5(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function aY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var oY = ue(jn(Q5(Q5({}, aC), {}, {
  content: M(Q),
  placement: M(Q, "right"),
  triggers: M(Gs, wa)
})), I9), oC = /* @__PURE__ */ Ot.extend({
  name: I9,
  extends: z_,
  inheritAttrs: !1,
  props: oY,
  methods: {
    getComponent: function() {
      return iY;
    },
    updateContent: function() {
      this.setContent(this.normalizeSlot() || this.content), this.setTitle(this.normalizeSlot(x_) || this.title);
    }
  }
  // Render function provided by BTooltip
}), sY = function(e, n) {
  return e.map(function(r, i) {
    return [i, r];
  }).sort(function(r, i) {
    return this(r[1], i[1]) || r[0] - i[0];
  }.bind(n)).map(function(r) {
    return r[1];
  });
}, hs;
function t6(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ps(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? t6(Object(n), !0).forEach(function(r) {
      Kr(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : t6(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Kr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var qp = zp("value", {
  type: vo
}), uY = qp.mixin, lY = qp.props, mg = qp.prop, e6 = qp.event, to = function(e) {
  return !e.disabled;
}, cY = /* @__PURE__ */ Ot.extend({
  name: lj,
  inject: {
    bvTabs: {
      default: (
        /* istanbul ignore next */
        function() {
          return {};
        }
      )
    }
  },
  props: {
    controls: M(Q),
    id: M(Q),
    noKeyNav: M(st, !1),
    posInSet: M(vo),
    setSize: M(vo),
    // Reference to the child <b-tab> instance
    tab: M(),
    tabIndex: M(vo)
  },
  methods: {
    focus: function() {
      Oe(this.$refs.link);
    },
    handleEvent: function(e) {
      if (!this.tab.disabled) {
        var n = e.type, r = e.keyCode, i = e.shiftKey;
        n === "click" ? (ke(e), this.$emit(wa, e)) : n === "keydown" && r === Bp ? (ke(e), this.$emit(wa, e)) : n === "keydown" && !this.noKeyNav && ([O_, dx, e5].indexOf(r) !== -1 ? (ke(e), i || r === e5 ? this.$emit(D9, e) : this.$emit(U9, e)) : [ld, px, t5].indexOf(r) !== -1 && (ke(e), i || r === t5 ? this.$emit(H9, e) : this.$emit(W9, e)));
      }
    }
  },
  render: function(e) {
    var n = this.id, r = this.tabIndex, i = this.setSize, a = this.posInSet, o = this.controls, s = this.handleEvent, l = this.tab, c = l.title, h = l.localActive, d = l.disabled, p = l.titleItemClass, g = l.titleLinkClass, v = l.titleLinkAttributes, b = e(Ks, {
      staticClass: "nav-link",
      class: [
        {
          active: h && !d,
          disabled: d
        },
        g,
        // Apply <b-tabs> `activeNavItemClass` styles when the tab is active
        h ? this.bvTabs.activeNavItemClass : null
      ],
      props: {
        disabled: d
      },
      attrs: Ps(Ps({}, v), {}, {
        id: n,
        role: "tab",
        // Roving tab index when keynav enabled
        tabindex: r,
        "aria-selected": h && !d ? "true" : "false",
        "aria-setsize": i,
        "aria-posinset": a,
        "aria-controls": o
      }),
      on: {
        click: s,
        keydown: s
      },
      ref: "link"
    }, [this.tab.normalizeSlot(x_) || c]);
    return e("li", {
      staticClass: "nav-item",
      class: [p],
      attrs: {
        role: "presentation"
      }
    }, [b]);
  }
}), fY = Tu(Qx, ["tabs", "isNavBar", "cardHeader"]), hY = ue(jn(Ps(Ps(Ps(Ps({}, La), lY), fY), {}, {
  // Only applied to the currently active `<b-nav-item>`
  activeNavItemClass: M(fe),
  // Only applied to the currently active `<b-tab>`
  // This prop is sniffed by the `<b-tab>` child
  activeTabClass: M(fe),
  card: M(st, !1),
  contentClass: M(fe),
  // Synonym for 'bottom'
  end: M(st, !1),
  // This prop is sniffed by the `<b-tab>` child
  lazy: M(st, !1),
  navClass: M(fe),
  navWrapperClass: M(fe),
  noFade: M(st, !1),
  noKeyNav: M(st, !1),
  noNavStyle: M(st, !1),
  tag: M(Q, "div")
})), L9), dY = /* @__PURE__ */ Ot.extend({
  name: L9,
  mixins: [Ou, uY, Wi],
  provide: function() {
    return {
      bvTabs: this
    };
  },
  props: hY,
  data: function() {
    return {
      // Index of current tab
      currentTab: Qt(this[mg], -1),
      // Array of direct child `<b-tab>` instances, in DOM order
      tabs: [],
      // Array of child instances registered (for triggering reactive updates)
      registeredTabs: []
    };
  },
  computed: {
    fade: function() {
      return !this.noFade;
    },
    localNavClass: function() {
      var e = [];
      return this.card && this.vertical && e.push("card-header", "h-100", "border-bottom-0", "rounded-0"), [].concat(e, [this.navClass]);
    }
  },
  watch: (hs = {}, Kr(hs, mg, function(t, e) {
    if (t !== e) {
      t = Qt(t, -1), e = Qt(e, 0);
      var n = this.tabs[t];
      n && !n.disabled ? this.activateTab(n) : t < e ? this.previousTab() : this.nextTab();
    }
  }), Kr(hs, "currentTab", function(e) {
    var n = -1;
    this.tabs.forEach(function(r, i) {
      i === e && !r.disabled ? (r.localActive = !0, n = i) : r.localActive = !1;
    }), this.$emit(e6, n);
  }), Kr(hs, "tabs", function(e, n) {
    var r = this;
    Ec(e.map(function(i) {
      return i[Ls];
    }), n.map(function(i) {
      return i[Ls];
    })) || this.$nextTick(function() {
      r.$emit(_j, e.slice(), n.slice());
    });
  }), Kr(hs, "registeredTabs", function() {
    this.updateTabs();
  }), hs),
  created: function() {
    this.$_observer = null;
  },
  mounted: function() {
    this.setObserver(!0);
  },
  beforeDestroy: function() {
    this.setObserver(!1), this.tabs = [];
  },
  methods: {
    registerTab: function(e) {
      ln(this.registeredTabs, e) || this.registeredTabs.push(e);
    },
    unregisterTab: function(e) {
      this.registeredTabs = this.registeredTabs.slice().filter(function(n) {
        return n !== e;
      });
    },
    // DOM observer is needed to detect changes in order of tabs
    setObserver: function() {
      var e = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      if (this.$_observer && this.$_observer.disconnect(), this.$_observer = null, n) {
        var r = function() {
          e.$nextTick(function() {
            Nr(function() {
              e.updateTabs();
            });
          });
        };
        this.$_observer = Cx(this.$refs.content, r, {
          childList: !0,
          subtree: !1,
          attributes: !0,
          attributeFilter: ["id"]
        });
      }
    },
    getTabs: function() {
      var e = this.registeredTabs.filter(function(i) {
        return i.$children.filter(function(a) {
          return a._isTab;
        }).length === 0;
      }), n = [];
      if (Je && e.length > 0) {
        var r = e.map(function(i) {
          return "#".concat(i.safeId());
        }).join(", ");
        n = _o(r, this.$el).map(function(i) {
          return i.id;
        }).filter(Vi);
      }
      return sY(e, function(i, a) {
        return n.indexOf(i.safeId()) - n.indexOf(a.safeId());
      });
    },
    updateTabs: function() {
      var e = this.getTabs(), n = e.indexOf(e.slice().reverse().find(function(i) {
        return i.localActive && !i.disabled;
      }));
      if (n < 0) {
        var r = this.currentTab;
        r >= e.length ? n = e.indexOf(e.slice().reverse().find(to)) : e[r] && !e[r].disabled && (n = r);
      }
      n < 0 && (n = e.indexOf(e.find(to))), e.forEach(function(i, a) {
        i.localActive = a === n;
      }), this.tabs = e, this.currentTab = n;
    },
    // Find a button that controls a tab, given the tab reference
    // Returns the button vm instance
    getButtonForTab: function(e) {
      return (this.$refs.buttons || []).find(function(n) {
        return n.tab === e;
      });
    },
    // Force a button to re-render its content, given a `<b-tab>` instance
    // Called by `<b-tab>` on `update()`
    updateButton: function(e) {
      var n = this.getButtonForTab(e);
      n && n.$forceUpdate && n.$forceUpdate();
    },
    // Activate a tab given a `<b-tab>` instance
    // Also accessed by `<b-tab>`
    activateTab: function(e) {
      var n = this.currentTab, r = this.tabs, i = !1;
      if (e) {
        var a = r.indexOf(e);
        if (a !== n && a > -1 && !e.disabled) {
          var o = new Nc(mj, {
            cancelable: !0,
            vueTarget: this,
            componentId: this.safeId()
          });
          this.$emit(o.type, a, n, o), o.defaultPrevented || (this.currentTab = a, i = !0);
        }
      }
      return !i && this[mg] !== n && this.$emit(e6, n), i;
    },
    // Deactivate a tab given a `<b-tab>` instance
    // Accessed by `<b-tab>`
    deactivateTab: function(e) {
      return e ? this.activateTab(this.tabs.filter(function(n) {
        return n !== e;
      }).find(to)) : !1;
    },
    // Focus a tab button given its `<b-tab>` instance
    focusButton: function(e) {
      var n = this;
      this.$nextTick(function() {
        Oe(n.getButtonForTab(e));
      });
    },
    // Emit a click event on a specified `<b-tab>` component instance
    emitTabClick: function(e, n) {
      Ip(n) && e && e.$emit && !e.disabled && e.$emit(wa, n);
    },
    // Click handler
    clickTab: function(e, n) {
      this.activateTab(e), this.emitTabClick(e, n);
    },
    // Move to first non-disabled tab
    firstTab: function(e) {
      var n = this.tabs.find(to);
      this.activateTab(n) && e && (this.focusButton(n), this.emitTabClick(n, e));
    },
    // Move to previous non-disabled tab
    previousTab: function(e) {
      var n = Ni(this.currentTab, 0), r = this.tabs.slice(0, n).reverse().find(to);
      this.activateTab(r) && e && (this.focusButton(r), this.emitTabClick(r, e));
    },
    // Move to next non-disabled tab
    nextTab: function(e) {
      var n = Ni(this.currentTab, -1), r = this.tabs.slice(n + 1).find(to);
      this.activateTab(r) && e && (this.focusButton(r), this.emitTabClick(r, e));
    },
    // Move to last non-disabled tab
    lastTab: function(e) {
      var n = this.tabs.slice().reverse().find(to);
      this.activateTab(n) && e && (this.focusButton(n), this.emitTabClick(n, e));
    }
  },
  render: function(e) {
    var n = this, r = this.align, i = this.card, a = this.end, o = this.fill, s = this.firstTab, l = this.justified, c = this.lastTab, h = this.nextTab, d = this.noKeyNav, p = this.noNavStyle, g = this.pills, v = this.previousTab, b = this.small, _ = this.tabs, w = this.vertical, x = _.find(function(W) {
      return W.localActive && !W.disabled;
    }), C = _.find(function(W) {
      return !W.disabled;
    }), $ = _.map(function(W, P) {
      var k, Y = W.safeId, V = null;
      return d || (V = -1, (W === x || !x && W === C) && (V = null)), e(cY, {
        props: {
          controls: Y ? Y() : null,
          id: W.controlledBy || (Y ? Y("_BV_tab_button_") : null),
          noKeyNav: d,
          posInSet: P + 1,
          setSize: _.length,
          tab: W,
          tabIndex: V
        },
        on: (k = {}, Kr(k, wa, function(I) {
          n.clickTab(W, I);
        }), Kr(k, D9, s), Kr(k, U9, v), Kr(k, W9, h), Kr(k, H9, c), k),
        key: W[Ls] || P,
        ref: "buttons",
        // Needed to make `this.$refs.buttons` an array
        refInFor: !0
      });
    }), E = e(SU, {
      class: this.localNavClass,
      attrs: {
        role: "tablist",
        id: this.safeId("_BV_tab_controls_")
      },
      props: {
        fill: o,
        justified: l,
        align: r,
        tabs: !p && !g,
        pills: !p && g,
        vertical: w,
        small: b,
        cardHeader: i && !w
      },
      ref: "nav"
    }, [this.normalizeSlot(Hj) || e(), $, this.normalizeSlot(Bj) || e()]);
    E = e("div", {
      class: [{
        "card-header": i && !w && !a,
        "card-footer": i && !w && a,
        "col-auto": w
      }, this.navWrapperClass],
      key: "bv-tabs-nav"
    }, [E]);
    var A = this.normalizeSlot() || [], R = e();
    A.length === 0 && (R = e("div", {
      class: ["tab-pane", "active", {
        "card-body": i
      }],
      key: "bv-empty-tab"
    }, this.normalizeSlot(Pj)));
    var L = e("div", {
      staticClass: "tab-content",
      class: [{
        col: w
      }, this.contentClass],
      attrs: {
        id: this.safeId("_BV_tab_container_")
      },
      key: "bv-content",
      ref: "content"
    }, [A, R]);
    return e(this.tag, {
      staticClass: "tabs",
      class: {
        row: w,
        "no-gutters": w && i
      },
      attrs: {
        id: this.safeId()
      }
    }, [a ? L : e(), E, a ? e() : L]);
  }
}), pr, il;
function n6(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function r6(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? n6(Object(n), !0).forEach(function(r) {
      Ln(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : n6(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Ln(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var pd = "active", i6 = y_ + pd, pY = ue(jn(r6(r6({}, La), {}, (pr = {}, Ln(pr, pd, M(st, !1)), Ln(pr, "buttonId", M(Q)), Ln(pr, "disabled", M(st, !1)), Ln(pr, "lazy", M(st, !1)), Ln(pr, "noBody", M(st, !1)), Ln(pr, "tag", M(Q, "div")), Ln(pr, "title", M(Q)), Ln(pr, "titleItemClass", M(fe)), Ln(pr, "titleLinkAttributes", M(Lr)), Ln(pr, "titleLinkClass", M(fe)), pr))), R9), mY = /* @__PURE__ */ Ot.extend({
  name: R9,
  mixins: [Ou, Wi],
  inject: {
    bvTabs: {
      default: function() {
        return {};
      }
    }
  },
  props: pY,
  data: function() {
    return {
      localActive: this[pd] && !this.disabled
    };
  },
  computed: {
    // For parent sniffing of child
    _isTab: function() {
      return !0;
    },
    tabClasses: function() {
      var e = this.localActive, n = this.disabled;
      return [
        {
          active: e,
          disabled: n,
          "card-body": this.bvTabs.card && !this.noBody
        },
        // Apply <b-tabs> `activeTabClass` styles when this tab is active
        e ? this.bvTabs.activeTabClass : null
      ];
    },
    controlledBy: function() {
      return this.buttonId || this.safeId("__BV_tab_button__");
    },
    computedNoFade: function() {
      return !this.bvTabs.fade;
    },
    computedLazy: function() {
      return this.bvTabs.lazy || this.lazy;
    }
  },
  watch: (il = {}, Ln(il, pd, function(t, e) {
    t !== e && (t ? this.activate() : this.deactivate() || this.$emit(i6, this.localActive));
  }), Ln(il, "disabled", function(e, n) {
    if (e !== n) {
      var r = this.bvTabs.firstTab;
      e && this.localActive && r && (this.localActive = !1, r());
    }
  }), Ln(il, "localActive", function(e) {
    this.$emit(i6, e);
  }), il),
  mounted: function() {
    this.registerTab();
  },
  updated: function() {
    var e = this.bvTabs.updateButton;
    e && this.hasNormalizedSlot(x_) && e(this);
  },
  beforeDestroy: function() {
    this.unregisterTab();
  },
  methods: {
    // Private methods
    registerTab: function() {
      var e = this.bvTabs.registerTab;
      e && e(this);
    },
    unregisterTab: function() {
      var e = this.bvTabs.unregisterTab;
      e && e(this);
    },
    // Public methods
    activate: function() {
      var e = this.bvTabs.activateTab;
      return e && !this.disabled ? e(this) : !1;
    },
    deactivate: function() {
      var e = this.bvTabs.deactivateTab;
      return e && this.localActive ? e(this) : !1;
    }
  },
  render: function(e) {
    var n = this.localActive, r = e(
      this.tag,
      {
        staticClass: "tab-pane",
        class: this.tabClasses,
        directives: [{
          name: "show",
          value: n
        }],
        attrs: {
          role: "tabpanel",
          id: this.safeId(),
          "aria-hidden": n ? "false" : "true",
          "aria-labelledby": this.controlledBy || null
        },
        ref: "panel"
      },
      // Render content lazily if requested
      [n || !this.computedLazy ? this.normalizeSlot() : e()]
    );
    return e(T_, {
      props: {
        mode: "out-in",
        noFade: this.computedNoFade
      }
    }, [r]);
  }
});
function a6(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o6(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? a6(Object(n), !0).forEach(function(r) {
      gY(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a6(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function gY(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var vr = "__BV_Tooltip__", vY = "hover focus", s6 = {
  focus: !0,
  hover: !0,
  click: !0,
  blur: !0,
  manual: !0
}, _Y = /^html$/i, bY = /^noninteractive$/i, yY = /^nofade$/i, wY = /^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/i, xY = /^(window|viewport|scrollParent)$/i, CY = /^d\d+$/i, $Y = /^ds\d+$/i, TY = /^dh\d+$/i, OY = /^o-?\d+$/i, SY = /^v-.+$/i, EY = /\s+/, AY = function(e, n) {
  var r = {
    title: void 0,
    trigger: "",
    // Default set below if needed
    placement: "top",
    fallbackPlacement: "flip",
    container: !1,
    // Default of body
    animation: !0,
    offset: 0,
    id: null,
    html: !1,
    interactive: !0,
    disabled: !1,
    delay: Ts(so, "delay", 50),
    boundary: String(Ts(so, "boundary", "scrollParent")),
    boundaryPadding: Qt(Ts(so, "boundaryPadding", 5), 0),
    variant: Ts(so, "variant"),
    customClass: Ts(so, "customClass")
  };
  if (fa(e.value) || _9(e.value) || Me(e.value) ? r.title = e.value : ya(e.value) && (r = o6(o6({}, r), e.value)), ba(r.title)) {
    var i = n.data || {};
    r.title = i.attrs && !si(i.attrs.title) ? i.attrs.title : void 0;
  }
  ya(r.delay) || (r.delay = {
    show: Qt(r.delay, 0),
    hide: Qt(r.delay, 0)
  }), e.arg && (r.container = "#".concat(e.arg)), Se(e.modifiers).forEach(function(o) {
    if (_Y.test(o))
      r.html = !0;
    else if (bY.test(o))
      r.interactive = !1;
    else if (yY.test(o))
      r.animation = !1;
    else if (wY.test(o))
      r.placement = o;
    else if (xY.test(o))
      o = o === "scrollparent" ? "scrollParent" : o, r.boundary = o;
    else if (CY.test(o)) {
      var s = Qt(o.slice(1), 0);
      r.delay.show = s, r.delay.hide = s;
    } else
      $Y.test(o) ? r.delay.show = Qt(o.slice(2), 0) : TY.test(o) ? r.delay.hide = Qt(o.slice(2), 0) : OY.test(o) ? r.offset = Qt(o.slice(1), 0) : SY.test(o) && (r.variant = o.slice(2) || null);
  });
  var a = {};
  return Fr(r.trigger || "").filter(Vi).join(" ").trim().toLowerCase().split(EY).forEach(function(o) {
    s6[o] && (a[o] = !0);
  }), Se(e.modifiers).forEach(function(o) {
    o = o.toLowerCase(), s6[o] && (a[o] = !0);
  }), r.trigger = Se(a).join(" "), r.trigger === "blur" && (r.trigger = "focus"), r.trigger || (r.trigger = vY), r;
}, u6 = function(e, n, r) {
  if (Je) {
    var i = AY(n, r);
    if (!e[vr]) {
      var a = r.context;
      e[vr] = new F_({
        parent: a,
        // Add the parent's scoped style attribute data
        _scopeId: Gl(a, void 0)
      }), e[vr].__bv_prev_data__ = {}, e[vr].$on(Cr, function() {
        Me(i.title) && e[vr].updateData({
          title: i.title(e)
        });
      });
    }
    var o = {
      title: i.title,
      triggers: i.trigger,
      placement: i.placement,
      fallbackPlacement: i.fallbackPlacement,
      variant: i.variant,
      customClass: i.customClass,
      container: i.container,
      boundary: i.boundary,
      delay: i.delay,
      offset: i.offset,
      noFade: !i.animation,
      id: i.id,
      interactive: i.interactive,
      disabled: i.disabled,
      html: i.html
    }, s = e[vr].__bv_prev_data__;
    if (e[vr].__bv_prev_data__ = o, !Ec(o, s)) {
      var l = {
        target: e
      };
      Se(o).forEach(function(c) {
        o[c] !== s[c] && (l[c] = c === "title" && Me(o[c]) ? o[c](e) : o[c]);
      }), e[vr].updateData(l);
    }
  }
}, PY = function(e) {
  e[vr] && (e[vr].$destroy(), e[vr] = null), delete e[vr];
}, MY = {
  bind: function(e, n, r) {
    u6(e, n, r);
  },
  // We use `componentUpdated` here instead of `update`, as the former
  // waits until the containing component and children have finished updating
  componentUpdated: function(e, n, r) {
    r.context.$nextTick(function() {
      u6(e, n, r);
    });
  },
  unbind: function(e) {
    PY(e);
  }
};
function l6(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? l6(Object(n), !0).forEach(function(r) {
      Re(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l6(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function md(t) {
  return md = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, md(t);
}
function kY(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function c6(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function NY(t, e, n) {
  return e && c6(t.prototype, e), n && c6(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Re(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function B_(t, e) {
  return RY(t) || DY(t, e) || sC(t, e) || zY();
}
function Ic(t) {
  return IY(t) || LY(t) || sC(t) || FY();
}
function IY(t) {
  if (Array.isArray(t))
    return I0(t);
}
function RY(t) {
  if (Array.isArray(t))
    return t;
}
function LY(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function DY(t, e) {
  var n = t == null ? null : typeof Symbol != "undefined" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(t); !(i = (o = n.next()).done) && (r.push(o.value), !(e && r.length === e)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return r;
  }
}
function sC(t, e) {
  if (t) {
    if (typeof t == "string")
      return I0(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return I0(t, e);
  }
}
function I0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function FY() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var f6 = function() {
}, H_ = {}, uC = {}, lC = null, cC = {
  mark: f6,
  measure: f6
};
try {
  typeof window != "undefined" && (H_ = window), typeof document != "undefined" && (uC = document), typeof MutationObserver != "undefined" && (lC = MutationObserver), typeof performance != "undefined" && (cC = performance);
} catch (t) {
}
var BY = H_.navigator || {}, h6 = BY.userAgent, d6 = h6 === void 0 ? "" : h6, Ca = H_, se = uC, p6 = lC, qf = cC;
Ca.document;
var Ui = !!se.documentElement && !!se.head && typeof se.addEventListener == "function" && typeof se.createElement == "function", fC = ~d6.indexOf("MSIE") || ~d6.indexOf("Trident/"), Gf, Kf, Xf, Zf, Jf, Li = "___FONT_AWESOME___", R0 = 16, hC = "fa", dC = "svg-inline--fa", $o = "data-fa-i2svg", L0 = "data-fa-pseudo-element", HY = "data-fa-pseudo-element-pending", j_ = "data-prefix", V_ = "data-icon", m6 = "fontawesome-i2svg", jY = "async", VY = ["HTML", "HEAD", "STYLE", "SCRIPT"], pC = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch (t) {
    return !1;
  }
}(), oe = "classic", ye = "sharp", W_ = [oe, ye];
function Rc(t) {
  return new Proxy(t, {
    get: function(n, r) {
      return r in n ? n[r] : n[oe];
    }
  });
}
var Kl = Rc((Gf = {}, Re(Gf, oe, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit"
}), Re(Gf, ye, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light"
}), Gf)), Xl = Rc((Kf = {}, Re(Kf, oe, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Re(Kf, ye, {
  solid: "fass",
  regular: "fasr",
  light: "fasl"
}), Kf)), Zl = Rc((Xf = {}, Re(Xf, oe, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Re(Xf, ye, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light"
}), Xf)), WY = Rc((Zf = {}, Re(Zf, oe, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Re(Zf, ye, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl"
}), Zf)), UY = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/, mC = "fa-layers-text", YY = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, qY = Rc((Jf = {}, Re(Jf, oe, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Re(Jf, ye, {
  900: "fass",
  400: "fasr",
  300: "fasl"
}), Jf)), gC = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], GY = gC.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), KY = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], ho = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Jl = /* @__PURE__ */ new Set();
Object.keys(Xl[oe]).map(Jl.add.bind(Jl));
Object.keys(Xl[ye]).map(Jl.add.bind(Jl));
var XY = [].concat(W_, Ic(Jl), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", ho.GROUP, ho.SWAP_OPACITY, ho.PRIMARY, ho.SECONDARY]).concat(gC.map(function(t) {
  return "".concat(t, "x");
})).concat(GY.map(function(t) {
  return "w-".concat(t);
})), Dl = Ca.FontAwesomeConfig || {};
function ZY(t) {
  var e = se.querySelector("script[" + t + "]");
  if (e)
    return e.getAttribute(t);
}
function JY(t) {
  return t === "" ? !0 : t === "false" ? !1 : t === "true" ? !0 : t;
}
if (se && typeof se.querySelector == "function") {
  var QY = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  QY.forEach(function(t) {
    var e = B_(t, 2), n = e[0], r = e[1], i = JY(ZY(n));
    i != null && (Dl[r] = i);
  });
}
var vC = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: hC,
  replacementClass: dC,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Dl.familyPrefix && (Dl.cssPrefix = Dl.familyPrefix);
var tu = mt(mt({}, vC), Dl);
tu.autoReplaceSvg || (tu.observeMutations = !1);
var _t = {};
Object.keys(vC).forEach(function(t) {
  Object.defineProperty(_t, t, {
    enumerable: !0,
    set: function(n) {
      tu[t] = n, Fl.forEach(function(r) {
        return r(_t);
      });
    },
    get: function() {
      return tu[t];
    }
  });
});
Object.defineProperty(_t, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    tu.cssPrefix = e, Fl.forEach(function(n) {
      return n(_t);
    });
  },
  get: function() {
    return tu.cssPrefix;
  }
});
Ca.FontAwesomeConfig = _t;
var Fl = [];
function tq(t) {
  return Fl.push(t), function() {
    Fl.splice(Fl.indexOf(t), 1);
  };
}
var ra = R0, ti = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function eq(t) {
  if (!(!t || !Ui)) {
    var e = se.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = t;
    for (var n = se.head.childNodes, r = null, i = n.length - 1; i > -1; i--) {
      var a = n[i], o = (a.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (r = a);
    }
    return se.head.insertBefore(e, r), t;
  }
}
var nq = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Ql() {
  for (var t = 12, e = ""; t-- > 0; )
    e += nq[Math.random() * 62 | 0];
  return e;
}
function Eu(t) {
  for (var e = [], n = (t || []).length >>> 0; n--; )
    e[n] = t[n];
  return e;
}
function U_(t) {
  return t.classList ? Eu(t.classList) : (t.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function _C(t) {
  return "".concat(t).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function rq(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e + "".concat(n, '="').concat(_C(t[n]), '" ');
  }, "").trim();
}
function Gp(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e + "".concat(n, ": ").concat(t[n].trim(), ";");
  }, "");
}
function Y_(t) {
  return t.size !== ti.size || t.x !== ti.x || t.y !== ti.y || t.rotate !== ti.rotate || t.flipX || t.flipY;
}
function iq(t) {
  var e = t.transform, n = t.containerWidth, r = t.iconWidth, i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, a = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), o = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), s = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(a, " ").concat(o, " ").concat(s)
  }, c = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: c
  };
}
function aq(t) {
  var e = t.transform, n = t.width, r = n === void 0 ? R0 : n, i = t.height, a = i === void 0 ? R0 : i, o = t.startCentered, s = o === void 0 ? !1 : o, l = "";
  return s && fC ? l += "translate(".concat(e.x / ra - r / 2, "em, ").concat(e.y / ra - a / 2, "em) ") : s ? l += "translate(calc(-50% + ".concat(e.x / ra, "em), calc(-50% + ").concat(e.y / ra, "em)) ") : l += "translate(".concat(e.x / ra, "em, ").concat(e.y / ra, "em) "), l += "scale(".concat(e.size / ra * (e.flipX ? -1 : 1), ", ").concat(e.size / ra * (e.flipY ? -1 : 1), ") "), l += "rotate(".concat(e.rotate, "deg) "), l;
}
var oq = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function bC() {
  var t = hC, e = dC, n = _t.cssPrefix, r = _t.replacementClass, i = oq;
  if (n !== t || r !== e) {
    var a = new RegExp("\\.".concat(t, "\\-"), "g"), o = new RegExp("\\--".concat(t, "\\-"), "g"), s = new RegExp("\\.".concat(e), "g");
    i = i.replace(a, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
var g6 = !1;
function gg() {
  _t.autoAddCss && !g6 && (eq(bC()), g6 = !0);
}
var sq = {
  mixout: function() {
    return {
      dom: {
        css: bC,
        insertCss: gg
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        gg();
      },
      beforeI2svg: function() {
        gg();
      }
    };
  }
}, Di = Ca || {};
Di[Li] || (Di[Li] = {});
Di[Li].styles || (Di[Li].styles = {});
Di[Li].hooks || (Di[Li].hooks = {});
Di[Li].shims || (Di[Li].shims = []);
var Ir = Di[Li], yC = [], uq = function t() {
  se.removeEventListener("DOMContentLoaded", t), gd = 1, yC.map(function(e) {
    return e();
  });
}, gd = !1;
Ui && (gd = (se.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(se.readyState), gd || se.addEventListener("DOMContentLoaded", uq));
function lq(t) {
  Ui && (gd ? setTimeout(t, 0) : yC.push(t));
}
function Lc(t) {
  var e = t.tag, n = t.attributes, r = n === void 0 ? {} : n, i = t.children, a = i === void 0 ? [] : i;
  return typeof t == "string" ? _C(t) : "<".concat(e, " ").concat(rq(r), ">").concat(a.map(Lc).join(""), "</").concat(e, ">");
}
function v6(t, e, n) {
  if (t && t[e] && t[e][n])
    return {
      prefix: e,
      iconName: n,
      icon: t[e][n]
    };
}
var cq = function(e, n) {
  return function(r, i, a, o) {
    return e.call(n, r, i, a, o);
  };
}, vg = function(e, n, r, i) {
  var a = Object.keys(e), o = a.length, s = i !== void 0 ? cq(n, i) : n, l, c, h;
  for (r === void 0 ? (l = 1, h = e[a[0]]) : (l = 0, h = r); l < o; l++)
    c = a[l], h = s(h, e[c], c, e);
  return h;
};
function fq(t) {
  for (var e = [], n = 0, r = t.length; n < r; ) {
    var i = t.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      var a = t.charCodeAt(n++);
      (a & 64512) == 56320 ? e.push(((i & 1023) << 10) + (a & 1023) + 65536) : (e.push(i), n--);
    } else
      e.push(i);
  }
  return e;
}
function D0(t) {
  var e = fq(t);
  return e.length === 1 ? e[0].toString(16) : null;
}
function hq(t, e) {
  var n = t.length, r = t.charCodeAt(e), i;
  return r >= 55296 && r <= 56319 && n > e + 1 && (i = t.charCodeAt(e + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function _6(t) {
  return Object.keys(t).reduce(function(e, n) {
    var r = t[n], i = !!r.icon;
    return i ? e[r.iconName] = r.icon : e[n] = r, e;
  }, {});
}
function F0(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, i = r === void 0 ? !1 : r, a = _6(e);
  typeof Ir.hooks.addPack == "function" && !i ? Ir.hooks.addPack(t, _6(e)) : Ir.styles[t] = mt(mt({}, Ir.styles[t] || {}), a), t === "fas" && F0("fa", e);
}
var Qf, th, eh, Ms = Ir.styles, dq = Ir.shims, pq = (Qf = {}, Re(Qf, oe, Object.values(Zl[oe])), Re(Qf, ye, Object.values(Zl[ye])), Qf), q_ = null, wC = {}, xC = {}, CC = {}, $C = {}, TC = {}, mq = (th = {}, Re(th, oe, Object.keys(Kl[oe])), Re(th, ye, Object.keys(Kl[ye])), th);
function gq(t) {
  return ~XY.indexOf(t);
}
function vq(t, e) {
  var n = e.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === t && i !== "" && !gq(i) ? i : null;
}
var OC = function() {
  var e = function(a) {
    return vg(Ms, function(o, s, l) {
      return o[l] = vg(s, a, {}), o;
    }, {});
  };
  wC = e(function(i, a, o) {
    if (a[3] && (i[a[3]] = o), a[2]) {
      var s = a[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        i[l.toString(16)] = o;
      });
    }
    return i;
  }), xC = e(function(i, a, o) {
    if (i[o] = o, a[2]) {
      var s = a[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        i[l] = o;
      });
    }
    return i;
  }), TC = e(function(i, a, o) {
    var s = a[2];
    return i[o] = o, s.forEach(function(l) {
      i[l] = o;
    }), i;
  });
  var n = "far" in Ms || _t.autoFetchSvg, r = vg(dq, function(i, a) {
    var o = a[0], s = a[1], l = a[2];
    return s === "far" && !n && (s = "fas"), typeof o == "string" && (i.names[o] = {
      prefix: s,
      iconName: l
    }), typeof o == "number" && (i.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: l
    }), i;
  }, {
    names: {},
    unicodes: {}
  });
  CC = r.names, $C = r.unicodes, q_ = Kp(_t.styleDefault, {
    family: _t.familyDefault
  });
};
tq(function(t) {
  q_ = Kp(t.styleDefault, {
    family: _t.familyDefault
  });
});
OC();
function G_(t, e) {
  return (wC[t] || {})[e];
}
function _q(t, e) {
  return (xC[t] || {})[e];
}
function po(t, e) {
  return (TC[t] || {})[e];
}
function SC(t) {
  return CC[t] || {
    prefix: null,
    iconName: null
  };
}
function bq(t) {
  var e = $C[t], n = G_("fas", t);
  return e || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function $a() {
  return q_;
}
var K_ = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function Kp(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.family, r = n === void 0 ? oe : n, i = Kl[r][t], a = Xl[r][t] || Xl[r][i], o = t in Ir.styles ? t : null;
  return a || o || null;
}
var b6 = (eh = {}, Re(eh, oe, Object.keys(Zl[oe])), Re(eh, ye, Object.keys(Zl[ye])), eh);
function Xp(t) {
  var e, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.skipLookups, i = r === void 0 ? !1 : r, a = (e = {}, Re(e, oe, "".concat(_t.cssPrefix, "-").concat(oe)), Re(e, ye, "".concat(_t.cssPrefix, "-").concat(ye)), e), o = null, s = oe;
  (t.includes(a[oe]) || t.some(function(c) {
    return b6[oe].includes(c);
  })) && (s = oe), (t.includes(a[ye]) || t.some(function(c) {
    return b6[ye].includes(c);
  })) && (s = ye);
  var l = t.reduce(function(c, h) {
    var d = vq(_t.cssPrefix, h);
    if (Ms[h] ? (h = pq[s].includes(h) ? WY[s][h] : h, o = h, c.prefix = h) : mq[s].indexOf(h) > -1 ? (o = h, c.prefix = Kp(h, {
      family: s
    })) : d ? c.iconName = d : h !== _t.replacementClass && h !== a[oe] && h !== a[ye] && c.rest.push(h), !i && c.prefix && c.iconName) {
      var p = o === "fa" ? SC(c.iconName) : {}, g = po(c.prefix, c.iconName);
      p.prefix && (o = null), c.iconName = p.iconName || g || c.iconName, c.prefix = p.prefix || c.prefix, c.prefix === "far" && !Ms.far && Ms.fas && !_t.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, K_());
  return (t.includes("fa-brands") || t.includes("fab")) && (l.prefix = "fab"), (t.includes("fa-duotone") || t.includes("fad")) && (l.prefix = "fad"), !l.prefix && s === ye && (Ms.fass || _t.autoFetchSvg) && (l.prefix = "fass", l.iconName = po(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || o === "fa") && (l.prefix = $a() || "fas"), l;
}
var yq = /* @__PURE__ */ function() {
  function t() {
    kY(this, t), this.definitions = {};
  }
  return NY(t, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, i = new Array(r), a = 0; a < r; a++)
        i[a] = arguments[a];
      var o = i.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        n.definitions[s] = mt(mt({}, n.definitions[s] || {}), o[s]), F0(s, o[s]);
        var l = Zl[oe][s];
        l && F0(l, o[s]), OC();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var i = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(i).map(function(a) {
        var o = i[a], s = o.prefix, l = o.iconName, c = o.icon, h = c[2];
        n[s] || (n[s] = {}), h.length > 0 && h.forEach(function(d) {
          typeof d == "string" && (n[s][d] = c);
        }), n[s][l] = c;
      }), n;
    }
  }]), t;
}(), y6 = [], ks = {}, zs = {}, wq = Object.keys(zs);
function xq(t, e) {
  var n = e.mixoutsTo;
  return y6 = t, ks = {}, Object.keys(zs).forEach(function(r) {
    wq.indexOf(r) === -1 && delete zs[r];
  }), y6.forEach(function(r) {
    var i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach(function(o) {
      typeof i[o] == "function" && (n[o] = i[o]), md(i[o]) === "object" && Object.keys(i[o]).forEach(function(s) {
        n[o] || (n[o] = {}), n[o][s] = i[o][s];
      });
    }), r.hooks) {
      var a = r.hooks();
      Object.keys(a).forEach(function(o) {
        ks[o] || (ks[o] = []), ks[o].push(a[o]);
      });
    }
    r.provides && r.provides(zs);
  }), n;
}
function z0(t, e) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var a = ks[t] || [];
  return a.forEach(function(o) {
    e = o.apply(null, [e].concat(r));
  }), e;
}
function To(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  var i = ks[t] || [];
  i.forEach(function(a) {
    a.apply(null, n);
  });
}
function Fi() {
  var t = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return zs[t] ? zs[t].apply(null, e) : void 0;
}
function B0(t) {
  t.prefix === "fa" && (t.prefix = "fas");
  var e = t.iconName, n = t.prefix || $a();
  if (e)
    return e = po(n, e) || e, v6(EC.definitions, n, e) || v6(Ir.styles, n, e);
}
var EC = new yq(), Cq = function() {
  _t.autoReplaceSvg = !1, _t.observeMutations = !1, To("noAuto");
}, $q = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Ui ? (To("beforeI2svg", e), Fi("pseudoElements2svg", e), Fi("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot;
    _t.autoReplaceSvg === !1 && (_t.autoReplaceSvg = !0), _t.observeMutations = !0, lq(function() {
      Oq({
        autoReplaceSvgRoot: n
      }), To("watch", e);
    });
  }
}, Tq = {
  icon: function(e) {
    if (e === null)
      return null;
    if (md(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: po(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var n = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], r = Kp(e[0]);
      return {
        prefix: r,
        iconName: po(r, n) || n
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(_t.cssPrefix, "-")) > -1 || e.match(UY))) {
      var i = Xp(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: i.prefix || $a(),
        iconName: po(i.prefix, i.iconName) || i.iconName
      };
    }
    if (typeof e == "string") {
      var a = $a();
      return {
        prefix: a,
        iconName: po(a, e) || e
      };
    }
  }
}, ir = {
  noAuto: Cq,
  config: _t,
  dom: $q,
  parse: Tq,
  library: EC,
  findIconDefinition: B0,
  toHtml: Lc
}, Oq = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot, r = n === void 0 ? se : n;
  (Object.keys(Ir.styles).length > 0 || _t.autoFetchSvg) && Ui && _t.autoReplaceSvg && ir.dom.i2svg({
    node: r
  });
};
function Zp(t, e) {
  return Object.defineProperty(t, "abstract", {
    get: e
  }), Object.defineProperty(t, "html", {
    get: function() {
      return t.abstract.map(function(r) {
        return Lc(r);
      });
    }
  }), Object.defineProperty(t, "node", {
    get: function() {
      if (Ui) {
        var r = se.createElement("div");
        return r.innerHTML = t.html, r.children;
      }
    }
  }), t;
}
function Sq(t) {
  var e = t.children, n = t.main, r = t.mask, i = t.attributes, a = t.styles, o = t.transform;
  if (Y_(o) && n.found && !r.found) {
    var s = n.width, l = n.height, c = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = Gp(mt(mt({}, a), {}, {
      "transform-origin": "".concat(c.x + o.x / 16, "em ").concat(c.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: e
  }];
}
function Eq(t) {
  var e = t.prefix, n = t.iconName, r = t.children, i = t.attributes, a = t.symbol, o = a === !0 ? "".concat(e, "-").concat(_t.cssPrefix, "-").concat(n) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: mt(mt({}, i), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function X_(t) {
  var e = t.icons, n = e.main, r = e.mask, i = t.prefix, a = t.iconName, o = t.transform, s = t.symbol, l = t.title, c = t.maskId, h = t.titleId, d = t.extra, p = t.watchable, g = p === void 0 ? !1 : p, v = r.found ? r : n, b = v.width, _ = v.height, w = i === "fak", x = [_t.replacementClass, a ? "".concat(_t.cssPrefix, "-").concat(a) : ""].filter(function(W) {
    return d.classes.indexOf(W) === -1;
  }).filter(function(W) {
    return W !== "" || !!W;
  }).concat(d.classes).join(" "), C = {
    children: [],
    attributes: mt(mt({}, d.attributes), {}, {
      "data-prefix": i,
      "data-icon": a,
      class: x,
      role: d.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(b, " ").concat(_)
    })
  }, $ = w && !~d.classes.indexOf("fa-fw") ? {
    width: "".concat(b / _ * 16 * 0.0625, "em")
  } : {};
  g && (C.attributes[$o] = ""), l && (C.children.push({
    tag: "title",
    attributes: {
      id: C.attributes["aria-labelledby"] || "title-".concat(h || Ql())
    },
    children: [l]
  }), delete C.attributes.title);
  var E = mt(mt({}, C), {}, {
    prefix: i,
    iconName: a,
    main: n,
    mask: r,
    maskId: c,
    transform: o,
    symbol: s,
    styles: mt(mt({}, $), d.styles)
  }), A = r.found && n.found ? Fi("generateAbstractMask", E) || {
    children: [],
    attributes: {}
  } : Fi("generateAbstractIcon", E) || {
    children: [],
    attributes: {}
  }, R = A.children, L = A.attributes;
  return E.children = R, E.attributes = L, s ? Eq(E) : Sq(E);
}
function w6(t) {
  var e = t.content, n = t.width, r = t.height, i = t.transform, a = t.title, o = t.extra, s = t.watchable, l = s === void 0 ? !1 : s, c = mt(mt(mt({}, o.attributes), a ? {
    title: a
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  l && (c[$o] = "");
  var h = mt({}, o.styles);
  Y_(i) && (h.transform = aq({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), h["-webkit-transform"] = h.transform);
  var d = Gp(h);
  d.length > 0 && (c.style = d);
  var p = [];
  return p.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), a && p.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [a]
  }), p;
}
function Aq(t) {
  var e = t.content, n = t.title, r = t.extra, i = mt(mt(mt({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), a = Gp(r.styles);
  a.length > 0 && (i.style = a);
  var o = [];
  return o.push({
    tag: "span",
    attributes: i,
    children: [e]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
var _g = Ir.styles;
function H0(t) {
  var e = t[0], n = t[1], r = t.slice(4), i = B_(r, 1), a = i[0], o = null;
  return Array.isArray(a) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(_t.cssPrefix, "-").concat(ho.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(_t.cssPrefix, "-").concat(ho.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(_t.cssPrefix, "-").concat(ho.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: e,
    height: n,
    icon: o
  };
}
var Pq = {
  found: !1,
  width: 512,
  height: 512
};
function Mq(t, e) {
  !pC && !_t.showMissingIcons && t && console.error('Icon with name "'.concat(t, '" and prefix "').concat(e, '" is missing.'));
}
function j0(t, e) {
  var n = e;
  return e === "fa" && _t.styleDefault !== null && (e = $a()), new Promise(function(r, i) {
    if (Fi("missingIconAbstract"), n === "fa") {
      var a = SC(t) || {};
      t = a.iconName || t, e = a.prefix || e;
    }
    if (t && e && _g[e] && _g[e][t]) {
      var o = _g[e][t];
      return r(H0(o));
    }
    Mq(t, e), r(mt(mt({}, Pq), {}, {
      icon: _t.showMissingIcons && t ? Fi("missingIconAbstract") || {} : {}
    }));
  });
}
var x6 = function() {
}, V0 = _t.measurePerformance && qf && qf.mark && qf.measure ? qf : {
  mark: x6,
  measure: x6
}, bl = 'FA "6.4.2"', kq = function(e) {
  return V0.mark("".concat(bl, " ").concat(e, " begins")), function() {
    return AC(e);
  };
}, AC = function(e) {
  V0.mark("".concat(bl, " ").concat(e, " ends")), V0.measure("".concat(bl, " ").concat(e), "".concat(bl, " ").concat(e, " begins"), "".concat(bl, " ").concat(e, " ends"));
}, Z_ = {
  begin: kq,
  end: AC
}, Rh = function() {
};
function C6(t) {
  var e = t.getAttribute ? t.getAttribute($o) : null;
  return typeof e == "string";
}
function Nq(t) {
  var e = t.getAttribute ? t.getAttribute(j_) : null, n = t.getAttribute ? t.getAttribute(V_) : null;
  return e && n;
}
function Iq(t) {
  return t && t.classList && t.classList.contains && t.classList.contains(_t.replacementClass);
}
function Rq() {
  if (_t.autoReplaceSvg === !0)
    return Lh.replace;
  var t = Lh[_t.autoReplaceSvg];
  return t || Lh.replace;
}
function Lq(t) {
  return se.createElementNS("http://www.w3.org/2000/svg", t);
}
function Dq(t) {
  return se.createElement(t);
}
function PC(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.ceFn, r = n === void 0 ? t.tag === "svg" ? Lq : Dq : n;
  if (typeof t == "string")
    return se.createTextNode(t);
  var i = r(t.tag);
  Object.keys(t.attributes || []).forEach(function(o) {
    i.setAttribute(o, t.attributes[o]);
  });
  var a = t.children || [];
  return a.forEach(function(o) {
    i.appendChild(PC(o, {
      ceFn: r
    }));
  }), i;
}
function Fq(t) {
  var e = " ".concat(t.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var Lh = {
  replace: function(e) {
    var n = e[0];
    if (n.parentNode)
      if (e[1].forEach(function(i) {
        n.parentNode.insertBefore(PC(i), n);
      }), n.getAttribute($o) === null && _t.keepOriginalSource) {
        var r = se.createComment(Fq(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(e) {
    var n = e[0], r = e[1];
    if (~U_(n).indexOf(_t.replacementClass))
      return Lh.replace(e);
    var i = new RegExp("".concat(_t.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var a = r[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === _t.replacementClass || l.match(i) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", a.toNode.join(" "));
    }
    var o = r.map(function(s) {
      return Lc(s);
    }).join(`
`);
    n.setAttribute($o, ""), n.innerHTML = o;
  }
};
function $6(t) {
  t();
}
function MC(t, e) {
  var n = typeof e == "function" ? e : Rh;
  if (t.length === 0)
    n();
  else {
    var r = $6;
    _t.mutateApproach === jY && (r = Ca.requestAnimationFrame || $6), r(function() {
      var i = Rq(), a = Z_.begin("mutate");
      t.map(i), a(), n();
    });
  }
}
var J_ = !1;
function kC() {
  J_ = !0;
}
function W0() {
  J_ = !1;
}
var vd = null;
function T6(t) {
  if (p6 && _t.observeMutations) {
    var e = t.treeCallback, n = e === void 0 ? Rh : e, r = t.nodeCallback, i = r === void 0 ? Rh : r, a = t.pseudoElementsCallback, o = a === void 0 ? Rh : a, s = t.observeMutationsRoot, l = s === void 0 ? se : s;
    vd = new p6(function(c) {
      if (!J_) {
        var h = $a();
        Eu(c).forEach(function(d) {
          if (d.type === "childList" && d.addedNodes.length > 0 && !C6(d.addedNodes[0]) && (_t.searchPseudoElements && o(d.target), n(d.target)), d.type === "attributes" && d.target.parentNode && _t.searchPseudoElements && o(d.target.parentNode), d.type === "attributes" && C6(d.target) && ~KY.indexOf(d.attributeName))
            if (d.attributeName === "class" && Nq(d.target)) {
              var p = Xp(U_(d.target)), g = p.prefix, v = p.iconName;
              d.target.setAttribute(j_, g || h), v && d.target.setAttribute(V_, v);
            } else
              Iq(d.target) && i(d.target);
        });
      }
    }), Ui && vd.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function zq() {
  vd && vd.disconnect();
}
function Bq(t) {
  var e = t.getAttribute("style"), n = [];
  return e && (n = e.split(";").reduce(function(r, i) {
    var a = i.split(":"), o = a[0], s = a.slice(1);
    return o && s.length > 0 && (r[o] = s.join(":").trim()), r;
  }, {})), n;
}
function Hq(t) {
  var e = t.getAttribute("data-prefix"), n = t.getAttribute("data-icon"), r = t.innerText !== void 0 ? t.innerText.trim() : "", i = Xp(U_(t));
  return i.prefix || (i.prefix = $a()), e && n && (i.prefix = e, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = _q(i.prefix, t.innerText) || G_(i.prefix, D0(t.innerText))), !i.iconName && _t.autoFetchSvg && t.firstChild && t.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = t.firstChild.data)), i;
}
function jq(t) {
  var e = Eu(t.attributes).reduce(function(i, a) {
    return i.name !== "class" && i.name !== "style" && (i[a.name] = a.value), i;
  }, {}), n = t.getAttribute("title"), r = t.getAttribute("data-fa-title-id");
  return _t.autoA11y && (n ? e["aria-labelledby"] = "".concat(_t.replacementClass, "-title-").concat(r || Ql()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function Vq() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: ti,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function O6(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = Hq(t), r = n.iconName, i = n.prefix, a = n.rest, o = jq(t), s = z0("parseNodeAttributes", {}, t), l = e.styleParser ? Bq(t) : [];
  return mt({
    iconName: r,
    title: t.getAttribute("title"),
    titleId: t.getAttribute("data-fa-title-id"),
    prefix: i,
    transform: ti,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: o
    }
  }, s);
}
var Wq = Ir.styles;
function NC(t) {
  var e = _t.autoReplaceSvg === "nest" ? O6(t, {
    styleParser: !1
  }) : O6(t);
  return ~e.extra.classes.indexOf(mC) ? Fi("generateLayersText", t, e) : Fi("generateSvgReplacementMutation", t, e);
}
var Ta = /* @__PURE__ */ new Set();
W_.map(function(t) {
  Ta.add("fa-".concat(t));
});
Object.keys(Kl[oe]).map(Ta.add.bind(Ta));
Object.keys(Kl[ye]).map(Ta.add.bind(Ta));
Ta = Ic(Ta);
function S6(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Ui)
    return Promise.resolve();
  var n = se.documentElement.classList, r = function(d) {
    return n.add("".concat(m6, "-").concat(d));
  }, i = function(d) {
    return n.remove("".concat(m6, "-").concat(d));
  }, a = _t.autoFetchSvg ? Ta : W_.map(function(h) {
    return "fa-".concat(h);
  }).concat(Object.keys(Wq));
  a.includes("fa") || a.push("fa");
  var o = [".".concat(mC, ":not([").concat($o, "])")].concat(a.map(function(h) {
    return ".".concat(h, ":not([").concat($o, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = Eu(t.querySelectorAll(o));
  } catch (h) {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  var l = Z_.begin("onTree"), c = s.reduce(function(h, d) {
    try {
      var p = NC(d);
      p && h.push(p);
    } catch (g) {
      pC || g.name === "MissingIcon" && console.error(g);
    }
    return h;
  }, []);
  return new Promise(function(h, d) {
    Promise.all(c).then(function(p) {
      MC(p, function() {
        r("active"), r("complete"), i("pending"), typeof e == "function" && e(), l(), h();
      });
    }).catch(function(p) {
      l(), d(p);
    });
  });
}
function Uq(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  NC(t).then(function(n) {
    n && MC([n], e);
  });
}
function Yq(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (e || {}).icon ? e : B0(e || {}), i = n.mask;
    return i && (i = (i || {}).icon ? i : B0(i || {})), t(r, mt(mt({}, n), {}, {
      mask: i
    }));
  };
}
var qq = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, i = r === void 0 ? ti : r, a = n.symbol, o = a === void 0 ? !1 : a, s = n.mask, l = s === void 0 ? null : s, c = n.maskId, h = c === void 0 ? null : c, d = n.title, p = d === void 0 ? null : d, g = n.titleId, v = g === void 0 ? null : g, b = n.classes, _ = b === void 0 ? [] : b, w = n.attributes, x = w === void 0 ? {} : w, C = n.styles, $ = C === void 0 ? {} : C;
  if (e) {
    var E = e.prefix, A = e.iconName, R = e.icon;
    return Zp(mt({
      type: "icon"
    }, e), function() {
      return To("beforeDOMElementCreation", {
        iconDefinition: e,
        params: n
      }), _t.autoA11y && (p ? x["aria-labelledby"] = "".concat(_t.replacementClass, "-title-").concat(v || Ql()) : (x["aria-hidden"] = "true", x.focusable = "false")), X_({
        icons: {
          main: H0(R),
          mask: l ? H0(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: E,
        iconName: A,
        transform: mt(mt({}, ti), i),
        symbol: o,
        title: p,
        maskId: h,
        titleId: v,
        extra: {
          attributes: x,
          styles: $,
          classes: _
        }
      });
    });
  }
}, Gq = {
  mixout: function() {
    return {
      icon: Yq(qq)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = S6, n.nodeCallback = Uq, n;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(n) {
      var r = n.node, i = r === void 0 ? se : r, a = n.callback, o = a === void 0 ? function() {
      } : a;
      return S6(i, o);
    }, e.generateSvgReplacementMutation = function(n, r) {
      var i = r.iconName, a = r.title, o = r.titleId, s = r.prefix, l = r.transform, c = r.symbol, h = r.mask, d = r.maskId, p = r.extra;
      return new Promise(function(g, v) {
        Promise.all([j0(i, s), h.iconName ? j0(h.iconName, h.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(b) {
          var _ = B_(b, 2), w = _[0], x = _[1];
          g([n, X_({
            icons: {
              main: w,
              mask: x
            },
            prefix: s,
            iconName: i,
            transform: l,
            symbol: c,
            maskId: d,
            title: a,
            titleId: o,
            extra: p,
            watchable: !0
          })]);
        }).catch(v);
      });
    }, e.generateAbstractIcon = function(n) {
      var r = n.children, i = n.attributes, a = n.main, o = n.transform, s = n.styles, l = Gp(s);
      l.length > 0 && (i.style = l);
      var c;
      return Y_(o) && (c = Fi("generateAbstractTransformGrouping", {
        main: a,
        transform: o,
        containerWidth: a.width,
        iconWidth: a.width
      })), r.push(c || a.icon), {
        children: r,
        attributes: i
      };
    };
  }
}, Kq = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.classes, a = i === void 0 ? [] : i;
        return Zp({
          type: "layer"
        }, function() {
          To("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var o = [];
          return n(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              o = o.concat(l.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(_t.cssPrefix, "-layers")].concat(Ic(a)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, Xq = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.title, a = i === void 0 ? null : i, o = r.classes, s = o === void 0 ? [] : o, l = r.attributes, c = l === void 0 ? {} : l, h = r.styles, d = h === void 0 ? {} : h;
        return Zp({
          type: "counter",
          content: n
        }, function() {
          return To("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Aq({
            content: n.toString(),
            title: a,
            extra: {
              attributes: c,
              styles: d,
              classes: ["".concat(_t.cssPrefix, "-layers-counter")].concat(Ic(s))
            }
          });
        });
      }
    };
  }
}, Zq = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.transform, a = i === void 0 ? ti : i, o = r.title, s = o === void 0 ? null : o, l = r.classes, c = l === void 0 ? [] : l, h = r.attributes, d = h === void 0 ? {} : h, p = r.styles, g = p === void 0 ? {} : p;
        return Zp({
          type: "text",
          content: n
        }, function() {
          return To("beforeDOMElementCreation", {
            content: n,
            params: r
          }), w6({
            content: n,
            transform: mt(mt({}, ti), a),
            title: s,
            extra: {
              attributes: d,
              styles: g,
              classes: ["".concat(_t.cssPrefix, "-layers-text")].concat(Ic(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(n, r) {
      var i = r.title, a = r.transform, o = r.extra, s = null, l = null;
      if (fC) {
        var c = parseInt(getComputedStyle(n).fontSize, 10), h = n.getBoundingClientRect();
        s = h.width / c, l = h.height / c;
      }
      return _t.autoA11y && !i && (o.attributes["aria-hidden"] = "true"), Promise.resolve([n, w6({
        content: n.innerHTML,
        width: s,
        height: l,
        transform: a,
        title: i,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, Jq = new RegExp('"', "ug"), E6 = [1105920, 1112319];
function Qq(t) {
  var e = t.replace(Jq, ""), n = hq(e, 0), r = n >= E6[0] && n <= E6[1], i = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: D0(i ? e[0] : e),
    isSecondary: r || i
  };
}
function A6(t, e) {
  var n = "".concat(HY).concat(e.replace(":", "-"));
  return new Promise(function(r, i) {
    if (t.getAttribute(n) !== null)
      return r();
    var a = Eu(t.children), o = a.filter(function(R) {
      return R.getAttribute(L0) === e;
    })[0], s = Ca.getComputedStyle(t, e), l = s.getPropertyValue("font-family").match(YY), c = s.getPropertyValue("font-weight"), h = s.getPropertyValue("content");
    if (o && !l)
      return t.removeChild(o), r();
    if (l && h !== "none" && h !== "") {
      var d = s.getPropertyValue("content"), p = ~["Sharp"].indexOf(l[2]) ? ye : oe, g = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? Xl[p][l[2].toLowerCase()] : qY[p][c], v = Qq(d), b = v.value, _ = v.isSecondary, w = l[0].startsWith("FontAwesome"), x = G_(g, b), C = x;
      if (w) {
        var $ = bq(b);
        $.iconName && $.prefix && (x = $.iconName, g = $.prefix);
      }
      if (x && !_ && (!o || o.getAttribute(j_) !== g || o.getAttribute(V_) !== C)) {
        t.setAttribute(n, C), o && t.removeChild(o);
        var E = Vq(), A = E.extra;
        A.attributes[L0] = e, j0(x, g).then(function(R) {
          var L = X_(mt(mt({}, E), {}, {
            icons: {
              main: R,
              mask: K_()
            },
            prefix: g,
            iconName: C,
            extra: A,
            watchable: !0
          })), W = se.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? t.insertBefore(W, t.firstChild) : t.appendChild(W), W.outerHTML = L.map(function(P) {
            return Lc(P);
          }).join(`
`), t.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function tG(t) {
  return Promise.all([A6(t, "::before"), A6(t, "::after")]);
}
function eG(t) {
  return t.parentNode !== document.head && !~VY.indexOf(t.tagName.toUpperCase()) && !t.getAttribute(L0) && (!t.parentNode || t.parentNode.tagName !== "svg");
}
function P6(t) {
  if (Ui)
    return new Promise(function(e, n) {
      var r = Eu(t.querySelectorAll("*")).filter(eG).map(tG), i = Z_.begin("searchPseudoElements");
      kC(), Promise.all(r).then(function() {
        i(), W0(), e();
      }).catch(function() {
        i(), W0(), n();
      });
    });
}
var nG = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = P6, n;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(n) {
      var r = n.node, i = r === void 0 ? se : r;
      _t.searchPseudoElements && P6(i);
    };
  }
}, M6 = !1, rG = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          kC(), M6 = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        T6(z0("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        zq();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        M6 ? W0() : T6(z0("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, k6 = function(e) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(r, i) {
    var a = i.toLowerCase().split("-"), o = a[0], s = a.slice(1).join("-");
    if (o && s === "h")
      return r.flipX = !0, r;
    if (o && s === "v")
      return r.flipY = !0, r;
    if (s = parseFloat(s), isNaN(s))
      return r;
    switch (o) {
      case "grow":
        r.size = r.size + s;
        break;
      case "shrink":
        r.size = r.size - s;
        break;
      case "left":
        r.x = r.x - s;
        break;
      case "right":
        r.x = r.x + s;
        break;
      case "up":
        r.y = r.y - s;
        break;
      case "down":
        r.y = r.y + s;
        break;
      case "rotate":
        r.rotate = r.rotate + s;
        break;
    }
    return r;
  }, n);
}, iG = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return k6(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-transform");
        return i && (n.transform = k6(i)), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(n) {
      var r = n.main, i = n.transform, a = n.containerWidth, o = n.iconWidth, s = {
        transform: "translate(".concat(a / 2, " 256)")
      }, l = "translate(".concat(i.x * 32, ", ").concat(i.y * 32, ") "), c = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), h = "rotate(".concat(i.rotate, " 0 0)"), d = {
        transform: "".concat(l, " ").concat(c, " ").concat(h)
      }, p = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, g = {
        outer: s,
        inner: d,
        path: p
      };
      return {
        tag: "g",
        attributes: mt({}, g.outer),
        children: [{
          tag: "g",
          attributes: mt({}, g.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: mt(mt({}, r.icon.attributes), g.path)
          }]
        }]
      };
    };
  }
}, bg = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function N6(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return t.attributes && (t.attributes.fill || e) && (t.attributes.fill = "black"), t;
}
function aG(t) {
  return t.tag === "g" ? t.children : [t];
}
var oG = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-mask"), a = i ? Xp(i.split(" ").map(function(o) {
          return o.trim();
        })) : K_();
        return a.prefix || (a.prefix = $a()), n.mask = a, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(n) {
      var r = n.children, i = n.attributes, a = n.main, o = n.mask, s = n.maskId, l = n.transform, c = a.width, h = a.icon, d = o.width, p = o.icon, g = iq({
        transform: l,
        containerWidth: d,
        iconWidth: c
      }), v = {
        tag: "rect",
        attributes: mt(mt({}, bg), {}, {
          fill: "white"
        })
      }, b = h.children ? {
        children: h.children.map(N6)
      } : {}, _ = {
        tag: "g",
        attributes: mt({}, g.inner),
        children: [N6(mt({
          tag: h.tag,
          attributes: mt(mt({}, h.attributes), g.path)
        }, b))]
      }, w = {
        tag: "g",
        attributes: mt({}, g.outer),
        children: [_]
      }, x = "mask-".concat(s || Ql()), C = "clip-".concat(s || Ql()), $ = {
        tag: "mask",
        attributes: mt(mt({}, bg), {}, {
          id: x,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [v, w]
      }, E = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: C
          },
          children: aG(p)
        }, $]
      };
      return r.push(E, {
        tag: "rect",
        attributes: mt({
          fill: "currentColor",
          "clip-path": "url(#".concat(C, ")"),
          mask: "url(#".concat(x, ")")
        }, bg)
      }), {
        children: r,
        attributes: i
      };
    };
  }
}, sG = {
  provides: function(e) {
    var n = !1;
    Ca.matchMedia && (n = Ca.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var r = [], i = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: mt(mt({}, i), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = mt(mt({}, a), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: mt(mt({}, i), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || s.children.push({
        tag: "animate",
        attributes: mt(mt({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: mt(mt({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(s), r.push({
        tag: "path",
        attributes: mt(mt({}, i), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: mt(mt({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: mt(mt({}, i), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: mt(mt({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, uG = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-symbol"), a = i === null ? !1 : i === "" ? !0 : i;
        return n.symbol = a, n;
      }
    };
  }
}, lG = [sq, Gq, Kq, Xq, Zq, nG, rG, iG, oG, sG, uG];
xq(lG, {
  mixoutsTo: ir
});
ir.noAuto;
var cG = ir.config, Br = ir.library;
ir.dom;
var U0 = ir.parse;
ir.findIconDefinition;
ir.toHtml;
var fG = ir.icon;
ir.layer;
ir.text;
ir.counter;
function I6(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _r(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? I6(Object(n), !0).forEach(function(r) {
      $i(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I6(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function _d(t) {
  return _d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _d(t);
}
function $i(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function hG(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function dG(t, e) {
  if (t == null)
    return {};
  var n = hG(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (i = 0; i < a.length; i++)
      r = a[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function pG(t) {
  return mG(t) || gG(t) || vG(t) || _G();
}
function mG(t) {
  if (Array.isArray(t))
    return Y0(t);
}
function gG(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function vG(t, e) {
  if (t) {
    if (typeof t == "string")
      return Y0(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Y0(t, e);
  }
}
function Y0(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function _G() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var bG = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, IC = { exports: {} };
(function(t) {
  (function(e) {
    var n = function(w, x, C) {
      if (!c(x) || d(x) || p(x) || g(x) || l(x))
        return x;
      var $, E = 0, A = 0;
      if (h(x))
        for ($ = [], A = x.length; E < A; E++)
          $.push(n(w, x[E], C));
      else {
        $ = {};
        for (var R in x)
          Object.prototype.hasOwnProperty.call(x, R) && ($[w(R, C)] = n(w, x[R], C));
      }
      return $;
    }, r = function(w, x) {
      x = x || {};
      var C = x.separator || "_", $ = x.split || /(?=[A-Z])/;
      return w.split($).join(C);
    }, i = function(w) {
      return v(w) ? w : (w = w.replace(/[\-_\s]+(.)?/g, function(x, C) {
        return C ? C.toUpperCase() : "";
      }), w.substr(0, 1).toLowerCase() + w.substr(1));
    }, a = function(w) {
      var x = i(w);
      return x.substr(0, 1).toUpperCase() + x.substr(1);
    }, o = function(w, x) {
      return r(w, x).toLowerCase();
    }, s = Object.prototype.toString, l = function(w) {
      return typeof w == "function";
    }, c = function(w) {
      return w === Object(w);
    }, h = function(w) {
      return s.call(w) == "[object Array]";
    }, d = function(w) {
      return s.call(w) == "[object Date]";
    }, p = function(w) {
      return s.call(w) == "[object RegExp]";
    }, g = function(w) {
      return s.call(w) == "[object Boolean]";
    }, v = function(w) {
      return w = w - 0, w === w;
    }, b = function(w, x) {
      var C = x && "process" in x ? x.process : x;
      return typeof C != "function" ? w : function($, E) {
        return C($, w, E);
      };
    }, _ = {
      camelize: i,
      decamelize: o,
      pascalize: a,
      depascalize: o,
      camelizeKeys: function(w, x) {
        return n(b(i, x), w);
      },
      decamelizeKeys: function(w, x) {
        return n(b(o, x), w, x);
      },
      pascalizeKeys: function(w, x) {
        return n(b(a, x), w);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    t.exports ? t.exports = _ : e.humps = _;
  })(bG);
})(IC);
var yG = IC.exports, wG = ["class", "style", "attrs"];
function xG(t) {
  return t.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, n) {
    var r = n.indexOf(":"), i = yG.camelize(n.slice(0, r)), a = n.slice(r + 1).trim();
    return e[i] = a, e;
  }, {});
}
function CG(t) {
  return t.split(/\s+/).reduce(function(e, n) {
    return e[n] = !0, e;
  }, {});
}
function $G() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return e.reduce(function(r, i) {
    return Array.isArray(i) ? r = r.concat(i) : r.push(i), r;
  }, []);
}
function RC(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = (e.children || []).map(RC.bind(null, t)), a = Object.keys(e.attributes || {}).reduce(function(g, v) {
    var b = e.attributes[v];
    switch (v) {
      case "class":
        g.class = CG(b);
        break;
      case "style":
        g.style = xG(b);
        break;
      default:
        g.attrs[v] = b;
    }
    return g;
  }, {
    class: {},
    style: {},
    attrs: {}
  }), o = r.class, s = o === void 0 ? {} : o, l = r.style, c = l === void 0 ? {} : l, h = r.attrs, d = h === void 0 ? {} : h, p = dG(r, wG);
  return typeof e == "string" ? e : t(e.tag, _r(_r({
    class: $G(a.class, s),
    style: _r(_r({}, a.style), c),
    attrs: _r(_r({}, a.attrs), d)
  }, p), {}, {
    props: n
  }), i);
}
var LC = !1;
try {
  LC = process.env.NODE_ENV === "production";
} catch (t) {
}
function TG() {
  if (!LC && console && typeof console.error == "function") {
    var t;
    (t = console).error.apply(t, arguments);
  }
}
function yg(t, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? $i({}, t, e) : {};
}
function OG(t) {
  var e, n = (e = {
    "fa-spin": t.spin,
    "fa-spin-pulse": t.spinPulse,
    "fa-spin-reverse": t.spinReverse,
    "fa-pulse": t.pulse,
    "fa-beat": t.beat,
    "fa-fade": t.fade,
    "fa-flash": t.flash,
    "fa-fw": t.fixedWidth,
    "fa-border": t.border,
    "fa-li": t.listItem,
    "fa-inverse": t.inverse,
    "fa-flip": t.flip === !0,
    "fa-flip-horizontal": t.flip === "horizontal" || t.flip === "both",
    "fa-flip-vertical": t.flip === "vertical" || t.flip === "both"
  }, $i(e, "fa-".concat(t.size), t.size !== null), $i(e, "fa-rotate-".concat(t.rotation), t.rotation !== null), $i(e, "fa-pull-".concat(t.pull), t.pull !== null), $i(e, "fa-swap-opacity", t.swapOpacity), $i(e, "fa-bounce", t.bounce), $i(e, "fa-shake", t.shake), $i(e, "fa-beat-fade", t.beatFade), e);
  return Object.keys(n).map(function(r) {
    return n[r] ? r : null;
  }).filter(function(r) {
    return r;
  });
}
function SG(t, e) {
  var n = (t || "").length === 0 ? [] : [t];
  return n.concat(e).join(" ");
}
function R6(t) {
  if (t && _d(t) === "object" && t.prefix && t.iconName && t.icon)
    return t;
  if (U0.icon)
    return U0.icon(t);
  if (t === null)
    return null;
  if (_d(t) === "object" && t.prefix && t.iconName)
    return t;
  if (Array.isArray(t) && t.length === 2)
    return {
      prefix: t[0],
      iconName: t[1]
    };
  if (typeof t == "string")
    return {
      prefix: "fas",
      iconName: t
    };
}
var ar = {
  name: "FontAwesomeIcon",
  functional: !0,
  props: {
    beat: {
      type: Boolean,
      default: !1
    },
    border: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    }
  },
  render: function(e, n) {
    var r = n.props, i = r.icon, a = r.mask, o = r.symbol, s = r.title, l = R6(i), c = yg("classes", OG(r)), h = yg("transform", typeof r.transform == "string" ? U0.transform(r.transform) : r.transform), d = yg("mask", R6(a)), p = fG(l, _r(_r(_r(_r({}, c), h), d), {}, {
      symbol: o,
      title: s
    }));
    if (!p)
      return TG("Could not find one or more icon(s)", l, d);
    var g = p.abstract, v = RC.bind(null, e);
    return v(g[0], {}, n.data);
  }
}, EG = {
  name: "FontAwesomeLayers",
  functional: !0,
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  render: function(e, n) {
    var r = cG.familyPrefix, i = n.data.staticClass, a = ["".concat(r, "-layers")].concat(pG(n.props.fixedWidth ? ["".concat(r, "-fw")] : []));
    return e("div", _r(_r({}, n.data), {}, {
      staticClass: SG(i, a)
    }), n.children);
  }
}, DC = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "clipboard", r = 384, i = 512, a = [128203], o = "f328", s = "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faClipboard = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(DC);
var FC = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "clipboard-check", r = 384, i = 512, a = [], o = "f46c", s = "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faClipboardCheck = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(FC);
function AG() {
}
var bd = AG, q0 = {}, PG = {
  get exports() {
    return q0;
  },
  set exports(t) {
    q0 = t;
  }
};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(t, e) {
  (function(r, i) {
    t.exports = i();
  })(Fn, function() {
    return (
      /******/
      function() {
        var n = {
          /***/
          686: (
            /***/
            function(a, o, s) {
              s.d(o, {
                default: function() {
                  return (
                    /* binding */
                    J
                  );
                }
              });
              var l = s(279), c = /* @__PURE__ */ s.n(l), h = s(370), d = /* @__PURE__ */ s.n(h), p = s(817), g = /* @__PURE__ */ s.n(p);
              function v(X) {
                try {
                  return document.execCommand(X);
                } catch (et) {
                  return !1;
                }
              }
              var b = function(et) {
                var rt = g()(et);
                return v("cut"), rt;
              }, _ = b;
              function w(X) {
                var et = document.documentElement.getAttribute("dir") === "rtl", rt = document.createElement("textarea");
                rt.style.fontSize = "12pt", rt.style.border = "0", rt.style.padding = "0", rt.style.margin = "0", rt.style.position = "absolute", rt.style[et ? "right" : "left"] = "-9999px";
                var ut = window.pageYOffset || document.documentElement.scrollTop;
                return rt.style.top = "".concat(ut, "px"), rt.setAttribute("readonly", ""), rt.value = X, rt;
              }
              var x = function(et, rt) {
                var ut = w(et);
                rt.container.appendChild(ut);
                var ft = g()(ut);
                return v("copy"), ut.remove(), ft;
              }, C = function(et) {
                var rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                }, ut = "";
                return typeof et == "string" ? ut = x(et, rt) : et instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(et == null ? void 0 : et.type) ? ut = x(et.value, rt) : (ut = g()(et), v("copy")), ut;
              }, $ = C;
              function E(X) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? E = function(rt) {
                  return typeof rt;
                } : E = function(rt) {
                  return rt && typeof Symbol == "function" && rt.constructor === Symbol && rt !== Symbol.prototype ? "symbol" : typeof rt;
                }, E(X);
              }
              var A = function() {
                var et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, rt = et.action, ut = rt === void 0 ? "copy" : rt, ft = et.container, ht = et.target, Nt = et.text;
                if (ut !== "copy" && ut !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
                if (ht !== void 0)
                  if (ht && E(ht) === "object" && ht.nodeType === 1) {
                    if (ut === "copy" && ht.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (ut === "cut" && (ht.hasAttribute("readonly") || ht.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
                if (Nt)
                  return $(Nt, {
                    container: ft
                  });
                if (ht)
                  return ut === "cut" ? _(ht) : $(ht, {
                    container: ft
                  });
              }, R = A;
              function L(X) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? L = function(rt) {
                  return typeof rt;
                } : L = function(rt) {
                  return rt && typeof Symbol == "function" && rt.constructor === Symbol && rt !== Symbol.prototype ? "symbol" : typeof rt;
                }, L(X);
              }
              function W(X, et) {
                if (!(X instanceof et))
                  throw new TypeError("Cannot call a class as a function");
              }
              function P(X, et) {
                for (var rt = 0; rt < et.length; rt++) {
                  var ut = et[rt];
                  ut.enumerable = ut.enumerable || !1, ut.configurable = !0, "value" in ut && (ut.writable = !0), Object.defineProperty(X, ut.key, ut);
                }
              }
              function k(X, et, rt) {
                return et && P(X.prototype, et), rt && P(X, rt), X;
              }
              function Y(X, et) {
                if (typeof et != "function" && et !== null)
                  throw new TypeError("Super expression must either be null or a function");
                X.prototype = Object.create(et && et.prototype, { constructor: { value: X, writable: !0, configurable: !0 } }), et && V(X, et);
              }
              function V(X, et) {
                return V = Object.setPrototypeOf || function(ut, ft) {
                  return ut.__proto__ = ft, ut;
                }, V(X, et);
              }
              function I(X) {
                var et = q();
                return function() {
                  var ut = Z(X), ft;
                  if (et) {
                    var ht = Z(this).constructor;
                    ft = Reflect.construct(ut, arguments, ht);
                  } else
                    ft = ut.apply(this, arguments);
                  return D(this, ft);
                };
              }
              function D(X, et) {
                return et && (L(et) === "object" || typeof et == "function") ? et : z(X);
              }
              function z(X) {
                if (X === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return X;
              }
              function q() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch (X) {
                  return !1;
                }
              }
              function Z(X) {
                return Z = Object.setPrototypeOf ? Object.getPrototypeOf : function(rt) {
                  return rt.__proto__ || Object.getPrototypeOf(rt);
                }, Z(X);
              }
              function B(X, et) {
                var rt = "data-clipboard-".concat(X);
                if (et.hasAttribute(rt))
                  return et.getAttribute(rt);
              }
              var H = /* @__PURE__ */ function(X) {
                Y(rt, X);
                var et = I(rt);
                function rt(ut, ft) {
                  var ht;
                  return W(this, rt), ht = et.call(this), ht.resolveOptions(ft), ht.listenClick(ut), ht;
                }
                return k(rt, [{
                  key: "resolveOptions",
                  value: function() {
                    var ft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    this.action = typeof ft.action == "function" ? ft.action : this.defaultAction, this.target = typeof ft.target == "function" ? ft.target : this.defaultTarget, this.text = typeof ft.text == "function" ? ft.text : this.defaultText, this.container = L(ft.container) === "object" ? ft.container : document.body;
                  }
                  /**
                   * Adds a click event listener to the passed trigger.
                   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                   */
                }, {
                  key: "listenClick",
                  value: function(ft) {
                    var ht = this;
                    this.listener = d()(ft, "click", function(Nt) {
                      return ht.onClick(Nt);
                    });
                  }
                  /**
                   * Defines a new `ClipboardAction` on each click event.
                   * @param {Event} e
                   */
                }, {
                  key: "onClick",
                  value: function(ft) {
                    var ht = ft.delegateTarget || ft.currentTarget, Nt = this.action(ht) || "copy", ot = R({
                      action: Nt,
                      container: this.container,
                      target: this.target(ht),
                      text: this.text(ht)
                    });
                    this.emit(ot ? "success" : "error", {
                      action: Nt,
                      text: ot,
                      trigger: ht,
                      clearSelection: function() {
                        ht && ht.focus(), window.getSelection().removeAllRanges();
                      }
                    });
                  }
                  /**
                   * Default `action` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultAction",
                  value: function(ft) {
                    return B("action", ft);
                  }
                  /**
                   * Default `target` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultTarget",
                  value: function(ft) {
                    var ht = B("target", ft);
                    if (ht)
                      return document.querySelector(ht);
                  }
                  /**
                   * Allow fire programmatically a copy action
                   * @param {String|HTMLElement} target
                   * @param {Object} options
                   * @returns Text copied.
                   */
                }, {
                  key: "defaultText",
                  /**
                   * Default `text` lookup function.
                   * @param {Element} trigger
                   */
                  value: function(ft) {
                    return B("text", ft);
                  }
                  /**
                   * Destroy lifecycle.
                   */
                }, {
                  key: "destroy",
                  value: function() {
                    this.listener.destroy();
                  }
                }], [{
                  key: "copy",
                  value: function(ft) {
                    var ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      container: document.body
                    };
                    return $(ft, ht);
                  }
                  /**
                   * Allow fire programmatically a cut action
                   * @param {String|HTMLElement} target
                   * @returns Text cutted.
                   */
                }, {
                  key: "cut",
                  value: function(ft) {
                    return _(ft);
                  }
                  /**
                   * Returns the support of the given action, or all actions if no action is
                   * given.
                   * @param {String} [action]
                   */
                }, {
                  key: "isSupported",
                  value: function() {
                    var ft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], ht = typeof ft == "string" ? [ft] : ft, Nt = !!document.queryCommandSupported;
                    return ht.forEach(function(ot) {
                      Nt = Nt && !!document.queryCommandSupported(ot);
                    }), Nt;
                  }
                }]), rt;
              }(c()), J = H;
            }
          ),
          /***/
          828: (
            /***/
            function(a) {
              var o = 9;
              if (typeof Element != "undefined" && !Element.prototype.matches) {
                var s = Element.prototype;
                s.matches = s.matchesSelector || s.mozMatchesSelector || s.msMatchesSelector || s.oMatchesSelector || s.webkitMatchesSelector;
              }
              function l(c, h) {
                for (; c && c.nodeType !== o; ) {
                  if (typeof c.matches == "function" && c.matches(h))
                    return c;
                  c = c.parentNode;
                }
              }
              a.exports = l;
            }
          ),
          /***/
          438: (
            /***/
            function(a, o, s) {
              var l = s(828);
              function c(p, g, v, b, _) {
                var w = d.apply(this, arguments);
                return p.addEventListener(v, w, _), {
                  destroy: function() {
                    p.removeEventListener(v, w, _);
                  }
                };
              }
              function h(p, g, v, b, _) {
                return typeof p.addEventListener == "function" ? c.apply(null, arguments) : typeof v == "function" ? c.bind(null, document).apply(null, arguments) : (typeof p == "string" && (p = document.querySelectorAll(p)), Array.prototype.map.call(p, function(w) {
                  return c(w, g, v, b, _);
                }));
              }
              function d(p, g, v, b) {
                return function(_) {
                  _.delegateTarget = l(_.target, g), _.delegateTarget && b.call(p, _);
                };
              }
              a.exports = h;
            }
          ),
          /***/
          879: (
            /***/
            function(a, o) {
              o.node = function(s) {
                return s !== void 0 && s instanceof HTMLElement && s.nodeType === 1;
              }, o.nodeList = function(s) {
                var l = Object.prototype.toString.call(s);
                return s !== void 0 && (l === "[object NodeList]" || l === "[object HTMLCollection]") && "length" in s && (s.length === 0 || o.node(s[0]));
              }, o.string = function(s) {
                return typeof s == "string" || s instanceof String;
              }, o.fn = function(s) {
                var l = Object.prototype.toString.call(s);
                return l === "[object Function]";
              };
            }
          ),
          /***/
          370: (
            /***/
            function(a, o, s) {
              var l = s(879), c = s(438);
              function h(v, b, _) {
                if (!v && !b && !_)
                  throw new Error("Missing required arguments");
                if (!l.string(b))
                  throw new TypeError("Second argument must be a String");
                if (!l.fn(_))
                  throw new TypeError("Third argument must be a Function");
                if (l.node(v))
                  return d(v, b, _);
                if (l.nodeList(v))
                  return p(v, b, _);
                if (l.string(v))
                  return g(v, b, _);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
              }
              function d(v, b, _) {
                return v.addEventListener(b, _), {
                  destroy: function() {
                    v.removeEventListener(b, _);
                  }
                };
              }
              function p(v, b, _) {
                return Array.prototype.forEach.call(v, function(w) {
                  w.addEventListener(b, _);
                }), {
                  destroy: function() {
                    Array.prototype.forEach.call(v, function(w) {
                      w.removeEventListener(b, _);
                    });
                  }
                };
              }
              function g(v, b, _) {
                return c(document.body, v, b, _);
              }
              a.exports = h;
            }
          ),
          /***/
          817: (
            /***/
            function(a) {
              function o(s) {
                var l;
                if (s.nodeName === "SELECT")
                  s.focus(), l = s.value;
                else if (s.nodeName === "INPUT" || s.nodeName === "TEXTAREA") {
                  var c = s.hasAttribute("readonly");
                  c || s.setAttribute("readonly", ""), s.select(), s.setSelectionRange(0, s.value.length), c || s.removeAttribute("readonly"), l = s.value;
                } else {
                  s.hasAttribute("contenteditable") && s.focus();
                  var h = window.getSelection(), d = document.createRange();
                  d.selectNodeContents(s), h.removeAllRanges(), h.addRange(d), l = h.toString();
                }
                return l;
              }
              a.exports = o;
            }
          ),
          /***/
          279: (
            /***/
            function(a) {
              function o() {
              }
              o.prototype = {
                on: function(s, l, c) {
                  var h = this.e || (this.e = {});
                  return (h[s] || (h[s] = [])).push({
                    fn: l,
                    ctx: c
                  }), this;
                },
                once: function(s, l, c) {
                  var h = this;
                  function d() {
                    h.off(s, d), l.apply(c, arguments);
                  }
                  return d._ = l, this.on(s, d, c);
                },
                emit: function(s) {
                  var l = [].slice.call(arguments, 1), c = ((this.e || (this.e = {}))[s] || []).slice(), h = 0, d = c.length;
                  for (h; h < d; h++)
                    c[h].fn.apply(c[h].ctx, l);
                  return this;
                },
                off: function(s, l) {
                  var c = this.e || (this.e = {}), h = c[s], d = [];
                  if (h && l)
                    for (var p = 0, g = h.length; p < g; p++)
                      h[p].fn !== l && h[p].fn._ !== l && d.push(h[p]);
                  return d.length ? c[s] = d : delete c[s], this;
                }
              }, a.exports = o, a.exports.TinyEmitter = o;
            }
          )
          /******/
        }, r = {};
        function i(a) {
          if (r[a])
            return r[a].exports;
          var o = r[a] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[a](o, o.exports, i), o.exports;
        }
        return function() {
          i.n = function(a) {
            var o = a && a.__esModule ? (
              /******/
              function() {
                return a.default;
              }
            ) : (
              /******/
              function() {
                return a;
              }
            );
            return i.d(o, { a: o }), o;
          };
        }(), function() {
          i.d = function(a, o) {
            for (var s in o)
              i.o(o, s) && !i.o(a, s) && Object.defineProperty(a, s, { enumerable: !0, get: o[s] });
          };
        }(), function() {
          i.o = function(a, o) {
            return Object.prototype.hasOwnProperty.call(a, o);
          };
        }(), i(686);
      }().default
    );
  });
})(PG);
const MG = /* @__PURE__ */ t9(q0);
function kG(t, e) {
  return new Promise(function(n, r) {
    const i = document.createElement("button");
    e = typeof e == "object" ? e : document.body;
    const a = new MG(i, { text: () => t, container: e });
    a.on("success", () => {
      a.destroy(), n();
    }), a.on("error", (o) => {
      a.destroy(), r(o);
    }), i.click();
  });
}
function NG(t, e) {
  function n(r) {
    r.clipboardData.setData("text/html", t), r.clipboardData.setData("text/plain", e), r.preventDefault();
  }
  document.addEventListener("copy", n), document.execCommand("copy"), document.removeEventListener("copy", n);
}
const IG = [
  "top",
  "topleft",
  "topright",
  "right",
  "righttop",
  "rightbottom",
  "bottom",
  "bottomleft",
  "bottomright",
  "left",
  "lefttop",
  "leftbottom"
], RG = te({
  i18n: Hn,
  name: "HapticCopy",
  components: {
    BTooltip: z_,
    FontAwesomeLayers: EG,
    Fa: ar
  },
  props: {
    /**
     * Text to copy to the clipboard
     */
    text: {
      type: String,
      default: null
    },
    /**
     * Plain text to use as an alternative text for HTML copy (uses `text` by default)
     */
    plain: {
      type: String,
      default: null
    },
    /**
     * Hide the button label (still visible for screen reader)
     */
    hideLabel: {
      type: Boolean
    },
    /**
     * Button label
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Delay after which we hide the tooltip
     */
    tooltipHideDelay: {
      type: Number,
      default: 2e3
    },
    /**
     * Placement of the tooltip. Can be: top, topleft, topright, right,<br />
     * righttop, rightbottom, bottom, bottomleft, bottomright, left, lefttop,
     * and leftbottom.
     */
    tooltipPlacement: {
      type: String,
      default: "top",
      validator: (t) => IG.includes(t)
    },
    /**
     * Copy HTML content
     */
    html: {
      type: Boolean
    },
    /**
     * Deactivate haptic tooltip display
     */
    noTooltip: {
      type: Boolean
    }
  },
  data() {
    return {
      mounted: !1,
      succeed: !1,
      tooltipContent: "",
      tooltipTimeout: void 0
    };
  },
  computed: {
    tooltipContainer() {
      return this.mounted && "id" in this.$root.$el ? `#${this.$root.$el.id}` : null;
    }
  },
  beforeMount() {
    Br.add(DC.faClipboard), Br.add(FC.faClipboardCheck);
  },
  mounted() {
    this.$nextTick(() => this.mounted = !0);
  },
  methods: {
    copyTextOrHtml() {
      return this.html ? this.copyHtml() : this.copyText();
    },
    copyText() {
      return kG(this.text, this.$el);
    },
    copyHtml() {
      return NG(this.text, this.plain || this.text);
    },
    copy() {
      return _e(this, null, function* () {
        try {
          this.$emit("attempt"), yield this.copyTextOrHtml(), yield this.openTooltip("haptic-copy.tooltip.succeed"), this.$emit("success");
        } catch (t) {
          yield this.openTooltip("haptic-copy.tooltip.failed"), this.$emit("error", t);
        }
        this.nextTimeout(this.closeTooltip, this.tooltipHideDelay);
      });
    },
    openTooltip(t = "haptic-copy.tooltip.succeed") {
      return _e(this, null, function* () {
        this.tooltipContent = this.$te(t) ? this.$t(t) : t, this.$root.$emit("bv::hide::tooltip"), yield this.$nextTick(), this.$refs.tooltip && this.$refs.tooltip.$emit("open");
      });
    },
    closeTooltip() {
      return _e(this, null, function* () {
        this.$refs.tooltip && this.$refs.tooltip.$emit("close"), yield this.$nextTick(), this.tooltipContent = "", this.tooltipTimeout = void 0;
      });
    },
    nextTimeout(t = bd, e = 0) {
      return clearTimeout(this.tooltipTimeout), new Promise((n) => {
        this.tooltipTimeout = setTimeout(n, e);
      }).finally(this.$nextTick).then(t);
    }
  }
});
var LG = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("button", { staticClass: "btn haptic-copy", on: { click: function(r) {
    return r.stopPropagation(), e.copy.apply(null, arguments);
  }, mouseleave: e.closeTooltip } }, [e._t("default", function() {
    return [n("font-awesome-layers", { attrs: { functional: "" } }, [n("transition", { attrs: { name: "spin" } }, [e.tooltipTimeout ? e._e() : n("fa", { staticClass: "haptic-copy__icon", attrs: { icon: "clipboard" } })], 1), n("transition", { attrs: { name: "spin" } }, [e.tooltipTimeout ? n("fa", { staticClass: "haptic-copy__icon", attrs: { icon: "clipboard-check" } }) : e._e()], 1)], 1), n("span", { staticClass: "ml-1 haptic-copy__label", class: { "sr-only": e.hideLabel } }, [e._v(" " + e._s(e.label || e.$t("haptic-copy.label")) + " ")])];
  }), !e.noTooltip && e.mounted && e.$el ? n("b-tooltip", { ref: "tooltip", attrs: { noninteractive: "", placement: e.tooltipPlacement, target: () => e.$el, triggers: [], container: e.tooltipContainer } }, [e._v(" " + e._s(e.tooltipContent) + " ")]) : e._e()], 2);
}, DG = [], FG = /* @__PURE__ */ Bt(
  RG,
  LG,
  DG,
  !1,
  null,
  null,
  null,
  null
);
const Jp = FG.exports;
var da = /* @__PURE__ */ ((t) => (t.Short = "short", t.Medium = "medium", t.Long = "long", t))(da || {}), zC = /* @__PURE__ */ ((t) => (t.Top = "top", t.Topleft = "topleft", t.Topright = "topright", t.Right = "right", t.Righttop = "righttop", t.Rightbottom = "rightbottom", t.Bottom = "bottom", t.Bottomleft = "bottomleft", t.Bottomright = "bottomright", t.Left = "left", t.Lefttop = "lefttop", t.Leftbottom = "leftbottom", t))(zC || {}), G0 = /* @__PURE__ */ ((t) => (t.Silk = "silk", t.Brick = "brick", t.Rock = "rock", t.Sand = "sand", t.Crack = "crack", t.Carbon = "carbon", t))(G0 || {}), va = /* @__PURE__ */ ((t) => (t.sm = "sm", t.md = "md", t.lg = "lg", t))(va || {});
const zG = te({
  name: "AdvancedLinkForm",
  i18n: Hn,
  components: {
    BTabs: dY,
    BTab: mY,
    BInputGroup: Xx,
    BInputGroupAppend: Kx,
    BFormInput: qx,
    HapticCopy: Jp
  },
  props: {
    /**
     * The link to copy
     */
    link: {
      type: String,
      default: null
    },
    /**
     * Title associated with the link
     */
    title: {
      type: String,
      default: null
    },
    /**
     * The forms to display
     */
    forms: {
      type: Array,
      default: () => ["raw", "markdown", "rich", "html"]
    },
    /**
     * Index of the selected tab
     */
    value: {
      type: Number,
      default: 0
    },
    /**
     * Activate the card integration for the tabs
     */
    card: {
      type: Boolean
    },
    /**
     * Renders the tabs with the appearance of pill buttons
     */
    pills: {
      type: Boolean
    },
    /**
     * Makes the tabs and the panels smaller.
     */
    small: {
      type: Boolean
    },
    /**
     * Makes the tabs and the panels vertical.
     */
    vertical: {
      type: Boolean
    },
    /**
     * CSS class (or classes) to apply to the currently active tab.
     */
    activeNavItemClass: {
      type: String,
      default: null
    },
    /**
     * When set to 'true', disables the fade animation on the tabs.
     */
    noFade: {
      type: Boolean
    }
  },
  computed: {
    titleOrLink() {
      return this.title || this.link;
    },
    linkAsMarkdown() {
      return `[${this.titleOrLink}](${this.link})`;
    },
    linkAsHtml() {
      return `<a href="${this.link}" target="_blank">${this.titleOrLink}</a>`;
    },
    formClasses() {
      return ["card", "pills", "small", "vertical"].reduce((e, n) => (e[`advanced-link-form--${n}`] = this[n], e), {});
    },
    size() {
      return this.small ? va.sm : va.md;
    }
  },
  methods: {
    showForm(t) {
      return this.forms.indexOf(t) > -1;
    },
    selectInput(t) {
      var e;
      (e = this.$el.querySelector(t)) == null || e.select();
    },
    selectRaw() {
      this.selectInput(".advanced-link-form__raw__input");
    },
    selectRich() {
      const t = this.$el.querySelector(".advanced-link-form__rich__input");
      if (!t)
        return;
      const e = window.getSelection ? window.getSelection() : null;
      if (e) {
        const n = document.createRange();
        n.selectNodeContents(t), e.removeAllRanges(), e.addRange(n);
      } else if (document.body.createTextRange) {
        const n = document.body.createTextRange();
        n.moveToElementText(t), n.select();
      }
    },
    selectMarkdown() {
      this.selectInput(".advanced-link-form__markdown__input");
    },
    selectHtml() {
      this.selectInput(".advanced-link-form__html__input");
    }
  }
});
var BG = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("b-tabs", { staticClass: "advanced-link-form", class: e.formClasses, attrs: { "content-class": e.card ? "mt-0" : "mt-3", card: e.card, pills: e.pills, value: e.value, small: e.small, vertical: e.vertical, "active-nav-item-class": e.activeNavItemClass, "no-fade": e.noFade }, on: { input: function(r) {
    return e.$emit("input", r);
  } } }, [e.showForm("raw") ? n("b-tab", { attrs: { title: e.$t("advanced-link-form.raw.tab") } }, [n("div", { staticClass: "advanced-link-form__raw", class: { small: e.small } }, [n("b-input-group", { attrs: { size: e.size } }, [n("b-form-input", { staticClass: "advanced-link-form__raw__input", attrs: { readonly: "", value: e.link }, on: { click: function(r) {
    return e.selectRaw();
  } } }), n("b-input-group-append", [n("haptic-copy", { staticClass: "btn-secondary", attrs: { text: e.link }, on: { attempt: function(r) {
    return e.selectRaw();
  } } })], 1)], 1)], 1)]) : e._e(), e.showForm("rich") ? n("b-tab", { attrs: { title: e.$t("advanced-link-form.rich.tab") } }, [n("div", { staticClass: "advanced-link-form__rich", class: { small: e.small } }, [n("b-input-group", { attrs: { size: e.size } }, [n("a", { staticClass: "form-control advanced-link-form__rich__input", attrs: { href: e.link }, on: { click: function(r) {
    return r.preventDefault(), e.selectRich();
  } } }, [e._v(e._s(e.titleOrLink))]), n("b-input-group-append", [n("haptic-copy", { staticClass: "btn-secondary", attrs: { html: "", text: e.linkAsHtml, plain: e.link }, on: { attempt: function(r) {
    return e.selectRich();
  } } })], 1)], 1), n("p", { staticClass: "text-muted mt-2 mb-0" }, [e._v(" " + e._s(e.$t("advanced-link-form.rich.description")) + " ")])], 1)]) : e._e(), e.showForm("markdown") ? n("b-tab", { attrs: { title: e.$t("advanced-link-form.markdown.tab") } }, [n("div", { staticClass: "advanced-link-form__markdown", class: { small: e.small } }, [n("b-input-group", { attrs: { size: e.size } }, [n("b-form-input", { staticClass: "advanced-link-form__markdown__input", attrs: { readonly: "", value: e.linkAsMarkdown }, on: { click: function(r) {
    return e.selectMarkdown();
  } } }), n("b-input-group-append", [n("haptic-copy", { staticClass: "btn-secondary", attrs: { text: e.linkAsMarkdown }, on: { attempt: function(r) {
    return e.selectMarkdown();
  } } })], 1)], 1), n("p", { staticClass: "text-muted mt-2 mb-0" }, [e._v(" " + e._s(e.$t("advanced-link-form.markdown.description")) + " ")])], 1)]) : e._e(), e.showForm("html") ? n("b-tab", { attrs: { title: e.$t("advanced-link-form.html.tab") } }, [n("div", { staticClass: "advanced-link-form__html", class: { small: e.small } }, [n("b-input-group", { attrs: { size: e.size } }, [n("b-form-input", { staticClass: "advanced-link-form__html__input", attrs: { readonly: "", value: e.linkAsHtml }, on: { click: function(r) {
    return e.selectHtml();
  } } }), n("b-input-group-append", [n("haptic-copy", { staticClass: "btn-secondary", attrs: { text: e.linkAsHtml }, on: { attempt: function(r) {
    return e.selectHtml();
  } } })], 1)], 1)], 1)]) : e._e()], 1);
}, HG = [], jG = /* @__PURE__ */ Bt(
  zG,
  BG,
  HG,
  !1,
  null,
  "cce7dadb",
  null,
  null
);
const VG = jG.exports;
var ct = {}, WG = {
  get exports() {
    return ct;
  },
  set exports(t) {
    ct = t;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(t, e) {
  (function() {
    var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, h = "__lodash_placeholder__", d = 1, p = 2, g = 4, v = 1, b = 2, _ = 1, w = 2, x = 4, C = 8, $ = 16, E = 32, A = 64, R = 128, L = 256, W = 512, P = 30, k = "...", Y = 800, V = 16, I = 1, D = 2, z = 3, q = 1 / 0, Z = 9007199254740991, B = 17976931348623157e292, H = 0 / 0, J = 4294967295, X = J - 1, et = J >>> 1, rt = [
      ["ary", R],
      ["bind", _],
      ["bindKey", w],
      ["curry", C],
      ["curryRight", $],
      ["flip", W],
      ["partial", E],
      ["partialRight", A],
      ["rearg", L]
    ], ut = "[object Arguments]", ft = "[object Array]", ht = "[object AsyncFunction]", Nt = "[object Boolean]", ot = "[object Date]", wt = "[object DOMException]", kt = "[object Error]", at = "[object Function]", Gt = "[object GeneratorFunction]", $t = "[object Map]", le = "[object Number]", qe = "[object Null]", yt = "[object Object]", re = "[object Promise]", Va = "[object Proxy]", En = "[object RegExp]", Or = "[object Set]", Du = "[object String]", Jc = "[object Symbol]", _A = "[object Undefined]", Fu = "[object WeakMap]", bA = "[object WeakSet]", zu = "[object ArrayBuffer]", Ko = "[object DataView]", D1 = "[object Float32Array]", F1 = "[object Float64Array]", z1 = "[object Int8Array]", B1 = "[object Int16Array]", H1 = "[object Int32Array]", j1 = "[object Uint8Array]", V1 = "[object Uint8ClampedArray]", W1 = "[object Uint16Array]", U1 = "[object Uint32Array]", yA = /\b__p \+= '';/g, wA = /\b(__p \+=) '' \+/g, xA = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Gb = /&(?:amp|lt|gt|quot|#39);/g, Kb = /[&<>"']/g, CA = RegExp(Gb.source), $A = RegExp(Kb.source), TA = /<%-([\s\S]+?)%>/g, OA = /<%([\s\S]+?)%>/g, Xb = /<%=([\s\S]+?)%>/g, SA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, EA = /^\w*$/, AA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Y1 = /[\\^$.*+?()[\]{}|]/g, PA = RegExp(Y1.source), q1 = /^\s+/, MA = /\s/, kA = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, NA = /\{\n\/\* \[wrapped with (.+)\] \*/, IA = /,? & /, RA = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, LA = /[()=,{}\[\]\/\s]/, DA = /\\(\\)?/g, FA = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Zb = /\w*$/, zA = /^[-+]0x[0-9a-f]+$/i, BA = /^0b[01]+$/i, HA = /^\[object .+?Constructor\]$/, jA = /^0o[0-7]+$/i, VA = /^(?:0|[1-9]\d*)$/, WA = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Qc = /($^)/, UA = /['\n\r\u2028\u2029\\]/g, tf = "\\ud800-\\udfff", YA = "\\u0300-\\u036f", qA = "\\ufe20-\\ufe2f", GA = "\\u20d0-\\u20ff", Jb = YA + qA + GA, Qb = "\\u2700-\\u27bf", ty = "a-z\\xdf-\\xf6\\xf8-\\xff", KA = "\\xac\\xb1\\xd7\\xf7", XA = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ZA = "\\u2000-\\u206f", JA = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ey = "A-Z\\xc0-\\xd6\\xd8-\\xde", ny = "\\ufe0e\\ufe0f", ry = KA + XA + ZA + JA, G1 = "['’]", QA = "[" + tf + "]", iy = "[" + ry + "]", ef = "[" + Jb + "]", ay = "\\d+", tP = "[" + Qb + "]", oy = "[" + ty + "]", sy = "[^" + tf + ry + ay + Qb + ty + ey + "]", K1 = "\\ud83c[\\udffb-\\udfff]", eP = "(?:" + ef + "|" + K1 + ")", uy = "[^" + tf + "]", X1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", Z1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xo = "[" + ey + "]", ly = "\\u200d", cy = "(?:" + oy + "|" + sy + ")", nP = "(?:" + Xo + "|" + sy + ")", fy = "(?:" + G1 + "(?:d|ll|m|re|s|t|ve))?", hy = "(?:" + G1 + "(?:D|LL|M|RE|S|T|VE))?", dy = eP + "?", py = "[" + ny + "]?", rP = "(?:" + ly + "(?:" + [uy, X1, Z1].join("|") + ")" + py + dy + ")*", iP = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", aP = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", my = py + dy + rP, oP = "(?:" + [tP, X1, Z1].join("|") + ")" + my, sP = "(?:" + [uy + ef + "?", ef, X1, Z1, QA].join("|") + ")", uP = RegExp(G1, "g"), lP = RegExp(ef, "g"), J1 = RegExp(K1 + "(?=" + K1 + ")|" + sP + my, "g"), cP = RegExp([
      Xo + "?" + oy + "+" + fy + "(?=" + [iy, Xo, "$"].join("|") + ")",
      nP + "+" + hy + "(?=" + [iy, Xo + cy, "$"].join("|") + ")",
      Xo + "?" + cy + "+" + fy,
      Xo + "+" + hy,
      aP,
      iP,
      ay,
      oP
    ].join("|"), "g"), fP = RegExp("[" + ly + tf + Jb + ny + "]"), hP = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, dP = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], pP = -1, ie = {};
    ie[D1] = ie[F1] = ie[z1] = ie[B1] = ie[H1] = ie[j1] = ie[V1] = ie[W1] = ie[U1] = !0, ie[ut] = ie[ft] = ie[zu] = ie[Nt] = ie[Ko] = ie[ot] = ie[kt] = ie[at] = ie[$t] = ie[le] = ie[yt] = ie[En] = ie[Or] = ie[Du] = ie[Fu] = !1;
    var ne = {};
    ne[ut] = ne[ft] = ne[zu] = ne[Ko] = ne[Nt] = ne[ot] = ne[D1] = ne[F1] = ne[z1] = ne[B1] = ne[H1] = ne[$t] = ne[le] = ne[yt] = ne[En] = ne[Or] = ne[Du] = ne[Jc] = ne[j1] = ne[V1] = ne[W1] = ne[U1] = !0, ne[kt] = ne[at] = ne[Fu] = !1;
    var mP = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, gP = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, vP = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, _P = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, bP = parseFloat, yP = parseInt, gy = typeof Fn == "object" && Fn && Fn.Object === Object && Fn, wP = typeof self == "object" && self && self.Object === Object && self, Ge = gy || wP || Function("return this")(), Q1 = e && !e.nodeType && e, Wa = Q1 && !0 && t && !t.nodeType && t, vy = Wa && Wa.exports === Q1, tm = vy && gy.process, or = function() {
      try {
        var j = Wa && Wa.require && Wa.require("util").types;
        return j || tm && tm.binding && tm.binding("util");
      } catch (K) {
      }
    }(), _y = or && or.isArrayBuffer, by = or && or.isDate, yy = or && or.isMap, wy = or && or.isRegExp, xy = or && or.isSet, Cy = or && or.isTypedArray;
    function Vn(j, K, G) {
      switch (G.length) {
        case 0:
          return j.call(K);
        case 1:
          return j.call(K, G[0]);
        case 2:
          return j.call(K, G[0], G[1]);
        case 3:
          return j.call(K, G[0], G[1], G[2]);
      }
      return j.apply(K, G);
    }
    function xP(j, K, G, pt) {
      for (var At = -1, Yt = j == null ? 0 : j.length; ++At < Yt; ) {
        var Ae = j[At];
        K(pt, Ae, G(Ae), j);
      }
      return pt;
    }
    function sr(j, K) {
      for (var G = -1, pt = j == null ? 0 : j.length; ++G < pt && K(j[G], G, j) !== !1; )
        ;
      return j;
    }
    function CP(j, K) {
      for (var G = j == null ? 0 : j.length; G-- && K(j[G], G, j) !== !1; )
        ;
      return j;
    }
    function $y(j, K) {
      for (var G = -1, pt = j == null ? 0 : j.length; ++G < pt; )
        if (!K(j[G], G, j))
          return !1;
      return !0;
    }
    function qi(j, K) {
      for (var G = -1, pt = j == null ? 0 : j.length, At = 0, Yt = []; ++G < pt; ) {
        var Ae = j[G];
        K(Ae, G, j) && (Yt[At++] = Ae);
      }
      return Yt;
    }
    function nf(j, K) {
      var G = j == null ? 0 : j.length;
      return !!G && Zo(j, K, 0) > -1;
    }
    function em(j, K, G) {
      for (var pt = -1, At = j == null ? 0 : j.length; ++pt < At; )
        if (G(K, j[pt]))
          return !0;
      return !1;
    }
    function ce(j, K) {
      for (var G = -1, pt = j == null ? 0 : j.length, At = Array(pt); ++G < pt; )
        At[G] = K(j[G], G, j);
      return At;
    }
    function Gi(j, K) {
      for (var G = -1, pt = K.length, At = j.length; ++G < pt; )
        j[At + G] = K[G];
      return j;
    }
    function nm(j, K, G, pt) {
      var At = -1, Yt = j == null ? 0 : j.length;
      for (pt && Yt && (G = j[++At]); ++At < Yt; )
        G = K(G, j[At], At, j);
      return G;
    }
    function $P(j, K, G, pt) {
      var At = j == null ? 0 : j.length;
      for (pt && At && (G = j[--At]); At--; )
        G = K(G, j[At], At, j);
      return G;
    }
    function rm(j, K) {
      for (var G = -1, pt = j == null ? 0 : j.length; ++G < pt; )
        if (K(j[G], G, j))
          return !0;
      return !1;
    }
    var TP = im("length");
    function OP(j) {
      return j.split("");
    }
    function SP(j) {
      return j.match(RA) || [];
    }
    function Ty(j, K, G) {
      var pt;
      return G(j, function(At, Yt, Ae) {
        if (K(At, Yt, Ae))
          return pt = Yt, !1;
      }), pt;
    }
    function rf(j, K, G, pt) {
      for (var At = j.length, Yt = G + (pt ? 1 : -1); pt ? Yt-- : ++Yt < At; )
        if (K(j[Yt], Yt, j))
          return Yt;
      return -1;
    }
    function Zo(j, K, G) {
      return K === K ? zP(j, K, G) : rf(j, Oy, G);
    }
    function EP(j, K, G, pt) {
      for (var At = G - 1, Yt = j.length; ++At < Yt; )
        if (pt(j[At], K))
          return At;
      return -1;
    }
    function Oy(j) {
      return j !== j;
    }
    function Sy(j, K) {
      var G = j == null ? 0 : j.length;
      return G ? om(j, K) / G : H;
    }
    function im(j) {
      return function(K) {
        return K == null ? n : K[j];
      };
    }
    function am(j) {
      return function(K) {
        return j == null ? n : j[K];
      };
    }
    function Ey(j, K, G, pt, At) {
      return At(j, function(Yt, Ae, Zt) {
        G = pt ? (pt = !1, Yt) : K(G, Yt, Ae, Zt);
      }), G;
    }
    function AP(j, K) {
      var G = j.length;
      for (j.sort(K); G--; )
        j[G] = j[G].value;
      return j;
    }
    function om(j, K) {
      for (var G, pt = -1, At = j.length; ++pt < At; ) {
        var Yt = K(j[pt]);
        Yt !== n && (G = G === n ? Yt : G + Yt);
      }
      return G;
    }
    function sm(j, K) {
      for (var G = -1, pt = Array(j); ++G < j; )
        pt[G] = K(G);
      return pt;
    }
    function PP(j, K) {
      return ce(K, function(G) {
        return [G, j[G]];
      });
    }
    function Ay(j) {
      return j && j.slice(0, Ny(j) + 1).replace(q1, "");
    }
    function Wn(j) {
      return function(K) {
        return j(K);
      };
    }
    function um(j, K) {
      return ce(K, function(G) {
        return j[G];
      });
    }
    function Bu(j, K) {
      return j.has(K);
    }
    function Py(j, K) {
      for (var G = -1, pt = j.length; ++G < pt && Zo(K, j[G], 0) > -1; )
        ;
      return G;
    }
    function My(j, K) {
      for (var G = j.length; G-- && Zo(K, j[G], 0) > -1; )
        ;
      return G;
    }
    function MP(j, K) {
      for (var G = j.length, pt = 0; G--; )
        j[G] === K && ++pt;
      return pt;
    }
    var kP = am(mP), NP = am(gP);
    function IP(j) {
      return "\\" + _P[j];
    }
    function RP(j, K) {
      return j == null ? n : j[K];
    }
    function Jo(j) {
      return fP.test(j);
    }
    function LP(j) {
      return hP.test(j);
    }
    function DP(j) {
      for (var K, G = []; !(K = j.next()).done; )
        G.push(K.value);
      return G;
    }
    function lm(j) {
      var K = -1, G = Array(j.size);
      return j.forEach(function(pt, At) {
        G[++K] = [At, pt];
      }), G;
    }
    function ky(j, K) {
      return function(G) {
        return j(K(G));
      };
    }
    function Ki(j, K) {
      for (var G = -1, pt = j.length, At = 0, Yt = []; ++G < pt; ) {
        var Ae = j[G];
        (Ae === K || Ae === h) && (j[G] = h, Yt[At++] = G);
      }
      return Yt;
    }
    function af(j) {
      var K = -1, G = Array(j.size);
      return j.forEach(function(pt) {
        G[++K] = pt;
      }), G;
    }
    function FP(j) {
      var K = -1, G = Array(j.size);
      return j.forEach(function(pt) {
        G[++K] = [pt, pt];
      }), G;
    }
    function zP(j, K, G) {
      for (var pt = G - 1, At = j.length; ++pt < At; )
        if (j[pt] === K)
          return pt;
      return -1;
    }
    function BP(j, K, G) {
      for (var pt = G + 1; pt--; )
        if (j[pt] === K)
          return pt;
      return pt;
    }
    function Qo(j) {
      return Jo(j) ? jP(j) : TP(j);
    }
    function Sr(j) {
      return Jo(j) ? VP(j) : OP(j);
    }
    function Ny(j) {
      for (var K = j.length; K-- && MA.test(j.charAt(K)); )
        ;
      return K;
    }
    var HP = am(vP);
    function jP(j) {
      for (var K = J1.lastIndex = 0; J1.test(j); )
        ++K;
      return K;
    }
    function VP(j) {
      return j.match(J1) || [];
    }
    function WP(j) {
      return j.match(cP) || [];
    }
    var UP = function j(K) {
      K = K == null ? Ge : ts.defaults(Ge.Object(), K, ts.pick(Ge, dP));
      var G = K.Array, pt = K.Date, At = K.Error, Yt = K.Function, Ae = K.Math, Zt = K.Object, cm = K.RegExp, YP = K.String, ur = K.TypeError, of = G.prototype, qP = Yt.prototype, es = Zt.prototype, sf = K["__core-js_shared__"], uf = qP.toString, Kt = es.hasOwnProperty, GP = 0, Iy = function() {
        var u = /[^.]+$/.exec(sf && sf.keys && sf.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), lf = es.toString, KP = uf.call(Zt), XP = Ge._, ZP = cm(
        "^" + uf.call(Kt).replace(Y1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), cf = vy ? K.Buffer : n, Xi = K.Symbol, ff = K.Uint8Array, Ry = cf ? cf.allocUnsafe : n, hf = ky(Zt.getPrototypeOf, Zt), Ly = Zt.create, Dy = es.propertyIsEnumerable, df = of.splice, Fy = Xi ? Xi.isConcatSpreadable : n, Hu = Xi ? Xi.iterator : n, Ua = Xi ? Xi.toStringTag : n, pf = function() {
        try {
          var u = Xa(Zt, "defineProperty");
          return u({}, "", {}), u;
        } catch (f) {
        }
      }(), JP = K.clearTimeout !== Ge.clearTimeout && K.clearTimeout, QP = pt && pt.now !== Ge.Date.now && pt.now, tM = K.setTimeout !== Ge.setTimeout && K.setTimeout, mf = Ae.ceil, gf = Ae.floor, fm = Zt.getOwnPropertySymbols, eM = cf ? cf.isBuffer : n, zy = K.isFinite, nM = of.join, rM = ky(Zt.keys, Zt), Pe = Ae.max, en = Ae.min, iM = pt.now, aM = K.parseInt, By = Ae.random, oM = of.reverse, hm = Xa(K, "DataView"), ju = Xa(K, "Map"), dm = Xa(K, "Promise"), ns = Xa(K, "Set"), Vu = Xa(K, "WeakMap"), Wu = Xa(Zt, "create"), vf = Vu && new Vu(), rs = {}, sM = Za(hm), uM = Za(ju), lM = Za(dm), cM = Za(ns), fM = Za(Vu), _f = Xi ? Xi.prototype : n, Uu = _f ? _f.valueOf : n, Hy = _f ? _f.toString : n;
      function O(u) {
        if (ve(u) && !Pt(u) && !(u instanceof Ht)) {
          if (u instanceof lr)
            return u;
          if (Kt.call(u, "__wrapped__"))
            return j3(u);
        }
        return new lr(u);
      }
      var is = function() {
        function u() {
        }
        return function(f) {
          if (!pe(f))
            return {};
          if (Ly)
            return Ly(f);
          u.prototype = f;
          var m = new u();
          return u.prototype = n, m;
        };
      }();
      function bf() {
      }
      function lr(u, f) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!f, this.__index__ = 0, this.__values__ = n;
      }
      O.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: TA,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: OA,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Xb,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: O
        }
      }, O.prototype = bf.prototype, O.prototype.constructor = O, lr.prototype = is(bf.prototype), lr.prototype.constructor = lr;
      function Ht(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = J, this.__views__ = [];
      }
      function hM() {
        var u = new Ht(this.__wrapped__);
        return u.__actions__ = An(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = An(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = An(this.__views__), u;
      }
      function dM() {
        if (this.__filtered__) {
          var u = new Ht(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function pM() {
        var u = this.__wrapped__.value(), f = this.__dir__, m = Pt(u), y = f < 0, T = m ? u.length : 0, S = Ok(0, T, this.__views__), N = S.start, F = S.end, U = F - N, tt = y ? F : N - 1, nt = this.__iteratees__, it = nt.length, lt = 0, vt = en(U, this.__takeCount__);
        if (!m || !y && T == U && vt == U)
          return f3(u, this.__actions__);
        var St = [];
        t:
          for (; U-- && lt < vt; ) {
            tt += f;
            for (var Lt = -1, Et = u[tt]; ++Lt < it; ) {
              var zt = nt[Lt], jt = zt.iteratee, qn = zt.type, hn = jt(Et);
              if (qn == D)
                Et = hn;
              else if (!hn) {
                if (qn == I)
                  continue t;
                break t;
              }
            }
            St[lt++] = Et;
          }
        return St;
      }
      Ht.prototype = is(bf.prototype), Ht.prototype.constructor = Ht;
      function Ya(u) {
        var f = -1, m = u == null ? 0 : u.length;
        for (this.clear(); ++f < m; ) {
          var y = u[f];
          this.set(y[0], y[1]);
        }
      }
      function mM() {
        this.__data__ = Wu ? Wu(null) : {}, this.size = 0;
      }
      function gM(u) {
        var f = this.has(u) && delete this.__data__[u];
        return this.size -= f ? 1 : 0, f;
      }
      function vM(u) {
        var f = this.__data__;
        if (Wu) {
          var m = f[u];
          return m === l ? n : m;
        }
        return Kt.call(f, u) ? f[u] : n;
      }
      function _M(u) {
        var f = this.__data__;
        return Wu ? f[u] !== n : Kt.call(f, u);
      }
      function bM(u, f) {
        var m = this.__data__;
        return this.size += this.has(u) ? 0 : 1, m[u] = Wu && f === n ? l : f, this;
      }
      Ya.prototype.clear = mM, Ya.prototype.delete = gM, Ya.prototype.get = vM, Ya.prototype.has = _M, Ya.prototype.set = bM;
      function fi(u) {
        var f = -1, m = u == null ? 0 : u.length;
        for (this.clear(); ++f < m; ) {
          var y = u[f];
          this.set(y[0], y[1]);
        }
      }
      function yM() {
        this.__data__ = [], this.size = 0;
      }
      function wM(u) {
        var f = this.__data__, m = yf(f, u);
        if (m < 0)
          return !1;
        var y = f.length - 1;
        return m == y ? f.pop() : df.call(f, m, 1), --this.size, !0;
      }
      function xM(u) {
        var f = this.__data__, m = yf(f, u);
        return m < 0 ? n : f[m][1];
      }
      function CM(u) {
        return yf(this.__data__, u) > -1;
      }
      function $M(u, f) {
        var m = this.__data__, y = yf(m, u);
        return y < 0 ? (++this.size, m.push([u, f])) : m[y][1] = f, this;
      }
      fi.prototype.clear = yM, fi.prototype.delete = wM, fi.prototype.get = xM, fi.prototype.has = CM, fi.prototype.set = $M;
      function hi(u) {
        var f = -1, m = u == null ? 0 : u.length;
        for (this.clear(); ++f < m; ) {
          var y = u[f];
          this.set(y[0], y[1]);
        }
      }
      function TM() {
        this.size = 0, this.__data__ = {
          hash: new Ya(),
          map: new (ju || fi)(),
          string: new Ya()
        };
      }
      function OM(u) {
        var f = kf(this, u).delete(u);
        return this.size -= f ? 1 : 0, f;
      }
      function SM(u) {
        return kf(this, u).get(u);
      }
      function EM(u) {
        return kf(this, u).has(u);
      }
      function AM(u, f) {
        var m = kf(this, u), y = m.size;
        return m.set(u, f), this.size += m.size == y ? 0 : 1, this;
      }
      hi.prototype.clear = TM, hi.prototype.delete = OM, hi.prototype.get = SM, hi.prototype.has = EM, hi.prototype.set = AM;
      function qa(u) {
        var f = -1, m = u == null ? 0 : u.length;
        for (this.__data__ = new hi(); ++f < m; )
          this.add(u[f]);
      }
      function PM(u) {
        return this.__data__.set(u, l), this;
      }
      function MM(u) {
        return this.__data__.has(u);
      }
      qa.prototype.add = qa.prototype.push = PM, qa.prototype.has = MM;
      function Er(u) {
        var f = this.__data__ = new fi(u);
        this.size = f.size;
      }
      function kM() {
        this.__data__ = new fi(), this.size = 0;
      }
      function NM(u) {
        var f = this.__data__, m = f.delete(u);
        return this.size = f.size, m;
      }
      function IM(u) {
        return this.__data__.get(u);
      }
      function RM(u) {
        return this.__data__.has(u);
      }
      function LM(u, f) {
        var m = this.__data__;
        if (m instanceof fi) {
          var y = m.__data__;
          if (!ju || y.length < i - 1)
            return y.push([u, f]), this.size = ++m.size, this;
          m = this.__data__ = new hi(y);
        }
        return m.set(u, f), this.size = m.size, this;
      }
      Er.prototype.clear = kM, Er.prototype.delete = NM, Er.prototype.get = IM, Er.prototype.has = RM, Er.prototype.set = LM;
      function jy(u, f) {
        var m = Pt(u), y = !m && Ja(u), T = !m && !y && ea(u), S = !m && !y && !T && us(u), N = m || y || T || S, F = N ? sm(u.length, YP) : [], U = F.length;
        for (var tt in u)
          (f || Kt.call(u, tt)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
          (tt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          T && (tt == "offset" || tt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          S && (tt == "buffer" || tt == "byteLength" || tt == "byteOffset") || // Skip index properties.
          gi(tt, U))) && F.push(tt);
        return F;
      }
      function Vy(u) {
        var f = u.length;
        return f ? u[$m(0, f - 1)] : n;
      }
      function DM(u, f) {
        return Nf(An(u), Ga(f, 0, u.length));
      }
      function FM(u) {
        return Nf(An(u));
      }
      function pm(u, f, m) {
        (m !== n && !Ar(u[f], m) || m === n && !(f in u)) && di(u, f, m);
      }
      function Yu(u, f, m) {
        var y = u[f];
        (!(Kt.call(u, f) && Ar(y, m)) || m === n && !(f in u)) && di(u, f, m);
      }
      function yf(u, f) {
        for (var m = u.length; m--; )
          if (Ar(u[m][0], f))
            return m;
        return -1;
      }
      function zM(u, f, m, y) {
        return Zi(u, function(T, S, N) {
          f(y, T, m(T), N);
        }), y;
      }
      function Wy(u, f) {
        return u && Ur(f, De(f), u);
      }
      function BM(u, f) {
        return u && Ur(f, Mn(f), u);
      }
      function di(u, f, m) {
        f == "__proto__" && pf ? pf(u, f, {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        }) : u[f] = m;
      }
      function mm(u, f) {
        for (var m = -1, y = f.length, T = G(y), S = u == null; ++m < y; )
          T[m] = S ? n : Km(u, f[m]);
        return T;
      }
      function Ga(u, f, m) {
        return u === u && (m !== n && (u = u <= m ? u : m), f !== n && (u = u >= f ? u : f)), u;
      }
      function cr(u, f, m, y, T, S) {
        var N, F = f & d, U = f & p, tt = f & g;
        if (m && (N = T ? m(u, y, T, S) : m(u)), N !== n)
          return N;
        if (!pe(u))
          return u;
        var nt = Pt(u);
        if (nt) {
          if (N = Ek(u), !F)
            return An(u, N);
        } else {
          var it = nn(u), lt = it == at || it == Gt;
          if (ea(u))
            return p3(u, F);
          if (it == yt || it == ut || lt && !T) {
            if (N = U || lt ? {} : N3(u), !F)
              return U ? vk(u, BM(N, u)) : gk(u, Wy(N, u));
          } else {
            if (!ne[it])
              return T ? u : {};
            N = Ak(u, it, F);
          }
        }
        S || (S = new Er());
        var vt = S.get(u);
        if (vt)
          return vt;
        S.set(u, N), u4(u) ? u.forEach(function(Et) {
          N.add(cr(Et, f, m, Et, u, S));
        }) : o4(u) && u.forEach(function(Et, zt) {
          N.set(zt, cr(Et, f, m, zt, u, S));
        });
        var St = tt ? U ? Rm : Im : U ? Mn : De, Lt = nt ? n : St(u);
        return sr(Lt || u, function(Et, zt) {
          Lt && (zt = Et, Et = u[zt]), Yu(N, zt, cr(Et, f, m, zt, u, S));
        }), N;
      }
      function HM(u) {
        var f = De(u);
        return function(m) {
          return Uy(m, u, f);
        };
      }
      function Uy(u, f, m) {
        var y = m.length;
        if (u == null)
          return !y;
        for (u = Zt(u); y--; ) {
          var T = m[y], S = f[T], N = u[T];
          if (N === n && !(T in u) || !S(N))
            return !1;
        }
        return !0;
      }
      function Yy(u, f, m) {
        if (typeof u != "function")
          throw new ur(o);
        return Qu(function() {
          u.apply(n, m);
        }, f);
      }
      function qu(u, f, m, y) {
        var T = -1, S = nf, N = !0, F = u.length, U = [], tt = f.length;
        if (!F)
          return U;
        m && (f = ce(f, Wn(m))), y ? (S = em, N = !1) : f.length >= i && (S = Bu, N = !1, f = new qa(f));
        t:
          for (; ++T < F; ) {
            var nt = u[T], it = m == null ? nt : m(nt);
            if (nt = y || nt !== 0 ? nt : 0, N && it === it) {
              for (var lt = tt; lt--; )
                if (f[lt] === it)
                  continue t;
              U.push(nt);
            } else
              S(f, it, y) || U.push(nt);
          }
        return U;
      }
      var Zi = b3(Wr), qy = b3(vm, !0);
      function jM(u, f) {
        var m = !0;
        return Zi(u, function(y, T, S) {
          return m = !!f(y, T, S), m;
        }), m;
      }
      function wf(u, f, m) {
        for (var y = -1, T = u.length; ++y < T; ) {
          var S = u[y], N = f(S);
          if (N != null && (F === n ? N === N && !Yn(N) : m(N, F)))
            var F = N, U = S;
        }
        return U;
      }
      function VM(u, f, m, y) {
        var T = u.length;
        for (m = It(m), m < 0 && (m = -m > T ? 0 : T + m), y = y === n || y > T ? T : It(y), y < 0 && (y += T), y = m > y ? 0 : c4(y); m < y; )
          u[m++] = f;
        return u;
      }
      function Gy(u, f) {
        var m = [];
        return Zi(u, function(y, T, S) {
          f(y, T, S) && m.push(y);
        }), m;
      }
      function Ke(u, f, m, y, T) {
        var S = -1, N = u.length;
        for (m || (m = Mk), T || (T = []); ++S < N; ) {
          var F = u[S];
          f > 0 && m(F) ? f > 1 ? Ke(F, f - 1, m, y, T) : Gi(T, F) : y || (T[T.length] = F);
        }
        return T;
      }
      var gm = y3(), Ky = y3(!0);
      function Wr(u, f) {
        return u && gm(u, f, De);
      }
      function vm(u, f) {
        return u && Ky(u, f, De);
      }
      function xf(u, f) {
        return qi(f, function(m) {
          return vi(u[m]);
        });
      }
      function Ka(u, f) {
        f = Qi(f, u);
        for (var m = 0, y = f.length; u != null && m < y; )
          u = u[Yr(f[m++])];
        return m && m == y ? u : n;
      }
      function Xy(u, f, m) {
        var y = f(u);
        return Pt(u) ? y : Gi(y, m(u));
      }
      function cn(u) {
        return u == null ? u === n ? _A : qe : Ua && Ua in Zt(u) ? Tk(u) : Fk(u);
      }
      function _m(u, f) {
        return u > f;
      }
      function WM(u, f) {
        return u != null && Kt.call(u, f);
      }
      function UM(u, f) {
        return u != null && f in Zt(u);
      }
      function YM(u, f, m) {
        return u >= en(f, m) && u < Pe(f, m);
      }
      function bm(u, f, m) {
        for (var y = m ? em : nf, T = u[0].length, S = u.length, N = S, F = G(S), U = 1 / 0, tt = []; N--; ) {
          var nt = u[N];
          N && f && (nt = ce(nt, Wn(f))), U = en(nt.length, U), F[N] = !m && (f || T >= 120 && nt.length >= 120) ? new qa(N && nt) : n;
        }
        nt = u[0];
        var it = -1, lt = F[0];
        t:
          for (; ++it < T && tt.length < U; ) {
            var vt = nt[it], St = f ? f(vt) : vt;
            if (vt = m || vt !== 0 ? vt : 0, !(lt ? Bu(lt, St) : y(tt, St, m))) {
              for (N = S; --N; ) {
                var Lt = F[N];
                if (!(Lt ? Bu(Lt, St) : y(u[N], St, m)))
                  continue t;
              }
              lt && lt.push(St), tt.push(vt);
            }
          }
        return tt;
      }
      function qM(u, f, m, y) {
        return Wr(u, function(T, S, N) {
          f(y, m(T), S, N);
        }), y;
      }
      function Gu(u, f, m) {
        f = Qi(f, u), u = D3(u, f);
        var y = u == null ? u : u[Yr(hr(f))];
        return y == null ? n : Vn(y, u, m);
      }
      function Zy(u) {
        return ve(u) && cn(u) == ut;
      }
      function GM(u) {
        return ve(u) && cn(u) == zu;
      }
      function KM(u) {
        return ve(u) && cn(u) == ot;
      }
      function Ku(u, f, m, y, T) {
        return u === f ? !0 : u == null || f == null || !ve(u) && !ve(f) ? u !== u && f !== f : XM(u, f, m, y, Ku, T);
      }
      function XM(u, f, m, y, T, S) {
        var N = Pt(u), F = Pt(f), U = N ? ft : nn(u), tt = F ? ft : nn(f);
        U = U == ut ? yt : U, tt = tt == ut ? yt : tt;
        var nt = U == yt, it = tt == yt, lt = U == tt;
        if (lt && ea(u)) {
          if (!ea(f))
            return !1;
          N = !0, nt = !1;
        }
        if (lt && !nt)
          return S || (S = new Er()), N || us(u) ? P3(u, f, m, y, T, S) : Ck(u, f, U, m, y, T, S);
        if (!(m & v)) {
          var vt = nt && Kt.call(u, "__wrapped__"), St = it && Kt.call(f, "__wrapped__");
          if (vt || St) {
            var Lt = vt ? u.value() : u, Et = St ? f.value() : f;
            return S || (S = new Er()), T(Lt, Et, m, y, S);
          }
        }
        return lt ? (S || (S = new Er()), $k(u, f, m, y, T, S)) : !1;
      }
      function ZM(u) {
        return ve(u) && nn(u) == $t;
      }
      function ym(u, f, m, y) {
        var T = m.length, S = T, N = !y;
        if (u == null)
          return !S;
        for (u = Zt(u); T--; ) {
          var F = m[T];
          if (N && F[2] ? F[1] !== u[F[0]] : !(F[0] in u))
            return !1;
        }
        for (; ++T < S; ) {
          F = m[T];
          var U = F[0], tt = u[U], nt = F[1];
          if (N && F[2]) {
            if (tt === n && !(U in u))
              return !1;
          } else {
            var it = new Er();
            if (y)
              var lt = y(tt, nt, U, u, f, it);
            if (!(lt === n ? Ku(nt, tt, v | b, y, it) : lt))
              return !1;
          }
        }
        return !0;
      }
      function Jy(u) {
        if (!pe(u) || Nk(u))
          return !1;
        var f = vi(u) ? ZP : HA;
        return f.test(Za(u));
      }
      function JM(u) {
        return ve(u) && cn(u) == En;
      }
      function QM(u) {
        return ve(u) && nn(u) == Or;
      }
      function tk(u) {
        return ve(u) && zf(u.length) && !!ie[cn(u)];
      }
      function Qy(u) {
        return typeof u == "function" ? u : u == null ? kn : typeof u == "object" ? Pt(u) ? n3(u[0], u[1]) : e3(u) : w4(u);
      }
      function wm(u) {
        if (!Ju(u))
          return rM(u);
        var f = [];
        for (var m in Zt(u))
          Kt.call(u, m) && m != "constructor" && f.push(m);
        return f;
      }
      function ek(u) {
        if (!pe(u))
          return Dk(u);
        var f = Ju(u), m = [];
        for (var y in u)
          y == "constructor" && (f || !Kt.call(u, y)) || m.push(y);
        return m;
      }
      function xm(u, f) {
        return u < f;
      }
      function t3(u, f) {
        var m = -1, y = Pn(u) ? G(u.length) : [];
        return Zi(u, function(T, S, N) {
          y[++m] = f(T, S, N);
        }), y;
      }
      function e3(u) {
        var f = Dm(u);
        return f.length == 1 && f[0][2] ? R3(f[0][0], f[0][1]) : function(m) {
          return m === u || ym(m, u, f);
        };
      }
      function n3(u, f) {
        return zm(u) && I3(f) ? R3(Yr(u), f) : function(m) {
          var y = Km(m, u);
          return y === n && y === f ? Xm(m, u) : Ku(f, y, v | b);
        };
      }
      function Cf(u, f, m, y, T) {
        u !== f && gm(f, function(S, N) {
          if (T || (T = new Er()), pe(S))
            nk(u, f, N, m, Cf, y, T);
          else {
            var F = y ? y(Hm(u, N), S, N + "", u, f, T) : n;
            F === n && (F = S), pm(u, N, F);
          }
        }, Mn);
      }
      function nk(u, f, m, y, T, S, N) {
        var F = Hm(u, m), U = Hm(f, m), tt = N.get(U);
        if (tt) {
          pm(u, m, tt);
          return;
        }
        var nt = S ? S(F, U, m + "", u, f, N) : n, it = nt === n;
        if (it) {
          var lt = Pt(U), vt = !lt && ea(U), St = !lt && !vt && us(U);
          nt = U, lt || vt || St ? Pt(F) ? nt = F : xe(F) ? nt = An(F) : vt ? (it = !1, nt = p3(U, !0)) : St ? (it = !1, nt = m3(U, !0)) : nt = [] : tl(U) || Ja(U) ? (nt = F, Ja(F) ? nt = f4(F) : (!pe(F) || vi(F)) && (nt = N3(U))) : it = !1;
        }
        it && (N.set(U, nt), T(nt, U, y, S, N), N.delete(U)), pm(u, m, nt);
      }
      function r3(u, f) {
        var m = u.length;
        if (m)
          return f += f < 0 ? m : 0, gi(f, m) ? u[f] : n;
      }
      function i3(u, f, m) {
        f.length ? f = ce(f, function(S) {
          return Pt(S) ? function(N) {
            return Ka(N, S.length === 1 ? S[0] : S);
          } : S;
        }) : f = [kn];
        var y = -1;
        f = ce(f, Wn(Tt()));
        var T = t3(u, function(S, N, F) {
          var U = ce(f, function(tt) {
            return tt(S);
          });
          return { criteria: U, index: ++y, value: S };
        });
        return AP(T, function(S, N) {
          return mk(S, N, m);
        });
      }
      function rk(u, f) {
        return a3(u, f, function(m, y) {
          return Xm(u, y);
        });
      }
      function a3(u, f, m) {
        for (var y = -1, T = f.length, S = {}; ++y < T; ) {
          var N = f[y], F = Ka(u, N);
          m(F, N) && Xu(S, Qi(N, u), F);
        }
        return S;
      }
      function ik(u) {
        return function(f) {
          return Ka(f, u);
        };
      }
      function Cm(u, f, m, y) {
        var T = y ? EP : Zo, S = -1, N = f.length, F = u;
        for (u === f && (f = An(f)), m && (F = ce(u, Wn(m))); ++S < N; )
          for (var U = 0, tt = f[S], nt = m ? m(tt) : tt; (U = T(F, nt, U, y)) > -1; )
            F !== u && df.call(F, U, 1), df.call(u, U, 1);
        return u;
      }
      function o3(u, f) {
        for (var m = u ? f.length : 0, y = m - 1; m--; ) {
          var T = f[m];
          if (m == y || T !== S) {
            var S = T;
            gi(T) ? df.call(u, T, 1) : Sm(u, T);
          }
        }
        return u;
      }
      function $m(u, f) {
        return u + gf(By() * (f - u + 1));
      }
      function ak(u, f, m, y) {
        for (var T = -1, S = Pe(mf((f - u) / (m || 1)), 0), N = G(S); S--; )
          N[y ? S : ++T] = u, u += m;
        return N;
      }
      function Tm(u, f) {
        var m = "";
        if (!u || f < 1 || f > Z)
          return m;
        do
          f % 2 && (m += u), f = gf(f / 2), f && (u += u);
        while (f);
        return m;
      }
      function Dt(u, f) {
        return jm(L3(u, f, kn), u + "");
      }
      function ok(u) {
        return Vy(ls(u));
      }
      function sk(u, f) {
        var m = ls(u);
        return Nf(m, Ga(f, 0, m.length));
      }
      function Xu(u, f, m, y) {
        if (!pe(u))
          return u;
        f = Qi(f, u);
        for (var T = -1, S = f.length, N = S - 1, F = u; F != null && ++T < S; ) {
          var U = Yr(f[T]), tt = m;
          if (U === "__proto__" || U === "constructor" || U === "prototype")
            return u;
          if (T != N) {
            var nt = F[U];
            tt = y ? y(nt, U, F) : n, tt === n && (tt = pe(nt) ? nt : gi(f[T + 1]) ? [] : {});
          }
          Yu(F, U, tt), F = F[U];
        }
        return u;
      }
      var s3 = vf ? function(u, f) {
        return vf.set(u, f), u;
      } : kn, uk = pf ? function(u, f) {
        return pf(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Jm(f),
          writable: !0
        });
      } : kn;
      function lk(u) {
        return Nf(ls(u));
      }
      function fr(u, f, m) {
        var y = -1, T = u.length;
        f < 0 && (f = -f > T ? 0 : T + f), m = m > T ? T : m, m < 0 && (m += T), T = f > m ? 0 : m - f >>> 0, f >>>= 0;
        for (var S = G(T); ++y < T; )
          S[y] = u[y + f];
        return S;
      }
      function ck(u, f) {
        var m;
        return Zi(u, function(y, T, S) {
          return m = f(y, T, S), !m;
        }), !!m;
      }
      function $f(u, f, m) {
        var y = 0, T = u == null ? y : u.length;
        if (typeof f == "number" && f === f && T <= et) {
          for (; y < T; ) {
            var S = y + T >>> 1, N = u[S];
            N !== null && !Yn(N) && (m ? N <= f : N < f) ? y = S + 1 : T = S;
          }
          return T;
        }
        return Om(u, f, kn, m);
      }
      function Om(u, f, m, y) {
        var T = 0, S = u == null ? 0 : u.length;
        if (S === 0)
          return 0;
        f = m(f);
        for (var N = f !== f, F = f === null, U = Yn(f), tt = f === n; T < S; ) {
          var nt = gf((T + S) / 2), it = m(u[nt]), lt = it !== n, vt = it === null, St = it === it, Lt = Yn(it);
          if (N)
            var Et = y || St;
          else
            tt ? Et = St && (y || lt) : F ? Et = St && lt && (y || !vt) : U ? Et = St && lt && !vt && (y || !Lt) : vt || Lt ? Et = !1 : Et = y ? it <= f : it < f;
          Et ? T = nt + 1 : S = nt;
        }
        return en(S, X);
      }
      function u3(u, f) {
        for (var m = -1, y = u.length, T = 0, S = []; ++m < y; ) {
          var N = u[m], F = f ? f(N) : N;
          if (!m || !Ar(F, U)) {
            var U = F;
            S[T++] = N === 0 ? 0 : N;
          }
        }
        return S;
      }
      function l3(u) {
        return typeof u == "number" ? u : Yn(u) ? H : +u;
      }
      function Un(u) {
        if (typeof u == "string")
          return u;
        if (Pt(u))
          return ce(u, Un) + "";
        if (Yn(u))
          return Hy ? Hy.call(u) : "";
        var f = u + "";
        return f == "0" && 1 / u == -q ? "-0" : f;
      }
      function Ji(u, f, m) {
        var y = -1, T = nf, S = u.length, N = !0, F = [], U = F;
        if (m)
          N = !1, T = em;
        else if (S >= i) {
          var tt = f ? null : wk(u);
          if (tt)
            return af(tt);
          N = !1, T = Bu, U = new qa();
        } else
          U = f ? [] : F;
        t:
          for (; ++y < S; ) {
            var nt = u[y], it = f ? f(nt) : nt;
            if (nt = m || nt !== 0 ? nt : 0, N && it === it) {
              for (var lt = U.length; lt--; )
                if (U[lt] === it)
                  continue t;
              f && U.push(it), F.push(nt);
            } else
              T(U, it, m) || (U !== F && U.push(it), F.push(nt));
          }
        return F;
      }
      function Sm(u, f) {
        return f = Qi(f, u), u = D3(u, f), u == null || delete u[Yr(hr(f))];
      }
      function c3(u, f, m, y) {
        return Xu(u, f, m(Ka(u, f)), y);
      }
      function Tf(u, f, m, y) {
        for (var T = u.length, S = y ? T : -1; (y ? S-- : ++S < T) && f(u[S], S, u); )
          ;
        return m ? fr(u, y ? 0 : S, y ? S + 1 : T) : fr(u, y ? S + 1 : 0, y ? T : S);
      }
      function f3(u, f) {
        var m = u;
        return m instanceof Ht && (m = m.value()), nm(f, function(y, T) {
          return T.func.apply(T.thisArg, Gi([y], T.args));
        }, m);
      }
      function Em(u, f, m) {
        var y = u.length;
        if (y < 2)
          return y ? Ji(u[0]) : [];
        for (var T = -1, S = G(y); ++T < y; )
          for (var N = u[T], F = -1; ++F < y; )
            F != T && (S[T] = qu(S[T] || N, u[F], f, m));
        return Ji(Ke(S, 1), f, m);
      }
      function h3(u, f, m) {
        for (var y = -1, T = u.length, S = f.length, N = {}; ++y < T; ) {
          var F = y < S ? f[y] : n;
          m(N, u[y], F);
        }
        return N;
      }
      function Am(u) {
        return xe(u) ? u : [];
      }
      function Pm(u) {
        return typeof u == "function" ? u : kn;
      }
      function Qi(u, f) {
        return Pt(u) ? u : zm(u, f) ? [u] : H3(qt(u));
      }
      var fk = Dt;
      function ta(u, f, m) {
        var y = u.length;
        return m = m === n ? y : m, !f && m >= y ? u : fr(u, f, m);
      }
      var d3 = JP || function(u) {
        return Ge.clearTimeout(u);
      };
      function p3(u, f) {
        if (f)
          return u.slice();
        var m = u.length, y = Ry ? Ry(m) : new u.constructor(m);
        return u.copy(y), y;
      }
      function Mm(u) {
        var f = new u.constructor(u.byteLength);
        return new ff(f).set(new ff(u)), f;
      }
      function hk(u, f) {
        var m = f ? Mm(u.buffer) : u.buffer;
        return new u.constructor(m, u.byteOffset, u.byteLength);
      }
      function dk(u) {
        var f = new u.constructor(u.source, Zb.exec(u));
        return f.lastIndex = u.lastIndex, f;
      }
      function pk(u) {
        return Uu ? Zt(Uu.call(u)) : {};
      }
      function m3(u, f) {
        var m = f ? Mm(u.buffer) : u.buffer;
        return new u.constructor(m, u.byteOffset, u.length);
      }
      function g3(u, f) {
        if (u !== f) {
          var m = u !== n, y = u === null, T = u === u, S = Yn(u), N = f !== n, F = f === null, U = f === f, tt = Yn(f);
          if (!F && !tt && !S && u > f || S && N && U && !F && !tt || y && N && U || !m && U || !T)
            return 1;
          if (!y && !S && !tt && u < f || tt && m && T && !y && !S || F && m && T || !N && T || !U)
            return -1;
        }
        return 0;
      }
      function mk(u, f, m) {
        for (var y = -1, T = u.criteria, S = f.criteria, N = T.length, F = m.length; ++y < N; ) {
          var U = g3(T[y], S[y]);
          if (U) {
            if (y >= F)
              return U;
            var tt = m[y];
            return U * (tt == "desc" ? -1 : 1);
          }
        }
        return u.index - f.index;
      }
      function v3(u, f, m, y) {
        for (var T = -1, S = u.length, N = m.length, F = -1, U = f.length, tt = Pe(S - N, 0), nt = G(U + tt), it = !y; ++F < U; )
          nt[F] = f[F];
        for (; ++T < N; )
          (it || T < S) && (nt[m[T]] = u[T]);
        for (; tt--; )
          nt[F++] = u[T++];
        return nt;
      }
      function _3(u, f, m, y) {
        for (var T = -1, S = u.length, N = -1, F = m.length, U = -1, tt = f.length, nt = Pe(S - F, 0), it = G(nt + tt), lt = !y; ++T < nt; )
          it[T] = u[T];
        for (var vt = T; ++U < tt; )
          it[vt + U] = f[U];
        for (; ++N < F; )
          (lt || T < S) && (it[vt + m[N]] = u[T++]);
        return it;
      }
      function An(u, f) {
        var m = -1, y = u.length;
        for (f || (f = G(y)); ++m < y; )
          f[m] = u[m];
        return f;
      }
      function Ur(u, f, m, y) {
        var T = !m;
        m || (m = {});
        for (var S = -1, N = f.length; ++S < N; ) {
          var F = f[S], U = y ? y(m[F], u[F], F, m, u) : n;
          U === n && (U = u[F]), T ? di(m, F, U) : Yu(m, F, U);
        }
        return m;
      }
      function gk(u, f) {
        return Ur(u, Fm(u), f);
      }
      function vk(u, f) {
        return Ur(u, M3(u), f);
      }
      function Of(u, f) {
        return function(m, y) {
          var T = Pt(m) ? xP : zM, S = f ? f() : {};
          return T(m, u, Tt(y, 2), S);
        };
      }
      function as(u) {
        return Dt(function(f, m) {
          var y = -1, T = m.length, S = T > 1 ? m[T - 1] : n, N = T > 2 ? m[2] : n;
          for (S = u.length > 3 && typeof S == "function" ? (T--, S) : n, N && fn(m[0], m[1], N) && (S = T < 3 ? n : S, T = 1), f = Zt(f); ++y < T; ) {
            var F = m[y];
            F && u(f, F, y, S);
          }
          return f;
        });
      }
      function b3(u, f) {
        return function(m, y) {
          if (m == null)
            return m;
          if (!Pn(m))
            return u(m, y);
          for (var T = m.length, S = f ? T : -1, N = Zt(m); (f ? S-- : ++S < T) && y(N[S], S, N) !== !1; )
            ;
          return m;
        };
      }
      function y3(u) {
        return function(f, m, y) {
          for (var T = -1, S = Zt(f), N = y(f), F = N.length; F--; ) {
            var U = N[u ? F : ++T];
            if (m(S[U], U, S) === !1)
              break;
          }
          return f;
        };
      }
      function _k(u, f, m) {
        var y = f & _, T = Zu(u);
        function S() {
          var N = this && this !== Ge && this instanceof S ? T : u;
          return N.apply(y ? m : this, arguments);
        }
        return S;
      }
      function w3(u) {
        return function(f) {
          f = qt(f);
          var m = Jo(f) ? Sr(f) : n, y = m ? m[0] : f.charAt(0), T = m ? ta(m, 1).join("") : f.slice(1);
          return y[u]() + T;
        };
      }
      function os(u) {
        return function(f) {
          return nm(b4(_4(f).replace(uP, "")), u, "");
        };
      }
      function Zu(u) {
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return new u();
            case 1:
              return new u(f[0]);
            case 2:
              return new u(f[0], f[1]);
            case 3:
              return new u(f[0], f[1], f[2]);
            case 4:
              return new u(f[0], f[1], f[2], f[3]);
            case 5:
              return new u(f[0], f[1], f[2], f[3], f[4]);
            case 6:
              return new u(f[0], f[1], f[2], f[3], f[4], f[5]);
            case 7:
              return new u(f[0], f[1], f[2], f[3], f[4], f[5], f[6]);
          }
          var m = is(u.prototype), y = u.apply(m, f);
          return pe(y) ? y : m;
        };
      }
      function bk(u, f, m) {
        var y = Zu(u);
        function T() {
          for (var S = arguments.length, N = G(S), F = S, U = ss(T); F--; )
            N[F] = arguments[F];
          var tt = S < 3 && N[0] !== U && N[S - 1] !== U ? [] : Ki(N, U);
          if (S -= tt.length, S < m)
            return O3(
              u,
              f,
              Sf,
              T.placeholder,
              n,
              N,
              tt,
              n,
              n,
              m - S
            );
          var nt = this && this !== Ge && this instanceof T ? y : u;
          return Vn(nt, this, N);
        }
        return T;
      }
      function x3(u) {
        return function(f, m, y) {
          var T = Zt(f);
          if (!Pn(f)) {
            var S = Tt(m, 3);
            f = De(f), m = function(F) {
              return S(T[F], F, T);
            };
          }
          var N = u(f, m, y);
          return N > -1 ? T[S ? f[N] : N] : n;
        };
      }
      function C3(u) {
        return mi(function(f) {
          var m = f.length, y = m, T = lr.prototype.thru;
          for (u && f.reverse(); y--; ) {
            var S = f[y];
            if (typeof S != "function")
              throw new ur(o);
            if (T && !N && Mf(S) == "wrapper")
              var N = new lr([], !0);
          }
          for (y = N ? y : m; ++y < m; ) {
            S = f[y];
            var F = Mf(S), U = F == "wrapper" ? Lm(S) : n;
            U && Bm(U[0]) && U[1] == (R | C | E | L) && !U[4].length && U[9] == 1 ? N = N[Mf(U[0])].apply(N, U[3]) : N = S.length == 1 && Bm(S) ? N[F]() : N.thru(S);
          }
          return function() {
            var tt = arguments, nt = tt[0];
            if (N && tt.length == 1 && Pt(nt))
              return N.plant(nt).value();
            for (var it = 0, lt = m ? f[it].apply(this, tt) : nt; ++it < m; )
              lt = f[it].call(this, lt);
            return lt;
          };
        });
      }
      function Sf(u, f, m, y, T, S, N, F, U, tt) {
        var nt = f & R, it = f & _, lt = f & w, vt = f & (C | $), St = f & W, Lt = lt ? n : Zu(u);
        function Et() {
          for (var zt = arguments.length, jt = G(zt), qn = zt; qn--; )
            jt[qn] = arguments[qn];
          if (vt)
            var hn = ss(Et), Gn = MP(jt, hn);
          if (y && (jt = v3(jt, y, T, vt)), S && (jt = _3(jt, S, N, vt)), zt -= Gn, vt && zt < tt) {
            var Ce = Ki(jt, hn);
            return O3(
              u,
              f,
              Sf,
              Et.placeholder,
              m,
              jt,
              Ce,
              F,
              U,
              tt - zt
            );
          }
          var Pr = it ? m : this, bi = lt ? Pr[u] : u;
          return zt = jt.length, F ? jt = zk(jt, F) : St && zt > 1 && jt.reverse(), nt && U < zt && (jt.length = U), this && this !== Ge && this instanceof Et && (bi = Lt || Zu(bi)), bi.apply(Pr, jt);
        }
        return Et;
      }
      function $3(u, f) {
        return function(m, y) {
          return qM(m, u, f(y), {});
        };
      }
      function Ef(u, f) {
        return function(m, y) {
          var T;
          if (m === n && y === n)
            return f;
          if (m !== n && (T = m), y !== n) {
            if (T === n)
              return y;
            typeof m == "string" || typeof y == "string" ? (m = Un(m), y = Un(y)) : (m = l3(m), y = l3(y)), T = u(m, y);
          }
          return T;
        };
      }
      function km(u) {
        return mi(function(f) {
          return f = ce(f, Wn(Tt())), Dt(function(m) {
            var y = this;
            return u(f, function(T) {
              return Vn(T, y, m);
            });
          });
        });
      }
      function Af(u, f) {
        f = f === n ? " " : Un(f);
        var m = f.length;
        if (m < 2)
          return m ? Tm(f, u) : f;
        var y = Tm(f, mf(u / Qo(f)));
        return Jo(f) ? ta(Sr(y), 0, u).join("") : y.slice(0, u);
      }
      function yk(u, f, m, y) {
        var T = f & _, S = Zu(u);
        function N() {
          for (var F = -1, U = arguments.length, tt = -1, nt = y.length, it = G(nt + U), lt = this && this !== Ge && this instanceof N ? S : u; ++tt < nt; )
            it[tt] = y[tt];
          for (; U--; )
            it[tt++] = arguments[++F];
          return Vn(lt, T ? m : this, it);
        }
        return N;
      }
      function T3(u) {
        return function(f, m, y) {
          return y && typeof y != "number" && fn(f, m, y) && (m = y = n), f = _i(f), m === n ? (m = f, f = 0) : m = _i(m), y = y === n ? f < m ? 1 : -1 : _i(y), ak(f, m, y, u);
        };
      }
      function Pf(u) {
        return function(f, m) {
          return typeof f == "string" && typeof m == "string" || (f = dr(f), m = dr(m)), u(f, m);
        };
      }
      function O3(u, f, m, y, T, S, N, F, U, tt) {
        var nt = f & C, it = nt ? N : n, lt = nt ? n : N, vt = nt ? S : n, St = nt ? n : S;
        f |= nt ? E : A, f &= ~(nt ? A : E), f & x || (f &= ~(_ | w));
        var Lt = [
          u,
          f,
          T,
          vt,
          it,
          St,
          lt,
          F,
          U,
          tt
        ], Et = m.apply(n, Lt);
        return Bm(u) && F3(Et, Lt), Et.placeholder = y, z3(Et, u, f);
      }
      function Nm(u) {
        var f = Ae[u];
        return function(m, y) {
          if (m = dr(m), y = y == null ? 0 : en(It(y), 292), y && zy(m)) {
            var T = (qt(m) + "e").split("e"), S = f(T[0] + "e" + (+T[1] + y));
            return T = (qt(S) + "e").split("e"), +(T[0] + "e" + (+T[1] - y));
          }
          return f(m);
        };
      }
      var wk = ns && 1 / af(new ns([, -0]))[1] == q ? function(u) {
        return new ns(u);
      } : eg;
      function S3(u) {
        return function(f) {
          var m = nn(f);
          return m == $t ? lm(f) : m == Or ? FP(f) : PP(f, u(f));
        };
      }
      function pi(u, f, m, y, T, S, N, F) {
        var U = f & w;
        if (!U && typeof u != "function")
          throw new ur(o);
        var tt = y ? y.length : 0;
        if (tt || (f &= ~(E | A), y = T = n), N = N === n ? N : Pe(It(N), 0), F = F === n ? F : It(F), tt -= T ? T.length : 0, f & A) {
          var nt = y, it = T;
          y = T = n;
        }
        var lt = U ? n : Lm(u), vt = [
          u,
          f,
          m,
          y,
          T,
          nt,
          it,
          S,
          N,
          F
        ];
        if (lt && Lk(vt, lt), u = vt[0], f = vt[1], m = vt[2], y = vt[3], T = vt[4], F = vt[9] = vt[9] === n ? U ? 0 : u.length : Pe(vt[9] - tt, 0), !F && f & (C | $) && (f &= ~(C | $)), !f || f == _)
          var St = _k(u, f, m);
        else
          f == C || f == $ ? St = bk(u, f, F) : (f == E || f == (_ | E)) && !T.length ? St = yk(u, f, m, y) : St = Sf.apply(n, vt);
        var Lt = lt ? s3 : F3;
        return z3(Lt(St, vt), u, f);
      }
      function E3(u, f, m, y) {
        return u === n || Ar(u, es[m]) && !Kt.call(y, m) ? f : u;
      }
      function A3(u, f, m, y, T, S) {
        return pe(u) && pe(f) && (S.set(f, u), Cf(u, f, n, A3, S), S.delete(f)), u;
      }
      function xk(u) {
        return tl(u) ? n : u;
      }
      function P3(u, f, m, y, T, S) {
        var N = m & v, F = u.length, U = f.length;
        if (F != U && !(N && U > F))
          return !1;
        var tt = S.get(u), nt = S.get(f);
        if (tt && nt)
          return tt == f && nt == u;
        var it = -1, lt = !0, vt = m & b ? new qa() : n;
        for (S.set(u, f), S.set(f, u); ++it < F; ) {
          var St = u[it], Lt = f[it];
          if (y)
            var Et = N ? y(Lt, St, it, f, u, S) : y(St, Lt, it, u, f, S);
          if (Et !== n) {
            if (Et)
              continue;
            lt = !1;
            break;
          }
          if (vt) {
            if (!rm(f, function(zt, jt) {
              if (!Bu(vt, jt) && (St === zt || T(St, zt, m, y, S)))
                return vt.push(jt);
            })) {
              lt = !1;
              break;
            }
          } else if (!(St === Lt || T(St, Lt, m, y, S))) {
            lt = !1;
            break;
          }
        }
        return S.delete(u), S.delete(f), lt;
      }
      function Ck(u, f, m, y, T, S, N) {
        switch (m) {
          case Ko:
            if (u.byteLength != f.byteLength || u.byteOffset != f.byteOffset)
              return !1;
            u = u.buffer, f = f.buffer;
          case zu:
            return !(u.byteLength != f.byteLength || !S(new ff(u), new ff(f)));
          case Nt:
          case ot:
          case le:
            return Ar(+u, +f);
          case kt:
            return u.name == f.name && u.message == f.message;
          case En:
          case Du:
            return u == f + "";
          case $t:
            var F = lm;
          case Or:
            var U = y & v;
            if (F || (F = af), u.size != f.size && !U)
              return !1;
            var tt = N.get(u);
            if (tt)
              return tt == f;
            y |= b, N.set(u, f);
            var nt = P3(F(u), F(f), y, T, S, N);
            return N.delete(u), nt;
          case Jc:
            if (Uu)
              return Uu.call(u) == Uu.call(f);
        }
        return !1;
      }
      function $k(u, f, m, y, T, S) {
        var N = m & v, F = Im(u), U = F.length, tt = Im(f), nt = tt.length;
        if (U != nt && !N)
          return !1;
        for (var it = U; it--; ) {
          var lt = F[it];
          if (!(N ? lt in f : Kt.call(f, lt)))
            return !1;
        }
        var vt = S.get(u), St = S.get(f);
        if (vt && St)
          return vt == f && St == u;
        var Lt = !0;
        S.set(u, f), S.set(f, u);
        for (var Et = N; ++it < U; ) {
          lt = F[it];
          var zt = u[lt], jt = f[lt];
          if (y)
            var qn = N ? y(jt, zt, lt, f, u, S) : y(zt, jt, lt, u, f, S);
          if (!(qn === n ? zt === jt || T(zt, jt, m, y, S) : qn)) {
            Lt = !1;
            break;
          }
          Et || (Et = lt == "constructor");
        }
        if (Lt && !Et) {
          var hn = u.constructor, Gn = f.constructor;
          hn != Gn && "constructor" in u && "constructor" in f && !(typeof hn == "function" && hn instanceof hn && typeof Gn == "function" && Gn instanceof Gn) && (Lt = !1);
        }
        return S.delete(u), S.delete(f), Lt;
      }
      function mi(u) {
        return jm(L3(u, n, U3), u + "");
      }
      function Im(u) {
        return Xy(u, De, Fm);
      }
      function Rm(u) {
        return Xy(u, Mn, M3);
      }
      var Lm = vf ? function(u) {
        return vf.get(u);
      } : eg;
      function Mf(u) {
        for (var f = u.name + "", m = rs[f], y = Kt.call(rs, f) ? m.length : 0; y--; ) {
          var T = m[y], S = T.func;
          if (S == null || S == u)
            return T.name;
        }
        return f;
      }
      function ss(u) {
        var f = Kt.call(O, "placeholder") ? O : u;
        return f.placeholder;
      }
      function Tt() {
        var u = O.iteratee || Qm;
        return u = u === Qm ? Qy : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function kf(u, f) {
        var m = u.__data__;
        return kk(f) ? m[typeof f == "string" ? "string" : "hash"] : m.map;
      }
      function Dm(u) {
        for (var f = De(u), m = f.length; m--; ) {
          var y = f[m], T = u[y];
          f[m] = [y, T, I3(T)];
        }
        return f;
      }
      function Xa(u, f) {
        var m = RP(u, f);
        return Jy(m) ? m : n;
      }
      function Tk(u) {
        var f = Kt.call(u, Ua), m = u[Ua];
        try {
          u[Ua] = n;
          var y = !0;
        } catch (S) {
        }
        var T = lf.call(u);
        return y && (f ? u[Ua] = m : delete u[Ua]), T;
      }
      var Fm = fm ? function(u) {
        return u == null ? [] : (u = Zt(u), qi(fm(u), function(f) {
          return Dy.call(u, f);
        }));
      } : ng, M3 = fm ? function(u) {
        for (var f = []; u; )
          Gi(f, Fm(u)), u = hf(u);
        return f;
      } : ng, nn = cn;
      (hm && nn(new hm(new ArrayBuffer(1))) != Ko || ju && nn(new ju()) != $t || dm && nn(dm.resolve()) != re || ns && nn(new ns()) != Or || Vu && nn(new Vu()) != Fu) && (nn = function(u) {
        var f = cn(u), m = f == yt ? u.constructor : n, y = m ? Za(m) : "";
        if (y)
          switch (y) {
            case sM:
              return Ko;
            case uM:
              return $t;
            case lM:
              return re;
            case cM:
              return Or;
            case fM:
              return Fu;
          }
        return f;
      });
      function Ok(u, f, m) {
        for (var y = -1, T = m.length; ++y < T; ) {
          var S = m[y], N = S.size;
          switch (S.type) {
            case "drop":
              u += N;
              break;
            case "dropRight":
              f -= N;
              break;
            case "take":
              f = en(f, u + N);
              break;
            case "takeRight":
              u = Pe(u, f - N);
              break;
          }
        }
        return { start: u, end: f };
      }
      function Sk(u) {
        var f = u.match(NA);
        return f ? f[1].split(IA) : [];
      }
      function k3(u, f, m) {
        f = Qi(f, u);
        for (var y = -1, T = f.length, S = !1; ++y < T; ) {
          var N = Yr(f[y]);
          if (!(S = u != null && m(u, N)))
            break;
          u = u[N];
        }
        return S || ++y != T ? S : (T = u == null ? 0 : u.length, !!T && zf(T) && gi(N, T) && (Pt(u) || Ja(u)));
      }
      function Ek(u) {
        var f = u.length, m = new u.constructor(f);
        return f && typeof u[0] == "string" && Kt.call(u, "index") && (m.index = u.index, m.input = u.input), m;
      }
      function N3(u) {
        return typeof u.constructor == "function" && !Ju(u) ? is(hf(u)) : {};
      }
      function Ak(u, f, m) {
        var y = u.constructor;
        switch (f) {
          case zu:
            return Mm(u);
          case Nt:
          case ot:
            return new y(+u);
          case Ko:
            return hk(u, m);
          case D1:
          case F1:
          case z1:
          case B1:
          case H1:
          case j1:
          case V1:
          case W1:
          case U1:
            return m3(u, m);
          case $t:
            return new y();
          case le:
          case Du:
            return new y(u);
          case En:
            return dk(u);
          case Or:
            return new y();
          case Jc:
            return pk(u);
        }
      }
      function Pk(u, f) {
        var m = f.length;
        if (!m)
          return u;
        var y = m - 1;
        return f[y] = (m > 1 ? "& " : "") + f[y], f = f.join(m > 2 ? ", " : " "), u.replace(kA, `{
/* [wrapped with ` + f + `] */
`);
      }
      function Mk(u) {
        return Pt(u) || Ja(u) || !!(Fy && u && u[Fy]);
      }
      function gi(u, f) {
        var m = typeof u;
        return f = f == null ? Z : f, !!f && (m == "number" || m != "symbol" && VA.test(u)) && u > -1 && u % 1 == 0 && u < f;
      }
      function fn(u, f, m) {
        if (!pe(m))
          return !1;
        var y = typeof f;
        return (y == "number" ? Pn(m) && gi(f, m.length) : y == "string" && f in m) ? Ar(m[f], u) : !1;
      }
      function zm(u, f) {
        if (Pt(u))
          return !1;
        var m = typeof u;
        return m == "number" || m == "symbol" || m == "boolean" || u == null || Yn(u) ? !0 : EA.test(u) || !SA.test(u) || f != null && u in Zt(f);
      }
      function kk(u) {
        var f = typeof u;
        return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? u !== "__proto__" : u === null;
      }
      function Bm(u) {
        var f = Mf(u), m = O[f];
        if (typeof m != "function" || !(f in Ht.prototype))
          return !1;
        if (u === m)
          return !0;
        var y = Lm(m);
        return !!y && u === y[0];
      }
      function Nk(u) {
        return !!Iy && Iy in u;
      }
      var Ik = sf ? vi : rg;
      function Ju(u) {
        var f = u && u.constructor, m = typeof f == "function" && f.prototype || es;
        return u === m;
      }
      function I3(u) {
        return u === u && !pe(u);
      }
      function R3(u, f) {
        return function(m) {
          return m == null ? !1 : m[u] === f && (f !== n || u in Zt(m));
        };
      }
      function Rk(u) {
        var f = Df(u, function(y) {
          return m.size === c && m.clear(), y;
        }), m = f.cache;
        return f;
      }
      function Lk(u, f) {
        var m = u[1], y = f[1], T = m | y, S = T < (_ | w | R), N = y == R && m == C || y == R && m == L && u[7].length <= f[8] || y == (R | L) && f[7].length <= f[8] && m == C;
        if (!(S || N))
          return u;
        y & _ && (u[2] = f[2], T |= m & _ ? 0 : x);
        var F = f[3];
        if (F) {
          var U = u[3];
          u[3] = U ? v3(U, F, f[4]) : F, u[4] = U ? Ki(u[3], h) : f[4];
        }
        return F = f[5], F && (U = u[5], u[5] = U ? _3(U, F, f[6]) : F, u[6] = U ? Ki(u[5], h) : f[6]), F = f[7], F && (u[7] = F), y & R && (u[8] = u[8] == null ? f[8] : en(u[8], f[8])), u[9] == null && (u[9] = f[9]), u[0] = f[0], u[1] = T, u;
      }
      function Dk(u) {
        var f = [];
        if (u != null)
          for (var m in Zt(u))
            f.push(m);
        return f;
      }
      function Fk(u) {
        return lf.call(u);
      }
      function L3(u, f, m) {
        return f = Pe(f === n ? u.length - 1 : f, 0), function() {
          for (var y = arguments, T = -1, S = Pe(y.length - f, 0), N = G(S); ++T < S; )
            N[T] = y[f + T];
          T = -1;
          for (var F = G(f + 1); ++T < f; )
            F[T] = y[T];
          return F[f] = m(N), Vn(u, this, F);
        };
      }
      function D3(u, f) {
        return f.length < 2 ? u : Ka(u, fr(f, 0, -1));
      }
      function zk(u, f) {
        for (var m = u.length, y = en(f.length, m), T = An(u); y--; ) {
          var S = f[y];
          u[y] = gi(S, m) ? T[S] : n;
        }
        return u;
      }
      function Hm(u, f) {
        if (!(f === "constructor" && typeof u[f] == "function") && f != "__proto__")
          return u[f];
      }
      var F3 = B3(s3), Qu = tM || function(u, f) {
        return Ge.setTimeout(u, f);
      }, jm = B3(uk);
      function z3(u, f, m) {
        var y = f + "";
        return jm(u, Pk(y, Bk(Sk(y), m)));
      }
      function B3(u) {
        var f = 0, m = 0;
        return function() {
          var y = iM(), T = V - (y - m);
          if (m = y, T > 0) {
            if (++f >= Y)
              return arguments[0];
          } else
            f = 0;
          return u.apply(n, arguments);
        };
      }
      function Nf(u, f) {
        var m = -1, y = u.length, T = y - 1;
        for (f = f === n ? y : f; ++m < f; ) {
          var S = $m(m, T), N = u[S];
          u[S] = u[m], u[m] = N;
        }
        return u.length = f, u;
      }
      var H3 = Rk(function(u) {
        var f = [];
        return u.charCodeAt(0) === 46 && f.push(""), u.replace(AA, function(m, y, T, S) {
          f.push(T ? S.replace(DA, "$1") : y || m);
        }), f;
      });
      function Yr(u) {
        if (typeof u == "string" || Yn(u))
          return u;
        var f = u + "";
        return f == "0" && 1 / u == -q ? "-0" : f;
      }
      function Za(u) {
        if (u != null) {
          try {
            return uf.call(u);
          } catch (f) {
          }
          try {
            return u + "";
          } catch (f) {
          }
        }
        return "";
      }
      function Bk(u, f) {
        return sr(rt, function(m) {
          var y = "_." + m[0];
          f & m[1] && !nf(u, y) && u.push(y);
        }), u.sort();
      }
      function j3(u) {
        if (u instanceof Ht)
          return u.clone();
        var f = new lr(u.__wrapped__, u.__chain__);
        return f.__actions__ = An(u.__actions__), f.__index__ = u.__index__, f.__values__ = u.__values__, f;
      }
      function Hk(u, f, m) {
        (m ? fn(u, f, m) : f === n) ? f = 1 : f = Pe(It(f), 0);
        var y = u == null ? 0 : u.length;
        if (!y || f < 1)
          return [];
        for (var T = 0, S = 0, N = G(mf(y / f)); T < y; )
          N[S++] = fr(u, T, T += f);
        return N;
      }
      function jk(u) {
        for (var f = -1, m = u == null ? 0 : u.length, y = 0, T = []; ++f < m; ) {
          var S = u[f];
          S && (T[y++] = S);
        }
        return T;
      }
      function Vk() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var f = G(u - 1), m = arguments[0], y = u; y--; )
          f[y - 1] = arguments[y];
        return Gi(Pt(m) ? An(m) : [m], Ke(f, 1));
      }
      var Wk = Dt(function(u, f) {
        return xe(u) ? qu(u, Ke(f, 1, xe, !0)) : [];
      }), Uk = Dt(function(u, f) {
        var m = hr(f);
        return xe(m) && (m = n), xe(u) ? qu(u, Ke(f, 1, xe, !0), Tt(m, 2)) : [];
      }), Yk = Dt(function(u, f) {
        var m = hr(f);
        return xe(m) && (m = n), xe(u) ? qu(u, Ke(f, 1, xe, !0), n, m) : [];
      });
      function qk(u, f, m) {
        var y = u == null ? 0 : u.length;
        return y ? (f = m || f === n ? 1 : It(f), fr(u, f < 0 ? 0 : f, y)) : [];
      }
      function Gk(u, f, m) {
        var y = u == null ? 0 : u.length;
        return y ? (f = m || f === n ? 1 : It(f), f = y - f, fr(u, 0, f < 0 ? 0 : f)) : [];
      }
      function Kk(u, f) {
        return u && u.length ? Tf(u, Tt(f, 3), !0, !0) : [];
      }
      function Xk(u, f) {
        return u && u.length ? Tf(u, Tt(f, 3), !0) : [];
      }
      function Zk(u, f, m, y) {
        var T = u == null ? 0 : u.length;
        return T ? (m && typeof m != "number" && fn(u, f, m) && (m = 0, y = T), VM(u, f, m, y)) : [];
      }
      function V3(u, f, m) {
        var y = u == null ? 0 : u.length;
        if (!y)
          return -1;
        var T = m == null ? 0 : It(m);
        return T < 0 && (T = Pe(y + T, 0)), rf(u, Tt(f, 3), T);
      }
      function W3(u, f, m) {
        var y = u == null ? 0 : u.length;
        if (!y)
          return -1;
        var T = y - 1;
        return m !== n && (T = It(m), T = m < 0 ? Pe(y + T, 0) : en(T, y - 1)), rf(u, Tt(f, 3), T, !0);
      }
      function U3(u) {
        var f = u == null ? 0 : u.length;
        return f ? Ke(u, 1) : [];
      }
      function Jk(u) {
        var f = u == null ? 0 : u.length;
        return f ? Ke(u, q) : [];
      }
      function Qk(u, f) {
        var m = u == null ? 0 : u.length;
        return m ? (f = f === n ? 1 : It(f), Ke(u, f)) : [];
      }
      function tN(u) {
        for (var f = -1, m = u == null ? 0 : u.length, y = {}; ++f < m; ) {
          var T = u[f];
          y[T[0]] = T[1];
        }
        return y;
      }
      function Y3(u) {
        return u && u.length ? u[0] : n;
      }
      function eN(u, f, m) {
        var y = u == null ? 0 : u.length;
        if (!y)
          return -1;
        var T = m == null ? 0 : It(m);
        return T < 0 && (T = Pe(y + T, 0)), Zo(u, f, T);
      }
      function nN(u) {
        var f = u == null ? 0 : u.length;
        return f ? fr(u, 0, -1) : [];
      }
      var rN = Dt(function(u) {
        var f = ce(u, Am);
        return f.length && f[0] === u[0] ? bm(f) : [];
      }), iN = Dt(function(u) {
        var f = hr(u), m = ce(u, Am);
        return f === hr(m) ? f = n : m.pop(), m.length && m[0] === u[0] ? bm(m, Tt(f, 2)) : [];
      }), aN = Dt(function(u) {
        var f = hr(u), m = ce(u, Am);
        return f = typeof f == "function" ? f : n, f && m.pop(), m.length && m[0] === u[0] ? bm(m, n, f) : [];
      });
      function oN(u, f) {
        return u == null ? "" : nM.call(u, f);
      }
      function hr(u) {
        var f = u == null ? 0 : u.length;
        return f ? u[f - 1] : n;
      }
      function sN(u, f, m) {
        var y = u == null ? 0 : u.length;
        if (!y)
          return -1;
        var T = y;
        return m !== n && (T = It(m), T = T < 0 ? Pe(y + T, 0) : en(T, y - 1)), f === f ? BP(u, f, T) : rf(u, Oy, T, !0);
      }
      function uN(u, f) {
        return u && u.length ? r3(u, It(f)) : n;
      }
      var lN = Dt(q3);
      function q3(u, f) {
        return u && u.length && f && f.length ? Cm(u, f) : u;
      }
      function cN(u, f, m) {
        return u && u.length && f && f.length ? Cm(u, f, Tt(m, 2)) : u;
      }
      function fN(u, f, m) {
        return u && u.length && f && f.length ? Cm(u, f, n, m) : u;
      }
      var hN = mi(function(u, f) {
        var m = u == null ? 0 : u.length, y = mm(u, f);
        return o3(u, ce(f, function(T) {
          return gi(T, m) ? +T : T;
        }).sort(g3)), y;
      });
      function dN(u, f) {
        var m = [];
        if (!(u && u.length))
          return m;
        var y = -1, T = [], S = u.length;
        for (f = Tt(f, 3); ++y < S; ) {
          var N = u[y];
          f(N, y, u) && (m.push(N), T.push(y));
        }
        return o3(u, T), m;
      }
      function Vm(u) {
        return u == null ? u : oM.call(u);
      }
      function pN(u, f, m) {
        var y = u == null ? 0 : u.length;
        return y ? (m && typeof m != "number" && fn(u, f, m) ? (f = 0, m = y) : (f = f == null ? 0 : It(f), m = m === n ? y : It(m)), fr(u, f, m)) : [];
      }
      function mN(u, f) {
        return $f(u, f);
      }
      function gN(u, f, m) {
        return Om(u, f, Tt(m, 2));
      }
      function vN(u, f) {
        var m = u == null ? 0 : u.length;
        if (m) {
          var y = $f(u, f);
          if (y < m && Ar(u[y], f))
            return y;
        }
        return -1;
      }
      function _N(u, f) {
        return $f(u, f, !0);
      }
      function bN(u, f, m) {
        return Om(u, f, Tt(m, 2), !0);
      }
      function yN(u, f) {
        var m = u == null ? 0 : u.length;
        if (m) {
          var y = $f(u, f, !0) - 1;
          if (Ar(u[y], f))
            return y;
        }
        return -1;
      }
      function wN(u) {
        return u && u.length ? u3(u) : [];
      }
      function xN(u, f) {
        return u && u.length ? u3(u, Tt(f, 2)) : [];
      }
      function CN(u) {
        var f = u == null ? 0 : u.length;
        return f ? fr(u, 1, f) : [];
      }
      function $N(u, f, m) {
        return u && u.length ? (f = m || f === n ? 1 : It(f), fr(u, 0, f < 0 ? 0 : f)) : [];
      }
      function TN(u, f, m) {
        var y = u == null ? 0 : u.length;
        return y ? (f = m || f === n ? 1 : It(f), f = y - f, fr(u, f < 0 ? 0 : f, y)) : [];
      }
      function ON(u, f) {
        return u && u.length ? Tf(u, Tt(f, 3), !1, !0) : [];
      }
      function SN(u, f) {
        return u && u.length ? Tf(u, Tt(f, 3)) : [];
      }
      var EN = Dt(function(u) {
        return Ji(Ke(u, 1, xe, !0));
      }), AN = Dt(function(u) {
        var f = hr(u);
        return xe(f) && (f = n), Ji(Ke(u, 1, xe, !0), Tt(f, 2));
      }), PN = Dt(function(u) {
        var f = hr(u);
        return f = typeof f == "function" ? f : n, Ji(Ke(u, 1, xe, !0), n, f);
      });
      function MN(u) {
        return u && u.length ? Ji(u) : [];
      }
      function kN(u, f) {
        return u && u.length ? Ji(u, Tt(f, 2)) : [];
      }
      function NN(u, f) {
        return f = typeof f == "function" ? f : n, u && u.length ? Ji(u, n, f) : [];
      }
      function Wm(u) {
        if (!(u && u.length))
          return [];
        var f = 0;
        return u = qi(u, function(m) {
          if (xe(m))
            return f = Pe(m.length, f), !0;
        }), sm(f, function(m) {
          return ce(u, im(m));
        });
      }
      function G3(u, f) {
        if (!(u && u.length))
          return [];
        var m = Wm(u);
        return f == null ? m : ce(m, function(y) {
          return Vn(f, n, y);
        });
      }
      var IN = Dt(function(u, f) {
        return xe(u) ? qu(u, f) : [];
      }), RN = Dt(function(u) {
        return Em(qi(u, xe));
      }), LN = Dt(function(u) {
        var f = hr(u);
        return xe(f) && (f = n), Em(qi(u, xe), Tt(f, 2));
      }), DN = Dt(function(u) {
        var f = hr(u);
        return f = typeof f == "function" ? f : n, Em(qi(u, xe), n, f);
      }), FN = Dt(Wm);
      function zN(u, f) {
        return h3(u || [], f || [], Yu);
      }
      function BN(u, f) {
        return h3(u || [], f || [], Xu);
      }
      var HN = Dt(function(u) {
        var f = u.length, m = f > 1 ? u[f - 1] : n;
        return m = typeof m == "function" ? (u.pop(), m) : n, G3(u, m);
      });
      function K3(u) {
        var f = O(u);
        return f.__chain__ = !0, f;
      }
      function jN(u, f) {
        return f(u), u;
      }
      function If(u, f) {
        return f(u);
      }
      var VN = mi(function(u) {
        var f = u.length, m = f ? u[0] : 0, y = this.__wrapped__, T = function(S) {
          return mm(S, u);
        };
        return f > 1 || this.__actions__.length || !(y instanceof Ht) || !gi(m) ? this.thru(T) : (y = y.slice(m, +m + (f ? 1 : 0)), y.__actions__.push({
          func: If,
          args: [T],
          thisArg: n
        }), new lr(y, this.__chain__).thru(function(S) {
          return f && !S.length && S.push(n), S;
        }));
      });
      function WN() {
        return K3(this);
      }
      function UN() {
        return new lr(this.value(), this.__chain__);
      }
      function YN() {
        this.__values__ === n && (this.__values__ = l4(this.value()));
        var u = this.__index__ >= this.__values__.length, f = u ? n : this.__values__[this.__index__++];
        return { done: u, value: f };
      }
      function qN() {
        return this;
      }
      function GN(u) {
        for (var f, m = this; m instanceof bf; ) {
          var y = j3(m);
          y.__index__ = 0, y.__values__ = n, f ? T.__wrapped__ = y : f = y;
          var T = y;
          m = m.__wrapped__;
        }
        return T.__wrapped__ = u, f;
      }
      function KN() {
        var u = this.__wrapped__;
        if (u instanceof Ht) {
          var f = u;
          return this.__actions__.length && (f = new Ht(this)), f = f.reverse(), f.__actions__.push({
            func: If,
            args: [Vm],
            thisArg: n
          }), new lr(f, this.__chain__);
        }
        return this.thru(Vm);
      }
      function XN() {
        return f3(this.__wrapped__, this.__actions__);
      }
      var ZN = Of(function(u, f, m) {
        Kt.call(u, m) ? ++u[m] : di(u, m, 1);
      });
      function JN(u, f, m) {
        var y = Pt(u) ? $y : jM;
        return m && fn(u, f, m) && (f = n), y(u, Tt(f, 3));
      }
      function QN(u, f) {
        var m = Pt(u) ? qi : Gy;
        return m(u, Tt(f, 3));
      }
      var tI = x3(V3), eI = x3(W3);
      function nI(u, f) {
        return Ke(Rf(u, f), 1);
      }
      function rI(u, f) {
        return Ke(Rf(u, f), q);
      }
      function iI(u, f, m) {
        return m = m === n ? 1 : It(m), Ke(Rf(u, f), m);
      }
      function X3(u, f) {
        var m = Pt(u) ? sr : Zi;
        return m(u, Tt(f, 3));
      }
      function Z3(u, f) {
        var m = Pt(u) ? CP : qy;
        return m(u, Tt(f, 3));
      }
      var aI = Of(function(u, f, m) {
        Kt.call(u, m) ? u[m].push(f) : di(u, m, [f]);
      });
      function oI(u, f, m, y) {
        u = Pn(u) ? u : ls(u), m = m && !y ? It(m) : 0;
        var T = u.length;
        return m < 0 && (m = Pe(T + m, 0)), Bf(u) ? m <= T && u.indexOf(f, m) > -1 : !!T && Zo(u, f, m) > -1;
      }
      var sI = Dt(function(u, f, m) {
        var y = -1, T = typeof f == "function", S = Pn(u) ? G(u.length) : [];
        return Zi(u, function(N) {
          S[++y] = T ? Vn(f, N, m) : Gu(N, f, m);
        }), S;
      }), uI = Of(function(u, f, m) {
        di(u, m, f);
      });
      function Rf(u, f) {
        var m = Pt(u) ? ce : t3;
        return m(u, Tt(f, 3));
      }
      function lI(u, f, m, y) {
        return u == null ? [] : (Pt(f) || (f = f == null ? [] : [f]), m = y ? n : m, Pt(m) || (m = m == null ? [] : [m]), i3(u, f, m));
      }
      var cI = Of(function(u, f, m) {
        u[m ? 0 : 1].push(f);
      }, function() {
        return [[], []];
      });
      function fI(u, f, m) {
        var y = Pt(u) ? nm : Ey, T = arguments.length < 3;
        return y(u, Tt(f, 4), m, T, Zi);
      }
      function hI(u, f, m) {
        var y = Pt(u) ? $P : Ey, T = arguments.length < 3;
        return y(u, Tt(f, 4), m, T, qy);
      }
      function dI(u, f) {
        var m = Pt(u) ? qi : Gy;
        return m(u, Ff(Tt(f, 3)));
      }
      function pI(u) {
        var f = Pt(u) ? Vy : ok;
        return f(u);
      }
      function mI(u, f, m) {
        (m ? fn(u, f, m) : f === n) ? f = 1 : f = It(f);
        var y = Pt(u) ? DM : sk;
        return y(u, f);
      }
      function gI(u) {
        var f = Pt(u) ? FM : lk;
        return f(u);
      }
      function vI(u) {
        if (u == null)
          return 0;
        if (Pn(u))
          return Bf(u) ? Qo(u) : u.length;
        var f = nn(u);
        return f == $t || f == Or ? u.size : wm(u).length;
      }
      function _I(u, f, m) {
        var y = Pt(u) ? rm : ck;
        return m && fn(u, f, m) && (f = n), y(u, Tt(f, 3));
      }
      var bI = Dt(function(u, f) {
        if (u == null)
          return [];
        var m = f.length;
        return m > 1 && fn(u, f[0], f[1]) ? f = [] : m > 2 && fn(f[0], f[1], f[2]) && (f = [f[0]]), i3(u, Ke(f, 1), []);
      }), Lf = QP || function() {
        return Ge.Date.now();
      };
      function yI(u, f) {
        if (typeof f != "function")
          throw new ur(o);
        return u = It(u), function() {
          if (--u < 1)
            return f.apply(this, arguments);
        };
      }
      function J3(u, f, m) {
        return f = m ? n : f, f = u && f == null ? u.length : f, pi(u, R, n, n, n, n, f);
      }
      function Q3(u, f) {
        var m;
        if (typeof f != "function")
          throw new ur(o);
        return u = It(u), function() {
          return --u > 0 && (m = f.apply(this, arguments)), u <= 1 && (f = n), m;
        };
      }
      var Um = Dt(function(u, f, m) {
        var y = _;
        if (m.length) {
          var T = Ki(m, ss(Um));
          y |= E;
        }
        return pi(u, y, f, m, T);
      }), t4 = Dt(function(u, f, m) {
        var y = _ | w;
        if (m.length) {
          var T = Ki(m, ss(t4));
          y |= E;
        }
        return pi(f, y, u, m, T);
      });
      function e4(u, f, m) {
        f = m ? n : f;
        var y = pi(u, C, n, n, n, n, n, f);
        return y.placeholder = e4.placeholder, y;
      }
      function n4(u, f, m) {
        f = m ? n : f;
        var y = pi(u, $, n, n, n, n, n, f);
        return y.placeholder = n4.placeholder, y;
      }
      function r4(u, f, m) {
        var y, T, S, N, F, U, tt = 0, nt = !1, it = !1, lt = !0;
        if (typeof u != "function")
          throw new ur(o);
        f = dr(f) || 0, pe(m) && (nt = !!m.leading, it = "maxWait" in m, S = it ? Pe(dr(m.maxWait) || 0, f) : S, lt = "trailing" in m ? !!m.trailing : lt);
        function vt(Ce) {
          var Pr = y, bi = T;
          return y = T = n, tt = Ce, N = u.apply(bi, Pr), N;
        }
        function St(Ce) {
          return tt = Ce, F = Qu(zt, f), nt ? vt(Ce) : N;
        }
        function Lt(Ce) {
          var Pr = Ce - U, bi = Ce - tt, x4 = f - Pr;
          return it ? en(x4, S - bi) : x4;
        }
        function Et(Ce) {
          var Pr = Ce - U, bi = Ce - tt;
          return U === n || Pr >= f || Pr < 0 || it && bi >= S;
        }
        function zt() {
          var Ce = Lf();
          if (Et(Ce))
            return jt(Ce);
          F = Qu(zt, Lt(Ce));
        }
        function jt(Ce) {
          return F = n, lt && y ? vt(Ce) : (y = T = n, N);
        }
        function qn() {
          F !== n && d3(F), tt = 0, y = U = T = F = n;
        }
        function hn() {
          return F === n ? N : jt(Lf());
        }
        function Gn() {
          var Ce = Lf(), Pr = Et(Ce);
          if (y = arguments, T = this, U = Ce, Pr) {
            if (F === n)
              return St(U);
            if (it)
              return d3(F), F = Qu(zt, f), vt(U);
          }
          return F === n && (F = Qu(zt, f)), N;
        }
        return Gn.cancel = qn, Gn.flush = hn, Gn;
      }
      var wI = Dt(function(u, f) {
        return Yy(u, 1, f);
      }), xI = Dt(function(u, f, m) {
        return Yy(u, dr(f) || 0, m);
      });
      function CI(u) {
        return pi(u, W);
      }
      function Df(u, f) {
        if (typeof u != "function" || f != null && typeof f != "function")
          throw new ur(o);
        var m = function() {
          var y = arguments, T = f ? f.apply(this, y) : y[0], S = m.cache;
          if (S.has(T))
            return S.get(T);
          var N = u.apply(this, y);
          return m.cache = S.set(T, N) || S, N;
        };
        return m.cache = new (Df.Cache || hi)(), m;
      }
      Df.Cache = hi;
      function Ff(u) {
        if (typeof u != "function")
          throw new ur(o);
        return function() {
          var f = arguments;
          switch (f.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, f[0]);
            case 2:
              return !u.call(this, f[0], f[1]);
            case 3:
              return !u.call(this, f[0], f[1], f[2]);
          }
          return !u.apply(this, f);
        };
      }
      function $I(u) {
        return Q3(2, u);
      }
      var TI = fk(function(u, f) {
        f = f.length == 1 && Pt(f[0]) ? ce(f[0], Wn(Tt())) : ce(Ke(f, 1), Wn(Tt()));
        var m = f.length;
        return Dt(function(y) {
          for (var T = -1, S = en(y.length, m); ++T < S; )
            y[T] = f[T].call(this, y[T]);
          return Vn(u, this, y);
        });
      }), Ym = Dt(function(u, f) {
        var m = Ki(f, ss(Ym));
        return pi(u, E, n, f, m);
      }), i4 = Dt(function(u, f) {
        var m = Ki(f, ss(i4));
        return pi(u, A, n, f, m);
      }), OI = mi(function(u, f) {
        return pi(u, L, n, n, n, f);
      });
      function SI(u, f) {
        if (typeof u != "function")
          throw new ur(o);
        return f = f === n ? f : It(f), Dt(u, f);
      }
      function EI(u, f) {
        if (typeof u != "function")
          throw new ur(o);
        return f = f == null ? 0 : Pe(It(f), 0), Dt(function(m) {
          var y = m[f], T = ta(m, 0, f);
          return y && Gi(T, y), Vn(u, this, T);
        });
      }
      function AI(u, f, m) {
        var y = !0, T = !0;
        if (typeof u != "function")
          throw new ur(o);
        return pe(m) && (y = "leading" in m ? !!m.leading : y, T = "trailing" in m ? !!m.trailing : T), r4(u, f, {
          leading: y,
          maxWait: f,
          trailing: T
        });
      }
      function PI(u) {
        return J3(u, 1);
      }
      function MI(u, f) {
        return Ym(Pm(f), u);
      }
      function kI() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return Pt(u) ? u : [u];
      }
      function NI(u) {
        return cr(u, g);
      }
      function II(u, f) {
        return f = typeof f == "function" ? f : n, cr(u, g, f);
      }
      function RI(u) {
        return cr(u, d | g);
      }
      function LI(u, f) {
        return f = typeof f == "function" ? f : n, cr(u, d | g, f);
      }
      function DI(u, f) {
        return f == null || Uy(u, f, De(f));
      }
      function Ar(u, f) {
        return u === f || u !== u && f !== f;
      }
      var FI = Pf(_m), zI = Pf(function(u, f) {
        return u >= f;
      }), Ja = Zy(function() {
        return arguments;
      }()) ? Zy : function(u) {
        return ve(u) && Kt.call(u, "callee") && !Dy.call(u, "callee");
      }, Pt = G.isArray, BI = _y ? Wn(_y) : GM;
      function Pn(u) {
        return u != null && zf(u.length) && !vi(u);
      }
      function xe(u) {
        return ve(u) && Pn(u);
      }
      function HI(u) {
        return u === !0 || u === !1 || ve(u) && cn(u) == Nt;
      }
      var ea = eM || rg, jI = by ? Wn(by) : KM;
      function VI(u) {
        return ve(u) && u.nodeType === 1 && !tl(u);
      }
      function WI(u) {
        if (u == null)
          return !0;
        if (Pn(u) && (Pt(u) || typeof u == "string" || typeof u.splice == "function" || ea(u) || us(u) || Ja(u)))
          return !u.length;
        var f = nn(u);
        if (f == $t || f == Or)
          return !u.size;
        if (Ju(u))
          return !wm(u).length;
        for (var m in u)
          if (Kt.call(u, m))
            return !1;
        return !0;
      }
      function UI(u, f) {
        return Ku(u, f);
      }
      function YI(u, f, m) {
        m = typeof m == "function" ? m : n;
        var y = m ? m(u, f) : n;
        return y === n ? Ku(u, f, n, m) : !!y;
      }
      function qm(u) {
        if (!ve(u))
          return !1;
        var f = cn(u);
        return f == kt || f == wt || typeof u.message == "string" && typeof u.name == "string" && !tl(u);
      }
      function qI(u) {
        return typeof u == "number" && zy(u);
      }
      function vi(u) {
        if (!pe(u))
          return !1;
        var f = cn(u);
        return f == at || f == Gt || f == ht || f == Va;
      }
      function a4(u) {
        return typeof u == "number" && u == It(u);
      }
      function zf(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= Z;
      }
      function pe(u) {
        var f = typeof u;
        return u != null && (f == "object" || f == "function");
      }
      function ve(u) {
        return u != null && typeof u == "object";
      }
      var o4 = yy ? Wn(yy) : ZM;
      function GI(u, f) {
        return u === f || ym(u, f, Dm(f));
      }
      function KI(u, f, m) {
        return m = typeof m == "function" ? m : n, ym(u, f, Dm(f), m);
      }
      function XI(u) {
        return s4(u) && u != +u;
      }
      function ZI(u) {
        if (Ik(u))
          throw new At(a);
        return Jy(u);
      }
      function JI(u) {
        return u === null;
      }
      function QI(u) {
        return u == null;
      }
      function s4(u) {
        return typeof u == "number" || ve(u) && cn(u) == le;
      }
      function tl(u) {
        if (!ve(u) || cn(u) != yt)
          return !1;
        var f = hf(u);
        if (f === null)
          return !0;
        var m = Kt.call(f, "constructor") && f.constructor;
        return typeof m == "function" && m instanceof m && uf.call(m) == KP;
      }
      var Gm = wy ? Wn(wy) : JM;
      function tR(u) {
        return a4(u) && u >= -Z && u <= Z;
      }
      var u4 = xy ? Wn(xy) : QM;
      function Bf(u) {
        return typeof u == "string" || !Pt(u) && ve(u) && cn(u) == Du;
      }
      function Yn(u) {
        return typeof u == "symbol" || ve(u) && cn(u) == Jc;
      }
      var us = Cy ? Wn(Cy) : tk;
      function eR(u) {
        return u === n;
      }
      function nR(u) {
        return ve(u) && nn(u) == Fu;
      }
      function rR(u) {
        return ve(u) && cn(u) == bA;
      }
      var iR = Pf(xm), aR = Pf(function(u, f) {
        return u <= f;
      });
      function l4(u) {
        if (!u)
          return [];
        if (Pn(u))
          return Bf(u) ? Sr(u) : An(u);
        if (Hu && u[Hu])
          return DP(u[Hu]());
        var f = nn(u), m = f == $t ? lm : f == Or ? af : ls;
        return m(u);
      }
      function _i(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = dr(u), u === q || u === -q) {
          var f = u < 0 ? -1 : 1;
          return f * B;
        }
        return u === u ? u : 0;
      }
      function It(u) {
        var f = _i(u), m = f % 1;
        return f === f ? m ? f - m : f : 0;
      }
      function c4(u) {
        return u ? Ga(It(u), 0, J) : 0;
      }
      function dr(u) {
        if (typeof u == "number")
          return u;
        if (Yn(u))
          return H;
        if (pe(u)) {
          var f = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = pe(f) ? f + "" : f;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = Ay(u);
        var m = BA.test(u);
        return m || jA.test(u) ? yP(u.slice(2), m ? 2 : 8) : zA.test(u) ? H : +u;
      }
      function f4(u) {
        return Ur(u, Mn(u));
      }
      function oR(u) {
        return u ? Ga(It(u), -Z, Z) : u === 0 ? u : 0;
      }
      function qt(u) {
        return u == null ? "" : Un(u);
      }
      var sR = as(function(u, f) {
        if (Ju(f) || Pn(f)) {
          Ur(f, De(f), u);
          return;
        }
        for (var m in f)
          Kt.call(f, m) && Yu(u, m, f[m]);
      }), h4 = as(function(u, f) {
        Ur(f, Mn(f), u);
      }), Hf = as(function(u, f, m, y) {
        Ur(f, Mn(f), u, y);
      }), uR = as(function(u, f, m, y) {
        Ur(f, De(f), u, y);
      }), lR = mi(mm);
      function cR(u, f) {
        var m = is(u);
        return f == null ? m : Wy(m, f);
      }
      var fR = Dt(function(u, f) {
        u = Zt(u);
        var m = -1, y = f.length, T = y > 2 ? f[2] : n;
        for (T && fn(f[0], f[1], T) && (y = 1); ++m < y; )
          for (var S = f[m], N = Mn(S), F = -1, U = N.length; ++F < U; ) {
            var tt = N[F], nt = u[tt];
            (nt === n || Ar(nt, es[tt]) && !Kt.call(u, tt)) && (u[tt] = S[tt]);
          }
        return u;
      }), hR = Dt(function(u) {
        return u.push(n, A3), Vn(d4, n, u);
      });
      function dR(u, f) {
        return Ty(u, Tt(f, 3), Wr);
      }
      function pR(u, f) {
        return Ty(u, Tt(f, 3), vm);
      }
      function mR(u, f) {
        return u == null ? u : gm(u, Tt(f, 3), Mn);
      }
      function gR(u, f) {
        return u == null ? u : Ky(u, Tt(f, 3), Mn);
      }
      function vR(u, f) {
        return u && Wr(u, Tt(f, 3));
      }
      function _R(u, f) {
        return u && vm(u, Tt(f, 3));
      }
      function bR(u) {
        return u == null ? [] : xf(u, De(u));
      }
      function yR(u) {
        return u == null ? [] : xf(u, Mn(u));
      }
      function Km(u, f, m) {
        var y = u == null ? n : Ka(u, f);
        return y === n ? m : y;
      }
      function wR(u, f) {
        return u != null && k3(u, f, WM);
      }
      function Xm(u, f) {
        return u != null && k3(u, f, UM);
      }
      var xR = $3(function(u, f, m) {
        f != null && typeof f.toString != "function" && (f = lf.call(f)), u[f] = m;
      }, Jm(kn)), CR = $3(function(u, f, m) {
        f != null && typeof f.toString != "function" && (f = lf.call(f)), Kt.call(u, f) ? u[f].push(m) : u[f] = [m];
      }, Tt), $R = Dt(Gu);
      function De(u) {
        return Pn(u) ? jy(u) : wm(u);
      }
      function Mn(u) {
        return Pn(u) ? jy(u, !0) : ek(u);
      }
      function TR(u, f) {
        var m = {};
        return f = Tt(f, 3), Wr(u, function(y, T, S) {
          di(m, f(y, T, S), y);
        }), m;
      }
      function OR(u, f) {
        var m = {};
        return f = Tt(f, 3), Wr(u, function(y, T, S) {
          di(m, T, f(y, T, S));
        }), m;
      }
      var SR = as(function(u, f, m) {
        Cf(u, f, m);
      }), d4 = as(function(u, f, m, y) {
        Cf(u, f, m, y);
      }), ER = mi(function(u, f) {
        var m = {};
        if (u == null)
          return m;
        var y = !1;
        f = ce(f, function(S) {
          return S = Qi(S, u), y || (y = S.length > 1), S;
        }), Ur(u, Rm(u), m), y && (m = cr(m, d | p | g, xk));
        for (var T = f.length; T--; )
          Sm(m, f[T]);
        return m;
      });
      function AR(u, f) {
        return p4(u, Ff(Tt(f)));
      }
      var PR = mi(function(u, f) {
        return u == null ? {} : rk(u, f);
      });
      function p4(u, f) {
        if (u == null)
          return {};
        var m = ce(Rm(u), function(y) {
          return [y];
        });
        return f = Tt(f), a3(u, m, function(y, T) {
          return f(y, T[0]);
        });
      }
      function MR(u, f, m) {
        f = Qi(f, u);
        var y = -1, T = f.length;
        for (T || (T = 1, u = n); ++y < T; ) {
          var S = u == null ? n : u[Yr(f[y])];
          S === n && (y = T, S = m), u = vi(S) ? S.call(u) : S;
        }
        return u;
      }
      function kR(u, f, m) {
        return u == null ? u : Xu(u, f, m);
      }
      function NR(u, f, m, y) {
        return y = typeof y == "function" ? y : n, u == null ? u : Xu(u, f, m, y);
      }
      var m4 = S3(De), g4 = S3(Mn);
      function IR(u, f, m) {
        var y = Pt(u), T = y || ea(u) || us(u);
        if (f = Tt(f, 4), m == null) {
          var S = u && u.constructor;
          T ? m = y ? new S() : [] : pe(u) ? m = vi(S) ? is(hf(u)) : {} : m = {};
        }
        return (T ? sr : Wr)(u, function(N, F, U) {
          return f(m, N, F, U);
        }), m;
      }
      function RR(u, f) {
        return u == null ? !0 : Sm(u, f);
      }
      function LR(u, f, m) {
        return u == null ? u : c3(u, f, Pm(m));
      }
      function DR(u, f, m, y) {
        return y = typeof y == "function" ? y : n, u == null ? u : c3(u, f, Pm(m), y);
      }
      function ls(u) {
        return u == null ? [] : um(u, De(u));
      }
      function FR(u) {
        return u == null ? [] : um(u, Mn(u));
      }
      function zR(u, f, m) {
        return m === n && (m = f, f = n), m !== n && (m = dr(m), m = m === m ? m : 0), f !== n && (f = dr(f), f = f === f ? f : 0), Ga(dr(u), f, m);
      }
      function BR(u, f, m) {
        return f = _i(f), m === n ? (m = f, f = 0) : m = _i(m), u = dr(u), YM(u, f, m);
      }
      function HR(u, f, m) {
        if (m && typeof m != "boolean" && fn(u, f, m) && (f = m = n), m === n && (typeof f == "boolean" ? (m = f, f = n) : typeof u == "boolean" && (m = u, u = n)), u === n && f === n ? (u = 0, f = 1) : (u = _i(u), f === n ? (f = u, u = 0) : f = _i(f)), u > f) {
          var y = u;
          u = f, f = y;
        }
        if (m || u % 1 || f % 1) {
          var T = By();
          return en(u + T * (f - u + bP("1e-" + ((T + "").length - 1))), f);
        }
        return $m(u, f);
      }
      var jR = os(function(u, f, m) {
        return f = f.toLowerCase(), u + (m ? v4(f) : f);
      });
      function v4(u) {
        return Zm(qt(u).toLowerCase());
      }
      function _4(u) {
        return u = qt(u), u && u.replace(WA, kP).replace(lP, "");
      }
      function VR(u, f, m) {
        u = qt(u), f = Un(f);
        var y = u.length;
        m = m === n ? y : Ga(It(m), 0, y);
        var T = m;
        return m -= f.length, m >= 0 && u.slice(m, T) == f;
      }
      function WR(u) {
        return u = qt(u), u && $A.test(u) ? u.replace(Kb, NP) : u;
      }
      function UR(u) {
        return u = qt(u), u && PA.test(u) ? u.replace(Y1, "\\$&") : u;
      }
      var YR = os(function(u, f, m) {
        return u + (m ? "-" : "") + f.toLowerCase();
      }), qR = os(function(u, f, m) {
        return u + (m ? " " : "") + f.toLowerCase();
      }), GR = w3("toLowerCase");
      function KR(u, f, m) {
        u = qt(u), f = It(f);
        var y = f ? Qo(u) : 0;
        if (!f || y >= f)
          return u;
        var T = (f - y) / 2;
        return Af(gf(T), m) + u + Af(mf(T), m);
      }
      function XR(u, f, m) {
        u = qt(u), f = It(f);
        var y = f ? Qo(u) : 0;
        return f && y < f ? u + Af(f - y, m) : u;
      }
      function ZR(u, f, m) {
        u = qt(u), f = It(f);
        var y = f ? Qo(u) : 0;
        return f && y < f ? Af(f - y, m) + u : u;
      }
      function JR(u, f, m) {
        return m || f == null ? f = 0 : f && (f = +f), aM(qt(u).replace(q1, ""), f || 0);
      }
      function QR(u, f, m) {
        return (m ? fn(u, f, m) : f === n) ? f = 1 : f = It(f), Tm(qt(u), f);
      }
      function tL() {
        var u = arguments, f = qt(u[0]);
        return u.length < 3 ? f : f.replace(u[1], u[2]);
      }
      var eL = os(function(u, f, m) {
        return u + (m ? "_" : "") + f.toLowerCase();
      });
      function nL(u, f, m) {
        return m && typeof m != "number" && fn(u, f, m) && (f = m = n), m = m === n ? J : m >>> 0, m ? (u = qt(u), u && (typeof f == "string" || f != null && !Gm(f)) && (f = Un(f), !f && Jo(u)) ? ta(Sr(u), 0, m) : u.split(f, m)) : [];
      }
      var rL = os(function(u, f, m) {
        return u + (m ? " " : "") + Zm(f);
      });
      function iL(u, f, m) {
        return u = qt(u), m = m == null ? 0 : Ga(It(m), 0, u.length), f = Un(f), u.slice(m, m + f.length) == f;
      }
      function aL(u, f, m) {
        var y = O.templateSettings;
        m && fn(u, f, m) && (f = n), u = qt(u), f = Hf({}, f, y, E3);
        var T = Hf({}, f.imports, y.imports, E3), S = De(T), N = um(T, S), F, U, tt = 0, nt = f.interpolate || Qc, it = "__p += '", lt = cm(
          (f.escape || Qc).source + "|" + nt.source + "|" + (nt === Xb ? FA : Qc).source + "|" + (f.evaluate || Qc).source + "|$",
          "g"
        ), vt = "//# sourceURL=" + (Kt.call(f, "sourceURL") ? (f.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++pP + "]") + `
`;
        u.replace(lt, function(Et, zt, jt, qn, hn, Gn) {
          return jt || (jt = qn), it += u.slice(tt, Gn).replace(UA, IP), zt && (F = !0, it += `' +
__e(` + zt + `) +
'`), hn && (U = !0, it += `';
` + hn + `;
__p += '`), jt && (it += `' +
((__t = (` + jt + `)) == null ? '' : __t) +
'`), tt = Gn + Et.length, Et;
        }), it += `';
`;
        var St = Kt.call(f, "variable") && f.variable;
        if (!St)
          it = `with (obj) {
` + it + `
}
`;
        else if (LA.test(St))
          throw new At(s);
        it = (U ? it.replace(yA, "") : it).replace(wA, "$1").replace(xA, "$1;"), it = "function(" + (St || "obj") + `) {
` + (St ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (F ? ", __e = _.escape" : "") + (U ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + it + `return __p
}`;
        var Lt = y4(function() {
          return Yt(S, vt + "return " + it).apply(n, N);
        });
        if (Lt.source = it, qm(Lt))
          throw Lt;
        return Lt;
      }
      function oL(u) {
        return qt(u).toLowerCase();
      }
      function sL(u) {
        return qt(u).toUpperCase();
      }
      function uL(u, f, m) {
        if (u = qt(u), u && (m || f === n))
          return Ay(u);
        if (!u || !(f = Un(f)))
          return u;
        var y = Sr(u), T = Sr(f), S = Py(y, T), N = My(y, T) + 1;
        return ta(y, S, N).join("");
      }
      function lL(u, f, m) {
        if (u = qt(u), u && (m || f === n))
          return u.slice(0, Ny(u) + 1);
        if (!u || !(f = Un(f)))
          return u;
        var y = Sr(u), T = My(y, Sr(f)) + 1;
        return ta(y, 0, T).join("");
      }
      function cL(u, f, m) {
        if (u = qt(u), u && (m || f === n))
          return u.replace(q1, "");
        if (!u || !(f = Un(f)))
          return u;
        var y = Sr(u), T = Py(y, Sr(f));
        return ta(y, T).join("");
      }
      function fL(u, f) {
        var m = P, y = k;
        if (pe(f)) {
          var T = "separator" in f ? f.separator : T;
          m = "length" in f ? It(f.length) : m, y = "omission" in f ? Un(f.omission) : y;
        }
        u = qt(u);
        var S = u.length;
        if (Jo(u)) {
          var N = Sr(u);
          S = N.length;
        }
        if (m >= S)
          return u;
        var F = m - Qo(y);
        if (F < 1)
          return y;
        var U = N ? ta(N, 0, F).join("") : u.slice(0, F);
        if (T === n)
          return U + y;
        if (N && (F += U.length - F), Gm(T)) {
          if (u.slice(F).search(T)) {
            var tt, nt = U;
            for (T.global || (T = cm(T.source, qt(Zb.exec(T)) + "g")), T.lastIndex = 0; tt = T.exec(nt); )
              var it = tt.index;
            U = U.slice(0, it === n ? F : it);
          }
        } else if (u.indexOf(Un(T), F) != F) {
          var lt = U.lastIndexOf(T);
          lt > -1 && (U = U.slice(0, lt));
        }
        return U + y;
      }
      function hL(u) {
        return u = qt(u), u && CA.test(u) ? u.replace(Gb, HP) : u;
      }
      var dL = os(function(u, f, m) {
        return u + (m ? " " : "") + f.toUpperCase();
      }), Zm = w3("toUpperCase");
      function b4(u, f, m) {
        return u = qt(u), f = m ? n : f, f === n ? LP(u) ? WP(u) : SP(u) : u.match(f) || [];
      }
      var y4 = Dt(function(u, f) {
        try {
          return Vn(u, n, f);
        } catch (m) {
          return qm(m) ? m : new At(m);
        }
      }), pL = mi(function(u, f) {
        return sr(f, function(m) {
          m = Yr(m), di(u, m, Um(u[m], u));
        }), u;
      });
      function mL(u) {
        var f = u == null ? 0 : u.length, m = Tt();
        return u = f ? ce(u, function(y) {
          if (typeof y[1] != "function")
            throw new ur(o);
          return [m(y[0]), y[1]];
        }) : [], Dt(function(y) {
          for (var T = -1; ++T < f; ) {
            var S = u[T];
            if (Vn(S[0], this, y))
              return Vn(S[1], this, y);
          }
        });
      }
      function gL(u) {
        return HM(cr(u, d));
      }
      function Jm(u) {
        return function() {
          return u;
        };
      }
      function vL(u, f) {
        return u == null || u !== u ? f : u;
      }
      var _L = C3(), bL = C3(!0);
      function kn(u) {
        return u;
      }
      function Qm(u) {
        return Qy(typeof u == "function" ? u : cr(u, d));
      }
      function yL(u) {
        return e3(cr(u, d));
      }
      function wL(u, f) {
        return n3(u, cr(f, d));
      }
      var xL = Dt(function(u, f) {
        return function(m) {
          return Gu(m, u, f);
        };
      }), CL = Dt(function(u, f) {
        return function(m) {
          return Gu(u, m, f);
        };
      });
      function tg(u, f, m) {
        var y = De(f), T = xf(f, y);
        m == null && !(pe(f) && (T.length || !y.length)) && (m = f, f = u, u = this, T = xf(f, De(f)));
        var S = !(pe(m) && "chain" in m) || !!m.chain, N = vi(u);
        return sr(T, function(F) {
          var U = f[F];
          u[F] = U, N && (u.prototype[F] = function() {
            var tt = this.__chain__;
            if (S || tt) {
              var nt = u(this.__wrapped__), it = nt.__actions__ = An(this.__actions__);
              return it.push({ func: U, args: arguments, thisArg: u }), nt.__chain__ = tt, nt;
            }
            return U.apply(u, Gi([this.value()], arguments));
          });
        }), u;
      }
      function $L() {
        return Ge._ === this && (Ge._ = XP), this;
      }
      function eg() {
      }
      function TL(u) {
        return u = It(u), Dt(function(f) {
          return r3(f, u);
        });
      }
      var OL = km(ce), SL = km($y), EL = km(rm);
      function w4(u) {
        return zm(u) ? im(Yr(u)) : ik(u);
      }
      function AL(u) {
        return function(f) {
          return u == null ? n : Ka(u, f);
        };
      }
      var PL = T3(), ML = T3(!0);
      function ng() {
        return [];
      }
      function rg() {
        return !1;
      }
      function kL() {
        return {};
      }
      function NL() {
        return "";
      }
      function IL() {
        return !0;
      }
      function RL(u, f) {
        if (u = It(u), u < 1 || u > Z)
          return [];
        var m = J, y = en(u, J);
        f = Tt(f), u -= J;
        for (var T = sm(y, f); ++m < u; )
          f(m);
        return T;
      }
      function LL(u) {
        return Pt(u) ? ce(u, Yr) : Yn(u) ? [u] : An(H3(qt(u)));
      }
      function DL(u) {
        var f = ++GP;
        return qt(u) + f;
      }
      var FL = Ef(function(u, f) {
        return u + f;
      }, 0), zL = Nm("ceil"), BL = Ef(function(u, f) {
        return u / f;
      }, 1), HL = Nm("floor");
      function jL(u) {
        return u && u.length ? wf(u, kn, _m) : n;
      }
      function VL(u, f) {
        return u && u.length ? wf(u, Tt(f, 2), _m) : n;
      }
      function WL(u) {
        return Sy(u, kn);
      }
      function UL(u, f) {
        return Sy(u, Tt(f, 2));
      }
      function YL(u) {
        return u && u.length ? wf(u, kn, xm) : n;
      }
      function qL(u, f) {
        return u && u.length ? wf(u, Tt(f, 2), xm) : n;
      }
      var GL = Ef(function(u, f) {
        return u * f;
      }, 1), KL = Nm("round"), XL = Ef(function(u, f) {
        return u - f;
      }, 0);
      function ZL(u) {
        return u && u.length ? om(u, kn) : 0;
      }
      function JL(u, f) {
        return u && u.length ? om(u, Tt(f, 2)) : 0;
      }
      return O.after = yI, O.ary = J3, O.assign = sR, O.assignIn = h4, O.assignInWith = Hf, O.assignWith = uR, O.at = lR, O.before = Q3, O.bind = Um, O.bindAll = pL, O.bindKey = t4, O.castArray = kI, O.chain = K3, O.chunk = Hk, O.compact = jk, O.concat = Vk, O.cond = mL, O.conforms = gL, O.constant = Jm, O.countBy = ZN, O.create = cR, O.curry = e4, O.curryRight = n4, O.debounce = r4, O.defaults = fR, O.defaultsDeep = hR, O.defer = wI, O.delay = xI, O.difference = Wk, O.differenceBy = Uk, O.differenceWith = Yk, O.drop = qk, O.dropRight = Gk, O.dropRightWhile = Kk, O.dropWhile = Xk, O.fill = Zk, O.filter = QN, O.flatMap = nI, O.flatMapDeep = rI, O.flatMapDepth = iI, O.flatten = U3, O.flattenDeep = Jk, O.flattenDepth = Qk, O.flip = CI, O.flow = _L, O.flowRight = bL, O.fromPairs = tN, O.functions = bR, O.functionsIn = yR, O.groupBy = aI, O.initial = nN, O.intersection = rN, O.intersectionBy = iN, O.intersectionWith = aN, O.invert = xR, O.invertBy = CR, O.invokeMap = sI, O.iteratee = Qm, O.keyBy = uI, O.keys = De, O.keysIn = Mn, O.map = Rf, O.mapKeys = TR, O.mapValues = OR, O.matches = yL, O.matchesProperty = wL, O.memoize = Df, O.merge = SR, O.mergeWith = d4, O.method = xL, O.methodOf = CL, O.mixin = tg, O.negate = Ff, O.nthArg = TL, O.omit = ER, O.omitBy = AR, O.once = $I, O.orderBy = lI, O.over = OL, O.overArgs = TI, O.overEvery = SL, O.overSome = EL, O.partial = Ym, O.partialRight = i4, O.partition = cI, O.pick = PR, O.pickBy = p4, O.property = w4, O.propertyOf = AL, O.pull = lN, O.pullAll = q3, O.pullAllBy = cN, O.pullAllWith = fN, O.pullAt = hN, O.range = PL, O.rangeRight = ML, O.rearg = OI, O.reject = dI, O.remove = dN, O.rest = SI, O.reverse = Vm, O.sampleSize = mI, O.set = kR, O.setWith = NR, O.shuffle = gI, O.slice = pN, O.sortBy = bI, O.sortedUniq = wN, O.sortedUniqBy = xN, O.split = nL, O.spread = EI, O.tail = CN, O.take = $N, O.takeRight = TN, O.takeRightWhile = ON, O.takeWhile = SN, O.tap = jN, O.throttle = AI, O.thru = If, O.toArray = l4, O.toPairs = m4, O.toPairsIn = g4, O.toPath = LL, O.toPlainObject = f4, O.transform = IR, O.unary = PI, O.union = EN, O.unionBy = AN, O.unionWith = PN, O.uniq = MN, O.uniqBy = kN, O.uniqWith = NN, O.unset = RR, O.unzip = Wm, O.unzipWith = G3, O.update = LR, O.updateWith = DR, O.values = ls, O.valuesIn = FR, O.without = IN, O.words = b4, O.wrap = MI, O.xor = RN, O.xorBy = LN, O.xorWith = DN, O.zip = FN, O.zipObject = zN, O.zipObjectDeep = BN, O.zipWith = HN, O.entries = m4, O.entriesIn = g4, O.extend = h4, O.extendWith = Hf, tg(O, O), O.add = FL, O.attempt = y4, O.camelCase = jR, O.capitalize = v4, O.ceil = zL, O.clamp = zR, O.clone = NI, O.cloneDeep = RI, O.cloneDeepWith = LI, O.cloneWith = II, O.conformsTo = DI, O.deburr = _4, O.defaultTo = vL, O.divide = BL, O.endsWith = VR, O.eq = Ar, O.escape = WR, O.escapeRegExp = UR, O.every = JN, O.find = tI, O.findIndex = V3, O.findKey = dR, O.findLast = eI, O.findLastIndex = W3, O.findLastKey = pR, O.floor = HL, O.forEach = X3, O.forEachRight = Z3, O.forIn = mR, O.forInRight = gR, O.forOwn = vR, O.forOwnRight = _R, O.get = Km, O.gt = FI, O.gte = zI, O.has = wR, O.hasIn = Xm, O.head = Y3, O.identity = kn, O.includes = oI, O.indexOf = eN, O.inRange = BR, O.invoke = $R, O.isArguments = Ja, O.isArray = Pt, O.isArrayBuffer = BI, O.isArrayLike = Pn, O.isArrayLikeObject = xe, O.isBoolean = HI, O.isBuffer = ea, O.isDate = jI, O.isElement = VI, O.isEmpty = WI, O.isEqual = UI, O.isEqualWith = YI, O.isError = qm, O.isFinite = qI, O.isFunction = vi, O.isInteger = a4, O.isLength = zf, O.isMap = o4, O.isMatch = GI, O.isMatchWith = KI, O.isNaN = XI, O.isNative = ZI, O.isNil = QI, O.isNull = JI, O.isNumber = s4, O.isObject = pe, O.isObjectLike = ve, O.isPlainObject = tl, O.isRegExp = Gm, O.isSafeInteger = tR, O.isSet = u4, O.isString = Bf, O.isSymbol = Yn, O.isTypedArray = us, O.isUndefined = eR, O.isWeakMap = nR, O.isWeakSet = rR, O.join = oN, O.kebabCase = YR, O.last = hr, O.lastIndexOf = sN, O.lowerCase = qR, O.lowerFirst = GR, O.lt = iR, O.lte = aR, O.max = jL, O.maxBy = VL, O.mean = WL, O.meanBy = UL, O.min = YL, O.minBy = qL, O.stubArray = ng, O.stubFalse = rg, O.stubObject = kL, O.stubString = NL, O.stubTrue = IL, O.multiply = GL, O.nth = uN, O.noConflict = $L, O.noop = eg, O.now = Lf, O.pad = KR, O.padEnd = XR, O.padStart = ZR, O.parseInt = JR, O.random = HR, O.reduce = fI, O.reduceRight = hI, O.repeat = QR, O.replace = tL, O.result = MR, O.round = KL, O.runInContext = j, O.sample = pI, O.size = vI, O.snakeCase = eL, O.some = _I, O.sortedIndex = mN, O.sortedIndexBy = gN, O.sortedIndexOf = vN, O.sortedLastIndex = _N, O.sortedLastIndexBy = bN, O.sortedLastIndexOf = yN, O.startCase = rL, O.startsWith = iL, O.subtract = XL, O.sum = ZL, O.sumBy = JL, O.template = aL, O.times = RL, O.toFinite = _i, O.toInteger = It, O.toLength = c4, O.toLower = oL, O.toNumber = dr, O.toSafeInteger = oR, O.toString = qt, O.toUpper = sL, O.trim = uL, O.trimEnd = lL, O.trimStart = cL, O.truncate = fL, O.unescape = hL, O.uniqueId = DL, O.upperCase = dL, O.upperFirst = Zm, O.each = X3, O.eachRight = Z3, O.first = Y3, tg(O, function() {
        var u = {};
        return Wr(O, function(f, m) {
          Kt.call(O.prototype, m) || (u[m] = f);
        }), u;
      }(), { chain: !1 }), O.VERSION = r, sr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        O[u].placeholder = O;
      }), sr(["drop", "take"], function(u, f) {
        Ht.prototype[u] = function(m) {
          m = m === n ? 1 : Pe(It(m), 0);
          var y = this.__filtered__ && !f ? new Ht(this) : this.clone();
          return y.__filtered__ ? y.__takeCount__ = en(m, y.__takeCount__) : y.__views__.push({
            size: en(m, J),
            type: u + (y.__dir__ < 0 ? "Right" : "")
          }), y;
        }, Ht.prototype[u + "Right"] = function(m) {
          return this.reverse()[u](m).reverse();
        };
      }), sr(["filter", "map", "takeWhile"], function(u, f) {
        var m = f + 1, y = m == I || m == z;
        Ht.prototype[u] = function(T) {
          var S = this.clone();
          return S.__iteratees__.push({
            iteratee: Tt(T, 3),
            type: m
          }), S.__filtered__ = S.__filtered__ || y, S;
        };
      }), sr(["head", "last"], function(u, f) {
        var m = "take" + (f ? "Right" : "");
        Ht.prototype[u] = function() {
          return this[m](1).value()[0];
        };
      }), sr(["initial", "tail"], function(u, f) {
        var m = "drop" + (f ? "" : "Right");
        Ht.prototype[u] = function() {
          return this.__filtered__ ? new Ht(this) : this[m](1);
        };
      }), Ht.prototype.compact = function() {
        return this.filter(kn);
      }, Ht.prototype.find = function(u) {
        return this.filter(u).head();
      }, Ht.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, Ht.prototype.invokeMap = Dt(function(u, f) {
        return typeof u == "function" ? new Ht(this) : this.map(function(m) {
          return Gu(m, u, f);
        });
      }), Ht.prototype.reject = function(u) {
        return this.filter(Ff(Tt(u)));
      }, Ht.prototype.slice = function(u, f) {
        u = It(u);
        var m = this;
        return m.__filtered__ && (u > 0 || f < 0) ? new Ht(m) : (u < 0 ? m = m.takeRight(-u) : u && (m = m.drop(u)), f !== n && (f = It(f), m = f < 0 ? m.dropRight(-f) : m.take(f - u)), m);
      }, Ht.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, Ht.prototype.toArray = function() {
        return this.take(J);
      }, Wr(Ht.prototype, function(u, f) {
        var m = /^(?:filter|find|map|reject)|While$/.test(f), y = /^(?:head|last)$/.test(f), T = O[y ? "take" + (f == "last" ? "Right" : "") : f], S = y || /^find/.test(f);
        T && (O.prototype[f] = function() {
          var N = this.__wrapped__, F = y ? [1] : arguments, U = N instanceof Ht, tt = F[0], nt = U || Pt(N), it = function(zt) {
            var jt = T.apply(O, Gi([zt], F));
            return y && lt ? jt[0] : jt;
          };
          nt && m && typeof tt == "function" && tt.length != 1 && (U = nt = !1);
          var lt = this.__chain__, vt = !!this.__actions__.length, St = S && !lt, Lt = U && !vt;
          if (!S && nt) {
            N = Lt ? N : new Ht(this);
            var Et = u.apply(N, F);
            return Et.__actions__.push({ func: If, args: [it], thisArg: n }), new lr(Et, lt);
          }
          return St && Lt ? u.apply(this, F) : (Et = this.thru(it), St ? y ? Et.value()[0] : Et.value() : Et);
        });
      }), sr(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var f = of[u], m = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", y = /^(?:pop|shift)$/.test(u);
        O.prototype[u] = function() {
          var T = arguments;
          if (y && !this.__chain__) {
            var S = this.value();
            return f.apply(Pt(S) ? S : [], T);
          }
          return this[m](function(N) {
            return f.apply(Pt(N) ? N : [], T);
          });
        };
      }), Wr(Ht.prototype, function(u, f) {
        var m = O[f];
        if (m) {
          var y = m.name + "";
          Kt.call(rs, y) || (rs[y] = []), rs[y].push({ name: f, func: m });
        }
      }), rs[Sf(n, w).name] = [{
        name: "wrapper",
        func: n
      }], Ht.prototype.clone = hM, Ht.prototype.reverse = dM, Ht.prototype.value = pM, O.prototype.at = VN, O.prototype.chain = WN, O.prototype.commit = UN, O.prototype.next = YN, O.prototype.plant = GN, O.prototype.reverse = KN, O.prototype.toJSON = O.prototype.valueOf = O.prototype.value = XN, O.prototype.first = O.prototype.head, Hu && (O.prototype[Hu] = qN), O;
    }, ts = UP();
    Wa ? ((Wa.exports = ts)._ = ts, Q1._ = ts) : Ge._ = ts;
  }).call(Fn);
})(WG, ct);
const UG = te({
  name: "BrandExpansion",
  props: {
    /**
     * Add a balancing effect to the globe
     */
    animated: {
      type: Boolean
    },
    /**
     * Monochromatic logo's color
     */
    color: {
      type: String,
      default: null
    },
    /**
     * Logo's background color
     */
    background: {
      type: String,
      default: null
    },
    /**
     * Logo's size
     */
    size: {
      type: [Number, String],
      default: "70px"
    },
    /**
     * Brand mode ("short", "medium", "long")
     */
    mode: {
      type: String,
      default: da.Short
    },
    /**
     * Reverse color of the main text to white if no `color` is given
     */
    dark: {
      type: Boolean
    }
  },
  computed: {
    baseWidth() {
      return {
        [da.Short]: 401.256,
        [da.Medium]: 901.24,
        [da.Long]: 1047.01
      }[this.mode];
    },
    width() {
      return `${this.baseWidth / 200 * this.sizeAsNumber}px`;
    },
    height() {
      return `${this.sizeAsNumber}px`;
    },
    sizeAsNumber() {
      return ct.isString(this.size) ? parseInt(this.size) : this.size;
    },
    style() {
      return {
        "--monochrome-color": this.color,
        background: this.background
      };
    }
  }
});
var YG = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("span", { staticClass: "brand-expansion", class: { "brand-expansion--dark": e.dark, "brand-expansion--animated": e.animated }, style: e.style }, [e.mode === "short" ? n("svg", { attrs: { width: e.width, height: e.height, viewBox: "0 0 106.166 52.917", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { staticClass: "triangle", attrs: { d: "m11.947 52.917 7.52-12.283 7.52 12.283Z" } }), n("path", { staticClass: "globe", attrs: { d: "M28.229 23.417c.298-1.504.485-3.092.554-4.726h5.091a14.367 14.367 0 0 1-1.286 4.726Zm1.474 4.105a14.488 14.488 0 0 1-4.053 2.861c.24-.388.47-.801.688-1.239.45-.897.841-1.875 1.173-2.917h3.342c-.355.45-.739.883-1.15 1.295m-8.83-4.105V18.69h5.097a27.764 27.764 0 0 1-.61 4.726Zm2.952 4.47c-.857 1.714-1.887 2.919-2.953 3.493v-5.153h3.67a16.722 16.722 0 0 1-.717 1.66m-8.716 0c-.26-.521-.5-1.076-.716-1.66h3.669v5.153c-1.066-.574-2.096-1.779-2.953-3.493m-2.145-9.196h5.098v4.726h-4.488a27.764 27.764 0 0 1-.61-4.726m-3.733 8.831a14.704 14.704 0 0 1-1.15-1.295h3.342c.332 1.042.724 2.02 1.172 2.917.22.438.449.851.689 1.24a14.48 14.48 0 0 1-4.053-2.862m-2.885-4.105a14.363 14.363 0 0 1-1.287-4.726h5.092c.069 1.634.256 3.222.554 4.726zm4.359-12.262a31.079 31.079 0 0 0-.554 4.726H5.06a14.363 14.363 0 0 1 1.287-4.726zM9.231 7.05a14.485 14.485 0 0 1 4.052-2.86c-.24.387-.469.8-.688 1.238-.448.898-.84 1.876-1.172 2.917H8.08c.355-.45.738-.883 1.15-1.295m8.83 4.105v4.726h-5.097c.075-1.652.281-3.244.61-4.726zm-2.952-4.47c.857-1.714 1.887-2.918 2.953-3.493v5.153h-3.67c.217-.583.456-1.138.717-1.66m8.716 0c.26.522.5 1.077.716 1.66h-3.669V3.192c1.066.575 2.096 1.78 2.953 3.493m2.145 9.196h-5.098v-4.726h4.488c.328 1.482.535 3.074.61 4.726m3.733-8.83c.411.411.795.844 1.15 1.294h-3.342a20.314 20.314 0 0 0-1.173-2.917 15.822 15.822 0 0 0-.688-1.239 14.49 14.49 0 0 1 4.053 2.861m2.885 4.105a14.367 14.367 0 0 1 1.286 4.726h-5.091a31.079 31.079 0 0 0-.554-4.726Zm-.898-6.092A17.173 17.173 0 0 0 19.467 0 17.173 17.173 0 0 0 7.244 5.063 17.174 17.174 0 0 0 2.18 17.286c0 4.618 1.798 8.959 5.063 12.223a17.173 17.173 0 0 0 12.223 5.064c4.617 0 8.958-1.799 12.223-5.064a17.173 17.173 0 0 0 5.063-12.223c0-4.617-1.798-8.958-5.063-12.223" } }), n("path", { staticClass: "plate", attrs: { d: "M0 36.198h38.934v2.81H0Z" } }), n("g", { staticClass: "main-text" }, [n("path", { attrs: { d: "M48.51 7.923h7.164v37.07H48.51z" } }), n("path", { attrs: { d: "M60.788 42.793c-1.626-1.698-2.439-4.028-2.439-6.991v-17.09c0-3.683.734-6.459 2.201-8.33 1.468-1.87 3.769-2.804 6.905-2.804 2.733 0 4.934.748 6.603 2.244 1.668 1.496 2.503 3.654 2.503 6.473v6.387h-7.38v-5.48c0-1.065-.129-1.799-.388-2.202-.259-.402-.705-.604-1.338-.604-.662 0-1.115.23-1.36.69-.244.461-.366 1.137-.366 2.029v18.6c0 .979.144 1.69.431 2.136.288.447.72.67 1.295.67 1.15 0 1.726-.935 1.726-2.806v-6.689h7.466v6.991c0 6.215-3.122 9.322-9.365 9.322-2.704 0-4.87-.848-6.494-2.546" } }), n("path", { attrs: { d: "M78.762 7.923h7.164v37.07h-7.164z" } }), n("path", { attrs: { d: "M92.528 44.346a7.609 7.609 0 0 1-3.258-2.913c-.792-1.28-1.187-2.826-1.187-4.639V29.03h7.294v7.333c0 .662.136 1.186.41 1.575.273.388.697.582 1.273.582.546 0 .956-.18 1.23-.539.273-.36.41-.87.41-1.532V7.923h7.466v27.792c0 1.928-.382 3.619-1.144 5.071-.763 1.453-1.827 2.575-3.194 3.366-1.366.792-2.927 1.187-4.682 1.187-1.698 0-3.237-.331-4.618-.993" } })])]) : e.mode === "medium" ? n("svg", { attrs: { width: e.width, height: e.height, viewBox: "0 0 901.24 200", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { staticClass: "triangle", attrs: { d: "m45.153 200 28.423-46.424L101.999 200Z" } }), n("path", { staticClass: "globe", attrs: { d: "M 106.692 88.5051 C 107.819 82.8227 108.526 76.8189 108.786 70.6453 L 128.03 70.6453 C 127.431 76.8914 125.785 82.9146 123.168 88.5051 Z M 112.263 104.021 C 107.739 108.545 102.563 112.178 96.9466 114.835 C 97.8831 113.313 98.751 111.751 99.5476 110.152 C 101.244 106.76 102.725 103.064 103.979 99.1273 L 116.611 99.1273 C 115.259 100.842 113.807 102.476 112.263 104.021 M 78.8877 88.5051 L 78.8877 70.6453 L 98.1543 70.6453 C 97.8706 76.8889 97.0908 82.9061 95.8503 88.5051 Z M 90.0467 105.401 C 86.8083 111.879 82.915 116.431 78.8877 118.601 L 78.8877 99.1273 L 92.7543 99.1273 C 91.9656 101.266 91.0617 103.36 90.0467 105.401 M 57.1059 105.401 C 56.0908 103.36 55.187 101.266 54.3983 99.1273 L 68.2649 99.1273 L 68.2649 118.601 C 64.237 116.431 60.3442 111.879 57.1059 105.401 M 48.9983 70.6453 L 68.2649 70.6453 L 68.2649 88.5051 L 51.3023 88.5051 C 50.0617 82.9061 49.282 76.8889 48.9983 70.6453 M 34.8894 104.021 C 33.3454 102.476 31.8937 100.842 30.5419 99.1273 L 43.1735 99.1273 C 44.4274 103.064 45.9091 106.76 47.6043 110.152 C 48.4014 111.751 49.2695 113.313 50.206 114.835 C 44.5894 112.179 39.4128 108.545 34.8894 104.021 M 23.9842 88.5051 C 21.3679 82.9146 19.7213 76.8914 19.1229 70.6453 L 38.367 70.6453 C 38.6263 76.8189 39.3337 82.8227 40.4604 88.5051 Z M 40.4604 42.1627 C 39.3337 47.8451 38.6263 53.8489 38.367 60.0225 L 19.1229 60.0225 C 19.7213 53.7764 21.3679 47.7532 23.9842 42.1627 Z M 34.8894 26.647 C 39.4128 22.123 44.5894 18.4895 50.206 15.8331 C 49.2695 17.3545 48.4014 18.9171 47.6043 20.516 C 45.9091 23.9078 44.4274 27.6045 43.1735 31.5405 L 30.5419 31.5405 C 31.8938 29.8255 33.3455 28.1915 34.8894 26.647 M 68.2649 42.1627 L 68.2649 60.0225 L 48.9983 60.0225 C 49.282 53.7795 50.0617 47.7617 51.3023 42.1627 Z M 57.1059 25.267 C 60.3442 18.789 64.237 14.237 68.2649 12.0663 L 68.2649 31.5405 L 54.3983 31.5405 C 55.1869 29.402 56.0907 27.3078 57.1059 25.267 M 90.0467 25.267 C 91.0619 27.3078 91.9657 29.402 92.7543 31.5405 L 78.8877 31.5405 L 78.8877 12.0663 C 82.915 14.237 86.8083 18.789 90.0467 25.267 M 98.1543 60.0225 L 78.8877 60.0225 L 78.8877 42.1627 L 95.8503 42.1627 C 97.0908 47.7617 97.8706 53.7795 98.1543 60.0225 M 112.263 26.647 C 113.807 28.1916 115.259 29.8256 116.611 31.5405 L 103.979 31.5405 C 102.725 27.6045 101.244 23.9078 99.5476 20.516 C 98.751 18.9169 97.8831 17.3544 96.9466 15.8331 C 102.563 18.4895 107.739 22.1236 112.263 26.647 M 123.168 42.1627 C 125.785 47.7532 127.431 53.7764 128.03 60.0225 L 108.786 60.0225 C 108.526 53.8489 107.819 47.8451 106.692 42.1627 Z M 119.774 19.136 C 107.434 6.79604 91.0274 0.00028712 73.576 0.00028712 C 56.1246 0.00028712 39.7178 6.79604 27.3778 19.136 C 15.0384 31.476 8.24207 47.8828 8.24207 65.3336 C 8.24207 82.7856 15.0384 99.1924 27.3778 111.532 C 39.7178 123.872 56.1246 130.668 73.576 130.668 C 91.0274 130.668 107.434 123.872 119.774 111.532 C 132.114 99.1924 138.91 82.7856 138.91 65.3336 C 138.91 47.8828 132.114 31.476 119.774 19.136" } }), n("path", { staticClass: "plate", attrs: { d: "M 2e-06 136.811 L 147.151 136.811 L 147.151 147.433 L 2e-06 147.433 Z" } }), n("path", { staticClass: "main-text", attrs: { d: "M187.413 29.944h27.076v140.112h-27.076zM233.817 161.737c-6.145-6.416-9.216-15.223-9.216-26.424V70.72c0-13.918 2.773-24.41 8.318-31.48 5.546-7.067 14.244-10.602 26.098-10.602 10.33 0 18.648 2.83 24.956 8.482 6.305 5.655 9.46 13.81 9.46 24.466v24.14h-27.892V65.013c0-4.021-.488-6.794-1.467-8.318-.98-1.522-2.666-2.284-5.057-2.284-2.502 0-4.215.872-5.138 2.61-.925 1.74-1.386 4.297-1.386 7.667v70.3c0 3.697.543 6.39 1.63 8.073 1.087 1.688 2.717 2.528 4.894 2.528 4.348 0 6.524-3.532 6.524-10.602v-25.282h28.218v26.424c0 23.488-11.8 35.232-35.394 35.232-10.223 0-18.406-3.206-24.548-9.623M301.752 29.944h27.076v140.112h-27.076zM353.782 167.609c-5.22-2.5-9.326-6.17-12.315-11.01-2.992-4.837-4.485-10.684-4.485-17.534l-.001-29.344h27.566v27.712c0 2.503.515 4.486 1.55 5.954 1.032 1.469 2.635 2.202 4.811 2.202 2.065 0 3.614-.678 4.65-2.039 1.03-1.358 1.548-3.287 1.548-5.79V29.944h28.219v105.043c0 7.286-1.443 13.676-4.323 19.166-2.882 5.491-6.906 9.732-12.07 12.722-5.166 2.992-11.066 4.485-17.697 4.485-6.418 0-12.233-1.251-17.453-3.751" } }), n("path", { staticClass: "secondary-text", attrs: { d: "M442.17 92.461c-2.644-2.948-3.965-7.703-3.965-14.262v-6.407h12.89v8.16c0 3.255 1.04 4.883 3.126 4.883 1.17 0 1.984-.344 2.441-1.03.458-.687.686-1.843.686-3.47 0-2.136-.254-3.903-.762-5.301-.509-1.399-1.158-2.567-1.945-3.51-.79-.939-2.2-2.402-4.233-4.385l-5.644-5.644c-4.374-4.27-6.56-9-6.56-14.186 0-5.593 1.284-9.851 3.852-12.776 2.567-2.923 6.318-4.385 11.25-4.385 5.898 0 10.145 1.563 12.737 4.69 2.594 3.128 3.89 8.022 3.89 14.682h-13.347l-.076-4.5c0-.863-.242-1.55-.725-2.059-.484-.507-1.157-.762-2.02-.762-1.019 0-1.782.28-2.289.839-.51.56-.763 1.322-.763 2.288 0 2.135 1.22 4.347 3.661 6.635l7.627 7.323c1.78 1.728 3.254 3.368 4.424 4.92 1.17 1.55 2.11 3.381 2.822 5.49.712 2.11 1.068 4.615 1.068 7.513 0 6.458-1.182 11.352-3.547 14.682-2.364 3.33-6.267 4.996-11.708 4.996-5.949 0-10.246-1.474-12.89-4.424M480.1 96.275V43.343h-7.779V30.758H501v12.585h-7.78v52.932ZM522.248 83.308c.406-1.016.61-2.44.61-4.27V47.003c0-1.422-.19-2.58-.572-3.47-.382-.889-1.158-1.334-2.327-1.334-2.187 0-3.279 1.652-3.279 4.957v31.958c0 1.881.229 3.306.686 4.271.457.966 1.297 1.45 2.517 1.45 1.17 0 1.957-.509 2.365-1.527m-14.415 8.734c-2.746-3.228-4.12-7.767-4.12-13.615V47.233c0-5.644 1.374-9.902 4.12-12.776 2.745-2.872 6.761-4.31 12.05-4.31 5.288 0 9.305 1.438 12.051 4.31 2.746 2.874 4.118 7.132 4.118 12.776v31.194c0 5.9-1.372 10.45-4.118 13.653-2.746 3.203-6.763 4.805-12.05 4.805-5.29 0-9.306-1.613-12.051-4.843M556.34 55.012c1.83 0 2.745-1.983 2.745-5.949 0-1.728-.076-3.025-.228-3.89-.153-.864-.433-1.46-.84-1.792-.407-.33-.99-.496-1.754-.496h-3.05v12.127Zm-16.475-24.254H560c3.204 0 5.683.725 7.437 2.174 1.754 1.449 2.937 3.483 3.547 6.101.61 2.62.915 5.963.915 10.03 0 3.713-.484 6.61-1.45 8.695-.966 2.086-2.644 3.534-5.033 4.348 1.983.407 3.419 1.399 4.309 2.974.89 1.577 1.335 3.712 1.335 6.407l-.152 24.788h-12.815V70.648c0-1.83-.356-3-1.067-3.508-.713-.509-2.01-.764-3.89-.764v29.899h-13.271zM574.965 30.758h12.66v65.517h-12.66zM591.583 96.275V30.758h26.237v12.661h-12.89v12.737h12.357v12.356H604.93v15.025h13.73v12.738ZM625.256 92.461c-2.644-2.948-3.966-7.703-3.966-14.262v-6.407h12.89v8.16c0 3.255 1.041 4.883 3.127 4.883 1.17 0 1.983-.344 2.44-1.03.458-.687.687-1.843.687-3.47 0-2.136-.255-3.903-.763-5.301-.508-1.399-1.157-2.567-1.945-3.51-.789-.939-2.2-2.402-4.232-4.385l-5.645-5.644c-4.374-4.27-6.559-9-6.559-14.186 0-5.593 1.283-9.851 3.851-12.776 2.567-2.923 6.318-4.385 11.25-4.385 5.898 0 10.145 1.563 12.738 4.69 2.593 3.128 3.89 8.022 3.89 14.682H639.67l-.076-4.5c0-.863-.242-1.55-.724-2.059-.484-.507-1.158-.762-2.021-.762-1.018 0-1.782.28-2.289.839-.51.56-.763 1.322-.763 2.288 0 2.135 1.221 4.347 3.661 6.635l7.628 7.323c1.779 1.728 3.253 3.368 4.423 4.92 1.17 1.55 2.11 3.381 2.822 5.49.712 2.11 1.068 4.615 1.068 7.513 0 6.458-1.182 11.352-3.546 14.682-2.365 3.33-6.268 4.996-11.708 4.996-5.95 0-10.246-1.474-12.89-4.424M681.239 96.275V43.343h-7.78V30.758h28.678v12.585h-7.78v52.932ZM705.126 96.275V30.758h13.042v23.415h6.178V30.758h13.043v65.517h-13.043V66.529h-6.178v29.746ZM755.12 75.224h5.95l-2.898-33.33h-.61Zm-14.49 21.05 6.33-65.516h22.195l6.254 65.517h-12.432l-.916-10.602h-7.931l-.763 10.602zM782.677 96.275V43.343h-7.78V30.758h28.679v12.585h-7.78v52.932ZM455.976 130.224c1.83 0 2.745-1.983 2.745-5.95 0-1.727-.076-3.024-.228-3.889-.153-.864-.433-1.46-.84-1.793-.407-.33-.99-.495-1.754-.495h-3.05v12.127ZM439.5 105.97h20.136c3.203 0 5.682.724 7.436 2.174 1.754 1.448 2.937 3.483 3.547 6.101.61 2.62.915 5.962.915 10.03 0 3.713-.484 6.61-1.45 8.695s-2.643 3.535-5.033 4.348c1.983.408 3.419 1.399 4.309 2.974.89 1.577 1.335 3.712 1.335 6.407l-.152 24.788h-12.815V145.86c0-1.83-.356-3-1.067-3.508-.712-.508-2.01-.763-3.89-.763v29.898h-13.271zM493.173 158.52c.406-1.016.61-2.44.61-4.27v-32.035c0-1.422-.19-2.58-.572-3.47-.382-.89-1.158-1.334-2.326-1.334-2.188 0-3.28 1.652-3.28 4.957v31.958c0 1.882.229 3.306.686 4.271.458.966 1.297 1.45 2.518 1.45 1.168 0 1.956-.509 2.364-1.526m-14.415 8.733c-2.746-3.229-4.119-7.767-4.119-13.615v-31.194c0-5.644 1.373-9.902 4.119-12.777 2.745-2.871 6.761-4.309 12.05-4.309 5.288 0 9.305 1.438 12.051 4.31 2.746 2.874 4.118 7.132 4.118 12.776v31.194c0 5.9-1.372 10.45-4.118 13.653-2.746 3.203-6.763 4.806-12.05 4.806-5.29 0-9.306-1.614-12.051-4.844M514.756 167.597c-2.873-3-4.309-7.118-4.309-12.355v-30.205c0-6.508 1.297-11.413 3.89-14.72 2.593-3.305 6.66-4.958 12.203-4.958 4.83 0 8.72 1.323 11.67 3.966 2.948 2.646 4.424 6.459 4.424 11.442v11.287H529.59v-9.686c0-1.88-.229-3.177-.686-3.89-.458-.711-1.246-1.067-2.365-1.067-1.17 0-1.97.408-2.403 1.22-.432.814-.648 2.01-.648 3.584v32.873c0 1.73.254 2.988.763 3.776.508.788 1.27 1.183 2.288 1.183 2.033 0 3.051-1.652 3.051-4.959v-11.822h13.195v12.356c0 10.983-5.518 16.476-16.55 16.476-4.78 0-8.607-1.5-11.48-4.5M546.088 171.487V105.97h12.967v26.239l6.1-26.239h13.196l-7.322 29.976 8.847 35.542H566.3l-7.17-31.729v31.73ZM605.578 171.487v-52.932H597.8V105.97h28.678v12.586h-7.78v52.932ZM629.466 171.487V105.97h13.043v23.416h6.178v-23.416h13.042v65.518h-13.042v-29.746h-6.178v29.746ZM665.93 171.487V105.97h26.238v12.662h-12.89v12.737h12.356v12.357h-12.356v15.025h13.729v12.737ZM720.31 171.487l-7.016-65.518h12.813l3.66 41.34 3.662-41.34h12.203l3.509 41.34 3.508-41.34h12.967l-7.17 65.518h-15.712l-3.28-31.577-3.126 31.577ZM786.254 158.52c.407-1.016.611-2.44.611-4.27v-32.035c0-1.422-.191-2.58-.572-3.47-.382-.89-1.158-1.334-2.327-1.334-2.187 0-3.279 1.652-3.279 4.957v31.958c0 1.882.228 3.306.686 4.271.457.966 1.297 1.45 2.517 1.45 1.169 0 1.957-.509 2.364-1.526m-14.415 8.733c-2.746-3.229-4.119-7.767-4.119-13.615v-31.194c0-5.644 1.373-9.902 4.12-12.777 2.745-2.871 6.761-4.309 12.05-4.309 5.288 0 9.305 1.438 12.051 4.31 2.745 2.874 4.118 7.132 4.118 12.776v31.194c0 5.9-1.373 10.45-4.118 13.653-2.746 3.203-6.763 4.806-12.05 4.806-5.29 0-9.306-1.614-12.052-4.844M820.347 130.224c1.83 0 2.745-1.983 2.745-5.95 0-1.727-.076-3.024-.228-3.889-.153-.864-.433-1.46-.84-1.793-.407-.33-.99-.495-1.754-.495h-3.05v12.127Zm-16.475-24.254h20.136c3.204 0 5.682.724 7.437 2.174 1.753 1.448 2.936 3.483 3.546 6.101.61 2.62.915 5.962.915 10.03 0 3.713-.484 6.61-1.449 8.695-.967 2.085-2.644 3.535-5.034 4.348 1.983.408 3.42 1.399 4.31 2.974.888 1.577 1.334 3.712 1.334 6.407l-.152 24.788H822.1V145.86c0-1.83-.356-3-1.067-3.508-.713-.508-2.01-.763-3.89-.763v29.898h-13.272zM839.246 171.487V105.97h13.12v54.382h13.499v11.136ZM884.383 159.893c2.389 0 3.584-1.168 3.584-3.508v-33.789c0-1.473-.114-2.58-.343-3.317-.229-.737-.648-1.232-1.258-1.488-.61-.253-1.552-.38-2.822-.38h-1.45v42.482Zm-15.484-53.924h18.077c4.678 0 8.186 1.297 10.525 3.891 2.338 2.593 3.534 6.433 3.585 11.516l.153 30.661c.05 6.459-1.069 11.315-3.356 14.568-2.288 3.255-6.077 4.882-11.364 4.882h-17.62z" } })]) : e.mode === "long" ? n("svg", { attrs: { width: e.width, height: e.height, viewBox: "0 0 1047.01 200", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { staticClass: "triangle", attrs: { d: "m45.153 200 28.423-46.424L101.999 200Z" } }), n("path", { staticClass: "globe", attrs: { d: "M 106.691 88.5051 C 107.818 82.8227 108.526 76.8189 108.785 70.6453 L 128.029 70.6453 C 127.431 76.8914 125.784 82.9146 123.168 88.5051 Z M 112.262 104.021 C 107.739 108.545 102.563 112.178 96.9465 114.835 C 97.883 113.313 98.7509 111.751 99.5475 110.152 C 101.243 106.76 102.725 103.064 103.978 99.1273 L 116.611 99.1273 C 115.259 100.842 113.807 102.476 112.263 104.021 M 78.887 88.5051 L 78.887 70.6453 L 98.1536 70.6453 C 97.8699 76.8889 97.0901 82.9061 95.8502 88.5051 Z M 90.046 105.401 C 86.8076 111.879 82.9143 116.431 78.887 118.601 L 78.887 99.1273 L 92.7536 99.1273 C 91.9649 101.266 91.061 103.36 90.046 105.401 M 57.1052 105.401 C 56.0901 103.36 55.1863 101.266 54.3976 99.1273 L 68.2642 99.1273 L 68.2642 118.601 C 64.2363 116.431 60.3435 111.879 57.1052 105.401 M 48.9976 70.6453 L 68.2642 70.6453 L 68.2642 88.5051 L 51.3028 88.5051 C 50.0623 82.9061 49.2819 76.8889 48.9988 70.6453 M 34.8899 104.021 C 33.3459 102.476 31.8942 100.842 30.5424 99.1273 L 43.1734 99.1273 C 44.4273 103.064 45.9096 106.76 47.6049 110.152 C 48.4019 111.751 49.27 113.313 50.2065 114.835 C 44.5899 112.179 39.4133 108.545 34.8899 104.021 M 23.9841 88.5051 C 21.3678 82.9146 19.7212 76.8914 19.1229 70.6453 L 38.3669 70.6453 C 38.6262 76.8189 39.3336 82.8227 40.4609 88.5051 Z M 40.4603 42.1627 C 39.3342 47.8451 38.6262 53.8489 38.3669 60.0225 L 19.1229 60.0225 C 19.7212 53.7764 21.3678 47.7532 23.9841 42.1627 Z M 34.8893 26.647 C 39.4127 22.123 44.5893 18.4895 50.2059 15.8331 C 49.2694 17.3545 48.4013 18.9171 47.6043 20.516 C 45.909 23.9078 44.4273 27.6045 43.1734 31.5405 L 30.5424 31.5405 C 31.8943 29.8255 33.346 28.1915 34.8899 26.647 M 68.2648 42.1627 L 68.2648 60.0225 L 48.9988 60.0225 C 49.2819 53.7795 50.0617 47.7617 51.3022 42.1627 Z M 57.1064 25.267 C 60.3448 18.789 64.2375 14.237 68.2654 12.0663 L 68.2654 31.5405 L 54.3988 31.5405 C 55.1872 29.402 56.0908 27.3078 57.1058 25.267 M 90.0466 25.267 C 91.0618 27.3078 91.9656 29.402 92.7542 31.5405 L 78.8876 31.5405 L 78.8876 12.0663 C 82.9149 14.237 86.8083 18.789 90.0466 25.267 M 98.1548 60.0225 L 78.8876 60.0225 L 78.8876 42.1627 L 95.8502 42.1627 C 97.0908 47.7617 97.8711 53.7795 98.1542 60.0225 M 112.263 26.647 C 113.807 28.1916 115.258 29.8256 116.611 31.5405 L 103.978 31.5405 C 102.725 27.6045 101.243 23.9078 99.5475 20.516 C 98.7509 18.9169 97.883 17.3544 96.9465 15.8331 C 102.563 18.4895 107.739 22.1236 112.263 26.647 M 123.169 42.1627 C 125.785 47.7532 127.431 53.7764 128.03 60.0225 L 108.786 60.0225 C 108.526 53.8489 107.819 47.8451 106.692 42.1627 Z M 119.775 19.136 C 107.434 6.79604 91.0273 0.00028712 73.5759 0.00028712 C 56.1245 0.00028712 39.7177 6.79604 27.3777 19.136 C 15.0389 31.476 8.24198 47.8828 8.24198 65.3336 C 8.24198 82.7856 15.0383 99.1924 27.3777 111.532 C 39.7177 123.872 56.1245 130.668 73.5759 130.668 C 91.0279 130.668 107.434 123.872 119.774 111.532 C 132.114 99.1924 138.91 82.7856 138.91 65.3336 C 138.91 47.8828 132.114 31.476 119.774 19.136" } }), n("path", { staticClass: "plate", attrs: { d: "M -8.72e-05 136.811 L 147.151 136.811 L 147.151 147.433 L -8.72e-05 147.433 Z" } }), n("path", { staticClass: "main-text", attrs: { d: "M203.5 25.928h12.66v65.517H203.5zM220.118 91.445V25.928h13.5l6.026 31.348V25.928h12.661v65.517h-12.814l-6.559-32.796v32.796ZM263.073 91.445V38.513h-7.78V25.928h28.678v12.585h-7.78v52.932ZM286.96 91.445V25.928h26.237V38.59h-12.89v12.737h12.357v12.357h-12.357v15.024h13.73v12.738ZM333.813 50.183c1.83 0 2.745-1.984 2.745-5.95 0-1.728-.075-3.025-.228-3.89-.152-.864-.433-1.46-.839-1.792-.408-.33-.992-.495-1.755-.495h-3.05v12.127Zm-16.475-24.255h20.136c3.204 0 5.682.724 7.437 2.174 1.753 1.45 2.936 3.484 3.546 6.102.61 2.619.916 5.962.916 10.03 0 3.712-.485 6.61-1.45 8.694-.966 2.086-2.644 3.535-5.034 4.348 1.984.408 3.42 1.4 4.309 2.974.89 1.577 1.336 3.713 1.336 6.408l-.153 24.787h-12.814V65.818c0-1.83-.357-2.999-1.068-3.508-.712-.508-2.01-.763-3.89-.763v29.898h-13.271zM352.712 91.445V25.928h13.5l6.026 31.348V25.928H384.9v65.517h-12.815l-6.56-32.796v32.796ZM402.592 70.394h5.95l-2.898-33.33h-.61Zm-14.491 21.051 6.33-65.517h22.195l6.255 65.517h-12.433l-.915-10.601H401.6l-.762 10.601zM430.148 91.445V38.513h-7.78V25.928h28.678v12.585h-7.78v52.932ZM453.761 25.928h12.661v65.517h-12.66zM488.616 78.479c.407-1.017.611-2.441.611-4.27V42.173c0-1.423-.19-2.58-.572-3.47-.382-.89-1.158-1.335-2.327-1.335-2.187 0-3.279 1.653-3.279 4.957v31.958c0 1.881.228 3.306.687 4.272.457.966 1.296 1.448 2.517 1.448 1.168 0 1.956-.507 2.363-1.525m-14.414 8.733c-2.747-3.228-4.12-7.767-4.12-13.614V42.403c0-5.644 1.373-9.902 4.12-12.776 2.745-2.872 6.761-4.31 12.05-4.31 5.288 0 9.305 1.438 12.052 4.31 2.745 2.873 4.118 7.132 4.118 12.776v31.195c0 5.898-1.373 10.449-4.118 13.653-2.747 3.203-6.764 4.805-12.051 4.805-5.29 0-9.306-1.614-12.051-4.844M506.234 91.445V25.928h13.5l6.026 31.348V25.928h12.661v65.517h-12.814l-6.559-32.796v32.796ZM556.114 70.394h5.95l-2.898-33.33h-.61Zm-14.491 21.051 6.33-65.517h22.195l6.254 65.517H563.97l-.915-10.601h-7.932l-.763 10.601zM579.574 91.445V25.928h13.118V80.31h13.501v11.136ZM631.475 87.556c-2.873-3-4.308-7.119-4.308-12.356V44.996c0-6.508 1.296-11.414 3.89-14.72 2.592-3.305 6.659-4.958 12.202-4.958 4.83 0 8.72 1.323 11.67 3.966 2.949 2.645 4.424 6.458 4.424 11.44v11.289H646.31v-9.687c0-1.88-.23-3.176-.687-3.89-.458-.71-1.246-1.067-2.365-1.067-1.17 0-1.97.408-2.402 1.22-.433.814-.649 2.01-.649 3.585v32.873c0 1.73.255 2.988.764 3.775.507.79 1.27 1.183 2.287 1.183 2.033 0 3.052-1.652 3.052-4.958V63.225h13.194v12.356c0 10.983-5.517 16.475-16.55 16.475-4.78 0-8.607-1.5-11.48-4.5M681.097 78.479c.407-1.017.61-2.441.61-4.27V42.173c0-1.423-.19-2.58-.571-3.47-.382-.89-1.158-1.335-2.327-1.335-2.187 0-3.279 1.653-3.279 4.957v31.958c0 1.881.228 3.306.687 4.272.457.966 1.296 1.448 2.517 1.448 1.168 0 1.955-.507 2.363-1.525m-14.414 8.733c-2.747-3.228-4.12-7.767-4.12-13.614V42.403c0-5.644 1.373-9.902 4.12-12.776 2.745-2.872 6.76-4.31 12.05-4.31 5.288 0 9.305 1.438 12.051 4.31 2.746 2.873 4.118 7.132 4.118 12.776v31.195c0 5.898-1.372 10.449-4.118 13.653-2.746 3.203-6.762 4.805-12.05 4.805-5.29 0-9.306-1.614-12.051-4.844M698.716 91.445V25.928h13.5l6.025 31.348V25.928h12.661v65.517H718.09l-6.56-32.796v32.796ZM738.24 87.631c-2.645-2.947-3.967-7.703-3.967-14.262v-6.406h12.89v8.16c0 3.255 1.04 4.882 3.127 4.882 1.169 0 1.983-.343 2.44-1.03.459-.687.687-1.843.687-3.47 0-2.136-.256-3.902-.763-5.301-.508-1.398-1.157-2.567-1.945-3.509-.789-.94-2.2-2.402-4.232-4.385l-5.645-5.645c-4.373-4.27-6.56-9-6.56-14.186 0-5.592 1.284-9.85 3.851-12.776 2.568-2.922 6.319-4.385 11.25-4.385 5.9 0 10.145 1.563 12.738 4.691 2.594 3.127 3.89 8.021 3.89 14.682h-13.347l-.076-4.5c0-.864-.242-1.55-.725-2.06-.483-.507-1.156-.762-2.02-.762-1.018 0-1.782.28-2.288.84-.51.56-.764 1.322-.764 2.287 0 2.135 1.22 4.347 3.66 6.635l7.628 7.323c1.78 1.729 3.254 3.369 4.424 4.92 1.17 1.551 2.11 3.382 2.822 5.49.712 2.111 1.068 4.616 1.068 7.514 0 6.458-1.182 11.352-3.547 14.681-2.363 3.331-6.267 4.997-11.708 4.997-5.948 0-10.246-1.475-12.889-4.424M788.02 78.479c.407-1.017.611-2.441.611-4.27V42.173c0-1.423-.191-2.58-.572-3.47-.381-.89-1.158-1.335-2.326-1.335-2.187 0-3.28 1.653-3.28 4.957v31.958c0 1.881.229 3.306.686 4.272.456.966 1.296 1.448 2.517 1.448 1.169 0 1.957-.507 2.365-1.525m-14.416 8.733c-2.745-3.228-4.118-7.767-4.118-13.614V42.403c0-5.644 1.373-9.902 4.118-12.776 2.745-2.872 6.762-4.31 12.05-4.31s9.306 1.438 12.052 4.31c2.745 2.873 4.118 7.132 4.118 12.776v31.195c0 5.898-1.373 10.449-4.118 13.653-2.746 3.203-6.763 4.805-12.051 4.805-5.289 0-9.306-1.614-12.05-4.844M822.113 50.183c1.83 0 2.746-1.984 2.746-5.95 0-1.728-.076-3.025-.229-3.89-.153-.864-.432-1.46-.838-1.792-.408-.33-.993-.495-1.755-.495h-3.05v12.127Zm-16.475-24.255h20.136c3.203 0 5.682.724 7.436 2.174 1.755 1.45 2.937 3.484 3.547 6.102.61 2.619.915 5.962.915 10.03 0 3.712-.484 6.61-1.45 8.694-.965 2.086-2.643 3.535-5.033 4.348 1.983.408 3.419 1.4 4.31 2.974.888 1.577 1.334 3.713 1.334 6.408l-.152 24.787h-12.814V65.818c0-1.83-.356-2.999-1.068-3.508-.712-.508-2.009-.763-3.89-.763v29.898h-13.271zM847.709 91.445V38.513h-7.78V25.928h28.678v12.585h-7.78v52.932ZM871.322 25.928h12.66v65.517h-12.66zM891.472 87.479c-2.62-3.051-3.928-7.576-3.928-13.576V25.928h12.738v47.44c0 2.086.203 3.714.61 4.883.406 1.17 1.27 1.753 2.593 1.753s2.185-.571 2.593-1.716c.406-1.144.61-2.783.61-4.92v-47.44h12.737v47.975c0 6-1.31 10.525-3.928 13.576-2.62 3.051-6.623 4.576-12.012 4.576-5.39 0-9.395-1.525-12.013-4.576M923.17 91.445V25.928h19.983l5.493 39.966 5.49-39.966h20.136v65.517h-11.974V44.234l-7.551 47.211h-11.745l-8.01-47.212v47.212ZM222.11 153.69c.406-1.016.61-2.44.61-4.27v-32.035c0-1.422-.19-2.58-.573-3.47-.381-.89-1.157-1.334-2.326-1.334-2.187 0-3.28 1.652-3.28 4.957v31.958c0 1.881.229 3.306.687 4.271.457.966 1.296 1.45 2.517 1.45 1.17 0 1.956-.509 2.364-1.526m-14.414 8.733c-2.747-3.229-4.12-7.767-4.12-13.615v-31.194c0-5.644 1.373-9.902 4.12-12.777 2.745-2.871 6.76-4.308 12.05-4.308 5.288 0 9.305 1.437 12.051 4.308 2.746 2.875 4.118 7.133 4.118 12.777v31.194c0 5.9-1.372 10.449-4.118 13.653-2.746 3.203-6.763 4.805-12.05 4.805-5.29 0-9.306-1.613-12.051-4.843M239.728 166.657v-65.518h26.236v12.738h-13.04v10.45h12.355v12.584h-12.356v29.746ZM287.396 101.14h12.66v65.517h-12.66zM304.014 166.657v-65.518h13.5l6.026 31.35v-31.35h12.661v65.518h-12.814l-6.559-32.797v32.797ZM347.275 166.657l-8.085-65.593h12.508l4.805 44.619 4.272-44.62h12.508l-8.085 65.594ZM376.264 166.657v-65.518h26.238V113.8h-12.89v12.738h12.356v12.357h-12.356v15.024h13.73v12.738ZM409.937 162.843c-2.644-2.948-3.965-7.703-3.965-14.263v-6.406h12.89v8.161c0 3.254 1.04 4.882 3.126 4.882 1.17 0 1.983-.344 2.441-1.03.457-.686.686-1.843.686-3.47 0-2.136-.255-3.902-.762-5.3-.51-1.4-1.158-2.568-1.945-3.51-.79-.94-2.2-2.402-4.233-4.385l-5.644-5.644c-4.375-4.272-6.56-9-6.56-14.187 0-5.592 1.283-9.85 3.852-12.775 2.566-2.923 6.318-4.386 11.25-4.386 5.898 0 10.145 1.564 12.737 4.691 2.593 3.127 3.89 8.021 3.89 14.681h-13.347l-.077-4.498c0-.865-.242-1.551-.724-2.06-.484-.508-1.158-.763-2.021-.763-1.018 0-1.78.28-2.289.839-.508.56-.762 1.322-.762 2.288 0 2.136 1.22 4.348 3.661 6.636l7.627 7.323c1.78 1.727 3.253 3.367 4.424 4.918 1.169 1.552 2.11 3.383 2.822 5.492.712 2.11 1.067 4.614 1.067 7.512 0 6.458-1.182 11.353-3.546 14.683-2.365 3.33-6.268 4.996-11.708 4.996-5.949 0-10.246-1.474-12.89-4.425M447.867 166.657v-52.932h-7.78v-12.586h28.678v12.586h-7.779v52.932ZM471.48 101.14h12.661v65.517H471.48zM491.272 162.271c-2.314-3.33-3.47-8.377-3.47-15.14v-28.22c0-6.051 1.346-10.626 4.042-13.729 2.695-3.101 6.712-4.652 12.051-4.652 4.321 0 7.676.865 10.068 2.593 2.39 1.729 4.042 4.246 4.957 7.55.916 3.307 1.373 7.551 1.373 12.739h-12.814v-5.873c0-1.577-.216-2.797-.648-3.662-.433-.864-1.208-1.296-2.325-1.296-2.492 0-3.738 1.627-3.738 4.88v31.73c0 1.983.254 3.483.762 4.5.508 1.018 1.399 1.526 2.67 1.526 1.27 0 2.16-.508 2.67-1.526.507-1.017.763-2.517.763-4.5v-9.382h-3.51v-11.287h16.018v38.135h-5.263l-2.212-5.492c-2.34 4.069-5.949 6.102-10.831 6.102-4.728 0-8.25-1.665-10.563-4.996M537.56 145.606h5.949l-2.899-33.33H540Zm-14.492 21.05 6.33-65.516h22.195l6.255 65.517h-12.433l-.915-10.602h-7.932l-.763 10.602zM565.115 166.657v-52.932h-7.78v-12.586h28.679v12.586h-7.78v52.932ZM588.728 101.14h12.662v65.517h-12.662zM612.257 166.657l-8.084-65.593h12.509l4.805 44.619 4.27-44.62h12.51l-8.085 65.594ZM641.247 166.657v-65.518h26.238V113.8h-12.89v12.738h12.356v12.357h-12.357v15.024h13.73v12.738ZM696.924 165.513c-2.44-1.169-4.36-2.885-5.758-5.148-1.4-2.262-2.098-4.996-2.098-8.2v-16.398h12.89v15.635c0 1.17.241 2.099.725 2.785.482.686 1.232 1.03 2.25 1.03.965 0 1.69-.318 2.174-.954.482-.635.724-1.537.724-2.707V101.14h13.195v49.119c0 3.407-.675 6.395-2.021 8.961-1.349 2.569-3.23 4.552-5.645 5.95-2.415 1.4-5.174 2.097-8.275 2.097-3 0-5.72-.585-8.161-1.754M742.968 153.69c.407-1.016.61-2.44.61-4.27v-32.035c0-1.422-.191-2.58-.571-3.47-.382-.89-1.158-1.334-2.327-1.334-2.187 0-3.28 1.652-3.28 4.957v31.958c0 1.881.23 3.306.686 4.271.457.966 1.297 1.45 2.517 1.45 1.17 0 1.957-.509 2.365-1.526m-14.415 8.733c-2.746-3.229-4.12-7.767-4.12-13.615v-31.194c0-5.644 1.374-9.902 4.12-12.777 2.745-2.871 6.762-4.308 12.05-4.308 5.289 0 9.306 1.437 12.051 4.308 2.746 2.875 4.119 7.133 4.119 12.777v31.194c0 5.9-1.373 10.449-4.119 13.653-2.745 3.203-6.762 4.805-12.05 4.805s-9.306-1.613-12.051-4.843M764.126 162.691c-2.62-3.05-3.928-7.575-3.928-13.577V101.14h12.737v47.44c0 2.086.203 3.714.61 4.882.406 1.17 1.27 1.755 2.594 1.755 1.32 0 2.185-.573 2.593-1.717.406-1.144.61-2.783.61-4.92v-47.44h12.737v47.974c0 6.002-1.31 10.526-3.928 13.577-2.62 3.051-6.623 4.576-12.012 4.576-5.391 0-9.395-1.525-12.013-4.576M812.298 125.394c1.831 0 2.746-1.983 2.746-5.95 0-1.727-.076-3.024-.229-3.89-.152-.863-.432-1.46-.84-1.792-.406-.33-.99-.495-1.753-.495h-3.05v12.127Zm-16.474-24.255h20.135c3.205 0 5.683.726 7.438 2.175 1.753 1.448 2.935 3.483 3.545 6.101.61 2.62.917 5.962.917 10.03 0 3.713-.485 6.61-1.45 8.694-.967 2.086-2.644 3.535-5.034 4.349 1.983.407 3.42 1.398 4.309 2.974.89 1.576 1.335 3.712 1.335 6.407l-.153 24.788h-12.813V141.03c0-1.83-.357-3-1.068-3.508-.712-.509-2.01-.764-3.89-.764v29.899h-13.271zM831.197 166.657v-65.518h13.5l6.026 31.35v-31.35h12.662v65.518H850.57l-6.559-32.797v32.797ZM881.078 145.606h5.95l-2.899-33.33h-.61Zm-14.492 21.05 6.331-65.516h22.194l6.255 65.517h-12.432l-.915-10.602h-7.932l-.763 10.602zM904.538 166.657v-65.518h13.118v54.381h13.5v11.137ZM933.91 101.14h12.66v65.517h-12.66zM953.7 162.843c-2.644-2.948-3.965-7.703-3.965-14.263v-6.406h12.89v8.161c0 3.254 1.04 4.882 3.126 4.882 1.17 0 1.983-.344 2.441-1.03.457-.686.686-1.843.686-3.47 0-2.136-.255-3.902-.762-5.3-.51-1.4-1.158-2.568-1.945-3.51-.79-.94-2.2-2.402-4.233-4.385l-5.644-5.644c-4.375-4.272-6.56-9-6.56-14.187 0-5.592 1.283-9.85 3.852-12.775 2.566-2.923 6.318-4.386 11.25-4.386 5.898 0 10.145 1.564 12.737 4.691 2.593 3.127 3.89 8.021 3.89 14.681h-13.347l-.077-4.498c0-.865-.242-1.551-.724-2.06-.485-.508-1.158-.763-2.02-.763-1.02 0-1.782.28-2.29.839-.509.56-.762 1.322-.762 2.288 0 2.136 1.22 4.348 3.661 6.636l7.627 7.323c1.78 1.727 3.253 3.367 4.423 4.918 1.17 1.552 2.11 3.383 2.823 5.492.712 2.11 1.067 4.614 1.067 7.512 0 6.458-1.182 11.353-3.546 14.683-2.365 3.33-6.268 4.996-11.709 4.996-5.948 0-10.244-1.474-12.89-4.425M991.63 166.657v-52.932h-7.78v-12.586h28.678v12.586h-7.78v52.932ZM1018.866 162.843c-2.645-2.948-3.967-7.703-3.967-14.263v-6.406h12.89v8.161c0 3.254 1.042 4.882 3.128 4.882 1.168 0 1.983-.344 2.44-1.03.458-.686.687-1.843.687-3.47 0-2.136-.256-3.902-.764-5.3-.507-1.4-1.156-2.568-1.945-3.51-.788-.94-2.199-2.402-4.231-4.385l-5.645-5.644c-4.374-4.272-6.56-9-6.56-14.187 0-5.592 1.285-9.85 3.852-12.775 2.567-2.923 6.318-4.386 11.25-4.386 5.899 0 10.144 1.564 12.737 4.691 2.594 3.127 3.89 8.021 3.89 14.681h-13.348l-.075-4.498c0-.865-.242-1.551-.725-2.06-.484-.508-1.156-.763-2.02-.763-1.018 0-1.782.28-2.289.839-.509.56-.764 1.322-.764 2.288 0 2.136 1.221 4.348 3.662 6.636l7.627 7.323c1.78 1.727 3.254 3.367 4.424 4.918 1.17 1.552 2.109 3.383 2.822 5.492.712 2.11 1.068 4.614 1.068 7.512 0 6.458-1.182 11.353-3.547 14.683-2.364 3.33-6.267 4.996-11.708 4.996-5.949 0-10.246-1.474-12.89-4.425" } })]) : e._e()]);
}, qG = [], GG = /* @__PURE__ */ Bt(
  UG,
  YG,
  qG,
  !1,
  null,
  "20f4c137",
  null,
  null
);
const Q_ = GG.exports, KG = te({
  name: "Brand",
  props: {
    /**
     * Add a balancing effect to the globe
     */
    animated: {
      type: Boolean
    },
    /**
     * Monochromatic logo's color
     */
    color: {
      type: [String],
      default: null
    },
    /**
     * Logo's background color
     */
    background: {
      type: String,
      default: null
    },
    /**
     * Logo's size
     */
    size: {
      type: [Number, String],
      default: "70px"
    },
    /**
     * Force the width of the logo to be the same as the height
     */
    square: {
      type: Boolean
    }
  },
  computed: {
    width() {
      return `${147.151 / 200 * this.sizeAsNumber}px`;
    },
    height() {
      return `${this.sizeAsNumber}px`;
    },
    sizeAsNumber() {
      return ct.isString(this.size) ? parseInt(this.size) : this.size;
    },
    style() {
      const t = this.square ? this.height : "auto";
      return {
        "--monochrome-color": this.color,
        color: this.color,
        background: this.background,
        width: t
      };
    }
  }
});
var XG = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("span", { staticClass: "brand", class: { "brand--animated": e.animated }, style: e.style }, [n("svg", { attrs: { width: e.width, height: e.height, viewBox: "0 0 147.151 200", xmlns: "http://www.w3.org/2000/svg" } }, [n("path", { staticClass: "triangle", attrs: { d: "M101.997 200H45.155l28.42-46.427z" } }), n("path", { staticClass: "globe", staticStyle: { "stroke-width": "0.608717" }, attrs: { d: "M119.771 19.138C107.432 6.793 91.028 0 73.576 0S39.719 6.793 27.38 19.138C15.035 31.477 8.242 47.882 8.242 65.334c0 17.451 6.793 33.856 19.138 46.195 12.339 12.339 28.744 19.138 46.196 19.138 17.452 0 33.856-6.793 46.195-19.138C132.11 99.19 138.91 82.785 138.91 65.334c0-17.452-6.793-33.857-19.138-46.196zm3.397 23.028a54.35 54.35 0 0 1 4.863 17.86H108.79c-.262-6.173-.968-12.175-2.094-17.86h16.478zM112.266 26.65a54.792 54.792 0 0 1 4.346 4.894H103.98c-1.254-3.939-2.733-7.634-4.431-11.024a61.475 61.475 0 0 0-2.6-4.681c5.619 2.654 10.793 6.288 15.316 10.81zm-14.11 33.376H78.89v-17.86h16.965c1.241 5.6 2.02 11.614 2.3 17.86zm-8.109-34.758a63.605 63.605 0 0 1 2.71 6.276H78.89v-19.48c4.03 2.174 7.92 6.721 11.157 13.204zm-32.943 0c3.238-6.477 7.134-11.03 11.158-13.203v19.473H54.395a62.794 62.794 0 0 1 2.709-6.276zm11.158 16.898v17.86H48.996c.286-6.246 1.065-12.26 2.3-17.86zM34.886 26.65A54.905 54.905 0 0 1 50.2 15.833a59.443 59.443 0 0 0-2.6 4.68c-1.698 3.391-3.177 7.086-4.43 11.025H30.538a55.764 55.764 0 0 1 4.347-4.894zm5.57 15.516c-1.127 5.685-1.833 11.687-2.095 17.86H19.12a54.201 54.201 0 0 1 4.863-17.86h16.478ZM23.976 88.507a54.35 54.35 0 0 1-4.863-17.86h19.241c.262 6.173.968 12.181 2.094 17.86H23.971Zm10.902 15.517a54.793 54.793 0 0 1-4.346-4.894h12.631c1.254 3.938 2.733 7.633 4.432 11.023a61.476 61.476 0 0 0 2.599 4.681 54.569 54.569 0 0 1-15.316-10.816zm14.11-33.376h19.266v17.86H51.29c-1.241-5.6-2.02-11.615-2.3-17.86Zm8.109 34.757a63.605 63.605 0 0 1-2.71-6.275h13.867v19.472c-4.03-2.173-7.919-6.72-11.157-13.203zm32.943 0c-3.238 6.477-7.134 11.03-11.157 13.203V99.136H92.75a62.793 62.793 0 0 1-2.709 6.275zM78.884 88.507v-17.86h19.265c-.286 6.246-1.065 12.26-2.3 17.86zm33.376 15.517a54.759 54.759 0 0 1-15.316 10.81 59.444 59.444 0 0 0 2.6-4.68c1.698-3.391 3.177-7.086 4.43-11.024h12.632a55.763 55.763 0 0 1-4.346 4.894zm-5.57-15.517c1.126-5.685 1.832-11.687 2.094-17.86h19.241a54.201 54.201 0 0 1-4.863 17.86h-16.478z" } }), n("path", { staticClass: "plate", staticStyle: { "stroke-width": "0.608717" }, attrs: { d: "M 147.151 136.809 L 147.151 147.431 L 9.02755e-15 147.431 L 8.37714e-15 136.809 Z" } })])]);
}, ZG = [], JG = /* @__PURE__ */ Bt(
  KG,
  XG,
  ZG,
  !1,
  null,
  "68c30091",
  null,
  null
);
const BC = JG.exports;
var t2 = {}, HC = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "xmark", r = 320, i = 512, a = [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], o = "f00d", s = "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faXmark = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(HC);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = HC;
  t.definition = {
    prefix: e.prefix,
    iconName: e.iconName,
    icon: [
      e.width,
      e.height,
      e.aliases,
      e.unicode,
      e.svgPathData
    ]
  }, t.faTimes = t.definition, t.prefix = e.prefix, t.iconName = e.iconName, t.width = e.width, t.height = e.height, t.ligatures = e.aliases, t.unicode = e.unicode, t.svgPathData = e.svgPathData, t.aliases = e.aliases;
})(t2);
const QG = te({
  name: "ConfirmButton",
  components: {
    BTooltip: z_,
    Fa: ar
  },
  props: {
    /**
     * Confirmation message visible in the tooltip upon user's click
     */
    label: {
      type: String,
      default: "Are you sure?"
    },
    /**
     * A description text to show under the confirmation label
     */
    description: {
      type: String,
      default: null
    },
    /**
     * Disable the closing button
     */
    noCloseButton: {
      type: Boolean
    },
    /**
     * The confirmation callback
     */
    confirmed: {
      type: Function,
      default: bd
    },
    /**
     * The cancellation callback
     */
    cancelled: {
      type: Function,
      default: bd
    },
    /**
     * Label for 'Yes' button
     */
    yes: {
      type: String,
      default: "Yes"
    },
    /**
     * Label for 'No' button
     */
    no: {
      type: String,
      default: "No"
    },
    /**
     * Tooltip position
     */
    placement: {
      type: String,
      default: zC.Top
    },
    /**
     * HTML tag to render this component to.
     */
    tag: {
      type: String,
      default: "button"
    }
  },
  data() {
    return {
      showTooltip: !1,
      uniqComponentId: p_("murmur-confirm-button-")
    };
  },
  watch: {
    showTooltip(t) {
      this.$refs.confirmationTooltip.$emit(t ? "open" : "close");
    }
  },
  beforeMount() {
    Br.add(t2.faTimes);
  },
  methods: {
    toggleConfirmationTooltip() {
      this.showTooltip || this.$root.$emit("bv::hide::tooltip"), this.showTooltip = !this.showTooltip, this.$root.$emit("toggled", this.showTooltip);
    },
    cancel() {
      this.$refs.confirmationTooltip.$emit("close"), this.cancelled(), this.$root.$emit("cancelled");
    },
    confirm() {
      this.showTooltip = !1, this.confirmed(), this.$root.$emit("confirmed");
    }
  }
});
var tK = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n(e.tag, { tag: "component", staticClass: "confirm-button", attrs: { id: e.uniqComponentId }, on: { click: e.toggleConfirmationTooltip } }, [e._t("default", function() {
    return [e._v("-")];
  }), n("b-tooltip", { ref: "confirmationTooltip", attrs: { target: e.uniqComponentId, triggers: "blur", placement: e.placement } }, [n("div", { staticClass: "confirm-button__tooltip" }, [e.noCloseButton ? e._e() : n("button", { staticClass: "confirm-button__tooltip__cancel btn btn-sm btn-link text-muted p-0 float-right", on: { click: e.cancel } }, [n("fa", { attrs: { icon: "times" } })], 1), n("p", { staticClass: "confirm-button__tooltip__label mb-2" }, [e._v(" " + e._s(e.label) + " ")]), e.description ? n("p", { staticClass: "confirm-button__tooltip__description mb-2" }, [e._v(" " + e._s(e.description) + " ")]) : e._e(), n("div", { staticClass: "confirm-button__tooltip__actions text-right" }, [n("button", { staticClass: "confirm-button__tooltip__actions__cancel btn btn-sm btn-link text-muted", on: { click: e.cancel } }, [e._v(" " + e._s(e.no) + " ")]), n("button", { staticClass: "confirm-button__tooltip__actions__confirm btn btn-sm btn-link text-light font-weight-bold", on: { click: e.confirm } }, [e._v(" " + e._s(e.yes) + " ")])])])])], 2);
}, eK = [], nK = /* @__PURE__ */ Bt(
  QG,
  tK,
  eK,
  !1,
  null,
  null,
  null,
  null
);
const rK = nK.exports;
var K0 = {}, iK = {
  get exports() {
    return K0;
  },
  set exports(t) {
    K0 = t;
  }
};
function aK(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var oK = aK;
function sK(t) {
  return function(e, n, r) {
    for (var i = -1, a = Object(e), o = r(e), s = o.length; s--; ) {
      var l = o[t ? s : ++i];
      if (n(a[l], l, a) === !1)
        break;
    }
    return e;
  };
}
var uK = sK, lK = uK, cK = lK(), fK = cK;
function hK(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var dK = hK, pK = vu, mK = Do, gK = "[object Arguments]";
function vK(t) {
  return mK(t) && pK(t) == gK;
}
var _K = vK, L6 = _K, bK = Do, jC = Object.prototype, yK = jC.hasOwnProperty, wK = jC.propertyIsEnumerable, xK = L6(function() {
  return arguments;
}()) ? L6 : function(t) {
  return bK(t) && yK.call(t, "callee") && !wK.call(t, "callee");
}, e2 = xK, tc = {}, CK = {
  get exports() {
    return tc;
  },
  set exports(t) {
    tc = t;
  }
};
function $K() {
  return !1;
}
var TK = $K;
(function(t, e) {
  var n = Hi, r = TK, i = e && !e.nodeType && e, a = i && !0 && t && !t.nodeType && t, o = a && a.exports === i, s = o ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  t.exports = c;
})(CK, tc);
var OK = 9007199254740991, SK = /^(?:0|[1-9]\d*)$/;
function EK(t, e) {
  var n = typeof t;
  return e = e == null ? OK : e, !!e && (n == "number" || n != "symbol" && SK.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var n2 = EK, AK = 9007199254740991;
function PK(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= AK;
}
var r2 = PK, MK = vu, kK = r2, NK = Do, IK = "[object Arguments]", RK = "[object Array]", LK = "[object Boolean]", DK = "[object Date]", FK = "[object Error]", zK = "[object Function]", BK = "[object Map]", HK = "[object Number]", jK = "[object Object]", VK = "[object RegExp]", WK = "[object Set]", UK = "[object String]", YK = "[object WeakMap]", qK = "[object ArrayBuffer]", GK = "[object DataView]", KK = "[object Float32Array]", XK = "[object Float64Array]", ZK = "[object Int8Array]", JK = "[object Int16Array]", QK = "[object Int32Array]", tX = "[object Uint8Array]", eX = "[object Uint8ClampedArray]", nX = "[object Uint16Array]", rX = "[object Uint32Array]", ae = {};
ae[KK] = ae[XK] = ae[ZK] = ae[JK] = ae[QK] = ae[tX] = ae[eX] = ae[nX] = ae[rX] = !0;
ae[IK] = ae[RK] = ae[qK] = ae[LK] = ae[GK] = ae[DK] = ae[FK] = ae[zK] = ae[BK] = ae[HK] = ae[jK] = ae[VK] = ae[WK] = ae[UK] = ae[YK] = !1;
function iX(t) {
  return NK(t) && kK(t.length) && !!ae[MK(t)];
}
var aX = iX;
function oX(t) {
  return function(e) {
    return t(e);
  };
}
var i2 = oX, yd = {}, sX = {
  get exports() {
    return yd;
  },
  set exports(t) {
    yd = t;
  }
};
(function(t, e) {
  var n = e9, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, a = i && i.exports === r, o = a && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch (c) {
    }
  }();
  t.exports = s;
})(sX, yd);
var uX = aX, lX = i2, D6 = yd, F6 = D6 && D6.isTypedArray, cX = F6 ? lX(F6) : uX, VC = cX, fX = dK, hX = e2, dX = Ue, pX = tc, mX = n2, gX = VC, vX = Object.prototype, _X = vX.hasOwnProperty;
function bX(t, e) {
  var n = dX(t), r = !n && hX(t), i = !n && !r && pX(t), a = !n && !r && !i && gX(t), o = n || r || i || a, s = o ? fX(t.length, String) : [], l = s.length;
  for (var c in t)
    (e || _X.call(t, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    mX(c, l))) && s.push(c);
  return s;
}
var yX = bX, wX = Object.prototype;
function xX(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || wX;
  return t === n;
}
var CX = xX;
function $X(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var TX = $X, OX = TX, SX = OX(Object.keys, Object), EX = SX, AX = CX, PX = EX, MX = Object.prototype, kX = MX.hasOwnProperty;
function NX(t) {
  if (!AX(t))
    return PX(t);
  var e = [];
  for (var n in Object(t))
    kX.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var IX = NX, RX = yp, LX = r2;
function DX(t) {
  return t != null && LX(t.length) && !RX(t);
}
var Au = DX, FX = yX, zX = IX, BX = Au;
function HX(t) {
  return BX(t) ? FX(t) : zX(t);
}
var Oa = HX, jX = fK, VX = Oa;
function WX(t, e) {
  return t && jX(t, e, VX);
}
var UX = WX, YX = Au;
function qX(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!YX(n))
      return t(n, r);
    for (var i = n.length, a = e ? i : -1, o = Object(n); (e ? a-- : ++a < i) && r(o[a], a, o) !== !1; )
      ;
    return n;
  };
}
var GX = qX, KX = UX, XX = GX, ZX = XX(KX), Pu = ZX;
function JX(t) {
  return t;
}
var rr = JX, QX = rr;
function tZ(t) {
  return typeof t == "function" ? t : QX;
}
var eZ = tZ, nZ = oK, rZ = Pu, iZ = eZ, aZ = Ue;
function oZ(t, e) {
  var n = aZ(t) ? nZ : rZ;
  return n(t, iZ(e));
}
var WC = oZ;
(function(t) {
  t.exports = WC;
})(iK);
const sZ = /* @__PURE__ */ t9(K0), uZ = {
  "imddb-header.dropdown.items": [
    { label: "Graphics", href: "#/" },
    { label: "Overview", href: "#/" },
    { label: "Visual overview", href: "#/" },
    { label: "Backgrounder", href: "#/" },
    { label: "About this project", href: "#/", active: !0 }
  ],
  "project.name": "Secret Papers",
  "app.name": "Awesome App",
  "app.home": "./",
  "app.donate-url": "https://www.icij.org/donate/",
  "contact-email": "contact@icij.org",
  "content-placeholder.rows": [
    {
      height: "1em",
      boxes: [[0, "50%"], ["5%", "30%"], ["5%", "10%"]]
    }
  ],
  "donate-form.tracker": null,
  "sharing-options.url": null,
  "sharing-options.title": "Awesome App by ICIJ",
  "sharing-options.description": "null",
  "sharing-options.media": null,
  "sharing-options.twitter-user": "ICIJorg",
  "signup-form.tracker": "EXTERNAL",
  "signup-form.action": "https://icij.us15.list-manage.com/subscribe/post?u=0d48a33b1c24d257734cc2a79&id=992ecfdbb2",
  "signup-form.email-field": "EMAIL",
  "signup-form.default-groups": ["group[9][1]"],
  "textured-deck.background-base-url": "https://icij.github.io/murmur",
  "map.topojson.world-countries-sans-antarctica": "https://icij.github.io/murmur/assets/topojson/world-countries-sans-antarctica.json",
  "map.topojson.france-departements": "https://icij.github.io/murmur/assets/topojson/france-departements.json"
}, al = "@VALUES", nh = "@SCOPES", UC = Ot.extend({
  props: {
    defaultValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      [al]: {},
      [nh]: {}
    };
  },
  created() {
    this.merge(this.defaultValues);
  },
  methods: {
    merge(t = {}) {
      sZ(t, (e, n) => {
        this.set(n, e);
      });
    },
    set(t, e) {
      const n = t.split(".");
      return n.length > 1 ? this.$set(this[al], t, this.scope(n.shift()).set(n.join("."), e)) : this.$set(this[al], t, e), e;
    },
    get(t, e) {
      return He(this[al], t, e);
    },
    is(t) {
      const e = this.get(t, null);
      switch (e) {
        case 1:
          return !0;
        case !0:
          return !0;
        case "1":
          return !0;
        case "true":
          return !0;
        case 0:
          return !1;
        case !1:
          return !1;
        case "0":
          return !1;
        case "false":
          return !1;
        default:
          return !!e;
      }
    },
    isnt(t) {
      return !this.is(t);
    },
    scope(t) {
      return this.$set(this[nh], t, He(this.scopes, t, new UC())), He(this, [nh, t]);
    }
  },
  computed: {
    values() {
      return this[al];
    },
    scopes() {
      return this[nh];
    }
  }
}), he = new UC({
  propsData: { defaultValues: uZ }
});
function z6(t) {
  return Number(t).toString() === t.toString();
}
function B6(t) {
  const e = String(t), n = ["px", "%", "em", "rem"];
  let r = !1;
  return n.forEach((i) => {
    Number(e.split(i)[0]) && e.split(i)[1] === "" && e.split(i).length === 2 && (r = !0);
  }), r;
}
function lZ(t, e, n, r = "box") {
  const i = [];
  return t !== 0 && (z6(t) ? i.push({ style: `flex-grow: ${t}; flex-shrink: 0; flex-basis: 0;`, subClass: r }) : B6(t) && i.push({ style: `flex-grow: 0; flex-shrink: 0; flex-basis: ${t};`, subClass: r })), z6(e) ? i.push({ style: `flex-grow: ${e}; flex-shrink: 0; flex-basis: 0;` }) : B6(e) && i.push({ style: `flex-grow: 0; flex-shrink: 0; flex-basis: ${e};` }), n && i.push({ style: "flex-grow: 1; flex-shrink: 0; flex-basis: 0;", subClass: r }), i;
}
function cZ(t, e = "box") {
  return t.map((r) => {
    const i = [], a = { height: r.height, boxes: [] };
    return r.boxes.forEach((o, s) => {
      const l = s === r.boxes.length - 1;
      i.push(...lZ(o[0], o[1], l, e));
    }), a.boxes = i, a;
  });
}
const fZ = te({
  name: "ContentPlaceholder",
  props: {
    /**
     * An array of lines describing a series of cell sizes and margin sizes.
     */
    rows: {
      type: Array,
      default: () => he.get("content-placeholder.rows")
    },
    /**
     * The size of the background gradient with the elapsing effect.
     */
    size: {
      type: String,
      default: "250%"
    }
  },
  computed: {
    formattedRows() {
      return cZ(this.rows, "content-placeholder__wrapper__row__box");
    }
  }
});
var hZ = function() {
  var e = this;
  return e._self._c, e._self._setupProxy, e._m(0);
}, dZ = [function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { staticClass: "content-placeholder" }, [e("div", { staticClass: "content-placeholder__wrapper", style: { backgroundSize: t.size } }, t._l(t.formattedRows, function(n, r) {
    return e("div", { key: r, staticClass: "content-placeholder__wrapper__row", style: { height: n.height } }, t._l(n.boxes, function(i, a) {
      return e("div", { key: a, style: i.style }, [i.subClass ? e("div", { class: i.subClass }) : t._e()]);
    }), 0);
  }), 0)]);
}], pZ = /* @__PURE__ */ Bt(
  fZ,
  hZ,
  dZ,
  !1,
  null,
  "3d3c251a",
  null,
  null
);
const mZ = pZ.exports, gZ = te({
  i18n: Hn,
  name: "CustomPagination",
  components: {
    BInputGroup: Xx,
    BPagination: VU
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    /**
     * Total items to be stored in pages
     */
    totalRows: {
      type: Number,
      default: 0
    },
    /**
     * Sets the quantity of items per page
     */
    perPage: {
      type: Number,
      default: 20
    },
    /**
     * Grabs and syncs the currentPage variable passed down from the parent in v-model
     */
    value: {
      type: Number,
      default: 1
    },
    /**
     * Displays the pagination element in pills styling as opposed to the default boxes
     */
    pills: {
      type: Boolean
    },
    /**
     * Set the size of the input: 'sm', 'md' (default), or 'lg'.
     */
    size: {
      type: String,
      default: va.md,
      validator: (t) => Object.values(va).includes(t)
    },
    /**
     * Compact layout
     */
    compact: {
      type: Boolean
    },
    /**
     * (Optional) Number of page. Propety `size` is required for this to work
     * properly. If `pages` is empty, it will be calculated using the size.
     */
    pages: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      currentPageInput: "",
      invalidNumberError: this.$t("custom-pagination.invalid-number-error"),
      errors: []
    };
  },
  computed: {
    inputPlaceholder() {
      const t = this.compact ? "compact-" : "";
      return this.$t(`custom-pagination.${t}placeholder`);
    },
    numberOfPages() {
      return this.pages === null ? Math.ceil(this.totalRows / this.perPage) : Number(this.pages);
    },
    paginationClassList() {
      return this.size === va.sm ? ["float-right", "mr-1"] : [];
    }
  },
  methods: {
    applyJumpFormPage() {
      const t = isNaN(parseInt(this.currentPageInput)) ? 0 : parseInt(this.currentPageInput);
      this.errors = [], (t > this.numberOfPages || t < 1) && this.errors.push(this.invalidNumberError), this.errors.length === 0 && this.$emit("input", parseInt(this.currentPageInput));
    },
    updateValue(t) {
      this.$emit("input", t);
    }
  }
});
var vZ = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "custom-pagination container-fluid", class: { "custom-pagination--compact": e.compact, "custom-pagination--pills": e.pills } }, [n("div", { staticClass: "row justify-content-center align-items-stretch", class: { "no-gutters": e.compact && !e.pills } }, [n("div", { staticClass: "col-auto custom-pagination__pages" }, [n("b-pagination", { staticClass: "m-0", class: e.paginationClassList, attrs: { "total-rows": e.perPage * e.numberOfPages, "per-page": e.perPage, value: e.value, pills: e.pills, size: e.size, "first-number": "", "last-number": "" }, on: { input: e.updateValue }, scopedSlots: e._u([{ key: "prev-text", fn: function({ disabled: r, index: i, page: a }) {
    return [e._t("prev-text", null, null, { disabled: r, index: i, page: a })];
  } }, { key: "next-text", fn: function({ disabled: r, index: i, page: a }) {
    return [e._t("next-text", null, null, { disabled: r, index: i, page: a })];
  } }, { key: "page", fn: function({ active: r, content: i, disabled: a, index: o, page: s }) {
    return [e._t("page", null, null, { active: r, content: i, disabled: a, index: o, page: s })];
  } }, { key: "ellipsis-text", fn: function() {
    return [e._t("ellipsis-text")];
  }, proxy: !0 }], null, !0) })], 1), n("div", { staticClass: "col-auto" }, [n("div", { staticClass: "custom-pagination__form" }, [n("form", { staticClass: "input-group", on: { submit: function(r) {
    return r.preventDefault(), e.applyJumpFormPage.apply(null, arguments);
  } } }, [n("b-input-group", { attrs: { size: e.size } }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.currentPageInput, expression: "currentPageInput" }], staticClass: "form-control", attrs: { type: "number", placeholder: e.inputPlaceholder, "aria-label": "Jump to page" }, domProps: { value: e.currentPageInput }, on: { input: function(r) {
    r.target.composing || (e.currentPageInput = r.target.value);
  } } }), e.compact ? e._e() : n("div", { staticClass: "input-group-append" }, [n("button", { staticClass: "btn btn-secondary btn-sm", attrs: { type: "submit" } }, [n("span", { staticClass: "px-1 py-3" }, [e._v(" Go ")])])])])], 1), e.compact ? e._e() : [e.errors.length ? n("small", { staticClass: "float-left mt-1 ml-1 text-danger", attrs: { id: "invalid-number-error" } }, [e._v(" " + e._s(e.errors[0]) + " ")]) : n("small", { staticClass: "float-left mt-1 ml-1 text-muted" }, [e._v(" " + e._s(e.$tc("custom-pagination.total-pages", e.numberOfPages, { count: e.numberOfPages })) + " ")])]], 2)])])]);
}, _Z = [], bZ = /* @__PURE__ */ Bt(
  gZ,
  vZ,
  _Z,
  !1,
  null,
  "581d7af4",
  null,
  null
);
const yZ = bZ.exports, wZ = te({
  name: "DigitsInput",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    /**
     * Number of digits to display
     */
    length: {
      type: Number,
      default: 6
    },
    /**
     * Value of the input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * Name of the input
     */
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mounted: !1,
      values: String(this.value).split("").slice(0, this.length)
    };
  },
  computed: {
    joinedValues() {
      return ct.filter(this.values, (t) => !isNaN(t)).join("");
    },
    /* eslint-disable no-undef */
    inputs() {
      return this.mounted ? this.$el.querySelectorAll(".digits-input__container__input") : [];
    },
    nextInput() {
      return this.joinedValues.length === this.length ? null : this.inputs[this.joinedValues.length] || this.lastInput;
    },
    hasNextInput() {
      return !!this.nextInput;
    },
    lastInput() {
      return this.inputs[this.inputs.length - 1];
    }
  },
  watch: {
    values(t) {
      const e = t.map((n) => String(n).replace(/\D/g, ""));
      e.forEach((n, r) => {
        n !== null && Number(n) > 9 && String(n).split("").forEach((i, a) => {
          e[r + a] = String(Number(i));
        });
      }), ct.isEqual(this.values, e) || this.$set(this, "values", e.slice(0, this.length)), this.focusToNextInput();
    },
    joinedValues() {
      this.$emit("input", this.joinedValues);
    },
    value() {
      this.values = String(this.value).split("").slice(0, this.length);
    }
  },
  mounted() {
    return _e(this, null, function* () {
      yield this.$nextTick(), this.mounted = !0;
    });
  },
  methods: {
    focusToNextInput() {
      var t;
      this.hasNextInput && ((t = this.nextInput) == null || t.focus());
    },
    focusToPreviousWhenEmpty(t) {
      var e;
      this.values[t] || (e = this.inputs[t - 1]) == null || e.focus();
    }
  }
});
var xZ = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "digits-input" }, [n("div", { staticClass: "d-flex digits-input__container" }, [e._l(e.length, function(r) {
    return n("input", { directives: [{ name: "model", rawName: "v-model", value: e.values[r - 1], expression: "values[d - 1]" }], key: r - 1, staticClass: "digits-input__container__input w-0 form-control", class: `digits-input__container__input--${r - 1}`, domProps: { value: e.values[r - 1] }, on: { keyup: function(i) {
      return !i.type.indexOf("key") && e._k(i.keyCode, "delete", [8, 46], i.key, ["Backspace", "Delete", "Del"]) ? null : e.focusToPreviousWhenEmpty(r - 1);
    }, input: function(i) {
      i.target.composing || e.$set(e.values, r - 1, i.target.value);
    } } });
  }), n("input", { attrs: { type: "hidden", name: e.name }, domProps: { value: e.joinedValues } })], 2)]);
}, CZ = [], $Z = /* @__PURE__ */ Bt(
  wZ,
  xZ,
  CZ,
  !1,
  null,
  "e7d4afb6",
  null,
  null
);
const TZ = $Z.exports;
var OZ = $p;
function SZ() {
  this.__data__ = new OZ(), this.size = 0;
}
var EZ = SZ;
function AZ(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var PZ = AZ;
function MZ(t) {
  return this.__data__.get(t);
}
var kZ = MZ;
function NZ(t) {
  return this.__data__.has(t);
}
var IZ = NZ, RZ = $p, LZ = c_, DZ = f_, FZ = 200;
function zZ(t, e) {
  var n = this.__data__;
  if (n instanceof RZ) {
    var r = n.__data__;
    if (!LZ || r.length < FZ - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new DZ(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var BZ = zZ, HZ = $p, jZ = EZ, VZ = PZ, WZ = kZ, UZ = IZ, YZ = BZ;
function Mu(t) {
  var e = this.__data__ = new HZ(t);
  this.size = e.size;
}
Mu.prototype.clear = jZ;
Mu.prototype.delete = VZ;
Mu.prototype.get = WZ;
Mu.prototype.has = UZ;
Mu.prototype.set = YZ;
var YC = Mu, qZ = "__lodash_hash_undefined__";
function GZ(t) {
  return this.__data__.set(t, qZ), this;
}
var KZ = GZ;
function XZ(t) {
  return this.__data__.has(t);
}
var ZZ = XZ, JZ = f_, QZ = KZ, tJ = ZZ;
function wd(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new JZ(); ++e < n; )
    this.add(t[e]);
}
wd.prototype.add = wd.prototype.push = QZ;
wd.prototype.has = tJ;
var qC = wd;
function eJ(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var GC = eJ;
function nJ(t, e) {
  return t.has(e);
}
var KC = nJ, rJ = qC, iJ = GC, aJ = KC, oJ = 1, sJ = 2;
function uJ(t, e, n, r, i, a) {
  var o = n & oJ, s = t.length, l = e.length;
  if (s != l && !(o && l > s))
    return !1;
  var c = a.get(t), h = a.get(e);
  if (c && h)
    return c == e && h == t;
  var d = -1, p = !0, g = n & sJ ? new rJ() : void 0;
  for (a.set(t, e), a.set(e, t); ++d < s; ) {
    var v = t[d], b = e[d];
    if (r)
      var _ = o ? r(b, v, d, e, t, a) : r(v, b, d, t, e, a);
    if (_ !== void 0) {
      if (_)
        continue;
      p = !1;
      break;
    }
    if (g) {
      if (!iJ(e, function(w, x) {
        if (!aJ(g, x) && (v === w || i(v, w, n, r, a)))
          return g.push(x);
      })) {
        p = !1;
        break;
      }
    } else if (!(v === b || i(v, b, n, r, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(t), a.delete(e), p;
}
var XC = uJ, lJ = Hi, cJ = lJ.Uint8Array, fJ = cJ;
function hJ(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var dJ = hJ;
function pJ(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var mJ = pJ, H6 = $c, j6 = fJ, gJ = xp, vJ = XC, _J = dJ, bJ = mJ, yJ = 1, wJ = 2, xJ = "[object Boolean]", CJ = "[object Date]", $J = "[object Error]", TJ = "[object Map]", OJ = "[object Number]", SJ = "[object RegExp]", EJ = "[object Set]", AJ = "[object String]", PJ = "[object Symbol]", MJ = "[object ArrayBuffer]", kJ = "[object DataView]", V6 = H6 ? H6.prototype : void 0, wg = V6 ? V6.valueOf : void 0;
function NJ(t, e, n, r, i, a, o) {
  switch (n) {
    case kJ:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case MJ:
      return !(t.byteLength != e.byteLength || !a(new j6(t), new j6(e)));
    case xJ:
    case CJ:
    case OJ:
      return gJ(+t, +e);
    case $J:
      return t.name == e.name && t.message == e.message;
    case SJ:
    case AJ:
      return t == e + "";
    case TJ:
      var s = _J;
    case EJ:
      var l = r & yJ;
      if (s || (s = bJ), t.size != e.size && !l)
        return !1;
      var c = o.get(t);
      if (c)
        return c == e;
      r |= wJ, o.set(t, e);
      var h = vJ(s(t), s(e), r, i, a, o);
      return o.delete(t), h;
    case PJ:
      if (wg)
        return wg.call(t) == wg.call(e);
  }
  return !1;
}
var IJ = NJ;
function RJ(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var ZC = RJ, LJ = ZC, DJ = Ue;
function FJ(t, e, n) {
  var r = e(t);
  return DJ(t) ? r : LJ(r, n(t));
}
var zJ = FJ;
function BJ(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, a = []; ++n < r; ) {
    var o = t[n];
    e(o, n, t) && (a[i++] = o);
  }
  return a;
}
var JC = BJ;
function HJ() {
  return [];
}
var jJ = HJ, VJ = JC, WJ = jJ, UJ = Object.prototype, YJ = UJ.propertyIsEnumerable, W6 = Object.getOwnPropertySymbols, qJ = W6 ? function(t) {
  return t == null ? [] : (t = Object(t), VJ(W6(t), function(e) {
    return YJ.call(t, e);
  }));
} : WJ, GJ = qJ, KJ = zJ, XJ = GJ, ZJ = Oa;
function JJ(t) {
  return KJ(t, ZJ, XJ);
}
var QJ = JJ, U6 = QJ, tQ = 1, eQ = Object.prototype, nQ = eQ.hasOwnProperty;
function rQ(t, e, n, r, i, a) {
  var o = n & tQ, s = U6(t), l = s.length, c = U6(e), h = c.length;
  if (l != h && !o)
    return !1;
  for (var d = l; d--; ) {
    var p = s[d];
    if (!(o ? p in e : nQ.call(e, p)))
      return !1;
  }
  var g = a.get(t), v = a.get(e);
  if (g && v)
    return g == e && v == t;
  var b = !0;
  a.set(t, e), a.set(e, t);
  for (var _ = o; ++d < l; ) {
    p = s[d];
    var w = t[p], x = e[p];
    if (r)
      var C = o ? r(x, w, p, e, t, a) : r(w, x, p, t, e, a);
    if (!(C === void 0 ? w === x || i(w, x, n, r, a) : C)) {
      b = !1;
      break;
    }
    _ || (_ = p == "constructor");
  }
  if (b && !_) {
    var $ = t.constructor, E = e.constructor;
    $ != E && "constructor" in t && "constructor" in e && !(typeof $ == "function" && $ instanceof $ && typeof E == "function" && E instanceof E) && (b = !1);
  }
  return a.delete(t), a.delete(e), b;
}
var iQ = rQ, aQ = Fo, oQ = Hi, sQ = aQ(oQ, "DataView"), uQ = sQ, lQ = Fo, cQ = Hi, fQ = lQ(cQ, "Promise"), hQ = fQ, dQ = Fo, pQ = Hi, mQ = dQ(pQ, "Set"), gQ = mQ, vQ = Fo, _Q = Hi, bQ = vQ(_Q, "WeakMap"), yQ = bQ, X0 = uQ, Z0 = c_, J0 = hQ, Q0 = gQ, tv = yQ, QC = vu, ku = r9, Y6 = "[object Map]", wQ = "[object Object]", q6 = "[object Promise]", G6 = "[object Set]", K6 = "[object WeakMap]", X6 = "[object DataView]", xQ = ku(X0), CQ = ku(Z0), $Q = ku(J0), TQ = ku(Q0), OQ = ku(tv), io = QC;
(X0 && io(new X0(new ArrayBuffer(1))) != X6 || Z0 && io(new Z0()) != Y6 || J0 && io(J0.resolve()) != q6 || Q0 && io(new Q0()) != G6 || tv && io(new tv()) != K6) && (io = function(t) {
  var e = QC(t), n = e == wQ ? t.constructor : void 0, r = n ? ku(n) : "";
  if (r)
    switch (r) {
      case xQ:
        return X6;
      case CQ:
        return Y6;
      case $Q:
        return q6;
      case TQ:
        return G6;
      case OQ:
        return K6;
    }
  return e;
});
var SQ = io, xg = YC, EQ = XC, AQ = IJ, PQ = iQ, Z6 = SQ, J6 = Ue, Q6 = tc, MQ = VC, kQ = 1, t8 = "[object Arguments]", e8 = "[object Array]", rh = "[object Object]", NQ = Object.prototype, n8 = NQ.hasOwnProperty;
function IQ(t, e, n, r, i, a) {
  var o = J6(t), s = J6(e), l = o ? e8 : Z6(t), c = s ? e8 : Z6(e);
  l = l == t8 ? rh : l, c = c == t8 ? rh : c;
  var h = l == rh, d = c == rh, p = l == c;
  if (p && Q6(t)) {
    if (!Q6(e))
      return !1;
    o = !0, h = !1;
  }
  if (p && !h)
    return a || (a = new xg()), o || MQ(t) ? EQ(t, e, n, r, i, a) : AQ(t, e, l, n, r, i, a);
  if (!(n & kQ)) {
    var g = h && n8.call(t, "__wrapped__"), v = d && n8.call(e, "__wrapped__");
    if (g || v) {
      var b = g ? t.value() : t, _ = v ? e.value() : e;
      return a || (a = new xg()), i(b, _, n, r, a);
    }
  }
  return p ? (a || (a = new xg()), PQ(t, e, n, r, i, a)) : !1;
}
var RQ = IQ, LQ = RQ, r8 = Do;
function t$(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !r8(t) && !r8(e) ? t !== t && e !== e : LQ(t, e, n, r, t$, i);
}
var a2 = t$, DQ = YC, FQ = a2, zQ = 1, BQ = 2;
function HQ(t, e, n, r) {
  var i = n.length, a = i, o = !r;
  if (t == null)
    return !a;
  for (t = Object(t); i--; ) {
    var s = n[i];
    if (o && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++i < a; ) {
    s = n[i];
    var l = s[0], c = t[l], h = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(l in t))
        return !1;
    } else {
      var d = new DQ();
      if (r)
        var p = r(c, h, l, t, e, d);
      if (!(p === void 0 ? FQ(h, c, zQ | BQ, r, d) : p))
        return !1;
    }
  }
  return !0;
}
var jQ = HQ, VQ = bu;
function WQ(t) {
  return t === t && !VQ(t);
}
var e$ = WQ, UQ = e$, YQ = Oa;
function qQ(t) {
  for (var e = YQ(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, UQ(i)];
  }
  return e;
}
var GQ = qQ;
function KQ(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var n$ = KQ, XQ = jQ, ZQ = GQ, JQ = n$;
function QQ(t) {
  var e = ZQ(t);
  return e.length == 1 && e[0][2] ? JQ(e[0][0], e[0][1]) : function(n) {
    return n === t || XQ(n, t, e);
  };
}
var ttt = QQ;
function ett(t, e) {
  return t != null && e in Object(t);
}
var ntt = ett, rtt = o9, itt = e2, att = Ue, ott = n2, stt = r2, utt = Ep;
function ltt(t, e, n) {
  e = rtt(e, t);
  for (var r = -1, i = e.length, a = !1; ++r < i; ) {
    var o = utt(e[r]);
    if (!(a = t != null && n(t, o)))
      break;
    t = t[o];
  }
  return a || ++r != i ? a : (i = t == null ? 0 : t.length, !!i && stt(i) && ott(o, i) && (att(t) || itt(t)));
}
var ctt = ltt, ftt = ntt, htt = ctt;
function dtt(t, e) {
  return t != null && htt(t, e, ftt);
}
var ptt = dtt, mtt = a2, gtt = He, vtt = ptt, _tt = l_, btt = e$, ytt = n$, wtt = Ep, xtt = 1, Ctt = 2;
function $tt(t, e) {
  return _tt(t) && btt(e) ? ytt(wtt(t), e) : function(n) {
    var r = gtt(n, t);
    return r === void 0 && r === e ? vtt(n, t) : mtt(e, r, xtt | Ctt);
  };
}
var Ttt = $tt;
function Ott(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var Stt = Ott, Ett = d_;
function Att(t) {
  return function(e) {
    return Ett(e, t);
  };
}
var Ptt = Att, Mtt = Stt, ktt = Ptt, Ntt = l_, Itt = Ep;
function Rtt(t) {
  return Ntt(t) ? Mtt(Itt(t)) : ktt(t);
}
var Ltt = Rtt, Dtt = ttt, Ftt = Ttt, ztt = rr, Btt = Ue, Htt = Ltt;
function jtt(t) {
  return typeof t == "function" ? t : t == null ? ztt : typeof t == "object" ? Btt(t) ? Ftt(t[0], t[1]) : Dtt(t) : Htt(t);
}
var Da = jtt, Vtt = Pu, Wtt = Au;
function Utt(t, e) {
  var n = -1, r = Wtt(t) ? Array(t.length) : [];
  return Vtt(t, function(i, a, o) {
    r[++n] = e(i, a, o);
  }), r;
}
var r$ = Utt, Ytt = Op, qtt = Da, Gtt = r$, Ktt = Ue;
function Xtt(t, e) {
  var n = Ktt(t) ? Ytt : Gtt;
  return n(t, qtt(e));
}
var Ztt = Xtt, i8 = $c, Jtt = e2, Qtt = Ue, a8 = i8 ? i8.isConcatSpreadable : void 0;
function tet(t) {
  return Qtt(t) || Jtt(t) || !!(a8 && t && t[a8]);
}
var eet = tet, net = ZC, ret = eet;
function i$(t, e, n, r, i) {
  var a = -1, o = t.length;
  for (n || (n = ret), i || (i = []); ++a < o; ) {
    var s = t[a];
    e > 0 && n(s) ? e > 1 ? i$(s, e - 1, n, r, i) : net(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var a$ = i$;
function iet(t, e) {
  var n = t.length;
  for (t.sort(e); n--; )
    t[n] = t[n].value;
  return t;
}
var aet = iet, o8 = _u;
function oet(t, e) {
  if (t !== e) {
    var n = t !== void 0, r = t === null, i = t === t, a = o8(t), o = e !== void 0, s = e === null, l = e === e, c = o8(e);
    if (!s && !c && !a && t > e || a && o && l && !s && !c || r && o && l || !n && l || !i)
      return 1;
    if (!r && !a && !c && t < e || c && n && i && !r && !a || s && n && i || !o && i || !l)
      return -1;
  }
  return 0;
}
var set = oet, uet = set;
function cet(t, e, n) {
  for (var r = -1, i = t.criteria, a = e.criteria, o = i.length, s = n.length; ++r < o; ) {
    var l = uet(i[r], a[r]);
    if (l) {
      if (r >= s)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
var fet = cet, Cg = Op, het = d_, det = Da, pet = r$, met = aet, get = i2, vet = fet, _et = rr, bet = Ue;
function yet(t, e, n) {
  e.length ? e = Cg(e, function(a) {
    return bet(a) ? function(o) {
      return het(o, a.length === 1 ? a[0] : a);
    } : a;
  }) : e = [_et];
  var r = -1;
  e = Cg(e, get(det));
  var i = pet(t, function(a, o, s) {
    var l = Cg(e, function(c) {
      return c(a);
    });
    return { criteria: l, index: ++r, value: a };
  });
  return met(i, function(a, o) {
    return vet(a, o, n);
  });
}
var wet = yet;
function xet(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var Cet = xet, $et = Cet, s8 = Math.max;
function Tet(t, e, n) {
  return e = s8(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, a = s8(r.length - e, 0), o = Array(a); ++i < a; )
      o[i] = r[e + i];
    i = -1;
    for (var s = Array(e + 1); ++i < e; )
      s[i] = r[i];
    return s[e] = n(o), $et(t, this, s);
  };
}
var Oet = Tet;
function Eet(t) {
  return function() {
    return t;
  };
}
var Aet = Eet, Pet = Fo, Met = function() {
  try {
    var t = Pet(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch (e) {
  }
}(), ket = Met, Net = Aet, u8 = ket, Iet = rr, Ret = u8 ? function(t, e) {
  return u8(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Net(e),
    writable: !0
  });
} : Iet, Let = Ret, Det = 800, Fet = 16, zet = Date.now;
function Bet(t) {
  var e = 0, n = 0;
  return function() {
    var r = zet(), i = Fet - (r - n);
    if (n = r, i > 0) {
      if (++e >= Det)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var Het = Bet, jet = Let, Vet = Het, Wet = Vet(jet), Uet = Wet, Yet = rr, qet = Oet, Get = Uet;
function Ket(t, e) {
  return Get(qet(t, e, Yet), t + "");
}
var o$ = Ket, Xet = xp, Zet = Au, Jet = n2, Qet = bu;
function tnt(t, e, n) {
  if (!Qet(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? Zet(n) && Jet(e, n.length) : r == "string" && e in n) ? Xet(n[e], t) : !1;
}
var o2 = tnt, ent = a$, nnt = wet, rnt = o$, l8 = o2, int = rnt(function(t, e) {
  if (t == null)
    return [];
  var n = e.length;
  return n > 1 && l8(t, e[0], e[1]) ? e = [] : n > 2 && l8(e[0], e[1], e[2]) && (e = [e[0]]), nnt(t, ent(e, 1), []);
}), Qp = int;
const ant = {
  i18n: Hn,
  name: "DonateForm",
  props: {
    /**
     * Title of the form.
     */
    noTitle: {
      type: Boolean
    }
  },
  data() {
    return {
      amount: 10,
      // True if the amount wasn't changed by the user yet
      amountIsPristine: !0,
      installmentPeriod: "monthly",
      level: "conversation",
      campaign: he.get("donate-form.tracker"),
      labelForChange: {
        monthly: {
          1: this.$t("donate-form.result.conversation"),
          15: this.$t("donate-form.result.rules"),
          50: this.$t("donate-form.result.world")
        },
        yearly: {
          1: this.$t("donate-form.result.conversation"),
          180: this.$t("donate-form.result.rules"),
          600: this.$t("donate-form.result.world")
        }
      },
      suggestedAmount: this.$t("donate-form.suggesteddonation")
    };
  },
  computed: {
    firstRange() {
      const t = Oa(this.ranges)[0];
      return this.ranges[t];
    },
    ranges() {
      return this.labelForChange[this.installmentPeriod || "yearly"];
    },
    changeThe() {
      let t = null;
      return WC(Qp(Ztt(Oa(this.ranges), Number)), (e) => {
        t = this.amount >= e ? this.ranges[e] : t;
      }), t;
    }
  },
  watch: {
    installmentPeriod() {
      this.amountIsPristine && (this.amount = this.getSuggestedAmount());
    },
    amount(t) {
      return this.level = this.changeThe, this.amount = t;
    }
  },
  methods: {
    getSuggestedAmount() {
      if (this.amountIsPristine)
        return this.level || (this.level = this.firstRange), this.suggestedAmount[this.level][this.installmentPeriod];
    },
    selectLevel(t) {
      this.level = t, this.amount = this.getSuggestedAmount();
    }
  }
};
var ont = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "donate-form container-fluid py-2" }, [e.noTitle ? e._e() : n("h2", { staticClass: "donate-form__title text-uppercase font-weight-bold text-primary h5" }, [e._v(" " + e._s(e.$t("donate-form.support")) + " ")]), e._t("introduction", function() {
    return [n("p", { staticClass: "donate-form__introduction", domProps: { innerHTML: e._s(e.$t("donate-form.introduction")) } })];
  }), n("div", { staticClass: "donate-form__payment mb-4 text-center" }, [n("form", { staticClass: "donate-form__payment__form bg-light p-4", attrs: { action: "//checkout.fundjournalism.org/memberform", method: "get", target: "_blank" } }, [n("div", { staticClass: "donate-form__payment__levels row" }, [n("div", { staticClass: "col donate-form__payment__level", class: { active: e.level === "conversation" }, on: { click: function(r) {
    return e.selectLevel("conversation");
  } } }, [n("h3", { staticClass: "donate-form__payment__heading text-uppercase font-weight-bold text-primary h5" }, [e._v(" " + e._s(e.$t("donate-form.benefits.impacts.conversation.heading")) + " ")]), n("div", { staticClass: "Article" }, [n("div", [n("p", { staticClass: "donate-form__payment__highlight text-icij font-weight-bold", domProps: { innerHTML: e._s(e.$t("donate-form.benefits.impacts.conversation.highlight")) } })])])]), n("div", { staticClass: "col donate-form__payment__level", class: { active: e.level === "rules" }, on: { click: function(r) {
    return e.selectLevel("rules");
  } } }, [n("h3", { staticClass: "donate-form__payment__heading text-uppercase font-weight-bold text-primary h5" }, [e._v(" " + e._s(e.$t("donate-form.benefits.impacts.rules.heading")) + " ")]), n("div", { staticClass: "Article" }, [n("div", [n("p", { staticClass: "donate-form__payment__highlight text-icij font-weight-bold", domProps: { innerHTML: e._s(e.$t("donate-form.benefits.impacts.rules.highlight")) } })])])]), n("div", { staticClass: "col donate-form__payment__level", class: { active: e.level === "world" }, on: { click: function(r) {
    return e.selectLevel("world");
  } } }, [n("h3", { staticClass: "donate-form__payment__heading text-uppercase font-weight-bold text-primary h5" }, [e._v(" " + e._s(e.$t("donate-form.benefits.impacts.world.heading")) + " ")]), n("div", { staticClass: "Article" }, [n("div", [n("p", { staticClass: "donate-form__payment__highlight text-icij font-weight-bold", domProps: { innerHTML: e._s(e.$t("donate-form.benefits.impacts.world.highlight")) } })])])])]), n("div", [n("div", { staticClass: "mt-5" }, [n("span", { staticClass: "donate-form__payment__buttons" }, [n("button", { staticClass: "btn btn-sm", class: { "btn-primary": e.installmentPeriod === "monthly" }, attrs: { type: "button" }, on: { click: function(r) {
    e.installmentPeriod = "monthly";
  } } }, [e._v(" " + e._s(e.$t("donate-form.frequency.monthly")) + " ")]), n("button", { staticClass: "btn btn-sm", class: { "btn-primary": e.installmentPeriod === "yearly" }, attrs: { type: "button" }, on: { click: function(r) {
    e.installmentPeriod = "yearly";
  } } }, [e._v(" " + e._s(e.$t("donate-form.frequency.yearly")) + " ")]), n("button", { staticClass: "btn btn-sm", class: { "btn-primary": e.installmentPeriod === null }, attrs: { type: "button" }, on: { click: function(r) {
    e.installmentPeriod = null;
  } } }, [e._v(" " + e._s(e.$t("donate-form.frequency.onetime")) + " ")])])]), n("div", { staticClass: "mt-4" }, [n("span", [e._v(e._s(e.$t("donate-form.label")) + " ")]), n("label", { staticClass: "donate-form__payment__unit input-group input-group-sm d-inline-flex" }, [e._m(0), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.amount, expression: "amount" }], staticClass: "donate-form__payment__input form-control", attrs: { name: "amount", type: "number", min: "0" }, domProps: { value: e.amount }, on: { change: function(r) {
    e.amountIsPristine = !1;
  }, input: function(r) {
    r.target.composing || (e.amount = r.target.value);
  } } })])]), n("div", { staticClass: "mt-4" }, [n("input", { attrs: { name: "org_id", value: "icij", type: "hidden" } }), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.campaign, expression: "campaign" }], attrs: { name: "campaign", type: "hidden" }, domProps: { value: e.campaign }, on: { input: function(r) {
    r.target.composing || (e.campaign = r.target.value);
  } } }), n("input", { directives: [{ name: "model", rawName: "v-model", value: e.installmentPeriod, expression: "installmentPeriod" }], attrs: { name: "installmentPeriod", type: "hidden" }, domProps: { value: e.installmentPeriod }, on: { input: function(r) {
    r.target.composing || (e.installmentPeriod = r.target.value);
  } } }), n("button", { staticClass: "btn btn-primary rounded-pill text-uppercase font-weight-bold", attrs: { type: "submit" } }, [e._v(" " + e._s(e.$t("donate-form.submit")) + " ")]), n("a", { staticClass: "donate-form__payment__image", attrs: { target: "_blank", href: "https://icij.org/donate" } })])])])]), n("div", { staticClass: "donate-form__insider" }, [n("h2", { staticClass: "donate-form__insider__title" }, [e._v(" " + e._s(e.$t("donate-form.benefits.heading")) + " ")]), n("p", [e._v(" " + e._s(e.$t("donate-form.benefits.introduction")) + " ")]), n("div", [n("ul", { staticClass: "donate-form__insider__list" }, e._l(e.$t("donate-form.benefits.list"), function(r, i) {
    return n("li", { key: i, staticClass: "donate-form__insider__list-item", domProps: { innerHTML: e._s(r) } });
  }), 0)]), n("div", [n("hr", { staticClass: "donate-form__insider__separator" }), n("div", { staticClass: "donate-form__insider__more text-center" }, [n("a", { staticClass: "btn btn-primary rounded-pill text-uppercase font-weight-bold py-2", attrs: { target: "_blank", href: "https://icij.org/donate" } }, [e._v(" " + e._s(e.$t("donate-form.benefits.more")) + " ")])])])])], 2);
}, snt = [function() {
  var t = this, e = t._self._c;
  return e("span", { staticClass: "input-group-prepend" }, [e("span", { staticClass: "input-group-text" }, [t._v("$")])]);
}], unt = /* @__PURE__ */ Bt(
  ant,
  ont,
  snt,
  !1,
  null,
  null,
  null,
  null
);
const lnt = unt.exports;
var s$ = {}, u$ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "share-nodes", r = 448, i = 512, a = ["share-alt"], o = "f1e0", s = "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faShareNodes = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(u$);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = u$;
  t.definition = {
    prefix: e.prefix,
    iconName: e.iconName,
    icon: [
      e.width,
      e.height,
      e.aliases,
      e.unicode,
      e.svgPathData
    ]
  }, t.faShareAlt = t.definition, t.prefix = e.prefix, t.iconName = e.iconName, t.width = e.width, t.height = e.height, t.ligatures = e.aliases, t.unicode = e.unicode, t.svgPathData = e.svgPathData, t.aliases = e.aliases;
})(s$);
function cnt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (!e(t[n], n, t))
      return !1;
  return !0;
}
var fnt = cnt, hnt = Pu;
function dnt(t, e) {
  var n = !0;
  return hnt(t, function(r, i, a) {
    return n = !!e(r, i, a), n;
  }), n;
}
var pnt = dnt, mnt = fnt, gnt = pnt, vnt = Da, _nt = Ue, bnt = o2;
function ynt(t, e, n) {
  var r = _nt(t) ? mnt : gnt;
  return n && bnt(t, e, n) && (e = void 0), r(t, vnt(e));
}
var wnt = ynt, xnt = 0;
const Cnt = ct.memoize(function(t, e = `dynamic-asset-${xnt++}`) {
  return new Promise((n) => {
    const r = document.querySelector("body") || document.querySelector("head"), i = t.split(".");
    switch (i[i.length - 1].toLowerCase()) {
      case "js":
        var o = document.createElement("script");
        o.setAttribute("type", "text/javascript"), o.onload = n, r.appendChild(o), o.setAttribute("src", t), o.setAttribute("id", e);
        break;
      case "css":
        var s = document.createElement("link");
        s.setAttribute("rel", "stylesheet"), s.setAttribute("type", "text/css"), s.onload = n, r.appendChild(s), s.setAttribute("href", t), s.setAttribute("id", e);
        break;
    }
  });
}), l$ = function(...t) {
  const e = ct.flatten(t);
  return new Promise((n) => {
    for (var r = 0, i = function() {
      ++r == e.length && n();
    }, a = 0; a < e.length; a++)
      Cnt(e[a]).then(i);
  });
};
var $g;
const c8 = ["initialWidth", "childId", "parentUrl", "parentTitle"], f8 = window.location.href;
class Oo {
  constructor() {
    Vf(this, "initializer");
    this.initializer = l$("//pym.nprapps.org/pym.v1.min.js").then(() => ($g = $g || new window.pym.Child({ polling: 300 }), $g));
  }
  sendHeight() {
    return this.initializer.then((e) => e.sendHeight());
  }
  static create() {
    return new Oo();
  }
  static template(e, n = "icij-" + Date.now().toString(32)) {
    return [
      '<script type="text/javascript" src="https://pym.nprapps.org/pym.v1.min.js"><\/script>',
      `<div id="${n}"></div>`,
      "<script>",
      `const icijIframe = new pym.Parent("${n}", "${Oo.deletePymParams(e)}", {})`,
      "<\/script>"
    ].join(`
`);
  }
  static deletePymParams(e = f8) {
    const n = new URL(e);
    for (const r of c8)
      n.searchParams.delete(r);
    return n.href;
  }
  static isEmbedded(e = f8) {
    const n = new URL(e);
    return wnt(c8, (r) => n.searchParams.has(r));
  }
}
function $nt(t, e, n, r) {
  var i = -1, a = t == null ? 0 : t.length;
  for (r && a && (n = t[++i]); ++i < a; )
    n = e(n, t[i], i, t);
  return n;
}
var c$ = $nt;
function Tnt(t, e, n, r, i) {
  return i(t, function(a, o, s) {
    n = r ? (r = !1, a) : e(n, a, o, s);
  }), n;
}
var Ont = Tnt, Snt = c$, Ent = Pu, Ant = Da, Pnt = Ont, Mnt = Ue;
function knt(t, e, n) {
  var r = Mnt(t) ? Snt : Pnt, i = arguments.length < 3;
  return r(t, Ant(e), n, i, Ent);
}
var f$ = knt, h$ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "code", r = 640, i = 512, a = [], o = "f121", s = "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faCode = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(h$);
const Nnt = te({
  i18n: Hn,
  name: "EmbedForm",
  components: {
    HapticCopy: Jp
  },
  props: {
    /**
     * Hide the form title
     */
    noTitle: {
      type: Boolean
    },
    /**
     * Hide the preview panel
     */
    noPreview: {
      type: Boolean
    },
    /**
     * Default width of the iframe code
     */
    width: {
      type: [Number, String],
      default: "100%"
    },
    /**
     * Default height of the iframe code
     */
    height: {
      type: Number,
      default: () => window.innerHeight
    },
    /**
     * Default minimal width of the iframe code (if extract from window\'s size)
     */
    minWidth: {
      type: Number,
      default: 0
    },
    /**
     * Default minimal height of the iframe code (if extract from window\'s size)
     */
    minHeight: {
      type: Number,
      default: 0
    },
    /**
     * URL of the iframe code
     */
    url: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      responsiveCheck: !1
    };
  },
  computed: {
    currentUrl() {
      return this.url || window.location.href;
    }
  },
  methods: {
    iframeCodeFor(t = this.currentUrl, e, n) {
      return `<iframe width="${e}" height="${n}" src="${Oo.deletePymParams(
        t
      )}" frameborder="0" allowfullscreen></iframe>`;
    },
    pymCodeFor(t = this.currentUrl) {
      return Oo.template(t);
    },
    selectCode() {
      var t;
      (t = this.$el.querySelector(".embed-form__code")) == null || t.select();
    },
    embedCode(t = this.responsiveCheck) {
      const e = typeof this.width == "string" ? this.width : Math.max(this.width, this.minWidth).toString(), n = Math.max(this.height, this.minHeight).toString();
      return t ? this.pymCodeFor(this.currentUrl) : this.iframeCodeFor(this.currentUrl, e, n);
    }
  }
});
var Int = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "embed-form" }, [n("div", { staticClass: "container-fluid" }, [e.noTitle ? e._e() : n("h4", { staticClass: "embed-form__heading" }, [e._v(" " + e._s(e.$t("embed-form.heading")) + " ")]), n("div", { staticClass: "row" }, [n("div", { staticClass: "col" }, [n("p", [e._v(" " + e._s(e.$t("embed-form.introduction")) + " ")]), n("textarea", { staticClass: "form-control embed-form__code mb-2", attrs: { readonly: "" }, domProps: { value: e.embedCode() }, on: { click: e.selectCode } }), n("label", { staticClass: "custom-control custom-checkbox btn btn-sm float-left" }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.responsiveCheck, expression: "responsiveCheck" }], staticClass: "custom-control-input", attrs: { type: "checkbox" }, domProps: { checked: Array.isArray(e.responsiveCheck) ? e._i(e.responsiveCheck, null) > -1 : e.responsiveCheck }, on: { change: function(r) {
    var i = e.responsiveCheck, a = r.target, o = !!a.checked;
    if (Array.isArray(i)) {
      var s = null, l = e._i(i, s);
      a.checked ? l < 0 && (e.responsiveCheck = i.concat([s])) : l > -1 && (e.responsiveCheck = i.slice(0, l).concat(i.slice(l + 1)));
    } else
      e.responsiveCheck = o;
  } } }), n("span", { staticClass: "custom-control-label font-weight-bold" }, [e._v(" " + e._s(e.$t("embed-form.responsive-optin")) + " ")])]), n("div", { staticClass: "text-right" }, [n("haptic-copy", { staticClass: "btn-link btn-sm text-uppercase font-weight-bold", attrs: { text: e.embedCode(), label: e.$t("embed-form.copy").toString() }, on: { attempt: function(r) {
    return e.selectCode();
  } } })], 1)]), e.noPreview ? e._e() : n("div", { staticClass: "col-7 d-none d-lg-block embed-form__preview" }, [n("span", { domProps: { innerHTML: e._s(e.embedCode(!1)) } })])])])]);
}, Rnt = [], Lnt = /* @__PURE__ */ Bt(
  Nnt,
  Int,
  Rnt,
  !1,
  null,
  "fd9aaf93",
  null,
  null
);
const d$ = Lnt.exports;
var eu = {};
function Dnt(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var Fnt = function(t, e, n, r) {
  e = e || "&", n = n || "=";
  var i = {};
  if (typeof t != "string" || t.length === 0)
    return i;
  var a = /\+/g;
  t = t.split(e);
  var o = 1e3;
  r && typeof r.maxKeys == "number" && (o = r.maxKeys);
  var s = t.length;
  o > 0 && s > o && (s = o);
  for (var l = 0; l < s; ++l) {
    var c = t[l].replace(a, "%20"), h = c.indexOf(n), d, p, g, v;
    h >= 0 ? (d = c.substr(0, h), p = c.substr(h + 1)) : (d = c, p = ""), g = decodeURIComponent(d), v = decodeURIComponent(p), Dnt(i, g) ? znt(i[g]) ? i[g].push(v) : i[g] = [i[g], v] : i[g] = v;
  }
  return i;
}, znt = Array.isArray || function(t) {
  return Object.prototype.toString.call(t) === "[object Array]";
}, ol = function(t) {
  switch (typeof t) {
    case "string":
      return t;
    case "boolean":
      return t ? "true" : "false";
    case "number":
      return isFinite(t) ? t : "";
    default:
      return "";
  }
}, Bnt = function(t, e, n, r) {
  return e = e || "&", n = n || "=", t === null && (t = void 0), typeof t == "object" ? h8(jnt(t), function(i) {
    var a = encodeURIComponent(ol(i)) + n;
    return Hnt(t[i]) ? h8(t[i], function(o) {
      return a + encodeURIComponent(ol(o));
    }).join(e) : a + encodeURIComponent(ol(t[i]));
  }).join(e) : r ? encodeURIComponent(ol(r)) + n + encodeURIComponent(ol(t)) : "";
}, Hnt = Array.isArray || function(t) {
  return Object.prototype.toString.call(t) === "[object Array]";
};
function h8(t, e) {
  if (t.map)
    return t.map(e);
  for (var n = [], r = 0; r < t.length; r++)
    n.push(e(t[r], r));
  return n;
}
var jnt = Object.keys || function(t) {
  var e = [];
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.push(n);
  return e;
};
eu.decode = eu.parse = Fnt;
eu.encode = eu.stringify = Bnt;
var p$ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "envelope", r = 512, i = 512, a = [128386, 9993, 61443], o = "f0e0", s = "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faEnvelope = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(p$);
var s2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fab", n = "twitter", r = 512, i = 512, a = [], o = "f099", s = "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faTwitter = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(s2);
var u2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fab", n = "facebook", r = 512, i = 512, a = [62e3], o = "f09a", s = "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faFacebook = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(u2);
var l2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fab", n = "linkedin", r = 448, i = 512, a = [], o = "f08c", s = "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faLinkedin = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(l2);
const In = {
  instance: null,
  interval: void 0,
  parent: typeof window != "undefined" ? window : null
}, Vnt = (t) => (e) => {
  e && e.preventDefault(), t();
}, sl = {
  email: {
    base: "mailto:?",
    icon: p$.faEnvelope,
    args: {
      subject: "title",
      body: "description"
    }
  },
  facebook: {
    base: "https://www.facebook.com/sharer.php?",
    icon: u2.faFacebook,
    args: {
      u: "url",
      title: "title",
      description: "description",
      hashtag: "hashtags"
    }
  },
  linkedin: {
    base: "https://www.linkedin.com/sharing/share-offsite/?",
    icon: l2.faLinkedin,
    args: {
      url: "url",
      title: "title",
      summary: "description"
    }
  },
  twitter: {
    base: "https://twitter.com/intent/tweet?",
    icon: s2.faTwitter,
    args: {
      url: "url",
      text: "title",
      via: "user",
      hashtags: "hashtags"
    }
  }
}, Wnt = te({
  name: "SharingOptionsLink",
  components: {
    Fa: ar
  },
  props: {
    /**
     * Root element type
     */
    tag: {
      type: String,
      default: "a"
    },
    /**
     * Social network to use
     */
    network: {
      type: String,
      required: !0,
      validator(t) {
        return Object.keys(sl).includes(t);
      }
    },
    /**
     * Disable icon
     */
    noIcon: {
      type: Boolean
    },
    /**
     * Shared URL
     */
    url: {
      type: String,
      default: null
    },
    /**
     * Shared text
     */
    title: {
      type: String,
      default: null
    },
    /**
     * Shared description
     */
    description: {
      type: String,
      default: null
    },
    /**
     * Shared image
     */
    media: {
      type: String,
      default: null
    },
    /**
     * Twitter user
     */
    user: {
      type: String,
      default: null
    },
    /**
     * Shared hashtags
     */
    hashtags: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      popup: {
        status: "no",
        resizable: "yes",
        toolbar: "no",
        menubar: "no",
        scrollbars: "no",
        location: "no",
        directories: "no",
        width: 626,
        height: 436,
        top: 0,
        left: 0,
        screenY: 0,
        screenX: 0
      }
    };
  },
  computed: {
    href() {
      return this.base + eu.stringify(this.query);
    },
    base() {
      return He(sl, [this.network, "base"], "");
    },
    args() {
      return He(sl, [this.network, "args"], {});
    },
    icon() {
      return He(sl, [this.network, "icon"], null);
    },
    query() {
      return f$(
        this.args,
        (t, e, n) => (this.$props[e] && (t[n] = this.$props[e]), t),
        {}
      );
    },
    name() {
      return He(sl, [this.network, "name"], this.network);
    },
    popupParams() {
      return eu.stringify(this.popup).split("&").join(",");
    }
  },
  methods: {
    click() {
      this.cleanExistingPopupInstance(), this.openPopup();
    },
    renderIcon(t) {
      if (!this.noIcon)
        return t("fa", { props: { icon: this.icon } });
    },
    openPopup() {
      var t, e;
      In.instance = (t = In.parent) == null ? void 0 : t.open(this.href, "sharer", this.popupParams), (e = In.instance) == null || e.focus(), In.interval = setInterval(this.cleanExistingPopupInterval, 500);
    },
    cleanExistingPopupInstance() {
      In.instance && In.interval && (clearInterval(In.interval), In.interval = void 0, In.instance.close());
    },
    cleanExistingPopupInterval() {
      In.instance && In.instance.closed && (clearInterval(In.interval), In.interval = void 0, In.instance = null);
    },
    hasPopup() {
      return this.network !== "email";
    }
  },
  render(t) {
    const e = this.hasPopup() ? Vnt(this.click) : bd, n = this.href, r = this.$slots.default || [this.renderIcon(t), t("span", { class: "sr-only" }, this.name)];
    return t(this.tag, { attrs: { href: n }, on: { click: e } }, r);
  }
}), Unt = null, Ynt = null;
var qnt = /* @__PURE__ */ Bt(
  Wnt,
  Unt,
  Ynt,
  !1,
  null,
  null,
  null,
  null
);
const m$ = qnt.exports, Gnt = te({
  i18n: Hn,
  name: "SharingOptions",
  components: {
    BModal: L_,
    EmbedForm: d$,
    SharingOptionsLink: m$,
    Fa: ar
  },
  props: {
    /**
     * URL to be shared.
     */
    url: {
      type: String,
      default: () => he.get("sharing-options.url", null) || Oo.deletePymParams()
    },
    /**
     * URL to use specificaly with the embed form
     */
    embedUrl: {
      type: String,
      default: null
    },
    /**
     * Direction of the sharing options. Can be: <em>row</em>, <em>row-reverse</em>,
     * <em>column</em> or <em>column-reverse</em>.
     */
    direction: {
      default: "row",
      validator(t) {
        return ["row", "row-reverse", "column", "column-reverse"].indexOf(t) !== -1;
      }
    },
    /**
     * Sharing contents which can be generic (<em>title</em>, <em>description</em>, etc)
     * or specific to a network (<em>twitter_title</em>, <em>facebook_description</em>, etc).
     */
    values: {
      type: Object,
      default: () => ({})
    },
    /**
     * The list of all the keys to automatically inject in each social button.
     */
    valuesKeys: {
      default: () => ["url", "title", "description", "media", "user"],
      type: Array
    },
    /**
     * Disable embed button.
     */
    noEmbed: {
      type: Boolean
    },
    /**
     * Minimum height of the iframe in the embed form.
     */
    iframeMinHeight: {
      type: Number,
      default: 100
    },
    /**
     * Minimum width of the iframe in the embed form.
     */
    iframeMinWidth: {
      type: Number,
      default: 100
    },
    /**
     * Prevent from reading default value from the <code>meta</code>.
     */
    noMeta: {
      type: Boolean
    }
  },
  computed: {
    style() {
      return {
        "flex-direction": this.direction
      };
    },
    metaValues() {
      return {
        url: this.url,
        title: this.defaultValueFor("sharing-options.title"),
        description: this.defaultValueFor("sharing-options.description", 'meta[name="description]'),
        facebook_title: this.defaultValueFor("sharing-options.facebook_title", 'meta[property="og:title"]'),
        facebook_description: this.defaultValueFor("sharing-options.description", 'meta[property="og:description"]'),
        facebook_media: this.defaultValueFor("sharing-options.media", 'meta[property="og:image"]'),
        twitter_media: this.defaultValueFor("sharing-options.media", 'meta[name="twitter:image"]'),
        twitter_user: this.defaultValueFor("sharing-options.twitter-user", 'meta[name="twitter:site"]')
      };
    }
  },
  beforeMount() {
    Br.add(h$.faCode);
  },
  methods: {
    showEmbedForm() {
      var t, e;
      return (e = (t = this.$refs.embedForm) == null ? void 0 : t.show()) != null ? e : !1;
    },
    valuesFor(t) {
      const e = Object.assign(this.metaValues, this.values);
      return f$(
        this.valuesKeys,
        (n, r) => (n[r] = He(e, `${t}_${r}`, e[r]), n),
        {}
      );
    },
    defaultValueFor(t, e) {
      return this.noMeta || !e ? he.get(t) : He(document.head.querySelector(e), "content", he.get(t));
    }
  }
});
var Knt = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "sharing-options", style: e.style }, [n("sharing-options-link", e._b({ staticClass: "sharing-options__link", attrs: { network: "facebook" } }, "sharing-options-link", e.valuesFor("facebook"), !1)), n("sharing-options-link", e._b({ staticClass: "sharing-options__link", attrs: { network: "twitter" } }, "sharing-options-link", e.valuesFor("twitter"), !1)), n("sharing-options-link", e._b({ staticClass: "sharing-options__link", attrs: { network: "linkedin" } }, "sharing-options-link", e.valuesFor("linkedin"), !1)), n("sharing-options-link", e._b({ staticClass: "sharing-options__link", attrs: { network: "email" } }, "sharing-options-link", e.valuesFor("email"), !1)), n("div", { directives: [{ name: "show", rawName: "v-show", value: !e.noEmbed, expression: "!noEmbed" }], staticClass: "sharing-options__link sharing-options__link--embed" }, [n("a", { on: { click: e.showEmbedForm } }, [n("fa", { attrs: { icon: "code" } }), n("span", { staticClass: "sr-only" }, [e._v("Embed")])], 1)]), n("b-modal", { ref: "embedForm", staticClass: "text-dark", attrs: { "hide-footer": "", title: "Embed on your website" } }, [n("embed-form", { attrs: { "no-title": "", "no-preview": "", url: e.embedUrl || e.url, "min-height": e.iframeMinHeight, "min-width": e.iframeMinWidth } })], 1)], 1);
}, Xnt = [], Znt = /* @__PURE__ */ Bt(
  Gnt,
  Knt,
  Xnt,
  !1,
  null,
  null,
  null,
  null
);
const g$ = Znt.exports, Jnt = te({
  i18n: Hn,
  name: "EmbeddableFooter",
  components: {
    Fa: ar,
    SharingOptions: g$,
    Brand: BC
  },
  props: {
    /**
     * Title to display next to ICIJ logo.
     */
    title: {
      type: String,
      default: () => he.get("project.name")
    },
    /**
     * Lead sentence to display next to the title.
     */
    lead: {
      type: String,
      default: ""
    },
    /**
     * Minimum height for the iframe generated in the embed form.
     */
    iframeMinHeight: {
      type: Number,
      default: 100
    },
    /**
     * Minimum width for the iframe generated in the embed form.
     */
    iframeMinWidth: {
      type: Number,
      default: 100
    },
    /**
     * Target of the ICIJ logo and title links.
     */
    homeUrl: {
      type: String,
      default: () => he.get("app.home")
    },
    /**
     * Sharing option values to bind to the sharing-options component on the bottom-right corner.
     */
    sharingOptionsValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showShareOptions: !1
    };
  },
  beforeMount() {
    Br.add(s$.faShareAlt);
  },
  mounted() {
    Oo.create();
  }
});
var Qnt = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "embeddable-footer p-2 text-nowrap" }, [n("a", { staticClass: "text-white embeddable-footer__brand", attrs: { href: e.homeUrl, target: "_blank" } }, [n("brand", { staticClass: "mr-2", attrs: { size: 40, "no-border": "", color: "white" } }), e._v(" " + e._s(e.title) + " ")], 1), n("div", { staticClass: "embeddable-footer__lead small text-truncate" }, [e._t("default", function() {
    return [e._v(" " + e._s(e.lead) + " ")];
  }, { lead: e.lead })], 2), e._t("sharing-button", function() {
    return [n("button", { staticClass: "btn btn-link text-white btn-sm py-0 embeddable-footer__share-btn", class: { active: e.showShareOptions }, on: { click: function(r) {
      e.showShareOptions = !e.showShareOptions;
    } } }, [n("fa", { attrs: { icon: "share-alt" } }), n("span", { staticClass: "sr-only" }, [e._v(e._s(e.$t("embeddable-footer.share")))])], 1)];
  }, null, { sharingOptionsValues: e.sharingOptionsValues }), e.showShareOptions ? n("sharing-options", { attrs: { values: e.sharingOptionsValues, direction: "column-reverse", "iframe-min-height": e.iframeMinHeight, "iframe-min-width": e.iframeMinWidth } }) : e._e()], 2);
}, trt = [], ert = /* @__PURE__ */ Bt(
  Jnt,
  Qnt,
  trt,
  !1,
  null,
  "fb4f4e02",
  null,
  null
);
const nrt = ert.exports;
var xd = {}, rrt = {
  get exports() {
    return xd;
  },
  set exports(t) {
    xd = t;
  }
}, Cd = {}, irt = {
  get exports() {
    return Cd;
  },
  set exports(t) {
    Cd = t;
  }
}, ec = 1e3, nc = ec * 60, rc = nc * 60, ic = rc * 24, art = ic * 365.25, ort = function(t, e) {
  e = e || {};
  var n = typeof t;
  if (n === "string" && t.length > 0)
    return srt(t);
  if (n === "number" && isNaN(t) === !1)
    return e.long ? lrt(t) : urt(t);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(t)
  );
};
function srt(t) {
  if (t = String(t), !(t.length > 100)) {
    var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      t
    );
    if (e) {
      var n = parseFloat(e[1]), r = (e[2] || "ms").toLowerCase();
      switch (r) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return n * art;
        case "days":
        case "day":
        case "d":
          return n * ic;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return n * rc;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return n * nc;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return n * ec;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return n;
        default:
          return;
      }
    }
  }
}
function urt(t) {
  return t >= ic ? Math.round(t / ic) + "d" : t >= rc ? Math.round(t / rc) + "h" : t >= nc ? Math.round(t / nc) + "m" : t >= ec ? Math.round(t / ec) + "s" : t + "ms";
}
function lrt(t) {
  return ih(t, ic, "day") || ih(t, rc, "hour") || ih(t, nc, "minute") || ih(t, ec, "second") || t + " ms";
}
function ih(t, e, n) {
  if (!(t < e))
    return t < e * 1.5 ? Math.floor(t / e) + " " + n : Math.ceil(t / e) + " " + n + "s";
}
(function(t, e) {
  e = t.exports = i.debug = i.default = i, e.coerce = l, e.disable = o, e.enable = a, e.enabled = s, e.humanize = ort, e.names = [], e.skips = [], e.formatters = {};
  var n;
  function r(c) {
    var h = 0, d;
    for (d in c)
      h = (h << 5) - h + c.charCodeAt(d), h |= 0;
    return e.colors[Math.abs(h) % e.colors.length];
  }
  function i(c) {
    function h() {
      if (h.enabled) {
        var d = h, p = +/* @__PURE__ */ new Date(), g = p - (n || p);
        d.diff = g, d.prev = n, d.curr = p, n = p;
        for (var v = new Array(arguments.length), b = 0; b < v.length; b++)
          v[b] = arguments[b];
        v[0] = e.coerce(v[0]), typeof v[0] != "string" && v.unshift("%O");
        var _ = 0;
        v[0] = v[0].replace(/%([a-zA-Z%])/g, function(x, C) {
          if (x === "%%")
            return x;
          _++;
          var $ = e.formatters[C];
          if (typeof $ == "function") {
            var E = v[_];
            x = $.call(d, E), v.splice(_, 1), _--;
          }
          return x;
        }), e.formatArgs.call(d, v);
        var w = h.log || e.log || console.log.bind(console);
        w.apply(d, v);
      }
    }
    return h.namespace = c, h.enabled = e.enabled(c), h.useColors = e.useColors(), h.color = r(c), typeof e.init == "function" && e.init(h), h;
  }
  function a(c) {
    e.save(c), e.names = [], e.skips = [];
    for (var h = (typeof c == "string" ? c : "").split(/[\s,]+/), d = h.length, p = 0; p < d; p++)
      h[p] && (c = h[p].replace(/\*/g, ".*?"), c[0] === "-" ? e.skips.push(new RegExp("^" + c.substr(1) + "$")) : e.names.push(new RegExp("^" + c + "$")));
  }
  function o() {
    e.enable("");
  }
  function s(c) {
    var h, d;
    for (h = 0, d = e.skips.length; h < d; h++)
      if (e.skips[h].test(c))
        return !1;
    for (h = 0, d = e.names.length; h < d; h++)
      if (e.names[h].test(c))
        return !0;
    return !1;
  }
  function l(c) {
    return c instanceof Error ? c.stack || c.message : c;
  }
})(irt, Cd);
(function(t, e) {
  e = t.exports = Cd, e.log = i, e.formatArgs = r, e.save = a, e.load = o, e.useColors = n, e.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : s(), e.colors = [
    "lightseagreen",
    "forestgreen",
    "goldenrod",
    "dodgerblue",
    "darkorchid",
    "crimson"
  ];
  function n() {
    return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  e.formatters.j = function(l) {
    try {
      return JSON.stringify(l);
    } catch (c) {
      return "[UnexpectedJSONParseError]: " + c.message;
    }
  };
  function r(l) {
    var c = this.useColors;
    if (l[0] = (c ? "%c" : "") + this.namespace + (c ? " %c" : " ") + l[0] + (c ? "%c " : " ") + "+" + e.humanize(this.diff), !!c) {
      var h = "color: " + this.color;
      l.splice(1, 0, h, "color: inherit");
      var d = 0, p = 0;
      l[0].replace(/%[a-zA-Z%]/g, function(g) {
        g !== "%%" && (d++, g === "%c" && (p = d));
      }), l.splice(p, 0, h);
    }
  }
  function i() {
    return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function a(l) {
    try {
      l == null ? e.storage.removeItem("debug") : e.storage.debug = l;
    } catch (c) {
    }
  }
  function o() {
    var l;
    try {
      l = e.storage.debug;
    } catch (c) {
    }
    return !l && typeof process != "undefined" && "env" in process && (l = process.env.DEBUG), l;
  }
  e.enable(o());
  function s() {
    try {
      return window.localStorage;
    } catch (l) {
    }
  }
})(rrt, xd);
var d8 = xd("jsonp"), crt = drt, frt = 0;
function hrt() {
}
function drt(t, e, n) {
  typeof e == "function" && (n = e, e = {}), e || (e = {});
  var r = e.prefix || "__jp", i = e.name || r + frt++, a = e.param || "callback", o = e.timeout != null ? e.timeout : 6e4, s = encodeURIComponent, l = document.getElementsByTagName("script")[0] || document.head, c, h;
  o && (h = setTimeout(function() {
    d(), n && n(new Error("Timeout"));
  }, o));
  function d() {
    c.parentNode && c.parentNode.removeChild(c), window[i] = hrt, h && clearTimeout(h);
  }
  function p() {
    window[i] && d();
  }
  return window[i] = function(g) {
    d8("jsonp got", g), d(), n && n(null, g);
  }, t += (~t.indexOf("?") ? "&" : "?") + a + "=" + s(i), t = t.replace("?&", "?"), d8('jsonp req "%s"', t), c = document.createElement("script"), c.src = t, l.parentNode.insertBefore(c, l), p;
}
var prt = Ue;
function mrt() {
  if (!arguments.length)
    return [];
  var t = arguments[0];
  return prt(t) ? t : [t];
}
var ev = mrt, grt = a$;
function vrt(t) {
  var e = t == null ? 0 : t.length;
  return e ? grt(t, 1) : [];
}
var _rt = vrt;
function brt(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
var yrt = brt;
const wrt = te({
  i18n: Hn,
  name: "SignUpForm",
  props: {
    /**
     * Mailchimp URL to send the data to.
     */
    action: {
      type: String,
      default: () => he.get("signup-form.action")
    },
    /**
     * Malchimp email field parameter
     */
    emailField: {
      type: String,
      default: () => he.get("signup-form.email-field")
    },
    /**
     * Malchimp default groups. Can be an array or a commat-separated list of groups.
     */
    defaultGroups: {
      type: [String, Array],
      default: () => he.get("signup-form.default-groups")
    },
    /**
     * Disable the main label.
     */
    noLabel: {
      type: Boolean
    },
    /**
     * Horizontal layout of the form.
     */
    horizontal: {
      type: Boolean
    },
    /**
     * Mailchimp tracker tag to identify the origin.
     */
    tracker: {
      type: String,
      default: () => he.get("signup-form.tracker")
    },
    /**
     * Referrer URL cant be passed explicitely
     */
    referrer: {
      type: String,
      default: null
    },
    /**
     * Color variant of the sign up button
     */
    variant: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      email: "",
      frozen: !1,
      response: {},
      errorMessage: null,
      successMessage: null
    };
  },
  computed: {
    groups() {
      return _rt(ev(this.defaultGroups).map((t) => t.split(",")));
    },
    url() {
      return this.action.replace("/post?", "/post-json?").concat("&c=?");
    },
    parentReferrer() {
      return this.referrer ? this.referrer : window.location !== window.parent.location ? document.referrer : document.location.href;
    },
    submitUrl() {
      const t = new URL(this.url);
      return t.searchParams.set("SIGNUP", this.tracker), t.searchParams.set("MMERGE24", this.parentReferrer), t.searchParams.set(this.emailField, this.email), this.groups.map((e) => t.searchParams.set(e, "1")), t.href;
    },
    variantColorClass() {
      return `btn-${this.variant}`;
    }
  },
  methods: {
    subscribe() {
      return this.resetMessages(), this.freeze(), this.send().then(this.done, this.done);
    },
    send() {
      return new Promise((t, e) => {
        crt(this.submitUrl, { param: "c" }, (n, r) => n ? e(n) : t(r));
      });
    },
    done({ result: t, msg: e }) {
      var n;
      t === "success" ? (this.email = "", this.successMessage = e) : this.errorMessage = (n = yrt((e || "Something's wrong").split("0 -"))) != null ? n : null, this.unfreeze();
    },
    resetMessages() {
      this.errorMessage = null, this.successMessage = null;
    },
    freeze() {
      this.frozen = !0;
    },
    unfreeze() {
      this.frozen = !1;
    }
  }
});
var xrt = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("form", { staticClass: "sign-up-form", class: { "sign-up-form--horizontal": e.horizontal }, on: { submit: function(r) {
    return r.preventDefault(), e.subscribe();
  } } }, [n("fieldset", { attrs: { disabled: e.frozen } }, [e.noLabel ? e._e() : n("label", { staticClass: "text-uppercase text-muted font-weight-bold", attrs: { for: "input-email" } }, [e._v(" " + e._s(e.$t("sign-up-form.label")) + " ")]), n("div", { staticClass: "sign-up-form__fieldset__group", class: { "input-group": e.horizontal } }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.email, expression: "email" }], staticClass: "form-control", attrs: { id: "input-email", name: "EMAIL", type: "email", placeholder: e.$t("sign-up-form.placeholder").toString() }, domProps: { value: e.email }, on: { input: function(r) {
    r.target.composing || (e.email = r.target.value);
  } } }), n("div", { staticClass: "sign-up-form__fieldset__group__addon", class: { "input-group-append": e.horizontal } }, [n("button", { staticClass: "btn text-uppercase font-weight-bold", class: e.variantColorClass, attrs: { type: "submit" } }, [e._v(" " + e._s(e.$t("sign-up-form.submit")) + " ")])])])]), e.errorMessage ? n("p", { staticClass: "alert alert-danger p-2 m-0 mt-2" }, [e._v(" " + e._s(e.errorMessage) + " ")]) : e._e(), e.successMessage ? n("p", { staticClass: "alert alert-success p-2 m-0 mt-2" }, [e._v(" " + e._s(e.successMessage) + " ")]) : e._e()]);
}, Crt = [], $rt = /* @__PURE__ */ Bt(
  wrt,
  xrt,
  Crt,
  !1,
  null,
  null,
  null,
  null
);
const v$ = $rt.exports, Trt = te({
  i18n: Hn,
  name: "FollowUsPopover",
  components: {
    Fa: ar,
    SignUpForm: v$
  },
  beforeMount() {
    Br.add(t2.faTimes, s2.faTwitter, u2.faFacebook, l2.faLinkedin);
  },
  methods: {
    closeSignupPopover() {
      this.$emit("update:show", !1);
    }
  }
});
var Ort = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "follow-us" }, [n("button", { staticClass: "btn btn-link text-light follow-us__close", on: { click: e.closeSignupPopover } }, [n("fa", { attrs: { icon: "times" } })], 1), n("sign-up-form", { staticClass: "p-3" }), n("div", { staticClass: "px-3 pb-1 text-uppercase text-muted font-weight-bold" }, [e._v(" " + e._s(e.$t("follow-us-popover.heading")) + " ")]), n("div", { staticClass: "p-3 bg-light container-fluid text-center" }, [n("div", { staticClass: "row w-100" }, [n("div", { staticClass: "col" }, [n("a", { staticClass: "d-inline-block text-primary border border-primary rounded-circle bg-white follow-us__social-btn", attrs: { href: "https://twitter.com/ICIJorg", target: "_blank", title: "Twitter" } }, [n("fa", { attrs: { icon: ["fab", "twitter"], size: "lg" } }), n("span", { staticClass: "sr-only" }, [e._v("Twitter")])], 1)]), n("div", { staticClass: "col" }, [n("a", { staticClass: "d-inline-block text-primary border border-primary rounded-circle bg-white follow-us__social-btn", attrs: { href: "https://www.facebook.com/ICIJ.org", target: "_blank", title: "Facebook" } }, [n("fa", { attrs: { icon: ["fab", "facebook"], size: "lg" } }), n("span", { staticClass: "sr-only" }, [e._v("Facebook")])], 1)]), n("div", { staticClass: "col" }, [n("a", { staticClass: "d-inline-block text-primary border border-primary rounded-circle bg-white follow-us__social-btn", attrs: { href: "https://www.linkedin.com/company/1732242/", target: "_blank", title: "Linkedin" } }, [n("fa", { attrs: { icon: ["fab", "linkedin"], size: "lg" } }), n("span", { staticClass: "sr-only" }, [e._v("Linkedin")])], 1)])])])], 1);
}, Srt = [], Ert = /* @__PURE__ */ Bt(
  Trt,
  Ort,
  Srt,
  !1,
  null,
  "935a04a0",
  null,
  null
);
const c2 = Ert.exports, Art = te({
  i18n: Hn,
  name: "GenericFooter",
  components: { BrandExpansion: Q_ },
  props: {
    /**
     * Version of the app to display in the bottom-right corner of the footer
     */
    version: {
      type: String,
      default: null
    },
    /**
     * Whether to show the About Us column or not
     */
    showAboutUs: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return { mode: da.Long };
  },
  computed: {
    year() {
      return (/* @__PURE__ */ new Date()).getFullYear();
    },
    contactEmail() {
      return he.get("contact-email");
    },
    contactEmailMailto() {
      return `mailto:${this.contactEmail}`;
    }
  }
});
var Prt = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("footer", { staticClass: "generic-footer" }, [n("div", { staticClass: "container" }, [n("div", { staticClass: "row" }, [n("div", { staticClass: "col-12 col-lg-5" }, [n("h5", { staticClass: "text-uppercase text-white clearfix generic-footer__icij mb-3" }, [n("a", { staticClass: "generic-footer__icij__logo text-decoration-none", attrs: { href: "https://icij.org", target: "_blank" } }, [n("brand-expansion", { attrs: { mode: e.mode, dark: "" } }), n("span", { staticClass: "sr-only" }, [e._v("International Consortium of Investigative Journalists")])], 1)]), n("p", [e._t("address", function() {
    return [e._v(" 1800 M Street NW, Front 1 #33019"), n("br"), e._v(" Washington, D.C. 20033 USA ")];
  })], 2), n("p", [n("strong", [n("a", { attrs: { href: e.contactEmailMailto } }, [e._v(e._s(e.contactEmail))])])]), e._t("left")], 2), n("div", { staticClass: "col-12 col-lg-7" }, [n("div", { staticClass: "row justify-content-end" }, [e.showAboutUs ? n("div", { staticClass: "col-6 col-lg-4" }, [n("h5", { staticClass: "text-uppercase mb-3" }, [e._v("About Us")]), e._m(0)]) : e._e(), n("div", { staticClass: "col-6 col-lg-4" }, [n("h5", { staticClass: "text-uppercase mb-3" }, [e._v(" " + e._s(e.$t("generic-footer.investigations")) + " ")]), e._t("investigations", function() {
    return [e._m(1)];
  })], 2), n("div", { staticClass: "col-6 col-lg-4" }, [n("h5", { staticClass: "text-uppercase mb-3" }, [e._v(" " + e._s(e.$t("generic-footer.follow-us")) + " ")]), e._m(2)])])])]), n("p", { staticClass: "text-white text-md-right small mt-5" }, [n("strong", [e._v(" © "), n("span", { staticClass: "generic-footer__year" }, [e._v(e._s(e.year))]), e._v(" — The International Consortium of Investigative Journalists. ")]), e._v(" " + e._s(e.$t("generic-footer.all-rights")) + " "), n("br"), e.version ? n("span", { staticClass: "text-muted generic-footer__version" }, [e._v(" " + e._s(e.$t("generic-footer.version", { version: e.version })) + " ")]) : e._e()])])]);
}, Mrt = [function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("ul", { staticClass: "list-unstyled" }, [e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/about/our-team/", target: "_blank" } }, [t._v(" Our team ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/about/our-supporters/", target: "_blank" } }, [t._v(" Our supporters ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/about/awards/", target: "_blank" } }, [t._v(" ICIJ's Awards ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/about/corporate/", target: "_blank" } }, [t._v(" Corportate ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/about/work-with-us/", target: "_blank" } }, [t._v(" Work with us ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/journalists/", target: "_blank" } }, [t._v(" Journalists ")])])]);
}, function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("ul", { staticClass: "list-unstyled" }, [e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/uber-files/", target: "_blank" } }, [t._v(" The Uber Files ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/russia-archive/", target: "_blank" } }, [t._v(" Russia Archive ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/ericsson-list/", target: "_blank" } }, [t._v(" The Ericsson List ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/pandora-papers/", target: "_blank" } }, [t._v(" Pandora Papers ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/fincen-files/", target: "_blank" } }, [t._v(" FinCEN Files ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/investigations/", target: "_blank" } }, [t._v(" More investigations ")])])]);
}, function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("ul", { staticClass: "list-unstyled" }, [e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.facebook.com/ICIJ.org", target: "_blank" } }, [t._v(" Facebook ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.linkedin.com/company/1732242/", target: "_blank" } }, [t._v(" LinkedIn ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://twitter.com/ICIJorg", target: "_blank" } }, [t._v(" Twitter ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://instagram.com/icijorg", target: "_blank" } }, [t._v(" Instagram ")])]), e("li", { staticClass: "list-unstyled-item" }, [e("a", { attrs: { href: "https://www.icij.org/signup/", target: "_blank" } }, [t._v(" Sign-up ")])])]);
}], krt = /* @__PURE__ */ Bt(
  Art,
  Prt,
  Mrt,
  !1,
  null,
  "a45a7dfd",
  null,
  null
);
const Nrt = krt.exports;
var _$ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "bars", r = 448, i = 512, a = ["navicon"], o = "f0c9", s = "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faBars = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(_$);
var $d = {}, Irt = {
  get exports() {
    return $d;
  },
  set exports(t) {
    $d = t;
  }
};
/*!
 * vue-headroom v0.10.1
 * (c) dalphyx <wjcbmk@gmail.com>
 * Released under the MIT License.
 */
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(Fn, function() {
    function n(B, H, J) {
      return H in B ? Object.defineProperty(B, H, {
        value: J,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : B[H] = J, B;
    }
    var r = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof Fn != "undefined" ? Fn : typeof self != "undefined" ? self : {};
    function i(B, H) {
      return H = { exports: {} }, B(H, H.exports), H.exports;
    }
    for (var a = i(function(B) {
      (function() {
        var H, J, X, et, rt, ut;
        typeof performance != "undefined" && performance !== null && performance.now ? B.exports = function() {
          return performance.now();
        } : typeof process != "undefined" && process !== null && process.hrtime ? (B.exports = function() {
          return (H() - rt) / 1e6;
        }, J = process.hrtime, H = function() {
          var ft;
          return ft = J(), ft[0] * 1e9 + ft[1];
        }, et = H(), ut = process.uptime() * 1e9, rt = et - ut) : Date.now ? (B.exports = function() {
          return Date.now() - X;
        }, X = Date.now()) : (B.exports = function() {
          return (/* @__PURE__ */ new Date()).getTime() - X;
        }, X = (/* @__PURE__ */ new Date()).getTime());
      }).call(r);
    }), o = typeof window == "undefined" ? r : window, s = ["moz", "webkit"], l = "AnimationFrame", c = o["request" + l], h = o["cancel" + l] || o["cancelRequest" + l], d = 0; !c && d < s.length; d++)
      c = o[s[d] + "Request" + l], h = o[s[d] + "Cancel" + l] || o[s[d] + "CancelRequest" + l];
    if (!c || !h) {
      var p = 0, g = 0, v = [], b = 1e3 / 60;
      c = function(B) {
        if (v.length === 0) {
          var H = a(), J = Math.max(0, b - (H - p));
          p = J + H, setTimeout(function() {
            var X = v.slice(0);
            v.length = 0;
            for (var et = 0; et < X.length; et++)
              if (!X[et].cancelled)
                try {
                  X[et].callback(p);
                } catch (rt) {
                  setTimeout(function() {
                    throw rt;
                  }, 0);
                }
          }, Math.round(J));
        }
        return v.push({
          handle: ++g,
          callback: B,
          cancelled: !1
        }), g;
      }, h = function(B) {
        for (var H = 0; H < v.length; H++)
          v[H].handle === B && (v[H].cancelled = !0);
      };
    }
    var _ = function(B) {
      return c.call(o, B);
    }, w = function() {
      h.apply(o, arguments);
    }, x = function(B) {
      B || (B = o), B.requestAnimationFrame = c, B.cancelAnimationFrame = h;
    };
    _.cancel = w, _.polyfill = x;
    function C(B) {
      var H = B.currentScrollY >= B.lastScrollY ? "down" : "up", J = Math.abs(B.currentScrollY - B.lastScrollY), X = B.lastScrollY === void 0, et;
      return B.currentScrollY > B.height + B.offset && B.state === "unfixed" && X ? et = "pin" : B.currentScrollY <= B.offset && B.state !== "unfixed" ? et = "unfix" : B.currentScrollY <= B.height && H === "down" && B.state === "unfixed" ? et = "none" : B.currentScrollY > B.height + B.offset && H === "down" && B.state === "unfixed" && !X ? et = "unpin-snap" : H === "down" && ["pinned", "unfixed"].indexOf(B.state) >= 0 && B.currentScrollY > B.height + B.offset && J > B.downTolerance ? et = "unpin" : H === "up" && J > B.upTolerance && ["pinned", "unfixed"].indexOf(B.state) < 0 || H === "up" && B.currentScrollY <= B.height && ["pinned", "unfixed"].indexOf(B.state) < 0 ? et = "pin" : et = "none", et;
    }
    function $() {
      for (var B = document.createElement("div"), H = !1, J = ["perspectiveProperty", "WebkitPerspective"], X = J.length - 1; X >= 0; X--)
        H = H || B.style[J[X]] !== void 0;
      if (H) {
        var et = document.createElement("style");
        et.textContent = "#modernizr{width:0;height:0} @media (transform-3d),(-webkit-transform-3d){#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", document.getElementsByTagName("head")[0].appendChild(et), B.id = "modernizr", document.body.appendChild(B), H = B.offsetWidth === 7 && B.offsetHeight === 18, et.parentNode.removeChild(et), B.parentNode.removeChild(B);
      }
      return H;
    }
    var E = {
      pinned: "headroom--pinned",
      unpinned: "headroom--unpinned",
      unfixed: "headroom--unfixed",
      top: "headroom--top",
      notTop: "headroom--not-top",
      bottom: "headroom--bottom",
      notBottom: "headroom--not-bottom",
      initial: "headroom"
    }, A = {
      name: "vueHeadroom",
      data: function() {
        return {
          isTop: !1,
          isNotTop: !1,
          isBottom: !1,
          isNotBottom: !1,
          isPinned: !1,
          isUnpinned: !1,
          currentScrollY: 0,
          lastScrollY: void 0,
          state: "unfixed",
          translate: 0,
          height: "",
          animation: !0,
          isSupport3d: !1
        };
      },
      props: {
        scroller: {
          type: Function,
          default: function() {
            return window;
          }
        },
        disabled: {
          type: Boolean,
          default: !1
        },
        upTolerance: {
          type: Number,
          default: 5
        },
        downTolerance: {
          type: Number,
          default: 0
        },
        speed: {
          type: Number,
          default: 250
        },
        easing: {
          type: String,
          default: "ease-in-out"
        },
        zIndex: {
          type: Number,
          default: 9999
        },
        offset: {
          type: Number,
          default: 0
        },
        classes: {
          type: Object,
          default: function() {
            return E;
          }
        },
        footroom: {
          type: Boolean,
          default: !1
        }
      },
      watch: {
        disabled: function(H) {
          H ? this.scroller().removeEventListener("scroll", this._handleScroll) : this.scroller().addEventListener("scroll", this._handleScroll);
        }
      },
      mounted: function() {
        this.isSupport3d = $(), this._setHeightOffset(), this.disabled || this.scroller().addEventListener("scroll", this._handleScroll), this._handleScroll();
      },
      updated: function() {
        this.$nextTick(function() {
          this._setHeightOffset();
        });
      },
      beforeDestroy: function() {
        this.scroller().removeEventListener("scroll", this._handleScroll);
      },
      computed: {
        style: function() {
          var H = {
            position: this.disabled || this.state === "unfixed" ? "relative" : "fixed",
            top: "0",
            left: "0",
            right: "0",
            "z-index": this.zIndex
          };
          return this.footroom && (H = Object.assign({}, H, {
            top: "unset",
            bottom: "0"
          })), this.$isServer || (H.transform = this.isSupport3d && !this.$isServer ? "translate3d(0, ".concat(this.translate, ", 0)") : "translateY(".concat(this.translate, ")"), this.animation && (H.transition = "all ".concat(this.speed, "ms ").concat(this.easing))), H;
        },
        clsOpts: function() {
          return Object.assign({}, E, this.classes);
        },
        cls: function() {
          var H, J = this.clsOpts;
          return this.disabled ? {} : (H = {}, n(H, J.top, this.isTop), n(H, J.notTop, this.isNotTop), n(H, J.bottom, this.isBottom), n(H, J.notBottom, this.isNotBottom), n(H, J.pinned, this.isPinned), n(H, J.unpinned, this.isUnpinned), n(H, J.initial, !0), H);
        }
      },
      methods: {
        _getViewportHeight: function() {
          return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        },
        _getElementPhysicalHeight: function(H) {
          return Math.max(H.offsetHeight, H.clientHeight);
        },
        _getDocumentHeight: function() {
          var H = document.body, J = document.documentElement;
          return Math.max(H.scrollHeight, J.scrollHeight, H.offsetHeight, J.offsetHeight, H.clientHeight, J.clientHeight);
        },
        _getElementHeight: function(H) {
          return Math.max(H.scrollHeight, H.offsetHeight, H.clientHeight);
        },
        _getScrollerPhysicalHeight: function() {
          var H = this.scroller();
          return H === window || H === document.body ? this._getViewportHeight() : this._getElementPhysicalHeight(H);
        },
        _getScrollerHeight: function() {
          var H = this.scroller();
          return H === window || H === document.body ? this._getDocumentHeight() : this._getElementHeight(H);
        },
        _isOutOfBound: function(H) {
          var J = H < 0, X = this._getScrollerPhysicalHeight(), et = this._getScrollerHeight(), rt = H + X > et;
          return J || rt;
        },
        _handleScroll: function() {
          _(this.update);
        },
        _setHeightOffset: function() {
          this.height = this.$slots.default ? this.$slots.default[0].elm && this.$slots.default[0].elm.offsetHeight : "";
        },
        _getScrollY: function() {
          var H;
          return this.scroller().pageYOffset !== void 0 ? H = this.scroller().pageYOffset : this.scroller().scrollTop !== void 0 ? H = this.scroller().scrollTop : H = (document.documentElement || document.body.parentNode || document.body).scrollTop, H;
        },
        update: function() {
          if (this.currentScrollY = this._getScrollY(), !this._isOutOfBound(this.currentScrollY)) {
            this.currentScrollY <= this.offset ? this.top() : this.notTop(), this.currentScrollY + this._getViewportHeight() >= this._getScrollerHeight() ? this.bottom() : this.notBottom();
            var H = C(this);
            H === "pin" ? this.pin() : H === "unpin-snap" ? this.unpinSnap() : H === "unpin" ? this.unpin() : H === "unfix" && this.unfix(), this.lastScrollY = this.currentScrollY;
          }
        },
        top: function() {
          this.isTop = !0, this.isNotTop = !1, this.$emit("top");
        },
        notTop: function() {
          this.isTop = !1, this.isNotTop = !0, this.$emit("not-top");
        },
        bottom: function() {
          this.isBottom = !0, this.isNotBottom = !1, this.$emit("bottom");
        },
        notBottom: function() {
          this.isNotBottom = !0, this.isBottom = !1, this.$emit("not-bottom");
        },
        pin: function() {
          var H = this;
          this.isPinned = !0, this.isUnpinned = !1, this.animation = !0, this.$emit("pin"), this.translate = 0, this.$nextTick(function() {
            H.state = "pinned";
          });
        },
        unpin: function() {
          var H = this;
          this.isUnpinned = !0, this.isPinned = !1, this.animation = !0, this.$emit("unpin"), this.translate = this.footroom ? "100%" : "-100%", this.$nextTick(function() {
            H.state = "unpinned";
          });
        },
        unpinSnap: function() {
          var H = this;
          this.isUnpinned = !0, this.isPinned = !1, this.animation = !1, this.$emit("unpin"), this.translate = this.footroom ? "100%" : "-100%", this.$nextTick(function() {
            H.state = "unpinned";
          });
        },
        unfix: function() {
          var H = this;
          this.translate = 0, this.animation = !1, this.$emit("unfix"), this.$nextTick(function() {
            H.state = "unfixed";
          });
        }
      }
    };
    function R(B, H, J, X, et, rt, ut, ft, ht, Nt) {
      typeof ut != "boolean" && (ht = ft, ft = ut, ut = !1);
      var ot = typeof J == "function" ? J.options : J;
      B && B.render && (ot.render = B.render, ot.staticRenderFns = B.staticRenderFns, ot._compiled = !0, et && (ot.functional = !0)), X && (ot._scopeId = X);
      var wt;
      if (rt ? (wt = function($t) {
        $t = $t || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !$t && typeof __VUE_SSR_CONTEXT__ != "undefined" && ($t = __VUE_SSR_CONTEXT__), H && H.call(this, ht($t)), $t && $t._registeredComponents && $t._registeredComponents.add(rt);
      }, ot._ssrRegister = wt) : H && (wt = ut ? function() {
        H.call(this, Nt(this.$root.$options.shadowRoot));
      } : function(Gt) {
        H.call(this, ft(Gt));
      }), wt)
        if (ot.functional) {
          var kt = ot.render;
          ot.render = function($t, le) {
            return wt.call(le), kt($t, le);
          };
        } else {
          var at = ot.beforeCreate;
          ot.beforeCreate = at ? [].concat(at, wt) : [wt];
        }
      return J;
    }
    var L = R, W = A, P = function() {
      var H = this, J = H.$createElement, X = H._self._c || J;
      return X("div", {
        style: {
          height: H.height + "px"
        }
      }, [X("div", {
        class: H.cls,
        style: H.style
      }, [H._t("default")], 2)]);
    }, k = [], Y = void 0, V = void 0, I = void 0, D = !1, z = L({
      render: P,
      staticRenderFns: k
    }, Y, W, V, D, I, void 0, void 0), q = function B(H) {
      B.installed || H.component(z.name, z);
    };
    typeof window != "undefined" && window.Vue && q(window.Vue);
    var Z = {
      headroom: z,
      install: q
    };
    return Z;
  });
})(Irt);
const Rrt = te({
  i18n: Hn,
  name: "GenericHeader",
  components: {
    BModal: L_,
    BPopover: oC,
    BrandExpansion: Q_,
    headroom: $d.headroom,
    Fa: ar,
    FollowUsPopover: c2
  },
  props: {
    /**
     * CSS position of the header. Can be <em>absolute</em>, <em>relative</em>, <em>static</em> or <em>fixed</em> (default).
     */
    position: {
      type: String,
      default: "fixed"
    },
    /**
     * Disable Headroom for hiding header until needed.
     */
    noHeadroom: {
      type: Boolean
    },
    /**
     * Target link of the ICIJ logo and project name.
     */
    homeUrl: {
      type: String,
      default: () => he.get("app.home")
    },
    /**
     * Default options to pass to the brand component
     */
    brandOptions: {
      type: Object,
      default: () => ({})
    },
    /**
     * Target link of the donate button.
     */
    donateUrl: {
      type: String,
      default: () => he.get("app.donate-url")
    }
  },
  data() {
    return {
      showFollowUsPopover: !1,
      collapseNavbar: !0,
      shortMode: da.Short,
      longMode: da.Long
    };
  },
  computed: {
    rootElement() {
      return this.noHeadroom ? "div" : "headroom";
    },
    appliedBrandOptions() {
      return Object.assign(this.defaultBrandOptions, this.brandOptions);
    },
    defaultBrandOptions() {
      return {
        noBorder: !0,
        size: 50,
        color: "white",
        background: "#A10207"
      };
    }
  },
  beforeMount() {
    Br.add(_$.faBars);
  },
  methods: {
    closeFollowUsPopover() {
      this.showFollowUsPopover = !1;
    },
    toggleNavbar() {
      this.collapseNavbar = !this.collapseNavbar, this.$root.$emit("bv::hide::popover"), this.$root.$emit("bv::hide::dropdwon");
    }
  }
});
var Lrt = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", [n(e.rootElement, { tag: "component", staticClass: "navbar navbar-expand-lg navbar-light generic-header", class: { "headroom--frozen": !e.collapseNavbar, "generic-header--collapsed": e.collapseNavbar }, style: { position: e.position }, attrs: { id: "generic-header", "data-turbolinks-permanent": "", offset: 100, "z-index": 1020, "on-unpin": e.closeFollowUsPopover } }, [e._t("brand", function() {
    return [n("a", { staticClass: "navbar-brand generic-header__brand", attrs: { href: e.homeUrl } }, [n("brand-expansion", { staticClass: "d-inline-block d-sm-none", attrs: { size: 45, mode: e.shortMode } }), n("brand-expansion", { staticClass: "d-none d-sm-inline-block", attrs: { size: 45, mode: e.longMode } }), n("span", { staticClass: "sr-only" }, [e._v("International Consortium of Investigative Journalists")])], 1)];
  }), n("button", { staticClass: "navbar-toggler border-0", attrs: { type: "button", "aria-label": "Toggle navigation" }, on: { click: e.toggleNavbar } }, [n("fa", { staticClass: "text-primary", attrs: { icon: "bars", size: "xl" } })], 1), n("div", { staticClass: "navbar-collapse", class: { collapse: e.collapseNavbar } }, [n("ul", { staticClass: "navbar-nav ml-auto" }, [n("li", { staticClass: "nav-item" }, [n("a", { staticClass: "nav-link text-uppercase", attrs: { href: "https://www.icij.org/investigations/", target: "_blank" } }, [e._v(" " + e._s(e.$t("generic-header.navbar.investigations")) + " ")])]), n("li", { staticClass: "nav-item" }, [n("a", { staticClass: "nav-link text-uppercase", attrs: { href: "https://www.icij.org/leak/", target: "_blank" } }, [e._v(" " + e._s(e.$t("generic-header.navbar.leak")) + " ")])]), n("li", { staticClass: "nav-item" }, [n("a", { staticClass: "nav-link text-uppercase", attrs: { id: "follow-us-toggler" } }, [e._v(" " + e._s(e.$t("generic-header.navbar.follow")) + " ")])]), n("li", { staticClass: "nav-item mr-lg-3" }, [e._t("donate-link", function() {
    return [n("a", { staticClass: "text-uppercase btn btn-primary font-weight-bold", attrs: { target: "_blank", href: e.donateUrl } }, [e._v(" " + e._s(e.$t("generic-header.navbar.support")) + " ")])];
  })], 2)]), n("b-popover", { ref: "followUsPopover", attrs: { id: "follow-us-popover", container: "generic-header", target: "follow-us-toggler", placement: "bottomleft", show: e.showFollowUsPopover }, on: { "update:show": function(r) {
    e.showFollowUsPopover = r;
  } } }, [n("follow-us-popover", { attrs: { show: e.showFollowUsPopover }, on: { "update:show": function(r) {
    e.showFollowUsPopover = r;
  } } })], 1)], 1)], 2)], 1);
}, Drt = [], Frt = /* @__PURE__ */ Bt(
  Rrt,
  Lrt,
  Drt,
  !1,
  null,
  null,
  null,
  null
);
const zrt = Frt.exports;
var b$ = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "globe", r = 512, i = 512, a = [127760], o = "f0ac", s = "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 21 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faGlobe = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(b$);
var Brt = Da, Hrt = Au, jrt = Oa;
function Vrt(t) {
  return function(e, n, r) {
    var i = Object(e);
    if (!Hrt(e)) {
      var a = Brt(n);
      e = jrt(e), n = function(s) {
        return a(i[s], s, i);
      };
    }
    var o = t(e, n, r);
    return o > -1 ? i[a ? e[o] : o] : void 0;
  };
}
var Wrt = Vrt;
function Urt(t, e, n, r) {
  for (var i = t.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i; )
    if (e(t[a], a, t))
      return a;
  return -1;
}
var y$ = Urt, Yrt = /\s/;
function qrt(t) {
  for (var e = t.length; e-- && Yrt.test(t.charAt(e)); )
    ;
  return e;
}
var Grt = qrt, Krt = Grt, Xrt = /^\s+/;
function Zrt(t) {
  return t && t.slice(0, Krt(t) + 1).replace(Xrt, "");
}
var Jrt = Zrt, Qrt = Jrt, p8 = bu, tit = _u, m8 = 0 / 0, eit = /^[-+]0x[0-9a-f]+$/i, nit = /^0b[01]+$/i, rit = /^0o[0-7]+$/i, iit = parseInt;
function ait(t) {
  if (typeof t == "number")
    return t;
  if (tit(t))
    return m8;
  if (p8(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = p8(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = Qrt(t);
  var n = nit.test(t);
  return n || rit.test(t) ? iit(t.slice(2), n ? 2 : 8) : eit.test(t) ? m8 : +t;
}
var oit = ait, sit = oit, g8 = 1 / 0, uit = 17976931348623157e292;
function lit(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = sit(t), t === g8 || t === -g8) {
    var e = t < 0 ? -1 : 1;
    return e * uit;
  }
  return t === t ? t : 0;
}
var cit = lit, fit = cit;
function hit(t) {
  var e = fit(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var dit = hit, pit = y$, mit = Da, git = dit, vit = Math.max;
function _it(t, e, n) {
  var r = t == null ? 0 : t.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : git(n);
  return i < 0 && (i = vit(r + i, 0)), pit(t, mit(e), i);
}
var w$ = _it, bit = Wrt, yit = w$, wit = bit(yit), ac = wit;
const xit = te({
  i18n: Hn,
  name: "ImddbHeader",
  components: {
    BDropdownItem: MW,
    BModal: L_,
    BNavItemDropdown: RU,
    BPopover: oC,
    headroom: $d.headroom,
    FollowUsPopover: c2,
    Fa: ar
  },
  props: {
    /**
     * CSS position of the header. Can be <em>absolute</em>, <em>relative</em>, <em>static</em> or <em>fixed</em> (default).
     */
    position: {
      type: String,
      default: "fixed"
    },
    /**
     * Disable Headroom for hiding header until needed.
     */
    noHeadroom: {
      type: Boolean
    },
    /**
     * Project name, to display next to ICIJ logo
     */
    project: {
      type: String,
      default: () => he.get("project.name")
    },
    /**
     * App name, to display next to project name
     */
    title: {
      type: String,
      default: () => he.get("app.name")
    },
    /**
     * An array of objects defining dropdown items. Each item defines a <em>label</em> and a <em>href</em>.
     */
    dropdownItems: {
      type: Array,
      default: () => he.get("imddb-header.dropdown.items")
    },
    /**
     * Target link of the ICIJ logo and project name.
     */
    homeUrl: {
      type: String,
      default: () => he.get("app.home")
    },
    /**
     * Target link of the donate button.
     */
    donateUrl: {
      type: String,
      default: () => he.get("app.donate-url")
    }
  },
  data() {
    return {
      showFollowUsPopover: !1,
      collapseNavbar: !0,
      languages: []
    };
  },
  computed: {
    rootElement() {
      return this.noHeadroom ? "div" : "headroom";
    },
    hasLanguagesDropdown() {
      return !!this.languages.length;
    },
    currentLanguage() {
      return He(ac(this.languages, { active: !0 }), "label", "Language");
    }
  },
  beforeMount() {
    Br.add(b$.faGlobe);
  },
  mounted() {
    this.setLanguages(he.get("imddb-header.languages.items"));
  },
  methods: {
    closeFollowUsPopover() {
      this.showFollowUsPopover = !1;
    },
    toggleNavbar() {
      this.collapseNavbar = !this.collapseNavbar, this.$root.$emit("bv::hide::popover"), this.$root.$emit("bv::hide::dropdwon");
    },
    setLanguages(t = []) {
      this.$set(this, "languages", t);
    }
  }
}), Cit = "data:image/png;base64,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";
var $it = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", [n(e.rootElement, { tag: "component", staticClass: "navbar navbar-expand-lg navbar-light imddb-header", class: { "headroom--frozen": !e.collapseNavbar }, style: { position: e.position }, attrs: { id: "imddb-header", "data-turbolinks-permanent": "", offset: 100, "z-index": 1020, "on-unpin": e.closeFollowUsPopover } }, [e._t("brand", function() {
    return [n("a", { staticClass: "navbar-brand imddb-header__brand", attrs: { href: e.homeUrl } }, [n("img", { staticClass: "mr-3", attrs: { src: Cit, height: "25" } }), e._v(" " + e._s(e.project) + " ")])];
  }), n("button", { staticClass: "navbar-toggler", attrs: { type: "button", "aria-label": "Toggle navigation" }, on: { click: e.toggleNavbar } }, [n("span", { staticClass: "navbar-toggler-icon" })]), n("div", { staticClass: "navbar-collapse", class: { collapse: e.collapseNavbar } }, [n("div", { staticClass: "imddb-header__site-switch mr-auto" }, [e._t("navbar", function() {
    return [n("ul", { staticClass: "navbar-nav" }, [n("b-nav-item-dropdown", { on: { show: function(r) {
      return e.$root.$emit("bv::hide::popover");
    } } }, [n("template", { slot: "button-content" }, [e._v(" " + e._s(e.title) + " ")]), e._l(e.dropdownItems, function(r, i) {
      return n("b-dropdown-item", e._b({ key: i, attrs: { href: r.href } }, "b-dropdown-item", { active: !!r.active }, !1), [e._v(" " + e._s(r.label) + " ")]);
    })], 2)], 1)];
  })], 2), n("ul", { staticClass: "navbar-nav" }, [e.hasLanguagesDropdown ? n("li", { staticClass: "nav-item" }, [n("b-nav-item-dropdown", { on: { show: function(r) {
    return e.$root.$emit("bv::hide::popover");
  } } }, [n("template", { slot: "button-content" }, [n("fa", { attrs: { icon: "globe" } }), e._v(" " + e._s(e.currentLanguage) + " ")], 1), e._l(e.languages, function(r, i) {
    return n("b-dropdown-item", e._b({ key: i, attrs: { href: r.href } }, "b-dropdown-item", { active: !!r.active }, !1), [e._v(" " + e._s(r.label) + " ")]);
  })], 2)], 1) : e._e(), n("li", { staticClass: "nav-item" }, [n("a", { staticClass: "nav-link", attrs: { href: "https://www.icij.org/leak/", target: "_blank" } }, [e._v(" " + e._s(e.$t("imddb-header.navbar.leak")) + " ")])]), n("li", { staticClass: "nav-item mr-lg-3" }, [e._t("donate-link", function() {
    return [n("a", { staticClass: "nav-link", attrs: { target: "_blank", href: e.donateUrl } }, [e._v(" " + e._s(e.$t("imddb-header.navbar.support")) + " ")])];
  })], 2), n("li", { staticClass: "nav-item" }, [n("button", { staticClass: "btn btn-primary btn-block font-weight-bold", attrs: { id: "follow-icij" } }, [e._v(" " + e._s(e.$t("imddb-header.navbar.follow")) + " ")]), n("b-popover", { attrs: { container: "imddb-header", target: "follow-icij", placement: "bottomleft", show: e.showFollowUsPopover }, on: { "update:show": function(r) {
    e.showFollowUsPopover = r;
  } } }, [n("follow-us-popover", { attrs: { show: e.showFollowUsPopover }, on: { "update:show": function(r) {
    e.showFollowUsPopover = r;
  } } })], 1)], 1)])])], 2)], 1);
}, Tit = [], Oit = /* @__PURE__ */ Bt(
  xit,
  $it,
  Tit,
  !1,
  null,
  null,
  null,
  null
);
const Sit = Oit.exports;
function Qe(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function t1(t) {
  let e = t, n = t, r = t;
  t.length === 1 && (e = (s, l) => t(s) - l, n = Qe, r = (s, l) => Qe(t(s), l));
  function i(s, l, c = 0, h = s.length) {
    if (c < h) {
      if (n(l, l) !== 0)
        return h;
      do {
        const d = c + h >>> 1;
        r(s[d], l) < 0 ? c = d + 1 : h = d;
      } while (c < h);
    }
    return c;
  }
  function a(s, l, c = 0, h = s.length) {
    if (c < h) {
      if (n(l, l) !== 0)
        return h;
      do {
        const d = c + h >>> 1;
        r(s[d], l) <= 0 ? c = d + 1 : h = d;
      } while (c < h);
    }
    return c;
  }
  function o(s, l, c = 0, h = s.length) {
    const d = i(s, l, c, h - 1);
    return d > c && e(s[d - 1], l) > -e(s[d], l) ? d - 1 : d;
  }
  return { left: i, center: o, right: a };
}
function x$(t) {
  return t === null ? NaN : +t;
}
function* Eit(t, e) {
  if (e === void 0)
    for (let n of t)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of t)
      (r = e(r, ++n, t)) != null && (r = +r) >= r && (yield r);
  }
}
const C$ = t1(Qe), $$ = C$.right, Ait = C$.left, Pit = t1(x$).center, Bo = $$;
function e1(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      r != null && (r = +r) >= r && ++n;
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (i = +i) >= i && ++n;
  }
  return n;
}
function Mit(t) {
  return t.length | 0;
}
function kit(t) {
  return !(t > 0);
}
function Nit(t) {
  return typeof t != "object" || "length" in t ? t : Array.from(t);
}
function Iit(t) {
  return (e) => t(...e);
}
function Rit(...t) {
  const e = typeof t[t.length - 1] == "function" && Iit(t.pop());
  t = t.map(Nit);
  const n = t.map(Mit), r = t.length - 1, i = new Array(r + 1).fill(0), a = [];
  if (r < 0 || n.some(kit))
    return a;
  for (; ; ) {
    a.push(i.map((s, l) => t[l][s]));
    let o = r;
    for (; ++i[o] === n[o]; ) {
      if (o === 0)
        return e ? a.map(e) : a;
      i[o--] = 0;
    }
  }
}
function Lit(t, e) {
  var n = 0, r = 0;
  return Float64Array.from(t, e === void 0 ? (i) => n += +i || 0 : (i) => n += +e(i, r++, t) || 0);
}
function Dit(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function T$(t, e) {
  let n = 0, r, i = 0, a = 0;
  if (e === void 0)
    for (let o of t)
      o != null && (o = +o) >= o && (r = o - i, i += r / ++n, a += r * (o - i));
  else {
    let o = -1;
    for (let s of t)
      (s = e(s, ++o, t)) != null && (s = +s) >= s && (r = s - i, i += r / ++n, a += r * (s - i));
  }
  if (n > 1)
    return a / (n - 1);
}
function O$(t, e) {
  const n = T$(t, e);
  return n && Math.sqrt(n);
}
function zl(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
class Ie {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(e) {
    const n = this._partials;
    let r = 0;
    for (let i = 0; i < this._n && i < 32; i++) {
      const a = n[i], o = e + a, s = Math.abs(e) < Math.abs(a) ? e - (o - a) : a - (o - e);
      s && (n[r++] = s), e = o;
    }
    return n[r] = e, this._n = r + 1, this;
  }
  valueOf() {
    const e = this._partials;
    let n = this._n, r, i, a, o = 0;
    if (n > 0) {
      for (o = e[--n]; n > 0 && (r = o, i = e[--n], o = r + i, a = i - (o - r), !a); )
        ;
      n > 0 && (a < 0 && e[n - 1] < 0 || a > 0 && e[n - 1] > 0) && (i = a * 2, r = o + i, i == r - o && (o = r));
    }
    return o;
  }
}
function Fit(t, e) {
  const n = new Ie();
  if (e === void 0)
    for (let r of t)
      (r = +r) && n.add(r);
  else {
    let r = -1;
    for (let i of t)
      (i = +e(i, ++r, t)) && n.add(i);
  }
  return +n;
}
function zit(t, e) {
  const n = new Ie();
  let r = -1;
  return Float64Array.from(
    t,
    e === void 0 ? (i) => n.add(+i || 0) : (i) => n.add(+e(i, ++r, t) || 0)
  );
}
class oc extends Map {
  constructor(e, n = A$) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null)
      for (const [r, i] of e)
        this.set(r, i);
  }
  get(e) {
    return super.get(nv(this, e));
  }
  has(e) {
    return super.has(nv(this, e));
  }
  set(e, n) {
    return super.set(S$(this, e), n);
  }
  delete(e) {
    return super.delete(E$(this, e));
  }
}
class So extends Set {
  constructor(e, n = A$) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null)
      for (const r of e)
        this.add(r);
  }
  has(e) {
    return super.has(nv(this, e));
  }
  add(e) {
    return super.add(S$(this, e));
  }
  delete(e) {
    return super.delete(E$(this, e));
  }
}
function nv({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : n;
}
function S$({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : (t.set(r, n), n);
}
function E$({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) && (n = t.get(r), t.delete(r)), n;
}
function A$(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function nu(t) {
  return t;
}
function P$(t, ...e) {
  return Nu(t, nu, nu, e);
}
function M$(t, ...e) {
  return Nu(t, Array.from, nu, e);
}
function k$(t, e) {
  for (let n = 1, r = e.length; n < r; ++n)
    t = t.flatMap((i) => i.pop().map(([a, o]) => [...i, a, o]));
  return t;
}
function Bit(t, ...e) {
  return k$(M$(t, ...e), e);
}
function Hit(t, e, ...n) {
  return k$(I$(t, e, ...n), n);
}
function N$(t, e, ...n) {
  return Nu(t, nu, e, n);
}
function I$(t, e, ...n) {
  return Nu(t, Array.from, e, n);
}
function jit(t, ...e) {
  return Nu(t, nu, R$, e);
}
function Vit(t, ...e) {
  return Nu(t, Array.from, R$, e);
}
function R$(t) {
  if (t.length !== 1)
    throw new Error("duplicate key");
  return t[0];
}
function Nu(t, e, n, r) {
  return function i(a, o) {
    if (o >= r.length)
      return n(a);
    const s = new oc(), l = r[o++];
    let c = -1;
    for (const h of a) {
      const d = l(h, ++c, a), p = s.get(d);
      p ? p.push(h) : s.set(d, [h]);
    }
    for (const [h, d] of s)
      s.set(h, i(d, o));
    return e(s);
  }(t, 0);
}
function L$(t, e) {
  return Array.from(e, (n) => t[n]);
}
function rv(t, ...e) {
  if (typeof t[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  t = Array.from(t);
  let [n] = e;
  if (n && n.length === 1 || e.length > 1) {
    const r = Uint32Array.from(t, (i, a) => a);
    return e.length > 1 ? (e = e.map((i) => t.map(i)), r.sort((i, a) => {
      for (const o of e) {
        const s = Dh(o[i], o[a]);
        if (s)
          return s;
      }
    })) : (n = t.map(n), r.sort((i, a) => Dh(n[i], n[a]))), L$(t, r);
  }
  return t.sort(n === void 0 ? Dh : D$(n));
}
function D$(t) {
  if (typeof t != "function")
    throw new TypeError("compare is not a function");
  return (e, n) => {
    const r = t(e, n);
    return r || r === 0 ? r : (t(n, n) === 0) - (t(e, e) === 0);
  };
}
function Dh(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
function Wit(t, e, n) {
  return (e.length === 1 ? rv(N$(t, e, n), ([r, i], [a, o]) => Qe(i, o) || Qe(r, a)) : rv(P$(t, n), ([r, i], [a, o]) => e(i, o) || Qe(r, a))).map(([r]) => r);
}
var Uit = Array.prototype, Yit = Uit.slice;
function ah(t) {
  return () => t;
}
var iv = Math.sqrt(50), av = Math.sqrt(10), ov = Math.sqrt(2);
function sc(t, e, n) {
  var r, i = -1, a, o, s;
  if (e = +e, t = +t, n = +n, t === e && n > 0)
    return [t];
  if ((r = e < t) && (a = t, t = e, e = a), (s = Dc(t, e, n)) === 0 || !isFinite(s))
    return [];
  if (s > 0) {
    let l = Math.round(t / s), c = Math.round(e / s);
    for (l * s < t && ++l, c * s > e && --c, o = new Array(a = c - l + 1); ++i < a; )
      o[i] = (l + i) * s;
  } else {
    s = -s;
    let l = Math.round(t * s), c = Math.round(e * s);
    for (l / s < t && ++l, c / s > e && --c, o = new Array(a = c - l + 1); ++i < a; )
      o[i] = (l + i) / s;
  }
  return r && o.reverse(), o;
}
function Dc(t, e, n) {
  var r = (e - t) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), a = r / Math.pow(10, i);
  return i >= 0 ? (a >= iv ? 10 : a >= av ? 5 : a >= ov ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= iv ? 10 : a >= av ? 5 : a >= ov ? 2 : 1);
}
function Td(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), a = r / i;
  return a >= iv ? i *= 10 : a >= av ? i *= 5 : a >= ov && (i *= 2), e < t ? -i : i;
}
function F$(t, e, n) {
  let r;
  for (; ; ) {
    const i = Dc(t, e, n);
    if (i === r || i === 0 || !isFinite(i))
      return [t, e];
    i > 0 ? (t = Math.floor(t / i) * i, e = Math.ceil(e / i) * i) : i < 0 && (t = Math.ceil(t * i) / i, e = Math.floor(e * i) / i), r = i;
  }
}
function z$(t) {
  return Math.ceil(Math.log(e1(t)) / Math.LN2) + 1;
}
function v8() {
  var t = nu, e = zl, n = z$;
  function r(i) {
    Array.isArray(i) || (i = Array.from(i));
    var a, o = i.length, s, l = new Array(o);
    for (a = 0; a < o; ++a)
      l[a] = t(i[a], a, i);
    var c = e(l), h = c[0], d = c[1], p = n(l, h, d);
    if (!Array.isArray(p)) {
      const _ = d, w = +p;
      if (e === zl && ([h, d] = F$(h, d, w)), p = sc(h, d, w), p[p.length - 1] >= d)
        if (_ >= d && e === zl) {
          const x = Dc(h, d, w);
          isFinite(x) && (x > 0 ? d = (Math.floor(d / x) + 1) * x : x < 0 && (d = (Math.ceil(d * -x) + 1) / -x));
        } else
          p.pop();
    }
    for (var g = p.length; p[0] <= h; )
      p.shift(), --g;
    for (; p[g - 1] > d; )
      p.pop(), --g;
    var v = new Array(g + 1), b;
    for (a = 0; a <= g; ++a)
      b = v[a] = [], b.x0 = a > 0 ? p[a - 1] : h, b.x1 = a < g ? p[a] : d;
    for (a = 0; a < o; ++a)
      s = l[a], s != null && h <= s && s <= d && v[Bo(p, s, 0, g)].push(i[a]);
    return v;
  }
  return r.value = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ah(i), r) : t;
  }, r.domain = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ah([i[0], i[1]]), r) : e;
  }, r.thresholds = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Array.isArray(i) ? ah(Yit.call(i)) : ah(i), r) : n;
  }, r;
}
function Sa(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function Od(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n > i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function f2(t, e, n = 0, r = t.length - 1, i) {
  for (i = i === void 0 ? Dh : D$(i); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = e - n + 1, h = Math.log(l), d = 0.5 * Math.exp(2 * h / 3), p = 0.5 * Math.sqrt(h * d * (l - d) / l) * (c - l / 2 < 0 ? -1 : 1), g = Math.max(n, Math.floor(e - c * d / l + p)), v = Math.min(r, Math.floor(e + (l - c) * d / l + p));
      f2(t, e, g, v, i);
    }
    const a = t[e];
    let o = n, s = r;
    for (ul(t, n, e), i(t[r], a) > 0 && ul(t, n, r); o < s; ) {
      for (ul(t, o, s), ++o, --s; i(t[o], a) < 0; )
        ++o;
      for (; i(t[s], a) > 0; )
        --s;
    }
    i(t[n], a) === 0 ? ul(t, n, s) : (++s, ul(t, s, r)), s <= e && (n = s + 1), e <= s && (r = s - 1);
  }
  return t;
}
function ul(t, e, n) {
  const r = t[e];
  t[e] = t[n], t[n] = r;
}
function uc(t, e, n) {
  if (t = Float64Array.from(Eit(t, n)), !!(r = t.length)) {
    if ((e = +e) <= 0 || r < 2)
      return Od(t);
    if (e >= 1)
      return Sa(t);
    var r, i = (r - 1) * e, a = Math.floor(i), o = Sa(f2(t, a).subarray(0, a + 1)), s = Od(t.subarray(a + 1));
    return o + (s - o) * (i - a);
  }
}
function B$(t, e, n = x$) {
  if (r = t.length) {
    if ((e = +e) <= 0 || r < 2)
      return +n(t[0], 0, t);
    if (e >= 1)
      return +n(t[r - 1], r - 1, t);
    var r, i = (r - 1) * e, a = Math.floor(i), o = +n(t[a], a, t), s = +n(t[a + 1], a + 1, t);
    return o + (s - o) * (i - a);
  }
}
function qit(t, e, n) {
  return Math.ceil((n - e) / (2 * (uc(t, 0.75) - uc(t, 0.25)) * Math.pow(e1(t), -1 / 3)));
}
function Git(t, e, n) {
  return Math.ceil((n - e) / (3.5 * O$(t) * Math.pow(e1(t), -1 / 3)));
}
function H$(t, e) {
  let n, r = -1, i = -1;
  if (e === void 0)
    for (const a of t)
      ++i, a != null && (n < a || n === void 0 && a >= a) && (n = a, r = i);
  else
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n < a || n === void 0 && a >= a) && (n = a, r = i);
  return r;
}
function Kit(t, e) {
  let n = 0, r = 0;
  if (e === void 0)
    for (let i of t)
      i != null && (i = +i) >= i && (++n, r += i);
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (a = +a) >= a && (++n, r += a);
  }
  if (n)
    return r / n;
}
function Xit(t, e) {
  return uc(t, 0.5, e);
}
function* Zit(t) {
  for (const e of t)
    yield* e;
}
function h2(t) {
  return Array.from(Zit(t));
}
function j$(t, e) {
  let n, r = -1, i = -1;
  if (e === void 0)
    for (const a of t)
      ++i, a != null && (n > a || n === void 0 && a >= a) && (n = a, r = i);
  else
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n > a || n === void 0 && a >= a) && (n = a, r = i);
  return r;
}
function Jit(t, e) {
  const n = new oc();
  if (e === void 0)
    for (let a of t)
      a != null && a >= a && n.set(a, (n.get(a) || 0) + 1);
  else {
    let a = -1;
    for (let o of t)
      (o = e(o, ++a, t)) != null && o >= o && n.set(o, (n.get(o) || 0) + 1);
  }
  let r, i = 0;
  for (const [a, o] of n)
    o > i && (i = o, r = a);
  return r;
}
function Qit(t, e = tat) {
  const n = [];
  let r, i = !1;
  for (const a of t)
    i && n.push(e(r, a)), r = a, i = !0;
  return n;
}
function tat(t, e) {
  return [t, e];
}
function ei(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = t + r * n;
  return a;
}
function eat(t, e = Qe) {
  let n, r = !1;
  if (e.length === 1) {
    let i;
    for (const a of t) {
      const o = e(a);
      (r ? Qe(o, i) < 0 : Qe(o, o) === 0) && (n = a, i = o, r = !0);
    }
  } else
    for (const i of t)
      (r ? e(i, n) < 0 : e(i, i) === 0) && (n = i, r = !0);
  return n;
}
function V$(t, e = Qe) {
  if (e.length === 1)
    return j$(t, e);
  let n, r = -1, i = -1;
  for (const a of t)
    ++i, (r < 0 ? e(a, a) === 0 : e(a, n) < 0) && (n = a, r = i);
  return r;
}
function nat(t, e = Qe) {
  let n, r = !1;
  if (e.length === 1) {
    let i;
    for (const a of t) {
      const o = e(a);
      (r ? Qe(o, i) > 0 : Qe(o, o) === 0) && (n = a, i = o, r = !0);
    }
  } else
    for (const i of t)
      (r ? e(i, n) > 0 : e(i, i) === 0) && (n = i, r = !0);
  return n;
}
function rat(t, e = Qe) {
  if (e.length === 1)
    return H$(t, e);
  let n, r = -1, i = -1;
  for (const a of t)
    ++i, (r < 0 ? e(a, a) === 0 : e(a, n) > 0) && (n = a, r = i);
  return r;
}
function iat(t, e) {
  const n = V$(t, e);
  return n < 0 ? void 0 : n;
}
const aat = W$(Math.random);
function W$(t) {
  return function(n, r = 0, i = n.length) {
    let a = i - (r = +r);
    for (; a; ) {
      const o = t() * a-- | 0, s = n[a + r];
      n[a + r] = n[o + r], n[o + r] = s;
    }
    return n;
  };
}
function d2(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      (r = +r) && (n += r);
  else {
    let r = -1;
    for (let i of t)
      (i = +e(i, ++r, t)) && (n += i);
  }
  return n;
}
function U$(t) {
  if (!(a = t.length))
    return [];
  for (var e = -1, n = Od(t, oat), r = new Array(n); ++e < n; )
    for (var i = -1, a, o = r[e] = new Array(a); ++i < a; )
      o[i] = t[i][e];
  return r;
}
function oat(t) {
  return t.length;
}
function sat() {
  return U$(arguments);
}
function uat(t, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  let n = -1;
  for (const r of t)
    if (!e(r, ++n, t))
      return !1;
  return !0;
}
function lat(t, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  let n = -1;
  for (const r of t)
    if (e(r, ++n, t))
      return !0;
  return !1;
}
function cat(t, e) {
  if (typeof e != "function")
    throw new TypeError("test is not a function");
  const n = [];
  let r = -1;
  for (const i of t)
    e(i, ++r, t) && n.push(i);
  return n;
}
function fat(t, e) {
  if (typeof t[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  if (typeof e != "function")
    throw new TypeError("mapper is not a function");
  return Array.from(t, (n, r) => e(n, r, t));
}
function hat(t, e, n) {
  if (typeof e != "function")
    throw new TypeError("reducer is not a function");
  const r = t[Symbol.iterator]();
  let i, a, o = -1;
  if (arguments.length < 3) {
    if ({ done: i, value: n } = r.next(), i)
      return;
    ++o;
  }
  for (; { done: i, value: a } = r.next(), !i; )
    n = e(n, a, ++o, t);
  return n;
}
function dat(t) {
  if (typeof t[Symbol.iterator] != "function")
    throw new TypeError("values is not iterable");
  return Array.from(t).reverse();
}
function pat(t, ...e) {
  t = new So(t);
  for (const n of e)
    for (const r of n)
      t.delete(r);
  return t;
}
function mat(t, e) {
  const n = e[Symbol.iterator](), r = new So();
  for (const i of t) {
    if (r.has(i))
      return !1;
    let a, o;
    for (; ({ value: a, done: o } = n.next()) && !o; ) {
      if (Object.is(i, a))
        return !1;
      r.add(a);
    }
  }
  return !0;
}
function gat(t, ...e) {
  t = new So(t), e = e.map(vat);
  t:
    for (const n of t)
      for (const r of e)
        if (!r.has(n)) {
          t.delete(n);
          continue t;
        }
  return t;
}
function vat(t) {
  return t instanceof So ? t : new So(t);
}
function Y$(t, e) {
  const n = t[Symbol.iterator](), r = /* @__PURE__ */ new Set();
  for (const i of e) {
    const a = _8(i);
    if (r.has(a))
      continue;
    let o, s;
    for (; { value: o, done: s } = n.next(); ) {
      if (s)
        return !1;
      const l = _8(o);
      if (r.add(l), Object.is(a, l))
        break;
    }
  }
  return !0;
}
function _8(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function _at(t, e) {
  return Y$(e, t);
}
function bat(...t) {
  const e = new So();
  for (const n of t)
    for (const r of n)
      e.add(r);
  return e;
}
function yat(t) {
  return t;
}
var Fh = 1, zh = 2, sv = 3, yl = 4, b8 = 1e-6;
function wat(t) {
  return "translate(" + t + ",0)";
}
function xat(t) {
  return "translate(0," + t + ")";
}
function Cat(t) {
  return (e) => +t(e);
}
function $at(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function Tat() {
  return !this.__axis;
}
function n1(t, e) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, l = typeof window != "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, c = t === Fh || t === yl ? -1 : 1, h = t === yl || t === zh ? "x" : "y", d = t === Fh || t === sv ? wat : xat;
  function p(g) {
    var v = r == null ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r, b = i == null ? e.tickFormat ? e.tickFormat.apply(e, n) : yat : i, _ = Math.max(a, 0) + s, w = e.range(), x = +w[0] + l, C = +w[w.length - 1] + l, $ = (e.bandwidth ? $at : Cat)(e.copy(), l), E = g.selection ? g.selection() : g, A = E.selectAll(".domain").data([null]), R = E.selectAll(".tick").data(v, e).order(), L = R.exit(), W = R.enter().append("g").attr("class", "tick"), P = R.select("line"), k = R.select("text");
    A = A.merge(A.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), R = R.merge(W), P = P.merge(W.append("line").attr("stroke", "currentColor").attr(h + "2", c * a)), k = k.merge(W.append("text").attr("fill", "currentColor").attr(h, c * _).attr("dy", t === Fh ? "0em" : t === sv ? "0.71em" : "0.32em")), g !== E && (A = A.transition(g), R = R.transition(g), P = P.transition(g), k = k.transition(g), L = L.transition(g).attr("opacity", b8).attr("transform", function(Y) {
      return isFinite(Y = $(Y)) ? d(Y + l) : this.getAttribute("transform");
    }), W.attr("opacity", b8).attr("transform", function(Y) {
      var V = this.parentNode.__axis;
      return d((V && isFinite(V = V(Y)) ? V : $(Y)) + l);
    })), L.remove(), A.attr("d", t === yl || t === zh ? o ? "M" + c * o + "," + x + "H" + l + "V" + C + "H" + c * o : "M" + l + "," + x + "V" + C : o ? "M" + x + "," + c * o + "V" + l + "H" + C + "V" + c * o : "M" + x + "," + l + "H" + C), R.attr("opacity", 1).attr("transform", function(Y) {
      return d($(Y) + l);
    }), P.attr(h + "2", c * a), k.attr(h, c * _).text(b), E.filter(Tat).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === zh ? "start" : t === yl ? "end" : "middle"), E.each(function() {
      this.__axis = $;
    });
  }
  return p.scale = function(g) {
    return arguments.length ? (e = g, p) : e;
  }, p.ticks = function() {
    return n = Array.from(arguments), p;
  }, p.tickArguments = function(g) {
    return arguments.length ? (n = g == null ? [] : Array.from(g), p) : n.slice();
  }, p.tickValues = function(g) {
    return arguments.length ? (r = g == null ? null : Array.from(g), p) : r && r.slice();
  }, p.tickFormat = function(g) {
    return arguments.length ? (i = g, p) : i;
  }, p.tickSize = function(g) {
    return arguments.length ? (a = o = +g, p) : a;
  }, p.tickSizeInner = function(g) {
    return arguments.length ? (a = +g, p) : a;
  }, p.tickSizeOuter = function(g) {
    return arguments.length ? (o = +g, p) : o;
  }, p.tickPadding = function(g) {
    return arguments.length ? (s = +g, p) : s;
  }, p.offset = function(g) {
    return arguments.length ? (l = +g, p) : l;
  }, p;
}
function Oat(t) {
  return n1(Fh, t);
}
function Sat(t) {
  return n1(zh, t);
}
function r1(t) {
  return n1(sv, t);
}
function i1(t) {
  return n1(yl, t);
}
var Eat = { value: () => {
} };
function Ho() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Bh(n);
}
function Bh(t) {
  this._ = t;
}
function Aat(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Bh.prototype = Ho.prototype = {
  constructor: Bh,
  on: function(t, e) {
    var n = this._, r = Aat(t + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; )
        if ((i = (t = r[a]).type) && (i = Pat(n[i], t.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++a < o; )
      if (i = (t = r[a]).type)
        n[i] = y8(n[i], t.name, e);
      else if (e == null)
        for (i in n)
          n[i] = y8(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e)
      t[n] = e[n].slice();
    return new Bh(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, a; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (a = this._[t], r = 0, i = a.length; r < i; ++r)
      a[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, a = r.length; i < a; ++i)
      r[i].value.apply(e, n);
  }
};
function Pat(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function y8(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = Eat, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var uv = "http://www.w3.org/1999/xhtml";
const lv = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: uv,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Fc(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), lv.hasOwnProperty(e) ? { space: lv[e], local: t } : t;
}
function Mat(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === uv && e.documentElement.namespaceURI === uv ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function kat(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function a1(t) {
  var e = Fc(t);
  return (e.local ? kat : Mat)(e);
}
function Nat() {
}
function o1(t) {
  return t == null ? Nat : function() {
    return this.querySelector(t);
  };
}
function Iat(t) {
  typeof t != "function" && (t = o1(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = new Array(o), l, c, h = 0; h < o; ++h)
      (l = a[h]) && (c = t.call(l, l.__data__, h, a)) && ("__data__" in l && (c.__data__ = l.__data__), s[h] = c);
  return new Cn(r, this._parents);
}
function q$(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Rat() {
  return [];
}
function p2(t) {
  return t == null ? Rat : function() {
    return this.querySelectorAll(t);
  };
}
function Lat(t) {
  return function() {
    return q$(t.apply(this, arguments));
  };
}
function Dat(t) {
  typeof t == "function" ? t = Lat(t) : t = p2(t);
  for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = e[a], s = o.length, l, c = 0; c < s; ++c)
      (l = o[c]) && (r.push(t.call(l, l.__data__, c, o)), i.push(l));
  return new Cn(r, i);
}
function m2(t) {
  return function() {
    return this.matches(t);
  };
}
function G$(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Fat = Array.prototype.find;
function zat(t) {
  return function() {
    return Fat.call(this.children, t);
  };
}
function Bat() {
  return this.firstElementChild;
}
function Hat(t) {
  return this.select(t == null ? Bat : zat(typeof t == "function" ? t : G$(t)));
}
var jat = Array.prototype.filter;
function Vat() {
  return Array.from(this.children);
}
function Wat(t) {
  return function() {
    return jat.call(this.children, t);
  };
}
function Uat(t) {
  return this.selectAll(t == null ? Vat : Wat(typeof t == "function" ? t : G$(t)));
}
function Yat(t) {
  typeof t != "function" && (t = m2(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, c = 0; c < o; ++c)
      (l = a[c]) && t.call(l, l.__data__, c, a) && s.push(l);
  return new Cn(r, this._parents);
}
function K$(t) {
  return new Array(t.length);
}
function qat() {
  return new Cn(this._enter || this._groups.map(K$), this._parents);
}
function Sd(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
Sd.prototype = {
  constructor: Sd,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function Gat(t) {
  return function() {
    return t;
  };
}
function Kat(t, e, n, r, i, a) {
  for (var o = 0, s, l = e.length, c = a.length; o < c; ++o)
    (s = e[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new Sd(t, a[o]);
  for (; o < l; ++o)
    (s = e[o]) && (i[o] = s);
}
function Xat(t, e, n, r, i, a, o) {
  var s, l, c = /* @__PURE__ */ new Map(), h = e.length, d = a.length, p = new Array(h), g;
  for (s = 0; s < h; ++s)
    (l = e[s]) && (p[s] = g = o.call(l, l.__data__, s, e) + "", c.has(g) ? i[s] = l : c.set(g, l));
  for (s = 0; s < d; ++s)
    g = o.call(t, a[s], s, a) + "", (l = c.get(g)) ? (r[s] = l, l.__data__ = a[s], c.delete(g)) : n[s] = new Sd(t, a[s]);
  for (s = 0; s < h; ++s)
    (l = e[s]) && c.get(p[s]) === l && (i[s] = l);
}
function Zat(t) {
  return t.__data__;
}
function Jat(t, e) {
  if (!arguments.length)
    return Array.from(this, Zat);
  var n = e ? Xat : Kat, r = this._parents, i = this._groups;
  typeof t != "function" && (t = Gat(t));
  for (var a = i.length, o = new Array(a), s = new Array(a), l = new Array(a), c = 0; c < a; ++c) {
    var h = r[c], d = i[c], p = d.length, g = Qat(t.call(h, h && h.__data__, c, r)), v = g.length, b = s[c] = new Array(v), _ = o[c] = new Array(v), w = l[c] = new Array(p);
    n(h, d, b, _, w, g, e);
    for (var x = 0, C = 0, $, E; x < v; ++x)
      if ($ = b[x]) {
        for (x >= C && (C = x + 1); !(E = _[C]) && ++C < v; )
          ;
        $._next = E || null;
      }
  }
  return o = new Cn(o, r), o._enter = s, o._exit = l, o;
}
function Qat(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function tot() {
  return new Cn(this._exit || this._groups.map(K$), this._parents);
}
function eot(t, e, n) {
  var r = this.enter(), i = this, a = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
function not(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), l = 0; l < o; ++l)
    for (var c = n[l], h = r[l], d = c.length, p = s[l] = new Array(d), g, v = 0; v < d; ++v)
      (g = c[v] || h[v]) && (p[v] = g);
  for (; l < i; ++l)
    s[l] = n[l];
  return new Cn(s, this._parents);
}
function rot() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function iot(t) {
  t || (t = aot);
  function e(d, p) {
    return d && p ? t(d.__data__, p.__data__) : !d - !p;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, l = i[a] = new Array(s), c, h = 0; h < s; ++h)
      (c = o[h]) && (l[h] = c);
    l.sort(e);
  }
  return new Cn(i, this._parents).order();
}
function aot(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function oot() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function sot() {
  return Array.from(this);
}
function uot() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o)
        return o;
    }
  return null;
}
function lot() {
  let t = 0;
  for (const e of this)
    ++t;
  return t;
}
function cot() {
  return !this.node();
}
function fot(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && t.call(s, s.__data__, a, i);
  return this;
}
function hot(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function dot(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function pot(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function mot(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function got(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function vot(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function _ot(t, e) {
  var n = Fc(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? dot : hot : typeof e == "function" ? n.local ? vot : got : n.local ? mot : pot)(n, e));
}
function g2(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function bot(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function yot(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function wot(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function xot(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? bot : typeof e == "function" ? wot : yot)(t, e, n == null ? "" : n)) : Eo(this.node(), t);
}
function Eo(t, e) {
  return t.style.getPropertyValue(e) || g2(t).getComputedStyle(t, null).getPropertyValue(e);
}
function Cot(t) {
  return function() {
    delete this[t];
  };
}
function $ot(t, e) {
  return function() {
    this[t] = e;
  };
}
function Tot(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function Oot(t, e) {
  return arguments.length > 1 ? this.each((e == null ? Cot : typeof e == "function" ? Tot : $ot)(t, e)) : this.node()[t];
}
function X$(t) {
  return t.trim().split(/^|\s+/);
}
function v2(t) {
  return t.classList || new Z$(t);
}
function Z$(t) {
  this._node = t, this._names = X$(t.getAttribute("class") || "");
}
Z$.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function J$(t, e) {
  for (var n = v2(t), r = -1, i = e.length; ++r < i; )
    n.add(e[r]);
}
function Q$(t, e) {
  for (var n = v2(t), r = -1, i = e.length; ++r < i; )
    n.remove(e[r]);
}
function Sot(t) {
  return function() {
    J$(this, t);
  };
}
function Eot(t) {
  return function() {
    Q$(this, t);
  };
}
function Aot(t, e) {
  return function() {
    (e.apply(this, arguments) ? J$ : Q$)(this, t);
  };
}
function Pot(t, e) {
  var n = X$(t + "");
  if (arguments.length < 2) {
    for (var r = v2(this.node()), i = -1, a = n.length; ++i < a; )
      if (!r.contains(n[i]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? Aot : e ? Sot : Eot)(n, e));
}
function Mot() {
  this.textContent = "";
}
function kot(t) {
  return function() {
    this.textContent = t;
  };
}
function Not(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e == null ? "" : e;
  };
}
function Iot(t) {
  return arguments.length ? this.each(t == null ? Mot : (typeof t == "function" ? Not : kot)(t)) : this.node().textContent;
}
function Rot() {
  this.innerHTML = "";
}
function Lot(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Dot(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e == null ? "" : e;
  };
}
function Fot(t) {
  return arguments.length ? this.each(t == null ? Rot : (typeof t == "function" ? Dot : Lot)(t)) : this.node().innerHTML;
}
function zot() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Bot() {
  return this.each(zot);
}
function Hot() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function jot() {
  return this.each(Hot);
}
function Vot(t) {
  var e = typeof t == "function" ? t : a1(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function Wot() {
  return null;
}
function Uot(t, e) {
  var n = typeof t == "function" ? t : a1(t), r = e == null ? Wot : typeof e == "function" ? e : o1(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function Yot() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function qot() {
  return this.each(Yot);
}
function Got() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Kot() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Xot(t) {
  return this.select(t ? Kot : Got);
}
function Zot(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Jot(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function Qot(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function tst(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, a; n < i; ++n)
        a = e[n], (!t.type || a.type === t.type) && a.name === t.name ? this.removeEventListener(a.type, a.listener, a.options) : e[++r] = a;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function est(t, e, n) {
  return function() {
    var r = this.__on, i, a = Jot(e);
    if (r) {
      for (var o = 0, s = r.length; o < s; ++o)
        if ((i = r[o]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, a, n), i = { type: t.type, name: t.name, value: e, listener: a, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function nst(t, e, n) {
  var r = Qot(t + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, c = s.length, h; l < c; ++l)
        for (i = 0, h = s[l]; i < a; ++i)
          if ((o = r[i]).type === h.type && o.name === h.name)
            return h.value;
    }
    return;
  }
  for (s = e ? est : tst, i = 0; i < a; ++i)
    this.each(s(r[i], e, n));
  return this;
}
function tT(t, e, n) {
  var r = g2(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function rst(t, e) {
  return function() {
    return tT(this, t, e);
  };
}
function ist(t, e) {
  return function() {
    return tT(this, t, e.apply(this, arguments));
  };
}
function ast(t, e) {
  return this.each((typeof e == "function" ? ist : rst)(t, e));
}
function* ost() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length, o; i < a; ++i)
      (o = r[i]) && (yield o);
}
var _2 = [null];
function Cn(t, e) {
  this._groups = t, this._parents = e;
}
function jo() {
  return new Cn([[document.documentElement]], _2);
}
function sst() {
  return this;
}
Cn.prototype = jo.prototype = {
  constructor: Cn,
  select: Iat,
  selectAll: Dat,
  selectChild: Hat,
  selectChildren: Uat,
  filter: Yat,
  data: Jat,
  enter: qat,
  exit: tot,
  join: eot,
  merge: not,
  selection: sst,
  order: rot,
  sort: iot,
  call: oot,
  nodes: sot,
  node: uot,
  size: lot,
  empty: cot,
  each: fot,
  attr: _ot,
  style: xot,
  property: Oot,
  classed: Pot,
  text: Iot,
  html: Fot,
  raise: Bot,
  lower: jot,
  append: Vot,
  insert: Uot,
  remove: qot,
  clone: Xot,
  datum: Zot,
  on: nst,
  dispatch: ast,
  [Symbol.iterator]: ost
};
function de(t) {
  return typeof t == "string" ? new Cn([[document.querySelector(t)]], [document.documentElement]) : new Cn([[t]], _2);
}
function eT(t) {
  return de(a1(t).call(document.documentElement));
}
var ust = 0;
function nT() {
  return new cv();
}
function cv() {
  this._ = "@" + (++ust).toString(36);
}
cv.prototype = nT.prototype = {
  constructor: cv,
  get: function(t) {
    for (var e = this._; !(e in t); )
      if (!(t = t.parentNode))
        return;
    return t[e];
  },
  set: function(t, e) {
    return t[this._] = e;
  },
  remove: function(t) {
    return this._ in t && delete t[this._];
  },
  toString: function() {
    return this._;
  }
};
function rT(t) {
  let e;
  for (; e = t.sourceEvent; )
    t = e;
  return t;
}
function mn(t, e) {
  if (t = rT(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
function lst(t, e) {
  return t.target && (t = rT(t), e === void 0 && (e = t.currentTarget), t = t.touches || [t]), Array.from(t, (n) => mn(n, e));
}
function cst(t) {
  return typeof t == "string" ? new Cn([document.querySelectorAll(t)], [document.documentElement]) : new Cn([q$(t)], _2);
}
const fst = { passive: !1 }, lc = { capture: !0, passive: !1 };
function Tg(t) {
  t.stopImmediatePropagation();
}
function Bs(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function s1(t) {
  var e = t.document.documentElement, n = de(t).on("dragstart.drag", Bs, lc);
  "onselectstart" in e ? n.on("selectstart.drag", Bs, lc) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function u1(t, e) {
  var n = t.document.documentElement, r = de(t).on("dragstart.drag", null);
  e && (r.on("click.drag", Bs, lc), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const oh = (t) => () => t;
function fv(t, {
  sourceEvent: e,
  subject: n,
  target: r,
  identifier: i,
  active: a,
  x: o,
  y: s,
  dx: l,
  dy: c,
  dispatch: h
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: c, enumerable: !0, configurable: !0 },
    _: { value: h }
  });
}
fv.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function hst(t) {
  return !t.ctrlKey && !t.button;
}
function dst() {
  return this.parentNode;
}
function pst(t, e) {
  return e == null ? { x: t.x, y: t.y } : e;
}
function mst() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function gst() {
  var t = hst, e = dst, n = pst, r = mst, i = {}, a = Ho("start", "drag", "end"), o = 0, s, l, c, h, d = 0;
  function p($) {
    $.on("mousedown.drag", g).filter(r).on("touchstart.drag", _).on("touchmove.drag", w, fst).on("touchend.drag touchcancel.drag", x).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function g($, E) {
    if (!(h || !t.call(this, $, E))) {
      var A = C(this, e.call(this, $, E), $, E, "mouse");
      A && (de($.view).on("mousemove.drag", v, lc).on("mouseup.drag", b, lc), s1($.view), Tg($), c = !1, s = $.clientX, l = $.clientY, A("start", $));
    }
  }
  function v($) {
    if (Bs($), !c) {
      var E = $.clientX - s, A = $.clientY - l;
      c = E * E + A * A > d;
    }
    i.mouse("drag", $);
  }
  function b($) {
    de($.view).on("mousemove.drag mouseup.drag", null), u1($.view, c), Bs($), i.mouse("end", $);
  }
  function _($, E) {
    if (t.call(this, $, E)) {
      var A = $.changedTouches, R = e.call(this, $, E), L = A.length, W, P;
      for (W = 0; W < L; ++W)
        (P = C(this, R, $, E, A[W].identifier, A[W])) && (Tg($), P("start", $, A[W]));
    }
  }
  function w($) {
    var E = $.changedTouches, A = E.length, R, L;
    for (R = 0; R < A; ++R)
      (L = i[E[R].identifier]) && (Bs($), L("drag", $, E[R]));
  }
  function x($) {
    var E = $.changedTouches, A = E.length, R, L;
    for (h && clearTimeout(h), h = setTimeout(function() {
      h = null;
    }, 500), R = 0; R < A; ++R)
      (L = i[E[R].identifier]) && (Tg($), L("end", $, E[R]));
  }
  function C($, E, A, R, L, W) {
    var P = a.copy(), k = mn(W || A, E), Y, V, I;
    if ((I = n.call($, new fv("beforestart", {
      sourceEvent: A,
      target: p,
      identifier: L,
      active: o,
      x: k[0],
      y: k[1],
      dx: 0,
      dy: 0,
      dispatch: P
    }), R)) != null)
      return Y = I.x - k[0] || 0, V = I.y - k[1] || 0, function D(z, q, Z) {
        var B = k, H;
        switch (z) {
          case "start":
            i[L] = D, H = o++;
            break;
          case "end":
            delete i[L], --o;
          case "drag":
            k = mn(Z || q, E), H = o;
            break;
        }
        P.call(
          z,
          $,
          new fv(z, {
            sourceEvent: q,
            subject: I,
            target: p,
            identifier: L,
            active: H,
            x: k[0] + Y,
            y: k[1] + V,
            dx: k[0] - B[0],
            dy: k[1] - B[1],
            dispatch: P
          }),
          R
        );
      };
  }
  return p.filter = function($) {
    return arguments.length ? (t = typeof $ == "function" ? $ : oh(!!$), p) : t;
  }, p.container = function($) {
    return arguments.length ? (e = typeof $ == "function" ? $ : oh($), p) : e;
  }, p.subject = function($) {
    return arguments.length ? (n = typeof $ == "function" ? $ : oh($), p) : n;
  }, p.touchable = function($) {
    return arguments.length ? (r = typeof $ == "function" ? $ : oh(!!$), p) : r;
  }, p.on = function() {
    var $ = a.on.apply(a, arguments);
    return $ === a ? p : $;
  }, p.clickDistance = function($) {
    return arguments.length ? (d = ($ = +$) * $, p) : Math.sqrt(d);
  }, p;
}
function Iu(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function zc(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e)
    n[r] = e[r];
  return n;
}
function Fa() {
}
var Ao = 0.7, ru = 1 / Ao, Hs = "\\s*([+-]?\\d+)\\s*", cc = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", ai = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", vst = /^#([0-9a-f]{3,8})$/, _st = new RegExp("^rgb\\(" + [Hs, Hs, Hs] + "\\)$"), bst = new RegExp("^rgb\\(" + [ai, ai, ai] + "\\)$"), yst = new RegExp("^rgba\\(" + [Hs, Hs, Hs, cc] + "\\)$"), wst = new RegExp("^rgba\\(" + [ai, ai, ai, cc] + "\\)$"), xst = new RegExp("^hsl\\(" + [cc, ai, ai] + "\\)$"), Cst = new RegExp("^hsla\\(" + [cc, ai, ai, cc] + "\\)$"), w8 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Iu(Fa, Ea, {
  copy: function(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: x8,
  // Deprecated! Use color.formatHex.
  formatHex: x8,
  formatHsl: $st,
  formatRgb: C8,
  toString: C8
});
function x8() {
  return this.rgb().formatHex();
}
function $st() {
  return iT(this).formatHsl();
}
function C8() {
  return this.rgb().formatRgb();
}
function Ea(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = vst.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? $8(e) : n === 3 ? new Ze(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? sh(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? sh(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = _st.exec(t)) ? new Ze(e[1], e[2], e[3], 1) : (e = bst.exec(t)) ? new Ze(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = yst.exec(t)) ? sh(e[1], e[2], e[3], e[4]) : (e = wst.exec(t)) ? sh(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = xst.exec(t)) ? S8(e[1], e[2] / 100, e[3] / 100, 1) : (e = Cst.exec(t)) ? S8(e[1], e[2] / 100, e[3] / 100, e[4]) : w8.hasOwnProperty(t) ? $8(w8[t]) : t === "transparent" ? new Ze(NaN, NaN, NaN, 0) : null;
}
function $8(t) {
  return new Ze(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function sh(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new Ze(t, e, n, r);
}
function b2(t) {
  return t instanceof Fa || (t = Ea(t)), t ? (t = t.rgb(), new Ze(t.r, t.g, t.b, t.opacity)) : new Ze();
}
function iu(t, e, n, r) {
  return arguments.length === 1 ? b2(t) : new Ze(t, e, n, r == null ? 1 : r);
}
function Ze(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
Iu(Ze, iu, zc(Fa, {
  brighter: function(t) {
    return t = t == null ? ru : Math.pow(ru, t), new Ze(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Ao : Math.pow(Ao, t), new Ze(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: T8,
  // Deprecated! Use color.formatHex.
  formatHex: T8,
  formatRgb: O8,
  toString: O8
}));
function T8() {
  return "#" + Og(this.r) + Og(this.g) + Og(this.b);
}
function O8() {
  var t = this.opacity;
  return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (t === 1 ? ")" : ", " + t + ")");
}
function Og(t) {
  return t = Math.max(0, Math.min(255, Math.round(t) || 0)), (t < 16 ? "0" : "") + t.toString(16);
}
function S8(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Zr(t, e, n, r);
}
function iT(t) {
  if (t instanceof Zr)
    return new Zr(t.h, t.s, t.l, t.opacity);
  if (t instanceof Fa || (t = Ea(t)), !t)
    return new Zr();
  if (t instanceof Zr)
    return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), a = Math.max(e, n, r), o = NaN, s = a - i, l = (a + i) / 2;
  return s ? (e === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - e) / s + 2 : o = (e - n) / s + 4, s /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new Zr(o, s, l, t.opacity);
}
function Ed(t, e, n, r) {
  return arguments.length === 1 ? iT(t) : new Zr(t, e, n, r == null ? 1 : r);
}
function Zr(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Iu(Zr, Ed, zc(Fa, {
  brighter: function(t) {
    return t = t == null ? ru : Math.pow(ru, t), new Zr(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Ao : Math.pow(Ao, t), new Zr(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new Ze(
      Sg(t >= 240 ? t - 240 : t + 120, i, r),
      Sg(t, i, r),
      Sg(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var t = this.opacity;
    return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (t === 1 ? ")" : ", " + t + ")");
  }
}));
function Sg(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const aT = Math.PI / 180, oT = 180 / Math.PI, Ad = 18, sT = 0.96422, uT = 1, lT = 0.82521, cT = 4 / 29, js = 6 / 29, fT = 3 * js * js, Tst = js * js * js;
function hT(t) {
  if (t instanceof Dr)
    return new Dr(t.l, t.a, t.b, t.opacity);
  if (t instanceof ni)
    return pT(t);
  t instanceof Ze || (t = b2(t));
  var e = Mg(t.r), n = Mg(t.g), r = Mg(t.b), i = Eg((0.2225045 * e + 0.7168786 * n + 0.0606169 * r) / uT), a, o;
  return e === n && n === r ? a = o = i : (a = Eg((0.4360747 * e + 0.3850649 * n + 0.1430804 * r) / sT), o = Eg((0.0139322 * e + 0.0971045 * n + 0.7141733 * r) / lT)), new Dr(116 * i - 16, 500 * (a - i), 200 * (i - o), t.opacity);
}
function Ost(t, e) {
  return new Dr(t, 0, 0, e == null ? 1 : e);
}
function Pd(t, e, n, r) {
  return arguments.length === 1 ? hT(t) : new Dr(t, e, n, r == null ? 1 : r);
}
function Dr(t, e, n, r) {
  this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
}
Iu(Dr, Pd, zc(Fa, {
  brighter: function(t) {
    return new Dr(this.l + Ad * (t == null ? 1 : t), this.a, this.b, this.opacity);
  },
  darker: function(t) {
    return new Dr(this.l - Ad * (t == null ? 1 : t), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var t = (this.l + 16) / 116, e = isNaN(this.a) ? t : t + this.a / 500, n = isNaN(this.b) ? t : t - this.b / 200;
    return e = sT * Ag(e), t = uT * Ag(t), n = lT * Ag(n), new Ze(
      Pg(3.1338561 * e - 1.6168667 * t - 0.4906146 * n),
      Pg(-0.9787684 * e + 1.9161415 * t + 0.033454 * n),
      Pg(0.0719453 * e - 0.2289914 * t + 1.4052427 * n),
      this.opacity
    );
  }
}));
function Eg(t) {
  return t > Tst ? Math.pow(t, 1 / 3) : t / fT + cT;
}
function Ag(t) {
  return t > js ? t * t * t : fT * (t - cT);
}
function Pg(t) {
  return 255 * (t <= 31308e-7 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - 0.055);
}
function Mg(t) {
  return (t /= 255) <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function dT(t) {
  if (t instanceof ni)
    return new ni(t.h, t.c, t.l, t.opacity);
  if (t instanceof Dr || (t = hT(t)), t.a === 0 && t.b === 0)
    return new ni(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
  var e = Math.atan2(t.b, t.a) * oT;
  return new ni(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
}
function Sst(t, e, n, r) {
  return arguments.length === 1 ? dT(t) : new ni(n, e, t, r == null ? 1 : r);
}
function Md(t, e, n, r) {
  return arguments.length === 1 ? dT(t) : new ni(t, e, n, r == null ? 1 : r);
}
function ni(t, e, n, r) {
  this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
}
function pT(t) {
  if (isNaN(t.h))
    return new Dr(t.l, 0, 0, t.opacity);
  var e = t.h * aT;
  return new Dr(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
}
Iu(ni, Md, zc(Fa, {
  brighter: function(t) {
    return new ni(this.h, this.c, this.l + Ad * (t == null ? 1 : t), this.opacity);
  },
  darker: function(t) {
    return new ni(this.h, this.c, this.l - Ad * (t == null ? 1 : t), this.opacity);
  },
  rgb: function() {
    return pT(this).rgb();
  }
}));
var mT = -0.14861, y2 = 1.78277, w2 = -0.29227, l1 = -0.90649, fc = 1.97294, E8 = fc * l1, A8 = fc * y2, P8 = y2 * w2 - l1 * mT;
function Est(t) {
  if (t instanceof yo)
    return new yo(t.h, t.s, t.l, t.opacity);
  t instanceof Ze || (t = b2(t));
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = (P8 * r + E8 * e - A8 * n) / (P8 + E8 - A8), a = r - i, o = (fc * (n - i) - w2 * a) / l1, s = Math.sqrt(o * o + a * a) / (fc * i * (1 - i)), l = s ? Math.atan2(o, a) * oT - 120 : NaN;
  return new yo(l < 0 ? l + 360 : l, s, i, t.opacity);
}
function Hr(t, e, n, r) {
  return arguments.length === 1 ? Est(t) : new yo(t, e, n, r == null ? 1 : r);
}
function yo(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Iu(yo, Hr, zc(Fa, {
  brighter: function(t) {
    return t = t == null ? ru : Math.pow(ru, t), new yo(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Ao : Math.pow(Ao, t), new yo(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = isNaN(this.h) ? 0 : (this.h + 120) * aT, e = +this.l, n = isNaN(this.s) ? 0 : this.s * e * (1 - e), r = Math.cos(t), i = Math.sin(t);
    return new Ze(
      255 * (e + n * (mT * r + y2 * i)),
      255 * (e + n * (w2 * r + l1 * i)),
      255 * (e + n * (fc * r)),
      this.opacity
    );
  }
}));
function gT(t, e, n, r, i) {
  var a = t * t, o = a * t;
  return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
}
function vT(t) {
  var e = t.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e), i = t[r], a = t[r + 1], o = r > 0 ? t[r - 1] : 2 * i - a, s = r < e - 1 ? t[r + 2] : 2 * a - i;
    return gT((n - r / e) * e, o, i, a, s);
  };
}
function _T(t) {
  var e = t.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e), i = t[(r + e - 1) % e], a = t[r % e], o = t[(r + 1) % e], s = t[(r + 2) % e];
    return gT((n - r / e) * e, i, a, o, s);
  };
}
const c1 = (t) => () => t;
function bT(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function Ast(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function f1(t, e) {
  var n = e - t;
  return n ? bT(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : c1(isNaN(t) ? e : t);
}
function Pst(t) {
  return (t = +t) == 1 ? je : function(e, n) {
    return n - e ? Ast(e, n, t) : c1(isNaN(e) ? n : e);
  };
}
function je(t, e) {
  var n = e - t;
  return n ? bT(t, n) : c1(isNaN(t) ? e : t);
}
const hc = function t(e) {
  var n = Pst(e);
  function r(i, a) {
    var o = n((i = iu(i)).r, (a = iu(a)).r), s = n(i.g, a.g), l = n(i.b, a.b), c = je(i.opacity, a.opacity);
    return function(h) {
      return i.r = o(h), i.g = s(h), i.b = l(h), i.opacity = c(h), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function yT(t) {
  return function(e) {
    var n = e.length, r = new Array(n), i = new Array(n), a = new Array(n), o, s;
    for (o = 0; o < n; ++o)
      s = iu(e[o]), r[o] = s.r || 0, i[o] = s.g || 0, a[o] = s.b || 0;
    return r = t(r), i = t(i), a = t(a), s.opacity = 1, function(l) {
      return s.r = r(l), s.g = i(l), s.b = a(l), s + "";
    };
  };
}
var wT = yT(vT), Mst = yT(_T);
function x2(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i)
      r[i] = t[i] * (1 - a) + e[i] * a;
    return r;
  };
}
function xT(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function kst(t, e) {
  return (xT(e) ? x2 : CT)(t, e);
}
function CT(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o)
    i[o] = za(t[o], e[o]);
  for (; o < n; ++o)
    a[o] = e[o];
  return function(s) {
    for (o = 0; o < r; ++o)
      a[o] = i[o](s);
    return a;
  };
}
function $T(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function br(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function TT(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = za(t[i], e[i]) : r[i] = e[i];
  return function(a) {
    for (i in n)
      r[i] = n[i](a);
    return r;
  };
}
var hv = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, kg = new RegExp(hv.source, "g");
function Nst(t) {
  return function() {
    return t;
  };
}
function Ist(t) {
  return function(e) {
    return t(e) + "";
  };
}
function C2(t, e) {
  var n = hv.lastIndex = kg.lastIndex = 0, r, i, a, o = -1, s = [], l = [];
  for (t = t + "", e = e + ""; (r = hv.exec(t)) && (i = kg.exec(e)); )
    (a = i.index) > n && (a = e.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, l.push({ i: o, x: br(r, i) })), n = kg.lastIndex;
  return n < e.length && (a = e.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? l[0] ? Ist(l[0].x) : Nst(e) : (e = l.length, function(c) {
    for (var h = 0, d; h < e; ++h)
      s[(d = l[h]).i] = d.x(c);
    return s.join("");
  });
}
function za(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? c1(e) : (n === "number" ? br : n === "string" ? (r = Ea(e)) ? (e = r, hc) : C2 : e instanceof Ea ? hc : e instanceof Date ? $T : xT(e) ? x2 : Array.isArray(e) ? CT : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? TT : br)(t, e);
}
function Rst(t) {
  var e = t.length;
  return function(n) {
    return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
  };
}
function Lst(t, e) {
  var n = f1(+t, +e);
  return function(r) {
    var i = n(r);
    return i - 360 * Math.floor(i / 360);
  };
}
function Bc(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var M8 = 180 / Math.PI, dv = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function OT(t, e, n, r, i, a) {
  var o, s, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * n + e * r) && (n -= t * l, r -= e * l), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, l /= s), t * r < e * n && (t = -t, e = -e, l = -l, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(e, t) * M8,
    skewX: Math.atan(l) * M8,
    scaleX: o,
    scaleY: s
  };
}
var uh;
function Dst(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? dv : OT(e.a, e.b, e.c, e.d, e.e, e.f);
}
function Fst(t) {
  return t == null || (uh || (uh = document.createElementNS("http://www.w3.org/2000/svg", "g")), uh.setAttribute("transform", t), !(t = uh.transform.baseVal.consolidate())) ? dv : (t = t.matrix, OT(t.a, t.b, t.c, t.d, t.e, t.f));
}
function ST(t, e, n, r) {
  function i(c) {
    return c.length ? c.pop() + " " : "";
  }
  function a(c, h, d, p, g, v) {
    if (c !== d || h !== p) {
      var b = g.push("translate(", null, e, null, n);
      v.push({ i: b - 4, x: br(c, d) }, { i: b - 2, x: br(h, p) });
    } else
      (d || p) && g.push("translate(" + d + e + p + n);
  }
  function o(c, h, d, p) {
    c !== h ? (c - h > 180 ? h += 360 : h - c > 180 && (c += 360), p.push({ i: d.push(i(d) + "rotate(", null, r) - 2, x: br(c, h) })) : h && d.push(i(d) + "rotate(" + h + r);
  }
  function s(c, h, d, p) {
    c !== h ? p.push({ i: d.push(i(d) + "skewX(", null, r) - 2, x: br(c, h) }) : h && d.push(i(d) + "skewX(" + h + r);
  }
  function l(c, h, d, p, g, v) {
    if (c !== d || h !== p) {
      var b = g.push(i(g) + "scale(", null, ",", null, ")");
      v.push({ i: b - 4, x: br(c, d) }, { i: b - 2, x: br(h, p) });
    } else
      (d !== 1 || p !== 1) && g.push(i(g) + "scale(" + d + "," + p + ")");
  }
  return function(c, h) {
    var d = [], p = [];
    return c = t(c), h = t(h), a(c.translateX, c.translateY, h.translateX, h.translateY, d, p), o(c.rotate, h.rotate, d, p), s(c.skewX, h.skewX, d, p), l(c.scaleX, c.scaleY, h.scaleX, h.scaleY, d, p), c = h = null, function(g) {
      for (var v = -1, b = p.length, _; ++v < b; )
        d[(_ = p[v]).i] = _.x(g);
      return d.join("");
    };
  };
}
var ET = ST(Dst, "px, ", "px)", "deg)"), AT = ST(Fst, ", ", ")", ")"), zst = 1e-12;
function k8(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Bst(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Hst(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const PT = function t(e, n, r) {
  function i(a, o) {
    var s = a[0], l = a[1], c = a[2], h = o[0], d = o[1], p = o[2], g = h - s, v = d - l, b = g * g + v * v, _, w;
    if (b < zst)
      w = Math.log(p / c) / e, _ = function(R) {
        return [
          s + R * g,
          l + R * v,
          c * Math.exp(e * R * w)
        ];
      };
    else {
      var x = Math.sqrt(b), C = (p * p - c * c + r * b) / (2 * c * n * x), $ = (p * p - c * c - r * b) / (2 * p * n * x), E = Math.log(Math.sqrt(C * C + 1) - C), A = Math.log(Math.sqrt($ * $ + 1) - $);
      w = (A - E) / e, _ = function(R) {
        var L = R * w, W = k8(E), P = c / (n * x) * (W * Hst(e * L + E) - Bst(E));
        return [
          s + P * g,
          l + P * v,
          c * W / k8(e * L + E)
        ];
      };
    }
    return _.duration = w * 1e3 * e / Math.SQRT2, _;
  }
  return i.rho = function(a) {
    var o = Math.max(1e-3, +a), s = o * o, l = s * s;
    return t(o, s, l);
  }, i;
}(Math.SQRT2, 2, 4);
function MT(t) {
  return function(e, n) {
    var r = t((e = Ed(e)).h, (n = Ed(n)).h), i = je(e.s, n.s), a = je(e.l, n.l), o = je(e.opacity, n.opacity);
    return function(s) {
      return e.h = r(s), e.s = i(s), e.l = a(s), e.opacity = o(s), e + "";
    };
  };
}
const jst = MT(f1);
var Vst = MT(je);
function Wst(t, e) {
  var n = je((t = Pd(t)).l, (e = Pd(e)).l), r = je(t.a, e.a), i = je(t.b, e.b), a = je(t.opacity, e.opacity);
  return function(o) {
    return t.l = n(o), t.a = r(o), t.b = i(o), t.opacity = a(o), t + "";
  };
}
function kT(t) {
  return function(e, n) {
    var r = t((e = Md(e)).h, (n = Md(n)).h), i = je(e.c, n.c), a = je(e.l, n.l), o = je(e.opacity, n.opacity);
    return function(s) {
      return e.h = r(s), e.c = i(s), e.l = a(s), e.opacity = o(s), e + "";
    };
  };
}
const Ust = kT(f1);
var Yst = kT(je);
function NT(t) {
  return function e(n) {
    n = +n;
    function r(i, a) {
      var o = t((i = Hr(i)).h, (a = Hr(a)).h), s = je(i.s, a.s), l = je(i.l, a.l), c = je(i.opacity, a.opacity);
      return function(h) {
        return i.h = o(h), i.s = s(h), i.l = l(Math.pow(h, n)), i.opacity = c(h), i + "";
      };
    }
    return r.gamma = e, r;
  }(1);
}
const qst = NT(f1);
var h1 = NT(je);
function IT(t, e) {
  e === void 0 && (e = t, t = za);
  for (var n = 0, r = e.length - 1, i = e[0], a = new Array(r < 0 ? 0 : r); n < r; )
    a[n] = t(i, i = e[++n]);
  return function(o) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(o *= r)));
    return a[s](o - s);
  };
}
function Gst(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t(r / (e - 1));
  return n;
}
var au = 0, wl = 0, ll = 0, RT = 1e3, kd, xl, Nd = 0, Po = 0, d1 = 0, dc = typeof performance == "object" && performance.now ? performance : Date, LT = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Hc() {
  return Po || (LT(Kst), Po = dc.now() + d1);
}
function Kst() {
  Po = 0;
}
function pc() {
  this._call = this._time = this._next = null;
}
pc.prototype = p1.prototype = {
  constructor: pc,
  restart: function(t, e, n) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? Hc() : +n) + (e == null ? 0 : +e), !this._next && xl !== this && (xl ? xl._next = this : kd = this, xl = this), this._call = t, this._time = n, pv();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, pv());
  }
};
function p1(t, e, n) {
  var r = new pc();
  return r.restart(t, e, n), r;
}
function DT() {
  Hc(), ++au;
  for (var t = kd, e; t; )
    (e = Po - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --au;
}
function N8() {
  Po = (Nd = dc.now()) + d1, au = wl = 0;
  try {
    DT();
  } finally {
    au = 0, Zst(), Po = 0;
  }
}
function Xst() {
  var t = dc.now(), e = t - Nd;
  e > RT && (d1 -= e, Nd = t);
}
function Zst() {
  for (var t, e = kd, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : kd = n);
  xl = t, pv(r);
}
function pv(t) {
  if (!au) {
    wl && (wl = clearTimeout(wl));
    var e = t - Po;
    e > 24 ? (t < 1 / 0 && (wl = setTimeout(N8, t - dc.now() - d1)), ll && (ll = clearInterval(ll))) : (ll || (Nd = dc.now(), ll = setInterval(Xst, RT)), au = 1, LT(N8));
  }
}
function mv(t, e, n) {
  var r = new pc();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
function Jst(t, e, n) {
  var r = new pc(), i = e;
  return e == null ? (r.restart(t, e, n), r) : (r._restart = r.restart, r.restart = function(a, o, s) {
    o = +o, s = s == null ? Hc() : +s, r._restart(function l(c) {
      c += i, r._restart(l, i += o, s), a(c);
    }, o, s);
  }, r.restart(t, e, n), r);
}
var Qst = Ho("start", "end", "cancel", "interrupt"), tut = [], FT = 0, gv = 1, vv = 2, Hh = 3, I8 = 4, _v = 5, jh = 6;
function m1(t, e, n, r, i, a) {
  var o = t.__transition;
  if (!o)
    t.__transition = {};
  else if (n in o)
    return;
  eut(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: Qst,
    tween: tut,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: FT
  });
}
function $2(t, e) {
  var n = jr(t, e);
  if (n.state > FT)
    throw new Error("too late; already scheduled");
  return n;
}
function ci(t, e) {
  var n = jr(t, e);
  if (n.state > Hh)
    throw new Error("too late; already running");
  return n;
}
function jr(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e]))
    throw new Error("transition not found");
  return n;
}
function eut(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = p1(a, 0, n.time);
  function a(c) {
    n.state = gv, n.timer.restart(o, n.delay, n.time), n.delay <= c && o(c - n.delay);
  }
  function o(c) {
    var h, d, p, g;
    if (n.state !== gv)
      return l();
    for (h in r)
      if (g = r[h], g.name === n.name) {
        if (g.state === Hh)
          return mv(o);
        g.state === I8 ? (g.state = jh, g.timer.stop(), g.on.call("interrupt", t, t.__data__, g.index, g.group), delete r[h]) : +h < e && (g.state = jh, g.timer.stop(), g.on.call("cancel", t, t.__data__, g.index, g.group), delete r[h]);
      }
    if (mv(function() {
      n.state === Hh && (n.state = I8, n.timer.restart(s, n.delay, n.time), s(c));
    }), n.state = vv, n.on.call("start", t, t.__data__, n.index, n.group), n.state === vv) {
      for (n.state = Hh, i = new Array(p = n.tween.length), h = 0, d = -1; h < p; ++h)
        (g = n.tween[h].value.call(t, t.__data__, n.index, n.group)) && (i[++d] = g);
      i.length = d + 1;
    }
  }
  function s(c) {
    for (var h = c < n.duration ? n.ease.call(null, c / n.duration) : (n.timer.restart(l), n.state = _v, 1), d = -1, p = i.length; ++d < p; )
      i[d].call(t, h);
    n.state === _v && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = jh, n.timer.stop(), delete r[e];
    for (var c in r)
      return;
    delete t.__transition;
  }
}
function wo(t, e) {
  var n = t.__transition, r, i, a = !0, o;
  if (n) {
    e = e == null ? null : e + "";
    for (o in n) {
      if ((r = n[o]).name !== e) {
        a = !1;
        continue;
      }
      i = r.state > vv && r.state < _v, r.state = jh, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[o];
    }
    a && delete t.__transition;
  }
}
function nut(t) {
  return this.each(function() {
    wo(this, t);
  });
}
function rut(t, e) {
  var n, r;
  return function() {
    var i = ci(this, t), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === e) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function iut(t, e, n) {
  var r, i;
  if (typeof n != "function")
    throw new Error();
  return function() {
    var a = ci(this, t), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: e, value: n }, l = 0, c = i.length; l < c; ++l)
        if (i[l].name === e) {
          i[l] = s;
          break;
        }
      l === c && i.push(s);
    }
    a.tween = i;
  };
}
function aut(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = jr(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? rut : iut)(n, t, e));
}
function T2(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = ci(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return jr(i, r).value[e];
  };
}
function zT(t, e) {
  var n;
  return (typeof e == "number" ? br : e instanceof Ea ? hc : (n = Ea(e)) ? (e = n, hc) : C2)(t, e);
}
function out(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function sut(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function uut(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttribute(t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function lut(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function cut(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function fut(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function hut(t, e) {
  var n = Fc(t), r = n === "transform" ? AT : zT;
  return this.attrTween(t, typeof e == "function" ? (n.local ? fut : cut)(n, r, T2(this, "attr." + t, e)) : e == null ? (n.local ? sut : out)(n) : (n.local ? lut : uut)(n, r, e));
}
function dut(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function put(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function mut(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && put(t, a)), n;
  }
  return i._value = e, i;
}
function gut(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && dut(t, a)), n;
  }
  return i._value = e, i;
}
function vut(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2)
    return (n = this.tween(n)) && n._value;
  if (e == null)
    return this.tween(n, null);
  if (typeof e != "function")
    throw new Error();
  var r = Fc(t);
  return this.tween(n, (r.local ? mut : gut)(r, e));
}
function _ut(t, e) {
  return function() {
    $2(this, t).delay = +e.apply(this, arguments);
  };
}
function but(t, e) {
  return e = +e, function() {
    $2(this, t).delay = e;
  };
}
function yut(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? _ut : but)(e, t)) : jr(this.node(), e).delay;
}
function wut(t, e) {
  return function() {
    ci(this, t).duration = +e.apply(this, arguments);
  };
}
function xut(t, e) {
  return e = +e, function() {
    ci(this, t).duration = e;
  };
}
function Cut(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? wut : xut)(e, t)) : jr(this.node(), e).duration;
}
function $ut(t, e) {
  if (typeof e != "function")
    throw new Error();
  return function() {
    ci(this, t).ease = e;
  };
}
function Tut(t) {
  var e = this._id;
  return arguments.length ? this.each($ut(e, t)) : jr(this.node(), e).ease;
}
function Out(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function")
      throw new Error();
    ci(this, t).ease = n;
  };
}
function Sut(t) {
  if (typeof t != "function")
    throw new Error();
  return this.each(Out(this._id, t));
}
function Eut(t) {
  typeof t != "function" && (t = m2(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, c = 0; c < o; ++c)
      (l = a[c]) && t.call(l, l.__data__, c, a) && s.push(l);
  return new ui(r, this._parents, this._name, this._id);
}
function Aut(t) {
  if (t._id !== this._id)
    throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var l = e[s], c = n[s], h = l.length, d = o[s] = new Array(h), p, g = 0; g < h; ++g)
      (p = l[g] || c[g]) && (d[g] = p);
  for (; s < r; ++s)
    o[s] = e[s];
  return new ui(o, this._parents, this._name, this._id);
}
function Put(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function Mut(t, e, n) {
  var r, i, a = Put(e) ? $2 : ci;
  return function() {
    var o = a(this, t), s = o.on;
    s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
  };
}
function kut(t, e) {
  var n = this._id;
  return arguments.length < 2 ? jr(this.node(), n).on.on(t) : this.each(Mut(n, t, e));
}
function Nut(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition)
      if (+n !== t)
        return;
    e && e.removeChild(this);
  };
}
function Iut() {
  return this.on("end.remove", Nut(this._id));
}
function Rut(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = o1(t));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], l = s.length, c = a[o] = new Array(l), h, d, p = 0; p < l; ++p)
      (h = s[p]) && (d = t.call(h, h.__data__, p, s)) && ("__data__" in h && (d.__data__ = h.__data__), c[p] = d, m1(c[p], e, n, p, c, jr(h, n)));
  return new ui(a, this._parents, e, n);
}
function Lut(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = p2(t));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var l = r[s], c = l.length, h, d = 0; d < c; ++d)
      if (h = l[d]) {
        for (var p = t.call(h, h.__data__, d, l), g, v = jr(h, n), b = 0, _ = p.length; b < _; ++b)
          (g = p[b]) && m1(g, e, n, b, p, v);
        a.push(p), o.push(h);
      }
  return new ui(a, o, e, n);
}
var Dut = jo.prototype.constructor;
function Fut() {
  return new Dut(this._groups, this._parents);
}
function zut(t, e) {
  var n, r, i;
  return function() {
    var a = Eo(this, t), o = (this.style.removeProperty(t), Eo(this, t));
    return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
  };
}
function BT(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function But(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = Eo(this, t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Hut(t, e, n) {
  var r, i, a;
  return function() {
    var o = Eo(this, t), s = n(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(t), Eo(this, t))), o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s));
  };
}
function jut(t, e) {
  var n, r, i, a = "style." + e, o = "end." + a, s;
  return function() {
    var l = ci(this, t), c = l.on, h = l.value[a] == null ? s || (s = BT(e)) : void 0;
    (c !== n || i !== h) && (r = (n = c).copy()).on(o, i = h), l.on = r;
  };
}
function Vut(t, e, n) {
  var r = (t += "") == "transform" ? ET : zT;
  return e == null ? this.styleTween(t, zut(t, r)).on("end.style." + t, BT(t)) : typeof e == "function" ? this.styleTween(t, Hut(t, r, T2(this, "style." + t, e))).each(jut(this._id, t)) : this.styleTween(t, But(t, r, e), n).on("end.style." + t, null);
}
function Wut(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function Uut(t, e, n) {
  var r, i;
  function a() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && Wut(t, o, n)), r;
  }
  return a._value = e, a;
}
function Yut(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (e == null)
    return this.tween(r, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(r, Uut(t, e, n == null ? "" : n));
}
function qut(t) {
  return function() {
    this.textContent = t;
  };
}
function Gut(t) {
  return function() {
    var e = t(this);
    this.textContent = e == null ? "" : e;
  };
}
function Kut(t) {
  return this.tween("text", typeof t == "function" ? Gut(T2(this, "text", t)) : qut(t == null ? "" : t + ""));
}
function Xut(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Zut(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && Xut(i)), e;
  }
  return r._value = t, r;
}
function Jut(t) {
  var e = "text";
  if (arguments.length < 1)
    return (e = this.tween(e)) && e._value;
  if (t == null)
    return this.tween(e, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(e, Zut(t));
}
function Qut() {
  for (var t = this._name, e = this._id, n = jT(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, c = 0; c < s; ++c)
      if (l = o[c]) {
        var h = jr(l, e);
        m1(l, t, n, c, o, {
          time: h.time + h.delay + h.duration,
          delay: 0,
          duration: h.duration,
          ease: h.ease
        });
      }
  return new ui(r, this._parents, t, n);
}
function tlt() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(a, o) {
    var s = { value: o }, l = { value: function() {
      --i === 0 && a();
    } };
    n.each(function() {
      var c = ci(this, r), h = c.on;
      h !== t && (e = (t = h).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), c.on = e;
    }), i === 0 && a();
  });
}
var elt = 0;
function ui(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function HT(t) {
  return jo().transition(t);
}
function jT() {
  return ++elt;
}
var yi = jo.prototype;
ui.prototype = HT.prototype = {
  constructor: ui,
  select: Rut,
  selectAll: Lut,
  selectChild: yi.selectChild,
  selectChildren: yi.selectChildren,
  filter: Eut,
  merge: Aut,
  selection: Fut,
  transition: Qut,
  call: yi.call,
  nodes: yi.nodes,
  node: yi.node,
  size: yi.size,
  empty: yi.empty,
  each: yi.each,
  on: kut,
  attr: hut,
  attrTween: vut,
  style: Vut,
  styleTween: Yut,
  text: Kut,
  textTween: Jut,
  remove: Iut,
  tween: aut,
  delay: yut,
  duration: Cut,
  ease: Tut,
  easeVarying: Sut,
  end: tlt,
  [Symbol.iterator]: yi[Symbol.iterator]
};
const nlt = (t) => +t;
function rlt(t) {
  return t * t;
}
function ilt(t) {
  return t * (2 - t);
}
function R8(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}
function alt(t) {
  return t * t * t;
}
function olt(t) {
  return --t * t * t + 1;
}
function bv(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var O2 = 3, slt = function t(e) {
  e = +e;
  function n(r) {
    return Math.pow(r, e);
  }
  return n.exponent = t, n;
}(O2), ult = function t(e) {
  e = +e;
  function n(r) {
    return 1 - Math.pow(1 - r, e);
  }
  return n.exponent = t, n;
}(O2), L8 = function t(e) {
  e = +e;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, e) : 2 - Math.pow(2 - r, e)) / 2;
  }
  return n.exponent = t, n;
}(O2), VT = Math.PI, WT = VT / 2;
function llt(t) {
  return +t == 1 ? 1 : 1 - Math.cos(t * WT);
}
function clt(t) {
  return Math.sin(t * WT);
}
function D8(t) {
  return (1 - Math.cos(VT * t)) / 2;
}
function Aa(t) {
  return (Math.pow(2, -10 * t) - 9765625e-10) * 1.0009775171065494;
}
function flt(t) {
  return Aa(1 - +t);
}
function hlt(t) {
  return 1 - Aa(t);
}
function F8(t) {
  return ((t *= 2) <= 1 ? Aa(1 - t) : 2 - Aa(t - 1)) / 2;
}
function dlt(t) {
  return 1 - Math.sqrt(1 - t * t);
}
function plt(t) {
  return Math.sqrt(1 - --t * t);
}
function z8(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}
var yv = 4 / 11, mlt = 6 / 11, glt = 8 / 11, vlt = 3 / 4, _lt = 9 / 11, blt = 10 / 11, ylt = 15 / 16, wlt = 21 / 22, xlt = 63 / 64, lh = 1 / yv / yv;
function Clt(t) {
  return 1 - mc(1 - t);
}
function mc(t) {
  return (t = +t) < yv ? lh * t * t : t < glt ? lh * (t -= mlt) * t + vlt : t < blt ? lh * (t -= _lt) * t + ylt : lh * (t -= wlt) * t + xlt;
}
function $lt(t) {
  return ((t *= 2) <= 1 ? 1 - mc(1 - t) : mc(t - 1) + 1) / 2;
}
var S2 = 1.70158, Tlt = function t(e) {
  e = +e;
  function n(r) {
    return (r = +r) * r * (e * (r - 1) + r);
  }
  return n.overshoot = t, n;
}(S2), Olt = function t(e) {
  e = +e;
  function n(r) {
    return --r * r * ((r + 1) * e + r) + 1;
  }
  return n.overshoot = t, n;
}(S2), B8 = function t(e) {
  e = +e;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((e + 1) * r - e) : (r -= 2) * r * ((e + 1) * r + e) + 2) / 2;
  }
  return n.overshoot = t, n;
}(S2), ou = 2 * Math.PI, E2 = 1, A2 = 0.3, Slt = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= ou);
  function i(a) {
    return e * Aa(- --a) * Math.sin((r - a) / n);
  }
  return i.amplitude = function(a) {
    return t(a, n * ou);
  }, i.period = function(a) {
    return t(e, a);
  }, i;
}(E2, A2), H8 = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= ou);
  function i(a) {
    return 1 - e * Aa(a = +a) * Math.sin((a + r) / n);
  }
  return i.amplitude = function(a) {
    return t(a, n * ou);
  }, i.period = function(a) {
    return t(e, a);
  }, i;
}(E2, A2), Elt = function t(e, n) {
  var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= ou);
  function i(a) {
    return ((a = a * 2 - 1) < 0 ? e * Aa(-a) * Math.sin((r - a) / n) : 2 - e * Aa(a) * Math.sin((r + a) / n)) / 2;
  }
  return i.amplitude = function(a) {
    return t(a, n * ou);
  }, i.period = function(a) {
    return t(e, a);
  }, i;
}(E2, A2), Alt = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: bv
};
function Plt(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function Mlt(t) {
  var e, n;
  t instanceof ui ? (e = t._id, t = t._name) : (e = jT(), (n = Alt).time = Hc(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, c = 0; c < s; ++c)
      (l = o[c]) && m1(l, t, e, c, o, n || Plt(l, e));
  return new ui(r, this._parents, t, e);
}
jo.prototype.interrupt = nut;
jo.prototype.transition = Mlt;
var klt = [null];
function Nlt(t, e) {
  var n = t.__transition, r, i;
  if (n) {
    e = e == null ? null : e + "";
    for (i in n)
      if ((r = n[i]).state > gv && r.name === e)
        return new ui([[t]], klt, e, +i);
  }
  return null;
}
const Ng = (t) => () => t;
function Ilt(t, {
  sourceEvent: e,
  target: n,
  selection: r,
  mode: i,
  dispatch: a
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    selection: { value: r, enumerable: !0, configurable: !0 },
    mode: { value: i, enumerable: !0, configurable: !0 },
    _: { value: a }
  });
}
function Rlt(t) {
  t.stopImmediatePropagation();
}
function Ig(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
var j8 = { name: "drag" }, Rg = { name: "space" }, ds = { name: "handle" }, ps = { name: "center" };
const { abs: V8, max: rn, min: an } = Math;
function W8(t) {
  return [+t[0], +t[1]];
}
function wv(t) {
  return [W8(t[0]), W8(t[1])];
}
var Vh = {
  name: "x",
  handles: ["w", "e"].map(gc),
  input: function(t, e) {
    return t == null ? null : [[+t[0], e[0][1]], [+t[1], e[1][1]]];
  },
  output: function(t) {
    return t && [t[0][0], t[1][0]];
  }
}, Wh = {
  name: "y",
  handles: ["n", "s"].map(gc),
  input: function(t, e) {
    return t == null ? null : [[e[0][0], +t[0]], [e[1][0], +t[1]]];
  },
  output: function(t) {
    return t && [t[0][1], t[1][1]];
  }
}, Llt = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(gc),
  input: function(t) {
    return t == null ? null : wv(t);
  },
  output: function(t) {
    return t;
  }
}, wi = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, U8 = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, Y8 = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, Dlt = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, Flt = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function gc(t) {
  return { type: t };
}
function zlt(t) {
  return !t.ctrlKey && !t.button;
}
function Blt() {
  var t = this.ownerSVGElement || this;
  return t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
}
function Hlt() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Lg(t) {
  for (; !t.__brush; )
    if (!(t = t.parentNode))
      return;
  return t.__brush;
}
function jlt(t) {
  return t[0][0] === t[1][0] || t[0][1] === t[1][1];
}
function Vlt(t) {
  var e = t.__brush;
  return e ? e.dim.output(e.selection) : null;
}
function Wlt() {
  return P2(Vh);
}
function Ult() {
  return P2(Wh);
}
function Ylt() {
  return P2(Llt);
}
function P2(t) {
  var e = Blt, n = zlt, r = Hlt, i = !0, a = Ho("start", "brush", "end"), o = 6, s;
  function l(_) {
    var w = _.property("__brush", b).selectAll(".overlay").data([gc("overlay")]);
    w.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", wi.overlay).merge(w).each(function() {
      var C = Lg(this).extent;
      de(this).attr("x", C[0][0]).attr("y", C[0][1]).attr("width", C[1][0] - C[0][0]).attr("height", C[1][1] - C[0][1]);
    }), _.selectAll(".selection").data([gc("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", wi.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var x = _.selectAll(".handle").data(t.handles, function(C) {
      return C.type;
    });
    x.exit().remove(), x.enter().append("rect").attr("class", function(C) {
      return "handle handle--" + C.type;
    }).attr("cursor", function(C) {
      return wi[C.type];
    }), _.each(c).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", p).filter(r).on("touchstart.brush", p).on("touchmove.brush", g).on("touchend.brush touchcancel.brush", v).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  l.move = function(_, w, x) {
    _.tween ? _.on("start.brush", function(C) {
      h(this, arguments).beforestart().start(C);
    }).on("interrupt.brush end.brush", function(C) {
      h(this, arguments).end(C);
    }).tween("brush", function() {
      var C = this, $ = C.__brush, E = h(C, arguments), A = $.selection, R = t.input(typeof w == "function" ? w.apply(this, arguments) : w, $.extent), L = za(A, R);
      function W(P) {
        $.selection = P === 1 && R === null ? null : L(P), c.call(C), E.brush();
      }
      return A !== null && R !== null ? W : W(1);
    }) : _.each(function() {
      var C = this, $ = arguments, E = C.__brush, A = t.input(typeof w == "function" ? w.apply(C, $) : w, E.extent), R = h(C, $).beforestart();
      wo(C), E.selection = A === null ? null : A, c.call(C), R.start(x).brush(x).end(x);
    });
  }, l.clear = function(_, w) {
    l.move(_, null, w);
  };
  function c() {
    var _ = de(this), w = Lg(this).selection;
    w ? (_.selectAll(".selection").style("display", null).attr("x", w[0][0]).attr("y", w[0][1]).attr("width", w[1][0] - w[0][0]).attr("height", w[1][1] - w[0][1]), _.selectAll(".handle").style("display", null).attr("x", function(x) {
      return x.type[x.type.length - 1] === "e" ? w[1][0] - o / 2 : w[0][0] - o / 2;
    }).attr("y", function(x) {
      return x.type[0] === "s" ? w[1][1] - o / 2 : w[0][1] - o / 2;
    }).attr("width", function(x) {
      return x.type === "n" || x.type === "s" ? w[1][0] - w[0][0] + o : o;
    }).attr("height", function(x) {
      return x.type === "e" || x.type === "w" ? w[1][1] - w[0][1] + o : o;
    })) : _.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function h(_, w, x) {
    var C = _.__brush.emitter;
    return C && (!x || !C.clean) ? C : new d(_, w, x);
  }
  function d(_, w, x) {
    this.that = _, this.args = w, this.state = _.__brush, this.active = 0, this.clean = x;
  }
  d.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function(_, w) {
      return this.starting ? (this.starting = !1, this.emit("start", _, w)) : this.emit("brush", _), this;
    },
    brush: function(_, w) {
      return this.emit("brush", _, w), this;
    },
    end: function(_, w) {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end", _, w)), this;
    },
    emit: function(_, w, x) {
      var C = de(this.that).datum();
      a.call(
        _,
        this.that,
        new Ilt(_, {
          sourceEvent: w,
          target: l,
          selection: t.output(this.state.selection),
          mode: x,
          dispatch: a
        }),
        C
      );
    }
  };
  function p(_) {
    if (s && !_.touches || !n.apply(this, arguments))
      return;
    var w = this, x = _.target.__data__.type, C = (i && _.metaKey ? x = "overlay" : x) === "selection" ? j8 : i && _.altKey ? ps : ds, $ = t === Wh ? null : Dlt[x], E = t === Vh ? null : Flt[x], A = Lg(w), R = A.extent, L = A.selection, W = R[0][0], P, k, Y = R[0][1], V, I, D = R[1][0], z, q, Z = R[1][1], B, H, J = 0, X = 0, et, rt = $ && E && i && _.shiftKey, ut, ft, ht = Array.from(_.touches || [_], (yt) => {
      const re = yt.identifier;
      return yt = mn(yt, w), yt.point0 = yt.slice(), yt.identifier = re, yt;
    });
    wo(w);
    var Nt = h(w, arguments, !0).beforestart();
    if (x === "overlay") {
      L && (et = !0);
      const yt = [ht[0], ht[1] || ht[0]];
      A.selection = L = [[
        P = t === Wh ? W : an(yt[0][0], yt[1][0]),
        V = t === Vh ? Y : an(yt[0][1], yt[1][1])
      ], [
        z = t === Wh ? D : rn(yt[0][0], yt[1][0]),
        B = t === Vh ? Z : rn(yt[0][1], yt[1][1])
      ]], ht.length > 1 && Gt(_);
    } else
      P = L[0][0], V = L[0][1], z = L[1][0], B = L[1][1];
    k = P, I = V, q = z, H = B;
    var ot = de(w).attr("pointer-events", "none"), wt = ot.selectAll(".overlay").attr("cursor", wi[x]);
    if (_.touches)
      Nt.moved = at, Nt.ended = $t;
    else {
      var kt = de(_.view).on("mousemove.brush", at, !0).on("mouseup.brush", $t, !0);
      i && kt.on("keydown.brush", le, !0).on("keyup.brush", qe, !0), s1(_.view);
    }
    c.call(w), Nt.start(_, C.name);
    function at(yt) {
      for (const re of yt.changedTouches || [yt])
        for (const Va of ht)
          Va.identifier === re.identifier && (Va.cur = mn(re, w));
      if (rt && !ut && !ft && ht.length === 1) {
        const re = ht[0];
        V8(re.cur[0] - re[0]) > V8(re.cur[1] - re[1]) ? ft = !0 : ut = !0;
      }
      for (const re of ht)
        re.cur && (re[0] = re.cur[0], re[1] = re.cur[1]);
      et = !0, Ig(yt), Gt(yt);
    }
    function Gt(yt) {
      const re = ht[0], Va = re.point0;
      var En;
      switch (J = re[0] - Va[0], X = re[1] - Va[1], C) {
        case Rg:
        case j8: {
          $ && (J = rn(W - P, an(D - z, J)), k = P + J, q = z + J), E && (X = rn(Y - V, an(Z - B, X)), I = V + X, H = B + X);
          break;
        }
        case ds: {
          ht[1] ? ($ && (k = rn(W, an(D, ht[0][0])), q = rn(W, an(D, ht[1][0])), $ = 1), E && (I = rn(Y, an(Z, ht[0][1])), H = rn(Y, an(Z, ht[1][1])), E = 1)) : ($ < 0 ? (J = rn(W - P, an(D - P, J)), k = P + J, q = z) : $ > 0 && (J = rn(W - z, an(D - z, J)), k = P, q = z + J), E < 0 ? (X = rn(Y - V, an(Z - V, X)), I = V + X, H = B) : E > 0 && (X = rn(Y - B, an(Z - B, X)), I = V, H = B + X));
          break;
        }
        case ps: {
          $ && (k = rn(W, an(D, P - J * $)), q = rn(W, an(D, z + J * $))), E && (I = rn(Y, an(Z, V - X * E)), H = rn(Y, an(Z, B + X * E)));
          break;
        }
      }
      q < k && ($ *= -1, En = P, P = z, z = En, En = k, k = q, q = En, x in U8 && wt.attr("cursor", wi[x = U8[x]])), H < I && (E *= -1, En = V, V = B, B = En, En = I, I = H, H = En, x in Y8 && wt.attr("cursor", wi[x = Y8[x]])), A.selection && (L = A.selection), ut && (k = L[0][0], q = L[1][0]), ft && (I = L[0][1], H = L[1][1]), (L[0][0] !== k || L[0][1] !== I || L[1][0] !== q || L[1][1] !== H) && (A.selection = [[k, I], [q, H]], c.call(w), Nt.brush(yt, C.name));
    }
    function $t(yt) {
      if (Rlt(yt), yt.touches) {
        if (yt.touches.length)
          return;
        s && clearTimeout(s), s = setTimeout(function() {
          s = null;
        }, 500);
      } else
        u1(yt.view, et), kt.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      ot.attr("pointer-events", "all"), wt.attr("cursor", wi.overlay), A.selection && (L = A.selection), jlt(L) && (A.selection = null, c.call(w)), Nt.end(yt, C.name);
    }
    function le(yt) {
      switch (yt.keyCode) {
        case 16: {
          rt = $ && E;
          break;
        }
        case 18: {
          C === ds && ($ && (z = q - J * $, P = k + J * $), E && (B = H - X * E, V = I + X * E), C = ps, Gt(yt));
          break;
        }
        case 32: {
          (C === ds || C === ps) && ($ < 0 ? z = q - J : $ > 0 && (P = k - J), E < 0 ? B = H - X : E > 0 && (V = I - X), C = Rg, wt.attr("cursor", wi.selection), Gt(yt));
          break;
        }
        default:
          return;
      }
      Ig(yt);
    }
    function qe(yt) {
      switch (yt.keyCode) {
        case 16: {
          rt && (ut = ft = rt = !1, Gt(yt));
          break;
        }
        case 18: {
          C === ps && ($ < 0 ? z = q : $ > 0 && (P = k), E < 0 ? B = H : E > 0 && (V = I), C = ds, Gt(yt));
          break;
        }
        case 32: {
          C === Rg && (yt.altKey ? ($ && (z = q - J * $, P = k + J * $), E && (B = H - X * E, V = I + X * E), C = ps) : ($ < 0 ? z = q : $ > 0 && (P = k), E < 0 ? B = H : E > 0 && (V = I), C = ds), wt.attr("cursor", wi[x]), Gt(yt));
          break;
        }
        default:
          return;
      }
      Ig(yt);
    }
  }
  function g(_) {
    h(this, arguments).moved(_);
  }
  function v(_) {
    h(this, arguments).ended(_);
  }
  function b() {
    var _ = this.__brush || { selection: null };
    return _.extent = wv(e.apply(this, arguments)), _.dim = t, _;
  }
  return l.extent = function(_) {
    return arguments.length ? (e = typeof _ == "function" ? _ : Ng(wv(_)), l) : e;
  }, l.filter = function(_) {
    return arguments.length ? (n = typeof _ == "function" ? _ : Ng(!!_), l) : n;
  }, l.touchable = function(_) {
    return arguments.length ? (r = typeof _ == "function" ? _ : Ng(!!_), l) : r;
  }, l.handleSize = function(_) {
    return arguments.length ? (o = +_, l) : o;
  }, l.keyModifiers = function(_) {
    return arguments.length ? (i = !!_, l) : i;
  }, l.on = function() {
    var _ = a.on.apply(a, arguments);
    return _ === a ? l : _;
  }, l;
}
var q8 = Math.abs, ms = Math.cos, gs = Math.sin, UT = Math.PI, ch = UT / 2, G8 = UT * 2, K8 = Math.max, Dg = 1e-12;
function Fg(t, e) {
  return Array.from({ length: e - t }, (n, r) => t + r);
}
function qlt(t) {
  return function(e, n) {
    return t(
      e.source.value + e.target.value,
      n.source.value + n.target.value
    );
  };
}
function Glt() {
  return M2(!1, !1);
}
function Klt() {
  return M2(!1, !0);
}
function Xlt() {
  return M2(!0, !1);
}
function M2(t, e) {
  var n = 0, r = null, i = null, a = null;
  function o(s) {
    var l = s.length, c = new Array(l), h = Fg(0, l), d = new Array(l * l), p = new Array(l), g = 0, v;
    s = Float64Array.from({ length: l * l }, e ? (b, _) => s[_ % l][_ / l | 0] : (b, _) => s[_ / l | 0][_ % l]);
    for (let b = 0; b < l; ++b) {
      let _ = 0;
      for (let w = 0; w < l; ++w)
        _ += s[b * l + w] + t * s[w * l + b];
      g += c[b] = _;
    }
    g = K8(0, G8 - n * l) / g, v = g ? n : G8 / l;
    {
      let b = 0;
      r && h.sort((_, w) => r(c[_], c[w]));
      for (const _ of h) {
        const w = b;
        if (t) {
          const x = Fg(~l + 1, l).filter((C) => C < 0 ? s[~C * l + _] : s[_ * l + C]);
          i && x.sort((C, $) => i(C < 0 ? -s[~C * l + _] : s[_ * l + C], $ < 0 ? -s[~$ * l + _] : s[_ * l + $]));
          for (const C of x)
            if (C < 0) {
              const $ = d[~C * l + _] || (d[~C * l + _] = { source: null, target: null });
              $.target = { index: _, startAngle: b, endAngle: b += s[~C * l + _] * g, value: s[~C * l + _] };
            } else {
              const $ = d[_ * l + C] || (d[_ * l + C] = { source: null, target: null });
              $.source = { index: _, startAngle: b, endAngle: b += s[_ * l + C] * g, value: s[_ * l + C] };
            }
          p[_] = { index: _, startAngle: w, endAngle: b, value: c[_] };
        } else {
          const x = Fg(0, l).filter((C) => s[_ * l + C] || s[C * l + _]);
          i && x.sort((C, $) => i(s[_ * l + C], s[_ * l + $]));
          for (const C of x) {
            let $;
            if (_ < C ? ($ = d[_ * l + C] || (d[_ * l + C] = { source: null, target: null }), $.source = { index: _, startAngle: b, endAngle: b += s[_ * l + C] * g, value: s[_ * l + C] }) : ($ = d[C * l + _] || (d[C * l + _] = { source: null, target: null }), $.target = { index: _, startAngle: b, endAngle: b += s[_ * l + C] * g, value: s[_ * l + C] }, _ === C && ($.source = $.target)), $.source && $.target && $.source.value < $.target.value) {
              const E = $.source;
              $.source = $.target, $.target = E;
            }
          }
          p[_] = { index: _, startAngle: w, endAngle: b, value: c[_] };
        }
        b += v;
      }
    }
    return d = Object.values(d), d.groups = p, a ? d.sort(a) : d;
  }
  return o.padAngle = function(s) {
    return arguments.length ? (n = K8(0, s), o) : n;
  }, o.sortGroups = function(s) {
    return arguments.length ? (r = s, o) : r;
  }, o.sortSubgroups = function(s) {
    return arguments.length ? (i = s, o) : i;
  }, o.sortChords = function(s) {
    return arguments.length ? (s == null ? a = null : (a = qlt(s))._ = s, o) : a && a._;
  }, o;
}
const xv = Math.PI, Cv = 2 * xv, ao = 1e-6, Zlt = Cv - ao;
function $v() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function Ba() {
  return new $v();
}
$v.prototype = Ba.prototype = {
  constructor: $v,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, i, a) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - t, l = r - e, c = a - t, h = o - e, d = c * c + h * h;
    if (i < 0)
      throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (d > ao)
      if (!(Math.abs(h * s - l * c) > ao) || !i)
        this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
      else {
        var p = n - a, g = r - o, v = s * s + l * l, b = p * p + g * g, _ = Math.sqrt(v), w = Math.sqrt(d), x = i * Math.tan((xv - Math.acos((v + d - b) / (2 * _ * w))) / 2), C = x / w, $ = x / _;
        Math.abs(C - 1) > ao && (this._ += "L" + (t + C * c) + "," + (e + C * h)), this._ += "A" + i + "," + i + ",0,0," + +(h * p > c * g) + "," + (this._x1 = t + $ * s) + "," + (this._y1 = e + $ * l);
      }
  },
  arc: function(t, e, n, r, i, a) {
    t = +t, e = +e, n = +n, a = !!a;
    var o = n * Math.cos(r), s = n * Math.sin(r), l = t + o, c = e + s, h = 1 ^ a, d = a ? r - i : i - r;
    if (n < 0)
      throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + l + "," + c : (Math.abs(this._x1 - l) > ao || Math.abs(this._y1 - c) > ao) && (this._ += "L" + l + "," + c), n && (d < 0 && (d = d % Cv + Cv), d > Zlt ? this._ += "A" + n + "," + n + ",0,1," + h + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + h + "," + (this._x1 = l) + "," + (this._y1 = c) : d > ao && (this._ += "A" + n + "," + n + ",0," + +(d >= xv) + "," + h + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
var Jlt = Array.prototype.slice;
function eo(t) {
  return function() {
    return t;
  };
}
function Qlt(t) {
  return t.source;
}
function tct(t) {
  return t.target;
}
function X8(t) {
  return t.radius;
}
function ect(t) {
  return t.startAngle;
}
function nct(t) {
  return t.endAngle;
}
function rct() {
  return 0;
}
function ict() {
  return 10;
}
function YT(t) {
  var e = Qlt, n = tct, r = X8, i = X8, a = ect, o = nct, s = rct, l = null;
  function c() {
    var h, d = e.apply(this, arguments), p = n.apply(this, arguments), g = s.apply(this, arguments) / 2, v = Jlt.call(arguments), b = +r.apply(this, (v[0] = d, v)), _ = a.apply(this, v) - ch, w = o.apply(this, v) - ch, x = +i.apply(this, (v[0] = p, v)), C = a.apply(this, v) - ch, $ = o.apply(this, v) - ch;
    if (l || (l = h = Ba()), g > Dg && (q8(w - _) > g * 2 + Dg ? w > _ ? (_ += g, w -= g) : (_ -= g, w += g) : _ = w = (_ + w) / 2, q8($ - C) > g * 2 + Dg ? $ > C ? (C += g, $ -= g) : (C -= g, $ += g) : C = $ = (C + $) / 2), l.moveTo(b * ms(_), b * gs(_)), l.arc(0, 0, b, _, w), _ !== C || w !== $)
      if (t) {
        var E = +t.apply(this, arguments), A = x - E, R = (C + $) / 2;
        l.quadraticCurveTo(0, 0, A * ms(C), A * gs(C)), l.lineTo(x * ms(R), x * gs(R)), l.lineTo(A * ms($), A * gs($));
      } else
        l.quadraticCurveTo(0, 0, x * ms(C), x * gs(C)), l.arc(0, 0, x, C, $);
    if (l.quadraticCurveTo(0, 0, b * ms(_), b * gs(_)), l.closePath(), h)
      return l = null, h + "" || null;
  }
  return t && (c.headRadius = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : eo(+h), c) : t;
  }), c.radius = function(h) {
    return arguments.length ? (r = i = typeof h == "function" ? h : eo(+h), c) : r;
  }, c.sourceRadius = function(h) {
    return arguments.length ? (r = typeof h == "function" ? h : eo(+h), c) : r;
  }, c.targetRadius = function(h) {
    return arguments.length ? (i = typeof h == "function" ? h : eo(+h), c) : i;
  }, c.startAngle = function(h) {
    return arguments.length ? (a = typeof h == "function" ? h : eo(+h), c) : a;
  }, c.endAngle = function(h) {
    return arguments.length ? (o = typeof h == "function" ? h : eo(+h), c) : o;
  }, c.padAngle = function(h) {
    return arguments.length ? (s = typeof h == "function" ? h : eo(+h), c) : s;
  }, c.source = function(h) {
    return arguments.length ? (e = h, c) : e;
  }, c.target = function(h) {
    return arguments.length ? (n = h, c) : n;
  }, c.context = function(h) {
    return arguments.length ? (l = h == null ? null : h, c) : l;
  }, c;
}
function act() {
  return YT();
}
function oct() {
  return YT(ict);
}
const sct = uct(lct);
function uct(t) {
  return function(e, n, r = n) {
    if (!((n = +n) >= 0))
      throw new RangeError("invalid rx");
    if (!((r = +r) >= 0))
      throw new RangeError("invalid ry");
    let { data: i, width: a, height: o } = e;
    if (!((a = Math.floor(a)) >= 0))
      throw new RangeError("invalid width");
    if (!((o = Math.floor(o !== void 0 ? o : i.length / a)) >= 0))
      throw new RangeError("invalid height");
    if (!a || !o || !n && !r)
      return e;
    const s = n && t(n), l = r && t(r), c = i.slice();
    return s && l ? (vs(s, c, i, a, o), vs(s, i, c, a, o), vs(s, c, i, a, o), _s(l, i, c, a, o), _s(l, c, i, a, o), _s(l, i, c, a, o)) : s ? (vs(s, i, c, a, o), vs(s, c, i, a, o), vs(s, i, c, a, o)) : l && (_s(l, i, c, a, o), _s(l, c, i, a, o), _s(l, i, c, a, o)), e;
  };
}
function vs(t, e, n, r, i) {
  for (let a = 0, o = r * i; a < o; )
    t(e, n, a, a += r, 1);
}
function _s(t, e, n, r, i) {
  for (let a = 0, o = r * i; a < r; ++a)
    t(e, n, a, a + o, r);
}
function lct(t) {
  const e = Math.floor(t);
  if (e === t)
    return cct(t);
  const n = t - e, r = 2 * t + 1;
  return (i, a, o, s, l) => {
    if (!((s -= l) >= o))
      return;
    let c = e * a[o];
    const h = l * e, d = h + l;
    for (let p = o, g = o + h; p < g; p += l)
      c += a[Math.min(s, p)];
    for (let p = o, g = s; p <= g; p += l)
      c += a[Math.min(s, p + h)], i[p] = (c + n * (a[Math.max(o, p - d)] + a[Math.min(s, p + d)])) / r, c -= a[Math.max(o, p - h)];
  };
}
function cct(t) {
  const e = 2 * t + 1;
  return (n, r, i, a, o) => {
    if (!((a -= o) >= i))
      return;
    let s = t * r[i];
    const l = o * t;
    for (let c = i, h = i + l; c < h; c += o)
      s += r[Math.min(a, c)];
    for (let c = i, h = a; c <= h; c += o)
      s += r[Math.min(a, c + l)], n[c] = s / e, s -= r[Math.max(i, c - l)];
  };
}
function fct(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      r != null && (r = +r) >= r && ++n;
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (i = +i) >= i && ++n;
  }
  return n;
}
function hct(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
var Tv = Math.sqrt(50), Ov = Math.sqrt(10), Sv = Math.sqrt(2);
function qT(t, e, n) {
  var r, i = -1, a, o, s;
  if (e = +e, t = +t, n = +n, t === e && n > 0)
    return [t];
  if ((r = e < t) && (a = t, t = e, e = a), (s = dct(t, e, n)) === 0 || !isFinite(s))
    return [];
  if (s > 0) {
    let l = Math.round(t / s), c = Math.round(e / s);
    for (l * s < t && ++l, c * s > e && --c, o = new Array(a = c - l + 1); ++i < a; )
      o[i] = (l + i) * s;
  } else {
    s = -s;
    let l = Math.round(t * s), c = Math.round(e * s);
    for (l / s < t && ++l, c / s > e && --c, o = new Array(a = c - l + 1); ++i < a; )
      o[i] = (l + i) / s;
  }
  return r && o.reverse(), o;
}
function dct(t, e, n) {
  var r = (e - t) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), a = r / Math.pow(10, i);
  return i >= 0 ? (a >= Tv ? 10 : a >= Ov ? 5 : a >= Sv ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= Tv ? 10 : a >= Ov ? 5 : a >= Sv ? 2 : 1);
}
function pct(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), a = r / i;
  return a >= Tv ? i *= 10 : a >= Ov ? i *= 5 : a >= Sv && (i *= 2), e < t ? -i : i;
}
function mct(t) {
  return Math.ceil(Math.log(fct(t)) / Math.LN2) + 1;
}
function Z8(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
var gct = Array.prototype, GT = gct.slice;
function vct(t, e) {
  return t - e;
}
function _ct(t) {
  for (var e = 0, n = t.length, r = t[n - 1][1] * t[0][0] - t[n - 1][0] * t[0][1]; ++e < n; )
    r += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
  return r;
}
const oa = (t) => () => t;
function bct(t, e) {
  for (var n = -1, r = e.length, i; ++n < r; )
    if (i = yct(t, e[n]))
      return i;
  return 0;
}
function yct(t, e) {
  for (var n = e[0], r = e[1], i = -1, a = 0, o = t.length, s = o - 1; a < o; s = a++) {
    var l = t[a], c = l[0], h = l[1], d = t[s], p = d[0], g = d[1];
    if (wct(l, d, e))
      return 0;
    h > r != g > r && n < (p - c) * (r - h) / (g - h) + c && (i = -i);
  }
  return i;
}
function wct(t, e, n) {
  var r;
  return xct(t, e, n) && Cct(t[r = +(t[0] === e[0])], n[r], e[r]);
}
function xct(t, e, n) {
  return (e[0] - t[0]) * (n[1] - t[1]) === (n[0] - t[0]) * (e[1] - t[1]);
}
function Cct(t, e, n) {
  return t <= e && e <= n || n <= e && e <= t;
}
function $ct() {
}
var xi = [
  [],
  [[[1, 1.5], [0.5, 1]]],
  [[[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [0.5, 1]]],
  [[[1, 0.5], [1.5, 1]]],
  [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]],
  [[[1, 0.5], [1, 1.5]]],
  [[[1, 0.5], [0.5, 1]]],
  [[[0.5, 1], [1, 0.5]]],
  [[[1, 1.5], [1, 0.5]]],
  [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [1, 0.5]]],
  [[[0.5, 1], [1.5, 1]]],
  [[[1, 1.5], [1.5, 1]]],
  [[[0.5, 1], [1, 1.5]]],
  []
];
function Ev() {
  var t = 1, e = 1, n = mct, r = l;
  function i(c) {
    var h = n(c);
    if (Array.isArray(h))
      h = h.slice().sort(vct);
    else {
      const d = hct(c), p = pct(d[0], d[1], h);
      h = qT(Math.floor(d[0] / p) * p, Math.floor(d[1] / p - 1) * p, h);
    }
    return h.map((d) => a(c, d));
  }
  function a(c, h) {
    var d = [], p = [];
    return o(c, h, function(g) {
      r(g, c, h), _ct(g) > 0 ? d.push([g]) : p.push(g);
    }), p.forEach(function(g) {
      for (var v = 0, b = d.length, _; v < b; ++v)
        if (bct((_ = d[v])[0], g) !== -1) {
          _.push(g);
          return;
        }
    }), {
      type: "MultiPolygon",
      value: h,
      coordinates: d
    };
  }
  function o(c, h, d) {
    var p = new Array(), g = new Array(), v, b, _, w, x, C;
    for (v = b = -1, w = c[0] >= h, xi[w << 1].forEach($); ++v < t - 1; )
      _ = w, w = c[v + 1] >= h, xi[_ | w << 1].forEach($);
    for (xi[w << 0].forEach($); ++b < e - 1; ) {
      for (v = -1, w = c[b * t + t] >= h, x = c[b * t] >= h, xi[w << 1 | x << 2].forEach($); ++v < t - 1; )
        _ = w, w = c[b * t + t + v + 1] >= h, C = x, x = c[b * t + v + 1] >= h, xi[_ | w << 1 | x << 2 | C << 3].forEach($);
      xi[w | x << 3].forEach($);
    }
    for (v = -1, x = c[b * t] >= h, xi[x << 2].forEach($); ++v < t - 1; )
      C = x, x = c[b * t + v + 1] >= h, xi[x << 2 | C << 3].forEach($);
    xi[x << 3].forEach($);
    function $(E) {
      var A = [E[0][0] + v, E[0][1] + b], R = [E[1][0] + v, E[1][1] + b], L = s(A), W = s(R), P, k;
      (P = g[L]) ? (k = p[W]) ? (delete g[P.end], delete p[k.start], P === k ? (P.ring.push(R), d(P.ring)) : p[P.start] = g[k.end] = { start: P.start, end: k.end, ring: P.ring.concat(k.ring) }) : (delete g[P.end], P.ring.push(R), g[P.end = W] = P) : (P = p[W]) ? (k = g[L]) ? (delete p[P.start], delete g[k.end], P === k ? (P.ring.push(R), d(P.ring)) : p[k.start] = g[P.end] = { start: k.start, end: P.end, ring: k.ring.concat(P.ring) }) : (delete p[P.start], P.ring.unshift(A), p[P.start = L] = P) : p[L] = g[W] = { start: L, end: W, ring: [A, R] };
    }
  }
  function s(c) {
    return c[0] * 2 + c[1] * (t + 1) * 4;
  }
  function l(c, h, d) {
    c.forEach(function(p) {
      var g = p[0], v = p[1], b = g | 0, _ = v | 0, w, x = h[_ * t + b];
      g > 0 && g < t && b === g && (w = h[_ * t + b - 1], p[0] = g + (d - w) / (x - w) - 0.5), v > 0 && v < e && _ === v && (w = h[(_ - 1) * t + b], p[1] = v + (d - w) / (x - w) - 0.5);
    });
  }
  return i.contour = a, i.size = function(c) {
    if (!arguments.length)
      return [t, e];
    var h = Math.floor(c[0]), d = Math.floor(c[1]);
    if (!(h >= 0 && d >= 0))
      throw new Error("invalid size");
    return t = h, e = d, i;
  }, i.thresholds = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Array.isArray(c) ? oa(GT.call(c)) : oa(c), i) : n;
  }, i.smooth = function(c) {
    return arguments.length ? (r = c ? l : $ct, i) : r === l;
  }, i;
}
function Tct(t) {
  return t[0];
}
function Oct(t) {
  return t[1];
}
function Sct() {
  return 1;
}
function Ect() {
  var t = Tct, e = Oct, n = Sct, r = 960, i = 500, a = 20, o = 2, s = a * 3, l = r + s * 2 >> o, c = i + s * 2 >> o, h = oa(20);
  function d(x) {
    var C = new Float32Array(l * c), $ = Math.pow(2, -o), E = -1;
    for (const V of x) {
      var A = (t(V, ++E, x) + s) * $, R = (e(V, E, x) + s) * $, L = +n(V, E, x);
      if (A >= 0 && A < l && R >= 0 && R < c) {
        var W = Math.floor(A), P = Math.floor(R), k = A - W - 0.5, Y = R - P - 0.5;
        C[W + P * l] += (1 - k) * (1 - Y) * L, C[W + 1 + P * l] += k * (1 - Y) * L, C[W + 1 + (P + 1) * l] += k * Y * L, C[W + (P + 1) * l] += (1 - k) * Y * L;
      }
    }
    return sct({ data: C, width: l, height: c }, a * $), C;
  }
  function p(x) {
    var C = d(x), $ = h(C), E = Math.pow(2, 2 * o);
    return Array.isArray($) || ($ = qT(Number.MIN_VALUE, Z8(C) / E, $)), Ev().size([l, c]).thresholds($.map((A) => A * E))(C).map((A, R) => (A.value = +$[R], g(A)));
  }
  p.contours = function(x) {
    var C = d(x), $ = Ev().size([l, c]), E = Math.pow(2, 2 * o), A = (R) => {
      R = +R;
      var L = g($.contour(C, R * E));
      return L.value = R, L;
    };
    return Object.defineProperty(A, "max", { get: () => Z8(C) / E }), A;
  };
  function g(x) {
    return x.coordinates.forEach(v), x;
  }
  function v(x) {
    x.forEach(b);
  }
  function b(x) {
    x.forEach(_);
  }
  function _(x) {
    x[0] = x[0] * Math.pow(2, o) - s, x[1] = x[1] * Math.pow(2, o) - s;
  }
  function w() {
    return s = a * 3, l = r + s * 2 >> o, c = i + s * 2 >> o, p;
  }
  return p.x = function(x) {
    return arguments.length ? (t = typeof x == "function" ? x : oa(+x), p) : t;
  }, p.y = function(x) {
    return arguments.length ? (e = typeof x == "function" ? x : oa(+x), p) : e;
  }, p.weight = function(x) {
    return arguments.length ? (n = typeof x == "function" ? x : oa(+x), p) : n;
  }, p.size = function(x) {
    if (!arguments.length)
      return [r, i];
    var C = +x[0], $ = +x[1];
    if (!(C >= 0 && $ >= 0))
      throw new Error("invalid size");
    return r = C, i = $, w();
  }, p.cellSize = function(x) {
    if (!arguments.length)
      return 1 << o;
    if (!((x = +x) >= 1))
      throw new Error("invalid cell size");
    return o = Math.floor(Math.log(x) / Math.LN2), w();
  }, p.thresholds = function(x) {
    return arguments.length ? (h = typeof x == "function" ? x : Array.isArray(x) ? oa(GT.call(x)) : oa(x), p) : h;
  }, p.bandwidth = function(x) {
    if (!arguments.length)
      return Math.sqrt(a * (a + 1));
    if (!((x = +x) >= 0))
      throw new Error("invalid bandwidth");
    return a = (Math.sqrt(4 * x * x + 1) - 1) / 2, w();
  }, p;
}
const Ii = 11102230246251565e-32, on = 134217729, Act = (3 + 8 * Ii) * Ii;
function zg(t, e, n, r, i) {
  let a, o, s, l, c = e[0], h = r[0], d = 0, p = 0;
  h > c == h > -c ? (a = c, c = e[++d]) : (a = h, h = r[++p]);
  let g = 0;
  if (d < t && p < n)
    for (h > c == h > -c ? (o = c + a, s = a - (o - c), c = e[++d]) : (o = h + a, s = a - (o - h), h = r[++p]), a = o, s !== 0 && (i[g++] = s); d < t && p < n; )
      h > c == h > -c ? (o = a + c, l = o - a, s = a - (o - l) + (c - l), c = e[++d]) : (o = a + h, l = o - a, s = a - (o - l) + (h - l), h = r[++p]), a = o, s !== 0 && (i[g++] = s);
  for (; d < t; )
    o = a + c, l = o - a, s = a - (o - l) + (c - l), c = e[++d], a = o, s !== 0 && (i[g++] = s);
  for (; p < n; )
    o = a + h, l = o - a, s = a - (o - l) + (h - l), h = r[++p], a = o, s !== 0 && (i[g++] = s);
  return (a !== 0 || g === 0) && (i[g++] = a), g;
}
function Pct(t, e) {
  let n = e[0];
  for (let r = 1; r < t; r++)
    n += e[r];
  return n;
}
function jc(t) {
  return new Float64Array(t);
}
const Mct = (3 + 16 * Ii) * Ii, kct = (2 + 12 * Ii) * Ii, Nct = (9 + 64 * Ii) * Ii * Ii, bs = jc(4), J8 = jc(8), Q8 = jc(12), tw = jc(16), dn = jc(4);
function Ict(t, e, n, r, i, a, o) {
  let s, l, c, h, d, p, g, v, b, _, w, x, C, $, E, A, R, L;
  const W = t - i, P = n - i, k = e - a, Y = r - a;
  $ = W * Y, p = on * W, g = p - (p - W), v = W - g, p = on * Y, b = p - (p - Y), _ = Y - b, E = v * _ - ($ - g * b - v * b - g * _), A = k * P, p = on * k, g = p - (p - k), v = k - g, p = on * P, b = p - (p - P), _ = P - b, R = v * _ - (A - g * b - v * b - g * _), w = E - R, d = E - w, bs[0] = E - (w + d) + (d - R), x = $ + w, d = x - $, C = $ - (x - d) + (w - d), w = C - A, d = C - w, bs[1] = C - (w + d) + (d - A), L = x + w, d = L - x, bs[2] = x - (L - d) + (w - d), bs[3] = L;
  let V = Pct(4, bs), I = kct * o;
  if (V >= I || -V >= I || (d = t - W, s = t - (W + d) + (d - i), d = n - P, c = n - (P + d) + (d - i), d = e - k, l = e - (k + d) + (d - a), d = r - Y, h = r - (Y + d) + (d - a), s === 0 && l === 0 && c === 0 && h === 0) || (I = Nct * o + Act * Math.abs(V), V += W * h + Y * s - (k * c + P * l), V >= I || -V >= I))
    return V;
  $ = s * Y, p = on * s, g = p - (p - s), v = s - g, p = on * Y, b = p - (p - Y), _ = Y - b, E = v * _ - ($ - g * b - v * b - g * _), A = l * P, p = on * l, g = p - (p - l), v = l - g, p = on * P, b = p - (p - P), _ = P - b, R = v * _ - (A - g * b - v * b - g * _), w = E - R, d = E - w, dn[0] = E - (w + d) + (d - R), x = $ + w, d = x - $, C = $ - (x - d) + (w - d), w = C - A, d = C - w, dn[1] = C - (w + d) + (d - A), L = x + w, d = L - x, dn[2] = x - (L - d) + (w - d), dn[3] = L;
  const D = zg(4, bs, 4, dn, J8);
  $ = W * h, p = on * W, g = p - (p - W), v = W - g, p = on * h, b = p - (p - h), _ = h - b, E = v * _ - ($ - g * b - v * b - g * _), A = k * c, p = on * k, g = p - (p - k), v = k - g, p = on * c, b = p - (p - c), _ = c - b, R = v * _ - (A - g * b - v * b - g * _), w = E - R, d = E - w, dn[0] = E - (w + d) + (d - R), x = $ + w, d = x - $, C = $ - (x - d) + (w - d), w = C - A, d = C - w, dn[1] = C - (w + d) + (d - A), L = x + w, d = L - x, dn[2] = x - (L - d) + (w - d), dn[3] = L;
  const z = zg(D, J8, 4, dn, Q8);
  $ = s * h, p = on * s, g = p - (p - s), v = s - g, p = on * h, b = p - (p - h), _ = h - b, E = v * _ - ($ - g * b - v * b - g * _), A = l * c, p = on * l, g = p - (p - l), v = l - g, p = on * c, b = p - (p - c), _ = c - b, R = v * _ - (A - g * b - v * b - g * _), w = E - R, d = E - w, dn[0] = E - (w + d) + (d - R), x = $ + w, d = x - $, C = $ - (x - d) + (w - d), w = C - A, d = C - w, dn[1] = C - (w + d) + (d - A), L = x + w, d = L - x, dn[2] = x - (L - d) + (w - d), dn[3] = L;
  const q = zg(z, Q8, 4, dn, tw);
  return tw[q - 1];
}
function fh(t, e, n, r, i, a) {
  const o = (e - a) * (n - i), s = (t - i) * (r - a), l = o - s;
  if (o === 0 || s === 0 || o > 0 != s > 0)
    return l;
  const c = Math.abs(o + s);
  return Math.abs(l) >= Mct * c ? l : -Ict(t, e, n, r, i, a, c);
}
const ew = Math.pow(2, -52), hh = new Uint32Array(512);
class Id {
  static from(e, n = zct, r = Bct) {
    const i = e.length, a = new Float64Array(i * 2);
    for (let o = 0; o < i; o++) {
      const s = e[o];
      a[2 * o] = n(s), a[2 * o + 1] = r(s);
    }
    return new Id(a);
  }
  constructor(e) {
    const n = e.length >> 1;
    if (n > 0 && typeof e[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = e;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize).fill(-1), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: e, _hullPrev: n, _hullNext: r, _hullTri: i, _hullHash: a } = this, o = e.length >> 1;
    let s = 1 / 0, l = 1 / 0, c = -1 / 0, h = -1 / 0;
    for (let P = 0; P < o; P++) {
      const k = e[2 * P], Y = e[2 * P + 1];
      k < s && (s = k), Y < l && (l = Y), k > c && (c = k), Y > h && (h = Y), this._ids[P] = P;
    }
    const d = (s + c) / 2, p = (l + h) / 2;
    let g = 1 / 0, v, b, _;
    for (let P = 0; P < o; P++) {
      const k = Bg(d, p, e[2 * P], e[2 * P + 1]);
      k < g && (v = P, g = k);
    }
    const w = e[2 * v], x = e[2 * v + 1];
    g = 1 / 0;
    for (let P = 0; P < o; P++) {
      if (P === v)
        continue;
      const k = Bg(w, x, e[2 * P], e[2 * P + 1]);
      k < g && k > 0 && (b = P, g = k);
    }
    let C = e[2 * b], $ = e[2 * b + 1], E = 1 / 0;
    for (let P = 0; P < o; P++) {
      if (P === v || P === b)
        continue;
      const k = Dct(w, x, C, $, e[2 * P], e[2 * P + 1]);
      k < E && (_ = P, E = k);
    }
    let A = e[2 * _], R = e[2 * _ + 1];
    if (E === 1 / 0) {
      for (let Y = 0; Y < o; Y++)
        this._dists[Y] = e[2 * Y] - e[0] || e[2 * Y + 1] - e[1];
      Ns(this._ids, this._dists, 0, o - 1);
      const P = new Uint32Array(o);
      let k = 0;
      for (let Y = 0, V = -1 / 0; Y < o; Y++) {
        const I = this._ids[Y];
        this._dists[I] > V && (P[k++] = I, V = this._dists[I]);
      }
      this.hull = P.subarray(0, k), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (fh(w, x, C, $, A, R) < 0) {
      const P = b, k = C, Y = $;
      b = _, C = A, $ = R, _ = P, A = k, R = Y;
    }
    const L = Fct(w, x, C, $, A, R);
    this._cx = L.x, this._cy = L.y;
    for (let P = 0; P < o; P++)
      this._dists[P] = Bg(e[2 * P], e[2 * P + 1], L.x, L.y);
    Ns(this._ids, this._dists, 0, o - 1), this._hullStart = v;
    let W = 3;
    r[v] = n[_] = b, r[b] = n[v] = _, r[_] = n[b] = v, i[v] = 0, i[b] = 1, i[_] = 2, a.fill(-1), a[this._hashKey(w, x)] = v, a[this._hashKey(C, $)] = b, a[this._hashKey(A, R)] = _, this.trianglesLen = 0, this._addTriangle(v, b, _, -1, -1, -1);
    for (let P = 0, k, Y; P < this._ids.length; P++) {
      const V = this._ids[P], I = e[2 * V], D = e[2 * V + 1];
      if (P > 0 && Math.abs(I - k) <= ew && Math.abs(D - Y) <= ew || (k = I, Y = D, V === v || V === b || V === _))
        continue;
      let z = 0;
      for (let J = 0, X = this._hashKey(I, D); J < this._hashSize && (z = a[(X + J) % this._hashSize], !(z !== -1 && z !== r[z])); J++)
        ;
      z = n[z];
      let q = z, Z;
      for (; Z = r[q], fh(I, D, e[2 * q], e[2 * q + 1], e[2 * Z], e[2 * Z + 1]) >= 0; )
        if (q = Z, q === z) {
          q = -1;
          break;
        }
      if (q === -1)
        continue;
      let B = this._addTriangle(q, V, r[q], -1, -1, i[q]);
      i[V] = this._legalize(B + 2), i[q] = B, W++;
      let H = r[q];
      for (; Z = r[H], fh(I, D, e[2 * H], e[2 * H + 1], e[2 * Z], e[2 * Z + 1]) < 0; )
        B = this._addTriangle(H, V, Z, i[V], -1, i[H]), i[V] = this._legalize(B + 2), r[H] = H, W--, H = Z;
      if (q === z)
        for (; Z = n[q], fh(I, D, e[2 * Z], e[2 * Z + 1], e[2 * q], e[2 * q + 1]) < 0; )
          B = this._addTriangle(Z, V, q, -1, i[q], i[Z]), this._legalize(B + 2), i[Z] = B, r[q] = q, W--, q = Z;
      this._hullStart = n[V] = q, r[q] = n[H] = V, r[V] = H, a[this._hashKey(I, D)] = V, a[this._hashKey(e[2 * q], e[2 * q + 1])] = q;
    }
    this.hull = new Uint32Array(W);
    for (let P = 0, k = this._hullStart; P < W; P++)
      this.hull[P] = k, k = r[k];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(e, n) {
    return Math.floor(Rct(e - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(e) {
    const { _triangles: n, _halfedges: r, coords: i } = this;
    let a = 0, o = 0;
    for (; ; ) {
      const s = r[e], l = e - e % 3;
      if (o = l + (e + 2) % 3, s === -1) {
        if (a === 0)
          break;
        e = hh[--a];
        continue;
      }
      const c = s - s % 3, h = l + (e + 1) % 3, d = c + (s + 2) % 3, p = n[o], g = n[e], v = n[h], b = n[d];
      if (Lct(
        i[2 * p],
        i[2 * p + 1],
        i[2 * g],
        i[2 * g + 1],
        i[2 * v],
        i[2 * v + 1],
        i[2 * b],
        i[2 * b + 1]
      )) {
        n[e] = b, n[s] = p;
        const w = r[d];
        if (w === -1) {
          let C = this._hullStart;
          do {
            if (this._hullTri[C] === d) {
              this._hullTri[C] = e;
              break;
            }
            C = this._hullPrev[C];
          } while (C !== this._hullStart);
        }
        this._link(e, w), this._link(s, r[o]), this._link(o, d);
        const x = c + (s + 1) % 3;
        a < hh.length && (hh[a++] = x);
      } else {
        if (a === 0)
          break;
        e = hh[--a];
      }
    }
    return o;
  }
  _link(e, n) {
    this._halfedges[e] = n, n !== -1 && (this._halfedges[n] = e);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(e, n, r, i, a, o) {
    const s = this.trianglesLen;
    return this._triangles[s] = e, this._triangles[s + 1] = n, this._triangles[s + 2] = r, this._link(s, i), this._link(s + 1, a), this._link(s + 2, o), this.trianglesLen += 3, s;
  }
}
function Rct(t, e) {
  const n = t / (Math.abs(t) + Math.abs(e));
  return (e > 0 ? 3 - n : 1 + n) / 4;
}
function Bg(t, e, n, r) {
  const i = t - n, a = e - r;
  return i * i + a * a;
}
function Lct(t, e, n, r, i, a, o, s) {
  const l = t - o, c = e - s, h = n - o, d = r - s, p = i - o, g = a - s, v = l * l + c * c, b = h * h + d * d, _ = p * p + g * g;
  return l * (d * _ - b * g) - c * (h * _ - b * p) + v * (h * g - d * p) < 0;
}
function Dct(t, e, n, r, i, a) {
  const o = n - t, s = r - e, l = i - t, c = a - e, h = o * o + s * s, d = l * l + c * c, p = 0.5 / (o * c - s * l), g = (c * h - s * d) * p, v = (o * d - l * h) * p;
  return g * g + v * v;
}
function Fct(t, e, n, r, i, a) {
  const o = n - t, s = r - e, l = i - t, c = a - e, h = o * o + s * s, d = l * l + c * c, p = 0.5 / (o * c - s * l), g = t + (c * h - s * d) * p, v = e + (o * d - l * h) * p;
  return { x: g, y: v };
}
function Ns(t, e, n, r) {
  if (r - n <= 20)
    for (let i = n + 1; i <= r; i++) {
      const a = t[i], o = e[a];
      let s = i - 1;
      for (; s >= n && e[t[s]] > o; )
        t[s + 1] = t[s--];
      t[s + 1] = a;
    }
  else {
    const i = n + r >> 1;
    let a = n + 1, o = r;
    cl(t, i, a), e[t[n]] > e[t[r]] && cl(t, n, r), e[t[a]] > e[t[r]] && cl(t, a, r), e[t[n]] > e[t[a]] && cl(t, n, a);
    const s = t[a], l = e[s];
    for (; ; ) {
      do
        a++;
      while (e[t[a]] < l);
      do
        o--;
      while (e[t[o]] > l);
      if (o < a)
        break;
      cl(t, a, o);
    }
    t[n + 1] = t[o], t[o] = s, r - a + 1 >= o - n ? (Ns(t, e, a, r), Ns(t, e, n, o - 1)) : (Ns(t, e, n, o - 1), Ns(t, e, a, r));
  }
}
function cl(t, e, n) {
  const r = t[e];
  t[e] = t[n], t[n] = r;
}
function zct(t) {
  return t[0];
}
function Bct(t) {
  return t[1];
}
const nw = 1e-6;
class mo {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(e, n) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(e, n) {
    this._ += `L${this._x1 = +e},${this._y1 = +n}`;
  }
  arc(e, n, r) {
    e = +e, n = +n, r = +r;
    const i = e + r, a = n;
    if (r < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${i},${a}` : (Math.abs(this._x1 - i) > nw || Math.abs(this._y1 - a) > nw) && (this._ += "L" + i + "," + a), r && (this._ += `A${r},${r},0,1,1,${e - r},${n}A${r},${r},0,1,1,${this._x1 = i},${this._y1 = a}`);
  }
  rect(e, n, r, i) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}h${+r}v${+i}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class Av {
  constructor() {
    this._ = [];
  }
  moveTo(e, n) {
    this._.push([e, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(e, n) {
    this._.push([e, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class KT {
  constructor(e, [n, r, i, a] = [0, 0, 960, 500]) {
    if (!((i = +i) >= (n = +n)) || !((a = +a) >= (r = +r)))
      throw new Error("invalid bounds");
    this.delaunay = e, this._circumcenters = new Float64Array(e.points.length * 2), this.vectors = new Float64Array(e.points.length * 2), this.xmax = i, this.xmin = n, this.ymax = a, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: e, hull: n, triangles: r }, vectors: i } = this, a = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let g = 0, v = 0, b = r.length, _, w; g < b; g += 3, v += 2) {
      const x = r[g] * 2, C = r[g + 1] * 2, $ = r[g + 2] * 2, E = e[x], A = e[x + 1], R = e[C], L = e[C + 1], W = e[$], P = e[$ + 1], k = R - E, Y = L - A, V = W - E, I = P - A, D = (k * I - Y * V) * 2;
      if (Math.abs(D) < 1e-9) {
        let z = 1e9;
        const q = r[0] * 2;
        z *= Math.sign((e[q] - E) * I - (e[q + 1] - A) * V), _ = (E + W) / 2 - z * I, w = (A + P) / 2 + z * V;
      } else {
        const z = 1 / D, q = k * k + Y * Y, Z = V * V + I * I;
        _ = E + (I * q - Y * Z) * z, w = A + (k * Z - V * q) * z;
      }
      a[v] = _, a[v + 1] = w;
    }
    let o = n[n.length - 1], s, l = o * 4, c, h = e[2 * o], d, p = e[2 * o + 1];
    i.fill(0);
    for (let g = 0; g < n.length; ++g)
      o = n[g], s = l, c = h, d = p, l = o * 4, h = e[2 * o], p = e[2 * o + 1], i[s + 2] = i[l] = d - p, i[s + 3] = i[l + 1] = h - c;
  }
  render(e) {
    const n = e == null ? e = new mo() : void 0, { delaunay: { halfedges: r, inedges: i, hull: a }, circumcenters: o, vectors: s } = this;
    if (a.length <= 1)
      return null;
    for (let h = 0, d = r.length; h < d; ++h) {
      const p = r[h];
      if (p < h)
        continue;
      const g = Math.floor(h / 3) * 2, v = Math.floor(p / 3) * 2, b = o[g], _ = o[g + 1], w = o[v], x = o[v + 1];
      this._renderSegment(b, _, w, x, e);
    }
    let l, c = a[a.length - 1];
    for (let h = 0; h < a.length; ++h) {
      l = c, c = a[h];
      const d = Math.floor(i[c] / 3) * 2, p = o[d], g = o[d + 1], v = l * 4, b = this._project(p, g, s[v + 2], s[v + 3]);
      b && this._renderSegment(p, g, b[0], b[1], e);
    }
    return n && n.value();
  }
  renderBounds(e) {
    const n = e == null ? e = new mo() : void 0;
    return e.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(e, n) {
    const r = n == null ? n = new mo() : void 0, i = this._clip(e);
    if (i === null || !i.length)
      return;
    n.moveTo(i[0], i[1]);
    let a = i.length;
    for (; i[0] === i[a - 2] && i[1] === i[a - 1] && a > 1; )
      a -= 2;
    for (let o = 2; o < a; o += 2)
      (i[o] !== i[o - 2] || i[o + 1] !== i[o - 1]) && n.lineTo(i[o], i[o + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: e } } = this;
    for (let n = 0, r = e.length / 2; n < r; ++n) {
      const i = this.cellPolygon(n);
      i && (i.index = n, yield i);
    }
  }
  cellPolygon(e) {
    const n = new Av();
    return this.renderCell(e, n), n.value();
  }
  _renderSegment(e, n, r, i, a) {
    let o;
    const s = this._regioncode(e, n), l = this._regioncode(r, i);
    s === 0 && l === 0 ? (a.moveTo(e, n), a.lineTo(r, i)) : (o = this._clipSegment(e, n, r, i, s, l)) && (a.moveTo(o[0], o[1]), a.lineTo(o[2], o[3]));
  }
  contains(e, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(e, n, r) === e;
  }
  *neighbors(e) {
    const n = this._clip(e);
    if (n)
      for (const r of this.delaunay.neighbors(e)) {
        const i = this._clip(r);
        if (i) {
          t:
            for (let a = 0, o = n.length; a < o; a += 2)
              for (let s = 0, l = i.length; s < l; s += 2)
                if (n[a] == i[s] && n[a + 1] == i[s + 1] && n[(a + 2) % o] == i[(s + l - 2) % l] && n[(a + 3) % o] == i[(s + l - 1) % l]) {
                  yield r;
                  break t;
                }
        }
      }
  }
  _cell(e) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: i, triangles: a } } = this, o = r[e];
    if (o === -1)
      return null;
    const s = [];
    let l = o;
    do {
      const c = Math.floor(l / 3);
      if (s.push(n[c * 2], n[c * 2 + 1]), l = l % 3 === 2 ? l - 2 : l + 1, a[l] !== e)
        break;
      l = i[l];
    } while (l !== o && l !== -1);
    return s;
  }
  _clip(e) {
    if (e === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(e);
    if (n === null)
      return null;
    const { vectors: r } = this, i = e * 4;
    return r[i] || r[i + 1] ? this._clipInfinite(e, n, r[i], r[i + 1], r[i + 2], r[i + 3]) : this._clipFinite(e, n);
  }
  _clipFinite(e, n) {
    const r = n.length;
    let i = null, a, o, s = n[r - 2], l = n[r - 1], c, h = this._regioncode(s, l), d, p = 0;
    for (let g = 0; g < r; g += 2)
      if (a = s, o = l, s = n[g], l = n[g + 1], c = h, h = this._regioncode(s, l), c === 0 && h === 0)
        d = p, p = 0, i ? i.push(s, l) : i = [s, l];
      else {
        let v, b, _, w, x;
        if (c === 0) {
          if ((v = this._clipSegment(a, o, s, l, c, h)) === null)
            continue;
          [b, _, w, x] = v;
        } else {
          if ((v = this._clipSegment(s, l, a, o, h, c)) === null)
            continue;
          [w, x, b, _] = v, d = p, p = this._edgecode(b, _), d && p && this._edge(e, d, p, i, i.length), i ? i.push(b, _) : i = [b, _];
        }
        d = p, p = this._edgecode(w, x), d && p && this._edge(e, d, p, i, i.length), i ? i.push(w, x) : i = [w, x];
      }
    if (i)
      d = p, p = this._edgecode(i[0], i[1]), d && p && this._edge(e, d, p, i, i.length);
    else if (this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return i;
  }
  _clipSegment(e, n, r, i, a, o) {
    for (; ; ) {
      if (a === 0 && o === 0)
        return [e, n, r, i];
      if (a & o)
        return null;
      let s, l, c = a || o;
      c & 8 ? (s = e + (r - e) * (this.ymax - n) / (i - n), l = this.ymax) : c & 4 ? (s = e + (r - e) * (this.ymin - n) / (i - n), l = this.ymin) : c & 2 ? (l = n + (i - n) * (this.xmax - e) / (r - e), s = this.xmax) : (l = n + (i - n) * (this.xmin - e) / (r - e), s = this.xmin), a ? (e = s, n = l, a = this._regioncode(e, n)) : (r = s, i = l, o = this._regioncode(r, i));
    }
  }
  _clipInfinite(e, n, r, i, a, o) {
    let s = Array.from(n), l;
    if ((l = this._project(s[0], s[1], r, i)) && s.unshift(l[0], l[1]), (l = this._project(s[s.length - 2], s[s.length - 1], a, o)) && s.push(l[0], l[1]), s = this._clipFinite(e, s))
      for (let c = 0, h = s.length, d, p = this._edgecode(s[h - 2], s[h - 1]); c < h; c += 2)
        d = p, p = this._edgecode(s[c], s[c + 1]), d && p && (c = this._edge(e, d, p, s, c), h = s.length);
    else
      this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(e, n, r, i, a) {
    for (; n !== r; ) {
      let o, s;
      switch (n) {
        case 5:
          n = 4;
          continue;
        case 4:
          n = 6, o = this.xmax, s = this.ymin;
          break;
        case 6:
          n = 2;
          continue;
        case 2:
          n = 10, o = this.xmax, s = this.ymax;
          break;
        case 10:
          n = 8;
          continue;
        case 8:
          n = 9, o = this.xmin, s = this.ymax;
          break;
        case 9:
          n = 1;
          continue;
        case 1:
          n = 5, o = this.xmin, s = this.ymin;
          break;
      }
      (i[a] !== o || i[a + 1] !== s) && this.contains(e, o, s) && (i.splice(a, 0, o, s), a += 2);
    }
    if (i.length > 4)
      for (let o = 0; o < i.length; o += 2) {
        const s = (o + 2) % i.length, l = (o + 4) % i.length;
        (i[o] === i[s] && i[s] === i[l] || i[o + 1] === i[s + 1] && i[s + 1] === i[l + 1]) && (i.splice(s, 2), o -= 2);
      }
    return a;
  }
  _project(e, n, r, i) {
    let a = 1 / 0, o, s, l;
    if (i < 0) {
      if (n <= this.ymin)
        return null;
      (o = (this.ymin - n) / i) < a && (l = this.ymin, s = e + (a = o) * r);
    } else if (i > 0) {
      if (n >= this.ymax)
        return null;
      (o = (this.ymax - n) / i) < a && (l = this.ymax, s = e + (a = o) * r);
    }
    if (r > 0) {
      if (e >= this.xmax)
        return null;
      (o = (this.xmax - e) / r) < a && (s = this.xmax, l = n + (a = o) * i);
    } else if (r < 0) {
      if (e <= this.xmin)
        return null;
      (o = (this.xmin - e) / r) < a && (s = this.xmin, l = n + (a = o) * i);
    }
    return [s, l];
  }
  _edgecode(e, n) {
    return (e === this.xmin ? 1 : e === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(e, n) {
    return (e < this.xmin ? 1 : e > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
}
const Hct = 2 * Math.PI, ys = Math.pow;
function jct(t) {
  return t[0];
}
function Vct(t) {
  return t[1];
}
function Wct(t) {
  const { triangles: e, coords: n } = t;
  for (let r = 0; r < e.length; r += 3) {
    const i = 2 * e[r], a = 2 * e[r + 1], o = 2 * e[r + 2];
    if ((n[o] - n[i]) * (n[a + 1] - n[i + 1]) - (n[a] - n[i]) * (n[o + 1] - n[i + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function Uct(t, e, n) {
  return [t + Math.sin(t + e) * n, e + Math.cos(t - e) * n];
}
class k2 {
  static from(e, n = jct, r = Vct, i) {
    return new k2("length" in e ? Yct(e, n, r, i) : Float64Array.from(qct(e, n, r, i)));
  }
  constructor(e) {
    this._delaunator = new Id(e), this.inedges = new Int32Array(e.length / 2), this._hullIndex = new Int32Array(e.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const e = this._delaunator, n = this.points;
    if (e.hull && e.hull.length > 2 && Wct(e)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (p, g) => g).sort((p, g) => n[2 * p] - n[2 * g] || n[2 * p + 1] - n[2 * g + 1]);
      const l = this.collinear[0], c = this.collinear[this.collinear.length - 1], h = [n[2 * l], n[2 * l + 1], n[2 * c], n[2 * c + 1]], d = 1e-8 * Math.hypot(h[3] - h[1], h[2] - h[0]);
      for (let p = 0, g = n.length / 2; p < g; ++p) {
        const v = Uct(n[2 * p], n[2 * p + 1], d);
        n[2 * p] = v[0], n[2 * p + 1] = v[1];
      }
      this._delaunator = new Id(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, i = this.hull = this._delaunator.hull, a = this.triangles = this._delaunator.triangles, o = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let l = 0, c = r.length; l < c; ++l) {
      const h = a[l % 3 === 2 ? l - 2 : l + 1];
      (r[l] === -1 || o[h] === -1) && (o[h] = l);
    }
    for (let l = 0, c = i.length; l < c; ++l)
      s[i[l]] = l;
    i.length <= 2 && i.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = i[0], o[i[0]] = 1, i.length === 2 && (o[i[1]] = 0, this.triangles[1] = i[1], this.triangles[2] = i[1]));
  }
  voronoi(e) {
    return new KT(this, e);
  }
  *neighbors(e) {
    const { inedges: n, hull: r, _hullIndex: i, halfedges: a, triangles: o, collinear: s } = this;
    if (s) {
      const d = s.indexOf(e);
      d > 0 && (yield s[d - 1]), d < s.length - 1 && (yield s[d + 1]);
      return;
    }
    const l = n[e];
    if (l === -1)
      return;
    let c = l, h = -1;
    do {
      if (yield h = o[c], c = c % 3 === 2 ? c - 2 : c + 1, o[c] !== e)
        return;
      if (c = a[c], c === -1) {
        const d = r[(i[e] + 1) % r.length];
        d !== h && (yield d);
        return;
      }
    } while (c !== l);
  }
  find(e, n, r = 0) {
    if (e = +e, e !== e || (n = +n, n !== n))
      return -1;
    const i = r;
    let a;
    for (; (a = this._step(r, e, n)) >= 0 && a !== r && a !== i; )
      r = a;
    return a;
  }
  _step(e, n, r) {
    const { inedges: i, hull: a, _hullIndex: o, halfedges: s, triangles: l, points: c } = this;
    if (i[e] === -1 || !c.length)
      return (e + 1) % (c.length >> 1);
    let h = e, d = ys(n - c[e * 2], 2) + ys(r - c[e * 2 + 1], 2);
    const p = i[e];
    let g = p;
    do {
      let v = l[g];
      const b = ys(n - c[v * 2], 2) + ys(r - c[v * 2 + 1], 2);
      if (b < d && (d = b, h = v), g = g % 3 === 2 ? g - 2 : g + 1, l[g] !== e)
        break;
      if (g = s[g], g === -1) {
        if (g = a[(o[e] + 1) % a.length], g !== v && ys(n - c[g * 2], 2) + ys(r - c[g * 2 + 1], 2) < d)
          return g;
        break;
      }
    } while (g !== p);
    return h;
  }
  render(e) {
    const n = e == null ? e = new mo() : void 0, { points: r, halfedges: i, triangles: a } = this;
    for (let o = 0, s = i.length; o < s; ++o) {
      const l = i[o];
      if (l < o)
        continue;
      const c = a[o] * 2, h = a[l] * 2;
      e.moveTo(r[c], r[c + 1]), e.lineTo(r[h], r[h + 1]);
    }
    return this.renderHull(e), n && n.value();
  }
  renderPoints(e, n) {
    n === void 0 && (!e || typeof e.moveTo != "function") && (n = e, e = null), n = n == null ? 2 : +n;
    const r = e == null ? e = new mo() : void 0, { points: i } = this;
    for (let a = 0, o = i.length; a < o; a += 2) {
      const s = i[a], l = i[a + 1];
      e.moveTo(s + n, l), e.arc(s, l, n, 0, Hct);
    }
    return r && r.value();
  }
  renderHull(e) {
    const n = e == null ? e = new mo() : void 0, { hull: r, points: i } = this, a = r[0] * 2, o = r.length;
    e.moveTo(i[a], i[a + 1]);
    for (let s = 1; s < o; ++s) {
      const l = 2 * r[s];
      e.lineTo(i[l], i[l + 1]);
    }
    return e.closePath(), n && n.value();
  }
  hullPolygon() {
    const e = new Av();
    return this.renderHull(e), e.value();
  }
  renderTriangle(e, n) {
    const r = n == null ? n = new mo() : void 0, { points: i, triangles: a } = this, o = a[e *= 3] * 2, s = a[e + 1] * 2, l = a[e + 2] * 2;
    return n.moveTo(i[o], i[o + 1]), n.lineTo(i[s], i[s + 1]), n.lineTo(i[l], i[l + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: e } = this;
    for (let n = 0, r = e.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(e) {
    const n = new Av();
    return this.renderTriangle(e, n), n.value();
  }
}
function Yct(t, e, n, r) {
  const i = t.length, a = new Float64Array(i * 2);
  for (let o = 0; o < i; ++o) {
    const s = t[o];
    a[o * 2] = e.call(r, s, o, t), a[o * 2 + 1] = n.call(r, s, o, t);
  }
  return a;
}
function* qct(t, e, n, r) {
  let i = 0;
  for (const a of t)
    yield e.call(r, a, i, t), yield n.call(r, a, i, t), ++i;
}
var rw = {}, Hg = {}, jg = 34, fl = 10, Vg = 13;
function XT(t) {
  return new Function("d", "return {" + t.map(function(e, n) {
    return JSON.stringify(e) + ": d[" + n + '] || ""';
  }).join(",") + "}");
}
function Gct(t, e) {
  var n = XT(t);
  return function(r, i) {
    return e(n(r), i, t);
  };
}
function iw(t) {
  var e = /* @__PURE__ */ Object.create(null), n = [];
  return t.forEach(function(r) {
    for (var i in r)
      i in e || n.push(e[i] = i);
  }), n;
}
function Rn(t, e) {
  var n = t + "", r = n.length;
  return r < e ? new Array(e - r + 1).join(0) + n : n;
}
function Kct(t) {
  return t < 0 ? "-" + Rn(-t, 6) : t > 9999 ? "+" + Rn(t, 6) : Rn(t, 4);
}
function Xct(t) {
  var e = t.getUTCHours(), n = t.getUTCMinutes(), r = t.getUTCSeconds(), i = t.getUTCMilliseconds();
  return isNaN(t) ? "Invalid Date" : Kct(t.getUTCFullYear()) + "-" + Rn(t.getUTCMonth() + 1, 2) + "-" + Rn(t.getUTCDate(), 2) + (i ? "T" + Rn(e, 2) + ":" + Rn(n, 2) + ":" + Rn(r, 2) + "." + Rn(i, 3) + "Z" : r ? "T" + Rn(e, 2) + ":" + Rn(n, 2) + ":" + Rn(r, 2) + "Z" : n || e ? "T" + Rn(e, 2) + ":" + Rn(n, 2) + "Z" : "");
}
function g1(t) {
  var e = new RegExp('["' + t + `
\r]`), n = t.charCodeAt(0);
  function r(d, p) {
    var g, v, b = i(d, function(_, w) {
      if (g)
        return g(_, w - 1);
      v = _, g = p ? Gct(_, p) : XT(_);
    });
    return b.columns = v || [], b;
  }
  function i(d, p) {
    var g = [], v = d.length, b = 0, _ = 0, w, x = v <= 0, C = !1;
    d.charCodeAt(v - 1) === fl && --v, d.charCodeAt(v - 1) === Vg && --v;
    function $() {
      if (x)
        return Hg;
      if (C)
        return C = !1, rw;
      var A, R = b, L;
      if (d.charCodeAt(R) === jg) {
        for (; b++ < v && d.charCodeAt(b) !== jg || d.charCodeAt(++b) === jg; )
          ;
        return (A = b) >= v ? x = !0 : (L = d.charCodeAt(b++)) === fl ? C = !0 : L === Vg && (C = !0, d.charCodeAt(b) === fl && ++b), d.slice(R + 1, A - 1).replace(/""/g, '"');
      }
      for (; b < v; ) {
        if ((L = d.charCodeAt(A = b++)) === fl)
          C = !0;
        else if (L === Vg)
          C = !0, d.charCodeAt(b) === fl && ++b;
        else if (L !== n)
          continue;
        return d.slice(R, A);
      }
      return x = !0, d.slice(R, v);
    }
    for (; (w = $()) !== Hg; ) {
      for (var E = []; w !== rw && w !== Hg; )
        E.push(w), w = $();
      p && (E = p(E, _++)) == null || g.push(E);
    }
    return g;
  }
  function a(d, p) {
    return d.map(function(g) {
      return p.map(function(v) {
        return h(g[v]);
      }).join(t);
    });
  }
  function o(d, p) {
    return p == null && (p = iw(d)), [p.map(h).join(t)].concat(a(d, p)).join(`
`);
  }
  function s(d, p) {
    return p == null && (p = iw(d)), a(d, p).join(`
`);
  }
  function l(d) {
    return d.map(c).join(`
`);
  }
  function c(d) {
    return d.map(h).join(t);
  }
  function h(d) {
    return d == null ? "" : d instanceof Date ? Xct(d) : e.test(d += "") ? '"' + d.replace(/"/g, '""') + '"' : d;
  }
  return {
    parse: r,
    parseRows: i,
    format: o,
    formatBody: s,
    formatRows: l,
    formatRow: c,
    formatValue: h
  };
}
var Vo = g1(","), ZT = Vo.parse, Zct = Vo.parseRows, Jct = Vo.format, Qct = Vo.formatBody, tft = Vo.formatRows, eft = Vo.formatRow, nft = Vo.formatValue, Wo = g1("	"), JT = Wo.parse, rft = Wo.parseRows, ift = Wo.format, aft = Wo.formatBody, oft = Wo.formatRows, sft = Wo.formatRow, uft = Wo.formatValue;
function lft(t) {
  for (var e in t) {
    var n = t[e].trim(), r, i;
    if (!n)
      n = null;
    else if (n === "true")
      n = !0;
    else if (n === "false")
      n = !1;
    else if (n === "NaN")
      n = NaN;
    else if (!isNaN(r = +n))
      n = r;
    else if (i = n.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/))
      cft && i[4] && !i[7] && (n = n.replace(/-/g, "/").replace(/T/, " ")), n = new Date(n);
    else
      continue;
    t[e] = n;
  }
  return t;
}
const cft = (/* @__PURE__ */ new Date("2019-01-01T00:00")).getHours() || (/* @__PURE__ */ new Date("2019-07-01T00:00")).getHours();
function fft(t) {
  if (!t.ok)
    throw new Error(t.status + " " + t.statusText);
  return t.blob();
}
function hft(t, e) {
  return fetch(t, e).then(fft);
}
function dft(t) {
  if (!t.ok)
    throw new Error(t.status + " " + t.statusText);
  return t.arrayBuffer();
}
function pft(t, e) {
  return fetch(t, e).then(dft);
}
function mft(t) {
  if (!t.ok)
    throw new Error(t.status + " " + t.statusText);
  return t.text();
}
function v1(t, e) {
  return fetch(t, e).then(mft);
}
function QT(t) {
  return function(e, n, r) {
    return arguments.length === 2 && typeof n == "function" && (r = n, n = void 0), v1(e, n).then(function(i) {
      return t(i, r);
    });
  };
}
function gft(t, e, n, r) {
  arguments.length === 3 && typeof n == "function" && (r = n, n = void 0);
  var i = g1(t);
  return v1(e, n).then(function(a) {
    return i.parse(a, r);
  });
}
var vft = QT(ZT), _ft = QT(JT);
function bft(t, e) {
  return new Promise(function(n, r) {
    var i = new Image();
    for (var a in e)
      i[a] = e[a];
    i.onerror = r, i.onload = function() {
      n(i);
    }, i.src = t;
  });
}
function yft(t) {
  if (!t.ok)
    throw new Error(t.status + " " + t.statusText);
  if (!(t.status === 204 || t.status === 205))
    return t.json();
}
function N2(t, e) {
  return fetch(t, e).then(yft);
}
function I2(t) {
  return (e, n) => v1(e, n).then((r) => new DOMParser().parseFromString(r, t));
}
const wft = I2("application/xml");
var xft = I2("text/html"), Cft = I2("image/svg+xml");
function $ft(t, e) {
  var n, r = 1;
  t == null && (t = 0), e == null && (e = 0);
  function i() {
    var a, o = n.length, s, l = 0, c = 0;
    for (a = 0; a < o; ++a)
      s = n[a], l += s.x, c += s.y;
    for (l = (l / o - t) * r, c = (c / o - e) * r, a = 0; a < o; ++a)
      s = n[a], s.x -= l, s.y -= c;
  }
  return i.initialize = function(a) {
    n = a;
  }, i.x = function(a) {
    return arguments.length ? (t = +a, i) : t;
  }, i.y = function(a) {
    return arguments.length ? (e = +a, i) : e;
  }, i.strength = function(a) {
    return arguments.length ? (r = +a, i) : r;
  }, i;
}
function Tft(t) {
  const e = +this._x.call(null, t), n = +this._y.call(null, t);
  return tO(this.cover(e, n), e, n, t);
}
function tO(t, e, n, r) {
  if (isNaN(e) || isNaN(n))
    return t;
  var i, a = t._root, o = { data: r }, s = t._x0, l = t._y0, c = t._x1, h = t._y1, d, p, g, v, b, _, w, x;
  if (!a)
    return t._root = o, t;
  for (; a.length; )
    if ((b = e >= (d = (s + c) / 2)) ? s = d : c = d, (_ = n >= (p = (l + h) / 2)) ? l = p : h = p, i = a, !(a = a[w = _ << 1 | b]))
      return i[w] = o, t;
  if (g = +t._x.call(null, a.data), v = +t._y.call(null, a.data), e === g && n === v)
    return o.next = a, i ? i[w] = o : t._root = o, t;
  do
    i = i ? i[w] = new Array(4) : t._root = new Array(4), (b = e >= (d = (s + c) / 2)) ? s = d : c = d, (_ = n >= (p = (l + h) / 2)) ? l = p : h = p;
  while ((w = _ << 1 | b) === (x = (v >= p) << 1 | g >= d));
  return i[x] = a, i[w] = o, t;
}
function Oft(t) {
  var e, n, r = t.length, i, a, o = new Array(r), s = new Array(r), l = 1 / 0, c = 1 / 0, h = -1 / 0, d = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, e = t[n])) || isNaN(a = +this._y.call(null, e)) || (o[n] = i, s[n] = a, i < l && (l = i), i > h && (h = i), a < c && (c = a), a > d && (d = a));
  if (l > h || c > d)
    return this;
  for (this.cover(l, c).cover(h, d), n = 0; n < r; ++n)
    tO(this, o[n], s[n], t[n]);
  return this;
}
function Sft(t, e) {
  if (isNaN(t = +t) || isNaN(e = +e))
    return this;
  var n = this._x0, r = this._y0, i = this._x1, a = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(t)) + 1, a = (r = Math.floor(e)) + 1;
  else {
    for (var o = i - n || 1, s = this._root, l, c; n > t || t >= i || r > e || e >= a; )
      switch (c = (e < r) << 1 | t < n, l = new Array(4), l[c] = s, s = l, o *= 2, c) {
        case 0:
          i = n + o, a = r + o;
          break;
        case 1:
          n = i - o, a = r + o;
          break;
        case 2:
          i = n + o, r = a - o;
          break;
        case 3:
          n = i - o, r = a - o;
          break;
      }
    this._root && this._root.length && (this._root = s);
  }
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this;
}
function Eft() {
  var t = [];
  return this.visit(function(e) {
    if (!e.length)
      do
        t.push(e.data);
      while (e = e.next);
  }), t;
}
function Aft(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function yn(t, e, n, r, i) {
  this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = i;
}
function Pft(t, e, n) {
  var r, i = this._x0, a = this._y0, o, s, l, c, h = this._x1, d = this._y1, p = [], g = this._root, v, b;
  for (g && p.push(new yn(g, i, a, h, d)), n == null ? n = 1 / 0 : (i = t - n, a = e - n, h = t + n, d = e + n, n *= n); v = p.pop(); )
    if (!(!(g = v.node) || (o = v.x0) > h || (s = v.y0) > d || (l = v.x1) < i || (c = v.y1) < a))
      if (g.length) {
        var _ = (o + l) / 2, w = (s + c) / 2;
        p.push(
          new yn(g[3], _, w, l, c),
          new yn(g[2], o, w, _, c),
          new yn(g[1], _, s, l, w),
          new yn(g[0], o, s, _, w)
        ), (b = (e >= w) << 1 | t >= _) && (v = p[p.length - 1], p[p.length - 1] = p[p.length - 1 - b], p[p.length - 1 - b] = v);
      } else {
        var x = t - +this._x.call(null, g.data), C = e - +this._y.call(null, g.data), $ = x * x + C * C;
        if ($ < n) {
          var E = Math.sqrt(n = $);
          i = t - E, a = e - E, h = t + E, d = e + E, r = g.data;
        }
      }
  return r;
}
function Mft(t) {
  if (isNaN(h = +this._x.call(null, t)) || isNaN(d = +this._y.call(null, t)))
    return this;
  var e, n = this._root, r, i, a, o = this._x0, s = this._y0, l = this._x1, c = this._y1, h, d, p, g, v, b, _, w;
  if (!n)
    return this;
  if (n.length)
    for (; ; ) {
      if ((v = h >= (p = (o + l) / 2)) ? o = p : l = p, (b = d >= (g = (s + c) / 2)) ? s = g : c = g, e = n, !(n = n[_ = b << 1 | v]))
        return this;
      if (!n.length)
        break;
      (e[_ + 1 & 3] || e[_ + 2 & 3] || e[_ + 3 & 3]) && (r = e, w = _);
    }
  for (; n.data !== t; )
    if (i = n, !(n = n.next))
      return this;
  return (a = n.next) && delete n.next, i ? (a ? i.next = a : delete i.next, this) : e ? (a ? e[_] = a : delete e[_], (n = e[0] || e[1] || e[2] || e[3]) && n === (e[3] || e[2] || e[1] || e[0]) && !n.length && (r ? r[w] = n : this._root = n), this) : (this._root = a, this);
}
function kft(t) {
  for (var e = 0, n = t.length; e < n; ++e)
    this.remove(t[e]);
  return this;
}
function Nft() {
  return this._root;
}
function Ift() {
  var t = 0;
  return this.visit(function(e) {
    if (!e.length)
      do
        ++t;
      while (e = e.next);
  }), t;
}
function Rft(t) {
  var e = [], n, r = this._root, i, a, o, s, l;
  for (r && e.push(new yn(r, this._x0, this._y0, this._x1, this._y1)); n = e.pop(); )
    if (!t(r = n.node, a = n.x0, o = n.y0, s = n.x1, l = n.y1) && r.length) {
      var c = (a + s) / 2, h = (o + l) / 2;
      (i = r[3]) && e.push(new yn(i, c, h, s, l)), (i = r[2]) && e.push(new yn(i, a, h, c, l)), (i = r[1]) && e.push(new yn(i, c, o, s, h)), (i = r[0]) && e.push(new yn(i, a, o, c, h));
    }
  return this;
}
function Lft(t) {
  var e = [], n = [], r;
  for (this._root && e.push(new yn(this._root, this._x0, this._y0, this._x1, this._y1)); r = e.pop(); ) {
    var i = r.node;
    if (i.length) {
      var a, o = r.x0, s = r.y0, l = r.x1, c = r.y1, h = (o + l) / 2, d = (s + c) / 2;
      (a = i[0]) && e.push(new yn(a, o, s, h, d)), (a = i[1]) && e.push(new yn(a, h, s, l, d)), (a = i[2]) && e.push(new yn(a, o, d, h, c)), (a = i[3]) && e.push(new yn(a, h, d, l, c));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    t(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function Dft(t) {
  return t[0];
}
function Fft(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function zft(t) {
  return t[1];
}
function Bft(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function _1(t, e, n) {
  var r = new R2(e == null ? Dft : e, n == null ? zft : n, NaN, NaN, NaN, NaN);
  return t == null ? r : r.addAll(t);
}
function R2(t, e, n, r, i, a) {
  this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this._root = void 0;
}
function aw(t) {
  for (var e = { data: t.data }, n = e; t = t.next; )
    n = n.next = { data: t.data };
  return e;
}
var Sn = _1.prototype = R2.prototype;
Sn.copy = function() {
  var t = new R2(this._x, this._y, this._x0, this._y0, this._x1, this._y1), e = this._root, n, r;
  if (!e)
    return t;
  if (!e.length)
    return t._root = aw(e), t;
  for (n = [{ source: e, target: t._root = new Array(4) }]; e = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = e.source[i]) && (r.length ? n.push({ source: r, target: e.target[i] = new Array(4) }) : e.target[i] = aw(r));
  return t;
};
Sn.add = Tft;
Sn.addAll = Oft;
Sn.cover = Sft;
Sn.data = Eft;
Sn.extent = Aft;
Sn.find = Pft;
Sn.remove = Mft;
Sn.removeAll = kft;
Sn.root = Nft;
Sn.size = Ift;
Sn.visit = Rft;
Sn.visitAfter = Lft;
Sn.x = Fft;
Sn.y = Bft;
function Ne(t) {
  return function() {
    return t;
  };
}
function pa(t) {
  return (t() - 0.5) * 1e-6;
}
function Hft(t) {
  return t.x + t.vx;
}
function jft(t) {
  return t.y + t.vy;
}
function Vft(t) {
  var e, n, r, i = 1, a = 1;
  typeof t != "function" && (t = Ne(t == null ? 1 : +t));
  function o() {
    for (var c, h = e.length, d, p, g, v, b, _, w = 0; w < a; ++w)
      for (d = _1(e, Hft, jft).visitAfter(s), c = 0; c < h; ++c)
        p = e[c], b = n[p.index], _ = b * b, g = p.x + p.vx, v = p.y + p.vy, d.visit(x);
    function x(C, $, E, A, R) {
      var L = C.data, W = C.r, P = b + W;
      if (L) {
        if (L.index > p.index) {
          var k = g - L.x - L.vx, Y = v - L.y - L.vy, V = k * k + Y * Y;
          V < P * P && (k === 0 && (k = pa(r), V += k * k), Y === 0 && (Y = pa(r), V += Y * Y), V = (P - (V = Math.sqrt(V))) / V * i, p.vx += (k *= V) * (P = (W *= W) / (_ + W)), p.vy += (Y *= V) * P, L.vx -= k * (P = 1 - P), L.vy -= Y * P);
        }
        return;
      }
      return $ > g + P || A < g - P || E > v + P || R < v - P;
    }
  }
  function s(c) {
    if (c.data)
      return c.r = n[c.data.index];
    for (var h = c.r = 0; h < 4; ++h)
      c[h] && c[h].r > c.r && (c.r = c[h].r);
  }
  function l() {
    if (e) {
      var c, h = e.length, d;
      for (n = new Array(h), c = 0; c < h; ++c)
        d = e[c], n[d.index] = +t(d, c, e);
    }
  }
  return o.initialize = function(c, h) {
    e = c, r = h, l();
  }, o.iterations = function(c) {
    return arguments.length ? (a = +c, o) : a;
  }, o.strength = function(c) {
    return arguments.length ? (i = +c, o) : i;
  }, o.radius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Ne(+c), l(), o) : t;
  }, o;
}
function Wft(t) {
  return t.index;
}
function ow(t, e) {
  var n = t.get(e);
  if (!n)
    throw new Error("node not found: " + e);
  return n;
}
function Uft(t) {
  var e = Wft, n = d, r, i = Ne(30), a, o, s, l, c, h = 1;
  t == null && (t = []);
  function d(_) {
    return 1 / Math.min(s[_.source.index], s[_.target.index]);
  }
  function p(_) {
    for (var w = 0, x = t.length; w < h; ++w)
      for (var C = 0, $, E, A, R, L, W, P; C < x; ++C)
        $ = t[C], E = $.source, A = $.target, R = A.x + A.vx - E.x - E.vx || pa(c), L = A.y + A.vy - E.y - E.vy || pa(c), W = Math.sqrt(R * R + L * L), W = (W - a[C]) / W * _ * r[C], R *= W, L *= W, A.vx -= R * (P = l[C]), A.vy -= L * P, E.vx += R * (P = 1 - P), E.vy += L * P;
  }
  function g() {
    if (o) {
      var _, w = o.length, x = t.length, C = new Map(o.map((E, A) => [e(E, A, o), E])), $;
      for (_ = 0, s = new Array(w); _ < x; ++_)
        $ = t[_], $.index = _, typeof $.source != "object" && ($.source = ow(C, $.source)), typeof $.target != "object" && ($.target = ow(C, $.target)), s[$.source.index] = (s[$.source.index] || 0) + 1, s[$.target.index] = (s[$.target.index] || 0) + 1;
      for (_ = 0, l = new Array(x); _ < x; ++_)
        $ = t[_], l[_] = s[$.source.index] / (s[$.source.index] + s[$.target.index]);
      r = new Array(x), v(), a = new Array(x), b();
    }
  }
  function v() {
    if (o)
      for (var _ = 0, w = t.length; _ < w; ++_)
        r[_] = +n(t[_], _, t);
  }
  function b() {
    if (o)
      for (var _ = 0, w = t.length; _ < w; ++_)
        a[_] = +i(t[_], _, t);
  }
  return p.initialize = function(_, w) {
    o = _, c = w, g();
  }, p.links = function(_) {
    return arguments.length ? (t = _, g(), p) : t;
  }, p.id = function(_) {
    return arguments.length ? (e = _, p) : e;
  }, p.iterations = function(_) {
    return arguments.length ? (h = +_, p) : h;
  }, p.strength = function(_) {
    return arguments.length ? (n = typeof _ == "function" ? _ : Ne(+_), v(), p) : n;
  }, p.distance = function(_) {
    return arguments.length ? (i = typeof _ == "function" ? _ : Ne(+_), b(), p) : i;
  }, p;
}
const Yft = 1664525, qft = 1013904223, sw = 4294967296;
function Gft() {
  let t = 1;
  return () => (t = (Yft * t + qft) % sw) / sw;
}
function Kft(t) {
  return t.x;
}
function Xft(t) {
  return t.y;
}
var Zft = 10, Jft = Math.PI * (3 - Math.sqrt(5));
function Qft(t) {
  var e, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), a = 0, o = 0.6, s = /* @__PURE__ */ new Map(), l = p1(d), c = Ho("tick", "end"), h = Gft();
  t == null && (t = []);
  function d() {
    p(), c.call("tick", e), n < r && (l.stop(), c.call("end", e));
  }
  function p(b) {
    var _, w = t.length, x;
    b === void 0 && (b = 1);
    for (var C = 0; C < b; ++C)
      for (n += (a - n) * i, s.forEach(function($) {
        $(n);
      }), _ = 0; _ < w; ++_)
        x = t[_], x.fx == null ? x.x += x.vx *= o : (x.x = x.fx, x.vx = 0), x.fy == null ? x.y += x.vy *= o : (x.y = x.fy, x.vy = 0);
    return e;
  }
  function g() {
    for (var b = 0, _ = t.length, w; b < _; ++b) {
      if (w = t[b], w.index = b, w.fx != null && (w.x = w.fx), w.fy != null && (w.y = w.fy), isNaN(w.x) || isNaN(w.y)) {
        var x = Zft * Math.sqrt(0.5 + b), C = b * Jft;
        w.x = x * Math.cos(C), w.y = x * Math.sin(C);
      }
      (isNaN(w.vx) || isNaN(w.vy)) && (w.vx = w.vy = 0);
    }
  }
  function v(b) {
    return b.initialize && b.initialize(t, h), b;
  }
  return g(), e = {
    tick: p,
    restart: function() {
      return l.restart(d), e;
    },
    stop: function() {
      return l.stop(), e;
    },
    nodes: function(b) {
      return arguments.length ? (t = b, g(), s.forEach(v), e) : t;
    },
    alpha: function(b) {
      return arguments.length ? (n = +b, e) : n;
    },
    alphaMin: function(b) {
      return arguments.length ? (r = +b, e) : r;
    },
    alphaDecay: function(b) {
      return arguments.length ? (i = +b, e) : +i;
    },
    alphaTarget: function(b) {
      return arguments.length ? (a = +b, e) : a;
    },
    velocityDecay: function(b) {
      return arguments.length ? (o = 1 - b, e) : 1 - o;
    },
    randomSource: function(b) {
      return arguments.length ? (h = b, s.forEach(v), e) : h;
    },
    force: function(b, _) {
      return arguments.length > 1 ? (_ == null ? s.delete(b) : s.set(b, v(_)), e) : s.get(b);
    },
    find: function(b, _, w) {
      var x = 0, C = t.length, $, E, A, R, L;
      for (w == null ? w = 1 / 0 : w *= w, x = 0; x < C; ++x)
        R = t[x], $ = b - R.x, E = _ - R.y, A = $ * $ + E * E, A < w && (L = R, w = A);
      return L;
    },
    on: function(b, _) {
      return arguments.length > 1 ? (c.on(b, _), e) : c.on(b);
    }
  };
}
function tht() {
  var t, e, n, r, i = Ne(-30), a, o = 1, s = 1 / 0, l = 0.81;
  function c(g) {
    var v, b = t.length, _ = _1(t, Kft, Xft).visitAfter(d);
    for (r = g, v = 0; v < b; ++v)
      e = t[v], _.visit(p);
  }
  function h() {
    if (t) {
      var g, v = t.length, b;
      for (a = new Array(v), g = 0; g < v; ++g)
        b = t[g], a[b.index] = +i(b, g, t);
    }
  }
  function d(g) {
    var v = 0, b, _, w = 0, x, C, $;
    if (g.length) {
      for (x = C = $ = 0; $ < 4; ++$)
        (b = g[$]) && (_ = Math.abs(b.value)) && (v += b.value, w += _, x += _ * b.x, C += _ * b.y);
      g.x = x / w, g.y = C / w;
    } else {
      b = g, b.x = b.data.x, b.y = b.data.y;
      do
        v += a[b.data.index];
      while (b = b.next);
    }
    g.value = v;
  }
  function p(g, v, b, _) {
    if (!g.value)
      return !0;
    var w = g.x - e.x, x = g.y - e.y, C = _ - v, $ = w * w + x * x;
    if (C * C / l < $)
      return $ < s && (w === 0 && (w = pa(n), $ += w * w), x === 0 && (x = pa(n), $ += x * x), $ < o && ($ = Math.sqrt(o * $)), e.vx += w * g.value * r / $, e.vy += x * g.value * r / $), !0;
    if (g.length || $ >= s)
      return;
    (g.data !== e || g.next) && (w === 0 && (w = pa(n), $ += w * w), x === 0 && (x = pa(n), $ += x * x), $ < o && ($ = Math.sqrt(o * $)));
    do
      g.data !== e && (C = a[g.data.index] * r / $, e.vx += w * C, e.vy += x * C);
    while (g = g.next);
  }
  return c.initialize = function(g, v) {
    t = g, n = v, h();
  }, c.strength = function(g) {
    return arguments.length ? (i = typeof g == "function" ? g : Ne(+g), h(), c) : i;
  }, c.distanceMin = function(g) {
    return arguments.length ? (o = g * g, c) : Math.sqrt(o);
  }, c.distanceMax = function(g) {
    return arguments.length ? (s = g * g, c) : Math.sqrt(s);
  }, c.theta = function(g) {
    return arguments.length ? (l = g * g, c) : Math.sqrt(l);
  }, c;
}
function eht(t, e, n) {
  var r, i = Ne(0.1), a, o;
  typeof t != "function" && (t = Ne(+t)), e == null && (e = 0), n == null && (n = 0);
  function s(c) {
    for (var h = 0, d = r.length; h < d; ++h) {
      var p = r[h], g = p.x - e || 1e-6, v = p.y - n || 1e-6, b = Math.sqrt(g * g + v * v), _ = (o[h] - b) * a[h] * c / b;
      p.vx += g * _, p.vy += v * _;
    }
  }
  function l() {
    if (r) {
      var c, h = r.length;
      for (a = new Array(h), o = new Array(h), c = 0; c < h; ++c)
        o[c] = +t(r[c], c, r), a[c] = isNaN(o[c]) ? 0 : +i(r[c], c, r);
    }
  }
  return s.initialize = function(c) {
    r = c, l();
  }, s.strength = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Ne(+c), l(), s) : i;
  }, s.radius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Ne(+c), l(), s) : t;
  }, s.x = function(c) {
    return arguments.length ? (e = +c, s) : e;
  }, s.y = function(c) {
    return arguments.length ? (n = +c, s) : n;
  }, s;
}
function nht(t) {
  var e = Ne(0.1), n, r, i;
  typeof t != "function" && (t = Ne(t == null ? 0 : +t));
  function a(s) {
    for (var l = 0, c = n.length, h; l < c; ++l)
      h = n[l], h.vx += (i[l] - h.x) * r[l] * s;
  }
  function o() {
    if (n) {
      var s, l = n.length;
      for (r = new Array(l), i = new Array(l), s = 0; s < l; ++s)
        r[s] = isNaN(i[s] = +t(n[s], s, n)) ? 0 : +e(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Ne(+s), o(), a) : e;
  }, a.x = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Ne(+s), o(), a) : t;
  }, a;
}
function rht(t) {
  var e = Ne(0.1), n, r, i;
  typeof t != "function" && (t = Ne(t == null ? 0 : +t));
  function a(s) {
    for (var l = 0, c = n.length, h; l < c; ++l)
      h = n[l], h.vy += (i[l] - h.y) * r[l] * s;
  }
  function o() {
    if (n) {
      var s, l = n.length;
      for (r = new Array(l), i = new Array(l), s = 0; s < l; ++s)
        r[s] = isNaN(i[s] = +t(n[s], s, n)) ? 0 : +e(n[s], s, n);
    }
  }
  return a.initialize = function(s) {
    n = s, o();
  }, a.strength = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Ne(+s), o(), a) : e;
  }, a.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Ne(+s), o(), a) : t;
  }, a;
}
function iht(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function Rd(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function su(t) {
  return t = Rd(Math.abs(t)), t ? t[1] : NaN;
}
function aht(t, e) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = t[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = t[o = (o + 1) % t.length];
    return a.reverse().join(e);
  };
}
function oht(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var sht = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function uu(t) {
  if (!(e = sht.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new b1({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
uu.prototype = b1.prototype;
function b1(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
b1.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function uht(t) {
  t:
    for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
      switch (t[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+t[n])
            break t;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var eO;
function lht(t, e) {
  var n = Rd(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1], a = i - (eO = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + Rd(t, Math.max(0, e + a - 1))[0];
}
function uw(t, e) {
  var n = Rd(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const lw = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: iht,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => uw(t * 100, e),
  r: uw,
  s: lht,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function cw(t) {
  return t;
}
var fw = Array.prototype.map, hw = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function nO(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? cw : aht(fw.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? cw : oht(fw.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function c(d) {
    d = uu(d);
    var p = d.fill, g = d.align, v = d.sign, b = d.symbol, _ = d.zero, w = d.width, x = d.comma, C = d.precision, $ = d.trim, E = d.type;
    E === "n" ? (x = !0, E = "g") : lw[E] || (C === void 0 && (C = 12), $ = !0, E = "g"), (_ || p === "0" && g === "=") && (_ = !0, p = "0", g = "=");
    var A = b === "$" ? n : b === "#" && /[boxX]/.test(E) ? "0" + E.toLowerCase() : "", R = b === "$" ? r : /[%p]/.test(E) ? o : "", L = lw[E], W = /[defgprs%]/.test(E);
    C = C === void 0 ? 6 : /[gprs]/.test(E) ? Math.max(1, Math.min(21, C)) : Math.max(0, Math.min(20, C));
    function P(k) {
      var Y = A, V = R, I, D, z;
      if (E === "c")
        V = L(k) + V, k = "";
      else {
        k = +k;
        var q = k < 0 || 1 / k < 0;
        if (k = isNaN(k) ? l : L(Math.abs(k), C), $ && (k = uht(k)), q && +k == 0 && v !== "+" && (q = !1), Y = (q ? v === "(" ? v : s : v === "-" || v === "(" ? "" : v) + Y, V = (E === "s" ? hw[8 + eO / 3] : "") + V + (q && v === "(" ? ")" : ""), W) {
          for (I = -1, D = k.length; ++I < D; )
            if (z = k.charCodeAt(I), 48 > z || z > 57) {
              V = (z === 46 ? i + k.slice(I + 1) : k.slice(I)) + V, k = k.slice(0, I);
              break;
            }
        }
      }
      x && !_ && (k = e(k, 1 / 0));
      var Z = Y.length + k.length + V.length, B = Z < w ? new Array(w - Z + 1).join(p) : "";
      switch (x && _ && (k = e(B + k, B.length ? w - V.length : 1 / 0), B = ""), g) {
        case "<":
          k = Y + k + V + B;
          break;
        case "=":
          k = Y + B + k + V;
          break;
        case "^":
          k = B.slice(0, Z = B.length >> 1) + Y + k + V + B.slice(Z);
          break;
        default:
          k = B + Y + k + V;
          break;
      }
      return a(k);
    }
    return P.toString = function() {
      return d + "";
    }, P;
  }
  function h(d, p) {
    var g = c((d = uu(d), d.type = "f", d)), v = Math.max(-8, Math.min(8, Math.floor(su(p) / 3))) * 3, b = Math.pow(10, -v), _ = hw[8 + v / 3];
    return function(w) {
      return g(b * w) + _;
    };
  }
  return {
    format: c,
    formatPrefix: h
  };
}
var dh, Uo, L2;
rO({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function rO(t) {
  return dh = nO(t), Uo = dh.format, L2 = dh.formatPrefix, dh;
}
function iO(t) {
  return Math.max(0, -su(Math.abs(t)));
}
function aO(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(su(e) / 3))) * 3 - su(Math.abs(t)));
}
function oO(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, su(e) - su(t)) + 1;
}
var xt = 1e-6, vc = 1e-12, Ft = Math.PI, we = Ft / 2, Ld = Ft / 4, $n = Ft * 2, Jt = 180 / Ft, Ct = Ft / 180, Vt = Math.abs, Ru = Math.atan, Tn = Math.atan2, bt = Math.cos, ph = Math.ceil, sO = Math.exp, Pv = Math.hypot, Dd = Math.log, Wg = Math.pow, gt = Math.sin, wr = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, We = Math.sqrt, D2 = Math.tan;
function uO(t) {
  return t > 1 ? 0 : t < -1 ? Ft : Math.acos(t);
}
function On(t) {
  return t > 1 ? we : t < -1 ? -we : Math.asin(t);
}
function dw(t) {
  return (t = gt(t / 2)) * t;
}
function ge() {
}
function Fd(t, e) {
  t && mw.hasOwnProperty(t.type) && mw[t.type](t, e);
}
var pw = {
  Feature: function(t, e) {
    Fd(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; )
      Fd(n[r].geometry, e);
  }
}, mw = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      t = n[r], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Mv(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      Mv(n[r], e, 0);
  },
  Polygon: function(t, e) {
    gw(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      gw(n[r], e);
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; )
      Fd(n[r], e);
  }
};
function Mv(t, e, n) {
  var r = -1, i = t.length - n, a;
  for (e.lineStart(); ++r < i; )
    a = t[r], e.point(a[0], a[1], a[2]);
  e.lineEnd();
}
function gw(t, e) {
  var n = -1, r = t.length;
  for (e.polygonStart(); ++n < r; )
    Mv(t[n], e, 1);
  e.polygonEnd();
}
function Mr(t, e) {
  t && pw.hasOwnProperty(t.type) ? pw[t.type](t, e) : Fd(t, e);
}
var zd = new Ie(), Bd = new Ie(), lO, cO, kv, Nv, Iv, li = {
  point: ge,
  lineStart: ge,
  lineEnd: ge,
  polygonStart: function() {
    zd = new Ie(), li.lineStart = cht, li.lineEnd = fht;
  },
  polygonEnd: function() {
    var t = +zd;
    Bd.add(t < 0 ? $n + t : t), this.lineStart = this.lineEnd = this.point = ge;
  },
  sphere: function() {
    Bd.add($n);
  }
};
function cht() {
  li.point = hht;
}
function fht() {
  fO(lO, cO);
}
function hht(t, e) {
  li.point = fO, lO = t, cO = e, t *= Ct, e *= Ct, kv = t, Nv = bt(e = e / 2 + Ld), Iv = gt(e);
}
function fO(t, e) {
  t *= Ct, e *= Ct, e = e / 2 + Ld;
  var n = t - kv, r = n >= 0 ? 1 : -1, i = r * n, a = bt(e), o = gt(e), s = Iv * o, l = Nv * a + s * bt(i), c = s * r * gt(i);
  zd.add(Tn(c, l)), kv = t, Nv = a, Iv = o;
}
function dht(t) {
  return Bd = new Ie(), Mr(t, li), Bd * 2;
}
function Hd(t) {
  return [Tn(t[1], t[0]), On(t[2])];
}
function Mo(t) {
  var e = t[0], n = t[1], r = bt(n);
  return [r * bt(e), r * gt(e), gt(n)];
}
function mh(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function lu(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function Ug(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function gh(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function jd(t) {
  var e = We(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
var me, Dn, be, er, oo, hO, dO, Vs, Bl, sa, zi, Ti = {
  point: Rv,
  lineStart: vw,
  lineEnd: _w,
  polygonStart: function() {
    Ti.point = mO, Ti.lineStart = pht, Ti.lineEnd = mht, Bl = new Ie(), li.polygonStart();
  },
  polygonEnd: function() {
    li.polygonEnd(), Ti.point = Rv, Ti.lineStart = vw, Ti.lineEnd = _w, zd < 0 ? (me = -(be = 180), Dn = -(er = 90)) : Bl > xt ? er = 90 : Bl < -xt && (Dn = -90), zi[0] = me, zi[1] = be;
  },
  sphere: function() {
    me = -(be = 180), Dn = -(er = 90);
  }
};
function Rv(t, e) {
  sa.push(zi = [me = t, be = t]), e < Dn && (Dn = e), e > er && (er = e);
}
function pO(t, e) {
  var n = Mo([t * Ct, e * Ct]);
  if (Vs) {
    var r = lu(Vs, n), i = [r[1], -r[0], 0], a = lu(i, r);
    jd(a), a = Hd(a);
    var o = t - oo, s = o > 0 ? 1 : -1, l = a[0] * Jt * s, c, h = Vt(o) > 180;
    h ^ (s * oo < l && l < s * t) ? (c = a[1] * Jt, c > er && (er = c)) : (l = (l + 360) % 360 - 180, h ^ (s * oo < l && l < s * t) ? (c = -a[1] * Jt, c < Dn && (Dn = c)) : (e < Dn && (Dn = e), e > er && (er = e))), h ? t < oo ? tr(me, t) > tr(me, be) && (be = t) : tr(t, be) > tr(me, be) && (me = t) : be >= me ? (t < me && (me = t), t > be && (be = t)) : t > oo ? tr(me, t) > tr(me, be) && (be = t) : tr(t, be) > tr(me, be) && (me = t);
  } else
    sa.push(zi = [me = t, be = t]);
  e < Dn && (Dn = e), e > er && (er = e), Vs = n, oo = t;
}
function vw() {
  Ti.point = pO;
}
function _w() {
  zi[0] = me, zi[1] = be, Ti.point = Rv, Vs = null;
}
function mO(t, e) {
  if (Vs) {
    var n = t - oo;
    Bl.add(Vt(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    hO = t, dO = e;
  li.point(t, e), pO(t, e);
}
function pht() {
  li.lineStart();
}
function mht() {
  mO(hO, dO), li.lineEnd(), Vt(Bl) > xt && (me = -(be = 180)), zi[0] = me, zi[1] = be, Vs = null;
}
function tr(t, e) {
  return (e -= t) < 0 ? e + 360 : e;
}
function ght(t, e) {
  return t[0] - e[0];
}
function bw(t, e) {
  return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
}
function vht(t) {
  var e, n, r, i, a, o, s;
  if (er = be = -(me = Dn = 1 / 0), sa = [], Mr(t, Ti), n = sa.length) {
    for (sa.sort(ght), e = 1, r = sa[0], a = [r]; e < n; ++e)
      i = sa[e], bw(r, i[0]) || bw(r, i[1]) ? (tr(r[0], i[1]) > tr(r[0], r[1]) && (r[1] = i[1]), tr(i[0], r[1]) > tr(r[0], r[1]) && (r[0] = i[0])) : a.push(r = i);
    for (o = -1 / 0, n = a.length - 1, e = 0, r = a[n]; e <= n; r = i, ++e)
      i = a[e], (s = tr(r[1], i[0])) > o && (o = s, me = i[0], be = r[1]);
  }
  return sa = zi = null, me === 1 / 0 || Dn === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[me, Dn], [be, er]];
}
var Cl, Vd, Wd, Ud, Yd, qd, Gd, Kd, Lv, Dv, Fv, gO, vO, vn, _n, bn, Rr = {
  sphere: ge,
  point: F2,
  lineStart: yw,
  lineEnd: ww,
  polygonStart: function() {
    Rr.lineStart = yht, Rr.lineEnd = wht;
  },
  polygonEnd: function() {
    Rr.lineStart = yw, Rr.lineEnd = ww;
  }
};
function F2(t, e) {
  t *= Ct, e *= Ct;
  var n = bt(e);
  Vc(n * bt(t), n * gt(t), gt(e));
}
function Vc(t, e, n) {
  ++Cl, Wd += (t - Wd) / Cl, Ud += (e - Ud) / Cl, Yd += (n - Yd) / Cl;
}
function yw() {
  Rr.point = _ht;
}
function _ht(t, e) {
  t *= Ct, e *= Ct;
  var n = bt(e);
  vn = n * bt(t), _n = n * gt(t), bn = gt(e), Rr.point = bht, Vc(vn, _n, bn);
}
function bht(t, e) {
  t *= Ct, e *= Ct;
  var n = bt(e), r = n * bt(t), i = n * gt(t), a = gt(e), o = Tn(We((o = _n * a - bn * i) * o + (o = bn * r - vn * a) * o + (o = vn * i - _n * r) * o), vn * r + _n * i + bn * a);
  Vd += o, qd += o * (vn + (vn = r)), Gd += o * (_n + (_n = i)), Kd += o * (bn + (bn = a)), Vc(vn, _n, bn);
}
function ww() {
  Rr.point = F2;
}
function yht() {
  Rr.point = xht;
}
function wht() {
  _O(gO, vO), Rr.point = F2;
}
function xht(t, e) {
  gO = t, vO = e, t *= Ct, e *= Ct, Rr.point = _O;
  var n = bt(e);
  vn = n * bt(t), _n = n * gt(t), bn = gt(e), Vc(vn, _n, bn);
}
function _O(t, e) {
  t *= Ct, e *= Ct;
  var n = bt(e), r = n * bt(t), i = n * gt(t), a = gt(e), o = _n * a - bn * i, s = bn * r - vn * a, l = vn * i - _n * r, c = Pv(o, s, l), h = On(c), d = c && -h / c;
  Lv.add(d * o), Dv.add(d * s), Fv.add(d * l), Vd += h, qd += h * (vn + (vn = r)), Gd += h * (_n + (_n = i)), Kd += h * (bn + (bn = a)), Vc(vn, _n, bn);
}
function Cht(t) {
  Cl = Vd = Wd = Ud = Yd = qd = Gd = Kd = 0, Lv = new Ie(), Dv = new Ie(), Fv = new Ie(), Mr(t, Rr);
  var e = +Lv, n = +Dv, r = +Fv, i = Pv(e, n, r);
  return i < vc && (e = qd, n = Gd, r = Kd, Vd < xt && (e = Wd, n = Ud, r = Yd), i = Pv(e, n, r), i < vc) ? [NaN, NaN] : [Tn(n, e) * Jt, On(r / i) * Jt];
}
function ws(t) {
  return function() {
    return t;
  };
}
function zv(t, e) {
  function n(r, i) {
    return r = t(r, i), e(r[0], r[1]);
  }
  return t.invert && e.invert && (n.invert = function(r, i) {
    return r = e.invert(r, i), r && t.invert(r[0], r[1]);
  }), n;
}
function Bv(t, e) {
  return [Vt(t) > Ft ? t + Math.round(-t / $n) * $n : t, e];
}
Bv.invert = Bv;
function z2(t, e, n) {
  return (t %= $n) ? e || n ? zv(Cw(t), $w(e, n)) : Cw(t) : e || n ? $w(e, n) : Bv;
}
function xw(t) {
  return function(e, n) {
    return e += t, [e > Ft ? e - $n : e < -Ft ? e + $n : e, n];
  };
}
function Cw(t) {
  var e = xw(t);
  return e.invert = xw(-t), e;
}
function $w(t, e) {
  var n = bt(t), r = gt(t), i = bt(e), a = gt(e);
  function o(s, l) {
    var c = bt(l), h = bt(s) * c, d = gt(s) * c, p = gt(l), g = p * n + h * r;
    return [
      Tn(d * i - g * a, h * n - p * r),
      On(g * i + d * a)
    ];
  }
  return o.invert = function(s, l) {
    var c = bt(l), h = bt(s) * c, d = gt(s) * c, p = gt(l), g = p * i - d * a;
    return [
      Tn(d * i + p * a, h * n + g * r),
      On(g * n - h * r)
    ];
  }, o;
}
function bO(t) {
  t = z2(t[0] * Ct, t[1] * Ct, t.length > 2 ? t[2] * Ct : 0);
  function e(n) {
    return n = t(n[0] * Ct, n[1] * Ct), n[0] *= Jt, n[1] *= Jt, n;
  }
  return e.invert = function(n) {
    return n = t.invert(n[0] * Ct, n[1] * Ct), n[0] *= Jt, n[1] *= Jt, n;
  }, e;
}
function yO(t, e, n, r, i, a) {
  if (n) {
    var o = bt(e), s = gt(e), l = r * n;
    i == null ? (i = e + r * $n, a = e - l / 2) : (i = Tw(o, i), a = Tw(o, a), (r > 0 ? i < a : i > a) && (i += r * $n));
    for (var c, h = i; r > 0 ? h > a : h < a; h -= l)
      c = Hd([o, -s * bt(h), -s * gt(h)]), t.point(c[0], c[1]);
  }
}
function Tw(t, e) {
  e = Mo(e), e[0] -= t, jd(e);
  var n = uO(-e[1]);
  return ((-e[2] < 0 ? -n : n) + $n - xt) % $n;
}
function $ht() {
  var t = ws([0, 0]), e = ws(90), n = ws(6), r, i, a = { point: o };
  function o(l, c) {
    r.push(l = i(l, c)), l[0] *= Jt, l[1] *= Jt;
  }
  function s() {
    var l = t.apply(this, arguments), c = e.apply(this, arguments) * Ct, h = n.apply(this, arguments) * Ct;
    return r = [], i = z2(-l[0] * Ct, -l[1] * Ct, 0).invert, yO(a, c, h, 1), l = { type: "Polygon", coordinates: [r] }, r = i = null, l;
  }
  return s.center = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : ws([+l[0], +l[1]]), s) : t;
  }, s.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : ws(+l), s) : e;
  }, s.precision = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : ws(+l), s) : n;
  }, s;
}
function wO() {
  var t = [], e;
  return {
    point: function(n, r, i) {
      e.push([n, r, i]);
    },
    lineStart: function() {
      t.push(e = []);
    },
    lineEnd: ge,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var n = t;
      return t = [], e = null, n;
    }
  };
}
function Uh(t, e) {
  return Vt(t[0] - e[0]) < xt && Vt(t[1] - e[1]) < xt;
}
function vh(t, e, n, r) {
  this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function xO(t, e, n, r, i) {
  var a = [], o = [], s, l;
  if (t.forEach(function(v) {
    if (!((b = v.length - 1) <= 0)) {
      var b, _ = v[0], w = v[b], x;
      if (Uh(_, w)) {
        if (!_[2] && !w[2]) {
          for (i.lineStart(), s = 0; s < b; ++s)
            i.point((_ = v[s])[0], _[1]);
          i.lineEnd();
          return;
        }
        w[0] += 2 * xt;
      }
      a.push(x = new vh(_, v, null, !0)), o.push(x.o = new vh(_, null, x, !1)), a.push(x = new vh(w, v, null, !1)), o.push(x.o = new vh(w, null, x, !0));
    }
  }), !!a.length) {
    for (o.sort(e), Ow(a), Ow(o), s = 0, l = o.length; s < l; ++s)
      o[s].e = n = !n;
    for (var c = a[0], h, d; ; ) {
      for (var p = c, g = !0; p.v; )
        if ((p = p.n) === c)
          return;
      h = p.z, i.lineStart();
      do {
        if (p.v = p.o.v = !0, p.e) {
          if (g)
            for (s = 0, l = h.length; s < l; ++s)
              i.point((d = h[s])[0], d[1]);
          else
            r(p.x, p.n.x, 1, i);
          p = p.n;
        } else {
          if (g)
            for (h = p.p.z, s = h.length - 1; s >= 0; --s)
              i.point((d = h[s])[0], d[1]);
          else
            r(p.x, p.p.x, -1, i);
          p = p.p;
        }
        p = p.o, h = p.z, g = !g;
      } while (!p.v);
      i.lineEnd();
    }
  }
}
function Ow(t) {
  if (e = t.length) {
    for (var e, n = 0, r = t[0], i; ++n < e; )
      r.n = i = t[n], i.p = r, r = i;
    r.n = i = t[0], i.p = r;
  }
}
function Yg(t) {
  return Vt(t[0]) <= Ft ? t[0] : wr(t[0]) * ((Vt(t[0]) + Ft) % $n - Ft);
}
function CO(t, e) {
  var n = Yg(e), r = e[1], i = gt(r), a = [gt(n), -bt(n), 0], o = 0, s = 0, l = new Ie();
  i === 1 ? r = we + xt : i === -1 && (r = -we - xt);
  for (var c = 0, h = t.length; c < h; ++c)
    if (p = (d = t[c]).length)
      for (var d, p, g = d[p - 1], v = Yg(g), b = g[1] / 2 + Ld, _ = gt(b), w = bt(b), x = 0; x < p; ++x, v = $, _ = A, w = R, g = C) {
        var C = d[x], $ = Yg(C), E = C[1] / 2 + Ld, A = gt(E), R = bt(E), L = $ - v, W = L >= 0 ? 1 : -1, P = W * L, k = P > Ft, Y = _ * A;
        if (l.add(Tn(Y * W * gt(P), w * R + Y * bt(P))), o += k ? L + W * $n : L, k ^ v >= n ^ $ >= n) {
          var V = lu(Mo(g), Mo(C));
          jd(V);
          var I = lu(a, V);
          jd(I);
          var D = (k ^ L >= 0 ? -1 : 1) * On(I[2]);
          (r > D || r === D && (V[0] || V[1])) && (s += k ^ L >= 0 ? 1 : -1);
        }
      }
  return (o < -xt || o < xt && l < -vc) ^ s & 1;
}
function $O(t, e, n, r) {
  return function(i) {
    var a = e(i), o = wO(), s = e(o), l = !1, c, h, d, p = {
      point: g,
      lineStart: b,
      lineEnd: _,
      polygonStart: function() {
        p.point = w, p.lineStart = x, p.lineEnd = C, h = [], c = [];
      },
      polygonEnd: function() {
        p.point = g, p.lineStart = b, p.lineEnd = _, h = h2(h);
        var $ = CO(c, r);
        h.length ? (l || (i.polygonStart(), l = !0), xO(h, Oht, $, n, i)) : $ && (l || (i.polygonStart(), l = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), l && (i.polygonEnd(), l = !1), h = c = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function g($, E) {
      t($, E) && i.point($, E);
    }
    function v($, E) {
      a.point($, E);
    }
    function b() {
      p.point = v, a.lineStart();
    }
    function _() {
      p.point = g, a.lineEnd();
    }
    function w($, E) {
      d.push([$, E]), s.point($, E);
    }
    function x() {
      s.lineStart(), d = [];
    }
    function C() {
      w(d[0][0], d[0][1]), s.lineEnd();
      var $ = s.clean(), E = o.result(), A, R = E.length, L, W, P;
      if (d.pop(), c.push(d), d = null, !!R) {
        if ($ & 1) {
          if (W = E[0], (L = W.length - 1) > 0) {
            for (l || (i.polygonStart(), l = !0), i.lineStart(), A = 0; A < L; ++A)
              i.point((P = W[A])[0], P[1]);
            i.lineEnd();
          }
          return;
        }
        R > 1 && $ & 2 && E.push(E.pop().concat(E.shift())), h.push(E.filter(Tht));
      }
    }
    return p;
  };
}
function Tht(t) {
  return t.length > 1;
}
function Oht(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - we - xt : we - t[1]) - ((e = e.x)[0] < 0 ? e[1] - we - xt : we - e[1]);
}
const Hv = $O(
  function() {
    return !0;
  },
  Sht,
  Aht,
  [-Ft, -we]
);
function Sht(t) {
  var e = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      t.lineStart(), i = 1;
    },
    point: function(a, o) {
      var s = a > 0 ? Ft : -Ft, l = Vt(a - e);
      Vt(l - Ft) < xt ? (t.point(e, n = (n + o) / 2 > 0 ? we : -we), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(s, n), t.point(a, n), i = 0) : r !== s && l >= Ft && (Vt(e - r) < xt && (e -= r * xt), Vt(a - s) < xt && (a -= s * xt), n = Eht(e, n, a, o), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(s, n), i = 0), t.point(e = a, n = o), r = s;
    },
    lineEnd: function() {
      t.lineEnd(), e = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function Eht(t, e, n, r) {
  var i, a, o = gt(t - n);
  return Vt(o) > xt ? Ru((gt(e) * (a = bt(r)) * gt(n) - gt(r) * (i = bt(e)) * gt(t)) / (i * a * o)) : (e + r) / 2;
}
function Aht(t, e, n, r) {
  var i;
  if (t == null)
    i = n * we, r.point(-Ft, i), r.point(0, i), r.point(Ft, i), r.point(Ft, 0), r.point(Ft, -i), r.point(0, -i), r.point(-Ft, -i), r.point(-Ft, 0), r.point(-Ft, i);
  else if (Vt(t[0] - e[0]) > xt) {
    var a = t[0] < e[0] ? Ft : -Ft;
    i = n * a / 2, r.point(-a, i), r.point(0, i), r.point(a, i);
  } else
    r.point(e[0], e[1]);
}
function TO(t) {
  var e = bt(t), n = 6 * Ct, r = e > 0, i = Vt(e) > xt;
  function a(h, d, p, g) {
    yO(g, t, n, p, h, d);
  }
  function o(h, d) {
    return bt(h) * bt(d) > e;
  }
  function s(h) {
    var d, p, g, v, b;
    return {
      lineStart: function() {
        v = g = !1, b = 1;
      },
      point: function(_, w) {
        var x = [_, w], C, $ = o(_, w), E = r ? $ ? 0 : c(_, w) : $ ? c(_ + (_ < 0 ? Ft : -Ft), w) : 0;
        if (!d && (v = g = $) && h.lineStart(), $ !== g && (C = l(d, x), (!C || Uh(d, C) || Uh(x, C)) && (x[2] = 1)), $ !== g)
          b = 0, $ ? (h.lineStart(), C = l(x, d), h.point(C[0], C[1])) : (C = l(d, x), h.point(C[0], C[1], 2), h.lineEnd()), d = C;
        else if (i && d && r ^ $) {
          var A;
          !(E & p) && (A = l(x, d, !0)) && (b = 0, r ? (h.lineStart(), h.point(A[0][0], A[0][1]), h.point(A[1][0], A[1][1]), h.lineEnd()) : (h.point(A[1][0], A[1][1]), h.lineEnd(), h.lineStart(), h.point(A[0][0], A[0][1], 3)));
        }
        $ && (!d || !Uh(d, x)) && h.point(x[0], x[1]), d = x, g = $, p = E;
      },
      lineEnd: function() {
        g && h.lineEnd(), d = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return b | (v && g) << 1;
      }
    };
  }
  function l(h, d, p) {
    var g = Mo(h), v = Mo(d), b = [1, 0, 0], _ = lu(g, v), w = mh(_, _), x = _[0], C = w - x * x;
    if (!C)
      return !p && h;
    var $ = e * w / C, E = -e * x / C, A = lu(b, _), R = gh(b, $), L = gh(_, E);
    Ug(R, L);
    var W = A, P = mh(R, W), k = mh(W, W), Y = P * P - k * (mh(R, R) - 1);
    if (!(Y < 0)) {
      var V = We(Y), I = gh(W, (-P - V) / k);
      if (Ug(I, R), I = Hd(I), !p)
        return I;
      var D = h[0], z = d[0], q = h[1], Z = d[1], B;
      z < D && (B = D, D = z, z = B);
      var H = z - D, J = Vt(H - Ft) < xt, X = J || H < xt;
      if (!J && Z < q && (B = q, q = Z, Z = B), X ? J ? q + Z > 0 ^ I[1] < (Vt(I[0] - D) < xt ? q : Z) : q <= I[1] && I[1] <= Z : H > Ft ^ (D <= I[0] && I[0] <= z)) {
        var et = gh(W, (-P + V) / k);
        return Ug(et, R), [I, Hd(et)];
      }
    }
  }
  function c(h, d) {
    var p = r ? t : Ft - t, g = 0;
    return h < -p ? g |= 1 : h > p && (g |= 2), d < -p ? g |= 4 : d > p && (g |= 8), g;
  }
  return $O(o, s, a, r ? [0, -t] : [-Ft, t - Ft]);
}
function Pht(t, e, n, r, i, a) {
  var o = t[0], s = t[1], l = e[0], c = e[1], h = 0, d = 1, p = l - o, g = c - s, v;
  if (v = n - o, !(!p && v > 0)) {
    if (v /= p, p < 0) {
      if (v < h)
        return;
      v < d && (d = v);
    } else if (p > 0) {
      if (v > d)
        return;
      v > h && (h = v);
    }
    if (v = i - o, !(!p && v < 0)) {
      if (v /= p, p < 0) {
        if (v > d)
          return;
        v > h && (h = v);
      } else if (p > 0) {
        if (v < h)
          return;
        v < d && (d = v);
      }
      if (v = r - s, !(!g && v > 0)) {
        if (v /= g, g < 0) {
          if (v < h)
            return;
          v < d && (d = v);
        } else if (g > 0) {
          if (v > d)
            return;
          v > h && (h = v);
        }
        if (v = a - s, !(!g && v < 0)) {
          if (v /= g, g < 0) {
            if (v > d)
              return;
            v > h && (h = v);
          } else if (g > 0) {
            if (v < h)
              return;
            v < d && (d = v);
          }
          return h > 0 && (t[0] = o + h * p, t[1] = s + h * g), d < 1 && (e[0] = o + d * p, e[1] = s + d * g), !0;
        }
      }
    }
  }
}
var $l = 1e9, _h = -$l;
function y1(t, e, n, r) {
  function i(c, h) {
    return t <= c && c <= n && e <= h && h <= r;
  }
  function a(c, h, d, p) {
    var g = 0, v = 0;
    if (c == null || (g = o(c, d)) !== (v = o(h, d)) || l(c, h) < 0 ^ d > 0)
      do
        p.point(g === 0 || g === 3 ? t : n, g > 1 ? r : e);
      while ((g = (g + d + 4) % 4) !== v);
    else
      p.point(h[0], h[1]);
  }
  function o(c, h) {
    return Vt(c[0] - t) < xt ? h > 0 ? 0 : 3 : Vt(c[0] - n) < xt ? h > 0 ? 2 : 1 : Vt(c[1] - e) < xt ? h > 0 ? 1 : 0 : h > 0 ? 3 : 2;
  }
  function s(c, h) {
    return l(c.x, h.x);
  }
  function l(c, h) {
    var d = o(c, 1), p = o(h, 1);
    return d !== p ? d - p : d === 0 ? h[1] - c[1] : d === 1 ? c[0] - h[0] : d === 2 ? c[1] - h[1] : h[0] - c[0];
  }
  return function(c) {
    var h = c, d = wO(), p, g, v, b, _, w, x, C, $, E, A, R = {
      point: L,
      lineStart: Y,
      lineEnd: V,
      polygonStart: P,
      polygonEnd: k
    };
    function L(D, z) {
      i(D, z) && h.point(D, z);
    }
    function W() {
      for (var D = 0, z = 0, q = g.length; z < q; ++z)
        for (var Z = g[z], B = 1, H = Z.length, J = Z[0], X, et, rt = J[0], ut = J[1]; B < H; ++B)
          X = rt, et = ut, J = Z[B], rt = J[0], ut = J[1], et <= r ? ut > r && (rt - X) * (r - et) > (ut - et) * (t - X) && ++D : ut <= r && (rt - X) * (r - et) < (ut - et) * (t - X) && --D;
      return D;
    }
    function P() {
      h = d, p = [], g = [], A = !0;
    }
    function k() {
      var D = W(), z = A && D, q = (p = h2(p)).length;
      (z || q) && (c.polygonStart(), z && (c.lineStart(), a(null, null, 1, c), c.lineEnd()), q && xO(p, s, D, a, c), c.polygonEnd()), h = c, p = g = v = null;
    }
    function Y() {
      R.point = I, g && g.push(v = []), E = !0, $ = !1, x = C = NaN;
    }
    function V() {
      p && (I(b, _), w && $ && d.rejoin(), p.push(d.result())), R.point = L, $ && h.lineEnd();
    }
    function I(D, z) {
      var q = i(D, z);
      if (g && v.push([D, z]), E)
        b = D, _ = z, w = q, E = !1, q && (h.lineStart(), h.point(D, z));
      else if (q && $)
        h.point(D, z);
      else {
        var Z = [x = Math.max(_h, Math.min($l, x)), C = Math.max(_h, Math.min($l, C))], B = [D = Math.max(_h, Math.min($l, D)), z = Math.max(_h, Math.min($l, z))];
        Pht(Z, B, t, e, n, r) ? ($ || (h.lineStart(), h.point(Z[0], Z[1])), h.point(B[0], B[1]), q || h.lineEnd(), A = !1) : q && (h.lineStart(), h.point(D, z), A = !1);
      }
      x = D, C = z, $ = q;
    }
    return R;
  };
}
function Mht() {
  var t = 0, e = 0, n = 960, r = 500, i, a, o;
  return o = {
    stream: function(s) {
      return i && a === s ? i : i = y1(t, e, n, r)(a = s);
    },
    extent: function(s) {
      return arguments.length ? (t = +s[0][0], e = +s[0][1], n = +s[1][0], r = +s[1][1], i = a = null, o) : [[t, e], [n, r]];
    }
  };
}
var jv, Vv, Yh, qh, cu = {
  sphere: ge,
  point: ge,
  lineStart: kht,
  lineEnd: ge,
  polygonStart: ge,
  polygonEnd: ge
};
function kht() {
  cu.point = Iht, cu.lineEnd = Nht;
}
function Nht() {
  cu.point = cu.lineEnd = ge;
}
function Iht(t, e) {
  t *= Ct, e *= Ct, Vv = t, Yh = gt(e), qh = bt(e), cu.point = Rht;
}
function Rht(t, e) {
  t *= Ct, e *= Ct;
  var n = gt(e), r = bt(e), i = Vt(t - Vv), a = bt(i), o = gt(i), s = r * o, l = qh * n - Yh * r * a, c = Yh * n + qh * r * a;
  jv.add(Tn(We(s * s + l * l), c)), Vv = t, Yh = n, qh = r;
}
function OO(t) {
  return jv = new Ie(), Mr(t, cu), +jv;
}
var Wv = [null, null], Lht = { type: "LineString", coordinates: Wv };
function Xd(t, e) {
  return Wv[0] = t, Wv[1] = e, OO(Lht);
}
var Sw = {
  Feature: function(t, e) {
    return Zd(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; )
      if (Zd(n[r].geometry, e))
        return !0;
    return !1;
  }
}, Ew = {
  Sphere: function() {
    return !0;
  },
  Point: function(t, e) {
    return Aw(t.coordinates, e);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (Aw(n[r], e))
        return !0;
    return !1;
  },
  LineString: function(t, e) {
    return Pw(t.coordinates, e);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (Pw(n[r], e))
        return !0;
    return !1;
  },
  Polygon: function(t, e) {
    return Mw(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (Mw(n[r], e))
        return !0;
    return !1;
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; )
      if (Zd(n[r], e))
        return !0;
    return !1;
  }
};
function Zd(t, e) {
  return t && Ew.hasOwnProperty(t.type) ? Ew[t.type](t, e) : !1;
}
function Aw(t, e) {
  return Xd(t, e) === 0;
}
function Pw(t, e) {
  for (var n, r, i, a = 0, o = t.length; a < o; a++) {
    if (r = Xd(t[a], e), r === 0 || a > 0 && (i = Xd(t[a], t[a - 1]), i > 0 && n <= i && r <= i && (n + r - i) * (1 - Math.pow((n - r) / i, 2)) < vc * i))
      return !0;
    n = r;
  }
  return !1;
}
function Mw(t, e) {
  return !!CO(t.map(Dht), SO(e));
}
function Dht(t) {
  return t = t.map(SO), t.pop(), t;
}
function SO(t) {
  return [t[0] * Ct, t[1] * Ct];
}
function Fht(t, e) {
  return (t && Sw.hasOwnProperty(t.type) ? Sw[t.type] : Zd)(t, e);
}
function kw(t, e, n) {
  var r = ei(t, e - xt, n).concat(e);
  return function(i) {
    return r.map(function(a) {
      return [i, a];
    });
  };
}
function Nw(t, e, n) {
  var r = ei(t, e - xt, n).concat(e);
  return function(i) {
    return r.map(function(a) {
      return [a, i];
    });
  };
}
function EO() {
  var t, e, n, r, i, a, o, s, l = 10, c = l, h = 90, d = 360, p, g, v, b, _ = 2.5;
  function w() {
    return { type: "MultiLineString", coordinates: x() };
  }
  function x() {
    return ei(ph(r / h) * h, n, h).map(v).concat(ei(ph(s / d) * d, o, d).map(b)).concat(ei(ph(e / l) * l, t, l).filter(function(C) {
      return Vt(C % h) > xt;
    }).map(p)).concat(ei(ph(a / c) * c, i, c).filter(function(C) {
      return Vt(C % d) > xt;
    }).map(g));
  }
  return w.lines = function() {
    return x().map(function(C) {
      return { type: "LineString", coordinates: C };
    });
  }, w.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        v(r).concat(
          b(o).slice(1),
          v(n).reverse().slice(1),
          b(s).reverse().slice(1)
        )
      ]
    };
  }, w.extent = function(C) {
    return arguments.length ? w.extentMajor(C).extentMinor(C) : w.extentMinor();
  }, w.extentMajor = function(C) {
    return arguments.length ? (r = +C[0][0], n = +C[1][0], s = +C[0][1], o = +C[1][1], r > n && (C = r, r = n, n = C), s > o && (C = s, s = o, o = C), w.precision(_)) : [[r, s], [n, o]];
  }, w.extentMinor = function(C) {
    return arguments.length ? (e = +C[0][0], t = +C[1][0], a = +C[0][1], i = +C[1][1], e > t && (C = e, e = t, t = C), a > i && (C = a, a = i, i = C), w.precision(_)) : [[e, a], [t, i]];
  }, w.step = function(C) {
    return arguments.length ? w.stepMajor(C).stepMinor(C) : w.stepMinor();
  }, w.stepMajor = function(C) {
    return arguments.length ? (h = +C[0], d = +C[1], w) : [h, d];
  }, w.stepMinor = function(C) {
    return arguments.length ? (l = +C[0], c = +C[1], w) : [l, c];
  }, w.precision = function(C) {
    return arguments.length ? (_ = +C, p = kw(a, i, 90), g = Nw(e, t, _), v = kw(s, o, 90), b = Nw(r, n, _), w) : _;
  }, w.extentMajor([[-180, -90 + xt], [180, 90 - xt]]).extentMinor([[-180, -80 - xt], [180, 80 + xt]]);
}
function zht() {
  return EO()();
}
function Bht(t, e) {
  var n = t[0] * Ct, r = t[1] * Ct, i = e[0] * Ct, a = e[1] * Ct, o = bt(r), s = gt(r), l = bt(a), c = gt(a), h = o * bt(n), d = o * gt(n), p = l * bt(i), g = l * gt(i), v = 2 * On(We(dw(a - r) + o * l * dw(i - n))), b = gt(v), _ = v ? function(w) {
    var x = gt(w *= v) / b, C = gt(v - w) / b, $ = C * h + x * p, E = C * d + x * g, A = C * s + x * c;
    return [
      Tn(E, $) * Jt,
      Tn(A, We($ * $ + E * E)) * Jt
    ];
  } : function() {
    return [n * Jt, r * Jt];
  };
  return _.distance = v, _;
}
const _c = (t) => t;
var qg = new Ie(), Uv = new Ie(), AO, PO, Yv, qv, la = {
  point: ge,
  lineStart: ge,
  lineEnd: ge,
  polygonStart: function() {
    la.lineStart = Hht, la.lineEnd = Vht;
  },
  polygonEnd: function() {
    la.lineStart = la.lineEnd = la.point = ge, qg.add(Vt(Uv)), Uv = new Ie();
  },
  result: function() {
    var t = qg / 2;
    return qg = new Ie(), t;
  }
};
function Hht() {
  la.point = jht;
}
function jht(t, e) {
  la.point = MO, AO = Yv = t, PO = qv = e;
}
function MO(t, e) {
  Uv.add(qv * t - Yv * e), Yv = t, qv = e;
}
function Vht() {
  MO(AO, PO);
}
const Iw = la;
var fu = 1 / 0, Jd = fu, bc = -fu, Qd = bc, Wht = {
  point: Uht,
  lineStart: ge,
  lineEnd: ge,
  polygonStart: ge,
  polygonEnd: ge,
  result: function() {
    var t = [[fu, Jd], [bc, Qd]];
    return bc = Qd = -(Jd = fu = 1 / 0), t;
  }
};
function Uht(t, e) {
  t < fu && (fu = t), t > bc && (bc = t), e < Jd && (Jd = e), e > Qd && (Qd = e);
}
const tp = Wht;
var Gv = 0, Kv = 0, Tl = 0, ep = 0, np = 0, Is = 0, Xv = 0, Zv = 0, Ol = 0, kO, NO, Jr, Qr, kr = {
  point: ko,
  lineStart: Rw,
  lineEnd: Lw,
  polygonStart: function() {
    kr.lineStart = Ght, kr.lineEnd = Kht;
  },
  polygonEnd: function() {
    kr.point = ko, kr.lineStart = Rw, kr.lineEnd = Lw;
  },
  result: function() {
    var t = Ol ? [Xv / Ol, Zv / Ol] : Is ? [ep / Is, np / Is] : Tl ? [Gv / Tl, Kv / Tl] : [NaN, NaN];
    return Gv = Kv = Tl = ep = np = Is = Xv = Zv = Ol = 0, t;
  }
};
function ko(t, e) {
  Gv += t, Kv += e, ++Tl;
}
function Rw() {
  kr.point = Yht;
}
function Yht(t, e) {
  kr.point = qht, ko(Jr = t, Qr = e);
}
function qht(t, e) {
  var n = t - Jr, r = e - Qr, i = We(n * n + r * r);
  ep += i * (Jr + t) / 2, np += i * (Qr + e) / 2, Is += i, ko(Jr = t, Qr = e);
}
function Lw() {
  kr.point = ko;
}
function Ght() {
  kr.point = Xht;
}
function Kht() {
  IO(kO, NO);
}
function Xht(t, e) {
  kr.point = IO, ko(kO = Jr = t, NO = Qr = e);
}
function IO(t, e) {
  var n = t - Jr, r = e - Qr, i = We(n * n + r * r);
  ep += i * (Jr + t) / 2, np += i * (Qr + e) / 2, Is += i, i = Qr * t - Jr * e, Xv += i * (Jr + t), Zv += i * (Qr + e), Ol += i * 3, ko(Jr = t, Qr = e);
}
const Dw = kr;
function RO(t) {
  this._context = t;
}
RO.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, $n);
        break;
      }
    }
  },
  result: ge
};
var Jv = new Ie(), Gg, LO, DO, Sl, El, rp = {
  point: ge,
  lineStart: function() {
    rp.point = Zht;
  },
  lineEnd: function() {
    Gg && FO(LO, DO), rp.point = ge;
  },
  polygonStart: function() {
    Gg = !0;
  },
  polygonEnd: function() {
    Gg = null;
  },
  result: function() {
    var t = +Jv;
    return Jv = new Ie(), t;
  }
};
function Zht(t, e) {
  rp.point = FO, LO = Sl = t, DO = El = e;
}
function FO(t, e) {
  Sl -= t, El -= e, Jv.add(We(Sl * Sl + El * El)), Sl = t, El = e;
}
const Fw = rp;
function zO() {
  this._string = [];
}
zO.prototype = {
  _radius: 4.5,
  _circle: zw(4.5),
  pointRadius: function(t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._string.push("M", t, ",", e), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", t, ",", e);
        break;
      }
      default: {
        this._circle == null && (this._circle = zw(this._radius)), this._string.push("M", t, ",", e, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    } else
      return null;
  }
};
function zw(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function B2(t, e) {
  var n = 4.5, r, i;
  function a(o) {
    return o && (typeof n == "function" && i.pointRadius(+n.apply(this, arguments)), Mr(o, r(i))), i.result();
  }
  return a.area = function(o) {
    return Mr(o, r(Iw)), Iw.result();
  }, a.measure = function(o) {
    return Mr(o, r(Fw)), Fw.result();
  }, a.bounds = function(o) {
    return Mr(o, r(tp)), tp.result();
  }, a.centroid = function(o) {
    return Mr(o, r(Dw)), Dw.result();
  }, a.projection = function(o) {
    return arguments.length ? (r = o == null ? (t = null, _c) : (t = o).stream, a) : t;
  }, a.context = function(o) {
    return arguments.length ? (i = o == null ? (e = null, new zO()) : new RO(e = o), typeof n != "function" && i.pointRadius(n), a) : e;
  }, a.pointRadius = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : (i.pointRadius(+o), +o), a) : n;
  }, a.projection(t).context(e);
}
function Jht(t) {
  return {
    stream: Wc(t)
  };
}
function Wc(t) {
  return function(e) {
    var n = new Qv();
    for (var r in t)
      n[r] = t[r];
    return n.stream = e, n;
  };
}
function Qv() {
}
Qv.prototype = {
  constructor: Qv,
  point: function(t, e) {
    this.stream.point(t, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function H2(t, e, n) {
  var r = t.clipExtent && t.clipExtent();
  return t.scale(150).translate([0, 0]), r != null && t.clipExtent(null), Mr(n, t.stream(tp)), e(tp.result()), r != null && t.clipExtent(r), t;
}
function w1(t, e, n) {
  return H2(t, function(r) {
    var i = e[1][0] - e[0][0], a = e[1][1] - e[0][1], o = Math.min(i / (r[1][0] - r[0][0]), a / (r[1][1] - r[0][1])), s = +e[0][0] + (i - o * (r[1][0] + r[0][0])) / 2, l = +e[0][1] + (a - o * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * o).translate([s, l]);
  }, n);
}
function j2(t, e, n) {
  return w1(t, [[0, 0], e], n);
}
function V2(t, e, n) {
  return H2(t, function(r) {
    var i = +e, a = i / (r[1][0] - r[0][0]), o = (i - a * (r[1][0] + r[0][0])) / 2, s = -a * r[0][1];
    t.scale(150 * a).translate([o, s]);
  }, n);
}
function W2(t, e, n) {
  return H2(t, function(r) {
    var i = +e, a = i / (r[1][1] - r[0][1]), o = -a * r[0][0], s = (i - a * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * a).translate([o, s]);
  }, n);
}
var Bw = 16, Qht = bt(30 * Ct);
function Hw(t, e) {
  return +e ? edt(t, e) : tdt(t);
}
function tdt(t) {
  return Wc({
    point: function(e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function edt(t, e) {
  function n(r, i, a, o, s, l, c, h, d, p, g, v, b, _) {
    var w = c - r, x = h - i, C = w * w + x * x;
    if (C > 4 * e && b--) {
      var $ = o + p, E = s + g, A = l + v, R = We($ * $ + E * E + A * A), L = On(A /= R), W = Vt(Vt(A) - 1) < xt || Vt(a - d) < xt ? (a + d) / 2 : Tn(E, $), P = t(W, L), k = P[0], Y = P[1], V = k - r, I = Y - i, D = x * V - w * I;
      (D * D / C > e || Vt((w * V + x * I) / C - 0.5) > 0.3 || o * p + s * g + l * v < Qht) && (n(r, i, a, o, s, l, k, Y, W, $ /= R, E /= R, A, b, _), _.point(k, Y), n(k, Y, W, $, E, A, c, h, d, p, g, v, b, _));
    }
  }
  return function(r) {
    var i, a, o, s, l, c, h, d, p, g, v, b, _ = {
      point: w,
      lineStart: x,
      lineEnd: $,
      polygonStart: function() {
        r.polygonStart(), _.lineStart = E;
      },
      polygonEnd: function() {
        r.polygonEnd(), _.lineStart = x;
      }
    };
    function w(L, W) {
      L = t(L, W), r.point(L[0], L[1]);
    }
    function x() {
      d = NaN, _.point = C, r.lineStart();
    }
    function C(L, W) {
      var P = Mo([L, W]), k = t(L, W);
      n(d, p, h, g, v, b, d = k[0], p = k[1], h = L, g = P[0], v = P[1], b = P[2], Bw, r), r.point(d, p);
    }
    function $() {
      _.point = w, r.lineEnd();
    }
    function E() {
      x(), _.point = A, _.lineEnd = R;
    }
    function A(L, W) {
      C(i = L, W), a = d, o = p, s = g, l = v, c = b, _.point = C;
    }
    function R() {
      n(d, p, h, g, v, b, a, o, i, s, l, c, Bw, r), _.lineEnd = $, $();
    }
    return _;
  };
}
var ndt = Wc({
  point: function(t, e) {
    this.stream.point(t * Ct, e * Ct);
  }
});
function rdt(t) {
  return Wc({
    point: function(e, n) {
      var r = t(e, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function idt(t, e, n, r, i) {
  function a(o, s) {
    return o *= r, s *= i, [e + t * o, n - t * s];
  }
  return a.invert = function(o, s) {
    return [(o - e) / t * r, (n - s) / t * i];
  }, a;
}
function jw(t, e, n, r, i, a) {
  if (!a)
    return idt(t, e, n, r, i);
  var o = bt(a), s = gt(a), l = o * t, c = s * t, h = o / t, d = s / t, p = (s * n - o * e) / t, g = (s * e + o * n) / t;
  function v(b, _) {
    return b *= r, _ *= i, [l * b - c * _ + e, n - c * b - l * _];
  }
  return v.invert = function(b, _) {
    return [r * (h * b - d * _ + p), i * (g - d * b - h * _)];
  }, v;
}
function Vr(t) {
  return U2(function() {
    return t;
  })();
}
function U2(t) {
  var e, n = 150, r = 480, i = 250, a = 0, o = 0, s = 0, l = 0, c = 0, h, d = 0, p = 1, g = 1, v = null, b = Hv, _ = null, w, x, C, $ = _c, E = 0.5, A, R, L, W, P;
  function k(D) {
    return L(D[0] * Ct, D[1] * Ct);
  }
  function Y(D) {
    return D = L.invert(D[0], D[1]), D && [D[0] * Jt, D[1] * Jt];
  }
  k.stream = function(D) {
    return W && P === D ? W : W = ndt(rdt(h)(b(A($(P = D)))));
  }, k.preclip = function(D) {
    return arguments.length ? (b = D, v = void 0, I()) : b;
  }, k.postclip = function(D) {
    return arguments.length ? ($ = D, _ = w = x = C = null, I()) : $;
  }, k.clipAngle = function(D) {
    return arguments.length ? (b = +D ? TO(v = D * Ct) : (v = null, Hv), I()) : v * Jt;
  }, k.clipExtent = function(D) {
    return arguments.length ? ($ = D == null ? (_ = w = x = C = null, _c) : y1(_ = +D[0][0], w = +D[0][1], x = +D[1][0], C = +D[1][1]), I()) : _ == null ? null : [[_, w], [x, C]];
  }, k.scale = function(D) {
    return arguments.length ? (n = +D, V()) : n;
  }, k.translate = function(D) {
    return arguments.length ? (r = +D[0], i = +D[1], V()) : [r, i];
  }, k.center = function(D) {
    return arguments.length ? (a = D[0] % 360 * Ct, o = D[1] % 360 * Ct, V()) : [a * Jt, o * Jt];
  }, k.rotate = function(D) {
    return arguments.length ? (s = D[0] % 360 * Ct, l = D[1] % 360 * Ct, c = D.length > 2 ? D[2] % 360 * Ct : 0, V()) : [s * Jt, l * Jt, c * Jt];
  }, k.angle = function(D) {
    return arguments.length ? (d = D % 360 * Ct, V()) : d * Jt;
  }, k.reflectX = function(D) {
    return arguments.length ? (p = D ? -1 : 1, V()) : p < 0;
  }, k.reflectY = function(D) {
    return arguments.length ? (g = D ? -1 : 1, V()) : g < 0;
  }, k.precision = function(D) {
    return arguments.length ? (A = Hw(R, E = D * D), I()) : We(E);
  }, k.fitExtent = function(D, z) {
    return w1(k, D, z);
  }, k.fitSize = function(D, z) {
    return j2(k, D, z);
  }, k.fitWidth = function(D, z) {
    return V2(k, D, z);
  }, k.fitHeight = function(D, z) {
    return W2(k, D, z);
  };
  function V() {
    var D = jw(n, 0, 0, p, g, d).apply(null, e(a, o)), z = jw(n, r - D[0], i - D[1], p, g, d);
    return h = z2(s, l, c), R = zv(e, z), L = zv(h, R), A = Hw(R, E), I();
  }
  function I() {
    return W = P = null, k;
  }
  return function() {
    return e = t.apply(this, arguments), k.invert = e.invert && Y, V();
  };
}
function Y2(t) {
  var e = 0, n = Ft / 3, r = U2(t), i = r(e, n);
  return i.parallels = function(a) {
    return arguments.length ? r(e = a[0] * Ct, n = a[1] * Ct) : [e * Jt, n * Jt];
  }, i;
}
function adt(t) {
  var e = bt(t);
  function n(r, i) {
    return [r * e, gt(i) / e];
  }
  return n.invert = function(r, i) {
    return [r / e, On(i * e)];
  }, n;
}
function BO(t, e) {
  var n = gt(t), r = (n + gt(e)) / 2;
  if (Vt(r) < xt)
    return adt(t);
  var i = 1 + n * (2 * r - n), a = We(i) / r;
  function o(s, l) {
    var c = We(i - 2 * r * gt(l)) / r;
    return [c * gt(s *= r), a - c * bt(s)];
  }
  return o.invert = function(s, l) {
    var c = a - l, h = Tn(s, Vt(c)) * wr(c);
    return c * r < 0 && (h -= Ft * wr(s) * wr(c)), [h / r, On((i - (s * s + c * c) * r * r) / (2 * r))];
  }, o;
}
function ip() {
  return Y2(BO).scale(155.424).center([0, 33.6442]);
}
function HO() {
  return ip().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function odt(t) {
  var e = t.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < e; )
        t[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < e; )
        t[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < e; )
        t[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonEnd();
    }
  };
}
function sdt() {
  var t, e, n = HO(), r, i = ip().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), a, o = ip().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), s, l, c = { point: function(p, g) {
    l = [p, g];
  } };
  function h(p) {
    var g = p[0], v = p[1];
    return l = null, r.point(g, v), l || (a.point(g, v), l) || (s.point(g, v), l);
  }
  h.invert = function(p) {
    var g = n.scale(), v = n.translate(), b = (p[0] - v[0]) / g, _ = (p[1] - v[1]) / g;
    return (_ >= 0.12 && _ < 0.234 && b >= -0.425 && b < -0.214 ? i : _ >= 0.166 && _ < 0.234 && b >= -0.214 && b < -0.115 ? o : n).invert(p);
  }, h.stream = function(p) {
    return t && e === p ? t : t = odt([n.stream(e = p), i.stream(p), o.stream(p)]);
  }, h.precision = function(p) {
    return arguments.length ? (n.precision(p), i.precision(p), o.precision(p), d()) : n.precision();
  }, h.scale = function(p) {
    return arguments.length ? (n.scale(p), i.scale(p * 0.35), o.scale(p), h.translate(n.translate())) : n.scale();
  }, h.translate = function(p) {
    if (!arguments.length)
      return n.translate();
    var g = n.scale(), v = +p[0], b = +p[1];
    return r = n.translate(p).clipExtent([[v - 0.455 * g, b - 0.238 * g], [v + 0.455 * g, b + 0.238 * g]]).stream(c), a = i.translate([v - 0.307 * g, b + 0.201 * g]).clipExtent([[v - 0.425 * g + xt, b + 0.12 * g + xt], [v - 0.214 * g - xt, b + 0.234 * g - xt]]).stream(c), s = o.translate([v - 0.205 * g, b + 0.212 * g]).clipExtent([[v - 0.214 * g + xt, b + 0.166 * g + xt], [v - 0.115 * g - xt, b + 0.234 * g - xt]]).stream(c), d();
  }, h.fitExtent = function(p, g) {
    return w1(h, p, g);
  }, h.fitSize = function(p, g) {
    return j2(h, p, g);
  }, h.fitWidth = function(p, g) {
    return V2(h, p, g);
  }, h.fitHeight = function(p, g) {
    return W2(h, p, g);
  };
  function d() {
    return t = e = null, h;
  }
  return h.scale(1070);
}
function jO(t) {
  return function(e, n) {
    var r = bt(e), i = bt(n), a = t(r * i);
    return a === 1 / 0 ? [2, 0] : [
      a * i * gt(e),
      a * gt(n)
    ];
  };
}
function Uc(t) {
  return function(e, n) {
    var r = We(e * e + n * n), i = t(r), a = gt(i), o = bt(i);
    return [
      Tn(e * a, r * o),
      On(r && n * a / r)
    ];
  };
}
var q2 = jO(function(t) {
  return We(2 / (1 + t));
});
q2.invert = Uc(function(t) {
  return 2 * On(t / 2);
});
function udt() {
  return Vr(q2).scale(124.75).clipAngle(180 - 1e-3);
}
var G2 = jO(function(t) {
  return (t = uO(t)) && t / gt(t);
});
G2.invert = Uc(function(t) {
  return t;
});
function ldt() {
  return Vr(G2).scale(79.4188).clipAngle(180 - 1e-3);
}
function Yc(t, e) {
  return [t, Dd(D2((we + e) / 2))];
}
Yc.invert = function(t, e) {
  return [t, 2 * Ru(sO(e)) - we];
};
function cdt() {
  return VO(Yc).scale(961 / $n);
}
function VO(t) {
  var e = Vr(t), n = e.center, r = e.scale, i = e.translate, a = e.clipExtent, o = null, s, l, c;
  e.scale = function(d) {
    return arguments.length ? (r(d), h()) : r();
  }, e.translate = function(d) {
    return arguments.length ? (i(d), h()) : i();
  }, e.center = function(d) {
    return arguments.length ? (n(d), h()) : n();
  }, e.clipExtent = function(d) {
    return arguments.length ? (d == null ? o = s = l = c = null : (o = +d[0][0], s = +d[0][1], l = +d[1][0], c = +d[1][1]), h()) : o == null ? null : [[o, s], [l, c]];
  };
  function h() {
    var d = Ft * r(), p = e(bO(e.rotate()).invert([0, 0]));
    return a(o == null ? [[p[0] - d, p[1] - d], [p[0] + d, p[1] + d]] : t === Yc ? [[Math.max(p[0] - d, o), s], [Math.min(p[0] + d, l), c]] : [[o, Math.max(p[1] - d, s)], [l, Math.min(p[1] + d, c)]]);
  }
  return h();
}
function bh(t) {
  return D2((we + t) / 2);
}
function WO(t, e) {
  var n = bt(t), r = t === e ? gt(t) : Dd(n / bt(e)) / Dd(bh(e) / bh(t)), i = n * Wg(bh(t), r) / r;
  if (!r)
    return Yc;
  function a(o, s) {
    i > 0 ? s < -we + xt && (s = -we + xt) : s > we - xt && (s = we - xt);
    var l = i / Wg(bh(s), r);
    return [l * gt(r * o), i - l * bt(r * o)];
  }
  return a.invert = function(o, s) {
    var l = i - s, c = wr(r) * We(o * o + l * l), h = Tn(o, Vt(l)) * wr(l);
    return l * r < 0 && (h -= Ft * wr(o) * wr(l)), [h / r, 2 * Ru(Wg(i / c, 1 / r)) - we];
  }, a;
}
function fdt() {
  return Y2(WO).scale(109.5).parallels([30, 30]);
}
function yc(t, e) {
  return [t, e];
}
yc.invert = yc;
function hdt() {
  return Vr(yc).scale(152.63);
}
function UO(t, e) {
  var n = bt(t), r = t === e ? gt(t) : (n - bt(e)) / (e - t), i = n / r + t;
  if (Vt(r) < xt)
    return yc;
  function a(o, s) {
    var l = i - s, c = r * o;
    return [l * gt(c), i - l * bt(c)];
  }
  return a.invert = function(o, s) {
    var l = i - s, c = Tn(o, Vt(l)) * wr(l);
    return l * r < 0 && (c -= Ft * wr(o) * wr(l)), [c / r, i - wr(r) * We(o * o + l * l)];
  }, a;
}
function ddt() {
  return Y2(UO).scale(131.154).center([0, 13.9389]);
}
var Hl = 1.340264, jl = -0.081106, Vl = 893e-6, Wl = 3796e-6, ap = We(3) / 2, pdt = 12;
function K2(t, e) {
  var n = On(ap * gt(e)), r = n * n, i = r * r * r;
  return [
    t * bt(n) / (ap * (Hl + 3 * jl * r + i * (7 * Vl + 9 * Wl * r))),
    n * (Hl + jl * r + i * (Vl + Wl * r))
  ];
}
K2.invert = function(t, e) {
  for (var n = e, r = n * n, i = r * r * r, a = 0, o, s, l; a < pdt && (s = n * (Hl + jl * r + i * (Vl + Wl * r)) - e, l = Hl + 3 * jl * r + i * (7 * Vl + 9 * Wl * r), n -= o = s / l, r = n * n, i = r * r * r, !(Vt(o) < vc)); ++a)
    ;
  return [
    ap * t * (Hl + 3 * jl * r + i * (7 * Vl + 9 * Wl * r)) / bt(n),
    On(gt(n) / ap)
  ];
};
function mdt() {
  return Vr(K2).scale(177.158);
}
function X2(t, e) {
  var n = bt(e), r = bt(t) * n;
  return [n * gt(t) / r, gt(e) / r];
}
X2.invert = Uc(Ru);
function gdt() {
  return Vr(X2).scale(144.049).clipAngle(60);
}
function vdt() {
  var t = 1, e = 0, n = 0, r = 1, i = 1, a = 0, o, s, l = null, c, h, d, p = 1, g = 1, v = Wc({
    point: function($, E) {
      var A = C([$, E]);
      this.stream.point(A[0], A[1]);
    }
  }), b = _c, _, w;
  function x() {
    return p = t * r, g = t * i, _ = w = null, C;
  }
  function C($) {
    var E = $[0] * p, A = $[1] * g;
    if (a) {
      var R = A * o - E * s;
      E = E * o + A * s, A = R;
    }
    return [E + e, A + n];
  }
  return C.invert = function($) {
    var E = $[0] - e, A = $[1] - n;
    if (a) {
      var R = A * o + E * s;
      E = E * o - A * s, A = R;
    }
    return [E / p, A / g];
  }, C.stream = function($) {
    return _ && w === $ ? _ : _ = v(b(w = $));
  }, C.postclip = function($) {
    return arguments.length ? (b = $, l = c = h = d = null, x()) : b;
  }, C.clipExtent = function($) {
    return arguments.length ? (b = $ == null ? (l = c = h = d = null, _c) : y1(l = +$[0][0], c = +$[0][1], h = +$[1][0], d = +$[1][1]), x()) : l == null ? null : [[l, c], [h, d]];
  }, C.scale = function($) {
    return arguments.length ? (t = +$, x()) : t;
  }, C.translate = function($) {
    return arguments.length ? (e = +$[0], n = +$[1], x()) : [e, n];
  }, C.angle = function($) {
    return arguments.length ? (a = $ % 360 * Ct, s = gt(a), o = bt(a), x()) : a * Jt;
  }, C.reflectX = function($) {
    return arguments.length ? (r = $ ? -1 : 1, x()) : r < 0;
  }, C.reflectY = function($) {
    return arguments.length ? (i = $ ? -1 : 1, x()) : i < 0;
  }, C.fitExtent = function($, E) {
    return w1(C, $, E);
  }, C.fitSize = function($, E) {
    return j2(C, $, E);
  }, C.fitWidth = function($, E) {
    return V2(C, $, E);
  }, C.fitHeight = function($, E) {
    return W2(C, $, E);
  }, C;
}
function Z2(t, e) {
  var n = e * e, r = n * n;
  return [
    t * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    e * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
Z2.invert = function(t, e) {
  var n = e, r = 25, i;
  do {
    var a = n * n, o = a * a;
    n -= i = (n * (1.007226 + a * (0.015085 + o * (-0.044475 + 0.028874 * a - 5916e-6 * o))) - e) / (1.007226 + a * (0.015085 * 3 + o * (-0.044475 * 7 + 0.028874 * 9 * a - 5916e-6 * 11 * o)));
  } while (Vt(i) > xt && --r > 0);
  return [
    t / (0.8707 + (a = n * n) * (-0.131979 + a * (-0.013791 + a * a * a * (3971e-6 - 1529e-6 * a)))),
    n
  ];
};
function _dt() {
  return Vr(Z2).scale(175.295);
}
function J2(t, e) {
  return [bt(e) * gt(t), gt(e)];
}
J2.invert = Uc(On);
function bdt() {
  return Vr(J2).scale(249.5).clipAngle(90 + xt);
}
function Q2(t, e) {
  var n = bt(e), r = 1 + bt(t) * n;
  return [n * gt(t) / r, gt(e) / r];
}
Q2.invert = Uc(function(t) {
  return 2 * Ru(t);
});
function ydt() {
  return Vr(Q2).scale(250).clipAngle(142);
}
function tb(t, e) {
  return [Dd(D2((we + e) / 2)), -t];
}
tb.invert = function(t, e) {
  return [-e, 2 * Ru(sO(t)) - we];
};
function wdt() {
  var t = VO(tb), e = t.center, n = t.rotate;
  return t.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
function xdt(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function Cdt(t) {
  return t.reduce($dt, 0) / t.length;
}
function $dt(t, e) {
  return t + e.x;
}
function Tdt(t) {
  return 1 + t.reduce(Odt, 0);
}
function Odt(t, e) {
  return Math.max(t, e.y);
}
function Sdt(t) {
  for (var e; e = t.children; )
    t = e[0];
  return t;
}
function Edt(t) {
  for (var e; e = t.children; )
    t = e[e.length - 1];
  return t;
}
function Adt() {
  var t = xdt, e = 1, n = 1, r = !1;
  function i(a) {
    var o, s = 0;
    a.eachAfter(function(p) {
      var g = p.children;
      g ? (p.x = Cdt(g), p.y = Tdt(g)) : (p.x = o ? s += t(p, o) : 0, p.y = 0, o = p);
    });
    var l = Sdt(a), c = Edt(a), h = l.x - t(l, c) / 2, d = c.x + t(c, l) / 2;
    return a.eachAfter(r ? function(p) {
      p.x = (p.x - a.x) * e, p.y = (a.y - p.y) * n;
    } : function(p) {
      p.x = (p.x - h) / (d - h) * e, p.y = (1 - (a.y ? p.y / a.y : 1)) * n;
    });
  }
  return i.separation = function(a) {
    return arguments.length ? (t = a, i) : t;
  }, i.size = function(a) {
    return arguments.length ? (r = !1, e = +a[0], n = +a[1], i) : r ? null : [e, n];
  }, i.nodeSize = function(a) {
    return arguments.length ? (r = !0, e = +a[0], n = +a[1], i) : r ? [e, n] : null;
  }, i;
}
function Pdt(t) {
  var e = 0, n = t.children, r = n && n.length;
  if (!r)
    e = 1;
  else
    for (; --r >= 0; )
      e += n[r].value;
  t.value = e;
}
function Mdt() {
  return this.eachAfter(Pdt);
}
function kdt(t, e) {
  let n = -1;
  for (const r of this)
    t.call(e, r, ++n, this);
  return this;
}
function Ndt(t, e) {
  for (var n = this, r = [n], i, a, o = -1; n = r.pop(); )
    if (t.call(e, n, ++o, this), i = n.children)
      for (a = i.length - 1; a >= 0; --a)
        r.push(i[a]);
  return this;
}
function Idt(t, e) {
  for (var n = this, r = [n], i = [], a, o, s, l = -1; n = r.pop(); )
    if (i.push(n), a = n.children)
      for (o = 0, s = a.length; o < s; ++o)
        r.push(a[o]);
  for (; n = i.pop(); )
    t.call(e, n, ++l, this);
  return this;
}
function Rdt(t, e) {
  let n = -1;
  for (const r of this)
    if (t.call(e, r, ++n, this))
      return r;
}
function Ldt(t) {
  return this.eachAfter(function(e) {
    for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0; )
      n += r[i].value;
    e.value = n;
  });
}
function Ddt(t) {
  return this.eachBefore(function(e) {
    e.children && e.children.sort(t);
  });
}
function Fdt(t) {
  for (var e = this, n = zdt(e, t), r = [e]; e !== n; )
    e = e.parent, r.push(e);
  for (var i = r.length; t !== n; )
    r.splice(i, 0, t), t = t.parent;
  return r;
}
function zdt(t, e) {
  if (t === e)
    return t;
  var n = t.ancestors(), r = e.ancestors(), i = null;
  for (t = n.pop(), e = r.pop(); t === e; )
    i = t, t = n.pop(), e = r.pop();
  return i;
}
function Bdt() {
  for (var t = this, e = [t]; t = t.parent; )
    e.push(t);
  return e;
}
function Hdt() {
  return Array.from(this);
}
function jdt() {
  var t = [];
  return this.eachBefore(function(e) {
    e.children || t.push(e);
  }), t;
}
function Vdt() {
  var t = this, e = [];
  return t.each(function(n) {
    n !== t && e.push({ source: n.parent, target: n });
  }), e;
}
function* Wdt() {
  var t = this, e, n = [t], r, i, a;
  do
    for (e = n.reverse(), n = []; t = e.pop(); )
      if (yield t, r = t.children)
        for (i = 0, a = r.length; i < a; ++i)
          n.push(r[i]);
  while (n.length);
}
function eb(t, e) {
  t instanceof Map ? (t = [void 0, t], e === void 0 && (e = qdt)) : e === void 0 && (e = Ydt);
  for (var n = new No(t), r, i = [n], a, o, s, l; r = i.pop(); )
    if ((o = e(r.data)) && (l = (o = Array.from(o)).length))
      for (r.children = o, s = l - 1; s >= 0; --s)
        i.push(a = o[s] = new No(o[s])), a.parent = r, a.depth = r.depth + 1;
  return n.eachBefore(YO);
}
function Udt() {
  return eb(this).eachBefore(Gdt);
}
function Ydt(t) {
  return t.children;
}
function qdt(t) {
  return Array.isArray(t) ? t[1] : null;
}
function Gdt(t) {
  t.data.value !== void 0 && (t.value = t.data.value), t.data = t.data.data;
}
function YO(t) {
  var e = 0;
  do
    t.height = e;
  while ((t = t.parent) && t.height < ++e);
}
function No(t) {
  this.data = t, this.depth = this.height = 0, this.parent = null;
}
No.prototype = eb.prototype = {
  constructor: No,
  count: Mdt,
  each: kdt,
  eachAfter: Idt,
  eachBefore: Ndt,
  find: Rdt,
  sum: Ldt,
  sort: Ddt,
  path: Fdt,
  ancestors: Bdt,
  descendants: Hdt,
  leaves: jdt,
  links: Vdt,
  copy: Udt,
  [Symbol.iterator]: Wdt
};
function Kdt(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Xdt(t) {
  for (var e = t.length, n, r; e; )
    r = Math.random() * e-- | 0, n = t[e], t[e] = t[r], t[r] = n;
  return t;
}
function qO(t) {
  for (var e = 0, n = (t = Xdt(Array.from(t))).length, r = [], i, a; e < n; )
    i = t[e], a && GO(a, i) ? ++e : (a = Jdt(r = Zdt(r, i)), e = 0);
  return a;
}
function Zdt(t, e) {
  var n, r;
  if (Kg(e, t))
    return [e];
  for (n = 0; n < t.length; ++n)
    if (yh(e, t[n]) && Kg(Al(t[n], e), t))
      return [t[n], e];
  for (n = 0; n < t.length - 1; ++n)
    for (r = n + 1; r < t.length; ++r)
      if (yh(Al(t[n], t[r]), e) && yh(Al(t[n], e), t[r]) && yh(Al(t[r], e), t[n]) && Kg(KO(t[n], t[r], e), t))
        return [t[n], t[r], e];
  throw new Error();
}
function yh(t, e) {
  var n = t.r - e.r, r = e.x - t.x, i = e.y - t.y;
  return n < 0 || n * n < r * r + i * i;
}
function GO(t, e) {
  var n = t.r - e.r + Math.max(t.r, e.r, 1) * 1e-9, r = e.x - t.x, i = e.y - t.y;
  return n > 0 && n * n > r * r + i * i;
}
function Kg(t, e) {
  for (var n = 0; n < e.length; ++n)
    if (!GO(t, e[n]))
      return !1;
  return !0;
}
function Jdt(t) {
  switch (t.length) {
    case 1:
      return Qdt(t[0]);
    case 2:
      return Al(t[0], t[1]);
    case 3:
      return KO(t[0], t[1], t[2]);
  }
}
function Qdt(t) {
  return {
    x: t.x,
    y: t.y,
    r: t.r
  };
}
function Al(t, e) {
  var n = t.x, r = t.y, i = t.r, a = e.x, o = e.y, s = e.r, l = a - n, c = o - r, h = s - i, d = Math.sqrt(l * l + c * c);
  return {
    x: (n + a + l / d * h) / 2,
    y: (r + o + c / d * h) / 2,
    r: (d + i + s) / 2
  };
}
function KO(t, e, n) {
  var r = t.x, i = t.y, a = t.r, o = e.x, s = e.y, l = e.r, c = n.x, h = n.y, d = n.r, p = r - o, g = r - c, v = i - s, b = i - h, _ = l - a, w = d - a, x = r * r + i * i - a * a, C = x - o * o - s * s + l * l, $ = x - c * c - h * h + d * d, E = g * v - p * b, A = (v * $ - b * C) / (E * 2) - r, R = (b * _ - v * w) / E, L = (g * C - p * $) / (E * 2) - i, W = (p * w - g * _) / E, P = R * R + W * W - 1, k = 2 * (a + A * R + L * W), Y = A * A + L * L - a * a, V = -(P ? (k + Math.sqrt(k * k - 4 * P * Y)) / (2 * P) : Y / k);
  return {
    x: r + A + R * V,
    y: i + L + W * V,
    r: V
  };
}
function Vw(t, e, n) {
  var r = t.x - e.x, i, a, o = t.y - e.y, s, l, c = r * r + o * o;
  c ? (a = e.r + n.r, a *= a, l = t.r + n.r, l *= l, a > l ? (i = (c + l - a) / (2 * c), s = Math.sqrt(Math.max(0, l / c - i * i)), n.x = t.x - i * r - s * o, n.y = t.y - i * o + s * r) : (i = (c + a - l) / (2 * c), s = Math.sqrt(Math.max(0, a / c - i * i)), n.x = e.x + i * r - s * o, n.y = e.y + i * o + s * r)) : (n.x = e.x + n.r, n.y = e.y);
}
function Ww(t, e) {
  var n = t.r + e.r - 1e-6, r = e.x - t.x, i = e.y - t.y;
  return n > 0 && n * n > r * r + i * i;
}
function Uw(t) {
  var e = t._, n = t.next._, r = e.r + n.r, i = (e.x * n.r + n.x * e.r) / r, a = (e.y * n.r + n.y * e.r) / r;
  return i * i + a * a;
}
function wh(t) {
  this._ = t, this.next = null, this.previous = null;
}
function XO(t) {
  if (!(i = (t = Kdt(t)).length))
    return 0;
  var e, n, r, i, a, o, s, l, c, h, d;
  if (e = t[0], e.x = 0, e.y = 0, !(i > 1))
    return e.r;
  if (n = t[1], e.x = -n.r, n.x = e.r, n.y = 0, !(i > 2))
    return e.r + n.r;
  Vw(n, e, r = t[2]), e = new wh(e), n = new wh(n), r = new wh(r), e.next = r.previous = n, n.next = e.previous = r, r.next = n.previous = e;
  t:
    for (s = 3; s < i; ++s) {
      Vw(e._, n._, r = t[s]), r = new wh(r), l = n.next, c = e.previous, h = n._.r, d = e._.r;
      do
        if (h <= d) {
          if (Ww(l._, r._)) {
            n = l, e.next = n, n.previous = e, --s;
            continue t;
          }
          h += l._.r, l = l.next;
        } else {
          if (Ww(c._, r._)) {
            e = c, e.next = n, n.previous = e, --s;
            continue t;
          }
          d += c._.r, c = c.previous;
        }
      while (l !== c.next);
      for (r.previous = e, r.next = n, e.next = n.previous = n = r, a = Uw(e); (r = r.next) !== n; )
        (o = Uw(r)) < a && (e = r, a = o);
      n = e.next;
    }
  for (e = [n._], r = n; (r = r.next) !== n; )
    e.push(r._);
  for (r = qO(e), s = 0; s < i; ++s)
    e = t[s], e.x -= r.x, e.y -= r.y;
  return r.r;
}
function tpt(t) {
  return XO(t), t;
}
function ept(t) {
  return t == null ? null : op(t);
}
function op(t) {
  if (typeof t != "function")
    throw new Error();
  return t;
}
function uo() {
  return 0;
}
function Os(t) {
  return function() {
    return t;
  };
}
function npt(t) {
  return Math.sqrt(t.value);
}
function rpt() {
  var t = null, e = 1, n = 1, r = uo;
  function i(a) {
    return a.x = e / 2, a.y = n / 2, t ? a.eachBefore(Yw(t)).eachAfter(Xg(r, 0.5)).eachBefore(qw(1)) : a.eachBefore(Yw(npt)).eachAfter(Xg(uo, 1)).eachAfter(Xg(r, a.r / Math.min(e, n))).eachBefore(qw(Math.min(e, n) / (2 * a.r))), a;
  }
  return i.radius = function(a) {
    return arguments.length ? (t = ept(a), i) : t;
  }, i.size = function(a) {
    return arguments.length ? (e = +a[0], n = +a[1], i) : [e, n];
  }, i.padding = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Os(+a), i) : r;
  }, i;
}
function Yw(t) {
  return function(e) {
    e.children || (e.r = Math.max(0, +t(e) || 0));
  };
}
function Xg(t, e) {
  return function(n) {
    if (r = n.children) {
      var r, i, a = r.length, o = t(n) * e || 0, s;
      if (o)
        for (i = 0; i < a; ++i)
          r[i].r += o;
      if (s = XO(r), o)
        for (i = 0; i < a; ++i)
          r[i].r -= o;
      n.r = s + o;
    }
  };
}
function qw(t) {
  return function(e) {
    var n = e.parent;
    e.r *= t, n && (e.x = n.x + t * e.x, e.y = n.y + t * e.y);
  };
}
function ZO(t) {
  t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
}
function qc(t, e, n, r, i) {
  for (var a = t.children, o, s = -1, l = a.length, c = t.value && (r - e) / t.value; ++s < l; )
    o = a[s], o.y0 = n, o.y1 = i, o.x0 = e, o.x1 = e += o.value * c;
}
function ipt() {
  var t = 1, e = 1, n = 0, r = !1;
  function i(o) {
    var s = o.height + 1;
    return o.x0 = o.y0 = n, o.x1 = t, o.y1 = e / s, o.eachBefore(a(e, s)), r && o.eachBefore(ZO), o;
  }
  function a(o, s) {
    return function(l) {
      l.children && qc(l, l.x0, o * (l.depth + 1) / s, l.x1, o * (l.depth + 2) / s);
      var c = l.x0, h = l.y0, d = l.x1 - n, p = l.y1 - n;
      d < c && (c = d = (c + d) / 2), p < h && (h = p = (h + p) / 2), l.x0 = c, l.y0 = h, l.x1 = d, l.y1 = p;
    };
  }
  return i.round = function(o) {
    return arguments.length ? (r = !!o, i) : r;
  }, i.size = function(o) {
    return arguments.length ? (t = +o[0], e = +o[1], i) : [t, e];
  }, i.padding = function(o) {
    return arguments.length ? (n = +o, i) : n;
  }, i;
}
var apt = { depth: -1 }, Gw = {};
function opt(t) {
  return t.id;
}
function spt(t) {
  return t.parentId;
}
function upt() {
  var t = opt, e = spt;
  function n(r) {
    var i = Array.from(r), a = i.length, o, s, l, c, h, d, p, g = /* @__PURE__ */ new Map();
    for (s = 0; s < a; ++s)
      o = i[s], h = i[s] = new No(o), (d = t(o, s, r)) != null && (d += "") && (p = h.id = d, g.set(p, g.has(p) ? Gw : h)), (d = e(o, s, r)) != null && (d += "") && (h.parent = d);
    for (s = 0; s < a; ++s)
      if (h = i[s], d = h.parent) {
        if (c = g.get(d), !c)
          throw new Error("missing: " + d);
        if (c === Gw)
          throw new Error("ambiguous: " + d);
        c.children ? c.children.push(h) : c.children = [h], h.parent = c;
      } else {
        if (l)
          throw new Error("multiple roots");
        l = h;
      }
    if (!l)
      throw new Error("no root");
    if (l.parent = apt, l.eachBefore(function(v) {
      v.depth = v.parent.depth + 1, --a;
    }).eachBefore(YO), l.parent = null, a > 0)
      throw new Error("cycle");
    return l;
  }
  return n.id = function(r) {
    return arguments.length ? (t = op(r), n) : t;
  }, n.parentId = function(r) {
    return arguments.length ? (e = op(r), n) : e;
  }, n;
}
function lpt(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function Zg(t) {
  var e = t.children;
  return e ? e[0] : t.t;
}
function Jg(t) {
  var e = t.children;
  return e ? e[e.length - 1] : t.t;
}
function cpt(t, e, n) {
  var r = n / (e.i - t.i);
  e.c -= r, e.s += n, t.c += r, e.z += n, e.m += n;
}
function fpt(t) {
  for (var e = 0, n = 0, r = t.children, i = r.length, a; --i >= 0; )
    a = r[i], a.z += e, a.m += e, e += a.s + (n += a.c);
}
function hpt(t, e, n) {
  return t.a.parent === e.parent ? t.a : n;
}
function Gh(t, e) {
  this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
}
Gh.prototype = Object.create(No.prototype);
function dpt(t) {
  for (var e = new Gh(t, 0), n, r = [e], i, a, o, s; n = r.pop(); )
    if (a = n._.children)
      for (n.children = new Array(s = a.length), o = s - 1; o >= 0; --o)
        r.push(i = n.children[o] = new Gh(a[o], o)), i.parent = n;
  return (e.parent = new Gh(null, 0)).children = [e], e;
}
function ppt() {
  var t = lpt, e = 1, n = 1, r = null;
  function i(c) {
    var h = dpt(c);
    if (h.eachAfter(a), h.parent.m = -h.z, h.eachBefore(o), r)
      c.eachBefore(l);
    else {
      var d = c, p = c, g = c;
      c.eachBefore(function(x) {
        x.x < d.x && (d = x), x.x > p.x && (p = x), x.depth > g.depth && (g = x);
      });
      var v = d === p ? 1 : t(d, p) / 2, b = v - d.x, _ = e / (p.x + v + b), w = n / (g.depth || 1);
      c.eachBefore(function(x) {
        x.x = (x.x + b) * _, x.y = x.depth * w;
      });
    }
    return c;
  }
  function a(c) {
    var h = c.children, d = c.parent.children, p = c.i ? d[c.i - 1] : null;
    if (h) {
      fpt(c);
      var g = (h[0].z + h[h.length - 1].z) / 2;
      p ? (c.z = p.z + t(c._, p._), c.m = c.z - g) : c.z = g;
    } else
      p && (c.z = p.z + t(c._, p._));
    c.parent.A = s(c, p, c.parent.A || d[0]);
  }
  function o(c) {
    c._.x = c.z + c.parent.m, c.m += c.parent.m;
  }
  function s(c, h, d) {
    if (h) {
      for (var p = c, g = c, v = h, b = p.parent.children[0], _ = p.m, w = g.m, x = v.m, C = b.m, $; v = Jg(v), p = Zg(p), v && p; )
        b = Zg(b), g = Jg(g), g.a = c, $ = v.z + x - p.z - _ + t(v._, p._), $ > 0 && (cpt(hpt(v, c, d), c, $), _ += $, w += $), x += v.m, _ += p.m, C += b.m, w += g.m;
      v && !Jg(g) && (g.t = v, g.m += x - w), p && !Zg(b) && (b.t = p, b.m += _ - C, d = c);
    }
    return d;
  }
  function l(c) {
    c.x *= e, c.y = c.depth * n;
  }
  return i.separation = function(c) {
    return arguments.length ? (t = c, i) : t;
  }, i.size = function(c) {
    return arguments.length ? (r = !1, e = +c[0], n = +c[1], i) : r ? null : [e, n];
  }, i.nodeSize = function(c) {
    return arguments.length ? (r = !0, e = +c[0], n = +c[1], i) : r ? [e, n] : null;
  }, i;
}
function x1(t, e, n, r, i) {
  for (var a = t.children, o, s = -1, l = a.length, c = t.value && (i - n) / t.value; ++s < l; )
    o = a[s], o.x0 = e, o.x1 = r, o.y0 = n, o.y1 = n += o.value * c;
}
var JO = (1 + Math.sqrt(5)) / 2;
function QO(t, e, n, r, i, a) {
  for (var o = [], s = e.children, l, c, h = 0, d = 0, p = s.length, g, v, b = e.value, _, w, x, C, $, E, A; h < p; ) {
    g = i - n, v = a - r;
    do
      _ = s[d++].value;
    while (!_ && d < p);
    for (w = x = _, E = Math.max(v / g, g / v) / (b * t), A = _ * _ * E, $ = Math.max(x / A, A / w); d < p; ++d) {
      if (_ += c = s[d].value, c < w && (w = c), c > x && (x = c), A = _ * _ * E, C = Math.max(x / A, A / w), C > $) {
        _ -= c;
        break;
      }
      $ = C;
    }
    o.push(l = { value: _, dice: g < v, children: s.slice(h, d) }), l.dice ? qc(l, n, r, i, b ? r += v * _ / b : a) : x1(l, n, r, b ? n += g * _ / b : i, a), b -= _, h = d;
  }
  return o;
}
const tS = function t(e) {
  function n(r, i, a, o, s) {
    QO(e, r, i, a, o, s);
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(JO);
function mpt() {
  var t = tS, e = !1, n = 1, r = 1, i = [0], a = uo, o = uo, s = uo, l = uo, c = uo;
  function h(p) {
    return p.x0 = p.y0 = 0, p.x1 = n, p.y1 = r, p.eachBefore(d), i = [0], e && p.eachBefore(ZO), p;
  }
  function d(p) {
    var g = i[p.depth], v = p.x0 + g, b = p.y0 + g, _ = p.x1 - g, w = p.y1 - g;
    _ < v && (v = _ = (v + _) / 2), w < b && (b = w = (b + w) / 2), p.x0 = v, p.y0 = b, p.x1 = _, p.y1 = w, p.children && (g = i[p.depth + 1] = a(p) / 2, v += c(p) - g, b += o(p) - g, _ -= s(p) - g, w -= l(p) - g, _ < v && (v = _ = (v + _) / 2), w < b && (b = w = (b + w) / 2), t(p, v, b, _, w));
  }
  return h.round = function(p) {
    return arguments.length ? (e = !!p, h) : e;
  }, h.size = function(p) {
    return arguments.length ? (n = +p[0], r = +p[1], h) : [n, r];
  }, h.tile = function(p) {
    return arguments.length ? (t = op(p), h) : t;
  }, h.padding = function(p) {
    return arguments.length ? h.paddingInner(p).paddingOuter(p) : h.paddingInner();
  }, h.paddingInner = function(p) {
    return arguments.length ? (a = typeof p == "function" ? p : Os(+p), h) : a;
  }, h.paddingOuter = function(p) {
    return arguments.length ? h.paddingTop(p).paddingRight(p).paddingBottom(p).paddingLeft(p) : h.paddingTop();
  }, h.paddingTop = function(p) {
    return arguments.length ? (o = typeof p == "function" ? p : Os(+p), h) : o;
  }, h.paddingRight = function(p) {
    return arguments.length ? (s = typeof p == "function" ? p : Os(+p), h) : s;
  }, h.paddingBottom = function(p) {
    return arguments.length ? (l = typeof p == "function" ? p : Os(+p), h) : l;
  }, h.paddingLeft = function(p) {
    return arguments.length ? (c = typeof p == "function" ? p : Os(+p), h) : c;
  }, h;
}
function gpt(t, e, n, r, i) {
  var a = t.children, o, s = a.length, l, c = new Array(s + 1);
  for (c[0] = l = o = 0; o < s; ++o)
    c[o + 1] = l += a[o].value;
  h(0, s, t.value, e, n, r, i);
  function h(d, p, g, v, b, _, w) {
    if (d >= p - 1) {
      var x = a[d];
      x.x0 = v, x.y0 = b, x.x1 = _, x.y1 = w;
      return;
    }
    for (var C = c[d], $ = g / 2 + C, E = d + 1, A = p - 1; E < A; ) {
      var R = E + A >>> 1;
      c[R] < $ ? E = R + 1 : A = R;
    }
    $ - c[E - 1] < c[E] - $ && d + 1 < E && --E;
    var L = c[E] - C, W = g - L;
    if (_ - v > w - b) {
      var P = g ? (v * W + _ * L) / g : _;
      h(d, E, L, v, b, P, w), h(E, p, W, P, b, _, w);
    } else {
      var k = g ? (b * W + w * L) / g : w;
      h(d, E, L, v, b, _, k), h(E, p, W, v, k, _, w);
    }
  }
}
function vpt(t, e, n, r, i) {
  (t.depth & 1 ? x1 : qc)(t, e, n, r, i);
}
const _pt = function t(e) {
  function n(r, i, a, o, s) {
    if ((l = r._squarify) && l.ratio === e)
      for (var l, c, h, d, p = -1, g, v = l.length, b = r.value; ++p < v; ) {
        for (c = l[p], h = c.children, d = c.value = 0, g = h.length; d < g; ++d)
          c.value += h[d].value;
        c.dice ? qc(c, i, a, o, b ? a += (s - a) * c.value / b : s) : x1(c, i, a, b ? i += (o - i) * c.value / b : o, s), b -= c.value;
      }
    else
      r._squarify = l = QO(e, r, i, a, o, s), l.ratio = e;
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(JO);
function bpt(t) {
  for (var e = -1, n = t.length, r, i = t[n - 1], a = 0; ++e < n; )
    r = i, i = t[e], a += r[1] * i[0] - r[0] * i[1];
  return a / 2;
}
function ypt(t) {
  for (var e = -1, n = t.length, r = 0, i = 0, a, o = t[n - 1], s, l = 0; ++e < n; )
    a = o, o = t[e], l += s = a[0] * o[1] - o[0] * a[1], r += (a[0] + o[0]) * s, i += (a[1] + o[1]) * s;
  return l *= 3, [r / l, i / l];
}
function wpt(t, e, n) {
  return (e[0] - t[0]) * (n[1] - t[1]) - (e[1] - t[1]) * (n[0] - t[0]);
}
function xpt(t, e) {
  return t[0] - e[0] || t[1] - e[1];
}
function Kw(t) {
  const e = t.length, n = [0, 1];
  let r = 2, i;
  for (i = 2; i < e; ++i) {
    for (; r > 1 && wpt(t[n[r - 2]], t[n[r - 1]], t[i]) <= 0; )
      --r;
    n[r++] = i;
  }
  return n.slice(0, r);
}
function Cpt(t) {
  if ((n = t.length) < 3)
    return null;
  var e, n, r = new Array(n), i = new Array(n);
  for (e = 0; e < n; ++e)
    r[e] = [+t[e][0], +t[e][1], e];
  for (r.sort(xpt), e = 0; e < n; ++e)
    i[e] = [r[e][0], -r[e][1]];
  var a = Kw(r), o = Kw(i), s = o[0] === a[0], l = o[o.length - 1] === a[a.length - 1], c = [];
  for (e = a.length - 1; e >= 0; --e)
    c.push(t[r[a[e]][2]]);
  for (e = +s; e < o.length - l; ++e)
    c.push(t[r[o[e]][2]]);
  return c;
}
function $pt(t, e) {
  for (var n = t.length, r = t[n - 1], i = e[0], a = e[1], o = r[0], s = r[1], l, c, h = !1, d = 0; d < n; ++d)
    r = t[d], l = r[0], c = r[1], c > a != s > a && i < (o - l) * (a - c) / (s - c) + l && (h = !h), o = l, s = c;
  return h;
}
function Tpt(t) {
  for (var e = -1, n = t.length, r = t[n - 1], i, a, o = r[0], s = r[1], l = 0; ++e < n; )
    i = o, a = s, r = t[e], o = r[0], s = r[1], i -= o, a -= s, l += Math.hypot(i, a);
  return l;
}
const tn = Math.random, Opt = function t(e) {
  function n(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, arguments.length === 1 ? (i = r, r = 0) : i -= r, function() {
      return e() * i + r;
    };
  }
  return n.source = t, n;
}(tn), Spt = function t(e) {
  function n(r, i) {
    return arguments.length < 2 && (i = r, r = 0), r = Math.floor(r), i = Math.floor(i) - r, function() {
      return Math.floor(e() * i + r);
    };
  }
  return n.source = t, n;
}(tn), nb = function t(e) {
  function n(r, i) {
    var a, o;
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var s;
      if (a != null)
        s = a, a = null;
      else
        do
          a = e() * 2 - 1, s = e() * 2 - 1, o = a * a + s * s;
        while (!o || o > 1);
      return r + i * s * Math.sqrt(-2 * Math.log(o) / o);
    };
  }
  return n.source = t, n;
}(tn), Ept = function t(e) {
  var n = nb.source(e);
  function r() {
    var i = n.apply(this, arguments);
    return function() {
      return Math.exp(i());
    };
  }
  return r.source = t, r;
}(tn), eS = function t(e) {
  function n(r) {
    return (r = +r) <= 0 ? () => 0 : function() {
      for (var i = 0, a = r; a > 1; --a)
        i += e();
      return i + a * e();
    };
  }
  return n.source = t, n;
}(tn), Apt = function t(e) {
  var n = eS.source(e);
  function r(i) {
    if ((i = +i) == 0)
      return e;
    var a = n(i);
    return function() {
      return a() / i;
    };
  }
  return r.source = t, r;
}(tn), Ppt = function t(e) {
  function n(r) {
    return function() {
      return -Math.log1p(-e()) / r;
    };
  }
  return n.source = t, n;
}(tn), Mpt = function t(e) {
  function n(r) {
    if ((r = +r) < 0)
      throw new RangeError("invalid alpha");
    return r = 1 / -r, function() {
      return Math.pow(1 - e(), r);
    };
  }
  return n.source = t, n;
}(tn), kpt = function t(e) {
  function n(r) {
    if ((r = +r) < 0 || r > 1)
      throw new RangeError("invalid p");
    return function() {
      return Math.floor(e() + r);
    };
  }
  return n.source = t, n;
}(tn), nS = function t(e) {
  function n(r) {
    if ((r = +r) < 0 || r > 1)
      throw new RangeError("invalid p");
    return r === 0 ? () => 1 / 0 : r === 1 ? () => 1 : (r = Math.log1p(-r), function() {
      return 1 + Math.floor(Math.log1p(-e()) / r);
    });
  }
  return n.source = t, n;
}(tn), rb = function t(e) {
  var n = nb.source(e)();
  function r(i, a) {
    if ((i = +i) < 0)
      throw new RangeError("invalid k");
    if (i === 0)
      return () => 0;
    if (a = a == null ? 1 : +a, i === 1)
      return () => -Math.log1p(-e()) * a;
    var o = (i < 1 ? i + 1 : i) - 1 / 3, s = 1 / (3 * Math.sqrt(o)), l = i < 1 ? () => Math.pow(e(), 1 / i) : () => 1;
    return function() {
      do {
        do
          var c = n(), h = 1 + s * c;
        while (h <= 0);
        h *= h * h;
        var d = 1 - e();
      } while (d >= 1 - 0.0331 * c * c * c * c && Math.log(d) >= 0.5 * c * c + o * (1 - h + Math.log(h)));
      return o * h * l() * a;
    };
  }
  return r.source = t, r;
}(tn), rS = function t(e) {
  var n = rb.source(e);
  function r(i, a) {
    var o = n(i), s = n(a);
    return function() {
      var l = o();
      return l === 0 ? 0 : l / (l + s());
    };
  }
  return r.source = t, r;
}(tn), iS = function t(e) {
  var n = nS.source(e), r = rS.source(e);
  function i(a, o) {
    return a = +a, (o = +o) >= 1 ? () => a : o <= 0 ? () => 0 : function() {
      for (var s = 0, l = a, c = o; l * c > 16 && l * (1 - c) > 16; ) {
        var h = Math.floor((l + 1) * c), d = r(h, l - h + 1)();
        d <= c ? (s += h, l -= h, c = (c - d) / (1 - d)) : (l = h - 1, c /= d);
      }
      for (var p = c < 0.5, g = p ? c : 1 - c, v = n(g), b = v(), _ = 0; b <= l; ++_)
        b += v();
      return s + (p ? _ : l - _);
    };
  }
  return i.source = t, i;
}(tn), Npt = function t(e) {
  function n(r, i, a) {
    var o;
    return (r = +r) == 0 ? o = (s) => -Math.log(s) : (r = 1 / r, o = (s) => Math.pow(s, r)), i = i == null ? 0 : +i, a = a == null ? 1 : +a, function() {
      return i + a * o(-Math.log1p(-e()));
    };
  }
  return n.source = t, n;
}(tn), Ipt = function t(e) {
  function n(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      return r + i * Math.tan(Math.PI * e());
    };
  }
  return n.source = t, n;
}(tn), Rpt = function t(e) {
  function n(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var a = e();
      return r + i * Math.log(a / (1 - a));
    };
  }
  return n.source = t, n;
}(tn), Lpt = function t(e) {
  var n = rb.source(e), r = iS.source(e);
  function i(a) {
    return function() {
      for (var o = 0, s = a; s > 16; ) {
        var l = Math.floor(0.875 * s), c = n(l)();
        if (c > s)
          return o + r(l - 1, s / c)();
        o += l, s -= c;
      }
      for (var h = -Math.log1p(-e()), d = 0; h <= s; ++d)
        h -= Math.log1p(-e());
      return o + d;
    };
  }
  return i.source = t, i;
}(tn), Dpt = 1664525, Fpt = 1013904223, Xw = 1 / 4294967296;
function zpt(t = Math.random()) {
  let e = (0 <= t && t < 1 ? t / Xw : Math.abs(t)) | 0;
  return () => (e = Dpt * e + Fpt | 0, Xw * (e >>> 0));
}
function Tr(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function Yi(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const sp = Symbol("implicit");
function Lu() {
  var t = new oc(), e = [], n = [], r = sp;
  function i(a) {
    let o = t.get(a);
    if (o === void 0) {
      if (r !== sp)
        return r;
      t.set(a, o = e.push(a) - 1);
    }
    return n[o % n.length];
  }
  return i.domain = function(a) {
    if (!arguments.length)
      return e.slice();
    e = [], t = new oc();
    for (const o of a)
      t.has(o) || t.set(o, e.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (n = Array.from(a), i) : n.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return Lu(e, n).unknown(r);
  }, Tr.apply(i, arguments), i;
}
function Gc() {
  var t = Lu().unknown(void 0), e = t.domain, n = t.range, r = 0, i = 1, a, o, s = !1, l = 0, c = 0, h = 0.5;
  delete t.unknown;
  function d() {
    var p = e().length, g = i < r, v = g ? i : r, b = g ? r : i;
    a = (b - v) / Math.max(1, p - l + c * 2), s && (a = Math.floor(a)), v += (b - v - a * (p - l)) * h, o = a * (1 - l), s && (v = Math.round(v), o = Math.round(o));
    var _ = ei(p).map(function(w) {
      return v + a * w;
    });
    return n(g ? _.reverse() : _);
  }
  return t.domain = function(p) {
    return arguments.length ? (e(p), d()) : e();
  }, t.range = function(p) {
    return arguments.length ? ([r, i] = p, r = +r, i = +i, d()) : [r, i];
  }, t.rangeRound = function(p) {
    return [r, i] = p, r = +r, i = +i, s = !0, d();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return a;
  }, t.round = function(p) {
    return arguments.length ? (s = !!p, d()) : s;
  }, t.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), d()) : l;
  }, t.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), d()) : l;
  }, t.paddingOuter = function(p) {
    return arguments.length ? (c = +p, d()) : c;
  }, t.align = function(p) {
    return arguments.length ? (h = Math.max(0, Math.min(1, p)), d()) : h;
  }, t.copy = function() {
    return Gc(e(), [r, i]).round(s).paddingInner(l).paddingOuter(c).align(h);
  }, Tr.apply(d(), arguments);
}
function aS(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return aS(e());
  }, t;
}
function oS() {
  return aS(Gc.apply(null, arguments).paddingInner(1));
}
function Bpt(t) {
  return function() {
    return t;
  };
}
function up(t) {
  return +t;
}
var Zw = [0, 1];
function xn(t) {
  return t;
}
function t_(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : Bpt(isNaN(e) ? NaN : 0.5);
}
function Hpt(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function jpt(t, e, n) {
  var r = t[0], i = t[1], a = e[0], o = e[1];
  return i < r ? (r = t_(i, r), a = n(o, a)) : (r = t_(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function Vpt(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = t_(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
  return function(s) {
    var l = Bo(t, s, 1, r) - 1;
    return a[l](i[l](s));
  };
}
function Kc(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function C1() {
  var t = Zw, e = Zw, n = za, r, i, a, o = xn, s, l, c;
  function h() {
    var p = Math.min(t.length, e.length);
    return o !== xn && (o = Hpt(t[0], t[p - 1])), s = p > 2 ? Vpt : jpt, l = c = null, d;
  }
  function d(p) {
    return p == null || isNaN(p = +p) ? a : (l || (l = s(t.map(r), e, n)))(r(o(p)));
  }
  return d.invert = function(p) {
    return o(i((c || (c = s(e, t.map(r), br)))(p)));
  }, d.domain = function(p) {
    return arguments.length ? (t = Array.from(p, up), h()) : t.slice();
  }, d.range = function(p) {
    return arguments.length ? (e = Array.from(p), h()) : e.slice();
  }, d.rangeRound = function(p) {
    return e = Array.from(p), n = Bc, h();
  }, d.clamp = function(p) {
    return arguments.length ? (o = p ? !0 : xn, h()) : o !== xn;
  }, d.interpolate = function(p) {
    return arguments.length ? (n = p, h()) : n;
  }, d.unknown = function(p) {
    return arguments.length ? (a = p, d) : a;
  }, function(p, g) {
    return r = p, i = g, h();
  };
}
function ib() {
  return C1()(xn, xn);
}
function ab(t, e, n, r) {
  var i = Td(t, e, n), a;
  switch (r = uu(r == null ? ",f" : r), r.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(a = aO(i, o)) && (r.precision = a), L2(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = oO(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = iO(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Uo(r);
}
function Ha(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return sc(r[0], r[r.length - 1], n == null ? 10 : n);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return ab(i[0], i[i.length - 1], n == null ? 10 : n, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, a = r.length - 1, o = r[i], s = r[a], l, c, h = 10;
    for (s < o && (c = o, o = s, s = c, c = i, i = a, a = c); h-- > 0; ) {
      if (c = Dc(o, s, n), c === l)
        return r[i] = o, r[a] = s, e(r);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return t;
  }, t;
}
function Bi() {
  var t = ib();
  return t.copy = function() {
    return Kc(t, Bi());
  }, Tr.apply(t, arguments), Ha(t);
}
function ob(t) {
  var e;
  function n(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (t = Array.from(r, up), n) : t.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (e = r, n) : e;
  }, n.copy = function() {
    return ob(t).unknown(e);
  }, t = arguments.length ? Array.from(t, up) : [0, 1], Ha(n);
}
function sS(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], a = t[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), t[n] = e.floor(i), t[r] = e.ceil(a), t;
}
function Jw(t) {
  return Math.log(t);
}
function Qw(t) {
  return Math.exp(t);
}
function Wpt(t) {
  return -Math.log(-t);
}
function Upt(t) {
  return -Math.exp(-t);
}
function Ypt(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function qpt(t) {
  return t === 10 ? Ypt : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function Gpt(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function t7(t) {
  return (e, n) => -t(-e, n);
}
function sb(t) {
  const e = t(Jw, Qw), n = e.domain;
  let r = 10, i, a;
  function o() {
    return i = Gpt(r), a = qpt(r), n()[0] < 0 ? (i = t7(i), a = t7(a), t(Wpt, Upt)) : t(Jw, Qw), e;
  }
  return e.base = function(s) {
    return arguments.length ? (r = +s, o()) : r;
  }, e.domain = function(s) {
    return arguments.length ? (n(s), o()) : n();
  }, e.ticks = (s) => {
    const l = n();
    let c = l[0], h = l[l.length - 1];
    const d = h < c;
    d && ([c, h] = [h, c]);
    let p = i(c), g = i(h), v, b;
    const _ = s == null ? 10 : +s;
    let w = [];
    if (!(r % 1) && g - p < _) {
      if (p = Math.floor(p), g = Math.ceil(g), c > 0) {
        for (; p <= g; ++p)
          for (v = 1; v < r; ++v)
            if (b = p < 0 ? v / a(-p) : v * a(p), !(b < c)) {
              if (b > h)
                break;
              w.push(b);
            }
      } else
        for (; p <= g; ++p)
          for (v = r - 1; v >= 1; --v)
            if (b = p > 0 ? v / a(-p) : v * a(p), !(b < c)) {
              if (b > h)
                break;
              w.push(b);
            }
      w.length * 2 < _ && (w = sc(c, h, _));
    } else
      w = sc(p, g, Math.min(g - p, _)).map(a);
    return d ? w.reverse() : w;
  }, e.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? ".0e" : ","), typeof l != "function" && (!(r % 1) && (l = uu(l)).precision == null && (l.trim = !0), l = Uo(l)), s === 1 / 0)
      return l;
    const c = Math.max(1, r * s / e.ticks().length);
    return (h) => {
      let d = h / a(Math.round(i(h)));
      return d * r < r - 0.5 && (d *= r), d <= c ? l(h) : "";
    };
  }, e.nice = () => n(sS(n(), {
    floor: (s) => a(Math.floor(i(s))),
    ceil: (s) => a(Math.ceil(i(s)))
  })), e;
}
function $1() {
  const t = sb(C1()).domain([1, 10]);
  return t.copy = () => Kc(t, $1()).base(t.base()), Tr.apply(t, arguments), t;
}
function e7(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function n7(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function ub(t) {
  var e = 1, n = t(e7(e), n7(e));
  return n.constant = function(r) {
    return arguments.length ? t(e7(e = +r), n7(e)) : e;
  }, Ha(n);
}
function lb() {
  var t = ub(C1());
  return t.copy = function() {
    return Kc(t, lb()).constant(t.constant());
  }, Tr.apply(t, arguments);
}
function r7(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function Kpt(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function Xpt(t) {
  return t < 0 ? -t * t : t * t;
}
function cb(t) {
  var e = t(xn, xn), n = 1;
  function r() {
    return n === 1 ? t(xn, xn) : n === 0.5 ? t(Kpt, Xpt) : t(r7(n), r7(1 / n));
  }
  return e.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, Ha(e);
}
function T1() {
  var t = cb(C1());
  return t.copy = function() {
    return Kc(t, T1()).exponent(t.exponent());
  }, Tr.apply(t, arguments), t;
}
function uS() {
  return T1.apply(null, arguments).exponent(0.5);
}
function i7(t) {
  return Math.sign(t) * t * t;
}
function Zpt(t) {
  return Math.sign(t) * Math.sqrt(Math.abs(t));
}
function fb() {
  var t = ib(), e = [0, 1], n = !1, r;
  function i(a) {
    var o = Zpt(t(a));
    return isNaN(o) ? r : n ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return t.invert(i7(a));
  }, i.domain = function(a) {
    return arguments.length ? (t.domain(a), i) : t.domain();
  }, i.range = function(a) {
    return arguments.length ? (t.range((e = Array.from(a, up)).map(i7)), i) : e.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (n = !!a, i) : n;
  }, i.clamp = function(a) {
    return arguments.length ? (t.clamp(a), i) : t.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return fb(t.domain(), e).round(n).clamp(t.clamp()).unknown(r);
  }, Tr.apply(i, arguments), Ha(i);
}
function hb() {
  var t = [], e = [], n = [], r;
  function i() {
    var o = 0, s = Math.max(1, e.length);
    for (n = new Array(s - 1); ++o < s; )
      n[o - 1] = B$(t, o / s);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? r : e[Bo(n, o)];
  }
  return a.invertExtent = function(o) {
    var s = e.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : t[0],
      s < n.length ? n[s] : t[t.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length)
      return t.slice();
    t = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && t.push(s);
    return t.sort(Qe), i();
  }, a.range = function(o) {
    return arguments.length ? (e = Array.from(o), i()) : e.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (r = o, a) : r;
  }, a.quantiles = function() {
    return n.slice();
  }, a.copy = function() {
    return hb().domain(t).range(e).unknown(r);
  }, Tr.apply(a, arguments);
}
function db() {
  var t = 0, e = 1, n = 1, r = [0.5], i = [0, 1], a;
  function o(l) {
    return l != null && l <= l ? i[Bo(r, l, 0, n)] : a;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; )
      r[l] = ((l + 1) * e - (l - n) * t) / (n + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([t, e] = l, t = +t, e = +e, s()) : [t, e];
  }, o.range = function(l) {
    return arguments.length ? (n = (i = Array.from(l)).length - 1, s()) : i.slice();
  }, o.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [t, r[0]] : c >= n ? [r[n - 1], e] : [r[c - 1], r[c]];
  }, o.unknown = function(l) {
    return arguments.length && (a = l), o;
  }, o.thresholds = function() {
    return r.slice();
  }, o.copy = function() {
    return db().domain([t, e]).range(i).unknown(a);
  }, Tr.apply(Ha(o), arguments);
}
function pb() {
  var t = [0.5], e = [0, 1], n, r = 1;
  function i(a) {
    return a != null && a <= a ? e[Bo(t, a, 0, r)] : n;
  }
  return i.domain = function(a) {
    return arguments.length ? (t = Array.from(a), r = Math.min(t.length, e.length - 1), i) : t.slice();
  }, i.range = function(a) {
    return arguments.length ? (e = Array.from(a), r = Math.min(t.length, e.length - 1), i) : e.slice();
  }, i.invertExtent = function(a) {
    var o = e.indexOf(a);
    return [t[o - 1], t[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return pb().domain(t).range(e).unknown(n);
  }, Tr.apply(i, arguments);
}
var Qg = /* @__PURE__ */ new Date(), t0 = /* @__PURE__ */ new Date();
function Le(t, e, n, r) {
  function i(a) {
    return t(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = function(a) {
    return t(a = /* @__PURE__ */ new Date(+a)), a;
  }, i.ceil = function(a) {
    return t(a = new Date(a - 1)), e(a, 1), t(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return e(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var l = [], c;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0))
      return l;
    do
      l.push(c = /* @__PURE__ */ new Date(+a)), e(a, s), t(a);
    while (c < a && a < o);
    return l;
  }, i.filter = function(a) {
    return Le(function(o) {
      if (o >= o)
        for (; t(o), !a(o); )
          o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0)
          for (; ++s <= 0; )
            for (; e(o, -1), !a(o); )
              ;
        else
          for (; --s >= 0; )
            for (; e(o, 1), !a(o); )
              ;
    });
  }, n && (i.count = function(a, o) {
    return Qg.setTime(+a), t0.setTime(+o), t(Qg), t(t0), Math.floor(n(Qg, t0));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var lp = Le(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
lp.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? Le(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : lp;
};
const e_ = lp;
var a7 = lp.range;
const Si = 1e3, xr = Si * 60, Ei = xr * 60, Io = Ei * 24, mb = Io * 7, o7 = Io * 30, e0 = Io * 365;
var lS = Le(function(t) {
  t.setTime(t - t.getMilliseconds());
}, function(t, e) {
  t.setTime(+t + e * Si);
}, function(t, e) {
  return (e - t) / Si;
}, function(t) {
  return t.getUTCSeconds();
});
const ma = lS;
var s7 = lS.range, cS = Le(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Si);
}, function(t, e) {
  t.setTime(+t + e * xr);
}, function(t, e) {
  return (e - t) / xr;
}, function(t) {
  return t.getMinutes();
});
const gb = cS;
var Jpt = cS.range, fS = Le(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Si - t.getMinutes() * xr);
}, function(t, e) {
  t.setTime(+t + e * Ei);
}, function(t, e) {
  return (e - t) / Ei;
}, function(t) {
  return t.getHours();
});
const vb = fS;
var Qpt = fS.range, hS = Le(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * xr) / Io,
  (t) => t.getDate() - 1
);
const Xc = hS;
var t1t = hS.range;
function Yo(t) {
  return Le(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * xr) / mb;
  });
}
var hu = Yo(0), wc = Yo(1), dS = Yo(2), pS = Yo(3), Ro = Yo(4), mS = Yo(5), gS = Yo(6), u7 = hu.range, e1t = wc.range, n1t = dS.range, r1t = pS.range, i1t = Ro.range, a1t = mS.range, o1t = gS.range, vS = Le(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
});
const _b = vS;
var s1t = vS.range, bb = Le(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
bb.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Le(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
const Pa = bb;
var u1t = bb.range, _S = Le(function(t) {
  t.setUTCSeconds(0, 0);
}, function(t, e) {
  t.setTime(+t + e * xr);
}, function(t, e) {
  return (e - t) / xr;
}, function(t) {
  return t.getUTCMinutes();
});
const yb = _S;
var l1t = _S.range, bS = Le(function(t) {
  t.setUTCMinutes(0, 0, 0);
}, function(t, e) {
  t.setTime(+t + e * Ei);
}, function(t, e) {
  return (e - t) / Ei;
}, function(t) {
  return t.getUTCHours();
});
const wb = bS;
var c1t = bS.range, yS = Le(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / Io;
}, function(t) {
  return t.getUTCDate() - 1;
});
const Zc = yS;
var f1t = yS.range;
function qo(t) {
  return Le(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / mb;
  });
}
var du = qo(0), xc = qo(1), wS = qo(2), xS = qo(3), Lo = qo(4), CS = qo(5), $S = qo(6), l7 = du.range, h1t = xc.range, d1t = wS.range, p1t = xS.range, m1t = Lo.range, g1t = CS.range, v1t = $S.range, TS = Le(function(t) {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCMonth(t.getUTCMonth() + e);
}, function(t, e) {
  return e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12;
}, function(t) {
  return t.getUTCMonth();
});
const xb = TS;
var _1t = TS.range, Cb = Le(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
Cb.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : Le(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
const Ma = Cb;
var b1t = Cb.range;
function OS(t, e, n, r, i, a) {
  const o = [
    [ma, 1, Si],
    [ma, 5, 5 * Si],
    [ma, 15, 15 * Si],
    [ma, 30, 30 * Si],
    [a, 1, xr],
    [a, 5, 5 * xr],
    [a, 15, 15 * xr],
    [a, 30, 30 * xr],
    [i, 1, Ei],
    [i, 3, 3 * Ei],
    [i, 6, 6 * Ei],
    [i, 12, 12 * Ei],
    [r, 1, Io],
    [r, 2, 2 * Io],
    [n, 1, mb],
    [e, 1, o7],
    [e, 3, 3 * o7],
    [t, 1, e0]
  ];
  function s(c, h, d) {
    const p = h < c;
    p && ([c, h] = [h, c]);
    const g = d && typeof d.range == "function" ? d : l(c, h, d), v = g ? g.range(c, +h + 1) : [];
    return p ? v.reverse() : v;
  }
  function l(c, h, d) {
    const p = Math.abs(h - c) / d, g = t1(([, , _]) => _).right(o, p);
    if (g === o.length)
      return t.every(Td(c / e0, h / e0, d));
    if (g === 0)
      return e_.every(Math.max(Td(c, h, d), 1));
    const [v, b] = o[p / o[g - 1][2] < o[g][2] / p ? g - 1 : g];
    return v.every(b);
  }
  return [s, l];
}
const [SS, ES] = OS(Ma, xb, du, Zc, wb, yb), [AS, PS] = OS(Pa, _b, hu, Xc, vb, gb);
function n0(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function r0(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function hl(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function MS(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, a = t.days, o = t.shortDays, s = t.months, l = t.shortMonths, c = dl(i), h = pl(i), d = dl(a), p = pl(a), g = dl(o), v = pl(o), b = dl(s), _ = pl(s), w = dl(l), x = pl(l), C = {
    a: q,
    A: Z,
    b: B,
    B: H,
    c: null,
    d: m7,
    e: m7,
    f: j1t,
    g: J1t,
    G: tmt,
    H: z1t,
    I: B1t,
    j: H1t,
    L: kS,
    m: V1t,
    M: W1t,
    p: J,
    q: X,
    Q: _7,
    s: b7,
    S: U1t,
    u: Y1t,
    U: q1t,
    V: G1t,
    w: K1t,
    W: X1t,
    x: null,
    X: null,
    y: Z1t,
    Y: Q1t,
    Z: emt,
    "%": v7
  }, $ = {
    a: et,
    A: rt,
    b: ut,
    B: ft,
    c: null,
    d: g7,
    e: g7,
    f: amt,
    g: mmt,
    G: vmt,
    H: nmt,
    I: rmt,
    j: imt,
    L: IS,
    m: omt,
    M: smt,
    p: ht,
    q: Nt,
    Q: _7,
    s: b7,
    S: umt,
    u: lmt,
    U: cmt,
    V: fmt,
    w: hmt,
    W: dmt,
    x: null,
    X: null,
    y: pmt,
    Y: gmt,
    Z: _mt,
    "%": v7
  }, E = {
    a: P,
    A: k,
    b: Y,
    B: V,
    c: I,
    d: d7,
    e: d7,
    f: R1t,
    g: h7,
    G: f7,
    H: p7,
    I: p7,
    j: M1t,
    L: I1t,
    m: P1t,
    M: k1t,
    p: W,
    q: A1t,
    Q: D1t,
    s: F1t,
    S: N1t,
    u: $1t,
    U: T1t,
    V: O1t,
    w: C1t,
    W: S1t,
    x: D,
    X: z,
    y: h7,
    Y: f7,
    Z: E1t,
    "%": L1t
  };
  C.x = A(n, C), C.X = A(r, C), C.c = A(e, C), $.x = A(n, $), $.X = A(r, $), $.c = A(e, $);
  function A(ot, wt) {
    return function(kt) {
      var at = [], Gt = -1, $t = 0, le = ot.length, qe, yt, re;
      for (kt instanceof Date || (kt = /* @__PURE__ */ new Date(+kt)); ++Gt < le; )
        ot.charCodeAt(Gt) === 37 && (at.push(ot.slice($t, Gt)), (yt = c7[qe = ot.charAt(++Gt)]) != null ? qe = ot.charAt(++Gt) : yt = qe === "e" ? " " : "0", (re = wt[qe]) && (qe = re(kt, yt)), at.push(qe), $t = Gt + 1);
      return at.push(ot.slice($t, Gt)), at.join("");
    };
  }
  function R(ot, wt) {
    return function(kt) {
      var at = hl(1900, void 0, 1), Gt = L(at, ot, kt += "", 0), $t, le;
      if (Gt != kt.length)
        return null;
      if ("Q" in at)
        return new Date(at.Q);
      if ("s" in at)
        return new Date(at.s * 1e3 + ("L" in at ? at.L : 0));
      if (wt && !("Z" in at) && (at.Z = 0), "p" in at && (at.H = at.H % 12 + at.p * 12), at.m === void 0 && (at.m = "q" in at ? at.q : 0), "V" in at) {
        if (at.V < 1 || at.V > 53)
          return null;
        "w" in at || (at.w = 1), "Z" in at ? ($t = r0(hl(at.y, 0, 1)), le = $t.getUTCDay(), $t = le > 4 || le === 0 ? xc.ceil($t) : xc($t), $t = Zc.offset($t, (at.V - 1) * 7), at.y = $t.getUTCFullYear(), at.m = $t.getUTCMonth(), at.d = $t.getUTCDate() + (at.w + 6) % 7) : ($t = n0(hl(at.y, 0, 1)), le = $t.getDay(), $t = le > 4 || le === 0 ? wc.ceil($t) : wc($t), $t = Xc.offset($t, (at.V - 1) * 7), at.y = $t.getFullYear(), at.m = $t.getMonth(), at.d = $t.getDate() + (at.w + 6) % 7);
      } else
        ("W" in at || "U" in at) && ("w" in at || (at.w = "u" in at ? at.u % 7 : "W" in at ? 1 : 0), le = "Z" in at ? r0(hl(at.y, 0, 1)).getUTCDay() : n0(hl(at.y, 0, 1)).getDay(), at.m = 0, at.d = "W" in at ? (at.w + 6) % 7 + at.W * 7 - (le + 5) % 7 : at.w + at.U * 7 - (le + 6) % 7);
      return "Z" in at ? (at.H += at.Z / 100 | 0, at.M += at.Z % 100, r0(at)) : n0(at);
    };
  }
  function L(ot, wt, kt, at) {
    for (var Gt = 0, $t = wt.length, le = kt.length, qe, yt; Gt < $t; ) {
      if (at >= le)
        return -1;
      if (qe = wt.charCodeAt(Gt++), qe === 37) {
        if (qe = wt.charAt(Gt++), yt = E[qe in c7 ? wt.charAt(Gt++) : qe], !yt || (at = yt(ot, kt, at)) < 0)
          return -1;
      } else if (qe != kt.charCodeAt(at++))
        return -1;
    }
    return at;
  }
  function W(ot, wt, kt) {
    var at = c.exec(wt.slice(kt));
    return at ? (ot.p = h.get(at[0].toLowerCase()), kt + at[0].length) : -1;
  }
  function P(ot, wt, kt) {
    var at = g.exec(wt.slice(kt));
    return at ? (ot.w = v.get(at[0].toLowerCase()), kt + at[0].length) : -1;
  }
  function k(ot, wt, kt) {
    var at = d.exec(wt.slice(kt));
    return at ? (ot.w = p.get(at[0].toLowerCase()), kt + at[0].length) : -1;
  }
  function Y(ot, wt, kt) {
    var at = w.exec(wt.slice(kt));
    return at ? (ot.m = x.get(at[0].toLowerCase()), kt + at[0].length) : -1;
  }
  function V(ot, wt, kt) {
    var at = b.exec(wt.slice(kt));
    return at ? (ot.m = _.get(at[0].toLowerCase()), kt + at[0].length) : -1;
  }
  function I(ot, wt, kt) {
    return L(ot, e, wt, kt);
  }
  function D(ot, wt, kt) {
    return L(ot, n, wt, kt);
  }
  function z(ot, wt, kt) {
    return L(ot, r, wt, kt);
  }
  function q(ot) {
    return o[ot.getDay()];
  }
  function Z(ot) {
    return a[ot.getDay()];
  }
  function B(ot) {
    return l[ot.getMonth()];
  }
  function H(ot) {
    return s[ot.getMonth()];
  }
  function J(ot) {
    return i[+(ot.getHours() >= 12)];
  }
  function X(ot) {
    return 1 + ~~(ot.getMonth() / 3);
  }
  function et(ot) {
    return o[ot.getUTCDay()];
  }
  function rt(ot) {
    return a[ot.getUTCDay()];
  }
  function ut(ot) {
    return l[ot.getUTCMonth()];
  }
  function ft(ot) {
    return s[ot.getUTCMonth()];
  }
  function ht(ot) {
    return i[+(ot.getUTCHours() >= 12)];
  }
  function Nt(ot) {
    return 1 + ~~(ot.getUTCMonth() / 3);
  }
  return {
    format: function(ot) {
      var wt = A(ot += "", C);
      return wt.toString = function() {
        return ot;
      }, wt;
    },
    parse: function(ot) {
      var wt = R(ot += "", !1);
      return wt.toString = function() {
        return ot;
      }, wt;
    },
    utcFormat: function(ot) {
      var wt = A(ot += "", $);
      return wt.toString = function() {
        return ot;
      }, wt;
    },
    utcParse: function(ot) {
      var wt = R(ot += "", !0);
      return wt.toString = function() {
        return ot;
      }, wt;
    }
  };
}
var c7 = { "-": "", _: " ", 0: "0" }, Ye = /^\s*\d+/, y1t = /^%/, w1t = /[\\^$*+?|[\]().{}]/g;
function Ut(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
}
function x1t(t) {
  return t.replace(w1t, "\\$&");
}
function dl(t) {
  return new RegExp("^(?:" + t.map(x1t).join("|") + ")", "i");
}
function pl(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function C1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function $1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function T1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function O1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function S1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function f7(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function h7(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function E1t(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function A1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function P1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function d7(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function M1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function p7(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function k1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function N1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function I1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function R1t(t, e, n) {
  var r = Ye.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function L1t(t, e, n) {
  var r = y1t.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function D1t(t, e, n) {
  var r = Ye.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function F1t(t, e, n) {
  var r = Ye.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function m7(t, e) {
  return Ut(t.getDate(), e, 2);
}
function z1t(t, e) {
  return Ut(t.getHours(), e, 2);
}
function B1t(t, e) {
  return Ut(t.getHours() % 12 || 12, e, 2);
}
function H1t(t, e) {
  return Ut(1 + Xc.count(Pa(t), t), e, 3);
}
function kS(t, e) {
  return Ut(t.getMilliseconds(), e, 3);
}
function j1t(t, e) {
  return kS(t, e) + "000";
}
function V1t(t, e) {
  return Ut(t.getMonth() + 1, e, 2);
}
function W1t(t, e) {
  return Ut(t.getMinutes(), e, 2);
}
function U1t(t, e) {
  return Ut(t.getSeconds(), e, 2);
}
function Y1t(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function q1t(t, e) {
  return Ut(hu.count(Pa(t) - 1, t), e, 2);
}
function NS(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? Ro(t) : Ro.ceil(t);
}
function G1t(t, e) {
  return t = NS(t), Ut(Ro.count(Pa(t), t) + (Pa(t).getDay() === 4), e, 2);
}
function K1t(t) {
  return t.getDay();
}
function X1t(t, e) {
  return Ut(wc.count(Pa(t) - 1, t), e, 2);
}
function Z1t(t, e) {
  return Ut(t.getFullYear() % 100, e, 2);
}
function J1t(t, e) {
  return t = NS(t), Ut(t.getFullYear() % 100, e, 2);
}
function Q1t(t, e) {
  return Ut(t.getFullYear() % 1e4, e, 4);
}
function tmt(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? Ro(t) : Ro.ceil(t), Ut(t.getFullYear() % 1e4, e, 4);
}
function emt(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + Ut(e / 60 | 0, "0", 2) + Ut(e % 60, "0", 2);
}
function g7(t, e) {
  return Ut(t.getUTCDate(), e, 2);
}
function nmt(t, e) {
  return Ut(t.getUTCHours(), e, 2);
}
function rmt(t, e) {
  return Ut(t.getUTCHours() % 12 || 12, e, 2);
}
function imt(t, e) {
  return Ut(1 + Zc.count(Ma(t), t), e, 3);
}
function IS(t, e) {
  return Ut(t.getUTCMilliseconds(), e, 3);
}
function amt(t, e) {
  return IS(t, e) + "000";
}
function omt(t, e) {
  return Ut(t.getUTCMonth() + 1, e, 2);
}
function smt(t, e) {
  return Ut(t.getUTCMinutes(), e, 2);
}
function umt(t, e) {
  return Ut(t.getUTCSeconds(), e, 2);
}
function lmt(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function cmt(t, e) {
  return Ut(du.count(Ma(t) - 1, t), e, 2);
}
function RS(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? Lo(t) : Lo.ceil(t);
}
function fmt(t, e) {
  return t = RS(t), Ut(Lo.count(Ma(t), t) + (Ma(t).getUTCDay() === 4), e, 2);
}
function hmt(t) {
  return t.getUTCDay();
}
function dmt(t, e) {
  return Ut(xc.count(Ma(t) - 1, t), e, 2);
}
function pmt(t, e) {
  return Ut(t.getUTCFullYear() % 100, e, 2);
}
function mmt(t, e) {
  return t = RS(t), Ut(t.getUTCFullYear() % 100, e, 2);
}
function gmt(t, e) {
  return Ut(t.getUTCFullYear() % 1e4, e, 4);
}
function vmt(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? Lo(t) : Lo.ceil(t), Ut(t.getUTCFullYear() % 1e4, e, 4);
}
function _mt() {
  return "+0000";
}
function v7() {
  return "%";
}
function _7(t) {
  return +t;
}
function b7(t) {
  return Math.floor(+t / 1e3);
}
var xs, $b, Tb, O1, Ob;
LS({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function LS(t) {
  return xs = MS(t), $b = xs.format, Tb = xs.parse, O1 = xs.utcFormat, Ob = xs.utcParse, xs;
}
var DS = "%Y-%m-%dT%H:%M:%S.%LZ";
function bmt(t) {
  return t.toISOString();
}
var ymt = Date.prototype.toISOString ? bmt : O1(DS);
const wmt = ymt;
function xmt(t) {
  var e = new Date(t);
  return isNaN(e) ? null : e;
}
var Cmt = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? xmt : Ob(DS);
const $mt = Cmt;
function Tmt(t) {
  return new Date(t);
}
function Omt(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function Sb(t, e, n, r, i, a, o, s, l, c) {
  var h = ib(), d = h.invert, p = h.domain, g = c(".%L"), v = c(":%S"), b = c("%I:%M"), _ = c("%I %p"), w = c("%a %d"), x = c("%b %d"), C = c("%B"), $ = c("%Y");
  function E(A) {
    return (l(A) < A ? g : s(A) < A ? v : o(A) < A ? b : a(A) < A ? _ : r(A) < A ? i(A) < A ? w : x : n(A) < A ? C : $)(A);
  }
  return h.invert = function(A) {
    return new Date(d(A));
  }, h.domain = function(A) {
    return arguments.length ? p(Array.from(A, Omt)) : p().map(Tmt);
  }, h.ticks = function(A) {
    var R = p();
    return t(R[0], R[R.length - 1], A == null ? 10 : A);
  }, h.tickFormat = function(A, R) {
    return R == null ? E : c(R);
  }, h.nice = function(A) {
    var R = p();
    return (!A || typeof A.range != "function") && (A = e(R[0], R[R.length - 1], A == null ? 10 : A)), A ? p(sS(R, A)) : h;
  }, h.copy = function() {
    return Kc(h, Sb(t, e, n, r, i, a, o, s, l, c));
  }, h;
}
function Eb() {
  return Tr.apply(Sb(AS, PS, Pa, _b, hu, Xc, vb, gb, ma, $b).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function FS() {
  return Tr.apply(Sb(SS, ES, Ma, xb, du, Zc, wb, yb, ma, O1).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function S1() {
  var t = 0, e = 1, n, r, i, a, o = xn, s = !1, l;
  function c(d) {
    return d == null || isNaN(d = +d) ? l : o(i === 0 ? 0.5 : (d = (a(d) - n) * i, s ? Math.max(0, Math.min(1, d)) : d));
  }
  c.domain = function(d) {
    return arguments.length ? ([t, e] = d, n = a(t = +t), r = a(e = +e), i = n === r ? 0 : 1 / (r - n), c) : [t, e];
  }, c.clamp = function(d) {
    return arguments.length ? (s = !!d, c) : s;
  }, c.interpolator = function(d) {
    return arguments.length ? (o = d, c) : o;
  };
  function h(d) {
    return function(p) {
      var g, v;
      return arguments.length ? ([g, v] = p, o = d(g, v), c) : [o(0), o(1)];
    };
  }
  return c.range = h(za), c.rangeRound = h(Bc), c.unknown = function(d) {
    return arguments.length ? (l = d, c) : l;
  }, function(d) {
    return a = d, n = d(t), r = d(e), i = n === r ? 0 : 1 / (r - n), c;
  };
}
function ja(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function Ab() {
  var t = Ha(S1()(xn));
  return t.copy = function() {
    return ja(t, Ab());
  }, Yi.apply(t, arguments);
}
function Pb() {
  var t = sb(S1()).domain([1, 10]);
  return t.copy = function() {
    return ja(t, Pb()).base(t.base());
  }, Yi.apply(t, arguments);
}
function Mb() {
  var t = ub(S1());
  return t.copy = function() {
    return ja(t, Mb()).constant(t.constant());
  }, Yi.apply(t, arguments);
}
function E1() {
  var t = cb(S1());
  return t.copy = function() {
    return ja(t, E1()).exponent(t.exponent());
  }, Yi.apply(t, arguments);
}
function zS() {
  return E1.apply(null, arguments).exponent(0.5);
}
function kb() {
  var t = [], e = xn;
  function n(r) {
    if (r != null && !isNaN(r = +r))
      return e((Bo(t, r, 1) - 1) / (t.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length)
      return t.slice();
    t = [];
    for (let i of r)
      i != null && !isNaN(i = +i) && t.push(i);
    return t.sort(Qe), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (e = r, n) : e;
  }, n.range = function() {
    return t.map((r, i) => e(i / (t.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, a) => uc(t, a / r));
  }, n.copy = function() {
    return kb(e).domain(t);
  }, Yi.apply(n, arguments);
}
function A1() {
  var t = 0, e = 0.5, n = 1, r = 1, i, a, o, s, l, c = xn, h, d = !1, p;
  function g(b) {
    return isNaN(b = +b) ? p : (b = 0.5 + ((b = +h(b)) - a) * (r * b < r * a ? s : l), c(d ? Math.max(0, Math.min(1, b)) : b));
  }
  g.domain = function(b) {
    return arguments.length ? ([t, e, n] = b, i = h(t = +t), a = h(e = +e), o = h(n = +n), s = i === a ? 0 : 0.5 / (a - i), l = a === o ? 0 : 0.5 / (o - a), r = a < i ? -1 : 1, g) : [t, e, n];
  }, g.clamp = function(b) {
    return arguments.length ? (d = !!b, g) : d;
  }, g.interpolator = function(b) {
    return arguments.length ? (c = b, g) : c;
  };
  function v(b) {
    return function(_) {
      var w, x, C;
      return arguments.length ? ([w, x, C] = _, c = IT(b, [w, x, C]), g) : [c(0), c(0.5), c(1)];
    };
  }
  return g.range = v(za), g.rangeRound = v(Bc), g.unknown = function(b) {
    return arguments.length ? (p = b, g) : p;
  }, function(b) {
    return h = b, i = b(t), a = b(e), o = b(n), s = i === a ? 0 : 0.5 / (a - i), l = a === o ? 0 : 0.5 / (o - a), r = a < i ? -1 : 1, g;
  };
}
function Nb() {
  var t = Ha(A1()(xn));
  return t.copy = function() {
    return ja(t, Nb());
  }, Yi.apply(t, arguments);
}
function Ib() {
  var t = sb(A1()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return ja(t, Ib()).base(t.base());
  }, Yi.apply(t, arguments);
}
function Rb() {
  var t = ub(A1());
  return t.copy = function() {
    return ja(t, Rb()).constant(t.constant());
  }, Yi.apply(t, arguments);
}
function P1() {
  var t = cb(A1());
  return t.copy = function() {
    return ja(t, P1()).exponent(t.exponent());
  }, Yi.apply(t, arguments);
}
function BS() {
  return P1.apply(null, arguments).exponent(0.5);
}
const y7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Gc,
  scaleDiverging: Nb,
  scaleDivergingLog: Ib,
  scaleDivergingPow: P1,
  scaleDivergingSqrt: BS,
  scaleDivergingSymlog: Rb,
  scaleIdentity: ob,
  scaleImplicit: sp,
  scaleLinear: Bi,
  scaleLog: $1,
  scaleOrdinal: Lu,
  scalePoint: oS,
  scalePow: T1,
  scaleQuantile: hb,
  scaleQuantize: db,
  scaleRadial: fb,
  scaleSequential: Ab,
  scaleSequentialLog: Pb,
  scaleSequentialPow: E1,
  scaleSequentialQuantile: kb,
  scaleSequentialSqrt: zS,
  scaleSequentialSymlog: Mb,
  scaleSqrt: uS,
  scaleSymlog: lb,
  scaleThreshold: pb,
  scaleTime: Eb,
  scaleUtc: FS,
  tickFormat: ab
}, Symbol.toStringTag, { value: "Module" }));
function Rt(t) {
  for (var e = t.length / 6 | 0, n = new Array(e), r = 0; r < e; )
    n[r] = "#" + t.slice(r * 6, ++r * 6);
  return n;
}
const Smt = Rt("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), Emt = Rt("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), Amt = Rt("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), Pmt = Rt("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), Mmt = Rt("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), kmt = Rt("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), Nmt = Rt("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), Imt = Rt("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), Rmt = Rt("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), Lmt = Rt("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), ee = (t) => wT(t[t.length - 1]);
var HS = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(Rt);
const Dmt = ee(HS);
var jS = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(Rt);
const Fmt = ee(jS);
var VS = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(Rt);
const zmt = ee(VS);
var WS = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(Rt);
const Bmt = ee(WS);
var US = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(Rt);
const Hmt = ee(US);
var YS = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(Rt);
const jmt = ee(YS);
var qS = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(Rt);
const Vmt = ee(qS);
var GS = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(Rt);
const Wmt = ee(GS);
var KS = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(Rt);
const Umt = ee(KS);
var XS = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(Rt);
const Ymt = ee(XS);
var ZS = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(Rt);
const qmt = ee(ZS);
var JS = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(Rt);
const Gmt = ee(JS);
var QS = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(Rt);
const Kmt = ee(QS);
var tE = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(Rt);
const Xmt = ee(tE);
var eE = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(Rt);
const Zmt = ee(eE);
var nE = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(Rt);
const Jmt = ee(nE);
var rE = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(Rt);
const Qmt = ee(rE);
var iE = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(Rt);
const tgt = ee(iE);
var aE = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(Rt);
const egt = ee(aE);
var oE = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(Rt);
const ngt = ee(oE);
var sE = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(Rt);
const rgt = ee(sE);
var uE = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(Rt);
const igt = ee(uE);
var lE = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(Rt);
const agt = ee(lE);
var cE = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(Rt);
const ogt = ee(cE);
var fE = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(Rt);
const sgt = ee(fE);
var hE = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(Rt);
const ugt = ee(hE);
var dE = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(Rt);
const lgt = ee(dE);
function cgt(t) {
  return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}
const fgt = h1(Hr(300, 0.5, 0), Hr(-240, 0.5, 1));
var hgt = h1(Hr(-100, 0.75, 0.35), Hr(80, 1.5, 0.8)), dgt = h1(Hr(260, 0.75, 0.35), Hr(80, 1.5, 0.8)), xh = Hr();
function pgt(t) {
  (t < 0 || t > 1) && (t -= Math.floor(t));
  var e = Math.abs(t - 0.5);
  return xh.h = 360 * t - 100, xh.s = 1.5 - 1.5 * e, xh.l = 0.8 - 0.9 * e, xh + "";
}
var Ch = iu(), mgt = Math.PI / 3, ggt = Math.PI * 2 / 3;
function vgt(t) {
  var e;
  return t = (0.5 - t) * Math.PI, Ch.r = 255 * (e = Math.sin(t)) * e, Ch.g = 255 * (e = Math.sin(t + mgt)) * e, Ch.b = 255 * (e = Math.sin(t + ggt)) * e, Ch + "";
}
function _gt(t) {
  return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}
function M1(t) {
  var e = t.length;
  return function(n) {
    return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
  };
}
const bgt = M1(Rt("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var ygt = M1(Rt("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), wgt = M1(Rt("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), xgt = M1(Rt("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function Mt(t) {
  return function() {
    return t;
  };
}
var w7 = Math.abs, sn = Math.atan2, no = Math.cos, Cgt = Math.max, i0 = Math.min, Gr = Math.sin, Rs = Math.sqrt, un = 1e-12, ka = Math.PI, cp = ka / 2, _a = 2 * ka;
function $gt(t) {
  return t > 1 ? 0 : t < -1 ? ka : Math.acos(t);
}
function x7(t) {
  return t >= 1 ? cp : t <= -1 ? -cp : Math.asin(t);
}
function Tgt(t) {
  return t.innerRadius;
}
function Ogt(t) {
  return t.outerRadius;
}
function Sgt(t) {
  return t.startAngle;
}
function Egt(t) {
  return t.endAngle;
}
function Agt(t) {
  return t && t.padAngle;
}
function Pgt(t, e, n, r, i, a, o, s) {
  var l = n - t, c = r - e, h = o - i, d = s - a, p = d * l - h * c;
  if (!(p * p < un))
    return p = (h * (e - a) - d * (t - i)) / p, [t + p * l, e + p * c];
}
function $h(t, e, n, r, i, a, o) {
  var s = t - n, l = e - r, c = (o ? a : -a) / Rs(s * s + l * l), h = c * l, d = -c * s, p = t + h, g = e + d, v = n + h, b = r + d, _ = (p + v) / 2, w = (g + b) / 2, x = v - p, C = b - g, $ = x * x + C * C, E = i - a, A = p * b - v * g, R = (C < 0 ? -1 : 1) * Rs(Cgt(0, E * E * $ - A * A)), L = (A * C - x * R) / $, W = (-A * x - C * R) / $, P = (A * C + x * R) / $, k = (-A * x + C * R) / $, Y = L - _, V = W - w, I = P - _, D = k - w;
  return Y * Y + V * V > I * I + D * D && (L = P, W = k), {
    cx: L,
    cy: W,
    x01: -h,
    y01: -d,
    x11: L * (i / E - 1),
    y11: W * (i / E - 1)
  };
}
function Mgt() {
  var t = Tgt, e = Ogt, n = Mt(0), r = null, i = Sgt, a = Egt, o = Agt, s = null;
  function l() {
    var c, h, d = +t.apply(this, arguments), p = +e.apply(this, arguments), g = i.apply(this, arguments) - cp, v = a.apply(this, arguments) - cp, b = w7(v - g), _ = v > g;
    if (s || (s = c = Ba()), p < d && (h = p, p = d, d = h), !(p > un))
      s.moveTo(0, 0);
    else if (b > _a - un)
      s.moveTo(p * no(g), p * Gr(g)), s.arc(0, 0, p, g, v, !_), d > un && (s.moveTo(d * no(v), d * Gr(v)), s.arc(0, 0, d, v, g, _));
    else {
      var w = g, x = v, C = g, $ = v, E = b, A = b, R = o.apply(this, arguments) / 2, L = R > un && (r ? +r.apply(this, arguments) : Rs(d * d + p * p)), W = i0(w7(p - d) / 2, +n.apply(this, arguments)), P = W, k = W, Y, V;
      if (L > un) {
        var I = x7(L / d * Gr(R)), D = x7(L / p * Gr(R));
        (E -= I * 2) > un ? (I *= _ ? 1 : -1, C += I, $ -= I) : (E = 0, C = $ = (g + v) / 2), (A -= D * 2) > un ? (D *= _ ? 1 : -1, w += D, x -= D) : (A = 0, w = x = (g + v) / 2);
      }
      var z = p * no(w), q = p * Gr(w), Z = d * no($), B = d * Gr($);
      if (W > un) {
        var H = p * no(x), J = p * Gr(x), X = d * no(C), et = d * Gr(C), rt;
        if (b < ka && (rt = Pgt(z, q, X, et, H, J, Z, B))) {
          var ut = z - rt[0], ft = q - rt[1], ht = H - rt[0], Nt = J - rt[1], ot = 1 / Gr($gt((ut * ht + ft * Nt) / (Rs(ut * ut + ft * ft) * Rs(ht * ht + Nt * Nt))) / 2), wt = Rs(rt[0] * rt[0] + rt[1] * rt[1]);
          P = i0(W, (d - wt) / (ot - 1)), k = i0(W, (p - wt) / (ot + 1));
        }
      }
      A > un ? k > un ? (Y = $h(X, et, z, q, p, k, _), V = $h(H, J, Z, B, p, k, _), s.moveTo(Y.cx + Y.x01, Y.cy + Y.y01), k < W ? s.arc(Y.cx, Y.cy, k, sn(Y.y01, Y.x01), sn(V.y01, V.x01), !_) : (s.arc(Y.cx, Y.cy, k, sn(Y.y01, Y.x01), sn(Y.y11, Y.x11), !_), s.arc(0, 0, p, sn(Y.cy + Y.y11, Y.cx + Y.x11), sn(V.cy + V.y11, V.cx + V.x11), !_), s.arc(V.cx, V.cy, k, sn(V.y11, V.x11), sn(V.y01, V.x01), !_))) : (s.moveTo(z, q), s.arc(0, 0, p, w, x, !_)) : s.moveTo(z, q), !(d > un) || !(E > un) ? s.lineTo(Z, B) : P > un ? (Y = $h(Z, B, H, J, d, -P, _), V = $h(z, q, X, et, d, -P, _), s.lineTo(Y.cx + Y.x01, Y.cy + Y.y01), P < W ? s.arc(Y.cx, Y.cy, P, sn(Y.y01, Y.x01), sn(V.y01, V.x01), !_) : (s.arc(Y.cx, Y.cy, P, sn(Y.y01, Y.x01), sn(Y.y11, Y.x11), !_), s.arc(0, 0, d, sn(Y.cy + Y.y11, Y.cx + Y.x11), sn(V.cy + V.y11, V.cx + V.x11), _), s.arc(V.cx, V.cy, P, sn(V.y11, V.x11), sn(V.y01, V.x01), !_))) : s.arc(0, 0, d, $, C, _);
    }
    if (s.closePath(), c)
      return s = null, c + "" || null;
  }
  return l.centroid = function() {
    var c = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2, h = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - ka / 2;
    return [no(h) * c, Gr(h) * c];
  }, l.innerRadius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Mt(+c), l) : t;
  }, l.outerRadius = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Mt(+c), l) : e;
  }, l.cornerRadius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Mt(+c), l) : n;
  }, l.padRadius = function(c) {
    return arguments.length ? (r = c == null ? null : typeof c == "function" ? c : Mt(+c), l) : r;
  }, l.startAngle = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Mt(+c), l) : i;
  }, l.endAngle = function(c) {
    return arguments.length ? (a = typeof c == "function" ? c : Mt(+c), l) : a;
  }, l.padAngle = function(c) {
    return arguments.length ? (o = typeof c == "function" ? c : Mt(+c), l) : o;
  }, l.context = function(c) {
    return arguments.length ? (s = c == null ? null : c, l) : s;
  }, l;
}
var kgt = Array.prototype.slice;
function k1(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function pE(t) {
  this._context = t;
}
pE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function N1(t) {
  return new pE(t);
}
function Lb(t) {
  return t[0];
}
function Db(t) {
  return t[1];
}
function I1(t, e) {
  var n = Mt(!0), r = null, i = N1, a = null;
  t = typeof t == "function" ? t : t === void 0 ? Lb : Mt(t), e = typeof e == "function" ? e : e === void 0 ? Db : Mt(e);
  function o(s) {
    var l, c = (s = k1(s)).length, h, d = !1, p;
    for (r == null && (a = i(p = Ba())), l = 0; l <= c; ++l)
      !(l < c && n(h = s[l], l, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+t(h, l, s), +e(h, l, s));
    if (p)
      return a = null, p + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Mt(+s), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Mt(+s), o) : e;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Mt(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
function mE(t, e, n) {
  var r = null, i = Mt(!0), a = null, o = N1, s = null;
  t = typeof t == "function" ? t : t === void 0 ? Lb : Mt(+t), e = typeof e == "function" ? e : Mt(e === void 0 ? 0 : +e), n = typeof n == "function" ? n : n === void 0 ? Db : Mt(+n);
  function l(h) {
    var d, p, g, v = (h = k1(h)).length, b, _ = !1, w, x = new Array(v), C = new Array(v);
    for (a == null && (s = o(w = Ba())), d = 0; d <= v; ++d) {
      if (!(d < v && i(b = h[d], d, h)) === _)
        if (_ = !_)
          p = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = d - 1; g >= p; --g)
            s.point(x[g], C[g]);
          s.lineEnd(), s.areaEnd();
        }
      _ && (x[d] = +t(b, d, h), C[d] = +e(b, d, h), s.point(r ? +r(b, d, h) : x[d], n ? +n(b, d, h) : C[d]));
    }
    if (w)
      return s = null, w + "" || null;
  }
  function c() {
    return I1().defined(i).curve(o).context(a);
  }
  return l.x = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : Mt(+h), r = null, l) : t;
  }, l.x0 = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : Mt(+h), l) : t;
  }, l.x1 = function(h) {
    return arguments.length ? (r = h == null ? null : typeof h == "function" ? h : Mt(+h), l) : r;
  }, l.y = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : Mt(+h), n = null, l) : e;
  }, l.y0 = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : Mt(+h), l) : e;
  }, l.y1 = function(h) {
    return arguments.length ? (n = h == null ? null : typeof h == "function" ? h : Mt(+h), l) : n;
  }, l.lineX0 = l.lineY0 = function() {
    return c().x(t).y(e);
  }, l.lineY1 = function() {
    return c().x(t).y(n);
  }, l.lineX1 = function() {
    return c().x(r).y(e);
  }, l.defined = function(h) {
    return arguments.length ? (i = typeof h == "function" ? h : Mt(!!h), l) : i;
  }, l.curve = function(h) {
    return arguments.length ? (o = h, a != null && (s = o(a)), l) : o;
  }, l.context = function(h) {
    return arguments.length ? (h == null ? a = s = null : s = o(a = h), l) : a;
  }, l;
}
function Ngt(t, e) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Igt(t) {
  return t;
}
function Rgt() {
  var t = Igt, e = Ngt, n = null, r = Mt(0), i = Mt(_a), a = Mt(0);
  function o(s) {
    var l, c = (s = k1(s)).length, h, d, p = 0, g = new Array(c), v = new Array(c), b = +r.apply(this, arguments), _ = Math.min(_a, Math.max(-_a, i.apply(this, arguments) - b)), w, x = Math.min(Math.abs(_) / c, a.apply(this, arguments)), C = x * (_ < 0 ? -1 : 1), $;
    for (l = 0; l < c; ++l)
      ($ = v[g[l] = l] = +t(s[l], l, s)) > 0 && (p += $);
    for (e != null ? g.sort(function(E, A) {
      return e(v[E], v[A]);
    }) : n != null && g.sort(function(E, A) {
      return n(s[E], s[A]);
    }), l = 0, d = p ? (_ - c * C) / p : 0; l < c; ++l, b = w)
      h = g[l], $ = v[h], w = b + ($ > 0 ? $ * d : 0) + C, v[h] = {
        data: s[h],
        index: l,
        value: $,
        startAngle: b,
        endAngle: w,
        padAngle: x
      };
    return v;
  }
  return o.value = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Mt(+s), o) : t;
  }, o.sortValues = function(s) {
    return arguments.length ? (e = s, n = null, o) : e;
  }, o.sort = function(s) {
    return arguments.length ? (n = s, e = null, o) : n;
  }, o.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Mt(+s), o) : r;
  }, o.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Mt(+s), o) : i;
  }, o.padAngle = function(s) {
    return arguments.length ? (a = typeof s == "function" ? s : Mt(+s), o) : a;
  }, o;
}
var gE = Fb(N1);
function vE(t) {
  this._curve = t;
}
vE.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(t, e) {
    this._curve.point(e * Math.sin(t), e * -Math.cos(t));
  }
};
function Fb(t) {
  function e(n) {
    return new vE(t(n));
  }
  return e._curve = t, e;
}
function Pl(t) {
  var e = t.curve;
  return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t.curve = function(n) {
    return arguments.length ? e(Fb(n)) : e()._curve;
  }, t;
}
function C7() {
  return Pl(I1().curve(gE));
}
function $7() {
  var t = mE().curve(gE), e = t.curve, n = t.lineX0, r = t.lineX1, i = t.lineY0, a = t.lineY1;
  return t.angle = t.x, delete t.x, t.startAngle = t.x0, delete t.x0, t.endAngle = t.x1, delete t.x1, t.radius = t.y, delete t.y, t.innerRadius = t.y0, delete t.y0, t.outerRadius = t.y1, delete t.y1, t.lineStartAngle = function() {
    return Pl(n());
  }, delete t.lineX0, t.lineEndAngle = function() {
    return Pl(r());
  }, delete t.lineX1, t.lineInnerRadius = function() {
    return Pl(i());
  }, delete t.lineY0, t.lineOuterRadius = function() {
    return Pl(a());
  }, delete t.lineY1, t.curve = function(o) {
    return arguments.length ? e(Fb(o)) : e()._curve;
  }, t;
}
function Ml(t, e) {
  return [(e = +e) * Math.cos(t -= Math.PI / 2), e * Math.sin(t)];
}
function Lgt(t) {
  return t.source;
}
function Dgt(t) {
  return t.target;
}
function zb(t) {
  var e = Lgt, n = Dgt, r = Lb, i = Db, a = null;
  function o() {
    var s, l = kgt.call(arguments), c = e.apply(this, l), h = n.apply(this, l);
    if (a || (a = s = Ba()), t(a, +r.apply(this, (l[0] = c, l)), +i.apply(this, l), +r.apply(this, (l[0] = h, l)), +i.apply(this, l)), s)
      return a = null, s + "" || null;
  }
  return o.source = function(s) {
    return arguments.length ? (e = s, o) : e;
  }, o.target = function(s) {
    return arguments.length ? (n = s, o) : n;
  }, o.x = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Mt(+s), o) : r;
  }, o.y = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Mt(+s), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (a = s == null ? null : s, o) : a;
  }, o;
}
function Fgt(t, e, n, r, i) {
  t.moveTo(e, n), t.bezierCurveTo(e = (e + r) / 2, n, e, i, r, i);
}
function zgt(t, e, n, r, i) {
  t.moveTo(e, n), t.bezierCurveTo(e, n = (n + i) / 2, r, n, r, i);
}
function Bgt(t, e, n, r, i) {
  var a = Ml(e, n), o = Ml(e, n = (n + i) / 2), s = Ml(r, n), l = Ml(r, i);
  t.moveTo(a[0], a[1]), t.bezierCurveTo(o[0], o[1], s[0], s[1], l[0], l[1]);
}
function Hgt() {
  return zb(Fgt);
}
function jgt() {
  return zb(zgt);
}
function Vgt() {
  var t = zb(Bgt);
  return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t;
}
const Bb = {
  draw: function(t, e) {
    var n = Math.sqrt(e / ka);
    t.moveTo(n, 0), t.arc(0, 0, n, 0, _a);
  }
}, _E = {
  draw: function(t, e) {
    var n = Math.sqrt(e / 5) / 2;
    t.moveTo(-3 * n, -n), t.lineTo(-n, -n), t.lineTo(-n, -3 * n), t.lineTo(n, -3 * n), t.lineTo(n, -n), t.lineTo(3 * n, -n), t.lineTo(3 * n, n), t.lineTo(n, n), t.lineTo(n, 3 * n), t.lineTo(-n, 3 * n), t.lineTo(-n, n), t.lineTo(-3 * n, n), t.closePath();
  }
};
var bE = Math.sqrt(1 / 3), Wgt = bE * 2;
const yE = {
  draw: function(t, e) {
    var n = Math.sqrt(e / Wgt), r = n * bE;
    t.moveTo(0, -n), t.lineTo(r, 0), t.lineTo(0, n), t.lineTo(-r, 0), t.closePath();
  }
};
var Ugt = 0.8908130915292852, wE = Math.sin(ka / 10) / Math.sin(7 * ka / 10), Ygt = Math.sin(_a / 10) * wE, qgt = -Math.cos(_a / 10) * wE;
const xE = {
  draw: function(t, e) {
    var n = Math.sqrt(e * Ugt), r = Ygt * n, i = qgt * n;
    t.moveTo(0, -n), t.lineTo(r, i);
    for (var a = 1; a < 5; ++a) {
      var o = _a * a / 5, s = Math.cos(o), l = Math.sin(o);
      t.lineTo(l * n, -s * n), t.lineTo(s * r - l * i, l * r + s * i);
    }
    t.closePath();
  }
}, CE = {
  draw: function(t, e) {
    var n = Math.sqrt(e), r = -n / 2;
    t.rect(r, r, n, n);
  }
};
var a0 = Math.sqrt(3);
const $E = {
  draw: function(t, e) {
    var n = -Math.sqrt(e / (a0 * 3));
    t.moveTo(0, n * 2), t.lineTo(-a0 * n, -n), t.lineTo(a0 * n, -n), t.closePath();
  }
};
var mr = -0.5, gr = Math.sqrt(3) / 2, n_ = 1 / Math.sqrt(12), Ggt = (n_ / 2 + 1) * 3;
const TE = {
  draw: function(t, e) {
    var n = Math.sqrt(e / Ggt), r = n / 2, i = n * n_, a = r, o = n * n_ + n, s = -a, l = o;
    t.moveTo(r, i), t.lineTo(a, o), t.lineTo(s, l), t.lineTo(mr * r - gr * i, gr * r + mr * i), t.lineTo(mr * a - gr * o, gr * a + mr * o), t.lineTo(mr * s - gr * l, gr * s + mr * l), t.lineTo(mr * r + gr * i, mr * i - gr * r), t.lineTo(mr * a + gr * o, mr * o - gr * a), t.lineTo(mr * s + gr * l, mr * l - gr * s), t.closePath();
  }
};
var Kgt = [
  Bb,
  _E,
  yE,
  CE,
  xE,
  $E,
  TE
];
function Xgt(t, e) {
  var n = null;
  t = typeof t == "function" ? t : Mt(t || Bb), e = typeof e == "function" ? e : Mt(e === void 0 ? 64 : +e);
  function r() {
    var i;
    if (n || (n = i = Ba()), t.apply(this, arguments).draw(n, +e.apply(this, arguments)), i)
      return n = null, i + "" || null;
  }
  return r.type = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Mt(i), r) : t;
  }, r.size = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Mt(+i), r) : e;
  }, r.context = function(i) {
    return arguments.length ? (n = i == null ? null : i, r) : n;
  }, r;
}
function Na() {
}
function fp(t, e, n) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + n) / 6
  );
}
function R1(t) {
  this._context = t;
}
R1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        fp(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        fp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Zgt(t) {
  return new R1(t);
}
function OE(t) {
  this._context = t;
}
OE.prototype = {
  areaStart: Na,
  areaEnd: Na,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        fp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Jgt(t) {
  return new OE(t);
}
function SE(t) {
  this._context = t;
}
SE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + t) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        fp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Qgt(t) {
  return new SE(t);
}
class EE {
  constructor(e, n) {
    this._context = e, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, n, e, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, e, this._y0, e, n);
        break;
      }
    }
    this._x0 = e, this._y0 = n;
  }
}
function t0t(t) {
  return new EE(t, !0);
}
function e0t(t) {
  return new EE(t, !1);
}
function AE(t, e) {
  this._basis = new R1(t), this._beta = e;
}
AE.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length - 1;
    if (n > 0)
      for (var r = t[0], i = e[0], a = t[n] - r, o = e[n] - i, s = -1, l; ++s <= n; )
        l = s / n, this._basis.point(
          this._beta * t[s] + (1 - this._beta) * (r + l * a),
          this._beta * e[s] + (1 - this._beta) * (i + l * o)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
const n0t = function t(e) {
  function n(r) {
    return e === 1 ? new R1(r) : new AE(r, e);
  }
  return n.beta = function(r) {
    return t(+r);
  }, n;
}(0.85);
function hp(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function Hb(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Hb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        hp(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        hp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const r0t = function t(e) {
  function n(r) {
    return new Hb(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function jb(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
jb.prototype = {
  areaStart: Na,
  areaEnd: Na,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        hp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const i0t = function t(e) {
  function n(r) {
    return new jb(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Vb(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Vb.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        hp(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const a0t = function t(e) {
  function n(r) {
    return new Vb(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Wb(t, e, n) {
  var r = t._x1, i = t._y1, a = t._x2, o = t._y2;
  if (t._l01_a > un) {
    var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, l = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
  }
  if (t._l23_a > un) {
    var c = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, h = 3 * t._l23_a * (t._l23_a + t._l12_a);
    a = (a * c + t._x1 * t._l23_2a - e * t._l12_2a) / h, o = (o * c + t._y1 * t._l23_2a - n * t._l12_2a) / h;
  }
  t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
}
function PE(t, e) {
  this._context = t, this._alpha = e;
}
PE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        Wb(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const o0t = function t(e) {
  function n(r) {
    return e ? new PE(r, e) : new Hb(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function ME(t, e) {
  this._context = t, this._alpha = e;
}
ME.prototype = {
  areaStart: Na,
  areaEnd: Na,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        Wb(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const s0t = function t(e) {
  function n(r) {
    return e ? new ME(r, e) : new jb(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function kE(t, e) {
  this._context = t, this._alpha = e;
}
kE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Wb(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const u0t = function t(e) {
  function n(r) {
    return e ? new kE(r, e) : new Vb(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function NE(t) {
  this._context = t;
}
NE.prototype = {
  areaStart: Na,
  areaEnd: Na,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function l0t(t) {
  return new NE(t);
}
function T7(t) {
  return t < 0 ? -1 : 1;
}
function O7(t, e, n) {
  var r = t._x1 - t._x0, i = e - t._x1, a = (t._y1 - t._y0) / (r || i < 0 && -0), o = (n - t._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
  return (T7(a) + T7(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function S7(t, e) {
  var n = t._x1 - t._x0;
  return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
}
function o0(t, e, n) {
  var r = t._x0, i = t._y0, a = t._x1, o = t._y1, s = (a - r) / 3;
  t._context.bezierCurveTo(r + s, i + s * e, a - s, o - s * n, a, o);
}
function dp(t) {
  this._context = t;
}
dp.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        o0(this, this._t0, S7(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var n = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, o0(this, S7(this, n = O7(this, t, e)), n);
          break;
        default:
          o0(this, this._t0, n = O7(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
    }
  }
};
function IE(t) {
  this._context = new RE(t);
}
(IE.prototype = Object.create(dp.prototype)).point = function(t, e) {
  dp.prototype.point.call(this, e, t);
};
function RE(t) {
  this._context = t;
}
RE.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, n, r, i, a) {
    this._context.bezierCurveTo(e, t, r, n, a, i);
  }
};
function c0t(t) {
  return new dp(t);
}
function f0t(t) {
  return new IE(t);
}
function LE(t) {
  this._context = t;
}
LE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length;
    if (n)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), n === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var r = E7(t), i = E7(e), a = 0, o = 1; o < n; ++a, ++o)
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], t[o], e[o]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function E7(t) {
  var e, n = t.length - 1, r, i = new Array(n), a = new Array(n), o = new Array(n);
  for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < n - 1; ++e)
    i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
  for (i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * t[n - 1] + t[n], e = 1; e < n; ++e)
    r = i[e] / a[e - 1], a[e] -= r, o[e] -= r * o[e - 1];
  for (i[n - 1] = o[n - 1] / a[n - 1], e = n - 2; e >= 0; --e)
    i[e] = (o[e] - i[e + 1]) / a[e];
  for (a[n - 1] = (t[n] + i[n - 1]) / 2, e = 0; e < n - 1; ++e)
    a[e] = 2 * t[e + 1] - i[e + 1];
  return [i, a];
}
function h0t(t) {
  return new LE(t);
}
function L1(t, e) {
  this._context = t, this._t = e;
}
L1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var n = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function d0t(t) {
  return new L1(t, 0.5);
}
function p0t(t) {
  return new L1(t, 0);
}
function m0t(t) {
  return new L1(t, 1);
}
function pu(t, e) {
  if ((o = t.length) > 1)
    for (var n = 1, r, i, a = t[e[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = t[e[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function mu(t) {
  for (var e = t.length, n = new Array(e); --e >= 0; )
    n[e] = e;
  return n;
}
function g0t(t, e) {
  return t[e];
}
function v0t(t) {
  const e = [];
  return e.key = t, e;
}
function _0t() {
  var t = Mt([]), e = mu, n = pu, r = g0t;
  function i(a) {
    var o = Array.from(t.apply(this, arguments), v0t), s, l = o.length, c = -1, h;
    for (const d of a)
      for (s = 0, ++c; s < l; ++s)
        (o[s][c] = [0, +r(d, o[s].key, c, a)]).data = d;
    for (s = 0, h = k1(e(o)); s < l; ++s)
      o[h[s]].index = s;
    return n(o, h), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Mt(Array.from(a)), i) : t;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Mt(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (e = a == null ? mu : typeof a == "function" ? a : Mt(Array.from(a)), i) : e;
  }, i.offset = function(a) {
    return arguments.length ? (n = a == null ? pu : a, i) : n;
  }, i;
}
function b0t(t, e) {
  if ((r = t.length) > 0) {
    for (var n, r, i = 0, a = t[0].length, o; i < a; ++i) {
      for (o = n = 0; n < r; ++n)
        o += t[n][i][1] || 0;
      if (o)
        for (n = 0; n < r; ++n)
          t[n][i][1] /= o;
    }
    pu(t, e);
  }
}
function y0t(t, e) {
  if ((l = t.length) > 0)
    for (var n, r = 0, i, a, o, s, l, c = t[e[0]].length; r < c; ++r)
      for (o = s = 0, n = 0; n < l; ++n)
        (a = (i = t[e[n]][r])[1] - i[0]) > 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : (i[0] = 0, i[1] = a);
}
function w0t(t, e) {
  if ((i = t.length) > 0) {
    for (var n = 0, r = t[e[0]], i, a = r.length; n < a; ++n) {
      for (var o = 0, s = 0; o < i; ++o)
        s += t[o][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    pu(t, e);
  }
}
function x0t(t, e) {
  if (!(!((o = t.length) > 0) || !((a = (i = t[e[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, a, o; r < a; ++r) {
      for (var s = 0, l = 0, c = 0; s < o; ++s) {
        for (var h = t[e[s]], d = h[r][1] || 0, p = h[r - 1][1] || 0, g = (d - p) / 2, v = 0; v < s; ++v) {
          var b = t[e[v]], _ = b[r][1] || 0, w = b[r - 1][1] || 0;
          g += _ - w;
        }
        l += d, c += g * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, l && (n -= c / l);
    }
    i[r - 1][1] += i[r - 1][0] = n, pu(t, e);
  }
}
function DE(t) {
  var e = t.map(C0t);
  return mu(t).sort(function(n, r) {
    return e[n] - e[r];
  });
}
function C0t(t) {
  for (var e = -1, n = 0, r = t.length, i, a = -1 / 0; ++e < r; )
    (i = +t[e][1]) > a && (a = i, n = e);
  return n;
}
function FE(t) {
  var e = t.map(zE);
  return mu(t).sort(function(n, r) {
    return e[n] - e[r];
  });
}
function zE(t) {
  for (var e = 0, n = -1, r = t.length, i; ++n < r; )
    (i = +t[n][1]) && (e += i);
  return e;
}
function $0t(t) {
  return FE(t).reverse();
}
function T0t(t) {
  var e = t.length, n, r, i = t.map(zE), a = DE(t), o = 0, s = 0, l = [], c = [];
  for (n = 0; n < e; ++n)
    r = a[n], o < s ? (o += i[r], l.push(r)) : (s += i[r], c.push(r));
  return c.reverse().concat(l);
}
function O0t(t) {
  return mu(t).reverse();
}
const Th = (t) => () => t;
function S0t(t, {
  sourceEvent: e,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function ri(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
ri.prototype = {
  constructor: ri,
  scale: function(t) {
    return t === 1 ? this : new ri(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new ri(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Ia = new ri(1, 0, 0);
BE.prototype = ri.prototype;
function BE(t) {
  for (; !t.__zoom; )
    if (!(t = t.parentNode))
      return Ia;
  return t.__zoom;
}
function s0(t) {
  t.stopImmediatePropagation();
}
function ml(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function E0t(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function A0t() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function A7() {
  return this.__zoom || Ia;
}
function P0t(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function M0t() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function k0t(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], i = t.invertX(e[1][0]) - n[1][0], a = t.invertY(e[0][1]) - n[0][1], o = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function Ub() {
  var t = E0t, e = A0t, n = k0t, r = P0t, i = M0t, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, l = PT, c = Ho("start", "zoom", "end"), h, d, p, g = 500, v = 150, b = 0, _ = 10;
  function w(I) {
    I.property("__zoom", A7).on("wheel.zoom", L, { passive: !1 }).on("mousedown.zoom", W).on("dblclick.zoom", P).filter(i).on("touchstart.zoom", k).on("touchmove.zoom", Y).on("touchend.zoom touchcancel.zoom", V).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  w.transform = function(I, D, z, q) {
    var Z = I.selection ? I.selection() : I;
    Z.property("__zoom", A7), I !== Z ? E(I, D, z, q) : Z.interrupt().each(function() {
      A(this, arguments).event(q).start().zoom(null, typeof D == "function" ? D.apply(this, arguments) : D).end();
    });
  }, w.scaleBy = function(I, D, z, q) {
    w.scaleTo(I, function() {
      var Z = this.__zoom.k, B = typeof D == "function" ? D.apply(this, arguments) : D;
      return Z * B;
    }, z, q);
  }, w.scaleTo = function(I, D, z, q) {
    w.transform(I, function() {
      var Z = e.apply(this, arguments), B = this.__zoom, H = z == null ? $(Z) : typeof z == "function" ? z.apply(this, arguments) : z, J = B.invert(H), X = typeof D == "function" ? D.apply(this, arguments) : D;
      return n(C(x(B, X), H, J), Z, o);
    }, z, q);
  }, w.translateBy = function(I, D, z, q) {
    w.transform(I, function() {
      return n(this.__zoom.translate(
        typeof D == "function" ? D.apply(this, arguments) : D,
        typeof z == "function" ? z.apply(this, arguments) : z
      ), e.apply(this, arguments), o);
    }, null, q);
  }, w.translateTo = function(I, D, z, q, Z) {
    w.transform(I, function() {
      var B = e.apply(this, arguments), H = this.__zoom, J = q == null ? $(B) : typeof q == "function" ? q.apply(this, arguments) : q;
      return n(Ia.translate(J[0], J[1]).scale(H.k).translate(
        typeof D == "function" ? -D.apply(this, arguments) : -D,
        typeof z == "function" ? -z.apply(this, arguments) : -z
      ), B, o);
    }, q, Z);
  };
  function x(I, D) {
    return D = Math.max(a[0], Math.min(a[1], D)), D === I.k ? I : new ri(D, I.x, I.y);
  }
  function C(I, D, z) {
    var q = D[0] - z[0] * I.k, Z = D[1] - z[1] * I.k;
    return q === I.x && Z === I.y ? I : new ri(I.k, q, Z);
  }
  function $(I) {
    return [(+I[0][0] + +I[1][0]) / 2, (+I[0][1] + +I[1][1]) / 2];
  }
  function E(I, D, z, q) {
    I.on("start.zoom", function() {
      A(this, arguments).event(q).start();
    }).on("interrupt.zoom end.zoom", function() {
      A(this, arguments).event(q).end();
    }).tween("zoom", function() {
      var Z = this, B = arguments, H = A(Z, B).event(q), J = e.apply(Z, B), X = z == null ? $(J) : typeof z == "function" ? z.apply(Z, B) : z, et = Math.max(J[1][0] - J[0][0], J[1][1] - J[0][1]), rt = Z.__zoom, ut = typeof D == "function" ? D.apply(Z, B) : D, ft = l(rt.invert(X).concat(et / rt.k), ut.invert(X).concat(et / ut.k));
      return function(ht) {
        if (ht === 1)
          ht = ut;
        else {
          var Nt = ft(ht), ot = et / Nt[2];
          ht = new ri(ot, X[0] - Nt[0] * ot, X[1] - Nt[1] * ot);
        }
        H.zoom(null, ht);
      };
    });
  }
  function A(I, D, z) {
    return !z && I.__zooming || new R(I, D);
  }
  function R(I, D) {
    this.that = I, this.args = D, this.active = 0, this.sourceEvent = null, this.extent = e.apply(I, D), this.taps = 0;
  }
  R.prototype = {
    event: function(I) {
      return I && (this.sourceEvent = I), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(I, D) {
      return this.mouse && I !== "mouse" && (this.mouse[1] = D.invert(this.mouse[0])), this.touch0 && I !== "touch" && (this.touch0[1] = D.invert(this.touch0[0])), this.touch1 && I !== "touch" && (this.touch1[1] = D.invert(this.touch1[0])), this.that.__zoom = D, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(I) {
      var D = de(this.that).datum();
      c.call(
        I,
        this.that,
        new S0t(I, {
          sourceEvent: this.sourceEvent,
          target: w,
          type: I,
          transform: this.that.__zoom,
          dispatch: c
        }),
        D
      );
    }
  };
  function L(I, ...D) {
    if (!t.apply(this, arguments))
      return;
    var z = A(this, D).event(I), q = this.__zoom, Z = Math.max(a[0], Math.min(a[1], q.k * Math.pow(2, r.apply(this, arguments)))), B = mn(I);
    if (z.wheel)
      (z.mouse[0][0] !== B[0] || z.mouse[0][1] !== B[1]) && (z.mouse[1] = q.invert(z.mouse[0] = B)), clearTimeout(z.wheel);
    else {
      if (q.k === Z)
        return;
      z.mouse = [B, q.invert(B)], wo(this), z.start();
    }
    ml(I), z.wheel = setTimeout(H, v), z.zoom("mouse", n(C(x(q, Z), z.mouse[0], z.mouse[1]), z.extent, o));
    function H() {
      z.wheel = null, z.end();
    }
  }
  function W(I, ...D) {
    if (p || !t.apply(this, arguments))
      return;
    var z = I.currentTarget, q = A(this, D, !0).event(I), Z = de(I.view).on("mousemove.zoom", X, !0).on("mouseup.zoom", et, !0), B = mn(I, z), H = I.clientX, J = I.clientY;
    s1(I.view), s0(I), q.mouse = [B, this.__zoom.invert(B)], wo(this), q.start();
    function X(rt) {
      if (ml(rt), !q.moved) {
        var ut = rt.clientX - H, ft = rt.clientY - J;
        q.moved = ut * ut + ft * ft > b;
      }
      q.event(rt).zoom("mouse", n(C(q.that.__zoom, q.mouse[0] = mn(rt, z), q.mouse[1]), q.extent, o));
    }
    function et(rt) {
      Z.on("mousemove.zoom mouseup.zoom", null), u1(rt.view, q.moved), ml(rt), q.event(rt).end();
    }
  }
  function P(I, ...D) {
    if (t.apply(this, arguments)) {
      var z = this.__zoom, q = mn(I.changedTouches ? I.changedTouches[0] : I, this), Z = z.invert(q), B = z.k * (I.shiftKey ? 0.5 : 2), H = n(C(x(z, B), q, Z), e.apply(this, D), o);
      ml(I), s > 0 ? de(this).transition().duration(s).call(E, H, q, I) : de(this).call(w.transform, H, q, I);
    }
  }
  function k(I, ...D) {
    if (t.apply(this, arguments)) {
      var z = I.touches, q = z.length, Z = A(this, D, I.changedTouches.length === q).event(I), B, H, J, X;
      for (s0(I), H = 0; H < q; ++H)
        J = z[H], X = mn(J, this), X = [X, this.__zoom.invert(X), J.identifier], Z.touch0 ? !Z.touch1 && Z.touch0[2] !== X[2] && (Z.touch1 = X, Z.taps = 0) : (Z.touch0 = X, B = !0, Z.taps = 1 + !!h);
      h && (h = clearTimeout(h)), B && (Z.taps < 2 && (d = X[0], h = setTimeout(function() {
        h = null;
      }, g)), wo(this), Z.start());
    }
  }
  function Y(I, ...D) {
    if (this.__zooming) {
      var z = A(this, D).event(I), q = I.changedTouches, Z = q.length, B, H, J, X;
      for (ml(I), B = 0; B < Z; ++B)
        H = q[B], J = mn(H, this), z.touch0 && z.touch0[2] === H.identifier ? z.touch0[0] = J : z.touch1 && z.touch1[2] === H.identifier && (z.touch1[0] = J);
      if (H = z.that.__zoom, z.touch1) {
        var et = z.touch0[0], rt = z.touch0[1], ut = z.touch1[0], ft = z.touch1[1], ht = (ht = ut[0] - et[0]) * ht + (ht = ut[1] - et[1]) * ht, Nt = (Nt = ft[0] - rt[0]) * Nt + (Nt = ft[1] - rt[1]) * Nt;
        H = x(H, Math.sqrt(ht / Nt)), J = [(et[0] + ut[0]) / 2, (et[1] + ut[1]) / 2], X = [(rt[0] + ft[0]) / 2, (rt[1] + ft[1]) / 2];
      } else if (z.touch0)
        J = z.touch0[0], X = z.touch0[1];
      else
        return;
      z.zoom("touch", n(C(H, J, X), z.extent, o));
    }
  }
  function V(I, ...D) {
    if (this.__zooming) {
      var z = A(this, D).event(I), q = I.changedTouches, Z = q.length, B, H;
      for (s0(I), p && clearTimeout(p), p = setTimeout(function() {
        p = null;
      }, g), B = 0; B < Z; ++B)
        H = q[B], z.touch0 && z.touch0[2] === H.identifier ? delete z.touch0 : z.touch1 && z.touch1[2] === H.identifier && delete z.touch1;
      if (z.touch1 && !z.touch0 && (z.touch0 = z.touch1, delete z.touch1), z.touch0)
        z.touch0[1] = this.__zoom.invert(z.touch0[0]);
      else if (z.end(), z.taps === 2 && (H = mn(H, this), Math.hypot(d[0] - H[0], d[1] - H[1]) < _)) {
        var J = de(this).on("dblclick.zoom");
        J && J.apply(this, arguments);
      }
    }
  }
  return w.wheelDelta = function(I) {
    return arguments.length ? (r = typeof I == "function" ? I : Th(+I), w) : r;
  }, w.filter = function(I) {
    return arguments.length ? (t = typeof I == "function" ? I : Th(!!I), w) : t;
  }, w.touchable = function(I) {
    return arguments.length ? (i = typeof I == "function" ? I : Th(!!I), w) : i;
  }, w.extent = function(I) {
    return arguments.length ? (e = typeof I == "function" ? I : Th([[+I[0][0], +I[0][1]], [+I[1][0], +I[1][1]]]), w) : e;
  }, w.scaleExtent = function(I) {
    return arguments.length ? (a[0] = +I[0], a[1] = +I[1], w) : [a[0], a[1]];
  }, w.translateExtent = function(I) {
    return arguments.length ? (o[0][0] = +I[0][0], o[1][0] = +I[1][0], o[0][1] = +I[0][1], o[1][1] = +I[1][1], w) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, w.constrain = function(I) {
    return arguments.length ? (n = I, w) : n;
  }, w.duration = function(I) {
    return arguments.length ? (s = +I, w) : s;
  }, w.interpolate = function(I) {
    return arguments.length ? (l = I, w) : l;
  }, w.on = function() {
    var I = c.on.apply(c, arguments);
    return I === c ? w : I;
  }, w.clickDistance = function(I) {
    return arguments.length ? (b = (I = +I) * I, w) : Math.sqrt(b);
  }, w.tapDistance = function(I) {
    return arguments.length ? (_ = +I, w) : _;
  }, w;
}
const N0t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Adder: Ie,
  Delaunay: k2,
  FormatSpecifier: b1,
  InternMap: oc,
  InternSet: So,
  Node: No,
  Voronoi: KT,
  ZoomTransform: ri,
  active: Nlt,
  arc: Mgt,
  area: mE,
  areaRadial: $7,
  ascending: Qe,
  autoType: lft,
  axisBottom: r1,
  axisLeft: i1,
  axisRight: Sat,
  axisTop: Oat,
  bin: v8,
  bisect: Bo,
  bisectCenter: Pit,
  bisectLeft: Ait,
  bisectRight: $$,
  bisector: t1,
  blob: hft,
  brush: Ylt,
  brushSelection: Vlt,
  brushX: Wlt,
  brushY: Ult,
  buffer: pft,
  chord: Glt,
  chordDirected: Xlt,
  chordTranspose: Klt,
  cluster: Adt,
  color: Ea,
  contourDensity: Ect,
  contours: Ev,
  count: e1,
  create: eT,
  creator: a1,
  cross: Rit,
  csv: vft,
  csvFormat: Jct,
  csvFormatBody: Qct,
  csvFormatRow: eft,
  csvFormatRows: tft,
  csvFormatValue: nft,
  csvParse: ZT,
  csvParseRows: Zct,
  cubehelix: Hr,
  cumsum: Lit,
  curveBasis: Zgt,
  curveBasisClosed: Jgt,
  curveBasisOpen: Qgt,
  curveBumpX: t0t,
  curveBumpY: e0t,
  curveBundle: n0t,
  curveCardinal: r0t,
  curveCardinalClosed: i0t,
  curveCardinalOpen: a0t,
  curveCatmullRom: o0t,
  curveCatmullRomClosed: s0t,
  curveCatmullRomOpen: u0t,
  curveLinear: N1,
  curveLinearClosed: l0t,
  curveMonotoneX: c0t,
  curveMonotoneY: f0t,
  curveNatural: h0t,
  curveStep: d0t,
  curveStepAfter: m0t,
  curveStepBefore: p0t,
  descending: Dit,
  deviation: O$,
  difference: pat,
  disjoint: mat,
  dispatch: Ho,
  drag: gst,
  dragDisable: s1,
  dragEnable: u1,
  dsv: gft,
  dsvFormat: g1,
  easeBack: B8,
  easeBackIn: Tlt,
  easeBackInOut: B8,
  easeBackOut: Olt,
  easeBounce: mc,
  easeBounceIn: Clt,
  easeBounceInOut: $lt,
  easeBounceOut: mc,
  easeCircle: z8,
  easeCircleIn: dlt,
  easeCircleInOut: z8,
  easeCircleOut: plt,
  easeCubic: bv,
  easeCubicIn: alt,
  easeCubicInOut: bv,
  easeCubicOut: olt,
  easeElastic: H8,
  easeElasticIn: Slt,
  easeElasticInOut: Elt,
  easeElasticOut: H8,
  easeExp: F8,
  easeExpIn: flt,
  easeExpInOut: F8,
  easeExpOut: hlt,
  easeLinear: nlt,
  easePoly: L8,
  easePolyIn: slt,
  easePolyInOut: L8,
  easePolyOut: ult,
  easeQuad: R8,
  easeQuadIn: rlt,
  easeQuadInOut: R8,
  easeQuadOut: ilt,
  easeSin: D8,
  easeSinIn: llt,
  easeSinInOut: D8,
  easeSinOut: clt,
  every: uat,
  extent: zl,
  fcumsum: zit,
  filter: cat,
  flatGroup: Bit,
  flatRollup: Hit,
  forceCenter: $ft,
  forceCollide: Vft,
  forceLink: Uft,
  forceManyBody: tht,
  forceRadial: eht,
  forceSimulation: Qft,
  forceX: nht,
  forceY: rht,
  get format() {
    return Uo;
  },
  formatDefaultLocale: rO,
  formatLocale: nO,
  get formatPrefix() {
    return L2;
  },
  formatSpecifier: uu,
  fsum: Fit,
  geoAlbers: HO,
  geoAlbersUsa: sdt,
  geoArea: dht,
  geoAzimuthalEqualArea: udt,
  geoAzimuthalEqualAreaRaw: q2,
  geoAzimuthalEquidistant: ldt,
  geoAzimuthalEquidistantRaw: G2,
  geoBounds: vht,
  geoCentroid: Cht,
  geoCircle: $ht,
  geoClipAntimeridian: Hv,
  geoClipCircle: TO,
  geoClipExtent: Mht,
  geoClipRectangle: y1,
  geoConicConformal: fdt,
  geoConicConformalRaw: WO,
  geoConicEqualArea: ip,
  geoConicEqualAreaRaw: BO,
  geoConicEquidistant: ddt,
  geoConicEquidistantRaw: UO,
  geoContains: Fht,
  geoDistance: Xd,
  geoEqualEarth: mdt,
  geoEqualEarthRaw: K2,
  geoEquirectangular: hdt,
  geoEquirectangularRaw: yc,
  geoGnomonic: gdt,
  geoGnomonicRaw: X2,
  geoGraticule: EO,
  geoGraticule10: zht,
  geoIdentity: vdt,
  geoInterpolate: Bht,
  geoLength: OO,
  geoMercator: cdt,
  geoMercatorRaw: Yc,
  geoNaturalEarth1: _dt,
  geoNaturalEarth1Raw: Z2,
  geoOrthographic: bdt,
  geoOrthographicRaw: J2,
  geoPath: B2,
  geoProjection: Vr,
  geoProjectionMutator: U2,
  geoRotation: bO,
  geoStereographic: ydt,
  geoStereographicRaw: Q2,
  geoStream: Mr,
  geoTransform: Jht,
  geoTransverseMercator: wdt,
  geoTransverseMercatorRaw: tb,
  gray: Ost,
  greatest: nat,
  greatestIndex: rat,
  group: P$,
  groupSort: Wit,
  groups: M$,
  hcl: Md,
  hierarchy: eb,
  histogram: v8,
  hsl: Ed,
  html: xft,
  image: bft,
  index: jit,
  indexes: Vit,
  interpolate: za,
  interpolateArray: kst,
  interpolateBasis: vT,
  interpolateBasisClosed: _T,
  interpolateBlues: igt,
  interpolateBrBG: Dmt,
  interpolateBuGn: Ymt,
  interpolateBuPu: qmt,
  interpolateCividis: cgt,
  interpolateCool: dgt,
  interpolateCubehelix: qst,
  interpolateCubehelixDefault: fgt,
  interpolateCubehelixLong: h1,
  interpolateDate: $T,
  interpolateDiscrete: Rst,
  interpolateGnBu: Gmt,
  interpolateGreens: agt,
  interpolateGreys: ogt,
  interpolateHcl: Ust,
  interpolateHclLong: Yst,
  interpolateHsl: jst,
  interpolateHslLong: Vst,
  interpolateHue: Lst,
  interpolateInferno: wgt,
  interpolateLab: Wst,
  interpolateMagma: ygt,
  interpolateNumber: br,
  interpolateNumberArray: x2,
  interpolateObject: TT,
  interpolateOrRd: Kmt,
  interpolateOranges: lgt,
  interpolatePRGn: Fmt,
  interpolatePiYG: zmt,
  interpolatePlasma: xgt,
  interpolatePuBu: Zmt,
  interpolatePuBuGn: Xmt,
  interpolatePuOr: Bmt,
  interpolatePuRd: Jmt,
  interpolatePurples: sgt,
  interpolateRainbow: pgt,
  interpolateRdBu: Hmt,
  interpolateRdGy: jmt,
  interpolateRdPu: Qmt,
  interpolateRdYlBu: Vmt,
  interpolateRdYlGn: Wmt,
  interpolateReds: ugt,
  interpolateRgb: hc,
  interpolateRgbBasis: wT,
  interpolateRgbBasisClosed: Mst,
  interpolateRound: Bc,
  interpolateSinebow: vgt,
  interpolateSpectral: Umt,
  interpolateString: C2,
  interpolateTransformCss: ET,
  interpolateTransformSvg: AT,
  interpolateTurbo: _gt,
  interpolateViridis: bgt,
  interpolateWarm: hgt,
  interpolateYlGn: egt,
  interpolateYlGnBu: tgt,
  interpolateYlOrBr: ngt,
  interpolateYlOrRd: rgt,
  interpolateZoom: PT,
  interrupt: wo,
  intersection: gat,
  interval: Jst,
  isoFormat: wmt,
  isoParse: $mt,
  json: N2,
  lab: Pd,
  lch: Sst,
  least: eat,
  leastIndex: V$,
  line: I1,
  lineRadial: C7,
  linkHorizontal: Hgt,
  linkRadial: Vgt,
  linkVertical: jgt,
  local: nT,
  map: fat,
  matcher: m2,
  max: Sa,
  maxIndex: H$,
  mean: Kit,
  median: Xit,
  merge: h2,
  min: Od,
  minIndex: j$,
  mode: Jit,
  namespace: Fc,
  namespaces: lv,
  nice: F$,
  now: Hc,
  pack: rpt,
  packEnclose: qO,
  packSiblings: tpt,
  pairs: Qit,
  partition: ipt,
  path: Ba,
  permute: L$,
  pie: Rgt,
  piecewise: IT,
  pointRadial: Ml,
  pointer: mn,
  pointers: lst,
  polygonArea: bpt,
  polygonCentroid: ypt,
  polygonContains: $pt,
  polygonHull: Cpt,
  polygonLength: Tpt,
  precisionFixed: iO,
  precisionPrefix: aO,
  precisionRound: oO,
  quadtree: _1,
  quantile: uc,
  quantileSorted: B$,
  quantize: Gst,
  quickselect: f2,
  radialArea: $7,
  radialLine: C7,
  randomBates: Apt,
  randomBernoulli: kpt,
  randomBeta: rS,
  randomBinomial: iS,
  randomCauchy: Ipt,
  randomExponential: Ppt,
  randomGamma: rb,
  randomGeometric: nS,
  randomInt: Spt,
  randomIrwinHall: eS,
  randomLcg: zpt,
  randomLogNormal: Ept,
  randomLogistic: Rpt,
  randomNormal: nb,
  randomPareto: Mpt,
  randomPoisson: Lpt,
  randomUniform: Opt,
  randomWeibull: Npt,
  range: ei,
  reduce: hat,
  reverse: dat,
  rgb: iu,
  ribbon: act,
  ribbonArrow: oct,
  rollup: N$,
  rollups: I$,
  scaleBand: Gc,
  scaleDiverging: Nb,
  scaleDivergingLog: Ib,
  scaleDivergingPow: P1,
  scaleDivergingSqrt: BS,
  scaleDivergingSymlog: Rb,
  scaleIdentity: ob,
  scaleImplicit: sp,
  scaleLinear: Bi,
  scaleLog: $1,
  scaleOrdinal: Lu,
  scalePoint: oS,
  scalePow: T1,
  scaleQuantile: hb,
  scaleQuantize: db,
  scaleRadial: fb,
  scaleSequential: Ab,
  scaleSequentialLog: Pb,
  scaleSequentialPow: E1,
  scaleSequentialQuantile: kb,
  scaleSequentialSqrt: zS,
  scaleSequentialSymlog: Mb,
  scaleSqrt: uS,
  scaleSymlog: lb,
  scaleThreshold: pb,
  scaleTime: Eb,
  scaleUtc: FS,
  scan: iat,
  schemeAccent: Emt,
  schemeBlues: uE,
  schemeBrBG: HS,
  schemeBuGn: XS,
  schemeBuPu: ZS,
  schemeCategory10: Smt,
  schemeDark2: Amt,
  schemeGnBu: JS,
  schemeGreens: lE,
  schemeGreys: cE,
  schemeOrRd: QS,
  schemeOranges: dE,
  schemePRGn: jS,
  schemePaired: Pmt,
  schemePastel1: Mmt,
  schemePastel2: kmt,
  schemePiYG: VS,
  schemePuBu: eE,
  schemePuBuGn: tE,
  schemePuOr: WS,
  schemePuRd: nE,
  schemePurples: fE,
  schemeRdBu: US,
  schemeRdGy: YS,
  schemeRdPu: rE,
  schemeRdYlBu: qS,
  schemeRdYlGn: GS,
  schemeReds: hE,
  schemeSet1: Nmt,
  schemeSet2: Imt,
  schemeSet3: Rmt,
  schemeSpectral: KS,
  schemeTableau10: Lmt,
  schemeYlGn: aE,
  schemeYlGnBu: iE,
  schemeYlOrBr: oE,
  schemeYlOrRd: sE,
  select: de,
  selectAll: cst,
  selection: jo,
  selector: o1,
  selectorAll: p2,
  shuffle: aat,
  shuffler: W$,
  some: lat,
  sort: rv,
  stack: _0t,
  stackOffsetDiverging: y0t,
  stackOffsetExpand: b0t,
  stackOffsetNone: pu,
  stackOffsetSilhouette: w0t,
  stackOffsetWiggle: x0t,
  stackOrderAppearance: DE,
  stackOrderAscending: FE,
  stackOrderDescending: $0t,
  stackOrderInsideOut: T0t,
  stackOrderNone: mu,
  stackOrderReverse: O0t,
  stratify: upt,
  style: Eo,
  subset: _at,
  sum: d2,
  superset: Y$,
  svg: Cft,
  symbol: Xgt,
  symbolCircle: Bb,
  symbolCross: _E,
  symbolDiamond: yE,
  symbolSquare: CE,
  symbolStar: xE,
  symbolTriangle: $E,
  symbolWye: TE,
  symbols: Kgt,
  text: v1,
  thresholdFreedmanDiaconis: qit,
  thresholdScott: Git,
  thresholdSturges: z$,
  tickFormat: ab,
  tickIncrement: Dc,
  tickStep: Td,
  ticks: sc,
  timeDay: Xc,
  timeDays: t1t,
  get timeFormat() {
    return $b;
  },
  timeFormatDefaultLocale: LS,
  timeFormatLocale: MS,
  timeFriday: mS,
  timeFridays: a1t,
  timeHour: vb,
  timeHours: Qpt,
  timeInterval: Le,
  timeMillisecond: e_,
  timeMilliseconds: a7,
  timeMinute: gb,
  timeMinutes: Jpt,
  timeMonday: wc,
  timeMondays: e1t,
  timeMonth: _b,
  timeMonths: s1t,
  get timeParse() {
    return Tb;
  },
  timeSaturday: gS,
  timeSaturdays: o1t,
  timeSecond: ma,
  timeSeconds: s7,
  timeSunday: hu,
  timeSundays: u7,
  timeThursday: Ro,
  timeThursdays: i1t,
  timeTickInterval: PS,
  timeTicks: AS,
  timeTuesday: dS,
  timeTuesdays: n1t,
  timeWednesday: pS,
  timeWednesdays: r1t,
  timeWeek: hu,
  timeWeeks: u7,
  timeYear: Pa,
  timeYears: u1t,
  timeout: mv,
  timer: p1,
  timerFlush: DT,
  transition: HT,
  transpose: U$,
  tree: ppt,
  treemap: mpt,
  treemapBinary: gpt,
  treemapDice: qc,
  treemapResquarify: _pt,
  treemapSlice: x1,
  treemapSliceDice: vpt,
  treemapSquarify: tS,
  tsv: _ft,
  tsvFormat: ift,
  tsvFormatBody: aft,
  tsvFormatRow: sft,
  tsvFormatRows: oft,
  tsvFormatValue: uft,
  tsvParse: JT,
  tsvParseRows: rft,
  union: bat,
  utcDay: Zc,
  utcDays: f1t,
  get utcFormat() {
    return O1;
  },
  utcFriday: CS,
  utcFridays: g1t,
  utcHour: wb,
  utcHours: c1t,
  utcMillisecond: e_,
  utcMilliseconds: a7,
  utcMinute: yb,
  utcMinutes: l1t,
  utcMonday: xc,
  utcMondays: h1t,
  utcMonth: xb,
  utcMonths: _1t,
  get utcParse() {
    return Ob;
  },
  utcSaturday: $S,
  utcSaturdays: v1t,
  utcSecond: ma,
  utcSeconds: s7,
  utcSunday: du,
  utcSundays: l7,
  utcThursday: Lo,
  utcThursdays: m1t,
  utcTickInterval: ES,
  utcTicks: SS,
  utcTuesday: wS,
  utcTuesdays: d1t,
  utcWednesday: xS,
  utcWednesdays: p1t,
  utcWeek: du,
  utcWeeks: l7,
  utcYear: Ma,
  utcYears: b1t,
  variance: T$,
  window: g2,
  xml: wft,
  zip: sat,
  zoom: Ub,
  zoomIdentity: Ia,
  zoomTransform: BE
}, Symbol.toStringTag, { value: "Module" })), I0t = te({
  name: "OrdinalLegend",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    horizontal: {
      type: Boolean
    },
    markerPath: {
      type: [String, Function],
      default: "M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z"
    },
    categoryObjectsPath: {
      type: String,
      default: "id"
    },
    highlight: {
      type: [String, Number],
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    markerBoundingClientRect() {
      var r;
      const t = de("body").append("svg").attr("width", 2046).attr("height", 2046), n = (r = t.append("path").attr("d", this.markerPathFunction()).node()) == null ? void 0 : r.getBoundingClientRect();
      return t.remove(), n;
    },
    markerViewbox() {
      var n;
      const { width: t, height: e } = (n = this.markerBoundingClientRect) != null ? n : { width: 0, height: 0 };
      return `0 0 ${t} ${e}`;
    },
    classList() {
      return {
        "ordinal-legend--horizontal": this.horizontal,
        "ordinal-legend--has-highlight": this.highlight !== null,
        "ordinal-legend--has-value": this.value !== null
      };
    },
    dataWithIds() {
      return this.data.map((t) => {
        const e = ct.uniqueId();
        return qr({ [this.categoryObjectsPath]: e }, t);
      });
    }
  },
  methods: {
    itemClassList(t) {
      const e = t[this.categoryObjectsPath];
      return {
        [`ordinal-legend__item--identifier-${ct.kebabCase(t.label)}`]: !0,
        "ordinal-legend__item--highlighted": e === this.highlight,
        "ordinal-legend__item--selected": e === this.value
      };
    },
    markerPathFunction(t) {
      return ct.isFunction(this.markerPath) && t ? this.markerPath(t) : this.markerPath;
    },
    update(t) {
      this.$emit("update", ct.get(t, this.categoryObjectsPath, null));
    },
    updateHighlight(t = {}) {
      this.$emit("update:highlight", ct.get(t, this.categoryObjectsPath, null));
    }
  }
});
var R0t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("ul", { staticClass: "ordinal-legend list-unstyled", class: e.classList }, e._l(e.data, function(r) {
    return n("li", { key: r[e.categoryObjectsPath], staticClass: "ordinal-legend__item", class: e.itemClassList(r) }, [n("a", { on: { click: function(i) {
      return e.update(r);
    }, mouseover: function(i) {
      return e.updateHighlight(r);
    }, mouseleave: function(i) {
      return e.updateHighlight();
    } } }, [n("span", { staticClass: "ordinal-legend__item__marker mr-1" }, [e._t("marker", function() {
      return [n("svg", { attrs: { viewBox: e.markerViewbox } }, [n("path", { staticClass: "ordinal-legend__item__marker__path", attrs: { d: e.markerPathFunction(r), fill: r.color } })])];
    }, { marker: { path: r.path, color: r.color } })], 2), n("span", { staticClass: "ordinal-legend__item__label" }, [e._t("label", function() {
      return [e._v(" " + e._s(r.label) + " ")];
    }, null, r)], 2)])]);
  }), 0);
}, L0t = [], D0t = /* @__PURE__ */ Bt(
  I0t,
  R0t,
  L0t,
  !1,
  null,
  "418e6298",
  null,
  null
);
const HE = D0t.exports;
var jE = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", n = "grip-lines-vertical", r = 192, i = 512, a = [], o = "f7a5", s = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z";
  t.definition = {
    prefix: e,
    iconName: n,
    icon: [
      r,
      i,
      a,
      o,
      s
    ]
  }, t.faGripLinesVertical = t.definition, t.prefix = e, t.iconName = n, t.width = r, t.height = i, t.ligatures = a, t.unicode = o, t.svgPathData = s, t.aliases = a;
})(jE);
const F0t = te({
  name: "RangePicker",
  components: {
    Fa: ar
  },
  directives: {
    draggable: {
      inserted(t, e, n) {
        var h, d;
        let r, i;
        const a = (d = (h = e.modifiers) == null ? void 0 : h.relative) != null ? d : !1;
        function o({ name: p, data: g = null }) {
          var b;
          const v = (b = ct.get(n, "data.on")) != null ? b : ct.get(n, "componentOptions.listeners");
          ct.has(v, p) && ct.invoke(v, `${p}.fns`, g);
        }
        function s(p) {
          const g = p instanceof MouseEvent ? p.clientX : p.touches[0].clientX, v = a ? t.offsetWidth : 0, b = n.context.rangeWidth() - v, _ = ct.clamp(r + g - i, 0, b);
          return o({ name: "dragged", data: _ }), !1;
        }
        function l(p) {
          o({ name: "ended" }), p instanceof MouseEvent ? (document.removeEventListener("mousemove", s), document.removeEventListener("mouseup", l)) : (document.removeEventListener("touchmove", s), document.removeEventListener("touchend", l));
        }
        function c(p) {
          return o({ name: "started" }), r = t.offsetLeft, p instanceof MouseEvent ? (i = p.clientX, document.addEventListener("mousemove", s), document.addEventListener("mouseup", l)) : (i = p.touches[0].clientX, document.addEventListener("touchmove", s), document.addEventListener("touchend", l)), !1;
        }
        t.addEventListener("mousedown", c), t.addEventListener("touchstart", c);
      }
    }
  },
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    /**
     * Initial values of the range bounds. Should contain two numbers.
     * indicating the start and end of the range.
     */
    value: {
      type: Array,
      required: !0
    },
    /**
     * Enables hover styling on rows.
     */
    hover: {
      type: Boolean
    },
    /**
     * Offset from the left side of the component
     * where the dragging for the start value begins.
     */
    startOffset: {
      type: [Number, String],
      default: 0
    },
    /**
     * Offset from the right side of the component where
     * the dragging for the end value ends.
     */
    endOffset: {
      type: [Number, String],
      default: 0
    },
    /**
     * Number of decimal places to which values should be rounded.
     */
    precision: {
      type: Number,
      default: 4
    },
    /**
     * Snap increment value. For instance,
     * if snap is 0.1, values will snap to 0, 0.1, 0.2, and so on.
     */
    snap: {
      type: Number,
      default: 1e-4
    },
    /**
     * Minimum distance between the two range bounds to ensure they
     * don't get too close to each other.
     */
    minDistance: {
      type: Number,
      default: 0.01
    },
    /**
     * Variant style of the component. Expected to be one
     * of the predefined Bootstrap theme (e.g., 'primary', 'secondary', etc).
     */
    variant: {
      type: String,
      default: "primary"
    },
    /**
     * Rounds corner edges of the range boundaries. If
     * true, the component will have rounded corners.
     */
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    var t, e;
    return {
      start: (t = this.value[0]) != null ? t : 0,
      end: (e = this.value[1]) != null ? e : 1,
      moving: !1,
      resizing: !1
    };
  },
  computed: {
    disabled() {
      return this.value.length < 2;
    },
    overlayStyle() {
      return {
        left: `${this.start * 100}%`,
        right: `${(1 - this.end) * 100}%`
      };
    },
    boundsStyle() {
      return {
        left: this.startOffsetWithUnit,
        right: this.endOffsetWithUnit
      };
    },
    startOffsetWithUnit() {
      return this.valueWithUnit(this.startOffset);
    },
    endOffsetWithUnit() {
      return this.valueWithUnit(this.endOffset);
    },
    startBoundStyle() {
      return { left: `${this.start * 100}% ` };
    },
    endBoundStyle() {
      return { left: `${this.end * 100}%` };
    },
    classList() {
      return {
        [`range-picker--${this.variant}`]: !!this.variant,
        "range-picker--hover": this.hover,
        "range-picker--disabled": this.disabled,
        "range-picker--rounded": this.rounded,
        "range-picker--resizing": this.resizing,
        "range-picker--moving": this.moving
      };
    }
  },
  watch: {
    value([t = null, e = null] = []) {
      this.start = t, this.end = e;
    }
  },
  beforeMount() {
    Br.add(jE.faGripLinesVertical);
  },
  methods: {
    toggleMoving(t) {
      this.moving = t != null ? t : !this.moving;
    },
    toggleResizing(t) {
      this.resizing = t != null ? t : !this.resizing;
    },
    snapValue(t) {
      return ct.round(t / this.snap) * this.snap;
    },
    rangeWidth() {
      var t, e, n;
      return (n = (e = (t = this.$el) == null ? void 0 : t.querySelector(".range-picker__bounds")) == null ? void 0 : e.getBoundingClientRect().width) != null ? n : 0;
    },
    dragStartBound(t) {
      const e = this.snapValue(t / this.rangeWidth());
      e < this.end - this.minDistance && (this.start = ct.round(e, this.precision), this.$emit("update", [this.start, this.end]));
    },
    dragEndBound(t) {
      const e = this.snapValue(t / this.rangeWidth());
      e > this.start + this.minDistance && (this.end = ct.round(e, this.precision), this.$emit("update", [this.start, this.end]));
    },
    dragBounds(t) {
      const e = this.snapValue(this.end - this.start), n = this.snapValue(t / this.rangeWidth());
      this.start = ct.round(n, this.precision), this.end = ct.round(n + e, this.precision), this.$emit("update", [this.start, this.end]);
    },
    valueWithUnit(t) {
      return typeof t == "number" ? `${t}px` : `${t}`;
    }
  }
});
var z0t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "range-picker", class: e.classList }, [n("div", { staticClass: "range-picker__wrapper" }, [e._t("default")], 2), n("div", { directives: [{ name: "show", rawName: "v-show", value: !e.disabled, expression: "!disabled" }], staticClass: "range-picker__bounds", style: e.boundsStyle }, [n("div", { directives: [{ name: "draggable", rawName: "v-draggable.relative", modifiers: { relative: !0 } }], staticClass: "range-picker__bounds__overlay", style: e.overlayStyle, on: { dragged: e.dragBounds, started: function(r) {
    return e.toggleMoving(!0);
  }, ended: function(r) {
    return e.toggleMoving(!1);
  } } }), n("button", { directives: [{ name: "draggable", rawName: "v-draggable" }], staticClass: "range-picker__bounds__start btn", style: e.startBoundStyle, on: { dragged: e.dragStartBound, started: function(r) {
    return e.toggleResizing(!0);
  }, ended: function(r) {
    return e.toggleResizing(!1);
  } } }, [n("fa", { attrs: { icon: "fa-grip-lines-vertical", "fixed-width": "" } })], 1), n("button", { directives: [{ name: "draggable", rawName: "v-draggable" }], staticClass: "range-picker__bounds__end btn", style: e.endBoundStyle, on: { dragged: e.dragEndBound, started: function(r) {
    return e.toggleResizing(!0);
  }, ended: function(r) {
    return e.toggleResizing(!1);
  } } }, [n("fa", { attrs: { icon: "fa-grip-lines-vertical", "fixed-width": "" } })], 1)])]);
}, B0t = [], H0t = /* @__PURE__ */ Bt(
  F0t,
  z0t,
  B0t,
  !1,
  null,
  "abac76db",
  null,
  null
);
const j0t = H0t.exports;
let V0t = 0;
const W0t = te({
  name: "ResponsiveIframe",
  props: {
    /**
     * URL of the generated iframe code.
     */
    url: {
      type: String,
      required: !0
    },
    /**
     * Option to pass to the constructor of the pymParent instance
     */
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iframeId: `icij-iframe-${++V0t}`,
      pymParent: null
    };
  },
  mounted() {
    return _e(this, null, function* () {
      yield l$("https://pym.nprapps.org/pym.v1.min.js"), this.pymParent = new window.pym.Parent(this.iframeId, this.url, this.options);
    });
  }
});
var U0t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { attrs: { id: e.iframeId } });
}, Y0t = [], q0t = /* @__PURE__ */ Bt(
  W0t,
  U0t,
  Y0t,
  !1,
  null,
  null,
  null,
  null
);
const G0t = q0t.exports, K0t = te({
  name: "ScaleLegend",
  filters: {
    formatNumber: Uo(",")
  },
  props: {
    width: {
      type: Number,
      default: 150
    },
    height: {
      type: Number,
      default: 16
    },
    cursorValue: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    colorScale: {
      type: [Function, String],
      default: "scaleLinear",
      validator(t) {
        return ct.isFunction(t) || t in y7;
      }
    },
    colorScaleEnd: {
      type: String,
      default() {
        return window.getComputedStyle(document.body).getPropertyValue("--primary") || "#000";
      }
    },
    colorScaleStart: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      cursorWrapperOffset: 0,
      mounted: !1
    };
  },
  computed: {
    classList() {
      return {
        "scale-legend--has-cursor": this.hasCursor
      };
    },
    cursorLeft() {
      const t = this.cursorLeftScale(this.cursorValue);
      return isNaN(t) ? "0%" : `${t}%`;
    },
    colorScaleBaseCanvas() {
      return eT("canvas").attr("width", this.width).attr("height", this.height).node();
    },
    colorScaleContext() {
      var t, e;
      return (e = (t = this.colorScaleBaseCanvas) == null ? void 0 : t.getContext("2d")) != null ? e : null;
    },
    colorScaleBase64() {
      var t, e;
      return this.mounted && (e = (t = this.colorScaleBaseCanvas) == null ? void 0 : t.toDataURL()) != null ? e : null;
    },
    colorScaleWidthRange() {
      return ei(1, this.width + 1);
    },
    hasCursor() {
      return this.cursorValue != null;
    },
    colorScaleFunction() {
      if (ct.isString(this.colorScale)) {
        const t = y7[this.colorScale];
        return t().domain([this.min, this.max]).range([this.colorScaleStart, this.colorScaleEnd]);
      }
      return this.colorScale;
    },
    cursorLeftScale() {
      return Bi().domain([this.min, this.max]).range([0, 100]).interpolate(Bc);
    },
    widthScaleColor() {
      return (t) => {
        const e = this.widthScale(t);
        return this.colorScaleFunction(e);
      };
    },
    widthScale() {
      return Bi().domain([0, this.width]).range([this.min, this.max]);
    }
  },
  watch: {
    cursorValue() {
      return _e(this, null, function* () {
        yield this.$nextTick(), this.setCursorWrapperOffset();
      });
    }
  },
  mounted() {
    return _e(this, null, function* () {
      yield this.$nextTick(), this.setCursorWrapperOffset(), this.setColorScaleCanvas(), this.mounted = !0;
    });
  },
  methods: {
    setCursorWrapperOffset() {
      const t = this.$el.querySelector(".scale-legend__cursor");
      if (t) {
        const { x: e, width: n } = t.getBoundingClientRect(), { x: r, width: i } = this.$el.getBoundingClientRect(), a = r - e - 6, o = r + i - (e + n) + 6;
        this.cursorWrapperOffset = Math.max(0, a) || Math.min(0, o);
      } else
        this.cursorWrapperOffset = 0;
    },
    setColorScaleCanvas() {
      if (this.colorScaleContext)
        for (const t of this.colorScaleWidthRange)
          this.colorScaleContext.fillStyle = this.widthScaleColor(t), this.colorScaleContext.fillRect(t, 0, 1, this.height);
    }
  }
});
var X0t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "scale-legend", class: e.classList }, [n("div", { staticClass: "scale-legend__bound scale-legend__bound--min" }, [e._t("legend-cursor-min", function() {
    return [e._v(" " + e._s(e._f("formatNumber")(e.min)) + " ")];
  }, null, { min: e.min })], 2), n("img", { staticClass: "scale-legend__scale", attrs: { height: e.height, src: e.colorScaleBase64, width: e.width } }), n("div", { staticClass: "scale-legend__bound scale-legend__bound--max" }, [e._t("legend-cursor-max", function() {
    return [e._v(" " + e._s(e._f("formatNumber")(e.max)) + " ")];
  }, null, { max: e.max })], 2), e.hasCursor ? n("div", { staticClass: "scale-legend__cursor", style: { left: e.cursorLeft } }, [n("div", { staticClass: "scale-legend__cursor__wrapper", style: { transform: `translateX(${e.cursorWrapperOffset}px)` } }, [e._t("cursor", function() {
    return [e._v(" " + e._s(e._f("formatNumber")(e.cursorValue)) + " ")];
  }, null, { value: e.cursorValue })], 2)]) : e._e()]);
}, Z0t = [], J0t = /* @__PURE__ */ Bt(
  K0t,
  X0t,
  Z0t,
  !1,
  null,
  "8653c96e",
  null,
  null
);
const VE = J0t.exports;
var Q0t = Pu;
function tvt(t, e) {
  var n = [];
  return Q0t(t, function(r, i, a) {
    e(r, i, a) && n.push(r);
  }), n;
}
var evt = tvt, nvt = JC, rvt = evt, ivt = Da, avt = Ue;
function ovt(t, e) {
  var n = avt(t) ? nvt : rvt;
  return n(t, ivt(e));
}
var P7 = ovt, svt = a2;
function uvt(t, e) {
  return svt(t, e);
}
var lvt = uvt, cvt = {
  prefix: "far",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z"]
}, fvt = cvt, hvt = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M150.7 92.77C195 58.27 251.8 32 320 32C400.8 32 465.5 68.84 512.6 112.6C559.4 156 590.7 207.1 605.5 243.7C608.8 251.6 608.8 260.4 605.5 268.3C592.1 300.6 565.2 346.1 525.6 386.7L630.8 469.1C641.2 477.3 643.1 492.4 634.9 502.8C626.7 513.2 611.6 515.1 601.2 506.9L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196C13.29-1.236 28.37-3.065 38.81 5.112L150.7 92.77zM189.8 123.5L235.8 159.5C258.3 139.9 287.8 128 320 128C390.7 128 448 185.3 448 256C448 277.2 442.9 297.1 433.8 314.7L487.6 356.9C521.1 322.8 545.9 283.1 558.6 256C544.1 225.1 518.4 183.5 479.9 147.7C438.8 109.6 385.2 79.1 320 79.1C269.5 79.1 225.1 97.73 189.8 123.5L189.8 123.5zM394.9 284.2C398.2 275.4 400 265.9 400 255.1C400 211.8 364.2 175.1 320 175.1C319.3 175.1 318.7 176 317.1 176C319.3 181.1 320 186.5 320 191.1C320 202.2 317.6 211.8 313.4 220.3L394.9 284.2zM404.3 414.5L446.2 447.5C409.9 467.1 367.8 480 320 480C239.2 480 174.5 443.2 127.4 399.4C80.62 355.1 49.34 304 34.46 268.3C31.18 260.4 31.18 251.6 34.46 243.7C44 220.8 60.29 191.2 83.09 161.5L120.8 191.2C102.1 214.5 89.76 237.6 81.45 255.1C95.02 286 121.6 328.5 160.1 364.3C201.2 402.4 254.8 432 320 432C350.7 432 378.8 425.4 404.3 414.5H404.3zM192 255.1C192 253.1 192.1 250.3 192.3 247.5L248.4 291.7C258.9 312.8 278.5 328.6 302 333.1L358.2 378.2C346.1 381.1 333.3 384 319.1 384C249.3 384 191.1 326.7 191.1 255.1H192z"]
}, dvt = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z"]
}, pvt = {
  prefix: "far",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M160 256C160 185.3 217.3 128 288 128C358.7 128 416 185.3 416 256C416 326.7 358.7 384 288 384C217.3 384 160 326.7 160 256zM288 336C332.2 336 368 300.2 368 256C368 211.8 332.2 176 288 176C287.3 176 286.7 176 285.1 176C287.3 181.1 288 186.5 288 192C288 227.3 259.3 256 224 256C218.5 256 213.1 255.3 208 253.1C208 254.7 208 255.3 208 255.1C208 300.2 243.8 336 288 336L288 336zM95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6V112.6zM288 80C222.8 80 169.2 109.6 128.1 147.7C89.6 183.5 63.02 225.1 49.44 256C63.02 286 89.6 328.5 128.1 364.3C169.2 402.4 222.8 432 288 432C353.2 432 406.8 402.4 447.9 364.3C486.4 328.5 512.1 286 526.6 256C512.1 225.1 486.4 183.5 447.9 147.7C406.8 109.6 353.2 80 288 80V80z"]
};
function mvt() {
  var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
  if (e > 0)
    return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
  var n = t.indexOf("Trident/");
  if (n > 0) {
    var r = t.indexOf("rv:");
    return parseInt(t.substring(r + 3, t.indexOf(".", r)), 10);
  }
  var i = t.indexOf("Edge/");
  return i > 0 ? parseInt(t.substring(i + 5, t.indexOf(".", i)), 10) : -1;
}
var Kh = void 0;
function r_() {
  r_.init || (r_.init = !0, Kh = mvt() !== -1);
}
var i_ = {
  render: function() {
    var e = this, n = e.$createElement, r = e._self._c || n;
    return r("div", { staticClass: "resize-observer", attrs: { tabindex: "-1" } });
  },
  staticRenderFns: [],
  _scopeId: "data-v-b329ee4c",
  name: "resize-observer",
  methods: {
    compareAndNotify: function() {
      (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.$emit("notify"));
    },
    addResizeHandlers: function() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers: function() {
      this._resizeObject && this._resizeObject.onload && (!Kh && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), delete this._resizeObject.onload);
    }
  },
  mounted: function() {
    var e = this;
    r_(), this.$nextTick(function() {
      e._w = e.$el.offsetWidth, e._h = e.$el.offsetHeight;
    });
    var n = document.createElement("object");
    this._resizeObject = n, n.setAttribute("aria-hidden", "true"), n.setAttribute("tabindex", -1), n.onload = this.addResizeHandlers, n.type = "text/html", Kh && this.$el.appendChild(n), n.data = "about:blank", Kh || this.$el.appendChild(n);
  },
  beforeDestroy: function() {
    this.removeResizeHandlers();
  }
};
function gvt(t) {
  t.component("resize-observer", i_), t.component("ResizeObserver", i_);
}
var vvt = {
  // eslint-disable-next-line no-undef
  version: "0.4.5",
  install: gvt
}, pp = null;
typeof window != "undefined" ? pp = window.Vue : typeof global != "undefined" && (pp = global.Vue);
pp && pp.use(vvt);
function Xh(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xh = function(e) {
    return typeof e;
  } : Xh = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xh(t);
}
function _vt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function M7(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function bvt(t, e, n) {
  return e && M7(t.prototype, e), n && M7(t, n), t;
}
function k7(t) {
  return yvt(t) || wvt(t) || xvt();
}
function yvt(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = new Array(t.length); e < t.length; e++)
      n[e] = t[e];
    return n;
  }
}
function wvt(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]")
    return Array.from(t);
}
function xvt() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function Cvt(t) {
  var e;
  return typeof t == "function" ? e = {
    callback: t
  } : e = t, e;
}
function $vt(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, i, a, o = function(l) {
    for (var c = arguments.length, h = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
      h[d - 1] = arguments[d];
    if (a = h, !(r && l === i)) {
      var p = n.leading;
      typeof p == "function" && (p = p(l, i)), (!r || l !== i) && p && t.apply(void 0, [l].concat(k7(a))), i = l, clearTimeout(r), r = setTimeout(function() {
        t.apply(void 0, [l].concat(k7(a))), r = 0;
      }, e);
    }
  };
  return o._clear = function() {
    clearTimeout(r), r = null;
  }, o;
}
function WE(t, e) {
  if (t === e)
    return !0;
  if (Xh(t) === "object") {
    for (var n in t)
      if (!WE(t[n], e[n]))
        return !1;
    return !0;
  }
  return !1;
}
var Tvt = /* @__PURE__ */ function() {
  function t(e, n, r) {
    _vt(this, t), this.el = e, this.observer = null, this.frozen = !1, this.createObserver(n, r);
  }
  return bvt(t, [{
    key: "createObserver",
    value: function(n, r) {
      var i = this;
      if (this.observer && this.destroyObserver(), !this.frozen) {
        if (this.options = Cvt(n), this.callback = function(s, l) {
          i.options.callback(s, l), s && i.options.once && (i.frozen = !0, i.destroyObserver());
        }, this.callback && this.options.throttle) {
          var a = this.options.throttleOptions || {}, o = a.leading;
          this.callback = $vt(this.callback, this.options.throttle, {
            leading: function(l) {
              return o === "both" || o === "visible" && l || o === "hidden" && !l;
            }
          });
        }
        this.oldResult = void 0, this.observer = new IntersectionObserver(function(s) {
          var l = s[0];
          if (s.length > 1) {
            var c = s.find(function(d) {
              return d.isIntersecting;
            });
            c && (l = c);
          }
          if (i.callback) {
            var h = l.isIntersecting && l.intersectionRatio >= i.threshold;
            if (h === i.oldResult)
              return;
            i.oldResult = h, i.callback(h, l);
          }
        }, this.options.intersection), r.context.$nextTick(function() {
          i.observer && i.observer.observe(i.el);
        });
      }
    }
  }, {
    key: "destroyObserver",
    value: function() {
      this.observer && (this.observer.disconnect(), this.observer = null), this.callback && this.callback._clear && (this.callback._clear(), this.callback = null);
    }
  }, {
    key: "threshold",
    get: function() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]), t;
}();
function UE(t, e, n) {
  var r = e.value;
  if (r)
    if (typeof IntersectionObserver == "undefined")
      console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
    else {
      var i = new Tvt(t, r, n);
      t._vue_visibilityState = i;
    }
}
function Ovt(t, e, n) {
  var r = e.value, i = e.oldValue;
  if (!WE(r, i)) {
    var a = t._vue_visibilityState;
    if (!r) {
      YE(t);
      return;
    }
    a ? a.createObserver(r, n) : UE(t, {
      value: r
    }, n);
  }
}
function YE(t) {
  var e = t._vue_visibilityState;
  e && (e.destroyObserver(), delete t._vue_visibilityState);
}
var qE = {
  bind: UE,
  update: Ovt,
  unbind: YE
};
function Svt(t) {
  t.directive("observe-visibility", qE);
}
var Evt = {
  // eslint-disable-next-line no-undef
  version: "0.4.6",
  install: Svt
}, mp = null;
typeof window != "undefined" ? mp = window.Vue : typeof global != "undefined" && (mp = global.Vue);
mp && mp.use(Evt);
var a_ = {}, Avt = {
  get exports() {
    return a_;
  },
  set exports(t) {
    a_ = t;
  }
};
(function(t) {
  (function(e, n) {
    t.exports ? t.exports = n() : e.Scrollparent = n();
  })(Fn, function() {
    var e = /(auto|scroll)/, n = function(s, l) {
      return s.parentNode === null ? l : n(s.parentNode, l.concat([s]));
    }, r = function(s, l) {
      return getComputedStyle(s, null).getPropertyValue(l);
    }, i = function(s) {
      return r(s, "overflow") + r(s, "overflow-y") + r(s, "overflow-x");
    }, a = function(s) {
      return e.test(i(s));
    }, o = function(s) {
      if (s instanceof HTMLElement || s instanceof SVGElement) {
        for (var l = n(s.parentNode, []), c = 0; c < l.length; c += 1)
          if (a(l[c]))
            return l[c];
        return document.scrollingElement || document.documentElement;
      }
    };
    return o;
  });
})(Avt);
const N7 = a_;
var GE = {
  itemsLimit: 1e3
};
const KE = {
  items: {
    type: Array,
    required: !0
  },
  keyField: {
    type: String,
    default: "id"
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (t) => ["vertical", "horizontal"].includes(t)
  },
  listTag: {
    type: String,
    default: "div"
  },
  itemTag: {
    type: String,
    default: "div"
  }
};
function XE() {
  return this.items.length && typeof this.items[0] != "object";
}
let o_ = !1;
if (typeof window != "undefined") {
  o_ = !1;
  try {
    var Pvt = Object.defineProperty({}, "passive", {
      get() {
        o_ = !0;
      }
    });
    window.addEventListener("test", null, Pvt);
  } catch (t) {
  }
}
let Mvt = 0;
var kvt = {
  name: "RecycleScroller",
  components: {
    ResizeObserver: i_
  },
  directives: {
    ObserveVisibility: qE
  },
  props: el(qr({}, KE), {
    itemSize: {
      type: Number,
      default: null
    },
    gridItems: {
      type: Number,
      default: void 0
    },
    itemSecondarySize: {
      type: Number,
      default: void 0
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: "size"
    },
    typeField: {
      type: String,
      default: "type"
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: !1
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: !1
    },
    skipHover: {
      type: Boolean,
      default: !1
    },
    listTag: {
      type: String,
      default: "div"
    },
    itemTag: {
      type: String,
      default: "div"
    },
    listClass: {
      type: [String, Object, Array],
      default: ""
    },
    itemClass: {
      type: [String, Object, Array],
      default: ""
    }
  }),
  data() {
    return {
      pool: [],
      totalSize: 0,
      ready: !1,
      hoverKey: null
    };
  },
  computed: {
    sizes() {
      if (this.itemSize === null) {
        const t = {
          "-1": {
            accumulator: 0
          }
        }, e = this.items, n = this.sizeField, r = this.minItemSize;
        let i = 1e4, a = 0, o;
        for (let s = 0, l = e.length; s < l; s++)
          o = e[s][n] || r, o < i && (i = o), a += o, t[s] = {
            accumulator: a,
            size: o
          };
        return this.$_computedMinItemSize = i, t;
      }
      return [];
    },
    simpleArray: XE
  },
  watch: {
    items() {
      this.updateVisibleItems(!0);
    },
    pageMode() {
      this.applyPageMode(), this.updateVisibleItems(!1);
    },
    sizes: {
      handler() {
        this.updateVisibleItems(!1);
      },
      deep: !0
    },
    gridItems() {
      this.updateVisibleItems(!0);
    },
    itemSecondarySize() {
      this.updateVisibleItems(!0);
    }
  },
  created() {
    this.$_startIndex = 0, this.$_endIndex = 0, this.$_views = /* @__PURE__ */ new Map(), this.$_unusedViews = /* @__PURE__ */ new Map(), this.$_scrollDirty = !1, this.$_lastUpdateScrollPosition = 0, this.prerender && (this.$_prerender = !0, this.updateVisibleItems(!1)), this.gridItems && !this.itemSize && console.error("[vue-recycle-scroller] You must provide an itemSize when using gridItems");
  },
  mounted() {
    this.applyPageMode(), this.$nextTick(() => {
      this.$_prerender = !1, this.updateVisibleItems(!0), this.ready = !0;
    });
  },
  activated() {
    const t = this.$_lastUpdateScrollPosition;
    typeof t == "number" && this.$nextTick(() => {
      this.scrollToPosition(t);
    });
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    addView(t, e, n, r, i) {
      const a = {
        item: n,
        position: 0
      }, o = {
        id: Mvt++,
        index: e,
        used: !0,
        key: r,
        type: i
      };
      return Object.defineProperty(a, "nr", {
        configurable: !1,
        value: o
      }), t.push(a), a;
    },
    unuseView(t, e = !1) {
      const n = this.$_unusedViews, r = t.nr.type;
      let i = n.get(r);
      i || (i = [], n.set(r, i)), i.push(t), e || (t.nr.used = !1, t.position = -9999, this.$_views.delete(t.nr.key));
    },
    handleResize() {
      this.$emit("resize"), this.ready && this.updateVisibleItems(!1);
    },
    handleScroll(t) {
      this.$_scrollDirty || (this.$_scrollDirty = !0, requestAnimationFrame(() => {
        this.$_scrollDirty = !1;
        const {
          continuous: e
        } = this.updateVisibleItems(!1, !0);
        e || (clearTimeout(this.$_refreshTimout), this.$_refreshTimout = setTimeout(this.handleScroll, 100));
      }));
    },
    handleVisibilityChange(t, e) {
      this.ready && (t || e.boundingClientRect.width !== 0 || e.boundingClientRect.height !== 0 ? (this.$emit("visible"), requestAnimationFrame(() => {
        this.updateVisibleItems(!1);
      })) : this.$emit("hidden"));
    },
    updateVisibleItems(t, e = !1) {
      const n = this.itemSize, r = this.gridItems || 1, i = this.itemSecondarySize || n, a = this.$_computedMinItemSize, o = this.typeField, s = this.simpleArray ? null : this.keyField, l = this.items, c = l.length, h = this.sizes, d = this.$_views, p = this.$_unusedViews, g = this.pool;
      let v, b, _, w, x;
      if (!c)
        v = b = w = x = _ = 0;
      else if (this.$_prerender)
        v = w = 0, b = x = Math.min(this.prerender, l.length), _ = null;
      else {
        const P = this.getScroll();
        if (e) {
          let V = P.start - this.$_lastUpdateScrollPosition;
          if (V < 0 && (V = -V), n === null && V < a || V < n)
            return {
              continuous: !0
            };
        }
        this.$_lastUpdateScrollPosition = P.start;
        const k = this.buffer;
        P.start -= k, P.end += k;
        let Y = 0;
        if (this.$refs.before && (Y = this.$refs.before.scrollHeight, P.start -= Y), this.$refs.after) {
          const V = this.$refs.after.scrollHeight;
          P.end += V;
        }
        if (n === null) {
          let V, I = 0, D = c - 1, z = ~~(c / 2), q;
          do
            q = z, V = h[z].accumulator, V < P.start ? I = z : z < c - 1 && h[z + 1].accumulator > P.start && (D = z), z = ~~((I + D) / 2);
          while (z !== q);
          for (z < 0 && (z = 0), v = z, _ = h[c - 1].accumulator, b = z; b < c && h[b].accumulator < P.end; b++)
            ;
          for (b === -1 ? b = l.length - 1 : (b++, b > c && (b = c)), w = v; w < c && Y + h[w].accumulator < P.start; w++)
            ;
          for (x = w; x < c && Y + h[x].accumulator < P.end; x++)
            ;
        } else {
          v = ~~(P.start / n * r);
          const V = v % r;
          v -= V, b = Math.ceil(P.end / n * r), w = Math.max(0, Math.floor((P.start - Y) / n * r)), x = Math.floor((P.end - Y) / n * r), v < 0 && (v = 0), b > c && (b = c), w < 0 && (w = 0), x > c && (x = c), _ = Math.ceil(c / r) * n;
        }
      }
      b - v > GE.itemsLimit && this.itemsLimitError(), this.totalSize = _;
      let C;
      const $ = v <= this.$_endIndex && b >= this.$_startIndex;
      if (this.$_continuous !== $) {
        if ($) {
          d.clear(), p.clear();
          for (let P = 0, k = g.length; P < k; P++)
            C = g[P], this.unuseView(C);
        }
        this.$_continuous = $;
      } else if ($)
        for (let P = 0, k = g.length; P < k; P++)
          C = g[P], C.nr.used && (t && (C.nr.index = l.indexOf(C.item)), (C.nr.index === -1 || C.nr.index < v || C.nr.index >= b) && this.unuseView(C));
      const E = $ ? null : /* @__PURE__ */ new Map();
      let A, R, L, W;
      for (let P = v; P < b; P++) {
        A = l[P];
        const k = s ? A[s] : A;
        if (k == null)
          throw new Error(`Key is ${k} on item (keyField is '${s}')`);
        if (C = d.get(k), !n && !h[P].size) {
          C && this.unuseView(C);
          continue;
        }
        C ? (C.nr.used = !0, C.item = A) : (P === l.length - 1 && this.$emit("scroll-end"), P === 0 && this.$emit("scroll-start"), R = A[o], L = p.get(R), $ ? L && L.length ? (C = L.pop(), C.item = A, C.nr.used = !0, C.nr.index = P, C.nr.key = k, C.nr.type = R) : C = this.addView(g, P, A, k, R) : (W = E.get(R) || 0, (!L || W >= L.length) && (C = this.addView(g, P, A, k, R), this.unuseView(C, !0), L = p.get(R)), C = L[W], C.item = A, C.nr.used = !0, C.nr.index = P, C.nr.key = k, C.nr.type = R, E.set(R, W + 1), W++), d.set(k, C)), n === null ? (C.position = h[P - 1].accumulator, C.offset = 0) : (C.position = Math.floor(P / r) * n, C.offset = P % r * i);
      }
      return this.$_startIndex = v, this.$_endIndex = b, this.emitUpdate && this.$emit("update", v, b, w, x), clearTimeout(this.$_sortTimer), this.$_sortTimer = setTimeout(this.sortViews, 300), {
        continuous: $
      };
    },
    getListenerTarget() {
      let t = N7(this.$el);
      return window.document && (t === window.document.documentElement || t === window.document.body) && (t = window), t;
    },
    getScroll() {
      const {
        $el: t,
        direction: e
      } = this, n = e === "vertical";
      let r;
      if (this.pageMode) {
        const i = t.getBoundingClientRect(), a = n ? i.height : i.width;
        let o = -(n ? i.top : i.left), s = n ? window.innerHeight : window.innerWidth;
        o < 0 && (s += o, o = 0), o + s > a && (s = a - o), r = {
          start: o,
          end: o + s
        };
      } else
        n ? r = {
          start: t.scrollTop,
          end: t.scrollTop + t.clientHeight
        } : r = {
          start: t.scrollLeft,
          end: t.scrollLeft + t.clientWidth
        };
      return r;
    },
    applyPageMode() {
      this.pageMode ? this.addListeners() : this.removeListeners();
    },
    addListeners() {
      this.listenerTarget = this.getListenerTarget(), this.listenerTarget.addEventListener("scroll", this.handleScroll, o_ ? {
        passive: !0
      } : !1), this.listenerTarget.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      this.listenerTarget && (this.listenerTarget.removeEventListener("scroll", this.handleScroll), this.listenerTarget.removeEventListener("resize", this.handleResize), this.listenerTarget = null);
    },
    scrollToItem(t) {
      let e;
      this.itemSize === null ? e = t > 0 ? this.sizes[t - 1].accumulator : 0 : e = Math.floor(t / this.gridItems) * this.itemSize, this.scrollToPosition(e);
    },
    scrollToPosition(t) {
      const e = this.direction === "vertical" ? {
        scroll: "scrollTop",
        start: "top"
      } : {
        scroll: "scrollLeft",
        start: "left"
      };
      let n, r, i;
      if (this.pageMode) {
        const a = N7(this.$el), o = a.tagName === "HTML" ? 0 : a[e.scroll], s = a.getBoundingClientRect(), c = this.$el.getBoundingClientRect()[e.start] - s[e.start];
        n = a, r = e.scroll, i = t + o + c;
      } else
        n = this.$el, r = e.scroll, i = t;
      n[r] = i;
    },
    itemsLimitError() {
      throw setTimeout(() => {
        console.log("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", this.$el), console.log("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
      }), new Error("Rendered items limit reached");
    },
    sortViews() {
      this.pool.sort((t, e) => t.nr.index - e.nr.index);
    }
  }
};
function Yb(t, e, n, r, i, a, o, s, l, c) {
  typeof o != "boolean" && (l = s, s = o, o = !1);
  const h = typeof n == "function" ? n.options : n;
  t && t.render && (h.render = t.render, h.staticRenderFns = t.staticRenderFns, h._compiled = !0, i && (h.functional = !0)), r && (h._scopeId = r);
  let d;
  if (a ? (d = function(p) {
    p = p || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !p && typeof __VUE_SSR_CONTEXT__ != "undefined" && (p = __VUE_SSR_CONTEXT__), e && e.call(this, l(p)), p && p._registeredComponents && p._registeredComponents.add(a);
  }, h._ssrRegister = d) : e && (d = o ? function(p) {
    e.call(this, c(p, this.$root.$options.shadowRoot));
  } : function(p) {
    e.call(this, s(p));
  }), d)
    if (h.functional) {
      const p = h.render;
      h.render = function(v, b) {
        return d.call(b), p(v, b);
      };
    } else {
      const p = h.beforeCreate;
      h.beforeCreate = p ? [].concat(p, d) : [d];
    }
  return n;
}
const Nvt = kvt;
var ZE = function() {
  var t, e, n = this, r = n.$createElement, i = n._self._c || r;
  return i(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: n.handleVisibilityChange,
          expression: "handleVisibilityChange"
        }
      ],
      staticClass: "vue-recycle-scroller",
      class: (t = {
        ready: n.ready,
        "page-mode": n.pageMode
      }, t["direction-" + n.direction] = !0, t),
      on: {
        "&scroll": function(a) {
          return n.handleScroll.apply(null, arguments);
        }
      }
    },
    [
      n.$slots.before ? i(
        "div",
        { ref: "before", staticClass: "vue-recycle-scroller__slot" },
        [n._t("before")],
        2
      ) : n._e(),
      n._v(" "),
      i(
        n.listTag,
        {
          ref: "wrapper",
          tag: "component",
          staticClass: "vue-recycle-scroller__item-wrapper",
          class: n.listClass,
          style: (e = {}, e[n.direction === "vertical" ? "minHeight" : "minWidth"] = n.totalSize + "px", e)
        },
        [
          n._l(n.pool, function(a) {
            return i(
              n.itemTag,
              n._g(
                {
                  key: a.nr.id,
                  tag: "component",
                  staticClass: "vue-recycle-scroller__item-view",
                  class: [
                    n.itemClass,
                    {
                      hover: !n.skipHover && n.hoverKey === a.nr.key
                    }
                  ],
                  style: n.ready ? {
                    transform: "translate" + (n.direction === "vertical" ? "Y" : "X") + "(" + a.position + "px) translate" + (n.direction === "vertical" ? "X" : "Y") + "(" + a.offset + "px)",
                    width: n.gridItems ? (n.direction === "vertical" && n.itemSecondarySize || n.itemSize) + "px" : void 0,
                    height: n.gridItems ? (n.direction === "horizontal" && n.itemSecondarySize || n.itemSize) + "px" : void 0
                  } : null
                },
                n.skipHover ? {} : {
                  mouseenter: function() {
                    n.hoverKey = a.nr.key;
                  },
                  mouseleave: function() {
                    n.hoverKey = null;
                  }
                }
              ),
              [
                n._t("default", null, {
                  item: a.item,
                  index: a.nr.index,
                  active: a.nr.used
                })
              ],
              2
            );
          }),
          n._v(" "),
          n._t("empty")
        ],
        2
      ),
      n._v(" "),
      n.$slots.after ? i(
        "div",
        { ref: "after", staticClass: "vue-recycle-scroller__slot" },
        [n._t("after")],
        2
      ) : n._e(),
      n._v(" "),
      i("ResizeObserver", { on: { notify: n.handleResize } })
    ],
    1
  );
}, Ivt = [];
ZE._withStripped = !0;
const Rvt = void 0, Lvt = void 0, Dvt = void 0, Fvt = !1, gp = /* @__PURE__ */ Yb(
  { render: ZE, staticRenderFns: Ivt },
  Rvt,
  Nvt,
  Lvt,
  Fvt,
  Dvt,
  !1,
  void 0,
  void 0,
  void 0
);
var zvt = {
  name: "DynamicScroller",
  components: {
    RecycleScroller: gp
  },
  provide() {
    return typeof ResizeObserver != "undefined" && (this.$_resizeObserver = new ResizeObserver((t) => {
      requestAnimationFrame(() => {
        if (Array.isArray(t)) {
          for (const e of t)
            if (e.target) {
              const n = new CustomEvent("resize", {
                detail: {
                  contentRect: e.contentRect
                }
              });
              e.target.dispatchEvent(n);
            }
        }
      });
    })), {
      vscrollData: this.vscrollData,
      vscrollParent: this,
      vscrollResizeObserver: this.$_resizeObserver
    };
  },
  inheritAttrs: !1,
  props: el(qr({}, KE), {
    minItemSize: {
      type: [Number, String],
      required: !0
    }
  }),
  data() {
    return {
      vscrollData: {
        active: !0,
        sizes: {},
        validSizes: {},
        keyField: this.keyField,
        simpleArray: !1
      }
    };
  },
  computed: {
    simpleArray: XE,
    itemsWithSize() {
      const t = [], {
        items: e,
        keyField: n,
        simpleArray: r
      } = this, i = this.vscrollData.sizes, a = e.length;
      for (let o = 0; o < a; o++) {
        const s = e[o], l = r ? o : s[n];
        let c = i[l];
        typeof c == "undefined" && !this.$_undefinedMap[l] && (c = 0), t.push({
          item: s,
          id: l,
          size: c
        });
      }
      return t;
    },
    listeners() {
      const t = {};
      for (const e in this.$listeners)
        e !== "resize" && e !== "visible" && (t[e] = this.$listeners[e]);
      return t;
    }
  },
  watch: {
    items() {
      this.forceUpdate(!1);
    },
    simpleArray: {
      handler(t) {
        this.vscrollData.simpleArray = t;
      },
      immediate: !0
    },
    direction(t) {
      this.forceUpdate(!0);
    },
    itemsWithSize(t, e) {
      const n = this.$el.scrollTop;
      let r = 0, i = 0;
      const a = Math.min(t.length, e.length);
      for (let s = 0; s < a && !(r >= n); s++)
        r += e[s].size || this.minItemSize, i += t[s].size || this.minItemSize;
      const o = i - r;
      o !== 0 && (this.$el.scrollTop += o);
    }
  },
  beforeCreate() {
    this.$_updates = [], this.$_undefinedSizes = 0, this.$_undefinedMap = {};
  },
  activated() {
    this.vscrollData.active = !0;
  },
  deactivated() {
    this.vscrollData.active = !1;
  },
  methods: {
    onScrollerResize() {
      this.$refs.scroller && this.forceUpdate(), this.$emit("resize");
    },
    onScrollerVisible() {
      this.$emit("vscroll:update", {
        force: !1
      }), this.$emit("visible");
    },
    forceUpdate(t = !0) {
      (t || this.simpleArray) && (this.vscrollData.validSizes = {}), this.$emit("vscroll:update", {
        force: !0
      });
    },
    scrollToItem(t) {
      const e = this.$refs.scroller;
      e && e.scrollToItem(t);
    },
    getItemSize(t, e = void 0) {
      const n = this.simpleArray ? e != null ? e : this.items.indexOf(t) : t[this.keyField];
      return this.vscrollData.sizes[n] || 0;
    },
    scrollToBottom() {
      if (this.$_scrollingToBottom)
        return;
      this.$_scrollingToBottom = !0;
      const t = this.$el;
      this.$nextTick(() => {
        t.scrollTop = t.scrollHeight + 5e3;
        const e = () => {
          t.scrollTop = t.scrollHeight + 5e3, requestAnimationFrame(() => {
            t.scrollTop = t.scrollHeight + 5e3, this.$_undefinedSizes === 0 ? this.$_scrollingToBottom = !1 : requestAnimationFrame(e);
          });
        };
        requestAnimationFrame(e);
      });
    }
  }
};
const Bvt = zvt;
var JE = function() {
  var t = this, e = t.$createElement, n = t._self._c || e;
  return n(
    "RecycleScroller",
    t._g(
      t._b(
        {
          ref: "scroller",
          attrs: {
            items: t.itemsWithSize,
            "min-item-size": t.minItemSize,
            direction: t.direction,
            "key-field": "id",
            "list-tag": t.listTag,
            "item-tag": t.itemTag
          },
          on: { resize: t.onScrollerResize, visible: t.onScrollerVisible },
          scopedSlots: t._u(
            [
              {
                key: "default",
                fn: function(r) {
                  var i = r.item, a = r.index, o = r.active;
                  return [
                    t._t("default", null, null, {
                      item: i.item,
                      index: a,
                      active: o,
                      itemWithSize: i
                    })
                  ];
                }
              }
            ],
            null,
            !0
          )
        },
        "RecycleScroller",
        t.$attrs,
        !1
      ),
      t.listeners
    ),
    [
      t._v(" "),
      n("template", { slot: "before" }, [t._t("before")], 2),
      t._v(" "),
      n("template", { slot: "after" }, [t._t("after")], 2),
      t._v(" "),
      n("template", { slot: "empty" }, [t._t("empty")], 2)
    ],
    2
  );
}, Hvt = [];
JE._withStripped = !0;
const jvt = void 0, Vvt = void 0, Wvt = void 0, Uvt = !1, I7 = /* @__PURE__ */ Yb(
  { render: JE, staticRenderFns: Hvt },
  jvt,
  Bvt,
  Vvt,
  Uvt,
  Wvt,
  !1,
  void 0,
  void 0,
  void 0
);
var Yvt = {
  name: "DynamicScrollerItem",
  inject: ["vscrollData", "vscrollParent", "vscrollResizeObserver"],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    item: {
      required: !0
    },
    watchData: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates if the view is actively used to display an item.
     */
    active: {
      type: Boolean,
      required: !0
    },
    index: {
      type: Number,
      default: void 0
    },
    sizeDependencies: {
      type: [Array, Object],
      default: null
    },
    emitResize: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    id() {
      if (this.vscrollData.simpleArray)
        return this.index;
      if (this.item.hasOwnProperty(this.vscrollData.keyField))
        return this.item[this.vscrollData.keyField];
      throw new Error(`keyField '${this.vscrollData.keyField}' not found in your item. You should set a valid keyField prop on your Scroller`);
    },
    size() {
      return this.vscrollData.validSizes[this.id] && this.vscrollData.sizes[this.id] || 0;
    },
    finalActive() {
      return this.active && this.vscrollData.active;
    }
  },
  watch: {
    watchData: "updateWatchData",
    id() {
      this.size || this.onDataUpdate();
    },
    finalActive(t) {
      this.size || (t ? this.vscrollParent.$_undefinedMap[this.id] || (this.vscrollParent.$_undefinedSizes++, this.vscrollParent.$_undefinedMap[this.id] = !0) : this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = !1)), this.vscrollResizeObserver ? t ? this.observeSize() : this.unobserveSize() : t && this.$_pendingVScrollUpdate === this.id && this.updateSize();
    }
  },
  created() {
    if (!this.$isServer && (this.$_forceNextVScrollUpdate = null, this.updateWatchData(), !this.vscrollResizeObserver)) {
      for (const t in this.sizeDependencies)
        this.$watch(() => this.sizeDependencies[t], this.onDataUpdate);
      this.vscrollParent.$on("vscroll:update", this.onVscrollUpdate), this.vscrollParent.$on("vscroll:update-size", this.onVscrollUpdateSize);
    }
  },
  mounted() {
    this.vscrollData.active && (this.updateSize(), this.observeSize());
  },
  beforeDestroy() {
    this.vscrollParent.$off("vscroll:update", this.onVscrollUpdate), this.vscrollParent.$off("vscroll:update-size", this.onVscrollUpdateSize), this.unobserveSize();
  },
  methods: {
    updateSize() {
      this.finalActive ? this.$_pendingSizeUpdate !== this.id && (this.$_pendingSizeUpdate = this.id, this.$_forceNextVScrollUpdate = null, this.$_pendingVScrollUpdate = null, this.computeSize(this.id)) : this.$_forceNextVScrollUpdate = this.id;
    },
    updateWatchData() {
      this.watchData && !this.vscrollResizeObserver ? this.$_watchData = this.$watch("item", () => {
        this.onDataUpdate();
      }, {
        deep: !0
      }) : this.$_watchData && (this.$_watchData(), this.$_watchData = null);
    },
    onVscrollUpdate({
      force: t
    }) {
      !this.finalActive && t && (this.$_pendingVScrollUpdate = this.id), (this.$_forceNextVScrollUpdate === this.id || t || !this.size) && this.updateSize();
    },
    onDataUpdate() {
      this.updateSize();
    },
    computeSize(t) {
      this.$nextTick(() => {
        if (this.id === t) {
          const e = this.$el.offsetWidth, n = this.$el.offsetHeight;
          this.applySize(e, n);
        }
        this.$_pendingSizeUpdate = null;
      });
    },
    applySize(t, e) {
      const n = ~~(this.vscrollParent.direction === "vertical" ? e : t);
      n && this.size !== n && (this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = void 0), this.$set(this.vscrollData.sizes, this.id, n), this.$set(this.vscrollData.validSizes, this.id, !0), this.emitResize && this.$emit("resize", this.id));
    },
    observeSize() {
      !this.vscrollResizeObserver || !this.$el.parentNode || (this.vscrollResizeObserver.observe(this.$el.parentNode), this.$el.parentNode.addEventListener("resize", this.onResize));
    },
    unobserveSize() {
      this.vscrollResizeObserver && (this.vscrollResizeObserver.unobserve(this.$el.parentNode), this.$el.parentNode.removeEventListener("resize", this.onResize));
    },
    onResize(t) {
      const {
        width: e,
        height: n
      } = t.detail.contentRect;
      this.applySize(e, n);
    }
  },
  render(t) {
    return t(this.tag, this.$slots.default);
  }
};
const qvt = Yvt, Gvt = void 0, Kvt = void 0, Xvt = void 0, Zvt = void 0, R7 = /* @__PURE__ */ Yb(
  {},
  Gvt,
  qvt,
  Kvt,
  Zvt,
  Xvt,
  !1,
  void 0,
  void 0,
  void 0
);
function Jvt(t, e) {
  t.component(`${e}recycle-scroller`, gp), t.component(`${e}RecycleScroller`, gp), t.component(`${e}dynamic-scroller`, I7), t.component(`${e}DynamicScroller`, I7), t.component(`${e}dynamic-scroller-item`, R7), t.component(`${e}DynamicScrollerItem`, R7);
}
const Qvt = {
  // eslint-disable-next-line no-undef
  version: "1.1.2",
  install(t, e) {
    const n = Object.assign({}, {
      installComponents: !0,
      componentsPrefix: ""
    }, e);
    for (const r in n)
      typeof n[r] != "undefined" && (GE[r] = n[r]);
    n.installComponents && Jvt(t, n.componentsPrefix);
  }
};
let vp = null;
typeof window != "undefined" ? vp = window.Vue : typeof global != "undefined" && (vp = global.Vue);
vp && vp.use(Qvt);
const t_t = 27, e_t = 38, n_t = 40, r_t = {
  name: "SelectableDropdown",
  components: {
    Fa: ar,
    RecycleScroller: gp
  },
  props: {
    /**
     * The items of the list.
     */
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * The actual selected item.
     */
    value: {
      type: [String, Object, Array, Number],
      default: null
    },
    /**
     * If true, the dropdown is hidden and deactivated.
     */
    hide: {
      type: Boolean
    },
    /**
     * If true, the key events won't be propagated.
     */
    propagate: {
      type: Boolean
    },
    /**
     * The user can select values.
     */
    multiple: {
      type: Boolean
    },
    /**
     * A function to change the label rendering.
     */
    serializer: {
      type: Function,
      default: rr
    },
    /**
     * The class to apply to the list.
     */
    listClass: {
      type: String,
      default: "dropdown-menu"
    },
    /**
     * The class to apply to each item.
     */
    itemClass: {
      type: String,
      default: "dropdown-item"
    },
    /**
     * Set to true to deactivate action when arrow keys are pressed
     */
    deactivateKeys: {
      type: Boolean
    },
    /**
     * Comparaison function to verify equality between selected items.
     */
    eq: {
      type: Function,
      default: xp
    },
    /**
     * Display height of the items in pixels used to calculate the scroll size and position
     * Default value is 32 (32px)
     */
    itemSize: {
      type: Number,
      default: 32
    },
    /**
     * Height of the scroll container to specify especially if using the virtual scroll feature
     * Default value is 'inherit'
     */
    scrollerHeight: {
      type: String,
      default: "inherit"
    }
  },
  data() {
    return {
      activeItems: []
    };
  },
  computed: {
    cssProps() {
      return {
        "--scroller-height": this.scrollerHeight
      };
    },
    keyField() {
      return typeof this.items_[0] == "string" ? null : "recycle_scroller_id";
    },
    items_() {
      return typeof this.items[0] == "string" ? this.items : this.items.map((t) => el(qr({}, t), { recycle_scroller_id: `id-${p_()}` }));
    },
    firstActiveItemIndex() {
      return this.activeItems.length ? this.items_.indexOf(this.activeItems[0]) : -1;
    },
    lastActiveItemIndex() {
      return this.activeItems.length ? this.items_.indexOf(this.activeItems.slice(-1)) : -1;
    },
    keysMap() {
      return {
        [e_t]: this.activatePreviousItem,
        [n_t]: this.activateNextItem,
        [t_t]: this.deactivateItems
      };
    }
  },
  watch: {
    hide() {
      this.toggleKeys();
    },
    activeItems() {
      this.$emit("input", this.multiple ? this.activeItems : this.activeItems[0]);
    },
    value(t) {
      const e = ev(t);
      lvt(this.activeItems, e) || this.activateItemOrItems(e);
    }
  },
  mounted() {
    this.activateItemOrItems(), this.toggleKeys();
  },
  destroyed() {
    this.unbindKeys();
  },
  methods: {
    indexIcon(t) {
      return this.itemActivated(t) ? fvt : dvt;
    },
    itemActivated(t) {
      return w$(this.activeItems, (e) => this.eq(t, e)) > -1;
    },
    clickToSelectItem(t) {
      this.$emit("click", t), this.multiple ? this.addItem(t) : this.selectItem(t);
    },
    clickToAddItem(t) {
      this.$emit("click", t), this.addItem(t);
    },
    clickToSelectRangeToItem(t) {
      this.$emit("click", t), this.selectRangeToItem(t);
    },
    emitEventOnItem(t, e) {
      this.$emit(t, e);
    },
    selectItem(t) {
      this.itemActivated(t) && this.activeItems.length === 1 ? this.activeItems = P7(this.activeItems, (e) => !this.eq(t, e)) : this.activeItems = [t];
    },
    addItem(t) {
      this.itemActivated(t) ? this.activeItems = P7(this.activeItems, (e) => !this.eq(t, e)) : this.activeItems.push(t);
    },
    selectRangeToItem(t) {
      if (!this.activeItems.length || !this.multiple)
        this.selectItem(t);
      else {
        const e = this.items_.indexOf(t);
        e > this.firstActiveItemIndex ? this.activeItems = this.items_.slice(this.firstActiveItemIndex, e + 1) : this.activeItems = this.items_.slice(e, this.firstActiveItemIndex + 1);
      }
    },
    activateItemOrItems(t = this.value) {
      const e = ev(t);
      this.activeItems = [...e];
    },
    activatePreviousItem() {
      this.activeItems = [this.items_[Math.max(this.firstActiveItemIndex - 1, -1)]];
    },
    activateNextItem() {
      this.activeItems = [this.items_[Math.min(this.firstActiveItemIndex + 1, this.items_.length - 1)]];
    },
    deactivateItems() {
      this.activeItems = [], this.$emit("deactivate");
    },
    keyDown(t) {
      const e = t.keyCode || t.which;
      this.deactivateKeys || this.hide || !this.isKnownKey(e) || (!this.propagate && t.stopPropagation && (t.stopPropagation(), t.preventDefault()), this.keysMap[e].call(this));
    },
    isKnownKey(t) {
      return Object.keys(this.keysMap).map(Number).indexOf(t) > -1;
    },
    unbindKeys() {
      window.removeEventListener("keydown", this.keyDown);
    },
    bindKeys() {
      window.addEventListener("keydown", this.keyDown);
    },
    toggleKeys() {
      this.hide ? this.unbindKeys() : this.bindKeys();
    }
  }
};
var i_t = function() {
  var e = this, n = e._self._c;
  return e.hide ? e._e() : n("div", { staticClass: "selectable-dropdown show", class: { "selectable-dropdown--multiple": e.multiple, [e.listClass]: !0 } }, [n("recycle-scroller", { staticClass: "scroller", style: e.cssProps, attrs: { items: e.items_, "key-field": e.keyField, "item-size": e.itemSize }, scopedSlots: e._u([{ key: "default", fn: function({ item: r, active: i }) {
    return [n("span", { staticClass: "selectable-dropdown__item px-3 d-flex", class: { "recycle_scroller-item--active": i, active: e.itemActivated(r), [e.itemClass]: !0 }, on: { click: [function(a) {
      return a.ctrlKey || a.shiftKey || a.altKey || a.metaKey ? null : e.clickToSelectItem(r);
    }, function(a) {
      return a.ctrlKey ? e.clickToAddItem(r) : null;
    }, function(a) {
      return a.shiftKey ? e.clickToSelectRangeToItem(r) : null;
    }] } }, [e._t("item", function() {
      return [e.multiple ? n("div", { staticClass: "selectable-dropdown__item__check" }, [n("fa", { staticClass: "mr-2", attrs: { icon: e.indexIcon(r) } })], 1) : e._e(), n("div", { staticClass: "flex-grow-1 text-truncate selectable-dropdown__item__label" }, [e._t("item-label", function() {
        return [e._v(" " + e._s(e.serializer(r)) + " ")];
      }, { item: r })], 2)];
    }, { item: r })], 2)];
  } }], null, !0) })], 1);
}, a_t = [], o_t = /* @__PURE__ */ Bt(
  r_t,
  i_t,
  a_t,
  !1,
  null,
  null,
  null,
  null
);
const s_t = o_t.exports;
const u_t = {
  name: "SecretInput",
  components: { Fa: ar, HapticCopy: Jp },
  model: {
    prop: "visible",
    event: "input"
  },
  props: {
    /**
     * If true the value is visible by default
     */
    visible: {
      type: Boolean
    },
    /**
     * Value of the input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * Size of the input form
     */
    size: {
      type: String,
      default: "md"
    },
    /**
     * Bootstrap variant of the haptic copy button
     */
    hapticCopyVariant: {
      type: String,
      default: "primary"
    },
    /**
     * Hide toggler button
     */
    noToggler: {
      type: Boolean
    },
    /**
     * Hide haptic copy button
     */
    noHapticCopy: {
      type: Boolean
    }
  },
  data() {
    return {
      isVisible: this.visible
    };
  },
  computed: {
    inputType() {
      return this.isVisible ? "text" : "password";
    },
    togglerIcon() {
      return this.isVisible ? ["far", "eye-slash"] : ["far", "eye"];
    },
    hapticCopyClassList() {
      return `btn-${this.hapticCopyVariant}`;
    }
  },
  watch: {
    visible(t) {
      this.isVisible = t;
    }
  },
  beforeMount() {
    Br.add(pvt, hvt);
  },
  methods: {
    toggle() {
      this.isVisible = !this.isVisible, this.$emit("input", this.isVisible);
    },
    selectInput() {
      this.isVisible && this.$el.querySelector(".secret-input__input").select();
    }
  }
};
var l_t = function() {
  var e = this, n = e._self._c;
  return n("b-input-group", { staticClass: "secret-input", attrs: { size: e.size } }, [e.noToggler ? e._e() : n("b-input-group-prepend", [n("b-button", { staticClass: "secret-input__toggler", attrs: { variant: "link" }, on: { click: e.toggle } }, [n("fa", { attrs: { "fixed-width": "", icon: e.togglerIcon } })], 1)], 1), n("b-form-input", { staticClass: "text-monospace secret-input__input", attrs: { readonly: "", type: e.inputType, value: e.value }, on: { click: e.selectInput } }), e.noHapticCopy ? e._e() : n("b-input-group-append", [n("haptic-copy", { staticClass: "secret-input__copy", class: e.hapticCopyClassList, attrs: { "hide-label": "", text: e.value }, on: { success: e.selectInput, error: e.selectInput } })], 1)], 1);
}, c_t = [], f_t = /* @__PURE__ */ Bt(
  u_t,
  l_t,
  c_t,
  !1,
  null,
  "11331786",
  null,
  null
);
const h_t = f_t.exports, Cs = {
  PRE: "pre",
  ACTIVE: "active",
  POST: "post"
}, d_t = te({
  name: "SlideUpDown",
  props: {
    /**
     * Toggler property. Set to <em>false</em> to hide the component.
     */
    active: {
      type: Boolean,
      default: !1
    },
    /**
     * Duration of the animation.
     */
    duration: {
      type: Number,
      default: 200
    },
    /**
     * HTML tag to render this component to.
     */
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      state: Cs.POST,
      mounted: !1,
      scrollHeight: 0
    };
  },
  computed: {
    stylePreTransition() {
      return {
        overflow: "hidden",
        "transition-property": "height",
        "transition-duration": `${this.duration}ms`,
        height: this.mounted ? `${this.containerScrollHeight}px` : 0
      };
    },
    styleActiveTransition() {
      return {
        overflow: "hidden",
        "transition-property": "height",
        "transition-duration": `${this.duration}ms`,
        height: this.mounted ? `${this.activeHeight}px` : "auto"
      };
    },
    stylePostTransition() {
      return this.active ? {} : this.styleActiveTransition;
    },
    style() {
      switch (this.state) {
        case Cs.PRE:
          return this.stylePreTransition;
        case Cs.ACTIVE:
          return this.styleActiveTransition;
        default:
          return this.stylePostTransition;
      }
    },
    activeHeight() {
      return this.active ? this.containerScrollHeight : 0;
    },
    containerScrollHeight() {
      var t, e;
      return (e = (t = this.$container) == null ? void 0 : t.scrollHeight) != null ? e : 0;
    },
    $container() {
      return this.$refs.container;
    }
  },
  watch: {
    active() {
      return this.triggerSlide();
    }
  },
  mounted() {
    return _e(this, null, function* () {
      var t;
      yield this.deferredNextTick(), this.mounted = !0, yield this.cleanLayout(null), (t = this.$container) == null || t.addEventListener("transitionend", (e) => this.cleanLayout(e));
    });
  },
  methods: {
    triggerSlide() {
      return _e(this, null, function* () {
        this.state = Cs.PRE, this.scrollHeight = this.containerScrollHeight, yield this.deferredNextTick(), this.state = Cs.ACTIVE;
      });
    },
    cleanLayout(t) {
      if (!t || t.target === this.$container)
        return this.state = Cs.POST, this.deferredNextTick();
    },
    deferredNextTick() {
      return _e(this, null, function* () {
        yield new Promise((t) => setTimeout(t, 0)), yield this.$nextTick();
      });
    }
  }
});
var p_t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n(e.tag, { ref: "container", tag: "component", style: e.style }, [e._t("default")], 2);
}, m_t = [], g_t = /* @__PURE__ */ Bt(
  d_t,
  p_t,
  m_t,
  !1,
  null,
  null,
  null,
  null
);
const v_t = g_t.exports, __t = te({
  name: "TexturedDeck",
  props: {
    /**
     * Name of the texture file ('silk', 'brick', 'rock', 'sand', 'crack', 'carbon')
     */
    value: {
      type: String,
      default: G0.Brick
    },
    /**
     * CSS background-size property (cover, contain, auto, 50%, 50% auto, ...)
     */
    size: {
      type: String,
      default: "cover"
    },
    /**
     * Tag/Component to use as root tag.
     */
    tag: {
      type: [String, Object],
      default: "div"
    },
    /**
     * Etheir or note we should use the black version of the texture
     */
    black: {
      type: Boolean
    },
    /**
     * Host where to find the textures (without tailing slash)
     */
    backgroundBaseUrl: {
      type: String,
      default: () => he.get("textured-deck.background-base-url", window.location.origin)
    }
  },
  computed: {
    names() {
      return Object.values(G0);
    },
    textureIndex() {
      return typeof this.value != "number" ? ct.clamp(this.names.indexOf(this.value), 0, this.names.length - 1) : this.value;
    },
    textureName() {
      return this.names[this.textureIndex];
    },
    filename() {
      return this.black ? `texture-${this.textureName}-black.jpg` : `texture-${this.textureName}.jpg`;
    },
    backgroundUrl() {
      return `${this.backgroundBaseUrl}/assets/img/${this.filename}`;
    },
    backgroundSize() {
      return this.size;
    },
    backgroundImage() {
      return `url("${this.backgroundUrl}")`;
    },
    inheritedProps() {
      return el(qr(qr({}, this.$attrs), this.$props), { tag: void 0 });
    }
  }
});
var b_t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n(e.tag, e._b({ tag: "component", staticClass: "textured-deck", style: { backgroundSize: e.backgroundSize, backgroundImage: e.backgroundImage } }, "component", e.inheritedProps, !1), [e._t("default")], 2);
}, y_t = [], w_t = /* @__PURE__ */ Bt(
  __t,
  b_t,
  y_t,
  !1,
  null,
  "56bd1adb",
  null,
  null
);
const x_t = w_t.exports;
var C_t = {
  prefix: "fas",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]
}, $_t = {
  prefix: "fas",
  iconName: "angle-left",
  icon: [320, 512, [8249], "f104", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
const T_t = te({
  i18n: Hn,
  name: "TinyPagination",
  components: {
    BButton: C0,
    BFormInput: qx,
    Fa: ar
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    /**
     * Total items to be stored in pages
     */
    totalRows: {
      type: Number,
      default: 0
    },
    /**
     * Sets the quantity of items per page
     */
    perPage: {
      type: Number,
      default: 20
    },
    /**
     * Grabs and syncs the currentPage variable passed down from the parent in v-model
     */
    value: {
      type: [Number, String],
      default: 1
    },
    /**
     * Set the size of the input: 'sm', 'md' (default), or 'lg'.
     */
    size: {
      type: String,
      default: va.md,
      validator: (t) => Object.values(va).includes(t)
    },
    /**
     * (Optional) Number of page. Propety `size` is required for this to work
     * properly. If `pages` is empty, it will be calculated using the size.
     */
    pages: {
      type: [Number, String],
      default: null
    },
    /**
     * Hide navigation buttons (next and previous)
     */
    noNav: {
      type: Boolean
    },
    /**
     * FontAwesome icon of the previous page button
     */
    previousPageIcon: {
      type: [String, Array, Object],
      default: "angle-left"
    },
    /**
     * FontAwesome icon of the next page button
     */
    nextPageIcon: {
      type: [String, Array, Object],
      default: "angle-right"
    },
    /**
     * Navigation button variants
     */
    navVariant: {
      type: String,
      default: "link"
    },
    /**
     * Display pagination as a block (full width)
     */
    block: {
      type: Boolean
    },
    /**
     * Compact mode with a grouped nav
     */
    compact: {
      type: Boolean
    }
  },
  data() {
    return {
      currentPageInput: +this.value
    };
  },
  computed: {
    numberOfPages() {
      return this.pages === null ? Math.ceil(this.totalRows / this.perPage) : Number(this.pages);
    },
    paginationClassList() {
      return {
        [`tiny-pagination--${this.size}`]: !0,
        ["tiny-pagination--no-nav"]: this.noNav,
        ["tiny-pagination--block"]: this.block,
        ["tiny-pagination--compact"]: this.compact
      };
    },
    hasPrevious() {
      return +this.value > 1;
    },
    hasNext() {
      return +this.value < this.numberOfPages;
    }
  },
  watch: {
    value(t) {
      this.currentPageInput = +t;
    }
  },
  beforeMount() {
    Br.add($_t, C_t);
  },
  methods: {
    applyPageForm() {
      isNaN(this.currentPageInput) || this.$emit("input", this.currentPageInput);
    },
    applyPreviousPage() {
      this.$emit("input", +this.value - 1);
    },
    applyNextPage() {
      this.$emit("input", +this.value + 1);
    }
  }
});
var O_t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "tiny-pagination", class: e.paginationClassList }, [n("b-button", { staticClass: "tiny-pagination__nav", attrs: { size: e.size, disabled: !e.hasPrevious, variant: e.navVariant }, on: { click: e.applyPreviousPage } }, [e._t("previous", function() {
    return [n("fa", { attrs: { icon: e.previousPageIcon } }), n("span", { staticClass: "sr-only" }, [e._v(e._s(e.$tc("tiny-pagination.previous")))])];
  }, null, { value: e.value, numberOfPages: e.numberOfPages, hasPrevious: e.hasPrevious, hasNext: e.hasNext })], 2), n("form", { staticClass: "tiny-pagination__form form-inline", on: { submit: function(r) {
    return r.preventDefault(), e.applyPageForm.apply(null, arguments);
  } } }, [n("label", { directives: [{ name: "show", rawName: "v-show", value: !e.compact, expression: "!compact" }], staticClass: "tiny-pagination__form__label mr-1 mb-0" }, [e._t("page", function() {
    return [e._v(" " + e._s(e.$t("tiny-pagination.page")) + " ")];
  }, null, { value: e.value, numberOfPages: e.numberOfPages })], 2), n("b-form-input", { staticClass: "tiny-pagination__form__input mr-1", attrs: { size: e.size, type: "number", step: "1", min: 1, max: e.numberOfPages, "aria-label": e.$tc("tiny-pagination.aria") }, model: { value: e.currentPageInput, callback: function(r) {
    e.currentPageInput = r;
  }, expression: "currentPageInput" } }), e._t("number-of-pages", function() {
    return [e._v(" " + e._s(e.$tc("tiny-pagination.total", e.numberOfPages, { numberOfPages: e.numberOfPages })) + " ")];
  }, null, { value: e.value, numberOfPages: e.numberOfPages })], 2), n("b-button", { staticClass: "tiny-pagination__nav", attrs: { size: e.size, disabled: !e.hasNext, variant: e.navVariant }, on: { click: e.applyNextPage } }, [e._t("next", function() {
    return [n("fa", { attrs: { icon: e.nextPageIcon } }), n("span", { staticClass: "sr-only" }, [e._v(e._s(e.$tc("tiny-pagination.next")))])];
  }, null, { value: e.value, numberOfPages: e.numberOfPages, hasPrevious: e.hasPrevious, hasNext: e.hasNext })], 2)], 1);
}, S_t = [], E_t = /* @__PURE__ */ Bt(
  T_t,
  O_t,
  S_t,
  !1,
  null,
  "e2d5979a",
  null,
  null
);
const A_t = E_t.exports, u0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccordionStep: ZD,
  AccordionWrapper: YD,
  ActiveTextTruncate: LH,
  AdvancedLinkForm: VG,
  Brand: BC,
  BrandExpansion: Q_,
  ConfirmButton: rK,
  ContentPlaceholder: mZ,
  CustomPagination: yZ,
  DigitsInput: TZ,
  DonateForm: lnt,
  EmbedForm: d$,
  EmbeddableFooter: nrt,
  Fa: ar,
  FollowUsPopover: c2,
  GenericFooter: Nrt,
  GenericHeader: zrt,
  HapticCopy: Jp,
  ImddbHeader: Sit,
  OrdinalLegend: HE,
  RangePicker: j0t,
  ResponsiveIframe: G0t,
  ScaleLegend: VE,
  SecretInput: h_t,
  SelectableDropdown: s_t,
  SharingOptions: g$,
  SharingOptionsLink: m$,
  SignUpForm: v$,
  SlideUpDown: v_t,
  TexturedDeck: x_t,
  TinyPagination: A_t
}, Symbol.toStringTag, { value: "Module" }));
var P_t = vu, M_t = Ue, k_t = Do, N_t = "[object String]";
function I_t(t) {
  return typeof t == "string" || !M_t(t) && k_t(t) && P_t(t) == N_t;
}
var R_t = I_t;
const l0 = R_t;
var L_t = _u;
function D_t(t, e, n) {
  for (var r = -1, i = t.length; ++r < i; ) {
    var a = t[r], o = e(a);
    if (o != null && (s === void 0 ? o === o && !L_t(o) : n(o, s)))
      var s = o, l = a;
  }
  return l;
}
var F_t = D_t;
function z_t(t, e) {
  return t > e;
}
var B_t = z_t, H_t = F_t, j_t = B_t, V_t = rr;
function W_t(t) {
  return t && t.length ? H_t(t, V_t, j_t) : void 0;
}
var U_t = W_t;
const L7 = U_t;
var Y_t = Pu;
function q_t(t, e) {
  var n;
  return Y_t(t, function(r, i, a) {
    return n = e(r, i, a), !n;
  }), !!n;
}
var G_t = q_t, K_t = GC, X_t = Da, Z_t = G_t, J_t = Ue, Q_t = o2;
function t2t(t, e, n) {
  var r = J_t(t) ? K_t : Z_t;
  return n && Q_t(t, e, n) && (e = void 0), r(t, X_t(e));
}
var e2t = t2t;
const n2t = e2t;
function r2t(t) {
  try {
    new URL(t);
  } catch (e) {
    return !1;
  }
  return !0;
}
const Go = {
  props: {
    /**
     * A data collection for the chart. Can be a data object or an URL.
     */
    data: {
      type: [Array, String, Object],
      default: () => [],
      validator(t) {
        return bu(t) || l0(t) && r2t(t);
      }
    },
    /**
     * Format of the data to load.
     */
    dataUrlType: {
      type: String,
      default: "json",
      validator(t) {
        return ["json", "csv", "tsv"].indexOf(t) > -1;
      }
    },
    /**
     * When applicable, default chart's height ratio
     */
    chartHeightRatio: {
      type: Number
    },
    /**
     * If true, the chart will be display on social mode
     */
    socialMode: {
      type: Boolean
    },
    /**
     * Ratio to use in social mode
     */
    socialModeRatio: {
      type: Number,
      default: 5 / 4
    }
  },
  resizeObserver: null,
  mounted() {
    return _e(this, null, function* () {
      var t;
      yield document.fonts.ready, this.$options.resizeObserver = new m_(this.resized), yield this.loadData(), yield this.$nextTick(), (t = this.$options.resizeObserver) == null || t.observe(this.$el), this.mounted = !0;
    });
  },
  beforeDestroy() {
    var t;
    (t = this.$options.resizeObserver) == null || t.unobserve(this.$el), this.$options.resizeObserver = null;
  },
  data() {
    return {
      narrowWidth: !1,
      mounted: !1,
      loadedData: null
    };
  },
  watch: {
    data() {
      return this.loadData();
    }
  },
  filters: {
    d3Formatter(t, e) {
      return yp(e) ? e(t) : l0(e) ? Uo(e)(t) : t;
    }
  },
  methods: {
    resized() {
      this.setNarrowWidth(), this.$emit("resized");
    },
    loadData() {
      return _e(this, null, function* () {
        l0(this.data) ? this.loadedData = yield this.dataLoader(this.data) : this.loadedData = this.data, this.$emit("loaded", this.loadedData);
      });
    },
    elementsMaxBBox({ selector: t = "text", defaultWidth: e = null, defaultHeight: n = null } = {}) {
      const r = this.mounted ? this.$el.querySelectorAll(t) : [];
      if (!r.length)
        return { width: e, height: n };
      const i = L7(
        [...r].map((o) => o.getBBox ? o.getBBox().width : e)
      ), a = L7(
        [...r].map((o) => o.getBBox ? o.getBBox().height : n)
      );
      return { width: i, height: a };
    },
    setNarrowWidth() {
      this.narrowWidth = He(this, "$el.offsetWidth", 540) < 540;
    },
    xAxisYearFormat(t) {
      return this.narrowWidth ? "’" + String(t).slice(2, 4) : t;
    },
    highlighted(t) {
      return t.highlight;
    }
  },
  computed: {
    dataLoader() {
      return N0t[this.dataUrlType];
    },
    baseHeightRatio() {
      return this.chartHeightRatio || (this.socialMode ? this.socialModeRatio : 9 / 16);
    },
    dataHasHighlights() {
      return n2t(this.data, this.highlighted);
    }
  }
};
const i2t = {
  name: "BarChart",
  mixins: [Go],
  props: {
    /**
     * Height of each bar
     */
    barHeight: {
      type: Number,
      default: 30
    },
    /**
     * Distance between each bar
     */
    barGap: {
      type: Number,
      default: 15
    },
    /**
     * Color of each bar (uses the CSS variable --bar-color by default)
     */
    barColor: {
      type: String,
      default: null
    },
    /**
     * Color of each highlighted bar (uses the CSS variable --bar-highlight-color by default)
     */
    barHighlightColor: {
      type: String,
      default: null
    },
    /**
     * Enforce a width for each bar's label
     */
    fixedLabelWidth: {
      type: Number,
      default: null
    },
    /**
     * Enforce a width for each bar's value
     */
    fixedValueWidth: {
      type: Number,
      default: null
    },
    /**
     * Distance between a bar and its label
     */
    labelGap: {
      type: Number,
      default: 10
    },
    /**
     * Distande between a bar and its value
     */
    valueGap: {
      type: Number,
      default: 5
    },
    /**
     * Sort bars by one or several keys.
     */
    sortBy: {
      type: [Array, String],
      default: null
    },
    /**
     * Function to apply to format x axis ticks (bar value). It can be a
     * function returning the formatted value or a d3's formatter string.
     */
    xAxisTickFormat: {
      type: [Function, String],
      default: rr
    }
  },
  data() {
    return {
      width: 0
    };
  },
  computed: {
    sortedData() {
      return this.loadedData ? this.sortBy ? Qp(this.sortedData, this.sortBy) : this.loadedData : [];
    },
    labelWidth() {
      if (this.fixedLabelWidth)
        return this.fixedLabelWidth;
      const t = ".bar-chart__labels__item", e = 100;
      return this.elementsMaxBBox({ selector: t, defaultWidth: e }).width;
    },
    valueWidth() {
      if (this.fixedValueWidth)
        return this.fixedValueWidth;
      const t = ".bar-chart__bars__item__value", e = 0;
      return this.elementsMaxBBox({ selector: t, defaultWidth: e }).width + this.valueGap;
    },
    margin() {
      return { left: this.labelWidth + this.labelGap, right: 0, top: 0, bottom: 0 };
    },
    padded() {
      const t = this.width - this.margin.left - this.margin.right, e = this.height - this.margin.top - this.margin.bottom;
      return { width: t, height: e };
    },
    scale() {
      return { x: Bi().domain([0, Sa(this.sortedData, (e) => e.value)]).range([0, this.padded.width - this.valueWidth]) };
    },
    bars() {
      return this.sortedData.map((t, e) => ({
        width: Math.abs(this.scale.x(t.value)),
        height: Math.abs(this.barHeight),
        value: t.value,
        highlight: t.highlight,
        x: 0,
        y: (this.barHeight + this.barGap) * e
      }));
    },
    labels() {
      return this.sortedData.map((t, e) => ({
        label: t.label,
        x: this.labelWidth,
        y: 4 + this.barHeight / 2 + (this.barHeight + this.barGap) * e
      }));
    },
    height() {
      return (this.barHeight + this.barGap) * this.sortedData.length;
    }
  },
  watch: {
    width() {
      this.initialize();
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize), this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.width = this.$el.offsetWidth;
    },
    initialize() {
      r1().scale(this.scale.x);
    }
  }
};
var a2t = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "bar-chart", class: {
    "bar-chart--has-highlights": e.dataHasHighlights,
    "bar-chart--social-mode": e.socialMode
  }, style: {
    "--bar-color": e.barColor,
    "--bar-highlight-color": e.barHighlightColor
  } }, [n("svg", { attrs: { width: e.width, height: e.height } }, [n("g", { staticClass: "bar-chart__labels", style: { transform: `translate(0, ${e.margin.top}px)` } }, e._l(e.labels, function(r, i) {
    return n("text", { key: i, staticClass: "bar-chart__labels__item", attrs: { x: r.x, y: r.y, "text-anchor": "end" } }, [e._v(" " + e._s(r.label) + " ")]);
  }), 0), n("g", { staticClass: "bar-chart__bars", style: { transform: `translate(${e.margin.left}px, ${e.margin.top}px)` } }, e._l(e.bars, function(r, i) {
    return n("g", { key: i, staticClass: "bar-chart__bars__item", class: { "bar-chart__bars__item--highlight": r.highlight } }, [n("rect", { attrs: { width: r.width, height: r.height, x: r.x, y: r.y } }), n("text", { staticClass: "bar-chart__bars__item__value", attrs: { x: r.width + e.valueGap, y: r.y + r.height / 2, "text-anchor": "start", "dominant-baseline": "middle" } }, [e._v(" " + e._s(e._f("d3Formatter")(r.value, e.xAxisTickFormat)) + " ")])]);
  }), 0)])]);
}, o2t = [], s2t = /* @__PURE__ */ Bt(
  i2t,
  a2t,
  o2t,
  !1,
  null,
  null,
  null,
  null
);
const u2t = s2t.exports, l2t = te({
  name: "ColumnChart",
  mixins: [Go],
  props: {
    /**
     * Color of each column (uses the CSS variable --column-color by default)
     */
    columnColor: {
      type: String,
      default: null
    },
    /**
     * Color of each highlighted column (uses the CSS variable --column-color by default)
     */
    columnHighlightColor: {
      type: String,
      default: null
    },
    /**
     * Enforce the height of the chart (regardless of the width or the social mode)
     */
    fixedHeight: {
      type: Number,
      default: null
    },
    /**
     * Enforce a width for each column's label
     */
    fixedLabelWidth: {
      type: Number,
      default: null
    },
    /**
     * Name of the series (to get the value from in the data collection objects)
     */
    seriesName: {
      type: String,
      default: "value"
    },
    /**
     * Hide x axis ticks when no enough space
     */
    xAxisTickCollapse: {
      type: Boolean,
      default: !1
    },
    /**
     * Function to apply to format x axis ticks
     */
    xAxisTickFormat: {
      type: [Function, String],
      default: ct.identity
    },
    /**
     * Definition of x axis ticks
     */
    xAxisTicks: {
      type: Array,
      default: null
    },
    /**
     * Function to apply to format y axis ticks
     */
    yAxisTickFormat: {
      type: [Function, String],
      default: ct.identity
    },
    /**
     * Definition of y axis ticks
     */
    yAxisTicks: {
      type: [Number, Object],
      default: 5
    },
    /**
     * Sort columns by one or several keys.
     */
    sortBy: {
      type: [Array, String],
      default: null
    },
    /**
     * Key to use for timeseries
     */
    timeseriesKey: {
      type: String,
      default: "date"
    },
    /**
     * Set max value instead of extracting it from the data.
     */
    maxValue: {
      type: Number,
      default: null
    },
    /**
     * Hide bar tooltips
     */
    noTooltips: {
      type: Boolean
    },
    /**
     * Hide x axis
     */
    noXAxis: {
      type: Boolean
    },
    /**
     * Hide y axis
     */
    noYAxis: {
      type: Boolean
    },
    /**
     * Bar padding as a portion of each bar width
     */
    barPadding: {
      type: Number,
      default: 0.35
    },
    /**
     * Bar margin in pixel
     */
    barMargin: {
      type: Number,
      default: 0
    },
    /**
     * A list of highlighted key
     */
    highlights: {
      type: Array,
      default: () => []
    },
    /**
     * Show a "placeholder" behind every bar
     */
    stripped: {
      type: Boolean
    },
    /**
     * Show a "placeholder" behind every bar on hover
     */
    hover: {
      type: Boolean
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      shownTooltip: -1
    };
  },
  computed: {
    sortedData() {
      return this.loadedData ? this.sortBy ? ct.sortBy(this.sortedData, this.sortBy) : this.loadedData : [];
    },
    labelWidth() {
      if (this.fixedLabelWidth)
        return this.fixedLabelWidth;
      const t = ".column-chart__axis--y .tick text", e = 100;
      return this.elementsMaxBBox({ selector: t, defaultWidth: e }).width;
    },
    labelHeight() {
      if (this.noYAxis)
        return 0;
      const t = ".column-chart__axis--y .tick text", e = 10;
      return this.elementsMaxBBox({ selector: t, defaultHeight: e }).height;
    },
    bucketHeight() {
      if (this.noXAxis)
        return 0;
      const t = ".column-chart__axis--x .tick text", e = 10;
      return this.elementsMaxBBox({ selector: t, defaultHeight: e }).height;
    },
    bucketWidth() {
      const t = ".column-chart__axis--x .tick text";
      return this.elementsMaxBBox({ selector: t, defaultWidth: 100 }).width;
    },
    margin() {
      return {
        left: this.noYAxis ? 0 : this.labelWidth + 10,
        right: 0,
        top: this.labelHeight / 2,
        bottom: this.noXAxis ? 0 : this.bucketHeight + 10
      };
    },
    padded() {
      const t = this.width - this.margin.left - this.margin.right, e = this.height - this.margin.top - this.margin.bottom;
      return { width: t, height: e };
    },
    scaleX() {
      return Gc().domain(this.sortedData.map(ct.iteratee(this.timeseriesKey))).range([0, this.padded.width]).padding(this.barPadding);
    },
    scaleY() {
      var e;
      const t = (e = this.maxValue) != null ? e : Sa(this.sortedData, ct.iteratee(this.seriesName));
      return Bi().domain([0, t]).range([this.padded.height, 0]);
    },
    bars() {
      return this.sortedData.map((t) => {
        var e, n;
        return {
          datum: t,
          width: Math.max(1, Math.abs(this.scaleX.bandwidth()) - this.barMargin),
          height: Math.abs(this.padded.height - this.scaleY(t[this.seriesName])),
          x: ((e = this.scaleX(t[this.timeseriesKey])) != null ? e : 0) + this.barMargin / 2,
          y: (n = this.scaleY(t[this.seriesName])) != null ? n : 0
        };
      });
    },
    xAxisHiddenTicks() {
      if (!this.xAxisTickCollapse)
        return 0;
      const t = ei(1, this.sortedData.length).find((e) => {
        const n = this.bucketWidth * 1.5;
        return this.width / (n / e) >= this.sortedData.length;
      });
      return t != null ? t : this.sortedData.length;
    },
    xAxisTickValues() {
      var e;
      return ((e = this.xAxisTicks) != null ? e : this.sortedData.map(ct.iteratee(this.timeseriesKey))).map((n, r) => (r + 1) % this.xAxisHiddenTicks ? null : n);
    },
    xAxis() {
      return r1(this.scaleX).tickFormat((t) => {
        var e;
        return (e = this.$options.filters) == null ? void 0 : e.d3Formatter(t, this.xAxisTickFormat);
      }).tickValues(this.xAxisTickValues);
    },
    yAxis() {
      return i1(this.scaleY).tickFormat((t) => {
        var e;
        return (e = this.$options.filters) == null ? void 0 : e.d3Formatter(t, this.yAxisTickFormat);
      }).ticks(this.yAxisTicks);
    }
  },
  watch: {
    width() {
      this.setup();
    },
    fixedHeight() {
      this.setSizes();
    },
    socialMode() {
      this.setup();
    },
    loadedData() {
      this.setup();
    },
    mounted() {
      this.setup();
    }
  },
  mounted() {
    this.$on("resized", this.setSizes), this.setSizes();
  },
  methods: {
    setup() {
      this.update();
    },
    setSizes() {
      var t, e;
      this.width = (e = (t = this.$el) == null ? void 0 : t.offsetWidth) != null ? e : 0, this.height = this.fixedHeight !== null ? this.fixedHeight : this.width * this.baseHeightRatio, this.update();
    },
    select({ datum: t }) {
      this.$emit("select", t);
    },
    update() {
      this.$el && (de(this.$el).select(".column-chart__axis--x").call(this.xAxis).select(".domain").remove(), de(this.$el).select(".column-chart__axis--y").call(this.yAxis).selectAll(".tick line").attr("x2", this.padded.width));
    },
    barTooltipStyle(t) {
      const e = `${t.y + this.margin.top}px`, n = `${t.x + t.width / 2 + this.margin.left}px`;
      return { top: e, left: n };
    },
    highlighted(t) {
      return t.highlight || this.highlights.includes(t[this.timeseriesKey]);
    }
  }
});
var c2t = function() {
  var e = this, n = e._self._c;
  return e._self._setupProxy, n("div", { staticClass: "column-chart", class: {
    "column-chart--has-highlights": e.dataHasHighlights,
    "column-chart--hover": e.hover,
    "column-chart--stripped": e.stripped,
    "column-chart--social-mode": e.socialMode
  }, style: { "--column-color": e.columnColor, "--column-highlight-color": e.columnHighlightColor } }, [n("svg", { attrs: { width: e.width, height: e.height } }, [n("g", { style: { transform: `translate(${e.margin.left}px, ${e.margin.top}px)` } }, [e.noXAxis ? e._e() : n("g", { staticClass: "column-chart__axis column-chart__axis--x", style: { transform: `translate(0, ${e.padded.height}px)` } }), e.noYAxis ? e._e() : n("g", { staticClass: "column-chart__axis column-chart__axis--y" })]), n("g", { staticClass: "column-chart__columns", style: { transform: `translate(${e.margin.left}px, ${e.margin.top}px)` } }, e._l(e.bars, function(r, i) {
    return n("g", { key: i, staticClass: "column-chart__columns__item", class: { "column-chart__columns__item--highlight": e.highlighted(r.datum) }, style: { transform: `translate(${r.x}px, 0px)` }, on: { click: function(a) {
      return e.select(r);
    }, mouseover: function(a) {
      e.shownTooltip = i;
    }, mouseleave: function(a) {
      e.shownTooltip = -1;
    } } }, [n("rect", { staticClass: "column-chart__columns__item__placeholder", attrs: { width: r.width, height: e.padded.height } }), n("rect", { staticClass: "column-chart__columns__item__bar", attrs: { width: r.width, height: r.height, y: r.y } })]);
  }), 0)]), e.noTooltips ? e._e() : n("div", { staticClass: "column-chart__tooltips" }, e._l(e.bars, function(r, i) {
    return n("div", { key: i }, [n("div", { staticClass: "column-chart__tooltips__item", style: e.barTooltipStyle(r) }, [n("transition", { attrs: { name: "fade" } }, [e.shownTooltip === i ? n("div", { staticClass: "column-chart__tooltips__item__wrapper" }, [e._t("tooltip", function() {
      return [n("h6", { staticClass: "column-chart__tooltips__item__wrapper__heading mb-0" }, [e._v(" " + e._s(e._f("d3Formatter")(r.datum[e.timeseriesKey], e.xAxisTickFormat)) + " ")]), n("div", { staticClass: "column-chart__tooltips__item__wrapper__value" }, [e._v(" " + e._s(e._f("d3Formatter")(r.datum[e.seriesName], e.yAxisTickFormat)) + " ")])];
    }, null, r)], 2) : e._e()])], 1)]);
  }), 0)]);
}, f2t = [], h2t = /* @__PURE__ */ Bt(
  l2t,
  c2t,
  f2t,
  !1,
  null,
  null,
  null,
  null
);
const d2t = h2t.exports;
const p2t = (t = rr, ...e) => yp(t) ? t(...e) : t, m2t = {
  name: "LineChart",
  mixins: [Go],
  props: {
    /**
     * Color of the line (uses the CSS variable --line-color by default)
     */
    lineColor: {
      type: String,
      default: null
    },
    /**
     * Enforce a width for each column's label
     */
    fixedLabelWidth: {
      type: Number,
      default: null
    },
    /**
     * Enforce the height of the chart (regardless of the width or the social mode)
     */
    fixedHeight: {
      type: Number,
      default: null
    },
    /**
     * Name of the series (to get the value from in the data collection objects)
     */
    seriesName: {
      type: String,
      default: "value"
    },
    /**
     * Argument for x-axis ticks
     * @see https://github.com/d3/d3-axis#axis_ticks
     */
    xAxisTicks: {
      type: [Object, Number, Function],
      default: null
    },
    /**
     * Function to apply to format y axis ticks (line value). It can be a
     * function returning the formatted value or a d3's formatter string.
     */
    yAxisTickFormat: {
      type: [Function, String],
      default: rr
    },
    /**
     * Argument for y-axis ticks
     * @see https://github.com/d3/d3-axis#axis_ticks
     */
    yAxisTicks: {
      type: [Object, Number, Function],
      default: 5
    },
    /**
     * Key to use for timeseries
     */
    timeseriesKey: {
      type: String,
      default: "date"
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      line: null
    };
  },
  computed: {
    labelWidth() {
      if (this.fixedLabelWidth)
        return this.fixedLabelWidth;
      const t = ".line-chart__axis--y .tick text", e = 100;
      return this.elementsMaxBBox({ selector: t, defaultWidth: e }).width;
    },
    labelHeight() {
      const t = ".line-chart__axis--y .tick";
      return this.elementsMaxBBox({ selector: t, defaultHeight: 10 }).height;
    },
    bucketHeight() {
      const t = ".line-chart__axis--x .tick";
      return this.elementsMaxBBox({ selector: t, defaultHeight: 10 }).height;
    },
    bucketWidth() {
      const t = ".line-chart__axis--x .tick text";
      return this.elementsMaxBBox({ selector: t, defaultWidth: 0 }).width;
    },
    scale() {
      return {
        x: Eb().range([0, this.padded.width]),
        y: Bi().range([this.padded.height, 0])
      };
    },
    margin() {
      const t = this.labelWidth + 10, e = this.bucketWidth / 2, n = this.labelHeight, r = this.bucketHeight + 10;
      return { left: t, right: e, top: n, bottom: r };
    },
    padded() {
      const t = this.width - this.margin.left - this.margin.right, e = this.height - this.margin.top - this.margin.bottom;
      return { width: t, height: e };
    },
    formattedData() {
      return this.loadedData ? this.loadedData.map((t) => (t[this.timeseriesKey] = this.parseTime(t[this.timeseriesKey]), t[this.seriesName] = +t[this.seriesName], t)) : [];
    }
  },
  watch: {
    socialMode() {
      this.setSizes();
    },
    width() {
      this.update();
    },
    height() {
      this.update();
    },
    fixedHeight() {
      this.update();
    },
    loadedData() {
      this.update();
    },
    labelHeight() {
      this.update();
    }
  },
  mounted() {
    window.addEventListener("resize", this.setSizes), this.setSizes();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setSizes);
  },
  methods: {
    createLine: I1().x((t) => t.x).y((t) => t.y),
    parseTime: Tb("%Y"),
    setSizes() {
      this.width = this.$el.offsetWidth, this.height = this.fixedHeight !== null ? this.fixedHeight : this.$el.offsetWidth * this.baseHeightRatio;
    },
    update() {
      this.scale.x.domain(zl(this.formattedData, (e) => e[this.timeseriesKey])), this.scale.y.domain([0, Sa(this.formattedData, (e) => e[this.seriesName])]);
      const t = this.formattedData.map((e) => ({
        x: this.scale.x(e[this.timeseriesKey]),
        y: this.scale.y(e[this.seriesName])
      }));
      this.line = this.createLine(t), de(this.$el).select(".line-chart__axis--x").call(
        r1(this.scale.x).ticks(this.xAxisTicks).tickFormat((e) => p2t(this.xAxisYearFormat, e.getFullYear()))
      ), de(this.$el).select(".line-chart__axis--y").call(
        i1(this.scale.y).tickFormat((e) => this.$options.filters.d3Formatter(e, this.yAxisTickFormat)).ticks(this.yAxisTicks)
      ).selectAll(".tick line").attr("x2", this.padded.width);
    }
  }
};
var g2t = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "line-chart", class: { "line-chart--social-mode": e.socialMode }, style: { "--line-color": e.lineColor } }, [n("svg", { attrs: { width: e.width, height: e.height } }, [n("g", { staticClass: "line-chart__axis line-chart__axis--x", style: {
    transform: `translate(${e.margin.left}px, ${e.margin.top + e.padded.height}px)`
  } }, [e._v(" > ")]), n("g", { staticClass: "line-chart__axis line-chart__axis--y", style: { transform: `translate(${e.margin.left}px, ${e.margin.top}px)` } }, [e._v(" > ")]), n("g", { style: { transform: `translate(${e.margin.left}px, ${e.margin.top}px)` } }, [n("path", { staticClass: "line-chart__line", attrs: { d: e.line } })])])]);
}, v2t = [], _2t = /* @__PURE__ */ Bt(
  m2t,
  g2t,
  v2t,
  !1,
  null,
  null,
  null,
  null
);
const b2t = _2t.exports;
function y2t(t) {
  return function(e) {
    return t == null ? void 0 : t[e];
  };
}
var w2t = y2t, x2t = w2t, C2t = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, $2t = x2t(C2t), T2t = $2t, O2t = T2t, S2t = Sp, E2t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, A2t = "\\u0300-\\u036f", P2t = "\\ufe20-\\ufe2f", M2t = "\\u20d0-\\u20ff", k2t = A2t + P2t + M2t, N2t = "[" + k2t + "]", I2t = RegExp(N2t, "g");
function R2t(t) {
  return t = S2t(t), t && t.replace(E2t, O2t).replace(I2t, "");
}
var L2t = R2t, D2t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function F2t(t) {
  return t.match(D2t) || [];
}
var z2t = F2t, B2t = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function H2t(t) {
  return B2t.test(t);
}
var j2t = H2t, QE = "\\ud800-\\udfff", V2t = "\\u0300-\\u036f", W2t = "\\ufe20-\\ufe2f", U2t = "\\u20d0-\\u20ff", Y2t = V2t + W2t + U2t, tA = "\\u2700-\\u27bf", eA = "a-z\\xdf-\\xf6\\xf8-\\xff", q2t = "\\xac\\xb1\\xd7\\xf7", G2t = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", K2t = "\\u2000-\\u206f", X2t = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", nA = "A-Z\\xc0-\\xd6\\xd8-\\xde", Z2t = "\\ufe0e\\ufe0f", rA = q2t + G2t + K2t + X2t, iA = "['’]", D7 = "[" + rA + "]", J2t = "[" + Y2t + "]", aA = "\\d+", Q2t = "[" + tA + "]", oA = "[" + eA + "]", sA = "[^" + QE + rA + aA + tA + eA + nA + "]", tbt = "\\ud83c[\\udffb-\\udfff]", ebt = "(?:" + J2t + "|" + tbt + ")", nbt = "[^" + QE + "]", uA = "(?:\\ud83c[\\udde6-\\uddff]){2}", lA = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ss = "[" + nA + "]", rbt = "\\u200d", F7 = "(?:" + oA + "|" + sA + ")", ibt = "(?:" + Ss + "|" + sA + ")", z7 = "(?:" + iA + "(?:d|ll|m|re|s|t|ve))?", B7 = "(?:" + iA + "(?:D|LL|M|RE|S|T|VE))?", cA = ebt + "?", fA = "[" + Z2t + "]?", abt = "(?:" + rbt + "(?:" + [nbt, uA, lA].join("|") + ")" + fA + cA + ")*", obt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", sbt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ubt = fA + cA + abt, lbt = "(?:" + [Q2t, uA, lA].join("|") + ")" + ubt, cbt = RegExp([
  Ss + "?" + oA + "+" + z7 + "(?=" + [D7, Ss, "$"].join("|") + ")",
  ibt + "+" + B7 + "(?=" + [D7, Ss + F7, "$"].join("|") + ")",
  Ss + "?" + F7 + "+" + z7,
  Ss + "+" + B7,
  sbt,
  obt,
  aA,
  lbt
].join("|"), "g");
function fbt(t) {
  return t.match(cbt) || [];
}
var hbt = fbt, dbt = z2t, pbt = j2t, mbt = Sp, gbt = hbt;
function vbt(t, e, n) {
  return t = mbt(t), e = n ? void 0 : e, e === void 0 ? pbt(t) ? gbt(t) : dbt(t) : t.match(e) || [];
}
var _bt = vbt, bbt = c$, ybt = L2t, wbt = _bt, xbt = "['’]", Cbt = RegExp(xbt, "g");
function $bt(t) {
  return function(e) {
    return bbt(wbt(ybt(e).replace(Cbt, "")), t, "");
  };
}
var Tbt = $bt, Obt = Tbt, Sbt = Obt(function(t, e, n) {
  return t + (n ? "-" : "") + e.toLowerCase();
}), Ebt = Sbt;
function Abt(t) {
  return t !== t;
}
var Pbt = Abt;
function Mbt(t, e, n) {
  for (var r = n - 1, i = t.length; ++r < i; )
    if (t[r] === e)
      return r;
  return -1;
}
var kbt = Mbt, Nbt = y$, Ibt = Pbt, Rbt = kbt;
function Lbt(t, e, n) {
  return e === e ? Rbt(t, e, n) : Nbt(t, Ibt, n);
}
var Dbt = Lbt, Fbt = Dbt;
function zbt(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && Fbt(t, e, 0) > -1;
}
var Bbt = zbt;
function Hbt(t, e, n) {
  for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
var jbt = Hbt, Vbt = qC, Wbt = Bbt, Ubt = jbt, Ybt = Op, qbt = i2, Gbt = KC, Kbt = 200;
function Xbt(t, e, n, r) {
  var i = -1, a = Wbt, o = !0, s = t.length, l = [], c = e.length;
  if (!s)
    return l;
  n && (e = Ybt(e, qbt(n))), r ? (a = Ubt, o = !1) : e.length >= Kbt && (a = Gbt, o = !1, e = new Vbt(e));
  t:
    for (; ++i < s; ) {
      var h = t[i], d = n == null ? h : n(h);
      if (h = r || h !== 0 ? h : 0, o && d === d) {
        for (var p = c; p--; )
          if (e[p] === d)
            continue t;
        l.push(h);
      } else
        a(e, d, r) || l.push(h);
    }
  return l;
}
var Zbt = Xbt, Jbt = Au, Qbt = Do;
function tyt(t) {
  return Qbt(t) && Jbt(t);
}
var eyt = tyt, nyt = Zbt, ryt = o$, iyt = eyt, ayt = ryt(function(t, e) {
  return iyt(t) ? nyt(t, e) : [];
}), hA = ayt;
const oyt = {
  name: "StackedBarChart",
  mixins: [Go],
  props: {
    /**
     * Field of each object containing data (for each group)
     */
    keys: {
      type: Array,
      default: () => []
    },
    /**
     * Group name to display in the legend
     */
    groups: {
      type: Array,
      default: () => []
    },
    /**
     * Colors of each bar group
     */
    barColors: {
      type: Array,
      default: () => []
    },
    /**
     * Enforce the height of the chart (regardless of the width or number of row)
     */
    fixedHeight: {
      type: Number,
      default: null
    },
    /**
     * Function to apply to format x axis ticks (bar value). It can be a
     * function returning the formatted value or a d3's formatter string.
     */
    xAxisTickFormat: {
      type: [Function, String],
      default: rr
    },
    /**
     * Field containing the label for each row
     */
    labelField: {
      type: String,
      default: "label"
    },
    /**
     * Switch labels above bars
     */
    labelAbove: {
      type: Boolean,
      default: !1
    },
    /**
     * Bar width is relative to each group's total
     */
    relative: {
      type: Boolean,
      default: !1
    },
    /**
     * Sort groups by one or several keys.
     */
    sortBy: {
      type: [Array, String],
      default: null
    },
    /**
     * Hide bars that have no values.
     */
    hideEmptyValues: {
      type: Boolean
    },
    /**
     * Hide the legend.
     */
    hideLegend: {
      type: Boolean
    },
    /**
     * A list of highlighted groups
     */
    highlights: {
      type: Array,
      default: () => []
    },
    /**
     * Delay to apply when set the first highlight
     */
    highlightDelay: {
      type: Number,
      default: 400
    },
    /**
     * Delay to apply when restoring hightlights to initial state
     */
    restoreHighlightDelay: {
      type: Number,
      default: 50
    },
    /**
     * A list of entire row to highlight
     */
    rowHighlights: {
      type: Array,
      default: () => []
    },
    /**
     * Set a minimal height for the bars
     */
    minBarHeight: {
      type: Number,
      default: 16
    },
    /**
     * Set a maximal height for the bars
     */
    maxBarHeight: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      highlightedKeys: this.highlights,
      highlightTimeout: null
    };
  },
  computed: {
    hasConstraintHeight() {
      return this.fixedHeight !== null || this.socialMode;
    },
    sortedData() {
      return this.loadedData ? this.sortBy ? Qp(this.loadedData, this.sortBy) : this.loadedData : [];
    },
    discoveredKeys() {
      return this.keys.length ? this.keys : this.loadedData ? hA(Oa(this.loadedData[0]), this.labelField) : [];
    },
    colorScale() {
      return Lu().domain(this.discoveredKeys).range(this.barColors);
    },
    maxValue() {
      return Sa(this.loadedData || [], (t, e) => this.totalRowValue(e));
    },
    hasHighlights() {
      return !!this.highlightedKeys.length;
    },
    hasRowHighlights() {
      return !!this.rowHighlights.length;
    },
    height() {
      return this.fixedHeight !== null ? `${this.fixedHeight}px` : this.socialMode && this.mounted ? `${this.$el.offsetWidth * this.baseHeightRatio}px` : "auto";
    }
  },
  watch: {
    relative() {
      this.$nextTick(this.$forceUpdate);
    },
    height() {
      this.$nextTick(this.$forceUpdate);
    },
    sortBy() {
      this.$nextTick(this.$forceUpdate);
    },
    highlights() {
      this.highlightedKeys = this.highlights;
    }
  },
  methods: {
    normalizeKey(t) {
      return Ebt(t);
    },
    totalRowValue(t) {
      return d2(this.discoveredKeys, (e) => this.sortedData[t][e]);
    },
    groupName(t) {
      const e = this.discoveredKeys.indexOf(t);
      return this.groups[e] || t;
    },
    highlight(t) {
      this.highlightedKeys = [t];
    },
    restoreHighlights() {
      clearTimeout(this.highlightTimeout);
      const t = this.restoreHighlightDelay;
      this.highlightTimeout = setTimeout(() => this.highlightedKeys = this.highlights, t);
    },
    delayHighlight(t) {
      clearTimeout(this.highlightTimeout);
      const n = !this.hasHighlights ? this.highlightDelay : 0;
      this.highlightTimeout = setTimeout(() => this.highlight(t), n);
    },
    isHighlighted(t) {
      return this.highlightedKeys.indexOf(t) > -1;
    },
    isRowHighlighted(t) {
      const e = He(this.sortedData, [t, this.labelField], null);
      return this.rowHighlights.includes(e) && !this.highlightedKeys.length;
    },
    barStyle(t, e) {
      const n = this.sortedData[t][e], r = this.relative ? this.totalRowValue(t) : this.maxValue, i = `${100 * (n / r)}%`, a = this.colorScale(e);
      return { width: i, backgroundColor: a };
    },
    barHeightBounds(t) {
      return Math.min(Math.max(t, this.minBarHeight), this.maxBarHeight);
    },
    stackBarAndValue(t) {
      if (!this.mounted)
        return [];
      const e = this.discoveredKeys.map((n) => {
        const { bar: r, row: i, value: a } = this.queryBarAndValue(t, n), o = r.getBoundingClientRect().left + r.offsetWidth, s = r.offsetWidth, l = i.getBoundingClientRect().left + i.offsetWidth, c = a.offsetWidth;
        return { key: n, barEdge: o, barWidth: s, rowEdge: l, valueWidth: c };
      });
      return e.map((n, r) => {
        if (n.overflow = n.valueWidth >= n.barWidth, r > 0) {
          const i = e[r - 1], a = n.valueWidth + i.valueWidth;
          n.overflow = n.overflow || i.overflow && n.barWidth < a;
        }
        return n.pushed = n.barEdge + n.valueWidth > n.rowEdge && n.overflow, n;
      });
    },
    queryBarAndValue(t, e) {
      if (!this.mounted)
        return {};
      const n = "stacked-bar-chart__groups__item__bars__item", r = ".stacked-bar-chart__groups__item", i = this.$el.querySelectorAll(r)[t], a = this.normalizeKey(e), o = `.${n}--${a}`, s = i.querySelector(o), l = `.${n}__value`, c = s.querySelector(l);
      return { bar: s, row: i, value: c };
    },
    hasValueOverflow(t, e) {
      const n = this.stackBarAndValue(t);
      return He(ac(n, { key: e }), "overflow");
    },
    hasValuePushed(t, e) {
      const n = this.stackBarAndValue(t);
      return He(ac(n, { key: e }), "pushed");
    },
    hasValueHidden(t, e) {
      const n = this.discoveredKeys.indexOf(e), r = this.discoveredKeys[n + 1];
      return r ? this.hasValueOverflow(t, e) && this.hasValueOverflow(t, r) : !1;
    },
    isHidden(t, e) {
      return this.hideEmptyValues && !this.sortedData[t][e];
    }
  }
};
var syt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "stacked-bar-chart d-flex flex-column", class: {
    "stacked-bar-chart--has-highlights": e.dataHasHighlights,
    "stacked-bar-chart--social-mode": e.socialMode,
    "stacked-bar-chart--label-above": e.labelAbove,
    "stacked-bar-chart--has-highlights": e.hasHighlights || e.hasRowHighlights,
    "stacked-bar-chart--has-constraint-height": e.hasConstraintHeight,
    "stacked-bar-chart--has-label-above": e.labelAbove
  }, style: { height: e.height } }, [n("div", { staticClass: "d-flex align-items-center" }, [e._t("header-left", function() {
    return [e.hideLegend ? e._e() : n("ul", { staticClass: "stacked-bar-chart__legend list-inline mx-0 mt-0 mb-2" }, e._l(e.discoveredKeys, function(r) {
      return n("li", { key: r, staticClass: "stacked-bar-chart__legend__item list-inline-item d-inline-flex", class: {
        "stacked-bar-chart__legend__item--highlighted": e.isHighlighted(r)
      }, on: { mouseover: function(i) {
        return e.delayHighlight(r);
      }, mouseleave: function(i) {
        return e.restoreHighlights();
      } } }, [n("span", { staticClass: "stacked-bar-chart__legend__item__box", style: { "background-color": e.colorScale(r) } }), e._v(" " + e._s(e.groupName(r)) + " ")]);
    }), 0)];
  }), e._t("header-right")], 2), n("div", { staticClass: "stacked-bar-chart__groups" }, e._l(e.sortedData, function(r, i) {
    return n("div", { key: i, staticClass: "stacked-bar-chart__groups__item border-bottom flex-fill d-flex align-items-center", class: { "flex-column": e.labelAbove } }, [n("div", { staticClass: "stacked-bar-chart__groups__item__label mr-1 small", class: { "w-100": e.labelAbove } }, [e._v(" " + e._s(r[e.labelField]) + " ")]), n("div", { staticClass: "stacked-bar-chart__groups__item__bars my-1 d-flex flex-grow-1 align-items-center" }, e._l(e.discoveredKeys, function(a, o) {
      return n("div", { key: o, staticClass: "stacked-bar-chart__groups__item__bars__item", class: {
        [`stacked-bar-chart__groups__item__bars__item--${e.normalizeKey(a)}`]: !0,
        [`stacked-bar-chart__groups__item__bars__item--${o}n`]: !0,
        "stacked-bar-chart__groups__item__bars__item--highlighted": e.isHighlighted(a) || e.isRowHighlighted(i),
        "stacked-bar-chart__groups__item__bars__item--hidden": e.isHidden(i, a),
        "stacked-bar-chart__groups__item__bars__item--value-overflow": e.hasValueOverflow(i, a),
        "stacked-bar-chart__groups__item__bars__item--value-pushed": e.hasValuePushed(i, a),
        "stacked-bar-chart__groups__item__bars__item--value-hidden": e.hasValueHidden(i, a)
      }, style: e.barStyle(i, a), on: { mouseover: function(s) {
        return e.delayHighlight(a);
      }, mouseleave: function(s) {
        return e.restoreHighlights();
      } } }, [n("div", { staticClass: "stacked-bar-chart__groups__item__bars__item__value p-1" }, [e._v(" " + e._s(e._f("d3Formatter")(r[a], e.xAxisTickFormat)) + " ")])]);
    }), 0)]);
  }), 0)]);
}, uyt = [], lyt = /* @__PURE__ */ Bt(
  oyt,
  syt,
  uyt,
  !1,
  null,
  null,
  null,
  null
);
const cyt = lyt.exports;
const fyt = {
  name: "StackedColumnChart",
  directives: {
    "b-tooltip": MY
  },
  mixins: [Go],
  props: {
    /**
     * Field of each object containing data (for each group)
     */
    keys: {
      type: Array,
      default: () => []
    },
    /**
     * Group name to display in the legend
     */
    groups: {
      type: Array,
      default: () => []
    },
    /**
     * Colors of each bar group
     */
    barColors: {
      type: Array,
      default: () => []
    },
    /**
     * Max with of each bar.
     */
    barMaxWidth: {
      type: String,
      default: "100%"
    },
    /**
     * Hide bars that have no values.
     */
    hideEmptyValues: {
      type: Boolean
    },
    /**
     * Hide the legend.
     */
    hideLegend: {
      type: Boolean
    },
    /**
     * Enforce the height of the chart (regardless of the width or number of row)
     */
    fixedHeight: {
      type: Number,
      default: null
    },
    /**
     * Function to apply to format x axis ticks
     */
    xAxisTickFormat: {
      type: [Function, String],
      default: rr
    },
    /**
     * Function to apply to format y axis ticks (bars value). It can be a
     * function returning the formatted value or a d3's formatter string.
     */
    yAxisTickFormat: {
      type: [Function, String],
      default: rr
    },
    /**
     * Padding on y axis ticks
     */
    yAxisTickPadding: {
      type: Number,
      default: 10
    },
    /**
     * Field containing the label for each column
     */
    labelField: {
      type: String,
      default: "date"
    },
    /**
     * Sort groups by one or several keys.
     */
    sortBy: {
      type: [Array, String],
      default: null
    },
    /**
     * Column height is relative to each group's total
     */
    relative: {
      type: Boolean,
      default: !1
    },
    /**
     * A list of highlighted groups
     */
    highlights: {
      type: Array,
      default: () => []
    },
    /**
     * Delay to apply when set the first highlight
     */
    highlightDelay: {
      type: Number,
      default: 400
    },
    /**
     * A list of entire column to highlight
     */
    columnHighlights: {
      type: Array,
      default: () => []
    },
    /**
     * Delay to apply when restoring hightlights to initial state
     */
    restoreHighlightDelay: {
      type: Number,
      default: 50
    },
    /**
     * Deactivate direct labeling on bars
     */
    noDirectLabeling: {
      type: Boolean
    },
    /**
     * Set max value instead of extracting it from the data.
     */
    maxValue: {
      type: Number,
      default: null
    },
    /**
     * Function to define tooltip content.
     */
    tooltipDisplay: {
      type: Function,
      default: ({ formattedKey: t, formattedValue: e }) => `<h6 class="mb-0">${t}</h6><div>${e}</div>`
    },
    /**
     * Hide bar tooltips
     */
    noTooltips: {
      type: Boolean
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      leftAxisHeight: 0,
      highlightedKeys: this.highlights,
      highlightTimeout: null
    };
  },
  resizeObserver: null,
  computed: {
    sortedData() {
      return this.loadedData ? this.sortBy ? Qp(this.loadedData, this.sortBy) : this.loadedData : [];
    },
    discoveredKeys() {
      return this.keys.length ? this.keys : hA(Oa(this.sortedData[0] || {}), this.labelField);
    },
    colorScale() {
      return Lu().domain(this.discoveredKeys).range(this.barColors);
    },
    maxRowValue() {
      return this.maxValue || Sa(this.loadedData || [], (t, e) => this.totalRowValue(e));
    },
    hasHighlights() {
      return !!this.highlightedKeys.length;
    },
    hasColumnHighlights() {
      return !!this.columnHighlights.length;
    },
    leftScale() {
      return Bi().domain([0, this.maxRowValue]).range([this.leftAxisHeight, 0]);
    },
    leftAxis: {
      cache: !1,
      get() {
        return i1(this.leftScale).tickFormat((t) => this.$options.filters.d3Formatter(t, this.yAxisTickFormat)).tickSize(this.width - this.leftAxisLabelsWidth).tickPadding(this.yAxisTickPadding);
      }
    },
    leftAxisLabelsWidth: {
      cache: !1,
      get() {
        const t = ".stacked-column-chart__left-axis__canvas .tick text";
        return this.elementsMaxBBox({ selector: t, defaultWidth: 0 }).width + this.yAxisTickPadding;
      }
    },
    leftAxisCanvas() {
      return de(this.$el).select(".stacked-column-chart__left-axis__canvas");
    },
    paddedStyle() {
      return {
        marginLeft: this.noDirectLabeling ? `${this.leftAxisLabelsWidth + this.yAxisTickPadding}px` : 0
      };
    },
    barTooltipDelay() {
      return this.hasHighlights ? 0 : this.highlightDelay;
    }
  },
  watch: {
    socialMode() {
      this.setup();
    },
    loadedData() {
      this.setup();
    },
    leftAxisLabelsWidth() {
      this.setup();
    },
    leftAxisHeight() {
      this.setup();
    },
    fixedHeight() {
      this.setup();
    },
    highlights() {
      this.highlightedKeys = this.highlights;
    }
  },
  mounted() {
    return _e(this, null, function* () {
      var t;
      this.$options.resizeObserver = new m_(this.setup), yield this.$nextTick(), (t = this.$options.resizeObserver) == null || t.observe(this.$el);
    });
  },
  beforeDestroy() {
    var t;
    (t = this.$options.resizeObserver) == null || t.unobserve(this.$el), this.$options.resizeObserver = null;
  },
  methods: {
    setSizes() {
      this.width = this.$el.offsetWidth, this.height = this.fixedHeight !== null ? this.fixedHeight : this.width * this.baseHeightRatio;
    },
    setup() {
      return _e(this, null, function* () {
        this.setSizes(), yield this.$nextTick(), this.leftAxisHeight = this.$el.querySelector(".stacked-column-chart__groups__item__bars").offsetHeight, this.leftAxisCanvas.call(this.leftAxis);
      });
    },
    groupName(t) {
      const e = this.discoveredKeys.indexOf(t);
      return this.groups[e] || t;
    },
    highlight(t) {
      this.highlightedKeys = [t];
    },
    restoreHighlights() {
      clearTimeout(this.highlightTimeout);
      const t = this.restoreHighlightDelay;
      this.highlightTimeout = setTimeout(() => this.highlightedKeys = this.highlights, t);
    },
    delayHighlight(t) {
      clearTimeout(this.highlightTimeout);
      const n = !this.hasHighlights ? this.highlightDelay : 0;
      this.highlightTimeout = setTimeout(() => this.highlight(t), n);
    },
    isHighlighted(t) {
      return this.highlightedKeys.indexOf(t) > -1;
    },
    isColumnHighlighted(t) {
      const e = He(this.sortedData, [t, this.labelField], null);
      return this.columnHighlights.includes(e) && !this.highlightedKeys.length;
    },
    totalRowValue(t) {
      return d2(this.discoveredKeys, (e) => this.sortedData[t][e]);
    },
    barStyle(t, e) {
      const n = this.sortedData[t][e], r = this.relative ? this.totalRowValue(t) : this.maxRowValue, i = `${100 * (n / r)}%`, a = this.colorScale(e);
      return { maxWidth: this.barMaxWidth, height: i, backgroundColor: a };
    },
    barTitle(t, e) {
      const n = this.sortedData[t][e], r = this.$options.filters.d3Formatter(n, this.yAxisTickFormat), i = this.groupName(e);
      return this.tooltipDisplay({ value: n, formattedValue: r, key: e, formattedKey: i });
    },
    stackBarAndValue(t) {
      if (!this.mounted)
        return [];
      const e = this.discoveredKeys.map((n) => {
        const { bar: r, row: i, value: a } = this.queryBarAndValue(t, n), o = r.getBoundingClientRect().top + r.offsetHeight, s = r.offsetHeight, l = i.getBoundingClientRect().top + i.offsetHeight, c = a.offsetHeight;
        return { key: n, barEdge: o, barHeight: s, rowEdge: l, valueHeight: c };
      });
      return e.map((n, r) => {
        if (n.overflow = n.valueHeight >= n.barHeight, r > 0) {
          const i = e[r - 1], a = n.valueHeight + i.valueHeight;
          n.overflow = n.overflow || i.overflow && n.barHeight < a;
        }
        return n.pushed = n.barEdge + n.valueHeight > n.rowEdge && n.overflow, n;
      });
    },
    queryBarAndValue(t, e) {
      if (!this.mounted)
        return {};
      const n = ".stacked-column-chart__groups__item", r = this.$el.querySelectorAll(n)[t], i = `.stacked-column-chart__groups__item__bars__item--${e}`, a = r.querySelector(i), o = ".stacked-column-chart__groups__item__bars__item__value", s = a.querySelector(o);
      return { bar: a, row: r, value: s };
    },
    isHidden(t, e) {
      return this.hideEmptyValues && !this.sortedData[t][e];
    },
    hasValueOverflow(t, e) {
      var r;
      const n = this.stackBarAndValue(t);
      return (r = ac(n, { key: e })) == null ? void 0 : r.overflow;
    },
    hasValuePushed(t, e) {
      var r;
      const n = this.stackBarAndValue(t);
      return (r = ac(n, { key: e })) == null ? void 0 : r.pushed;
    },
    hasValueHidden(t, e) {
      const n = this.discoveredKeys.indexOf(e), r = this.discoveredKeys[n + 1];
      return r ? this.hasValueOverflow(t, e) && this.hasValueOverflow(t, r) : !1;
    }
  }
};
var hyt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "stacked-column-chart d-flex flex-column", class: {
    "stacked-column-chart--social-mode": e.socialMode,
    "stacked-column-chart--has-highlights": e.hasHighlights || e.hasColumnHighlights,
    "stacked-column-chart--no-direct-labeling": e.noDirectLabeling
  }, style: { height: `${e.height}px` } }, [e.hideLegend ? e._e() : n("ul", { staticClass: "stacked-column-chart__legend list-inline" }, e._l(e.discoveredKeys, function(r) {
    return n("li", { key: r, staticClass: "stacked-column-chart__legend__item list-inline-item d-inline-flex", class: {
      "stacked-column-chart__legend__item--highlighted": e.isHighlighted(r)
    }, on: { mouseover: function(i) {
      return e.delayHighlight(r);
    }, mouseleave: function(i) {
      return e.restoreHighlights();
    } } }, [n("span", { staticClass: "stacked-column-chart__legend__item__box", style: { "background-color": e.colorScale(r) } }), e._v(" " + e._s(e.groupName(r)) + " ")]);
  }), 0), n("div", { staticClass: "d-flex flex-grow-1 position-relative overflow-hidden" }, [n("svg", { directives: [{ name: "show", rawName: "v-show", value: e.noDirectLabeling, expression: "noDirectLabeling" }], staticClass: "stacked-column-chart__left-axis", attrs: { width: e.width + "px", height: e.height + "px" } }, [n("g", { staticClass: "stacked-column-chart__left-axis__canvas", attrs: { transform: `translate(${e.width}, 0)` } })]), n("div", { staticClass: "stacked-column-chart__groups d-flex flex-grow-1", style: e.paddedStyle }, e._l(e.sortedData, function(r, i) {
    return n("div", { key: i, staticClass: "stacked-column-chart__groups__item flex-grow-1 d-flex flex-column text-center" }, [n("div", { staticClass: "stacked-column-chart__groups__item__bars flex-grow-1 d-flex flex-column-reverse px-1 justify-content-start align-items-center" }, e._l(e.discoveredKeys, function(a, o) {
      return n("div", { directives: [{ name: "b-tooltip", rawName: "v-b-tooltip.html", value: { delay: e.barTooltipDelay, disabled: e.noTooltips, title: e.barTitle(i, a) }, expression: "{ delay: barTooltipDelay, disabled: noTooltips, title: barTitle(i, key) }", modifiers: { html: !0 } }], key: o, staticClass: "stacked-column-chart__groups__item__bars__item", class: {
        [`stacked-column-chart__groups__item__bars__item--${a}`]: !0,
        [`stacked-column-chart__groups__item__bars__item--${o}n`]: !0,
        "stacked-column-chart__groups__item__bars__item--hidden": e.isHidden(i, a),
        "stacked-column-chart__groups__item__bars__item--highlighted": e.isHighlighted(a) || e.isColumnHighlighted(i),
        "stacked-column-chart__groups__item__bars__item--value-overflow": e.hasValueOverflow(i, a),
        "stacked-column-chart__groups__item__bars__item--value-pushed": e.hasValuePushed(i, a),
        "stacked-column-chart__groups__item__bars__item--value-hidden": e.hasValueHidden(i, a)
      }, style: e.barStyle(i, a), on: { mouseover: function(s) {
        return e.delayHighlight(a);
      }, mouseleave: function(s) {
        return e.restoreHighlights();
      } } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: !e.noDirectLabeling, expression: "!noDirectLabeling" }], staticClass: "stacked-column-chart__groups__item__bars__item__value" }, [e._v(" " + e._s(e._f("d3Formatter")(r[a], e.yAxisTickFormat)) + " ")])]);
    }), 0), n("div", { staticClass: "stacked-column-chart__groups__item__label small py-2" }, [e._v(" " + e._s(e._f("d3Formatter")(r[e.labelField], e.xAxisTickFormat)) + " ")])]);
  }), 0)])]);
}, dyt = [], pyt = /* @__PURE__ */ Bt(
  fyt,
  hyt,
  dyt,
  !1,
  null,
  null,
  null,
  null
);
const myt = pyt.exports, H7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BarChart: u2t,
  ColumnChart: d2t,
  LineChart: b2t,
  StackedBarChart: cyt,
  StackedColumnChart: myt
}, Symbol.toStringTag, { value: "Module" }));
var kl = Math.abs, s_ = Math.floor, gyt = Math.max, lo = Math.min, dA = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, vyt = 1e-12, qb = Math.PI, _yt = 180 / qb, byt = qb / 180, Qn = [
  [0.9986, -0.062],
  [1, 0],
  [0.9986, 0.062],
  [0.9954, 0.124],
  [0.99, 0.186],
  [0.9822, 0.248],
  [0.973, 0.31],
  [0.96, 0.372],
  [0.9427, 0.434],
  [0.9216, 0.4958],
  [0.8962, 0.5571],
  [0.8679, 0.6176],
  [0.835, 0.6769],
  [0.7986, 0.7346],
  [0.7597, 0.7903],
  [0.7186, 0.8435],
  [0.6732, 0.8936],
  [0.6213, 0.9394],
  [0.5722, 0.9761],
  [0.5322, 1]
];
Qn.forEach(function(t) {
  t[1] *= 1.593415793900743;
});
function pA(t, e) {
  var n = lo(18, kl(e) * 36 / qb), r = s_(n), i = n - r, a = (d = Qn[r])[0], o = d[1], s = (d = Qn[++r])[0], l = d[1], c = (d = Qn[lo(19, ++r)])[0], h = d[1], d;
  return [
    t * (s + i * (c - a) / 2 + i * i * (c - 2 * s + a) / 2),
    dA(e) * (l + i * (h - o) / 2 + i * i * (h - 2 * l + o) / 2)
  ];
}
pA.invert = function(t, e) {
  var n = e * 90, r = lo(18, kl(n / 5)), i = gyt(0, s_(r));
  do {
    var a = Qn[i][1], o = Qn[i + 1][1], s = Qn[lo(19, i + 2)][1], l = s - a, c = s - 2 * o + a, h = 2 * (kl(e) - o) / l, d = c / l, p = h * (1 - d * h * (1 - 2 * d * h));
    if (p >= 0 || i === 1) {
      n = (e >= 0 ? 5 : -5) * (p + r);
      var g = 50, v;
      do
        r = lo(18, kl(n) / 5), i = s_(r), p = r - i, a = Qn[i][1], o = Qn[i + 1][1], s = Qn[lo(19, i + 2)][1], n -= (v = dA(e) * (o + p * (s - a) / 2 + p * p * (s - 2 * o + a) / 2) - e) * _yt;
      while (kl(v) > vyt && --g > 0);
      break;
    }
  } while (--i >= 0);
  var b = Qn[i][0], _ = Qn[i + 1][0], w = Qn[lo(19, i + 2)][0];
  return [
    t / (_ + p * (w - b) / 2 + p * p * (w - 2 * _ + b) / 2),
    n * byt
  ];
};
function mA() {
  return Vr(pA).scale(152.63);
}
function yyt(t) {
  return t;
}
function wyt(t) {
  if (t == null)
    return yyt;
  var e, n, r = t.scale[0], i = t.scale[1], a = t.translate[0], o = t.translate[1];
  return function(s, l) {
    l || (e = n = 0);
    var c = 2, h = s.length, d = new Array(h);
    for (d[0] = (e += s[0]) * r + a, d[1] = (n += s[1]) * i + o; c < h; )
      d[c] = s[c], ++c;
    return d;
  };
}
function xyt(t, e) {
  for (var n, r = t.length, i = r - e; i < --r; )
    n = t[i], t[i++] = t[r], t[r] = n;
}
function gA(t, e) {
  return e.type === "GeometryCollection" ? { type: "FeatureCollection", features: e.geometries.map(function(n) {
    return j7(t, n);
  }) } : j7(t, e);
}
function j7(t, e) {
  var n = e.id, r = e.bbox, i = e.properties == null ? {} : e.properties, a = Cyt(t, e);
  return n == null && r == null ? { type: "Feature", properties: i, geometry: a } : r == null ? { type: "Feature", id: n, properties: i, geometry: a } : { type: "Feature", id: n, bbox: r, properties: i, geometry: a };
}
function Cyt(t, e) {
  var n = wyt(t.transform), r = t.arcs;
  function i(h, d) {
    d.length && d.pop();
    for (var p = r[h < 0 ? ~h : h], g = 0, v = p.length; g < v; ++g)
      d.push(n(p[g], g));
    h < 0 && xyt(d, v);
  }
  function a(h) {
    return n(h);
  }
  function o(h) {
    for (var d = [], p = 0, g = h.length; p < g; ++p)
      i(h[p], d);
    return d.length < 2 && d.push(d[0]), d;
  }
  function s(h) {
    for (var d = o(h); d.length < 4; )
      d.push(d[0]);
    return d;
  }
  function l(h) {
    return h.map(s);
  }
  function c(h) {
    var d = h.type, p;
    switch (d) {
      case "GeometryCollection":
        return { type: d, geometries: h.geometries.map(c) };
      case "Point":
        p = a(h.coordinates);
        break;
      case "MultiPoint":
        p = h.coordinates.map(a);
        break;
      case "LineString":
        p = o(h.arcs);
        break;
      case "MultiLineString":
        p = h.arcs.map(o);
        break;
      case "Polygon":
        p = l(h.arcs);
        break;
      case "MultiPolygon":
        p = h.arcs.map(l);
        break;
      default:
        return null;
    }
    return { type: d, coordinates: p };
  }
  return c(e);
}
const $yt = {
  name: "ChoroplethMap",
  components: {
    ScaleLegend: VE
  },
  filters: {
    formatNumber: Uo(",")
  },
  mixins: [Go],
  props: {
    hatchEmpty: {
      type: Boolean
    },
    hideLegend: {
      type: Boolean
    },
    featureColorScale: {
      type: Function,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    clickable: {
      type: Boolean
    },
    topojsonObjects: {
      type: String,
      default: "countries1"
    },
    topojsonObjectsPath: {
      type: [String, Array],
      default: "id"
    },
    topojsonUrl: {
      type: String,
      default: () => he.get("map.topojson.world-countries-sans-antarctica")
    },
    transitionDuration: {
      type: Number,
      default: 750
    },
    zoomable: {
      type: Boolean
    },
    zoomMin: {
      type: Number,
      default: 1
    },
    zoomMax: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      mapRect: { width: 0, height: 0 },
      featureCursor: null,
      featureZoom: null
    };
  },
  topojson: null,
  computed: {
    featureColorScaleEnd() {
      return this.mounted && window.getComputedStyle(this.map.node()).getPropertyValue("--primary") || "#852308";
    },
    featureColorScaleStart() {
      return this.mounted && this.socialMode !== null && window.getComputedStyle(this.map.node()).getPropertyValue("color") || "#fff";
    },
    featureColor() {
      return (t) => {
        const e = ct.get(t, this.topojsonObjectsPath);
        if (e in this.loadedData)
          return this.featureColorScaleFunction(this.loadedData[e]);
      };
    },
    featureColorScaleFunction() {
      return this.featureColorScale !== null ? this.featureColorScale : this.defaultFeatureColorScale;
    },
    defaultFeatureColorScale() {
      return $1().domain([Math.max(1, this.minValue), this.maxValue]).range([this.featureColorScaleStart, this.featureColorScaleEnd]);
    },
    featurePath() {
      return B2().projection(this.mapProjection);
    },
    hasCursor() {
      return !!this.featureCursor;
    },
    hasZoom() {
      return !!this.featureZoom;
    },
    topojson() {
      return this.$options.topojson;
    },
    geojson() {
      const t = ct.get(this.topojson, ["objects", this.topojsonObjects], null);
      return gA(this.topojson, t);
    },
    mapClass() {
      return {
        "choropleth-map--has-cursor": this.hasCursor,
        "choropleth-map--has-zoom": this.hasZoom,
        "choropleth-map--hatch-empty": this.hatchEmpty
      };
    },
    mapProjection() {
      const { height: t, width: e } = this.mapRect;
      return mA().fitSize([e, t], this.geojson);
    },
    mapZoom() {
      return Ub().scaleExtent([this.zoomMin, this.zoomMax]).translateExtent([
        [0, 0],
        [this.mapRect.width, this.mapRect.height]
      ]).on("zoom", this.mapZoomed);
    },
    mapHeight() {
      return this.mapRect.height;
    },
    mapWidth() {
      return this.mapRect.width;
    },
    map() {
      return this.mounted ? de(this.$el).select("svg") : null;
    },
    maxValue() {
      return this.max !== null ? this.max : ct.max(ct.values(this.loadedData)) || 0;
    },
    minValue() {
      return this.min !== null ? this.min : ct.min(ct.values(this.loadedData)) || 0;
    },
    cursorValue() {
      return ct.get(this, ["data", this.featureCursor], null);
    }
  },
  watch: {
    socialMode() {
      this.draw();
    },
    data() {
      this.update();
    },
    featureZoom() {
      this.setFeaturesClasses();
    },
    featureCursor() {
      this.setFeaturesClasses();
    }
  },
  created() {
    return _e(this, null, function* () {
      yield new Promise((t) => this.$on("loaded", t)), yield this.loadTopojson(), this.draw(), this.$on("resized", this.debouncedDraw);
    });
  },
  methods: {
    debouncedDraw: ct.debounce(function() {
      this.draw();
    }, 10),
    prepare() {
      return this.$set(this, "mapRect", this.map.node().getBoundingClientRect()), this.map.selectAll("g").remove(), this.map;
    },
    prepareZoom() {
      this.zoomable && this.map.call(this.mapZoom);
    },
    draw() {
      this.prepare().append("g").attr("class", "choropleth-map__main__features").selectAll(".choropleth-map__main__features__item").data(this.geojson.features).enter().append("path").attr("class", this.featureClass).attr("d", this.featurePath).on("mouseover", this.featureMouseOver).on("mouseleave", this.featureMouseLeave).on("click", this.mapClicked).style("color", this.featureColor), this.prepareZoom();
    },
    update() {
      this.map.selectAll(".choropleth-map__main__features__item").data(this.geojson.features).attr("class", this.featureClass).style("color", this.featureColor);
    },
    featureClass(t) {
      return ct.keys(ct.pickBy(this.featureClassObject(t), (e) => e)).join(" ");
    },
    featureClassObject(t) {
      const e = "choropleth-map__main__features__item", n = ct.get(t, this.topojsonObjectsPath);
      return {
        [e]: !0,
        [`${e}--identifier-${ct.kebabCase(n)}`]: !0,
        [`${e}--empty`]: !(n in this.loadedData),
        [`${e}--zoomed`]: this.featureZoom === n,
        [`${e}--cursored`]: this.featureCursor === n
      };
    },
    featureMouseLeave() {
      this.featureCursor = null;
    },
    featureMouseOver(t, e) {
      const n = ct.get(e, this.topojsonObjectsPath);
      this.featureCursor = n in this.loadedData ? n : null;
    },
    loadTopojson() {
      return _e(this, null, function* () {
        return this.$options.topojsonPromise || (this.$options.topojsonPromise = N2(this.topojsonUrl), this.$options.topojson = yield this.$options.topojsonPromise), this.$options.topojsonPromise;
      });
    },
    mapZoomed({ transform: t }) {
      this.map.style("--map-scale", t.k).selectAll(".choropleth-map__main__features__item").attr("transform", t);
    },
    mapClicked(t, e) {
      return _e(this, null, function* () {
        if (this.$emit("click", e), !!this.clickable) {
          if (this.featureZoom === ct.get(e, this.topojsonObjectsPath))
            return this.resetZoom(t, e);
          yield this.setFeatureZoom(e, mn(t, this.map.node())), this.$emit("zoomed", e);
        }
      });
    },
    resetZoom() {
      this.map.style("--map-scale", 1).transition().duration(this.transitionDuration).call(this.mapZoom.transform, Ia), this.featureZoom = null, this.$emit("reset");
    },
    setFeaturesClasses() {
      this.map.selectAll(".choropleth-map__main__features__item").attr("class", this.featureClass);
    },
    setFeatureZoom(t, e = [0, 0]) {
      this.featureZoom = ct.get(t, this.topojsonObjectsPath);
      const { height: n, width: r } = this.mapRect, [[i, a], [o, s]] = this.featurePath.bounds(t), l = Math.min(8, 0.9 / Math.max((o - i) / r, (s - a) / n)), c = Ia.translate(r / 2, n / 2).scale(l).translate(-(i + o) / 2, -(a + s) / 2);
      return this.map.style("--map-scale", l).transition().duration(this.transitionDuration).call(this.mapZoom.transform, c, e).end();
    }
  }
};
var Tyt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "choropleth-map", class: e.mapClass }, [n("svg", { staticClass: "choropleth-map__main" }, [n("pattern", { attrs: { id: "diagonalHatch", width: "1", height: "1", patternTransform: "rotate(45 0 0)", patternUnits: "userSpaceOnUse" } }, [n("rect", { attrs: { width: "1", height: "1", fill: e.featureColorScaleEnd } }), n("line", { style: { stroke: e.featureColorScaleStart, strokeWidth: 1 }, attrs: { x1: "0", y1: "0", x2: "0", y2: "1" } })])]), e.hideLegend ? e._e() : n("scale-legend", { staticClass: "choropleth-map__legend", attrs: { "color-scale-end": e.featureColorScaleEnd, "color-scale-start": e.featureColorScaleStart, "color-scale": e.featureColorScaleFunction, "cursor-value": e.cursorValue, max: e.maxValue, min: e.minValue }, scopedSlots: e._u([{ key: "cursor", fn: function({ value: r }) {
    return [e._t("legend-cursor", null, null, { value: r, identifier: e.featureCursor })];
  } }], null, !0) })], 1);
}, Oyt = [], Syt = /* @__PURE__ */ Bt(
  $yt,
  Tyt,
  Oyt,
  !1,
  null,
  "fd6901e3",
  null,
  null
);
const Eyt = Syt.exports;
const Ayt = {
  name: "SymbolMap",
  components: {
    OrdinalLegend: HE
  },
  mixins: [Go],
  props: {
    categoryObjectsPath: {
      type: [String, Array],
      default: "category"
    },
    clickable: {
      type: Boolean
    },
    hideLegend: {
      type: Boolean
    },
    hideTooltip: {
      type: Boolean
    },
    horizontalLegend: {
      type: Boolean
    },
    featureColor: {
      type: [String, Function],
      default: "currentColor"
    },
    fitToMarkers: {
      type: Boolean
    },
    labelObjectsPath: {
      type: [String, Array],
      default: "label"
    },
    mapPadding: {
      type: Number,
      default: 15
    },
    markerObjectsPath: {
      type: [String, Array],
      default: "id"
    },
    markerPath: {
      type: [String, Function],
      default: "M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z"
    },
    markerColor: {
      type: String,
      default: null
    },
    markerWidth: {
      type: [Number, Function],
      default: 10
    },
    noMarkersScale: {
      type: Boolean
    },
    tooltipCustomClass: {
      type: String,
      default: null
    },
    tooltipPlacement: {
      type: String,
      default: "top"
    },
    tooltipFallbackPlacement: {
      type: [Array, String],
      default: "flip"
    },
    topojsonObjects: {
      type: String,
      default: "countries1"
    },
    topojsonObjectsPath: {
      type: [String, Array],
      default: "id"
    },
    topojsonUrl: {
      type: String,
      default: () => he.get("map.topojson.world-countries-sans-antarctica")
    },
    transitionDuration: {
      type: Number,
      default: 750
    },
    zoomable: {
      type: Boolean
    },
    zoomMin: {
      type: Number,
      default: 1
    },
    zoomMax: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      mapRect: { width: 0, height: 0 },
      markerCursor: null,
      categoryHighlight: null
    };
  },
  topojson: null,
  computed: {
    featurePath() {
      return B2().projection(this.mapProjection);
    },
    hasCursor() {
      return !!this.markerCursor;
    },
    hasHighlight() {
      return !!this.categoryHighlight;
    },
    topojson() {
      return this.$options.topojson;
    },
    geojson() {
      return this.fitToMarkers ? this.markersGeojson : this.featuresGeojson;
    },
    featuresGeojson() {
      const t = ct.get(this.topojson, ["objects", this.topojsonObjects], null);
      return gA(this.topojson, t);
    },
    markersGeojson() {
      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [this.coordinates]
        }
      };
    },
    coordinates() {
      return (this.loadedData || []).map(({ longitude: t, latitude: e }) => [t, e]);
    },
    mapId() {
      return ct.uniqueId("symbol-map-");
    },
    mapClass() {
      return {
        "symbol-map--has-cursor": this.hasCursor,
        "symbol-map--has-highlight": this.hasHighlight,
        "symbol-map--has-markers-scale": !this.noMarkersScale
      };
    },
    mapProjection() {
      const { height: t, width: e } = this.mapRect, n = this.mapPadding;
      return mA().fitExtent(
        [
          [n, n],
          [e - n, t - n]
        ],
        this.geojson
      );
    },
    mapZoom() {
      return Ub().scaleExtent([this.zoomMin, this.zoomMax]).translateExtent([
        [0, 0],
        [this.mapRect.width, this.mapRect.height]
      ]).on("zoom", this.mapZoomed);
    },
    mapHeight() {
      return this.mapRect.height;
    },
    mapWidth() {
      return this.mapRect.width;
    },
    map() {
      return this.mounted ? de(this.$el).select(".symbol-map__main") : null;
    },
    markerCursorValue() {
      return ct.find(this.loadedDataWithIds, (t) => ct.get(t, this.markerObjectsPath) === this.markerCursor);
    },
    loadedDataWithIds() {
      return this.loadedData.map((t) => qr(qr({}, ct.set({}, this.markerObjectsPath, ct.uniqueId())), t));
    },
    categories() {
      const t = (this.loadedData || []).map((e) => ct.get(e, this.categoryObjectsPath));
      return ct.uniq(t).map(String);
    },
    legendData() {
      const t = ct.groupBy(this.loadedData || [], (e) => ct.get(e, this.categoryObjectsPath));
      return Object.entries(t).map((e) => {
        const [n, [{ color: r }]] = e, i = r || this.categoryColor(n);
        return { label: n, color: i };
      });
    },
    hasTooltip() {
      return !this.hideTooltip && this.loadedData && this.markerCursor;
    },
    tooltipTarget() {
      return this.hasTooltip ? this.markerId(this.markerCursorValue) : null;
    }
  },
  watch: {
    data() {
      this.draw();
    },
    socialMode() {
      this.draw();
    },
    markerCursor() {
      this.setMarkersClasses();
    },
    categoryHighlight() {
      this.setMarkersClasses();
    }
  },
  created() {
    return _e(this, null, function* () {
      yield new Promise((t) => this.$on("loaded", t)), yield this.loadTopojson(), this.draw(), this.$on("resized", this.debouncedDraw);
    });
  },
  methods: {
    debouncedDraw: ct.debounce(function() {
      this.draw();
    }, 10),
    prepare() {
      return this.$set(this, "mapRect", this.map.node().getBoundingClientRect()), this.map.selectAll("g").remove(), this.map;
    },
    prepareZoom() {
      this.zoomable && this.map.call(this.mapZoom);
    },
    categoryColor(t) {
      if (this.mounted) {
        const e = this.categories.indexOf(t);
        return window.getComputedStyle(this.$el).getPropertyValue(`--category-color-${e}n`) || "#000";
      }
      return null;
    },
    draw() {
      const t = this.prepare();
      t.append("g").attr("class", "symbol-map__main__features").selectAll(".symbol-map__main__features__item").data(this.featuresGeojson.features).enter().append("path").attr("class", this.featureClass).attr("d", this.featurePath).on("click", this.featureClicked).style("color", this.featureColor), t.append("g").attr("class", "symbol-map__main__markers").selectAll(".symbol-map__main__markers__item").data(this.loadedDataWithIds).enter().append("g").attr("id", this.markerId).attr("class", this.markerClass).attr("transform", this.markerTransform).append("path").on("mouseover", this.markerMouseOver).on("mouseleave", this.markerMouseLeave).attr("d", this.markerPathFunction).attr("fill", this.markerColorFunction), this.prepareZoom();
    },
    featureClass(t) {
      return ct.keys(ct.pickBy(this.featureClassObject(t), (e) => e)).join(" ");
    },
    featureClassObject(t) {
      const e = "symbol-map__main__features__item", n = ct.get(t, this.topojsonObjectsPath, null);
      return {
        [e]: !0,
        [`${e}--identifier-${ct.kebabCase(n)}`]: n !== null
      };
    },
    loadTopojson() {
      return _e(this, null, function* () {
        return this.$options.topojsonPromise || (this.$options.topojsonPromise = N2(this.topojsonUrl), this.$options.topojson = yield this.$options.topojsonPromise), this.$options.topojsonPromise;
      });
    },
    mapZoomed({ transform: t }) {
      this.markerCursor = null, this.map.style("--map-scale", t.k).selectAll(".symbol-map__main__features, .symbol-map__main__markers").attr("transform", t);
    },
    markerBoundingClientRect(t) {
      const e = this.map.append("path").attr("d", this.markerPathFunction(t)), n = e.node().getBoundingClientRect();
      return e.remove(), n;
    },
    markerMouseLeave() {
      this.markerCursor = null;
    },
    markerMouseOver(t, e) {
      this.markerCursor = ct.get(e, this.markerObjectsPath);
    },
    markerClass(t) {
      return ct.keys(ct.pickBy(this.markerClassObject(t), (e) => e)).join(" ");
    },
    markerId(t) {
      const e = ct.get(t, this.markerObjectsPath);
      return `${this.mapId}-marker-${e}`;
    },
    markerClassObject(t) {
      const e = String(ct.get(t, this.categoryObjectsPath)), n = this.categories.indexOf(e), r = ct.get(t, this.markerObjectsPath), i = "symbol-map__main__markers__item";
      return {
        [i]: !0,
        [`${i}--category-${ct.kebabCase(e)}`]: e !== null,
        [`${i}--category-${n}n`]: e !== null,
        [`${i}--cursored`]: this.markerCursor === r,
        [`${i}--identifier-${ct.kebabCase(r)}`]: r !== null,
        [`${i}--highlighted`]: this.categoryHighlight === e
      };
    },
    markerPathFunction(t) {
      return ct.isFunction(this.markerPath) ? this.markerPath(t) : this.markerPath;
    },
    markerColorFunction(n) {
      var r = n, { color: t } = r, e = T4(r, ["color"]);
      return t || (ct.isFunction(this.markerColor) ? this.markerColor(e) : this.markerColor);
    },
    markerWidthFunction(t) {
      return ct.isFunction(this.markerWidth) ? this.markerWidth(t) : this.markerWidth;
    },
    markerLabel(t) {
      return ct.get(t, this.labelObjectsPath);
    },
    markerTransform(t) {
      const { latitude: e, longitude: n } = t, { height: r, width: i } = this.markerBoundingClientRect(t), [a, o] = this.mapProjection([n, e]), s = this.markerWidthFunction(t) / Math.max(1, i), l = a - i / 2 * s, c = o - r / 2 * s;
      return `translate(${l}, ${c}) scale(${s})`;
    },
    featureClicked(t, e) {
      return _e(this, null, function* () {
        this.$emit("click", e), this.clickable && (yield this.setFeatureZoom(e, mn(t, this.map.node())), this.$emit("zoomed", e));
      });
    },
    resetZoom() {
      this.map.style("--map-scale", 1).transition().duration(this.transitionDuration).call(this.mapZoom.transform, Ia), this.$emit("reset");
    },
    setMarkersClasses() {
      this.map.selectAll(".symbol-map__main__markers__item").attr("class", this.markerClass);
    },
    setFeatureZoom(t, e = [0, 0]) {
      const { height: n, width: r } = this.mapRect, [[i, a], [o, s]] = this.featurePath.bounds(t), l = Math.min(8, 0.9 / Math.max((o - i) / r, (s - a) / n)), c = -(i + o) / 2, h = -(a + s) / 2, d = Ia.translate(r / 2, n / 2).scale(l).translate(c, h);
      return this.map.style("--map-scale", l).transition().duration(this.transitionDuration).call(this.mapZoom.transform, d, e).end();
    }
  }
};
var Pyt = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "symbol-map", class: e.mapClass }, [e._t("legend", function() {
    return [!e.hideLegend && e.legendData ? n("ordinal-legend", { attrs: { data: e.legendData, highlight: e.categoryHighlight, horizontal: e.horizontalLegend, "marker-path": e.markerPath, "category-objects-path": "label" }, on: { "update:highlight": function(r) {
      e.categoryHighlight = r;
    } }, scopedSlots: e._u([{ key: "marker", fn: function(r) {
      return [e._t("legend-marker", null, null, r)];
    } }, { key: "label", fn: function(r) {
      return [e._t("legend-label", null, null, r)];
    } }], null, !0) }) : e._e()];
  }, null, { legendData: e.legendData }), n("svg", { staticClass: "symbol-map__main" }), e.tooltipTarget ? n("b-tooltip", { ref: "marker-tooltip", attrs: { "custom-class": e.tooltipCustomClass, "fallback-placement": e.tooltipFallbackPlacement, placement: e.tooltipPlacement, target: e.tooltipTarget } }, [e._t("tooltip", function() {
    return [e._v(" " + e._s(e.markerLabel(e.markerCursorValue)) + " ")];
  }, null, qr({ markerCursor: e.markerCursor }, e.markerCursorValue))], 2) : e._e()], 2);
}, Myt = [], kyt = /* @__PURE__ */ Bt(
  Ayt,
  Pyt,
  Myt,
  !1,
  null,
  "ac2bb09a",
  null,
  null
);
const Nyt = kyt.exports, V7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChoroplethMap: Eyt,
  SymbolMap: Nyt
}, Symbol.toStringTag, { value: "Module" }));
class vA {
  static get i18n() {
    return Hn;
  }
  static get config() {
    return he;
  }
  static get components() {
    return u0;
  }
  static setLocaleMessage(e, n) {
    return this.i18n.setLocaleMessage(e, n);
  }
  static mergeLocaleMessage(e, n) {
    return this.i18n.mergeLocaleMessage(e, n);
  }
  static setLocale(e) {
    return this.i18n.locale = e;
  }
  static getLocale() {
    return this.i18n.locale;
  }
  static install(e) {
    e.prototype.$config = vA.config, Object.keys(u0).forEach((n) => e.component(n, u0[n])), Object.keys(H7).forEach((n) => e.component(n, H7[n])), Object.keys(V7).forEach((n) => e.component(n, V7[n]));
  }
}
export {
  ZD as AccordionStep,
  YD as AccordionWrapper,
  LH as ActiveTextTruncate,
  VG as AdvancedLinkForm,
  u2t as BarChart,
  BC as Brand,
  Q_ as BrandExpansion,
  Eyt as ChoroplethMap,
  d2t as ColumnChart,
  rK as ConfirmButton,
  mZ as ContentPlaceholder,
  yZ as CustomPagination,
  TZ as DigitsInput,
  lnt as DonateForm,
  d$ as EmbedForm,
  nrt as EmbeddableFooter,
  ar as Fa,
  c2 as FollowUsPopover,
  Nrt as GenericFooter,
  zrt as GenericHeader,
  Jp as HapticCopy,
  Sit as ImddbHeader,
  b2t as LineChart,
  HE as OrdinalLegend,
  j0t as RangePicker,
  G0t as ResponsiveIframe,
  VE as ScaleLegend,
  h_t as SecretInput,
  s_t as SelectableDropdown,
  g$ as SharingOptions,
  m$ as SharingOptionsLink,
  v$ as SignUpForm,
  v_t as SlideUpDown,
  cyt as StackedBarChart,
  Nyt as SymbolMap,
  x_t as TexturedDeck,
  A_t as TinyPagination,
  he as config,
  vA as default
};
